// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328a745%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23dc3545%27 viewBox=%27-2 -2 7 7%27%3e%3cpath stroke=%27%23dc3545%27 d=%27M0 0l3 3m0-3L0 3%27/%3e%3ccircle r=%27.5%27/%3e%3ccircle cx=%273%27 r=%27.5%27/%3e%3ccircle cy=%273%27 r=%27.5%27/%3e%3ccircle cx=%273%27 cy=%273%27 r=%27.5%27/%3e%3c/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/utils/images/logo-inverse.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("assets/utils/images/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("components/icons/linearicons/Linearicons-Free.eot?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("components/icons/linearicons/Linearicons-Free.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("components/icons/linearicons/Linearicons-Free.woff2?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("components/icons/linearicons/Linearicons-Free.woff?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("components/icons/linearicons/Linearicons-Free.ttf?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("components/icons/linearicons/Linearicons-Free.svg?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.woff?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.ttf?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.svg?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("components/react-widgets/fonts/rw-widgets.eot?v=4.1.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("components/react-widgets/fonts/rw-widgets.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("components/react-widgets/fonts/rw-widgets.woff?v=4.1.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("components/react-widgets/fonts/rw-widgets.ttf?v=4.1.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("components/react-widgets/fonts/rw-widgets.svg?v=4.1.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("components/react-widgets/img/loading.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("components/react-widgets/img/loader-big.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "?#iefixw118d" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "#Linearicons-Free" });
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___, { hash: "?#iefixd7yf1v" });
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "#Pe-icon-7-stroke" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___, { hash: "?#iefix&v=4.1.0" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___, { hash: "#fontawesomeregular" });
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.border-primary {
  border-color: #545cd8;
}

.border-secondary {
  border-color: #6c757d;
}

.border-success {
  border-color: #3ac47d;
}

.border-info {
  border-color: #30b1ff;
}

.border-warning {
  border-color: #f7b924;
}

.border-danger {
  border-color: #d92550;
}

.border-light {
  border-color: #eeeeee;
}

.border-dark {
  border-color: #343a40;
}

.border-focus {
  border-color: #444054;
}

.border-alternate {
  border-color: #83588a;
}

.list-group-item-primary {
  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);
  background-color: rgb(81.2235294118%, 82.1019607843%, 95.7176470588%);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);
  background-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);
  border-color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);
}

.list-group-item-secondary {
  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  background-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  border-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
}

.list-group-item-success {
  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);
  background-color: rgb(78.368627451%, 93.5215686275%, 85.7254901961%);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);
  background-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);
  border-color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);
}

.list-group-item-info {
  color: rgb(9.7882352941%, 36.0941176471%, 52%);
  background-color: rgb(77.2705882353%, 91.4352941176%, 100%);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(9.7882352941%, 36.0941176471%, 52%);
  background-color: rgb(67.2705882353%, 87.6671781756%, 100%);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(9.7882352941%, 36.0941176471%, 52%);
  border-color: rgb(9.7882352941%, 36.0941176471%, 52%);
}

.list-group-item-warning {
  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);
  background-color: rgb(99.1215686275%, 92.3137254902%, 75.9529411765%);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);
  background-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);
  border-color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);
}

.list-group-item-danger {
  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);
  background-color: rgb(95.8274509804%, 76.062745098%, 80.7843137255%);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);
  background-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);
  border-color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);
}

.list-group-item-light {
  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);
  background-color: rgb(98.1333333333%, 98.1333333333%, 98.1333333333%);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);
  background-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);
  border-color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);
}

.list-group-item-dark {
  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  background-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  border-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
}

.list-group-item-focus {
  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);
  background-color: rgb(79.4666666667%, 79.0274509804%, 81.2235294118%);
}
.list-group-item-focus.list-group-item-action:hover, .list-group-item-focus.list-group-item-action:focus {
  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);
  background-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);
}
.list-group-item-focus.list-group-item-action.active {
  color: #fff;
  background-color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);
  border-color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);
}

.list-group-item-alternate {
  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);
  background-color: rgb(86.3843137255%, 81.662745098%, 87.1529411765%);
}
.list-group-item-alternate.list-group-item-action:hover, .list-group-item-alternate.list-group-item-action:focus {
  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);
  background-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);
}
.list-group-item-alternate.list-group-item-action.active {
  color: #fff;
  background-color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);
  border-color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);
}

.bg-primary {
  background-color: #545cd8 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%) !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%) !important;
}

.bg-success {
  background-color: #3ac47d !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%) !important;
}

.bg-info {
  background-color: #30b1ff !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(0%, 61.5856777494%, 98.8235294118%) !important;
}

.bg-warning {
  background-color: #f7b924 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%) !important;
}

.bg-danger {
  background-color: #d92550 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%) !important;
}

.bg-light {
  background-color: #eeeeee !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%) !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%) !important;
}

.bg-focus {
  background-color: #444054 !important;
}

a.bg-focus:hover, a.bg-focus:focus,
button.bg-focus:hover,
button.bg-focus:focus {
  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%) !important;
}

.bg-alternate {
  background-color: #83588a !important;
}

a.bg-alternate:hover, a.bg-alternate:focus,
button.bg-alternate:hover,
button.bg-alternate:focus {
  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%) !important;
}

:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #545cd8;
  --secondary: #6c757d;
  --success: #3ac47d;
  --info: #30b1ff;
  --warning: #f7b924;
  --danger: #d92550;
  --light: #eeeeee;
  --dark: #343a40;
  --focus: #444054;
  --alternate: #83588a;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #545cd8;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: rgb(0%, 33.7647058824%, 70%);
  text-decoration: underline;
}

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):focus {
  outline: 0;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

input[type=date],
input[type=time],
input[type=datetime-local],
input[type=month] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 400;
  line-height: 1.2;
}

h1, .h1 {
  font-size: 2.5rem;
}

h2, .h2 {
  font-size: 2rem;
}

h3, .h3 {
  font-size: 1.75rem;
}

h4, .h4 {
  font-size: 1.5rem;
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-break: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 1140px;
  }
}

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}

.col-2 {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.col-5 {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.3333333333%;
  max-width: 58.3333333333%;
}

.col-8 {
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.3333333333%;
  max-width: 83.3333333333%;
}

.col-11 {
  flex: 0 0 91.6666666667%;
  max-width: 91.6666666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.3333333333%;
}

.offset-2 {
  margin-left: 16.6666666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.3333333333%;
}

.offset-5 {
  margin-left: 41.6666666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.3333333333%;
}

.offset-8 {
  margin-left: 66.6666666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.3333333333%;
}

.offset-11 {
  margin-left: 91.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.3333333333%;
  }
  .offset-sm-2 {
    margin-left: 16.6666666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.3333333333%;
  }
  .offset-sm-5 {
    margin-left: 41.6666666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.3333333333%;
  }
  .offset-sm-8 {
    margin-left: 66.6666666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.3333333333%;
  }
  .offset-sm-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-md-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-md-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-md-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-md-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.3333333333%;
  }
  .offset-md-2 {
    margin-left: 16.6666666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.3333333333%;
  }
  .offset-md-5 {
    margin-left: 41.6666666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.3333333333%;
  }
  .offset-md-8 {
    margin-left: 66.6666666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.3333333333%;
  }
  .offset-md-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.3333333333%;
  }
  .offset-lg-2 {
    margin-left: 16.6666666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.3333333333%;
  }
  .offset-lg-5 {
    margin-left: 41.6666666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.3333333333%;
  }
  .offset-lg-8 {
    margin-left: 66.6666666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.3333333333%;
  }
  .offset-lg-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.3333333333%;
  }
  .offset-xl-2 {
    margin-left: 16.6666666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.3333333333%;
  }
  .offset-xl-5 {
    margin-left: 41.6666666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.3333333333%;
  }
  .offset-xl-8 {
    margin-left: 66.6666666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.3333333333%;
  }
  .offset-xl-11 {
    margin-left: 91.6666666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}
.table th,
.table td {
  padding: 0.55rem;
  vertical-align: top;
  border-top: 1px solid #e9ecef;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #e9ecef;
}
.table tbody + tbody {
  border-top: 2px solid #e9ecef;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #e9ecef;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #e9ecef;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: #e0f3ff;
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: rgb(81.2235294118%, 82.1019607843%, 95.7176470588%);
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: rgb(65.1294117647%, 66.7607843137%, 92.0470588235%);
}

.table-hover .table-primary:hover {
  background-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: rgb(70.0235294118%, 71.8588235294%, 73.4901960784%);
}

.table-hover .table-secondary:hover {
  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: rgb(78.368627451%, 93.5215686275%, 85.7254901961%);
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: rgb(59.8274509804%, 87.968627451%, 73.4901960784%);
}

.table-hover .table-success:hover {
  background-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: rgb(77.2705882353%, 91.4352941176%, 100%);
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: rgb(57.7882352941%, 84.0941176471%, 100%);
}

.table-hover .table-info:hover {
  background-color: rgb(67.2705882353%, 87.6671781756%, 100%);
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: rgb(67.2705882353%, 87.6671781756%, 100%);
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: rgb(99.1215686275%, 92.3137254902%, 75.9529411765%);
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: rgb(98.368627451%, 85.7254901961%, 55.3411764706%);
}

.table-hover .table-warning:hover {
  background-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: rgb(95.8274509804%, 76.062745098%, 80.7843137255%);
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: rgb(92.2509803922%, 55.5450980392%, 64.3137254902%);
}

.table-hover .table-danger:hover {
  background-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: rgb(98.1333333333%, 98.1333333333%, 98.1333333333%);
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: rgb(96.5333333333%, 96.5333333333%, 96.5333333333%);
}

.table-hover .table-light:hover {
  background-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: rgb(58.6039215686%, 59.8274509804%, 61.0509803922%);
}

.table-hover .table-dark:hover {
  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);
}

.table-focus,
.table-focus > th,
.table-focus > td {
  background-color: rgb(79.4666666667%, 79.0274509804%, 81.2235294118%);
}
.table-focus th,
.table-focus td,
.table-focus thead th,
.table-focus tbody + tbody {
  border-color: rgb(61.8666666667%, 61.0509803922%, 65.1294117647%);
}

.table-hover .table-focus:hover {
  background-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);
}
.table-hover .table-focus:hover > td,
.table-hover .table-focus:hover > th {
  background-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);
}

.table-alternate,
.table-alternate > th,
.table-alternate > td {
  background-color: rgb(86.3843137255%, 81.662745098%, 87.1529411765%);
}
.table-alternate th,
.table-alternate td,
.table-alternate thead th,
.table-alternate tbody + tbody {
  border-color: rgb(74.7137254902%, 65.9450980392%, 76.1411764706%);
}

.table-hover .table-alternate:hover {
  background-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);
}
.table-hover .table-alternate:hover > td,
.table-hover .table-alternate:hover > th {
  background-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: #e0f3ff;
}

.table-hover .table-active:hover {
  background-color: rgb(77.8431372549%, 91.4231499051%, 100%);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgb(77.8431372549%, 91.4231499051%, 100%);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: rgb(27.1162947938%, 30.2450980392%, 33.3739012847%);
}
.table .thead-light th {
  color: #6c757d;
  background-color: #f8f9fa;
  border-color: #e9ecef;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: rgb(27.1162947938%, 30.2450980392%, 33.3739012847%);
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(73.6554621849%, 74.8879551821%, 93.9915966387%);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #28a745;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #28a745;
  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_0___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated .custom-select:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-tooltip, .custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control-file:valid ~ .valid-feedback,
.was-validated .form-control-file:valid ~ .valid-tooltip, .form-control-file.is-valid ~ .valid-feedback,
.form-control-file.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28a745;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #28a745;
}
.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: rgb(20.2728047741%, 80.9036658142%, 34.1176470588%);
  background-color: rgb(20.2728047741%, 80.9036658142%, 34.1176470588%);
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28a745;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745;
}
.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #dc3545;
  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_2___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .custom-select:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-tooltip, .custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control-file:invalid ~ .invalid-feedback,
.was-validated .form-control-file:invalid ~ .invalid-tooltip, .form-control-file.is-invalid ~ .invalid-feedback,
.form-control-file.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #dc3545;
}
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: rgb(89.2280963018%, 37.8307272276%, 42.7550260611%);
  background-color: rgb(89.2280963018%, 37.8307272276%, 42.7550260611%);
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545;
}
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #495057;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #495057;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: none;
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(20.7268907563%, 24.4355742297%, 81.9201680672%);
  border-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
}
.btn-primary:focus, .btn-primary.focus {
  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
  border-color: rgb(17.2058823529%, 20.7352941176%, 75.4411764706%);
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(35.4001514769%, 38.3501641%, 40.9723975427%);
  border-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.btn-secondary:focus, .btn-secondary.focus {
  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
  border-color: rgb(30.7649583439%, 33.3287048725%, 35.6075906758%);
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success:hover {
  color: #fff;
  background-color: rgb(19.3199011888%, 65.2879419484%, 41.6377180794%);
  border-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);
}
.btn-success:focus, .btn-success.focus {
  box-shadow: 0 0 0 0 rgba(34.3333333333%, 80.3333333333%, 56.6666666667%, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);
  border-color: rgb(17.0364366219%, 57.5714065154%, 36.7164582368%);
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(34.3333333333%, 80.3333333333%, 56.6666666667%, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info:hover {
  color: #fff;
  background-color: rgb(3.8235294118%, 63.7595907928%, 100%);
  border-color: rgb(0%, 61.5856777494%, 98.8235294118%);
}
.btn-info:focus, .btn-info.focus {
  box-shadow: 0 0 0 0 rgba(31%, 74%, 100%, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0%, 61.5856777494%, 98.8235294118%);
  border-color: rgb(0%, 58.4697357204%, 93.8235294118%);
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(31%, 74%, 100%, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning:hover {
  color: #212529;
  background-color: rgb(92.5978232703%, 66.3829143992%, 3.3825688866%);
  border-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);
}
.btn-warning:focus, .btn-warning.focus {
  box-shadow: 0 0 0 0 rgba(84.2745098039%, 63.8431372549%, 14.4117647059%, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);
  border-color: rgb(82.9502461778%, 59.4666148398%, 3.0301459791%);
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(84.2745098039%, 63.8431372549%, 14.4117647059%, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(72.2830785858%, 12.3247645515%, 26.6481395708%);
  border-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);
}
.btn-danger:focus, .btn-danger.focus {
  box-shadow: 0 0 0 0 rgba(87.3333333333%, 27.3333333333%, 41.6666666667%, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);
  border-color: rgb(63.7397714992%, 10.8680716381%, 23.4985332716%);
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(87.3333333333%, 27.3333333333%, 41.6666666667%, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light:hover {
  color: #212529;
  background-color: rgb(85.8333333333%, 85.8333333333%, 85.8333333333%);
  border-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);
}
.btn-light:focus, .btn-light.focus {
  box-shadow: 0 0 0 0 rgba(81.2745098039%, 81.5098039216%, 81.7450980392%, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);
  border-color: rgb(80.8333333333%, 80.8333333333%, 80.8333333333%);
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(81.2745098039%, 81.5098039216%, 81.7450980392%, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(13.6680189317%, 15.2450980392%, 16.8221771467%);
  border-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
}
.btn-dark:focus, .btn-dark.focus {
  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
  border-color: rgb(9.185260311%, 10.2450980392%, 11.3049357674%);
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);
}

.btn-focus {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus:hover {
  color: #fff;
  background-color: rgb(19.7747747748%, 18.6115527292%, 24.4276629571%);
  border-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);
}
.btn-focus:focus, .btn-focus.focus {
  box-shadow: 0 0 0 0 rgba(37.6666666667%, 36.3333333333%, 43%, 0.5);
}
.btn-focus.disabled, .btn-focus:disabled {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus:not(:disabled):not(.disabled):active, .btn-focus:not(:disabled):not(.disabled).active, .show > .btn-focus.dropdown-toggle {
  color: #fff;
  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);
  border-color: rgb(15.1801801802%, 14.2872284049%, 18.7519872814%);
}
.btn-focus:not(:disabled):not(.disabled):active:focus, .btn-focus:not(:disabled):not(.disabled).active:focus, .show > .btn-focus.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(37.6666666667%, 36.3333333333%, 43%, 0.5);
}

.btn-alternate {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate:hover {
  color: #fff;
  background-color: rgb(42.6778587541%, 28.669095957%, 44.9583550234%);
  border-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);
}
.btn-alternate:focus, .btn-alternate.focus {
  box-shadow: 0 0 0 0 rgba(58.6666666667%, 44.3333333333%, 61%, 0.5);
}
.btn-alternate.disabled, .btn-alternate:disabled {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate:not(:disabled):not(.disabled):active, .btn-alternate:not(:disabled):not(.disabled).active, .show > .btn-alternate.dropdown-toggle {
  color: #fff;
  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);
  border-color: rgb(36.8813985771%, 24.7752906472%, 38.8521603332%);
}
.btn-alternate:not(:disabled):not(.disabled):active:focus, .btn-alternate:not(:disabled):not(.disabled).active:focus, .show > .btn-alternate.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(58.6666666667%, 44.3333333333%, 61%, 0.5);
}

.btn-outline-primary {
  color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #545cd8;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}

.btn-outline-success {
  color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #3ac47d;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}

.btn-outline-info {
  color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #30b1ff;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}

.btn-outline-warning {
  color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #f7b924;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}

.btn-outline-danger {
  color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #d92550;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}

.btn-outline-light {
  color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #eeeeee;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}

.btn-outline-focus {
  color: #444054;
  border-color: #444054;
}
.btn-outline-focus:hover {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-outline-focus:focus, .btn-outline-focus.focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-outline-focus.disabled, .btn-outline-focus:disabled {
  color: #444054;
  background-color: transparent;
}
.btn-outline-focus:not(:disabled):not(.disabled):active, .btn-outline-focus:not(:disabled):not(.disabled).active, .show > .btn-outline-focus.dropdown-toggle {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-outline-focus:not(:disabled):not(.disabled):active:focus, .btn-outline-focus:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-focus.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}

.btn-outline-alternate {
  color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:hover {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:focus, .btn-outline-alternate.focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate.disabled, .btn-outline-alternate:disabled {
  color: #83588a;
  background-color: transparent;
}
.btn-outline-alternate:not(:disabled):not(.disabled):active, .btn-outline-alternate:not(:disabled):not(.disabled).active, .show > .btn-outline-alternate.dropdown-toggle {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:not(:disabled):not(.disabled):active:focus, .btn-outline-alternate:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-alternate.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #545cd8;
  text-decoration: none;
}
.btn-link:hover {
  color: rgb(0%, 33.7647058824%, 70%);
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
  box-shadow: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 15rem;
  padding: 0.65rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.4rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);
  text-decoration: none;
  background-color: #e0f3ff;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #545cd8;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.65rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.968rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.4rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:last-child),
.input-group > .custom-select:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: rgb(93.8431372549%, 97.6166982922%, 100%);
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  display: block;
  min-height: 1.32rem;
  padding-left: 1.5rem;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #545cd8;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgb(50%, 74.1176470588%, 100%);
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: rgb(89.9411764706%, 90.4117647059%, 97.7058823529%);
  border-color: rgb(70%, 84.4705882353%, 100%);
}
.custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.16rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #adb5bd solid 1px;
}
.custom-control-label::after {
  position: absolute;
  top: 0.16rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #007bff;
  background-color: #545cd8;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(84, 92, 216, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(84, 92, 216, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(84, 92, 216, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.16rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(84, 92, 216, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}
.custom-select:focus {
  border-color: rgb(50%, 74.1176470588%, 100%);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgb(50%, 74.1176470588%, 100%);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: calc(1rem + 0.4rem);
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: none;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #545cd8;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb {
  appearance: none;
}
.custom-range::-webkit-slider-thumb:active {
  background-color: rgb(89.9411764706%, 90.4117647059%, 97.7058823529%);
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #545cd8;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb {
  appearance: none;
}
.custom-range::-moz-range-thumb:active {
  background-color: rgb(89.9411764706%, 90.4117647059%, 97.7058823529%);
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #545cd8;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb {
  appearance: none;
}
.custom-range::-ms-thumb:active {
  background-color: rgb(89.9411764706%, 90.4117647059%, 97.7058823529%);
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #545cd8;
}

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar > .container, .navbar > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar > .body-tabs.body-tabs-layout.body-tabs-big,
.navbar > .container-fluid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container, .navbar-expand-sm > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-sm > .body-tabs.body-tabs-layout.body-tabs-big,
  .navbar-expand-sm > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container, .navbar-expand-sm > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-sm > .body-tabs.body-tabs-layout.body-tabs-big,
  .navbar-expand-sm > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container, .navbar-expand-md > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-md > .body-tabs.body-tabs-layout.body-tabs-big,
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container, .navbar-expand-md > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-md > .body-tabs.body-tabs-layout.body-tabs-big,
  .navbar-expand-md > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container, .navbar-expand-lg > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-lg > .body-tabs.body-tabs-layout.body-tabs-big,
  .navbar-expand-lg > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container, .navbar-expand-lg > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-lg > .body-tabs.body-tabs-layout.body-tabs-big,
  .navbar-expand-lg > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container, .navbar-expand-xl > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-xl > .body-tabs.body-tabs-layout.body-tabs-big,
  .navbar-expand-xl > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container, .navbar-expand-xl > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-xl > .body-tabs.body-tabs-layout.body-tabs-big,
  .navbar-expand-xl > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand > .container, .navbar-expand > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand > .body-tabs.body-tabs-layout.body-tabs-big,
.navbar-expand > .container-fluid {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container, .navbar-expand > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand > .body-tabs.body-tabs-layout.body-tabs-big,
.navbar-expand > .container-fluid {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group:first-child .list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.card > .list-group:last-child .list-group-item:last-child {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border-top: 1px solid rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
}

.card-img {
  width: 100%;
  border-radius: calc(0.25rem - 1px);
}

.card-img-top {
  width: 100%;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img-bottom {
  width: 100%;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck {
  display: flex;
  flex-direction: column;
}
.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    display: flex;
    flex: 1 0;
    flex-direction: column;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group {
  display: flex;
  flex-direction: column;
}
.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:first-of-type) .card-header:first-child {
  border-radius: 0;
}
.accordion > .card:not(:first-of-type):not(:last-of-type) {
  border-bottom: 0;
  border-radius: 0;
}
.accordion > .card:first-of-type {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:last-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card .card-header {
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: rgb(0%, 33.7647058824%, 70%);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 2;
  outline: 0;
  box-shadow: none;
}

.page-item:first-child .page-link, .pagination .page-number:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link, .pagination .page-number:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link, .pagination .active.page-number .page-link {
  z-index: 1;
  color: #fff;
  background-color: #545cd8;
  border-color: #007bff;
}
.page-item.disabled .page-link, .pagination .disabled.page-number .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.1rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link, .pagination-lg .pagination .page-number:first-child .page-link, .pagination .pagination-lg .page-number:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link, .pagination-lg .pagination .page-number:last-child .page-link, .pagination .pagination-lg .page-number:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link, .pagination-sm .pagination .page-number:first-child .page-link, .pagination .pagination-sm .page-number:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link, .pagination-sm .pagination .page-number:last-child .page-link, .pagination .pagination-sm .page-number:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #545cd8;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(84, 92, 216, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #3ac47d;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(58, 196, 125, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #30b1ff;
}
a.badge-info:hover, a.badge-info:focus {
  color: #fff;
  background-color: rgb(0%, 61.5856777494%, 98.8235294118%);
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(48, 177, 255, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #f7b924;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #212529;
  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(247, 185, 36, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #d92550;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(217, 37, 80, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #eeeeee;
}
a.badge-light:hover, a.badge-light:focus {
  color: #212529;
  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(238, 238, 238, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.badge-focus {
  color: #fff;
  background-color: #444054;
}
a.badge-focus:hover, a.badge-focus:focus {
  color: #fff;
  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);
}
a.badge-focus:focus, a.badge-focus.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(68, 64, 84, 0.5);
}

.badge-alternate {
  color: #fff;
  background-color: #83588a;
}
a.badge-alternate:hover, a.badge-alternate:focus {
  color: #fff;
  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);
}
a.badge-alternate:focus, a.badge-alternate.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(131, 88, 138, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);
  background-color: rgb(86.5882352941%, 87.2156862745%, 96.9411764706%);
  border-color: rgb(81.2235294118%, 82.1019607843%, 95.7176470588%);
}
.alert-primary hr {
  border-top-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);
}
.alert-primary .alert-link {
  color: rgb(11.5294117647%, 12.6274509804%, 29.6470588235%);
}

.alert-secondary {
  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  background-color: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  border-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);
}
.alert-secondary hr {
  border-top-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);
}
.alert-secondary .alert-link {
  color: rgb(12.7531431457%, 13.8159050745%, 14.7605823445%);
}

.alert-success {
  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);
  background-color: rgb(84.5490196078%, 95.3725490196%, 89.8039215686%);
  border-color: rgb(78.368627451%, 93.5215686275%, 85.7254901961%);
}
.alert-success hr {
  border-top-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);
}
.alert-success .alert-link {
  color: rgb(7.2605218465%, 24.5355565848%, 15.6476763934%);
}

.alert-info {
  color: rgb(9.7882352941%, 36.0941176471%, 52%);
  background-color: rgb(83.7647058824%, 93.8823529412%, 100%);
  border-color: rgb(77.2705882353%, 91.4352941176%, 100%);
}
.alert-info hr {
  border-top-color: rgb(67.2705882353%, 87.6671781756%, 100%);
}
.alert-info .alert-link {
  color: rgb(6.6199184624%, 24.4109493302%, 35.1683168317%);
}

.alert-warning {
  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);
  background-color: rgb(99.3725490196%, 94.5098039216%, 82.8235294118%);
  border-color: rgb(99.1215686275%, 92.3137254902%, 75.9529411765%);
}
.alert-warning hr {
  border-top-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);
}
.alert-warning .alert-link {
  color: rgb(32.9127970623%, 24.6512852491%, 4.7970068593%);
}

.alert-danger {
  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);
  background-color: rgb(97.0196078431%, 82.9019607843%, 86.2745098039%);
  border-color: rgb(95.8274509804%, 76.062745098%, 80.7843137255%);
}
.alert-danger hr {
  border-top-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);
}
.alert-danger .alert-link {
  color: rgb(27.1643662189%, 4.6317122124%, 10.0145128918%);
}

.alert-light {
  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);
  background-color: rgb(98.6666666667%, 98.6666666667%, 98.6666666667%);
  border-color: rgb(98.1333333333%, 98.1333333333%, 98.1333333333%);
}
.alert-light hr {
  border-top-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);
}
.alert-light .alert-link {
  color: rgb(38.5333333333%, 38.5333333333%, 38.5333333333%);
}

.alert-dark {
  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  background-color: rgb(84.0784313725%, 84.5490196078%, 85.0196078431%);
  border-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);
}
.alert-dark hr {
  border-top-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);
}
.alert-dark .alert-link {
  color: rgb(1.6384043272%, 1.8274509804%, 2.0164976335%);
}

.alert-focus {
  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);
  background-color: rgb(85.3333333333%, 85.0196078431%, 86.5882352941%);
  border-color: rgb(79.4666666667%, 79.0274509804%, 81.2235294118%);
}
.alert-focus hr {
  border-top-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);
}
.alert-focus .alert-link {
  color: rgb(4.6774774775%, 4.4023317435%, 5.7780604134%);
}

.alert-alternate {
  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);
  background-color: rgb(90.2745098039%, 86.9019607843%, 90.8235294118%);
  border-color: rgb(86.3843137255%, 81.662745098%, 87.1529411765%);
}
.alert-alternate hr {
  border-top-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);
}
.alert-alternate .alert-link {
  color: rgb(15.1208051362%, 10.1574874197%, 15.9287870901%);
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #545cd8;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #545cd8;
  border-color: #007bff;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal .list-group-item {
  margin-right: -1px;
  margin-bottom: 0;
}
.list-group-horizontal .list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal .list-group-item:last-child {
  margin-right: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }
  .list-group-horizontal-sm .list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }
  .list-group-horizontal-md .list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }
  .list-group-horizontal-lg .list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }
  .list-group-horizontal-xl .list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}
.list-group-flush .list-group-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.list-group-flush .list-group-item:last-child {
  margin-bottom: -1px;
}
.list-group-flush:first-child .list-group-item:first-child {
  border-top: 0;
}
.list-group-flush:last-child .list-group-item:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.list-group-item-primary {
  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);
  background-color: rgb(81.2235294118%, 82.1019607843%, 95.7176470588%);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);
  background-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);
  border-color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);
}

.list-group-item-secondary {
  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  background-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  border-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
}

.list-group-item-success {
  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);
  background-color: rgb(78.368627451%, 93.5215686275%, 85.7254901961%);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);
  background-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);
  border-color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);
}

.list-group-item-info {
  color: rgb(9.7882352941%, 36.0941176471%, 52%);
  background-color: rgb(77.2705882353%, 91.4352941176%, 100%);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(9.7882352941%, 36.0941176471%, 52%);
  background-color: rgb(67.2705882353%, 87.6671781756%, 100%);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(9.7882352941%, 36.0941176471%, 52%);
  border-color: rgb(9.7882352941%, 36.0941176471%, 52%);
}

.list-group-item-warning {
  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);
  background-color: rgb(99.1215686275%, 92.3137254902%, 75.9529411765%);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);
  background-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);
  border-color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);
}

.list-group-item-danger {
  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);
  background-color: rgb(95.8274509804%, 76.062745098%, 80.7843137255%);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);
  background-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);
  border-color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);
}

.list-group-item-light {
  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);
  background-color: rgb(98.1333333333%, 98.1333333333%, 98.1333333333%);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);
  background-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);
  border-color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);
}

.list-group-item-dark {
  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  background-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  border-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
}

.list-group-item-focus {
  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);
  background-color: rgb(79.4666666667%, 79.0274509804%, 81.2235294118%);
}
.list-group-item-focus.list-group-item-action:hover, .list-group-item-focus.list-group-item-action:focus {
  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);
  background-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);
}
.list-group-item-focus.list-group-item-action.active {
  color: #fff;
  background-color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);
  border-color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);
}

.list-group-item-alternate {
  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);
  background-color: rgb(86.3843137255%, 81.662745098%, 87.1529411765%);
}
.list-group-item-alternate.list-group-item-action:hover, .list-group-item-alternate.list-group-item-action:focus {
  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);
  background-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);
}
.list-group-item-alternate.list-group-item-action.active {
  color: #fff;
  background-color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);
  border-color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  appearance: none;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  max-width: 350px;
  overflow: hidden;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.modal-footer > :not(:first-child) {
  margin-left: 0.25rem;
}
.modal-footer > :not(:last-child) {
  margin-right: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 320px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125);
  border-radius: 0.3rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc((0.5rem + 1px) * -1);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc((0.5rem + 1px) * -1);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #fff;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.88rem;
  background-color: #fff;
  border-bottom: 1px solid rgb(95%, 95%, 95%);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: 0s 0.6s opacity;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50%/100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: spinner-grow 0.75s linear infinite;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #545cd8 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%) !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%) !important;
}

.bg-success {
  background-color: #3ac47d !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%) !important;
}

.bg-info {
  background-color: #30b1ff !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(0%, 61.5856777494%, 98.8235294118%) !important;
}

.bg-warning {
  background-color: #f7b924 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%) !important;
}

.bg-danger {
  background-color: #d92550 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%) !important;
}

.bg-light {
  background-color: #eeeeee !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%) !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%) !important;
}

.bg-focus {
  background-color: #444054 !important;
}

a.bg-focus:hover, a.bg-focus:focus,
button.bg-focus:hover,
button.bg-focus:focus {
  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%) !important;
}

.bg-alternate {
  background-color: #83588a !important;
}

a.bg-alternate:hover, a.bg-alternate:focus,
button.bg-alternate:hover,
button.bg-alternate:focus {
  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%) !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
  border-left: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #545cd8 !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #3ac47d !important;
}

.border-info {
  border-color: #30b1ff !important;
}

.border-warning {
  border-color: #f7b924 !important;
}

.border-danger {
  border-color: #d92550 !important;
}

.border-light {
  border-color: #eeeeee !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-focus {
  border-color: #444054 !important;
}

.border-alternate {
  border-color: #83588a !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.8571428571%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #545cd8 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%) !important;
}

.text-secondary {
  color: #6c757d !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: rgb(28.4473617773%, 30.8179752588%, 32.9251872423%) !important;
}

.text-success {
  color: #3ac47d !important;
}

a.text-success:hover, a.text-success:focus {
  color: rgb(15.8947043384%, 53.7131387988%, 34.2558283156%) !important;
}

.text-info {
  color: #30b1ff !important;
}

a.text-info:hover, a.text-info:focus {
  color: rgb(0%, 55.3537936914%, 88.8235294118%) !important;
}

.text-warning {
  color: #f7b924 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: rgb(78.1264576315%, 56.00846506%, 2.8539345254%) !important;
}

.text-danger {
  color: #d92550 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: rgb(59.4681179558%, 10.1397251814%, 21.923730122%) !important;
}

.text-light {
  color: #eeeeee !important;
}

a.text-light:hover, a.text-light:focus {
  color: rgb(78.3333333333%, 78.3333333333%, 78.3333333333%) !important;
}

.text-dark {
  color: #343a40 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: rgb(6.9438810007%, 7.7450980392%, 8.5463150778%) !important;
}

.text-focus {
  color: #444054 !important;
}

a.text-focus:hover, a.text-focus:focus {
  color: rgb(12.8828828829%, 12.1250662427%, 15.9141494436%) !important;
}

.text-alternate {
  color: #83588a !important;
}

a.text-alternate:hover, a.text-alternate:focus {
  color: rgb(33.9831684886%, 22.8283879924%, 35.799062988%) !important;
}

.text-body {
  color: #495057 !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

a,
button,
.btn {
  outline: none !important;
}

.app-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
}

.SidebarAnimation-appear {
  transform: translateX(-30px);
  opacity: 0;
}
.SidebarAnimation-appear.SidebarAnimation-appear-active {
  opacity: 1;
  transform: translateX(0);
  transition: all 0.4s linear;
}

.HeaderAnimation-appear {
  transform: translateY(-30px);
  opacity: 0;
}
.HeaderAnimation-appear.HeaderAnimation-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s linear;
}

.MainAnimation-appear {
  transform: translateY(-30px);
  opacity: 0;
}
.MainAnimation-appear.MainAnimation-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s linear;
}

.app-header {
  height: 60px;
  display: flex;
  align-items: center;
  align-content: center;
  position: relative;
  z-index: 10;
  transition: all 0.2s;
}
.app-header.header-shadow {
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}
.app-header .app-header__content {
  display: flex;
  align-items: center;
  align-content: center;
  flex: 1 1;
  padding: 0 1.5rem;
  height: 60px;
}
.app-header .app-header__content .app-header-left {
  display: flex;
  align-items: center;
}
.app-header .app-header__content .app-header-right {
  align-items: center;
  display: flex;
  margin-left: auto;
}
.app-header .header-user-info > .widget-heading, .app-header .header-user-info > .widget-subheading {
  white-space: nowrap;
}
.app-header .header-user-info > .widget-subheading {
  font-size: 0.8rem;
}

.app-header__logo {
  padding: 0 1.5rem;
  height: 60px;
  width: 280px;
  display: flex;
  align-items: center;
  transition: width 0.2s;
}
.app-header__logo .logo-src {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.app-header__menu,
.app-header__mobile-menu {
  display: none;
  padding: 0 1.5rem;
  height: 60px;
  align-items: center;
}

.fixed-header .app-header {
  position: fixed;
  width: 100%;
  top: 0;
}
.fixed-header .app-header .app-header__logo {
  visibility: visible;
}
.fixed-header .app-main {
  padding-top: 60px;
}
.fixed-header:not(.fixed-sidebar):not(.closed-sidebar) .app-sidebar .app-header__logo {
  visibility: hidden;
}

.header-dots {
  margin-left: auto;
  display: flex;
}
.header-dots > .dropdown {
  display: flex;
  align-content: center;
}
.header-dots .icon-wrapper-alt {
  margin: 0;
  height: 44px;
  width: 44px;
  text-align: center;
  overflow: visible;
}
.header-dots .icon-wrapper-alt .language-icon {
  border-radius: 30px;
  position: relative;
  z-index: 4;
  width: 28px;
  height: 28px;
  overflow: hidden;
  margin: 0 auto;
}
.header-dots .icon-wrapper-alt .language-icon img {
  position: relative;
  top: 50%;
  left: 50%;
  margin: -22px 0 0 -20px;
}
.header-dots .icon-wrapper-alt .icon-wrapper-bg {
  opacity: 0.1;
  transition: opacity 0.2s;
  border-radius: 40px;
}
.header-dots .icon-wrapper-alt svg {
  margin: 0 auto;
}
@-moz-document url-prefix() {
  .header-dots .icon-wrapper-alt svg {
    width: 50%;
  }
}
.header-dots .icon-wrapper-alt i {
  font-size: 1.3rem;
}
.header-dots .icon-wrapper-alt:hover {
  cursor: pointer;
}
.header-dots .icon-wrapper-alt:hover .icon-wrapper-bg {
  opacity: 0.2;
}
.header-dots .icon-wrapper-alt .badge-dot {
  top: 1px;
  right: 1px;
  border: 0;
}

.header-megamenu.nav > li > .nav-link {
  color: #6c757d;
  padding-left: 0.6666666667rem;
  padding-right: 0.6666666667rem;
}
.header-megamenu.nav > li > .nav-link .badge-pill {
  padding: 5px 7px;
}
.header-megamenu.nav > li > .nav-link:hover {
  color: #343a40;
}
.header-megamenu.nav > li > .nav-link svg {
  margin-top: 1px;
}

.header-btn-lg {
  padding: 0 0 0 1.5rem;
  margin-left: 1.5rem;
  display: flex;
  align-items: center;
  position: relative;
}
.header-btn-lg::before {
  position: absolute;
  left: -1px;
  top: 50%;
  background: #dee2e6;
  width: 1px;
  height: 30px;
  margin-top: -15px;
  content: "";
}
.header-btn-lg .hamburger-inner,
.header-btn-lg .hamburger-inner::before,
.header-btn-lg .hamburger-inner::after {
  background: #6c757d;
}

.app-header.header-text-light .app-header-left > .nav > li > .nav-link {
  color: rgba(255, 255, 255, 0.7);
}
.app-header.header-text-light .app-header-left > .nav > li > .nav-link .nav-link-icon {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header-left > .nav > li > .nav-link:hover {
  color: rgb(255, 255, 255);
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt svg {
  fill: rgba(255, 255, 255, 0.7);
  transition: all 0.2s;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt .icon-wrapper-bg {
  background: rgba(255, 255, 255, 0.1) !important;
  transition: all 0.2s;
  opacity: 1;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover svg {
  fill: rgba(255, 255, 255, 0.95);
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {
  background: rgba(255, 255, 255, 0.15) !important;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt .badge-dot {
  border-color: transparent;
}
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-content-left .btn-group > .btn-link,
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-heading,
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-subheading {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header-right > .header-btn-lg .header-user-info > .btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
}
.app-header.header-text-light .search-wrapper .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-light .search-wrapper .input-holder .search-input::placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-webkit-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-ms-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-moz-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.app-header.header-text-light .search-wrapper.active .input-holder {
  background: rgba(255, 255, 255, 0.1);
}
.app-header.header-text-light .search-wrapper.active .input-holder .search-input {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .search-wrapper.active .input-holder .search-icon {
  background: rgba(255, 255, 255, 0.1);
}
.app-header.header-text-light .header-btn-lg::before {
  background: rgba(255, 255, 255, 0.2);
}
.app-header.header-text-light .header-btn-lg .hamburger-inner,
.app-header.header-text-light .header-btn-lg .hamburger.is-active .hamburger-inner,
.app-header.header-text-light .header-btn-lg .hamburger-inner::before,
.app-header.header-text-light .header-btn-lg .hamburger-inner::after,
.app-header.header-text-light .header__pane .hamburger-inner,
.app-header.header-text-light .header__pane .hamburger.is-active .hamburger-inner,
.app-header.header-text-light .header__pane .hamburger-inner::before,
.app-header.header-text-light .header__pane .hamburger-inner::after {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
.app-header.header-text-light .search-wrapper .input-holder .search-icon span::after {
  border-color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .search-wrapper .close::before,
.app-header.header-text-light .search-wrapper .close::after,
.app-header.header-text-light .search-wrapper .input-holder .search-icon span::before {
  background: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner,
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::before,
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::after {
  background: rgba(255, 255, 255, 0.9);
}

.app-header.header-text-dark .app-header-left > .nav > li > .nav-link {
  color: rgba(0, 0, 0, 0.7);
}
.app-header.header-text-dark .app-header-left > .nav > li > .nav-link .nav-link-icon {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .app-header-left > .nav > li > .nav-link:hover {
  color: rgb(0, 0, 0);
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt svg {
  fill: rgba(0, 0, 0, 0.7);
  transition: all 0.2s;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt .icon-wrapper-bg {
  background: rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s;
  opacity: 1;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover svg {
  fill: rgba(0, 0, 0, 0.95);
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {
  background: rgba(0, 0, 0, 0.15) !important;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt .badge-dot {
  border-color: transparent;
}
.app-header.header-text-dark .app-header-right .widget-content-left > .btn-group > .btn-link,
.app-header.header-text-dark .app-header-right .widget-content-left .widget-heading,
.app-header.header-text-dark .app-header-right .widget-content-left .widget-subheading {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .search-wrapper.active .input-holder {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .search-wrapper.active .input-holder .search-input {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper.active .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .header-btn-lg::before {
  background: rgba(0, 0, 0, 0.2);
}
.app-header.header-text-dark .header-btn-lg .hamburger-inner,
.app-header.header-text-dark .header-btn-lg .hamburger.is-active .hamburger-inner,
.app-header.header-text-dark .header-btn-lg .hamburger-inner::before,
.app-header.header-text-dark .header-btn-lg .hamburger-inner::after,
.app-header.header-text-dark .header__pane .hamburger-inner,
.app-header.header-text-dark .header__pane .hamburger.is-active .hamburger-inner,
.app-header.header-text-dark .header__pane .hamburger-inner::before,
.app-header.header-text-dark .header__pane .hamburger-inner::after {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::after {
  border-color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper .close::before,
.app-header.header-text-dark .search-wrapper .close::after,
.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::before {
  background: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.app-sidebar {
  width: 280px;
  display: flex;
  z-index: 11;
  overflow: hidden;
  min-width: 280px;
  position: relative;
  flex: 0 0 280px;
  margin-top: -60px;
  padding-top: 60px;
  transition: all 0.2s;
}
.app-sidebar .app-sidebar__inner {
  padding: 2px 1.5rem 1.5rem;
}
.app-sidebar .scrollbar-container {
  z-index: 15;
  width: 100%;
}
.app-sidebar .app-sidebar-bg {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: 0.05;
  background-size: cover;
  z-index: 10;
}
.app-sidebar .app-header__logo {
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  z-index: 11;
}
.app-sidebar.sidebar-shadow {
  box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);
}

.app-sidebar__heading {
  text-transform: uppercase;
  font-size: 0.8rem;
  margin: 0.75rem 0;
  font-weight: bold;
  color: #545cd8;
  white-space: nowrap;
  position: relative;
}

.sidebar-mobile-overlay {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #333;
  opacity: 0.6;
  left: 0;
  top: 0;
  z-index: 12;
}

.vertical-nav-menu {
  position: relative;
}
.vertical-nav-menu::after {
  content: " ";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}
.vertical-nav-menu .metismenu-container,
.vertical-nav-menu .metismenu-item {
  margin: 0;
  padding: 0;
  position: relative;
}
.vertical-nav-menu .metismenu-container {
  list-style: none;
}
.vertical-nav-menu .metismenu-container:before {
  opacity: 0;
  transition: opacity 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-link {
  transition: transform 0.2s, height 300ms, color 300ms, background-color 300ms;
  display: block;
  line-height: 2.5rem;
  height: 2.5rem;
  padding: 0 1.5rem 0 45px;
  position: relative;
  border-radius: 0.25rem;
  color: #343a40;
  white-space: nowrap;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover {
  background: #e0f3ff;
  text-decoration: none;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-icon {
  opacity: 0.6;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-state-icon {
  opacity: 1;
}
.vertical-nav-menu .metismenu-container .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-link.has-active-child, .vertical-nav-menu .metismenu-container .metismenu-link.active {
  font-weight: bold;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon,
.vertical-nav-menu .metismenu-container i.metismenu-icon {
  text-align: center;
  width: 34px;
  height: 34px;
  line-height: 34px;
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -17px;
  font-size: 1.5rem;
  opacity: 0.3;
  transition: color 300ms;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon {
  transition: transform 300ms;
  left: auto;
  right: 0;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon.rotate-minus-90 {
  transform: rotate(-180deg);
}
.vertical-nav-menu .metismenu-container .metismenu-container {
  transition: padding 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible:before {
  content: "";
  height: 100%;
  opacity: 1;
  width: 3px;
  background: #e0f3ff;
  position: absolute;
  left: 20px;
  top: 0;
  border-radius: 15px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
  line-height: 2.3em;
  color: #6c757d;
  margin: 0 0 3px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link:hover {
  color: #545cd8;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link .metismenu-icon {
  display: none;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-item > .metismenu-link {
  height: 0;
  overflow: hidden;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 1em;
}

.app-sidebar.sidebar-text-light {
  border-right: 0 !important;
}
.app-sidebar.sidebar-text-light .app-sidebar__heading {
  color: rgba(255, 255, 255, 0.6);
}
.app-sidebar.sidebar-text-light .app-sidebar__heading::before {
  background: rgba(255, 255, 255, 0.2) !important;
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link {
  color: rgba(255, 255, 255, 0.7);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link:hover {
  color: rgb(255, 255, 255);
  background: rgba(255, 255, 255, 0.1);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link.active {
  background: rgba(255, 255, 255, 0.1);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {
  color: rgba(255, 255, 255, 0.6);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link:hover {
  color: rgb(255, 255, 255);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible::before {
  background: rgba(255, 255, 255, 0.3);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-state-icon,
.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-icon {
  opacity: 0.5;
}
.app-sidebar.sidebar-text-light .ps__thumb-y {
  background: rgba(255, 255, 255, 0.3);
}
.app-sidebar.sidebar-text-light .ps__rail-y:hover .ps__thumb-y {
  background: rgba(255, 255, 255, 0.2);
}
.app-sidebar.sidebar-text-light .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner,
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::before,
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::after {
  background-color: rgba(255, 255, 255, 0.8);
}

.app-sidebar.sidebar-text-dark {
  border-right: 0 !important;
}
.app-sidebar.sidebar-text-dark .app-sidebar__heading {
  color: rgba(0, 0, 0, 0.6);
}
.app-sidebar.sidebar-text-dark .app-sidebar__heading::before {
  background: rgba(0, 0, 0, 0.5) !important;
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link {
  color: rgba(0, 0, 0, 0.7);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link:hover {
  color: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link.active {
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {
  color: rgba(0, 0, 0, 0.6);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible::before {
  background: rgba(0, 0, 0, 0.3);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-state-icon,
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-icon {
  opacity: 0.5;
}
.app-sidebar.sidebar-text-dark .ps__thumb-y {
  background: rgba(0, 0, 0, 0.3);
}
.app-sidebar.sidebar-text-dark .ps__rail-y:hover .ps__thumb-y {
  background: rgba(0, 0, 0, 0.2);
}
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner,
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::before,
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::after {
  background-color: rgba(0, 0, 0, 0.8);
}

.fixed-sidebar .app-sidebar {
  position: fixed;
  height: 100vh;
}
.fixed-sidebar .app-main .app-main__outer {
  z-index: 9;
  padding-left: 280px;
}
.fixed-sidebar.fixed-header .app-sidebar .app-header__logo {
  display: none;
}
.fixed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {
  display: flex;
}
.fixed-sidebar:not(.fixed-header) .app-header {
  margin-left: 280px;
}
.fixed-sidebar:not(.fixed-header) .app-header .app-header__logo {
  display: none;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-header {
  margin-left: 80px;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {
  width: 80px;
  padding: 0;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .logo-src {
  display: none;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .header__pane {
  margin-right: auto;
}

.closed-sidebar .app-sidebar {
  transition: all 0.3s ease;
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px;
  z-index: 13;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading {
  text-indent: -999em;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: #e0f3ff;
  text-indent: 1px;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-link {
  text-indent: -99rem;
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {
  text-indent: 0;
  left: 50%;
  margin-left: -17px;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-state-icon {
  visibility: hidden;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible {
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 0;
}
.closed-sidebar .app-sidebar:hover {
  flex: 0 0 280px !important;
  width: 280px !important;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading {
  text-indent: 0;
  text-indent: initial;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading::before {
  display: none;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-link {
  text-indent: 0;
  text-indent: initial;
  padding: 0 1.5rem 0 45px;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-icon {
  text-indent: 0;
  text-indent: initial;
  left: 5px;
  margin-left: 0;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-state-icon {
  visibility: visible;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 1em;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar .scrollbar-container {
  position: static;
  height: auto;
  overflow: visible !important;
  overflow: initial !important;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar:hover .scrollbar-container {
  position: absolute;
  height: 100%;
  overflow: hidden !important;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo {
  width: 80px;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .logo-src {
  display: none;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .header__pane {
  margin-right: auto;
}
.closed-sidebar.fixed-sidebar .app-main__outer {
  padding-left: 80px;
}
.closed-sidebar.fixed-header:not(.fixed-sidebar) .app-sidebar .app-header__logo {
  visibility: hidden;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo {
  width: auto;
  display: flex;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo {
  display: flex;
  width: 80px;
  padding: 0 1.5rem !important;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .logo-src {
  display: block !important;
  margin: 0 auto;
  width: 21px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo {
  width: 280px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo .logo-src {
  width: 97px;
  margin: 0;
}
.closed-sidebar.closed-sidebar-mobile .app-header {
  margin-left: 0 !important;
}
.closed-sidebar.fixed-footer .app-footer__inner {
  margin-left: 0 !important;
}

.app-main {
  z-index: 8;
  position: relative;
  display: flex;
}
.app-main .app-main__outer {
  flex: 1 1;
  flex-direction: column;
  display: flex;
  z-index: 12;
  width: 1px;
}
.app-main .app-main__inner {
  padding: 30px 30px 0;
  flex: 1 1;
}
.app-main .app-main__inner > .RRT__container > .RRT__panel {
  margin-top: 30px;
}
.app-main .app-main__inner > .RRT__container > .body-tabs-layout .RRT__tab {
  margin-top: -0.5rem;
}

.body-tabs-shadow-btn .app-main__inner > .RRT__container > .RRT__panel {
  margin-top: 20px;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout {
  border: 0;
  background: transparent;
  position: relative;
  z-index: 7;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__showmore {
  margin-top: -13px;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab {
  margin-top: 0.5rem;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab--selected {
  color: #fff;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper {
  position: absolute;
  top: 1.1rem;
  z-index: 5;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper .RRT__inkbar {
  height: 35px;
  margin-top: 0;
  border-radius: 0.25rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.app-theme-white.app-container {
  background: #f1f4f6;
}
.app-theme-white .app-sidebar {
  background: #ffffff;
}
.app-theme-white .app-page-title {
  background: rgba(255, 255, 255, 0.55);
}
.app-theme-white .app-footer .app-footer__inner,
.app-theme-white .app-header {
  background: #fafbfc;
}
.app-theme-white.fixed-header .app-header__logo {
  background: rgba(250, 251, 252, 0.1);
}

.app-theme-gray.app-container {
  background: #ffffff;
}
.app-theme-gray .app-sidebar {
  background: #ffffff;
  border-right: #dee2e6 solid 1px;
}
.app-theme-gray .app-page-title {
  background: rgba(0, 0, 0, 0.03);
}
.app-theme-gray .app-footer,
.app-theme-gray .app-header {
  background: #f8f9fa;
}
.app-theme-gray .app-footer {
  border-top: #dee2e6 solid 1px;
}
.app-theme-gray .app-header .app-header__logo {
  border-right: rgba(0, 0, 0, 0.1) solid 1px;
}
.app-theme-gray.fixed-header .app-header__logo {
  background: rgba(0, 0, 0, 0.03);
}
.app-theme-gray .card {
  border-width: 1px;
}
.app-theme-gray .main-card {
  box-shadow: 0 0 0 0 transparent !important;
}
.app-theme-gray .main-card > .card-body > .card-title {
  text-transform: none;
  font-size: 1.1rem;
  font-weight: normal;
  border-bottom: #dee2e6 solid 1px;
  position: relative;
  padding: 0 0 1.125rem;
  margin: 0 0 1.125rem;
}
.app-theme-gray .main-card > .card-body > .card-title::before {
  position: absolute;
  width: 40px;
  background: #545cd8;
  border-radius: 30px;
  height: 5px;
  left: 0;
  bottom: -2px;
  content: "";
}
.app-theme-gray .app-inner-layout__sidebar {
  border-left: 0 !important;
}

.app-footer {
  height: 60px;
}
.app-footer .app-footer__inner {
  padding: 0 1.5rem 0 0.75rem;
  height: 60px;
  transition: all 0.2s;
  display: flex;
  align-content: center;
  align-items: center;
}
.app-footer .app-footer__inner .app-footer-left {
  display: flex;
  align-items: center;
}
.app-footer .app-footer__inner .app-footer-right {
  margin-left: auto;
  display: flex;
}

.footer-dots {
  display: flex;
  align-items: center;
  align-content: center;
}
.footer-dots .dots-separator {
  height: 40px;
  margin: 0 0.6rem;
  width: 1px;
  background: #e9ecef;
}

.dot-btn-wrapper {
  padding: 0.5rem;
  position: relative;
  display: flex;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.dot-btn-wrapper .badge-abs {
  right: 50%;
}
.dot-btn-wrapper .badge-abs.badge-dot-sm {
  top: -2px;
  margin-right: -3px;
}
.dot-btn-wrapper .dot-btn-icon {
  font-size: 1.8rem;
}
.dot-btn-wrapper:hover {
  text-decoration: none;
  opacity: 1;
}

.fixed-footer .app-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 7;
}
.fixed-footer .app-footer .app-footer__inner {
  margin-left: 280px;
  box-shadow: 0.3rem -0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.02), 0.3rem -0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.02), 0.3rem -0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.04), 0.3rem -0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.02);
}
.fixed-footer .app-main .app-main__outer {
  padding-bottom: 60px;
}
.fixed-footer.closed-sidebar .app-footer .app-footer__inner {
  margin-left: 80px !important;
}

.app-page-title {
  padding: 30px;
  margin: -30px -30px 30px;
  position: relative;
}
.app-page-title .page-title-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.app-page-title .page-title-heading,
.app-page-title .page-title-subheading {
  margin: 0;
  padding: 0;
}
.app-page-title .page-title-heading {
  font-size: 1.25rem;
  font-weight: 400;
  display: flex;
  align-content: center;
  align-items: center;
}
.app-page-title .page-title-subheading {
  padding: 3px 0 0;
  font-size: 0.88rem;
  opacity: 0.6;
}
.app-page-title .page-title-subheading .breadcrumb {
  padding: 0;
  margin: 3px 0 0;
  background: transparent;
}
.app-page-title .page-title-actions {
  margin-left: auto;
}
.app-page-title .page-title-actions .breadcrumb {
  margin: 0;
  padding: 0;
  background: transparent;
}
.app-page-title .page-title-icon {
  font-size: 2rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  padding: 0.8333333333rem;
  margin: 0 30px 0 0;
  background: #fff;
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
  border-radius: 0.25rem;
  width: 60px;
  height: 60px;
}
.app-page-title .page-title-icon i {
  margin: auto;
}
.app-page-title .page-title-icon.rounded-circle {
  margin: 0 20px 0 0;
}
.app-page-title + .RRT__container {
  margin-top: -23.0769230769px;
}
.app-page-title + .rc-tabs {
  max-width: calc(100vw - 322px);
  margin: -30px -15px 39px;
}
@media only screen and (max-width: 812px) and (min-width: 360px) {
  .app-page-title + .rc-tabs {
    max-width: calc(100vw - 0px);
    margin: -30px -15px 39px;
  }
}
.app-page-title.app-page-title-simple {
  margin: 0;
  background: none !important;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}

.page-title-icon-rounded .page-title-icon {
  border-radius: 50px;
}

.body-tabs.body-tabs-layout {
  margin-left: -30px;
  margin-right: -30px;
  padding: 0 30px;
  border-top: 0;
  border-bottom: #dee2e6 solid 1px;
}

.search-wrapper {
  position: relative;
  margin-right: 0.6666666667rem;
}
.search-wrapper .input-holder {
  height: 42px;
  width: 42px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease-in-out;
}
.search-wrapper .input-holder .search-input {
  width: 100%;
  padding: 0 70px 0 20px;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  box-sizing: border-box;
  border: none;
  outline: none;
  transform: translate(0, 60px);
  transition: all 0.3s cubic-bezier(0, 0.105, 0.035, 1.57);
  transition-delay: 0.3s;
  font-size: 0.88rem;
}
.search-wrapper .input-holder .search-icon {
  width: 42px;
  height: 42px;
  border: none;
  padding: 0;
  outline: none;
  position: relative;
  z-index: 2;
  float: right;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 30px;
}
.search-wrapper .input-holder .search-icon span {
  width: 22px;
  height: 22px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  transform: rotate(45deg);
  transition: all 0.4s cubic-bezier(0.65, -0.6, 0.24, 1.65);
}
.search-wrapper .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {
  position: absolute;
  content: "";
}
.search-wrapper .input-holder .search-icon span::before {
  width: 4px;
  height: 11px;
  left: 9px;
  top: 13px;
  border-radius: 2px;
  background: #545cd8;
}
.search-wrapper .input-holder .search-icon span::after {
  width: 14px;
  height: 14px;
  left: 4px;
  top: 0;
  border-radius: 16px;
  border: 2px solid #545cd8;
}
.search-wrapper .close {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 0;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  cursor: pointer;
  opacity: 0 !important;
  transform: rotate(-180deg);
  transition: all 0.2s cubic-bezier(0.285, -0.45, 0.935, 0.11);
  transition-delay: 0.1s;
}
.search-wrapper .close::before, .search-wrapper .close::after {
  position: absolute;
  content: "";
  background: #545cd8;
  border-radius: 2px;
}
.search-wrapper .close::before {
  width: 2px;
  height: 20px;
  left: 9px;
  top: 0;
}
.search-wrapper .close::after {
  width: 20px;
  height: 2px;
  left: 0;
  top: 9px;
}
.search-wrapper.active {
  width: 330px;
}
.search-wrapper.active .input-holder {
  width: 290px;
  border-radius: 50px;
  background: rgba(0, 0, 0, 0.05);
  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);
}
.search-wrapper.active .input-holder .search-input {
  opacity: 1;
  transform: translate(0, 11px);
}
.search-wrapper.active .input-holder .search-icon {
  width: 42px;
  height: 42px;
  margin: 0;
  border-radius: 30px;
}
.search-wrapper.active .input-holder .search-icon span {
  transform: rotate(-45deg);
}
.search-wrapper.active .close {
  left: 300px;
  opacity: 0.6 !important;
  transform: rotate(45deg);
  transition: all 0.6s cubic-bezier(0, 0.105, 0.035, 1.57);
  transition-delay: 0.5s;
}
.search-wrapper.active .close:hover {
  opacity: 1 !important;
}
.search-wrapper.active + .header-megamenu {
  opacity: 0;
}

.opacity-01 {
  opacity: 0.01 !important;
}

.opacity-02 {
  opacity: 0.02 !important;
}

.opacity-03 {
  opacity: 0.03 !important;
}

.opacity-04 {
  opacity: 0.04 !important;
}

.opacity-05 {
  opacity: 0.05 !important;
}

.opacity-06 {
  opacity: 0.06 !important;
}

.opacity-07 {
  opacity: 0.07 !important;
}

.opacity-08 {
  opacity: 0.08 !important;
}

.opacity-09 {
  opacity: 0.09 !important;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-9 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.filter-grayscale-5 {
  filter: grayscale(5%) !important;
}

.filter-grayscale-10 {
  filter: grayscale(10%) !important;
}

.filter-grayscale-20 {
  filter: grayscale(20%) !important;
}

.filter-grayscale-30 {
  filter: grayscale(30%) !important;
}

.filter-grayscale-40 {
  filter: grayscale(40%) !important;
}

.filter-grayscale-50 {
  filter: grayscale(50%) !important;
}

.filter-grayscale-80 {
  filter: grayscale(80%) !important;
}

.filter-grayscale-100 {
  filter: grayscale(100%) !important;
}

.br-tl {
  border-top-left-radius: 0.25rem !important;
}

.br-tr {
  border-top-right-radius: 0.25rem !important;
}

.br-bl {
  border-bottom-left-radius: 0.25rem !important;
}

.br-br {
  border-bottom-right-radius: 0.25rem !important;
}

.b-radius-0 {
  border-radius: 0 !important;
}

.rm-border {
  border-width: 0 !important;
}

.br-a {
  border-radius: 0.25rem;
}

.margin-h-center {
  margin-left: auto !important;
  margin-right: auto !important;
}

.center-svg {
  margin: 0 auto;
}
.center-svg svg {
  margin: 0 auto;
}

.apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-donut {
  display: flex;
  align-items: center;
  align-content: center;
}

.alert-dismissible .close {
  top: 0;
  right: 5px;
  padding: 5px;
}

.icon-gradient {
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.font-size-xlg {
  font-size: 1.3rem !important;
}

.font-size-md {
  font-size: 0.9rem !important;
}

.font-size-lg {
  font-size: 1.1rem !important;
}

.no-shadow {
  box-shadow: 0 0 0 transparent !important;
}

.h-100 {
  height: 100vh !important;
}

.he-auto {
  height: auto !important;
}

.he-100 {
  height: 100%;
}

.h-sm {
  height: 150px;
}

.text-nowrap {
  white-space: nowrap;
}

.fsize-1 {
  font-size: 0.95rem !important;
}

.fsize-2 {
  font-size: 1.3rem !important;
}

.fsize-3 {
  font-size: 1.6rem !important;
}

.fsize-4 {
  font-size: 2rem !important;
}

.z-index-6 {
  z-index: 6;
}

.line-height-1 {
  line-height: 1;
}

.center-elem {
  display: flex;
  align-items: center;
  align-content: center;
}

.flex2 {
  flex: 2 1;
}

.divider {
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1px;
  overflow: hidden;
  background: #e9ecef;
}

.list-group-item:hover {
  z-index: auto;
  z-index: initial;
}

.no-results {
  padding: 1.5rem;
  text-align: center;
}
.no-results .results-title {
  color: #495057;
  font-size: 1.25rem;
}
.no-results .results-subtitle {
  color: #adb5bd;
  font-size: 1.1rem;
}

.bg-animation {
  animation: bg-pan-left 8s both;
}
@keyframes bg-pan-left {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.w-100 {
  width: 100%;
}

.mb--2 {
  margin-bottom: -1.5rem;
}

.mbg-3 {
  margin-bottom: 30px;
}

.loader-container {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100vw;
  text-align: center;
  line-height: 1.6rem;
}
.loader-container .loader-container-inner {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 1.5rem;
}
.loader-container small {
  margin: 10px 0 0;
  display: block;
  color: #6c757d;
  font-weight: normal;
}
.loader-container h3 {
  text-align: center;
  display: block;
}

.bg-warm-flame {
  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;
}

.bg-night-fade {
  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;
}

.bg-sunny-morning {
  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;
}

.bg-tempting-azure {
  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;
}

.bg-amy-crisp {
  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;
}

.bg-heavy-rain {
  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;
}

.bg-mean-fruit {
  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;
}

.bg-malibu-beach {
  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;
}

.bg-deep-blue {
  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;
}

.bg-ripe-malin {
  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;
}

.bg-arielle-smile {
  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;
}

.bg-plum-plate {
  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.bg-happy-fisher {
  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;
}

.bg-happy-itmeo {
  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;
}

.bg-mixed-hopes {
  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;
}

.bg-strong-bliss {
  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;
}

.bg-grow-early {
  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;
}

.bg-love-kiss {
  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;
}

.bg-premium-dark {
  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;
}

.bg-happy-green {
  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;
}

.bg-vicious-stance {
  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;
}

.bg-midnight-bloom {
  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;
}

.bg-night-sky {
  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;
}

.bg-slick-carbon {
  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.25) 200%) !important;
  background-blend-mode: multiply;
}

.bg-royal {
  background-image: linear-gradient(to right, #141e30, #243b55) !important;
}

.bg-asteroid {
  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;
}

.bg-transparent {
  background: transparent !important;
}

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT
Copyright (c) 2015 Daniel Eden
*/
body {
  -webkit-backface-visibility: hidden;
}

.animated, .TabsAnimation-appear {
  animation-duration: calc(1s);
  animation-fill-mode: both;
}
.animated.infinite, .infinite.TabsAnimation-appear {
  animation-iteration-count: infinite;
}
.animated.hinge, .hinge.TabsAnimation-appear {
  animation-duration: calc(1s * 2);
}
.animated.bounceIn, .bounceIn.TabsAnimation-appear, .animated.bounceOut, .bounceOut.TabsAnimation-appear {
  animation-duration: calc(1s * 0.75);
}
.animated.flipOutX, .flipOutX.TabsAnimation-appear, .animated.flipOutY, .flipOutY.TabsAnimation-appear {
  animation-duration: calc(1s * 0.75);
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadeIn {
  animation-name: fadeIn;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeInUp, .TabsAnimation-appear {
  animation-name: fadeInUp;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes lightSpeedIn {
  0% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0;
  }
  60% {
    transform: translateX(-20%) skewX(30deg);
    opacity: 1;
  }
  80% {
    transform: translateX(0%) skewX(-15deg);
    opacity: 1;
  }
  100% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1;
  }
}
.lightSpeedIn {
  animation-name: lightSpeedIn;
  animation-timing-function: ease-out;
}
@keyframes lightSpeedOut {
  0% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1;
  }
  100% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0;
  }
}
.lightSpeedOut {
  animation-name: lightSpeedOut;
  animation-timing-function: ease-in;
}

.dropdown-menu.show {
  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.popover.show {
  display: block;
  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.dropdown-menu[data-placement^=top].show {
  animation: fade-in3 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  bottom: auto !important;
  top: auto !important;
}

@keyframes fade-in2 {
  0% {
    margin-top: -50px;
    visibility: hidden;
    opacity: 0;
  }
  100% {
    margin-top: 0px;
    visibility: visible;
    opacity: 1;
  }
}
.form-control {
  transition: all 0.2s;
}

.btn-outline-2x {
  border-width: 2px;
}

.btn-group .btn {
  font-size: 0.8rem;
  font-weight: 500;
}
.btn-group .btn-outline-2x + .btn-outline-2x {
  margin-left: -2px;
}
.btn-group .btn-square {
  border-radius: 0;
}

.btn {
  font-size: 0.8rem;
  font-weight: 500;
}
.btn.btn-pill.btn-wide, .btn.btn-pill {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.btn-dashed {
  border-style: dashed;
}

.btn-icon {
  vertical-align: bottom;
}
.btn-icon.btn-icon-right .btn-icon-wrapper {
  margin-left: 0.5rem;
  margin-right: 0;
}
.btn-icon .btn-icon-wrapper {
  margin-right: 0.5rem;
  margin-left: 0;
  margin-top: 0;
  font-size: 17px;
  vertical-align: middle;
  transition: color 0.1s;
  display: inline-block;
}
.btn-icon.btn-link {
  text-decoration: none;
}
.btn-icon.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 25px;
}
.btn-icon.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 16px;
}

.btn-icon-only .btn-icon-wrapper {
  margin-left: 0;
  margin-right: 0;
}

.btn-hover-shine {
  position: relative;
}
.btn-hover-shine:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  transition: none;
}
.btn-hover-shine:hover:after {
  width: 120%;
  background-color: rgba(255, 255, 255, 0);
  transition: all 0.4s ease-in-out;
}
.btn-hover-shine.btn-pill::after {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.btn-icon-vertical {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.btn-icon-vertical .btn-icon-wrapper {
  display: block;
  font-size: 200%;
  margin: 5px 0;
  opacity: 0.6;
}
.btn-icon-vertical.btn-link {
  text-decoration: none;
}
.btn-icon-vertical.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 25px;
}
.btn-icon-vertical.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 16px;
}
.btn-icon-vertical:active .btn-icon-wrapper, .btn-icon-vertical.active .btn-icon-wrapper, .btn-icon-vertical:hover .btn-icon-wrapper {
  opacity: 1;
}
.btn-icon-vertical.btn-icon-bottom .btn-icon-wrapper {
  margin: 0.2rem 0 5px;
}
.btn-icon-vertical.btn-transition-text .btn-icon-wrapper {
  transition: all 0.2s !important;
}
.btn-icon-vertical.btn-transition-text:hover .btn-icon-wrapper {
  transform: scale(1.3);
}
.btn-icon-vertical.btn-transition-text.btn-transition-alt:hover .btn-icon-wrapper {
  color: #fff !important;
}

.btn-icon-lg {
  font-size: 2.5rem !important;
}

.btn-transition {
  color: #6c757d;
  border-color: #e9ecef;
  background-color: none;
}
.btn-transition.btn-outline-link {
  border-color: transparent;
  background-color: transparent;
}
.btn-transition.btn-outline-link:hover {
  color: #545cd8;
  background: #f8f9fa;
}
.btn-transition.disabled, .btn-transition:disabled {
  color: #6c757d;
  border-color: #e9ecef;
}
.btn-transition:hover .btn-icon-wrapper {
  transition: none;
}

.btn-transition-alt:hover .icon-gradient {
  -webkit-background-clip: initial;
  -webkit-text-fill-color: initial;
  background-clip: border-box;
  background-clip: initial;
  text-fill-color: initial;
  background: none !important;
  color: #fff;
}

.btn-square {
  border-radius: 0 !important;
}

.btn.btn-wide {
  padding: 0.375rem 1.5rem;
  font-size: 0.8rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.btn-lg.btn-wide, .btn-group-lg > .btn-wide.btn {
  padding: 0.5rem 2rem;
  font-size: 1.1rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm.btn-wide, .btn-group-sm > .btn-wide.btn {
  padding: 0.25rem 1rem;
  font-size: 0.8rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.dropdown-toggle::after {
  position: relative;
  top: 2px;
  opacity: 0.8;
}

.dropright .dropdown-toggle::after {
  top: 0;
}

.dropdown-toggle-split {
  border-left: rgba(255, 255, 255, 0.1) solid 1px;
}

.btn-gradient-primary {
  background-image: linear-gradient(140deg, rgb(16.2773109244%, 19.6162464986%, 71.3697478992%) -30%, #545cd8 90%);
  background-color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);
  border-color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);
  color: #fff;
}
.btn-gradient-primary.active, .btn-gradient-primary:active, .btn-gradient-primary:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(15.1630252101%, 18.2733893557%, 66.4840336134%) 0%, rgb(28.0554621849%, 31.4212885154%, 83.5915966387%) 100%);
  color: #fff;
  border-color: rgb(12.5630252101%, 15.1400560224%, 55.0840336134%);
}
.btn-gradient-primary:focus, .btn-gradient-primary.focus, .btn-gradient-primary:active, .btn-gradient-primary.active {
  color: #fff !important;
  border-color: rgb(14.4201680672%, 17.3781512605%, 63.2268907563%) !important;
}
.btn-gradient-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-gradient-primary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}

.btn-gradient-secondary {
  background-image: linear-gradient(140deg, rgb(28.4473617773%, 30.8179752588%, 32.9251872423%) -30%, #6c757d 90%);
  background-color: rgb(28.4473617773%, 30.8179752588%, 32.9251872423%);
  border-color: rgb(28.4473617773%, 30.8179752588%, 32.9251872423%);
  color: #fff;
}
.btn-gradient-secondary.active, .btn-gradient-secondary:active, .btn-gradient-secondary:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(25.6662458975%, 27.8050997223%, 29.7063031221%) 0%, rgb(39.5718252966%, 42.8694774047%, 45.800723723%) 100%);
  color: #fff;
  border-color: rgb(19.1769755112%, 20.7750568038%, 22.1955735084%);
}
.btn-gradient-secondary:focus, .btn-gradient-secondary.focus, .btn-gradient-secondary:active, .btn-gradient-secondary.active {
  color: #fff !important;
  border-color: rgb(23.8121686443%, 25.7965160313%, 27.5603803753%) !important;
}
.btn-gradient-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-gradient-secondary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}

.btn-gradient-success {
  background-image: linear-gradient(140deg, rgb(15.8947043384%, 53.7131387988%, 34.2558283156%) -30%, #3ac47d 90%);
  background-color: rgb(15.8947043384%, 53.7131387988%, 34.2558283156%);
  border-color: rgb(15.8947043384%, 53.7131387988%, 34.2558283156%);
  color: #fff;
}
.btn-gradient-success.active, .btn-gradient-success:active, .btn-gradient-success:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(14.5246255983%, 49.083217539%, 31.3030724101%) 0%, rgb(21.3750192991%, 72.2328238382%, 46.0668519376%) 100%);
  color: #fff;
  border-color: rgb(11.3277752046%, 38.2800679327%, 24.4133086305%);
}
.btn-gradient-success:focus, .btn-gradient-success.focus, .btn-gradient-success:active, .btn-gradient-success.active {
  color: #fff !important;
  border-color: rgb(13.6112397715%, 45.9966033658%, 29.3345684731%) !important;
}
.btn-gradient-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-gradient-success.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}

.btn-gradient-info {
  background-image: linear-gradient(140deg, rgb(0%, 55.3537936914%, 88.8235294118%) -30%, #30b1ff 90%);
  background-color: rgb(0%, 55.3537936914%, 88.8235294118%);
  border-color: rgb(0%, 55.3537936914%, 88.8235294118%);
  color: #fff;
}
.btn-gradient-info.active, .btn-gradient-info:active, .btn-gradient-info:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(0%, 51.6146632566%, 82.8235294118%) 0%, rgb(12.8235294118%, 67.1508951407%, 100%) 100%);
  color: #fff;
  border-color: rgb(0%, 42.8900255754%, 68.8235294118%);
}
.btn-gradient-info:focus, .btn-gradient-info.focus, .btn-gradient-info:active, .btn-gradient-info.active {
  color: #fff !important;
  border-color: rgb(0%, 49.1219096334%, 78.8235294118%) !important;
}
.btn-gradient-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-gradient-info.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}

.btn-gradient-warning {
  background-image: linear-gradient(140deg, rgb(78.1264576315%, 56.00846506%, 2.8539345254%) -30%, #f7b924 90%);
  background-color: rgb(78.1264576315%, 56.00846506%, 2.8539345254%);
  border-color: rgb(78.1264576315%, 56.00846506%, 2.8539345254%);
  color: #fff;
}
.btn-gradient-warning.active, .btn-gradient-warning:active, .btn-gradient-warning:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(72.337911376%, 51.8586853243%, 2.6424807809%) 0%, rgb(96.6512913535%, 70.6987993435%, 8.3291008033%) 100%);
  color: #fff;
  border-color: rgb(58.8313034465%, 42.1758659411%, 2.1490887104%);
}
.btn-gradient-warning:focus, .btn-gradient-warning.focus, .btn-gradient-warning:active, .btn-gradient-warning.active {
  color: #fff !important;
  border-color: rgb(68.478880539%, 49.0921655006%, 2.5015116179%) !important;
}
.btn-gradient-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-gradient-warning.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}

.btn-gradient-danger {
  background-image: linear-gradient(140deg, rgb(59.4681179558%, 10.1397251814%, 21.923730122%) -30%, #d92550 90%);
  background-color: rgb(59.4681179558%, 10.1397251814%, 21.923730122%);
  border-color: rgb(59.4681179558%, 10.1397251814%, 21.923730122%);
  color: #fff;
}
.btn-gradient-danger.active, .btn-gradient-danger:active, .btn-gradient-danger:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(54.3421337039%, 9.2657094334%, 20.0339663424%) 0%, rgb(79.9720549637%, 13.6357881735%, 29.4827852401%) 100%);
  color: #fff;
  border-color: rgb(42.3815037826%, 7.2263393546%, 15.6245175235%);
}
.btn-gradient-danger:focus, .btn-gradient-danger.focus, .btn-gradient-danger:active, .btn-gradient-danger.active {
  color: #fff !important;
  border-color: rgb(50.9248108692%, 8.683032268%, 18.7741238228%) !important;
}
.btn-gradient-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-gradient-danger.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}

.btn-gradient-focus {
  background-image: linear-gradient(140deg, rgb(12.8828828829%, 12.1250662427%, 15.9141494436%) -30%, #444054 90%);
  background-color: rgb(12.8828828829%, 12.1250662427%, 15.9141494436%);
  border-color: rgb(12.8828828829%, 12.1250662427%, 15.9141494436%);
  color: #fff;
}
.btn-gradient-focus.active, .btn-gradient-focus:active, .btn-gradient-focus:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(10.1261261261%, 9.5304716481%, 12.5087440382%) 0%, rgb(23.9099099099%, 22.5034446211%, 29.5357710652%) 100%);
  color: #fff;
  border-color: rgb(3.6936936937%, 3.4764175941%, 4.5627980922%);
}
.btn-gradient-focus:focus, .btn-gradient-focus.focus, .btn-gradient-focus:active, .btn-gradient-focus.active {
  color: #fff !important;
  border-color: rgb(8.2882882883%, 7.8007419184%, 10.2384737679%) !important;
}
.btn-gradient-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-gradient-focus.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}

.btn-gradient-alternate {
  background-image: linear-gradient(140deg, rgb(33.9831684886%, 22.8283879924%, 35.799062988%) -30%, #83588a 90%);
  background-color: rgb(33.9831684886%, 22.8283879924%, 35.799062988%);
  border-color: rgb(33.9831684886%, 22.8283879924%, 35.799062988%);
  color: #fff;
}
.btn-gradient-alternate.active, .btn-gradient-alternate:active, .btn-gradient-alternate:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(30.5052923824%, 20.4921048065%, 32.1353461739%) 0%, rgb(47.8946729134%, 32.1735207357%, 50.4539302447%) 100%);
  color: #fff;
  border-color: rgb(22.3902481347%, 15.0407773729%, 23.5866736075%);
}
.btn-gradient-alternate:focus, .btn-gradient-alternate.focus, .btn-gradient-alternate:active, .btn-gradient-alternate.active {
  color: #fff !important;
  border-color: rgb(28.1867083116%, 18.9345826826%, 29.6928682978%) !important;
}
.btn-gradient-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-gradient-alternate.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}

.btn-gradient-light {
  background-image: linear-gradient(140deg, rgb(78.3333333333%, 78.3333333333%, 78.3333333333%) -30%, #eeeeee 90%);
  background-color: rgb(78.3333333333%, 78.3333333333%, 78.3333333333%);
  border-color: rgb(78.3333333333%, 78.3333333333%, 78.3333333333%);
  color: #212529;
}
.btn-gradient-light.active, .btn-gradient-light:active, .btn-gradient-light:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(75.3333333333%, 75.3333333333%, 75.3333333333%) 0%, rgb(90.3333333333%, 90.3333333333%, 90.3333333333%) 100%);
  color: #212529;
  border-color: rgb(68.3333333333%, 68.3333333333%, 68.3333333333%);
}
.btn-gradient-light:focus, .btn-gradient-light.focus, .btn-gradient-light:active, .btn-gradient-light.active {
  color: #212529 !important;
  border-color: #bbbbbb !important;
}
.btn-gradient-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-gradient-light.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}

.btn-gradient-dark {
  background-image: linear-gradient(140deg, rgb(6.9438810007%, 7.7450980392%, 8.5463150778%) -30%, #343a40 90%);
  background-color: rgb(6.9438810007%, 7.7450980392%, 8.5463150778%);
  border-color: rgb(6.9438810007%, 7.7450980392%, 8.5463150778%);
  color: #fff;
}
.btn-gradient-dark.active, .btn-gradient-dark:active, .btn-gradient-dark:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(4.2542258283%, 4.7450980392%, 5.2359702502%) 0%, rgb(17.7025016903%, 19.7450980392%, 21.7876943881%) 100%);
  color: #fff;
  border-color: black;
}
.btn-gradient-dark:focus, .btn-gradient-dark.focus, .btn-gradient-dark:active, .btn-gradient-dark.active {
  color: #fff !important;
  border-color: rgb(2.46112238%, 2.7450980392%, 3.0290736984%) !important;
}
.btn-gradient-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-gradient-dark.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}

.btn-shadow.active {
  box-shadow: 0 0 0 0 transparent !important;
}

.btn-primary {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(20.7268907563%, 24.4355742297%, 81.9201680672%);
  border-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
}
.btn-primary:focus, .btn-primary.focus {
  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
  border-color: rgb(17.2058823529%, 20.7352941176%, 75.4411764706%);
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);
}
.btn-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-primary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(35.4001514769%, 38.3501641%, 40.9723975427%);
  border-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.btn-secondary:focus, .btn-secondary.focus {
  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
  border-color: rgb(30.7649583439%, 33.3287048725%, 35.6075906758%);
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);
}
.btn-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-secondary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}

.btn-success {
  color: #fff;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success:hover {
  color: #fff;
  background-color: rgb(19.3199011888%, 65.2879419484%, 41.6377180794%);
  border-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);
}
.btn-success:focus, .btn-success.focus {
  box-shadow: 0 0 0 0 rgba(34.3333333333%, 80.3333333333%, 56.6666666667%, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);
  border-color: rgb(17.0364366219%, 57.5714065154%, 36.7164582368%);
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(34.3333333333%, 80.3333333333%, 56.6666666667%, 0.5);
}
.btn-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-success.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}

.btn-info {
  color: #fff;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info:hover {
  color: #fff;
  background-color: rgb(3.8235294118%, 63.7595907928%, 100%);
  border-color: rgb(0%, 61.5856777494%, 98.8235294118%);
}
.btn-info:focus, .btn-info.focus {
  box-shadow: 0 0 0 0 rgba(31%, 74%, 100%, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0%, 61.5856777494%, 98.8235294118%);
  border-color: rgb(0%, 58.4697357204%, 93.8235294118%);
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(31%, 74%, 100%, 0.5);
}
.btn-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-info.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}

.btn-warning {
  color: #212529;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning:hover {
  color: #212529;
  background-color: rgb(92.5978232703%, 66.3829143992%, 3.3825688866%);
  border-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);
}
.btn-warning:focus, .btn-warning.focus {
  box-shadow: 0 0 0 0 rgba(84.2745098039%, 63.8431372549%, 14.4117647059%, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);
  border-color: rgb(82.9502461778%, 59.4666148398%, 3.0301459791%);
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(84.2745098039%, 63.8431372549%, 14.4117647059%, 0.5);
}
.btn-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-warning.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}

.btn-danger {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(72.2830785858%, 12.3247645515%, 26.6481395708%);
  border-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);
}
.btn-danger:focus, .btn-danger.focus {
  box-shadow: 0 0 0 0 rgba(87.3333333333%, 27.3333333333%, 41.6666666667%, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);
  border-color: rgb(63.7397714992%, 10.8680716381%, 23.4985332716%);
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(87.3333333333%, 27.3333333333%, 41.6666666667%, 0.5);
}
.btn-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-danger.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}

.btn-light {
  color: #212529;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light:hover {
  color: #212529;
  background-color: rgb(85.8333333333%, 85.8333333333%, 85.8333333333%);
  border-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);
}
.btn-light:focus, .btn-light.focus {
  box-shadow: 0 0 0 0 rgba(81.2745098039%, 81.5098039216%, 81.7450980392%, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);
  border-color: rgb(80.8333333333%, 80.8333333333%, 80.8333333333%);
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(81.2745098039%, 81.5098039216%, 81.7450980392%, 0.5);
}
.btn-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-light.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(13.6680189317%, 15.2450980392%, 16.8221771467%);
  border-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
}
.btn-dark:focus, .btn-dark.focus {
  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
  border-color: rgb(9.185260311%, 10.2450980392%, 11.3049357674%);
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);
}
.btn-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-dark.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}

.btn-focus {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus:hover {
  color: #fff;
  background-color: rgb(19.7747747748%, 18.6115527292%, 24.4276629571%);
  border-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);
}
.btn-focus:focus, .btn-focus.focus {
  box-shadow: 0 0 0 0 rgba(37.6666666667%, 36.3333333333%, 43%, 0.5);
}
.btn-focus.disabled, .btn-focus:disabled {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus:not(:disabled):not(.disabled):active, .btn-focus:not(:disabled):not(.disabled).active, .show > .btn-focus.dropdown-toggle {
  color: #fff;
  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);
  border-color: rgb(15.1801801802%, 14.2872284049%, 18.7519872814%);
}
.btn-focus:not(:disabled):not(.disabled):active:focus, .btn-focus:not(:disabled):not(.disabled).active:focus, .show > .btn-focus.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(37.6666666667%, 36.3333333333%, 43%, 0.5);
}
.btn-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-focus.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}

.btn-alternate {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate:hover {
  color: #fff;
  background-color: rgb(42.6778587541%, 28.669095957%, 44.9583550234%);
  border-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);
}
.btn-alternate:focus, .btn-alternate.focus {
  box-shadow: 0 0 0 0 rgba(58.6666666667%, 44.3333333333%, 61%, 0.5);
}
.btn-alternate.disabled, .btn-alternate:disabled {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate:not(:disabled):not(.disabled):active, .btn-alternate:not(:disabled):not(.disabled).active, .show > .btn-alternate.dropdown-toggle {
  color: #fff;
  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);
  border-color: rgb(36.8813985771%, 24.7752906472%, 38.8521603332%);
}
.btn-alternate:not(:disabled):not(.disabled):active:focus, .btn-alternate:not(:disabled):not(.disabled).active:focus, .show > .btn-alternate.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(58.6666666667%, 44.3333333333%, 61%, 0.5);
}
.btn-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-alternate.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}

.btn-shadow-primary:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}

.btn-shadow-secondary:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}

.btn-shadow-success:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}

.btn-shadow-info:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}

.btn-shadow-warning:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}

.btn-shadow-danger:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}

.btn-shadow-light:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}

.btn-shadow-dark:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}

.btn-shadow-focus:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}

.btn-shadow-alternate:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}

.btn-outline-primary {
  color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #545cd8;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-outline-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-outline-primary.btn-shadow.active:hover, .btn-outline-primary.btn-shadow.disabled:hover, .btn-outline-primary.btn-shadow:active:hover, .btn-outline-primary.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}
.btn-outline-primary.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(84, 92, 216, 0.19);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.btn-shadow.active:hover, .btn-outline-secondary.btn-shadow.disabled:hover, .btn-outline-secondary.btn-shadow:active:hover, .btn-outline-secondary.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}
.btn-outline-secondary.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(108, 117, 125, 0.19);
}

.btn-outline-success {
  color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #3ac47d;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-outline-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-outline-success.btn-shadow.active:hover, .btn-outline-success.btn-shadow.disabled:hover, .btn-outline-success.btn-shadow:active:hover, .btn-outline-success.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}
.btn-outline-success.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(58, 196, 125, 0.19);
}

.btn-outline-info {
  color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #30b1ff;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-outline-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-outline-info.btn-shadow.active:hover, .btn-outline-info.btn-shadow.disabled:hover, .btn-outline-info.btn-shadow:active:hover, .btn-outline-info.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}
.btn-outline-info.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(48, 177, 255, 0.19);
}

.btn-outline-warning {
  color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #f7b924;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-outline-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-outline-warning.btn-shadow.active:hover, .btn-outline-warning.btn-shadow.disabled:hover, .btn-outline-warning.btn-shadow:active:hover, .btn-outline-warning.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}
.btn-outline-warning.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(247, 185, 36, 0.19);
}

.btn-outline-danger {
  color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #d92550;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-outline-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-outline-danger.btn-shadow.active:hover, .btn-outline-danger.btn-shadow.disabled:hover, .btn-outline-danger.btn-shadow:active:hover, .btn-outline-danger.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}
.btn-outline-danger.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(217, 37, 80, 0.19);
}

.btn-outline-light {
  color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #eeeeee;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-outline-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-outline-light.btn-shadow.active:hover, .btn-outline-light.btn-shadow.disabled:hover, .btn-outline-light.btn-shadow:active:hover, .btn-outline-light.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}
.btn-outline-light.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(238, 238, 238, 0.19);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.btn-shadow.active:hover, .btn-outline-dark.btn-shadow.disabled:hover, .btn-outline-dark.btn-shadow:active:hover, .btn-outline-dark.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}
.btn-outline-dark.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(52, 58, 64, 0.19);
}

.btn-outline-focus {
  color: #444054;
  border-color: #444054;
}
.btn-outline-focus:hover {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-outline-focus:focus, .btn-outline-focus.focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-outline-focus.disabled, .btn-outline-focus:disabled {
  color: #444054;
  background-color: transparent;
}
.btn-outline-focus:not(:disabled):not(.disabled):active, .btn-outline-focus:not(:disabled):not(.disabled).active, .show > .btn-outline-focus.dropdown-toggle {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-outline-focus:not(:disabled):not(.disabled):active:focus, .btn-outline-focus:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-focus.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-outline-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-outline-focus.btn-shadow.active:hover, .btn-outline-focus.btn-shadow.disabled:hover, .btn-outline-focus.btn-shadow:active:hover, .btn-outline-focus.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}
.btn-outline-focus.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(68, 64, 84, 0.19);
}

.btn-outline-alternate {
  color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:hover {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:focus, .btn-outline-alternate.focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate.disabled, .btn-outline-alternate:disabled {
  color: #83588a;
  background-color: transparent;
}
.btn-outline-alternate:not(:disabled):not(.disabled):active, .btn-outline-alternate:not(:disabled):not(.disabled).active, .show > .btn-outline-alternate.dropdown-toggle {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:not(:disabled):not(.disabled):active:focus, .btn-outline-alternate:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-alternate.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate.btn-shadow.active:hover, .btn-outline-alternate.btn-shadow.disabled:hover, .btn-outline-alternate.btn-shadow:active:hover, .btn-outline-alternate.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}
.btn-outline-alternate.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(131, 88, 138, 0.19);
}

.btn {
  position: relative;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn-light {
  border-color: rgb(86.0784313725%, 86.0784313725%, 86.0784313725%);
}

.btn-outline-light {
  color: #8f8f8f;
}

.dropdown-menu {
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
  font-size: 0.88rem;
  margin: 0.125rem;
}
.dropdown-menu.dropdown-menu-right {
  right: 0 !important;
}
.dropdown-menu .dropdown-header {
  text-transform: uppercase;
  font-size: 0.7333333333rem;
  color: #545cd8;
  font-weight: bold;
}
.dropdown-menu .dropdown-item {
  font-size: 0.88rem;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  z-index: 6;
  position: relative;
}
.dropdown-menu .dropdown-item .dropdown-icon {
  font-size: 1rem;
  margin-right: 0.325rem;
  width: 30px;
  text-align: center;
  opacity: 0.3;
  margin-left: -10px;
}
.dropdown-menu .dropdown-item:hover .dropdown-icon {
  opacity: 0.7;
}
.dropdown-menu.dropdown-menu-shadow {
  box-shadow: 0 0.66875rem 2.3875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 1.1375rem 1.60625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.45rem 0.73125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.325rem 0.3875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}

.dropdown-menu-rounded {
  border-radius: 10px;
  padding: 0.65rem;
}
.dropdown-menu-rounded .dropdown-item {
  border-radius: 30px;
}
.dropdown-menu-rounded .dropdown-divider {
  margin-left: -0.65rem;
  margin-right: -0.65rem;
}
.dropdown-menu-rounded .dropdown-menu-header {
  margin-left: -0.65rem;
  margin-right: -0.65rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.dropdown-menu-rounded .menu-header-image,
.dropdown-menu-rounded .dropdown-menu-header-inner {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.dropdown-menu-hover-link .dropdown-item:hover {
  background: none;
  color: #545cd8;
}

.dropdown-menu-hover-primary .dropdown-item:hover {
  background: #545cd8;
  color: #fff;
}

.dropdown-menu.dropdown-menu-lg {
  min-width: 22rem;
}
.dropdown-menu.dropdown-menu-xl {
  min-width: 25rem;
}

.dropdown-menu .dropdown-menu-header,
.dropdown-menu .menu-header-image,
.dropdown-menu .dropdown-menu-header-inner {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.dropdown-menu-header {
  color: #fff;
  margin-top: -0.65rem;
  margin-bottom: 0.65rem;
  position: relative;
  z-index: 6;
}
.dropdown-menu-header .dropdown-menu-header-inner {
  margin: -1px -1px 0;
  padding: 1.5rem 0.5rem;
  position: relative;
}
.dropdown-menu-header .menu-header-image {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 8;
  opacity: 0.25;
  filter: grayscale(80%);
  background-size: cover;
}
.dropdown-menu-header .menu-header-content {
  text-align: center;
  position: relative;
  z-index: 10;
}
.dropdown-menu-header .menu-header-content.text-left {
  padding-left: 0.5rem;
}
.dropdown-menu-header .menu-header-content.btn-pane-right {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  align-content: center;
  align-items: center;
  text-align: left;
}
.dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
  margin: 0 0 0 auto;
}
.dropdown-menu-header .menu-header-content .menu-header-btn-pane {
  margin-top: 10px;
  margin-bottom: 3px;
}
.dropdown-menu-header + .grid-menu {
  margin-top: -0.65rem;
}

.menu-header-title {
  font-weight: 500;
  font-size: 1.25rem;
  margin: 0;
}

.menu-header-subtitle {
  font-size: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  margin: 5px 0 0;
  opacity: 0.8;
}

.dropdown-menu .grid-menu {
  margin-bottom: -0.65rem;
  padding: 1px;
}
.dropdown-menu .grid-menu [class*=col-] {
  padding: 0.65rem;
}
.dropdown-menu .grid-menu-xl {
  margin-bottom: -0.4814814815rem;
}
.dropdown-menu .grid-menu-xl [class*=col-] {
  padding: 0;
}

.dropdown-toggle::after {
  position: relative;
  top: 2px;
  opacity: 0.8;
  margin-left: 5px;
}

.dropdown-toggle-split::after {
  margin-left: 0;
}

.dropright .dropdown-toggle::after {
  top: 0;
}

.dropdown-toggle-split {
  border-left: rgba(255, 255, 255, 0.1) solid 2px;
}

.dropdown-menu::before, .dropdown-menu::after {
  position: absolute;
  width: 14px;
  height: 14px;
  left: 5px;
  top: -5px;
  transform: rotate(45deg);
  border-radius: 4px;
  content: "";
  display: block;
  z-index: 5;
}
.dropdown-menu::before {
  background: #fff;
  z-index: 5;
}
.dropdown-menu::after {
  top: -6px;
  background: rgba(0, 0, 0, 0.15);
  z-index: 4;
}
.dropdown-menu[data-placement=top-start]::before, .dropdown-menu[data-placement=top-start]::after {
  top: auto;
  bottom: -5px;
}
.dropdown-menu[data-placement=top-start]::after {
  bottom: -6px;
}
.dropdown-menu[data-placement=left-start]::before, .dropdown-menu[data-placement=left-start]::after {
  left: auto;
  right: -5px;
  top: 5px;
}
.dropdown-menu[data-placement=left-start]::after {
  top: 5px;
  right: -6px;
}
.dropdown-menu[data-placement=right-start]::before, .dropdown-menu[data-placement=right-start]::after {
  right: auto;
  left: -5px;
  top: 5px;
}
.dropdown-menu[data-placement=right-start]::after {
  top: 5px;
  left: -6px;
}
.dropdown-menu.dropdown-menu-right::before, .dropdown-menu.dropdown-menu-right::after {
  left: auto;
  right: 6px;
}
.dropdown-menu.dropdown-menu-right::after {
  right: 6px;
}
.dropdown-menu.rm-pointers::before, .dropdown-menu.rm-pointers::after {
  display: none;
}

.dropdown-mega-menu {
  width: 56rem;
  padding: 1rem;
}
.dropdown-mega-menu .nav-item.nav-item-header {
  text-transform: none;
  font-size: 1rem;
  padding-top: 0;
  font-weight: normal;
}
.dropdown-mega-menu .grid-menu {
  margin-bottom: 0;
}

.dropdown-mega-menu-sm {
  width: 40rem;
}

body .dropdown-menu.dropdown-menu-inline {
  border: 0;
  position: static !important;
  box-shadow: 0 0 0 transparent;
  background: transparent;
  border-radius: 0;
  display: inline-block;
  float: none;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  transform: translateY(0) !important;
}
body .dropdown-menu.dropdown-menu-inline::before, body .dropdown-menu.dropdown-menu-inline::after {
  display: none;
}

.nav-item .nav-link {
  font-weight: normal;
}

.nav-link {
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}
.nav-link .nav-link-icon {
  color: #545cd8;
  font-size: 1rem;
  width: 30px;
  text-align: center;
  opacity: 0.45;
  margin-left: -10px;
}
.nav-link:hover {
  color: #495057;
}
.nav-link:hover .nav-link-icon {
  opacity: 0.9;
  color: #545cd8;
}
.nav-link:disabled .nav-link-icon, .nav-link.disabled .nav-link-icon {
  opacity: 0.3;
}

.nav-item.nav-item-header {
  text-transform: uppercase;
  font-size: 0.7333333333rem;
  color: #6c757d;
  font-weight: bold;
  padding: 0.5rem 1rem;
}
.nav-item.nav-item-btn {
  padding: 0.5rem 1rem;
}
.nav-item.nav-item-divider {
  margin: 0.5rem 0;
  height: 1px;
  overflow: hidden;
  background: #dee2e6;
}

.nav .badge {
  margin-left: 8px;
}

.nav-pills .nav-link.active, .nav-pills .nav-link.active:hover {
  color: #fff;
}
.nav-pills .nav-link.active .nav-link-icon, .nav-pills .nav-link.active:hover .nav-link-icon {
  color: #fff;
  opacity: 0.8;
}
.nav-pills .nav-link:hover {
  color: #495057 !important;
}

.grid-menu [class*=col-] {
  border-right: #dee2e6 solid 0;
  border-bottom: #dee2e6 solid 1px;
}
.grid-menu [class*=col-]:hover {
  z-index: 5;
}
@media (min-width: 576px) {
  .grid-menu [class*=col-]:nth-last-child(-n+2) {
    border-bottom-width: 0;
  }
  .grid-menu [class*=col-]:nth-child(1n) {
    border-right-width: 1px;
  }
  .grid-menu [class*=col-]:nth-child(2n) {
    border-right-width: 0;
  }
}
.grid-menu [class*=col-]:nth-last-child(-n+1) {
  border-bottom-width: 0;
}
@media (min-width: 1200px) {
  .grid-menu.grid-menu-3col [class*=col-]:nth-last-child(-n+3) {
    border-bottom-width: 0;
  }
  .grid-menu.grid-menu-3col [class*=col-]:nth-child(2n) {
    border-right-width: 1px;
  }
  .grid-menu.grid-menu-3col [class*=col-]:nth-child(3n) {
    border-right-width: 0;
  }
}
.grid-menu .btn {
  display: block;
  border: 0;
  min-width: 100%;
}

.badge-primary {
  color: #fff;
  background-color: #545cd8;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(84, 92, 216, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #3ac47d;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(58, 196, 125, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #30b1ff;
}
a.badge-info:hover, a.badge-info:focus {
  color: #fff;
  background-color: rgb(0%, 61.5856777494%, 98.8235294118%);
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(48, 177, 255, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #f7b924;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #212529;
  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(247, 185, 36, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #d92550;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(217, 37, 80, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #eeeeee;
}
a.badge-light:hover, a.badge-light:focus {
  color: #212529;
  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(238, 238, 238, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.badge-focus {
  color: #fff;
  background-color: #444054;
}
a.badge-focus:hover, a.badge-focus:focus {
  color: #fff;
  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);
}
a.badge-focus:focus, a.badge-focus.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(68, 64, 84, 0.5);
}

.badge-alternate {
  color: #fff;
  background-color: #83588a;
}
a.badge-alternate:hover, a.badge-alternate:focus {
  color: #fff;
  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);
}
a.badge-alternate:focus, a.badge-alternate.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(131, 88, 138, 0.5);
}

.badge {
  font-weight: bold;
  text-transform: uppercase;
  padding: 5px 10px;
  min-width: 19px;
}

.badge-light {
  background: #fff;
}

.badge-dot {
  text-indent: -999em;
  padding: 0;
  width: 8px;
  height: 8px;
  border: transparent solid 1px;
  border-radius: 30px;
  min-width: 2px;
}

.badge-dot-lg {
  width: 10px;
  height: 10px;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}
.badge-dot-xl::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 0.25rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -5px 0 0 -5px;
  background: #fff;
}

.badge-dot-sm {
  width: 6px;
  height: 6px;
}

.btn .badge {
  margin-left: 8px;
}
.btn .badge-dot {
  position: absolute;
  border: #fff solid 2px;
  top: -5px;
  right: -5px;
  width: 11px;
  height: 11px;
}
.btn .badge-dot.badge-dot-lg {
  width: 14px;
  height: 14px;
}
.btn .badge-dot.badge-dot-sm {
  width: 8px;
  height: 8px;
  border-width: 1px;
}
.btn .badge-dot-inside {
  top: 10px;
  right: 10px;
}

.btn-sm .badge-dot-sm, .btn-group-sm > .btn .badge-dot-sm {
  top: 1px;
  right: 4px;
}
.btn-sm .badge-dot, .btn-group-sm > .btn .badge-dot {
  top: 0px;
  right: 2px;
}
.btn-sm .badge-dot-lg, .btn-group-sm > .btn .badge-dot-lg {
  top: -3px;
  right: -2px;
}
.btn-sm .badge-pill, .btn-group-sm > .btn .badge-pill {
  position: absolute;
  top: -4px;
  right: -4px;
}

.badge-abs {
  position: absolute;
  right: -3px;
  top: -3px;
}

.avatar-icon-wrapper {
  display: inline-block;
  margin-right: 0.1rem;
  position: relative;
}
.avatar-icon-wrapper .badge {
  position: absolute;
  right: -2px;
  top: -2px;
}
.avatar-icon-wrapper .badge:empty {
  display: block;
}
.avatar-icon-wrapper .badge.badge-bottom {
  top: auto;
  right: -2px;
  bottom: -2px;
}
.avatar-icon-wrapper .badge-dot {
  width: 10px;
  height: 10px;
  border: #fff solid 2px;
}
.avatar-icon-wrapper .badge-dot.badge-dot-lg {
  width: 14px;
  height: 14px;
  border: #fff solid 2px;
  top: 0;
  right: 0;
}
.avatar-icon-wrapper .badge-dot.badge-dot-lg.badge-bottom {
  top: auto;
  right: 0;
  bottom: 0;
}

.avatar-icon-add .avatar-icon {
  background: #e0f3ff;
  border: rgb(57.3697478992%, 59.3641456583%, 90.2773109244%) dashed 1px;
  color: #545cd8;
  text-align: center;
  opacity: 0.6;
}
.avatar-icon-add .avatar-icon i {
  font-style: normal;
  vertical-align: middle;
  font-size: 1.5rem;
  display: block;
  height: 100%;
}
.avatar-icon-add:hover {
  cursor: pointer;
}
.avatar-icon-add:hover .avatar-icon {
  opacity: 1;
}

a.avatar-icon-wrapper:hover .avatar-icon {
  opacity: 0.8;
}

.avatar-icon {
  display: block;
  width: 44px;
  height: 44px;
  transition: all 0.2s;
  opacity: 1;
  border-radius: 50px;
}
.avatar-icon.rounded {
  border-radius: 0.39rem !important;
}

.avatar-icon-xl .avatar-icon {
  width: 64px;
  height: 64px;
}
.avatar-icon-xl.avatar-icon-add i {
  font-size: 2rem;
}

.avatar-icon-lg .avatar-icon {
  width: 54px;
  height: 54px;
}
.avatar-icon-lg.avatar-icon-add i {
  font-size: 1.75rem;
}

.avatar-icon-sm .avatar-icon {
  width: 34px;
  height: 34px;
}
.avatar-icon-sm.avatar-icon-add i {
  font-size: 1.1rem;
}

.avatar-icon-xs .avatar-icon {
  width: 26px;
  height: 26px;
  transition: transform 0.2s;
}
.avatar-icon-xs.avatar-icon-add i {
  line-height: 26px;
  font-size: 0.88rem;
}
.avatar-icon-xs:hover .avatar-icon {
  transform: scale(2);
}

.avatar-icon {
  border: #fff solid 3px;
  overflow: hidden;
}
.avatar-icon img {
  width: 100%;
  height: 100%;
}

.avatar-wrapper-overlap .avatar-icon-wrapper {
  z-index: 5;
  margin-left: -18px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper:hover {
  z-index: 7;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xl {
  margin-left: -30px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-lg {
  margin-left: -24px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-sm {
  margin-left: -14px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xs {
  margin-left: -10px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-add, .avatar-wrapper-overlap .avatar-icon-wrapper:first-child {
  margin-left: 0 !important;
}
.badge-pulse {
  -webkit-animation: pulse 2s ease-out;
  -webkit-animation-iteration-count: infinite;
  position: relative;
}
.badge-pulse::before, .badge-pulse::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  -webkit-animation-iteration-count: infinite;
}
.badge-pulse::after {
  -webkit-animation-delay: 0.33s;
  -webkit-animation-duration: 2.2s;
}

.card {
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
  border-width: 0;
  transition: all 0.2s;
}
.card > .dropdown-menu-header {
  margin: 0;
}
.card > .dropdown-menu-header .dropdown-menu-header-inner {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.card.text-dark.text-white .card-footer,
.card.text-dark.text-white .card-header, .card.text-white .card-footer,
.card.text-white .card-header {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}
.card.text-dark.text-white .card-footer,
.card.text-dark.text-white .card-header {
  color: rgba(0, 0, 0, 0.9);
}
.card .card-footer {
  display: flex;
  align-items: center;
}

.btn-actions-pane-right {
  margin-left: auto;
  white-space: nowrap;
}

.btn-actions-pane-left {
  margin-right: auto;
}

.actions-icon-btn .btn-icon-only {
  padding-left: 0;
  padding-right: 0;
}
.actions-icon-btn .btn-icon-only .btn-icon-wrapper {
  font-size: 1.3rem;
  width: 30px;
  text-align: center;
}
.actions-icon-btn .btn-icon-only {
  color: #495057;
}
.actions-icon-btn .btn-icon-only:hover {
  color: #545cd8;
}

.card-header,
.card-title {
  text-transform: uppercase;
  color: rgba(6.9915966387%, 8.4257703081%, 30.6554621849%, 0.7);
  font-weight: bold;
  font-size: 0.88rem;
}

.card-header {
  display: flex;
  align-items: center;
  border-bottom-width: 1px;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0.625rem;
  height: 3.5rem;
}
.card-header.no-border {
  border: 0;
  padding: 0;
  height: auto;
}
.card-header .menu-header-subtitle {
  display: block;
}
.card-header.card-header-tab .nav {
  width: auto;
  margin-left: auto;
}
.card-header.card-header-tab .card-header-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.card-header .header-icon {
  font-size: 1.65rem;
  margin-right: 0.625rem;
}
.card-header > .nav {
  margin-left: -0.625rem;
  height: 100%;
  width: 100%;
}
.card-header > .nav .nav-item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}
.card-header > .nav .nav-link {
  text-transform: none;
  width: 100%;
  display: block;
  color: #495057;
}
.card-header > .nav .nav-link::before {
  content: "";
  border-radius: 15px;
  background: #545cd8;
  transition: all 0.2s;
  height: 4px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -2px;
  opacity: 0;
}
.card-header > .nav .nav-link:hover {
  color: #545cd8;
}
.card-header > .nav .nav-link.active {
  color: #545cd8;
}
.card-header > .nav .nav-link.active::before {
  opacity: 1;
}
.card-header.card-header-tab-animation .nav .nav-link::before {
  transform: scale(0);
  opacity: 1;
  width: 90%;
  left: 5%;
}
.card-header.card-header-tab-animation .nav .nav-link.active::before, .card-header.card-header-tab-animation .nav .nav-link:hover::before {
  transform: scale(1);
}

.card-border {
  box-shadow: 0 0 0 transparent;
  border-width: 1px;
}

.card-hover-shadow:hover {
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}

.card-hover-shadow-2x:hover {
  box-shadow: 0 0.66875rem 2.3875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 1.1375rem 1.60625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.45rem 0.73125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.325rem 0.3875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}

.card-subtitle {
  margin-bottom: 0.75rem;
  font-size: 0.968rem;
  color: rgba(6.9915966387%, 8.4257703081%, 30.6554621849%, 0.55);
}

.card-shadow-primary {
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.03), 0 0.9375rem 1.40625rem rgba(84, 92, 216, 0.03), 0 0.25rem 0.53125rem rgba(84, 92, 216, 0.05), 0 0.125rem 0.1875rem rgba(84, 92, 216, 0.03);
}

.card-shadow-secondary {
  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.03), 0 0.9375rem 1.40625rem rgba(108, 117, 125, 0.03), 0 0.25rem 0.53125rem rgba(108, 117, 125, 0.05), 0 0.125rem 0.1875rem rgba(108, 117, 125, 0.03);
}

.card-shadow-success {
  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.03), 0 0.9375rem 1.40625rem rgba(58, 196, 125, 0.03), 0 0.25rem 0.53125rem rgba(58, 196, 125, 0.05), 0 0.125rem 0.1875rem rgba(58, 196, 125, 0.03);
}

.card-shadow-info {
  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.03), 0 0.9375rem 1.40625rem rgba(48, 177, 255, 0.03), 0 0.25rem 0.53125rem rgba(48, 177, 255, 0.05), 0 0.125rem 0.1875rem rgba(48, 177, 255, 0.03);
}

.card-shadow-warning {
  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.03), 0 0.9375rem 1.40625rem rgba(247, 185, 36, 0.03), 0 0.25rem 0.53125rem rgba(247, 185, 36, 0.05), 0 0.125rem 0.1875rem rgba(247, 185, 36, 0.03);
}

.card-shadow-danger {
  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.03), 0 0.9375rem 1.40625rem rgba(217, 37, 80, 0.03), 0 0.25rem 0.53125rem rgba(217, 37, 80, 0.05), 0 0.125rem 0.1875rem rgba(217, 37, 80, 0.03);
}

.card-shadow-light {
  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.03), 0 0.9375rem 1.40625rem rgba(238, 238, 238, 0.03), 0 0.25rem 0.53125rem rgba(238, 238, 238, 0.05), 0 0.125rem 0.1875rem rgba(238, 238, 238, 0.03);
}

.card-shadow-dark {
  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.03), 0 0.9375rem 1.40625rem rgba(52, 58, 64, 0.03), 0 0.25rem 0.53125rem rgba(52, 58, 64, 0.05), 0 0.125rem 0.1875rem rgba(52, 58, 64, 0.03);
}

.card-shadow-focus {
  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.03), 0 0.9375rem 1.40625rem rgba(68, 64, 84, 0.03), 0 0.25rem 0.53125rem rgba(68, 64, 84, 0.05), 0 0.125rem 0.1875rem rgba(68, 64, 84, 0.03);
}

.card-shadow-alternate {
  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.03), 0 0.9375rem 1.40625rem rgba(131, 88, 138, 0.03), 0 0.25rem 0.53125rem rgba(131, 88, 138, 0.05), 0 0.125rem 0.1875rem rgba(131, 88, 138, 0.03);
}

.card-header-lg {
  padding: 1.5rem 2.5rem;
  height: auto;
}

.sticky-active-class .sticky-inner-wrapper > div {
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}

.nav-pills,
.nav-tabs {
  margin-bottom: 1rem;
}

.nav-link {
  font-weight: bold;
}
.nav-link:hover {
  cursor: pointer;
}

.nav-tabs .nav-link:hover {
  color: #545cd8 !important;
}
.nav-tabs .nav-link.active {
  color: #545cd8;
}

.nav-pills .nav-link:hover {
  color: #545cd8 !important;
}
.nav-pills .nav-link.active {
  background: #545cd8;
}
.nav-pills .nav-link.active:hover {
  color: #fff !important;
}

.RRT__container {
  position: relative;
}

.RRT__tabs {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.RRT__accordion {
  flex-direction: column;
}

.RRT__tab {
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  padding: 0.5rem 1rem;
  transition: all 0.2s;
}
.RRT__tab:hover {
  color: #545cd8;
}
.RRT__tab:focus {
  outline: 0;
}

.RRT__tab--selected {
  color: #545cd8;
}

.RRT__tab--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.RRT__tab:focus {
  z-index: 2;
}

.RRT__tab--selected .RRT__removable {
  position: relative;
}

.RRT__tab--selected .RRT__removable-text {
  margin-right: 10px;
}

.RRT__tab--selected .RRT__removable-icon {
  position: absolute;
  font-size: 18px;
  right: 0.5em;
  top: 0.2em;
}

.body-tabs.body-tabs-layout.body-tabs-big {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin: 0 auto;
  padding: 10px;
  border-radius: 50px;
  border: #e9ecef solid 1px;
  z-index: 7;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {
  margin: 0;
  font-size: 1rem;
  font-weight: 300;
  padding: 0;
  height: 50px;
  line-height: 50px;
  flex: 1 1;
  text-align: center;
  position: relative;
  color: #545cd8;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab:hover {
  color: #212529;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected {
  color: #fff;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected:hover {
  color: #fff;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper {
  height: 70px !important;
  top: -70px !important;
  margin: 0 auto -3.4rem;
  position: relative;
  padding: 0 10px;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper::before {
  position: absolute;
  content: "";
  background: #fff;
  width: 100%;
  height: 100%;
  left: 0;
  top: -11px;
  border-radius: 50px;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper .RRT__inkbar {
  height: 50px !important;
  margin-top: 10px;
  border-radius: 50px;
  box-shadow: 0 0 0 transparent;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper + .RRT__panel {
  margin-top: -1rem;
}

.RRT__panel {
  margin-top: 1rem;
}

.RRT__showmore {
  border-radius: 0.25rem;
  background: #545cd8;
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  font-weight: bold;
  width: 36px;
  text-align: center;
  height: 36px;
  display: block;
  margin-left: 15px;
  position: absolute;
  right: 30px;
  top: 50%;
  margin-top: -18px;
  font-size: 1.4rem;
}
.RRT__showmore:focus {
  outline: none;
}

.RRT__showmore-label {
  position: relative;
  z-index: 1;
  color: #fff;
  width: 36px;
  text-align: center;
  height: 36px;
  line-height: 24px;
}

.RRT__showmore--selected {
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.RRT__showmore-list {
  position: absolute;
  right: -1px;
  top: 100%;
  display: none;
  min-width: 15rem;
  padding: 0.65rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.88rem;
  color: #495057;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}
.RRT__showmore-list .RRT__tab {
  display: block;
  width: 100%;
  padding: 0.4rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  margin: 0;
}
.RRT__showmore-list .RRT__tab:hover, .RRT__showmore-list .RRT__tab.RRT__tab--selected {
  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%) !important;
  text-decoration: none;
  background: #e0f3ff;
}

.RRT__showmore-list--opened {
  display: block;
}
.RRT__showmore-list--opened .RRT__tab--selected {
  color: #545cd8;
}

.RRT__inkbar-wrapper {
  width: 100%;
}

.RRT__inkbar {
  position: relative;
  bottom: 0;
  height: 3px;
  margin-top: -3px;
  background-color: #545cd8;
  border-radius: 15px;
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;
  z-index: 2;
}

.card-tabs .card-header {
  padding: 0 1.25rem;
}
.card-tabs .card-header.RRT__tabs {
  cursor: pointer;
  font-weight: normal;
}
.card-tabs .card-header.RRT__tabs .RRT__tab {
  text-transform: none;
  line-height: 1.3;
}
.card-tabs .RRT__inkbar-wrapper {
  width: calc(100% - 1.5rem) !important;
  margin-left: 1.25rem;
}
.card-tabs .RRT__panel {
  padding: 1rem;
  margin: 0;
}
.card-tabs.text-white .RRT__tab {
  color: rgba(255, 255, 255, 0.6);
}
.card-tabs.text-white .RRT__tab:hover {
  color: #fff;
}
.card-tabs.text-white .RRT__tab--selected {
  color: #fff;
}
.card-tabs.text-white .RRT__inkbar {
  background: rgb(98.0840336134%, 98.1736694678%, 99.5630252101%);
}

.card-tabs-animated .RRT__container > .RRT__tabs {
  background: transparent;
  position: relative;
  z-index: 7;
}
.card-tabs-animated .RRT__container > .RRT__tabs.card-header {
  border-bottom: 0;
  height: auto;
  padding: 1.5rem 1.5rem 0.5rem;
}
.card-tabs-animated .RRT__inkbar-wrapper {
  position: absolute;
  top: 1.5rem;
  z-index: 5;
}
.card-tabs-animated .RRT__tab {
  padding: 0.5rem 1.2rem;
}
.card-tabs-animated .RRT__tab--selected {
  color: #fff;
}
.card-tabs-animated .RRT__inkbar {
  height: 35px;
  margin-top: 0;
  border-radius: 0.25rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.card-tabs-animated-inner .RRT__tabs {
  padding: 0 5%;
}
.card-tabs-animated-inner .RRT__inkbar-wrapper {
  left: 5%;
  width: 90%;
  height: 36px;
  top: 14px;
}
.card-tabs-animated-inner .RRT__inkbar {
  height: 36px;
}

.body-tabs {
  border-bottom: #dee2e6 solid 2px;
}
.body-tabs > .RRT__tab {
  padding: 1rem 1.25rem;
  font-weight: normal;
  font-size: 0.88rem;
}
.body-tabs.body-tabs-alt > .RRT__tab {
  padding: 1.3636363636rem 0.5rem;
  font-weight: normal;
  font-size: 0.86rem;
  width: 33%;
  text-align: center;
}
.body-tabs.body-tabs-alt .RRT__inkbar {
  height: 2px;
  margin-top: -2px;
}

.popover .RRT__panel,
.dropdown-menu .RRT__panel {
  margin: 0;
  padding: 0;
  position: relative;
}
.popover .RRT__panel::after, .popover .RRT__panel::before,
.dropdown-menu .RRT__panel::after,
.dropdown-menu .RRT__panel::before {
  width: 100%;
  bottom: auto;
  top: 0;
  left: 0;
  height: 20px;
  position: absolute;
  z-index: 10;
  content: "";
  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);
}
.popover .RRT__panel::after,
.dropdown-menu .RRT__panel::after {
  bottom: 0;
  top: auto;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);
}

.tabs-lg-alternate.card-header {
  padding: 0;
  height: auto;
}
.tabs-lg-alternate.card-header .widget-number {
  font-size: 2rem;
  font-weight: 300;
}
.tabs-lg-alternate.card-header .tab-subheading {
  padding: 5px 0 0;
  opacity: 0.6;
  transition: all 0.2s;
}
.tabs-lg-alternate.card-header > .nav {
  margin: 0;
}
.tabs-lg-alternate.card-header > .nav .nav-link {
  padding: 1.5rem 0;
  border-right: #e9ecef solid 1px;
  background: #f8f9fa;
}
.tabs-lg-alternate.card-header > .nav .nav-link:hover {
  background: #fff;
}
.tabs-lg-alternate.card-header > .nav .nav-link:hover .tab-subheading {
  color: #000;
  opacity: 0.9;
}
.tabs-lg-alternate.card-header > .nav .nav-link::before {
  background: #fff;
  border-radius: 0;
}
.tabs-lg-alternate.card-header > .nav .nav-link.active {
  background: #fff;
}
.tabs-lg-alternate.card-header > .nav .nav-link.active .tab-subheading {
  color: #000;
  opacity: 0.9;
}
.tabs-lg-alternate.card-header > .nav .nav-item:last-child .nav-link {
  border-right: 0;
}

.accordion-wrapper {
  border-radius: 0.25rem;
  border: #e9ecef solid 1px;
}
.accordion-wrapper > .card {
  box-shadow: 0 0 0 0 transparent;
}
.accordion-wrapper > .card > .card-header {
  padding: 1rem;
  height: auto;
}
.accordion-wrapper > .card > .card-header .btn:active,
.accordion-wrapper > .card > .card-header .btn:focus,
.accordion-wrapper > .card > .card-header .btn:hover {
  text-decoration: none;
}
.accordion-wrapper > .card > .card-header .form-heading p {
  margin: 0;
}
.accordion-wrapper > .card .collapse {
  border-bottom: transparent solid 1px;
}
.accordion-wrapper > .card .collapse.show {
  border-bottom-color: #e9ecef;
}

.modal-header,
.modal-footer {
  background: #f8f9fa;
}

.modal-footer {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.modal-dialog {
  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);
  border-radius: 0.25rem;
}

/**
 * Dots
 */
@keyframes scale {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  45% {
    transform: scale(0.1);
    opacity: 0.7;
  }
  80% {
    transform: scale(1);
    opacity: 1;
  }
}
.ball-pulse > div:nth-child(0) {
  animation: scale 0.75s -0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(1) {
  animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(2) {
  animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(3) {
  animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes ball-pulse-sync {
  33% {
    transform: translateY(10px);
  }
  66% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
.ball-pulse-sync > div:nth-child(0) {
  animation: ball-pulse-sync 0.6s -0.21s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(1) {
  animation: ball-pulse-sync 0.6s -0.14s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(2) {
  animation: ball-pulse-sync 0.6s -0.07s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(3) {
  animation: ball-pulse-sync 0.6s 0s infinite ease-in-out;
}
.ball-pulse-sync > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes ball-scale {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.ball-scale > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  height: 60px;
  width: 60px;
  animation: ball-scale 1s 0s ease-in-out infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ball-rotate {
  position: relative;
}
.ball-rotate > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: relative;
}
.ball-rotate > div:first-child {
  animation: rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86) infinite;
}
.ball-rotate > div:before, .ball-rotate > div:after {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  content: "";
  position: absolute;
  opacity: 0.8;
}
.ball-rotate > div:before {
  top: 0px;
  left: -28px;
}
.ball-rotate > div:after {
  top: 0px;
  left: 25px;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
.ball-clip-rotate > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  border: 2px solid #545cd8;
  border-bottom-color: transparent;
  height: 25px;
  width: 25px;
  background: transparent !important;
  display: inline-block;
  animation: rotate 0.75s 0s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
@keyframes scale {
  30% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
.ball-clip-rotate-pulse {
  position: relative;
  transform: translateY(-15px);
}
.ball-clip-rotate-pulse > div {
  animation-fill-mode: both;
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 100%;
}
.ball-clip-rotate-pulse > div:first-child {
  background: #545cd8;
  height: 16px;
  width: 16px;
  top: 7px;
  left: -7px;
  animation: scale 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}
.ball-clip-rotate-pulse > div:last-child {
  position: absolute;
  border: 2px solid #545cd8;
  width: 30px;
  height: 30px;
  left: -16px;
  top: -2px;
  background: transparent;
  border: 2px solid;
  border-color: #545cd8 transparent #545cd8 transparent;
  animation: rotate 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
  animation-duration: 1s;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
.ball-clip-rotate-multiple {
  position: relative;
}
.ball-clip-rotate-multiple > div {
  animation-fill-mode: both;
  position: absolute;
  left: -20px;
  top: -20px;
  border: 2px solid #545cd8;
  border-bottom-color: transparent;
  border-top-color: transparent;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  animation: rotate 1s 0s ease-in-out infinite;
}
.ball-clip-rotate-multiple > div:last-child {
  display: inline-block;
  top: -10px;
  left: -10px;
  width: 15px;
  height: 15px;
  animation-duration: 0.5s;
  border-color: #545cd8 transparent #545cd8 transparent;
  animation-direction: reverse;
}

@keyframes ball-scale-ripple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.ball-scale-ripple > div {
  animation-fill-mode: both;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  border: 2px solid #545cd8;
  animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
}

@keyframes ball-scale-ripple-multiple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.ball-scale-ripple-multiple > div:nth-child(0) {
  animation-delay: -0.8s;
}
.ball-scale-ripple-multiple > div:nth-child(1) {
  animation-delay: -0.6s;
}
.ball-scale-ripple-multiple > div:nth-child(2) {
  animation-delay: -0.4s;
}
.ball-scale-ripple-multiple > div:nth-child(3) {
  animation-delay: -0.2s;
}
.ball-scale-ripple-multiple {
  position: relative;
  transform: translateY(-25px);
}
.ball-scale-ripple-multiple > div {
  animation-fill-mode: both;
  position: absolute;
  top: -2px;
  left: -26px;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid #545cd8;
  animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
}

@keyframes ball-beat {
  50% {
    opacity: 0.2;
    transform: scale(0.75);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ball-beat > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation: ball-beat 0.7s 0s infinite linear;
}
.ball-beat > div:nth-child(2n-1) {
  animation-delay: -0.35s !important;
}

@keyframes ball-scale-multiple {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.ball-scale-multiple > div:nth-child(2) {
  animation-delay: -0.4s;
}
.ball-scale-multiple > div:nth-child(3) {
  animation-delay: -0.2s;
}
.ball-scale-multiple {
  position: relative;
  transform: translateY(-30px);
}
.ball-scale-multiple > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  left: -30px;
  top: 0px;
  opacity: 0;
  margin: 0;
  width: 60px;
  height: 60px;
  animation: ball-scale-multiple 1s 0s linear infinite;
}

@keyframes ball-triangle-path-1 {
  33% {
    transform: translate(25px, -50px);
  }
  66% {
    transform: translate(50px, 0px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes ball-triangle-path-2 {
  33% {
    transform: translate(25px, 50px);
  }
  66% {
    transform: translate(-25px, 50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes ball-triangle-path-3 {
  33% {
    transform: translate(-50px, 0px);
  }
  66% {
    transform: translate(-25px, -50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
.ball-triangle-path {
  position: relative;
}
.ball-triangle-path > div:nth-child(1) {
  animation-name: ball-triangle-path-1;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div:nth-child(2) {
  animation-name: ball-triangle-path-2;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div:nth-child(3) {
  animation-name: ball-triangle-path-3;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path {
  transform: translate(-29.9940011998px, -37.5093773443px);
}
.ball-triangle-path > div {
  animation-fill-mode: both;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 1px solid #545cd8;
}
.ball-triangle-path > div:nth-of-type(1) {
  top: 50px;
}
.ball-triangle-path > div:nth-of-type(2) {
  left: 25px;
}
.ball-triangle-path > div:nth-of-type(3) {
  top: 50px;
  left: 50px;
}

@keyframes ball-pulse-rise-even {
  0% {
    transform: scale(1.1);
  }
  25% {
    transform: translateY(-30px);
  }
  50% {
    transform: scale(0.4);
  }
  75% {
    transform: translateY(30px);
  }
  100% {
    transform: translateY(0);
    transform: scale(1);
  }
}
@keyframes ball-pulse-rise-odd {
  0% {
    transform: scale(0.4);
  }
  25% {
    transform: translateY(30px);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: translateY(-30px);
  }
  100% {
    transform: translateY(0);
    transform: scale(0.75);
  }
}
.ball-pulse-rise > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.15, 0.46, 0.9, 0.6);
  animation-iteration-count: infinite;
  animation-delay: 0;
}
.ball-pulse-rise > div:nth-child(2n) {
  animation-name: ball-pulse-rise-even;
}
.ball-pulse-rise > div:nth-child(2n-1) {
  animation-name: ball-pulse-rise-odd;
}

@keyframes ball-grid-beat {
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
.ball-grid-beat > div:nth-child(1) {
  animation-delay: 0.33s;
  animation-duration: 0.96s;
}
.ball-grid-beat > div:nth-child(2) {
  animation-delay: 0.47s;
  animation-duration: 1.26s;
}
.ball-grid-beat > div:nth-child(3) {
  animation-delay: 0.8s;
  animation-duration: 1.02s;
}
.ball-grid-beat > div:nth-child(4) {
  animation-delay: 0.35s;
  animation-duration: 1.46s;
}
.ball-grid-beat > div:nth-child(5) {
  animation-delay: -0.01s;
  animation-duration: 1.02s;
}
.ball-grid-beat > div:nth-child(6) {
  animation-delay: 0.23s;
  animation-duration: 1.19s;
}
.ball-grid-beat > div:nth-child(7) {
  animation-delay: 0.75s;
  animation-duration: 1.52s;
}
.ball-grid-beat > div:nth-child(8) {
  animation-delay: 0.72s;
  animation-duration: 1.45s;
}
.ball-grid-beat > div:nth-child(9) {
  animation-delay: 0.49s;
  animation-duration: 1.45s;
}
.ball-grid-beat {
  width: 57px;
}
.ball-grid-beat > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  float: left;
  animation-name: ball-grid-beat;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes ball-grid-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.ball-grid-pulse > div:nth-child(1) {
  animation-delay: -0.16s;
  animation-duration: 0.63s;
}
.ball-grid-pulse > div:nth-child(2) {
  animation-delay: 0.54s;
  animation-duration: 1.3s;
}
.ball-grid-pulse > div:nth-child(3) {
  animation-delay: 0.28s;
  animation-duration: 1.05s;
}
.ball-grid-pulse > div:nth-child(4) {
  animation-delay: -0.05s;
  animation-duration: 1.19s;
}
.ball-grid-pulse > div:nth-child(5) {
  animation-delay: 0.41s;
  animation-duration: 0.9s;
}
.ball-grid-pulse > div:nth-child(6) {
  animation-delay: 0.46s;
  animation-duration: 1.04s;
}
.ball-grid-pulse > div:nth-child(7) {
  animation-delay: 0.13s;
  animation-duration: 0.88s;
}
.ball-grid-pulse > div:nth-child(8) {
  animation-delay: -0.12s;
  animation-duration: 1.21s;
}
.ball-grid-pulse > div:nth-child(9) {
  animation-delay: 0.17s;
  animation-duration: 1.21s;
}
.ball-grid-pulse {
  width: 57px;
}
.ball-grid-pulse > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  float: left;
  animation-name: ball-grid-pulse;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes ball-spin-fade-loader {
  50% {
    opacity: 0.3;
    transform: scale(0.4);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ball-spin-fade-loader > div:nth-child(1) {
  top: 25px;
  left: 0;
  animation: ball-spin-fade-loader 1s -0.96s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(2) {
  top: 17.0454545455px;
  left: 17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.84s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(3) {
  top: 0;
  left: 25px;
  animation: ball-spin-fade-loader 1s -0.72s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(4) {
  top: -17.0454545455px;
  left: 17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.6s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(5) {
  top: -25px;
  left: 0;
  animation: ball-spin-fade-loader 1s -0.48s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(6) {
  top: -17.0454545455px;
  left: -17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.36s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(7) {
  top: 0;
  left: -25px;
  animation: ball-spin-fade-loader 1s -0.24s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(8) {
  top: 17.0454545455px;
  left: -17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.12s infinite linear;
}
.ball-spin-fade-loader {
  position: relative;
  top: -10px;
  left: -10px;
}
.ball-spin-fade-loader > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
}

@keyframes ball-spin-loader {
  75% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}
.ball-spin-loader > span:nth-child(1) {
  top: 45px;
  left: 0;
  animation: ball-spin-loader 2s 0.9s infinite linear;
}
.ball-spin-loader > span:nth-child(2) {
  top: 30.6818181818px;
  left: 30.6818181818px;
  animation: ball-spin-loader 2s 1.8s infinite linear;
}
.ball-spin-loader > span:nth-child(3) {
  top: 0;
  left: 45px;
  animation: ball-spin-loader 2s 2.7s infinite linear;
}
.ball-spin-loader > span:nth-child(4) {
  top: -30.6818181818px;
  left: 30.6818181818px;
  animation: ball-spin-loader 2s 3.6s infinite linear;
}
.ball-spin-loader > span:nth-child(5) {
  top: -45px;
  left: 0;
  animation: ball-spin-loader 2s 4.5s infinite linear;
}
.ball-spin-loader > span:nth-child(6) {
  top: -30.6818181818px;
  left: -30.6818181818px;
  animation: ball-spin-loader 2s 5.4s infinite linear;
}
.ball-spin-loader > span:nth-child(7) {
  top: 0;
  left: -45px;
  animation: ball-spin-loader 2s 6.3s infinite linear;
}
.ball-spin-loader > span:nth-child(8) {
  top: 30.6818181818px;
  left: -30.6818181818px;
  animation: ball-spin-loader 2s 7.2s infinite linear;
}
.ball-spin-loader {
  position: relative;
}
.ball-spin-loader > div {
  animation-fill-mode: both;
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  background: green;
}

@keyframes ball-zig {
  33% {
    transform: translate(-15px, -30px);
  }
  66% {
    transform: translate(15px, -30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes ball-zag {
  33% {
    transform: translate(15px, 30px);
  }
  66% {
    transform: translate(-15px, 30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.ball-zig-zag {
  position: relative;
  transform: translate(-15px, -15px);
}
.ball-zig-zag > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  margin-left: 15px;
  top: 4px;
  left: -7px;
}
.ball-zig-zag > div:first-child {
  animation: ball-zig 0.7s 0s infinite linear;
}
.ball-zig-zag > div:last-child {
  animation: ball-zag 0.7s 0s infinite linear;
}

@keyframes ball-zig-deflect {
  17% {
    transform: translate(-15px, -30px);
  }
  34% {
    transform: translate(15px, -30px);
  }
  50% {
    transform: translate(0, 0);
  }
  67% {
    transform: translate(15px, -30px);
  }
  84% {
    transform: translate(-15px, -30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes ball-zag-deflect {
  17% {
    transform: translate(15px, 30px);
  }
  34% {
    transform: translate(-15px, 30px);
  }
  50% {
    transform: translate(0, 0);
  }
  67% {
    transform: translate(-15px, 30px);
  }
  84% {
    transform: translate(15px, 30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.ball-zig-zag-deflect {
  position: relative;
  transform: translate(-15px, -15px);
}
.ball-zig-zag-deflect > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  margin-left: 15px;
  top: 4px;
  left: -7px;
}
.ball-zig-zag-deflect > div:first-child {
  animation: ball-zig-deflect 1.5s 0s infinite linear;
}
.ball-zig-zag-deflect > div:last-child {
  animation: ball-zag-deflect 1.5s 0s infinite linear;
}

/**
 * Lines
 */
@keyframes line-scale {
  0% {
    transform: scaley(1);
  }
  50% {
    transform: scaley(0.4);
  }
  100% {
    transform: scaley(1);
  }
}
.line-scale > div:nth-child(1) {
  animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(2) {
  animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(3) {
  animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(4) {
  animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(5) {
  animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes line-scale-party {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}
.line-scale-party > div:nth-child(1) {
  animation-delay: 0.1s;
  animation-duration: 0.34s;
}
.line-scale-party > div:nth-child(2) {
  animation-delay: 0.19s;
  animation-duration: 1.25s;
}
.line-scale-party > div:nth-child(3) {
  animation-delay: -0.08s;
  animation-duration: 1s;
}
.line-scale-party > div:nth-child(4) {
  animation-delay: 0.04s;
  animation-duration: 0.41s;
}
.line-scale-party > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation-name: line-scale-party;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes line-scale-pulse-out {
  0% {
    transform: scaley(1);
  }
  50% {
    transform: scaley(0.4);
  }
  100% {
    transform: scaley(1);
  }
}
.line-scale-pulse-out > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation: line-scale-pulse-out 0.9s -0.6s infinite cubic-bezier(0.85, 0.25, 0.37, 0.85);
}
.line-scale-pulse-out > div:nth-child(2), .line-scale-pulse-out > div:nth-child(4) {
  animation-delay: -0.4s !important;
}
.line-scale-pulse-out > div:nth-child(1), .line-scale-pulse-out > div:nth-child(5) {
  animation-delay: -0.2s !important;
}

@keyframes line-scale-pulse-out-rapid {
  0% {
    transform: scaley(1);
  }
  80% {
    transform: scaley(0.3);
  }
  90% {
    transform: scaley(1);
  }
}
.line-scale-pulse-out-rapid > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  vertical-align: middle;
  animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78);
}
.line-scale-pulse-out-rapid > div:nth-child(2), .line-scale-pulse-out-rapid > div:nth-child(4) {
  animation-delay: -0.25s !important;
}
.line-scale-pulse-out-rapid > div:nth-child(1), .line-scale-pulse-out-rapid > div:nth-child(5) {
  animation-delay: 0s !important;
}

@keyframes line-spin-fade-loader {
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
.line-spin-fade-loader > div:nth-child(1) {
  top: 20px;
  left: 0;
  animation: line-spin-fade-loader 1.2s -0.84s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(2) {
  top: 13.6363636364px;
  left: 13.6363636364px;
  transform: rotate(-45deg);
  animation: line-spin-fade-loader 1.2s -0.72s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(3) {
  top: 0;
  left: 20px;
  transform: rotate(90deg);
  animation: line-spin-fade-loader 1.2s -0.6s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(4) {
  top: -13.6363636364px;
  left: 13.6363636364px;
  transform: rotate(45deg);
  animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(5) {
  top: -20px;
  left: 0;
  animation: line-spin-fade-loader 1.2s -0.36s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(6) {
  top: -13.6363636364px;
  left: -13.6363636364px;
  transform: rotate(-45deg);
  animation: line-spin-fade-loader 1.2s -0.24s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(7) {
  top: 0;
  left: -20px;
  transform: rotate(90deg);
  animation: line-spin-fade-loader 1.2s -0.12s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(8) {
  top: 13.6363636364px;
  left: -13.6363636364px;
  transform: rotate(45deg);
  animation: line-spin-fade-loader 1.2s 0s infinite ease-in-out;
}
.line-spin-fade-loader {
  position: relative;
  top: -10px;
  left: -4px;
}
.line-spin-fade-loader > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  width: 5px;
  height: 15px;
}

/**
 * Misc
 */
@keyframes triangle-skew-spin {
  25% {
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }
  50% {
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }
  75% {
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }
  100% {
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}
.triangle-skew-spin > div {
  animation-fill-mode: both;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #545cd8;
  animation: triangle-skew-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}

@keyframes square-spin {
  25% {
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }
  50% {
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }
  75% {
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }
  100% {
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}
.square-spin > div {
  animation-fill-mode: both;
  width: 50px;
  height: 50px;
  background: #545cd8;
  animation: square-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}

@keyframes rotate_pacman_half_up {
  0% {
    transform: rotate(270deg);
  }
  50% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(270deg);
  }
}
@keyframes rotate_pacman_half_down {
  0% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(90deg);
  }
}
@keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    transform: translate(-100px, -6.25px);
  }
}
.pacman > div:nth-child(2) {
  animation: pacman-balls 1s -0.99s infinite linear;
}
.pacman > div:nth-child(3) {
  animation: pacman-balls 1s -0.66s infinite linear;
}
.pacman > div:nth-child(4) {
  animation: pacman-balls 1s -0.33s infinite linear;
}
.pacman > div:nth-child(5) {
  animation: pacman-balls 1s 0s infinite linear;
}
.pacman {
  position: relative;
}
.pacman > div:first-of-type {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #545cd8;
  border-left: 25px solid #545cd8;
  border-bottom: 25px solid #545cd8;
  border-radius: 25px;
  animation: rotate_pacman_half_up 0.5s 0s infinite;
  position: relative;
  left: -30px;
}
.pacman > div:nth-child(2) {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #545cd8;
  border-left: 25px solid #545cd8;
  border-bottom: 25px solid #545cd8;
  border-radius: 25px;
  animation: rotate_pacman_half_down 0.5s 0s infinite;
  margin-top: -50px;
  position: relative;
  left: -30px;
}
.pacman > div:nth-child(3),
.pacman > div:nth-child(4),
.pacman > div:nth-child(5),
.pacman > div:nth-child(6) {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  width: 10px;
  height: 10px;
  position: absolute;
  transform: translate(0, -6.25px);
  top: 25px;
  left: 70px;
}

@keyframes cube-transition {
  25% {
    transform: translateX(50px) scale(0.5) rotate(-90deg);
  }
  50% {
    transform: translate(50px, 50px) rotate(-180deg);
  }
  75% {
    transform: translateY(50px) scale(0.5) rotate(-270deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.cube-transition {
  position: relative;
  transform: translate(-25px, -25px);
}
.cube-transition > div {
  animation-fill-mode: both;
  width: 10px;
  height: 10px;
  position: absolute;
  top: -5px;
  left: -5px;
  background-color: #545cd8;
  animation: cube-transition 1.6s 0s infinite ease-in-out;
}
.cube-transition > div:last-child {
  animation-delay: -0.8s;
}

@keyframes spin-rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.semi-circle-spin {
  position: relative;
  width: 35px;
  height: 35px;
  overflow: hidden;
}
.semi-circle-spin > div {
  position: absolute;
  border-width: 0px;
  border-radius: 100%;
  animation: spin-rotate 0.6s 0s infinite linear;
  background-image: linear-gradient(transparent 0%, transparent 70%, #545cd8 30%, #545cd8 100%);
  width: 100%;
  height: 100%;
}

.progress .progress-bar:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.progress.progress-bar-sm {
  height: 0.5rem;
}
.progress.progress-bar-xs {
  height: 0.3rem;
}
.progress.progress-bar-rounded {
  border-radius: 30px;
}

.progress-bar-animated-alt.progress-bar,
.progress-bar-animated-alt .progress-bar {
  position: relative;
}
.progress-bar-animated-alt.progress-bar::after,
.progress-bar-animated-alt .progress-bar::after {
  content: "";
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  animation: progress-active 2s ease infinite;
}

@keyframes progress-active {
  0% {
    opacity: 0.4;
    width: 0;
  }
  100% {
    opacity: 0;
    width: 100%;
  }
}
.vertical-timeline {
  width: 100%;
  position: relative;
  padding: 1.5rem 0 1rem;
}
.vertical-timeline::after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 67px;
  height: 100%;
  width: 4px;
  background: #e9ecef;
  border-radius: 0.25rem;
}

.vertical-timeline-element {
  position: relative;
  margin: 0 0 1rem;
}
.vertical-timeline-element:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-element:last-child {
  margin-bottom: 0;
}

.vertical-timeline-element-content {
  position: relative;
  margin-left: 90px;
  font-size: 0.8rem;
}
.vertical-timeline-element-content:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-element-content .timeline-title {
  font-size: 0.8rem;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  padding: 2px 0 0;
  font-weight: bold;
}
.vertical-timeline-element-content p {
  color: #6c757d;
  margin: 0 0 0.5rem;
}
.vertical-timeline-element-content .vertical-timeline-element-date {
  display: block;
  position: absolute;
  left: -90px;
  top: 0;
  padding-right: 10px;
  text-align: right;
  color: #adb5bd;
  font-size: 0.7619047619rem;
  white-space: nowrap;
}

.vertical-timeline-element-icon {
  position: absolute;
  top: 0;
  left: 60px;
}
.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.vertical-timeline-element--no-children .vertical-timeline-element-content {
  background: 0 0;
  box-shadow: none;
}
.vertical-timeline-element--no-children .vertical-timeline-element-content::before {
  display: none;
}

.vertical-without-time::before {
  left: 11px;
}
.vertical-without-time .vertical-timeline-element-content {
  margin-left: 36px;
}
.vertical-without-time .vertical-timeline-element-icon {
  left: 4px;
}

.vertical-time-icons {
  padding: 2rem 0 0;
}
.vertical-time-icons::before {
  content: "";
  position: absolute;
  top: 0;
  left: 14px;
  height: 100%;
  width: 6px;
  background: #e9ecef;
  border-radius: 0.25rem;
}
.vertical-time-icons .vertical-timeline-element {
  margin-bottom: 1rem;
}
.vertical-time-icons .vertical-timeline-element-content {
  margin-left: 50px;
}
.vertical-time-icons .vertical-timeline-element-icon {
  width: 34px;
  height: 34px;
  left: 0;
  top: -7px;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon {
  width: 34px;
  height: 34px;
  background: #fff;
  border-radius: 50px;
  border-width: 2px;
  border-style: solid;
  box-shadow: 0 0 0 5px #fff;
  text-align: center;
  display: flex;
  align-items: center;
  align-content: center;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon i {
  display: block;
  font-size: 1.1rem;
  margin: 0 auto;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon svg {
  margin: 0 auto;
}

.vertical-time-simple {
  padding: 0.5rem 0;
}
.vertical-time-simple .vertical-timeline-element {
  margin: 0 0 0.5rem;
}
.vertical-time-simple .timeline-title {
  font-weight: normal;
  font-size: 0.9166666667rem;
  padding: 0;
}
.vertical-time-simple .vertical-timeline-element-icon {
  height: 14px;
  width: 14px;
  background: #e9ecef;
  position: absolute;
  left: 6px;
  top: 2px;
  display: block;
  border-radius: 20px;
}
.vertical-time-simple .vertical-timeline-element-icon::after {
  content: "";
  position: absolute;
  background: #fff;
  left: 50%;
  top: 50%;
  margin: -4px 0 0 -4px;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 20px;
}
.vertical-time-simple .timeline-title {
  text-transform: none;
}

.dot-primary .vertical-timeline-element-icon {
  background: #545cd8;
}

.dot-secondary .vertical-timeline-element-icon {
  background: #6c757d;
}

.dot-success .vertical-timeline-element-icon {
  background: #3ac47d;
}

.dot-info .vertical-timeline-element-icon {
  background: #30b1ff;
}

.dot-warning .vertical-timeline-element-icon {
  background: #f7b924;
}

.dot-danger .vertical-timeline-element-icon {
  background: #d92550;
}

.dot-light .vertical-timeline-element-icon {
  background: #eeeeee;
}

.dot-dark .vertical-timeline-element-icon {
  background: #343a40;
}

.dot-focus .vertical-timeline-element-icon {
  background: #444054;
}

.dot-alternate .vertical-timeline-element-icon {
  background: #83588a;
}

.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {
  visibility: hidden;
}

.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
  visibility: visible;
  animation: cd-bounce-1 0.8s;
}
@keyframes cd-bounce-1 {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  60% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {
  visibility: hidden;
}

.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {
  visibility: visible;
  animation: cd-bounce-2 0.6s;
}

@media only screen and (min-width: 1170px) {
  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {
    animation: cd-bounce-2-inverse 0.6s;
  }
}
@media only screen and (max-width: 1169px) {
  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {
    visibility: visible;
    animation: cd-bounce-2-inverse 0.6s;
  }
}
@keyframes cd-bounce-2 {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  60% {
    opacity: 1;
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes cd-bounce-2-inverse {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  60% {
    opacity: 1;
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0);
  }
}
.todo-list-wrapper .todo-indicator {
  position: absolute;
  width: 4px;
  height: 60%;
  border-radius: 0.3rem;
  left: 0.625rem;
  top: 20%;
  opacity: 0.6;
  transition: opacity 0.2s;
}
.todo-list-wrapper .list-group-item:hover .todo-indicator {
  opacity: 0.9;
}
.todo-list-wrapper .custom-control,
.todo-list-wrapper input[checkbox] {
  margin-left: 0.625rem;
}

.list-group-flush + .card-footer {
  border-top: 0;
}

.rm-list-borders .list-group-item {
  border: 0;
  padding: 0.5rem 0;
}

.rm-list-borders-scroll .list-group-item {
  border: 0;
  padding-right: 1.125rem;
}

.input-group .input-group-prepend div:not([class]) .react-datepicker__input-container .form-control, .input-group .input-group-prepend + div .react-datepicker__input-container .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.input-group > div:not([class]) {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > div:not([class]) .react-datepicker__input-container .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group .input-group-prepend + div {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > .react-datepicker-wrapper {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > .react-datepicker-wrapper > .react-datepicker__input-container > .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

legend {
  font-size: 0.88rem;
  font-weight: bold;
}

.form-heading {
  font-size: 1.1rem;
  margin: 0;
  color: #545cd8;
}
.form-heading p {
  color: #6c757d;
  padding: 0.3rem 0 0;
  font-size: 0.88rem;
}

.custom-select {
  -webkit-appearance: none;
  -moz-appearance: none;
}

.pagination li a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.pagination li a:hover {
  z-index: 2;
  color: rgb(0%, 33.7647058824%, 70%);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.pagination li a:focus {
  z-index: 2;
  outline: 0;
  box-shadow: none;
}
.pagination li a:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.pagination li:first-child a {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.pagination li:last-child a {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.pagination li.active a {
  z-index: 1;
  color: #fff;
  background-color: #545cd8;
  border-color: #007bff;
}
.pagination li.active a:hover {
  color: #fff;
}
.pagination li.disabled a {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-rounded li a {
  border-radius: 50px !important;
  margin: 0 0.3rem;
}

.chat-box-wrapper {
  display: flex;
  clear: both;
  padding: 0.75rem;
}
.chat-box-wrapper + .chat-box-wrapper {
  padding-top: 0;
}
.chat-box-wrapper .chat-box {
  box-shadow: 0 0 0 transparent;
  position: relative;
  opacity: 1;
  background: #e0f3ff;
  border: 0;
  padding: 0.75rem 1.5rem;
  border-radius: 30px;
  border-top-left-radius: 0.25rem;
  flex: 1 1;
  display: flex;
  max-width: 50%;
  min-width: 100%;
  text-align: left;
}
.chat-box-wrapper .chat-box + small {
  text-align: left;
  padding: 0.5rem 0 0;
  margin-left: 1.5rem;
  display: block;
}
.chat-box-wrapper.chat-box-wrapper-right {
  text-align: right;
}
.chat-box-wrapper.chat-box-wrapper-right .chat-box {
  border-radius: 30px;
  border-top-left-radius: 30px;
  border-top-right-radius: 0.25rem;
  margin-left: auto;
}
.chat-box-wrapper.chat-box-wrapper-right .chat-box + small {
  text-align: right;
  margin-right: 1.5rem;
  margin-left: 0;
}

.forms-wizard {
  margin: 0;
  padding: 0;
  list-style-type: none;
  width: 100%;
  display: table;
  table-layout: fixed;
  border-radius: 0.25rem;
}
.forms-wizard li {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  font-size: 1rem;
  padding: 1rem 0;
  color: #adb5bd;
  position: relative;
}
.forms-wizard li::after, .forms-wizard li::before {
  position: absolute;
  height: 4px;
  top: 50%;
  margin-top: -1rem;
  width: 50%;
  content: "";
  background: #dee2e6;
  z-index: 5;
  transition: all 0.2s;
}
.forms-wizard li::after {
  left: 50%;
}
.forms-wizard li::before {
  left: 0;
}
.forms-wizard li:first-child::before {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.forms-wizard li:last-child::after {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.forms-wizard li em {
  font-style: normal;
  font-size: 1.5rem;
  background: #ced4da;
  color: #fff;
  text-align: center;
  padding: 0;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50px;
  display: block;
  margin: 0 auto 0.5rem;
  position: relative;
  z-index: 7;
  transition: all 0.2s;
}
.forms-wizard li.form-wizard-step-doing {
  color: #495057;
}
.forms-wizard li.form-wizard-step-doing em {
  background: #545cd8;
}
.forms-wizard li.form-wizard-step-doing::before {
  background: #545cd8;
}
.forms-wizard li.form-wizard-step-done em {
  font-family: "Linearicons-Free";
  background: #3ac47d;
  overflow: hidden;
}
.forms-wizard li.form-wizard-step-done em::before {
  width: 42px;
  height: 42px;
  font-size: 1.2rem;
  line-height: 40px;
  text-align: center;
  display: block;
}
.forms-wizard li.form-wizard-step-done::after, .forms-wizard li.form-wizard-step-done::before {
  background: #3ac47d;
}
.forms-wizard li:hover {
  color: #6c757d;
}

.forms-wizard-alt .forms-wizard li {
  font-size: 0.88rem;
}
.forms-wizard-alt .forms-wizard li em {
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-indent: -999rem;
  border: #fff solid 2px;
  margin: -7px auto 0;
}

.forms-wizard-vertical .forms-wizard {
  display: block;
  width: 30%;
  float: left;
  padding: 0 1.5rem 1.5rem 0;
}
.forms-wizard-vertical .forms-wizard li {
  text-align: left;
  display: flex;
  align-items: center;
  align-content: flex-start;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 0.3rem;
  transition: all 0.2s;
}
.forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {
  display: none;
}
.forms-wizard-vertical .forms-wizard li em {
  margin: 0 0.75rem 0 0;
}
.forms-wizard-vertical .forms-wizard li:hover {
  background: #e9ecef;
}
.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {
  background: #545cd8;
  color: #fff;
}
.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {
  background: rgba(255, 255, 255, 0.2);
}
.forms-wizard-vertical .form-wizard-content {
  width: 70%;
  overflow: auto;
}

@media screen and (min-width: 360px) and (max-width: 812px) {
  .forms-wizard-vertical .forms-wizard {
    display: block;
    width: 50%;
    float: left;
    padding: 0 1.5rem 1.5rem 0;
  }
  .forms-wizard-vertical .forms-wizard li {
    text-align: left;
    display: flex;
    align-items: center;
    align-content: flex-start;
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    border-radius: 0.3rem;
    transition: all 0.2s;
  }
  .forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {
    display: none;
  }
  .forms-wizard-vertical .forms-wizard li em {
    margin: 0 0.75rem 0 0;
  }
  .forms-wizard-vertical .forms-wizard li:hover {
    background: #e9ecef;
  }
  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {
    background: #545cd8;
    color: #fff;
  }
  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {
    background: rgba(255, 255, 255, 0.2);
  }
  .forms-wizard-vertical .form-wizard-content {
    width: 50%;
    overflow: auto;
  }
}
.icon-wrapper {
  display: flex;
  align-content: center;
  align-items: center;
}

.widget-chart {
  text-align: center;
  padding: 1rem;
  position: relative;
}
.widget-chart .progress-sub-label {
  opacity: 0.8;
  padding: 5px 0 0;
}
.widget-chart .progress-circle-wrapper {
  min-width: 68px;
  margin-right: 1rem;
}
.widget-chart .progress-circle-wrapper .react-sweet-progress-symbol {
  font-size: 0.8rem;
}
.widget-chart .widget-chart-content {
  position: relative;
  z-index: 5;
}
.widget-chart .widget-chart-content-lg {
  padding: 2rem 0 1rem 2rem;
}
.widget-chart .widget-chart-content-lg .widget-numbers {
  margin-bottom: 0;
}
.widget-chart .widget-chart-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0.25;
  z-index: 6;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  overflow: hidden;
}
.widget-chart .widget-numbers {
  font-weight: bold;
  font-size: 2.5rem;
  display: block;
  line-height: 1;
  margin: 1rem auto;
}
.widget-chart .widget-numbers + .widget-chart-flex, .widget-chart .widget-numbers + .widget-description, .widget-chart .widget-numbers + .widget-subheading {
  margin-top: -0.5rem;
}
.widget-chart .widget-subheading {
  margin: -0.5rem 0 0;
  display: block;
  opacity: 0.6;
}
.widget-chart .widget-subheading:first-child {
  margin-top: 0;
}
.widget-chart .widget-subheading + .widget-numbers {
  margin-top: 0.5rem;
}
.widget-chart .widget-description {
  margin: 1rem 0 0;
}
.widget-chart.widget-chart-hover {
  transition: all 0.2s;
}
.widget-chart.widget-chart-hover:hover {
  z-index: 15;
  transform: scale(1.15);
  box-shadow: 0 0.46875rem 4.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.9375rem 2.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.25rem 1.3125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.06), 0 0.125rem 1.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.06);
  cursor: pointer;
  background: #fff;
}
.widget-chart .widget-chart-actions {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  z-index: 12;
}
.widget-chart .widget-chart-actions .btn-link {
  font-size: 1.1rem;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0.6;
}
.widget-chart .widget-progress-wrapper {
  margin-top: 1rem;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {
  margin: 0 -1px -1px;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress .progress-bar {
  border-bottom-left-radius: 0.25rem;
}
.widget-chart .widget-chart-flex {
  display: flex;
  align-items: center;
  align-content: center;
  margin-bottom: 1rem;
}
.widget-chart .widget-chart-flex:last-child {
  margin-bottom: 0;
}
.widget-chart .widget-chart-flex .widget-subheading {
  margin: 0;
}
.widget-chart .widget-chart-flex .widget-description {
  margin-top: 0;
}
.widget-chart.text-left {
  flex-direction: row;
  align-items: center;
}
.widget-chart.text-left .icon-wrapper {
  min-width: 54px;
  margin: 0 1rem 0 0;
}
.widget-chart.text-left .widget-numbers {
  margin-left: 0;
}
.widget-chart.text-left .widget-chart-content {
  display: flex;
  flex-direction: column;
  align-content: center;
  flex: 1 1;
  position: relative;
}
.widget-chart.text-left .widget-chart-content > .widget-numbers:first-child {
  margin-top: 0;
}
.widget-chart.text-left .widget-chart-content .widget-description {
  align-self: flex-start;
}
.widget-chart.text-left .widget-chart-wrapper {
  height: 35%;
}
.widget-chart.widget-chart-left {
  padding-bottom: 15%;
}
.widget-chart .chart-wrapper-relative {
  position: relative;
  opacity: 1;
  margin-top: 1rem;
}

.widget-chart-actions {
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 12;
}
.widget-chart-actions .btn-link {
  font-size: 1.1rem;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0.6;
}

.widget-chart:hover .widget-chart-actions .btn-link,
.widget-content:hover .widget-chart-actions .btn-link {
  opacity: 1;
}

.grid-menu .widget-chart.widget-chart-hover:hover {
  background: #fff;
  border-radius: 0.25rem;
}

.icon-wrapper {
  width: 54px;
  height: 54px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.icon-wrapper[class*=border-] {
  border-width: 1px;
  border-style: solid;
}
.icon-wrapper .icon-wrapper-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 3;
  opacity: 0.2;
}
.icon-wrapper .icon-wrapper-bg.bg-light {
  opacity: 0.08;
}
.icon-wrapper i {
  margin: 0 auto;
  font-size: 1.7rem;
  position: relative;
  z-index: 5;
}
.icon-wrapper i:before {
  margin-top: -3px;
}
.icon-wrapper .progress-circle-wrapper {
  width: 100%;
  margin-right: 0;
}

.widget-chart2 .widget-chart-flex {
  display: flex;
  align-items: baseline;
  align-content: center;
  margin-bottom: 0;
}
.widget-chart2 .widget-chart-flex .widget-subtitle {
  margin-left: auto;
}
.widget-chart2 .widget-chart-flex .widget-numbers {
  font-weight: normal;
}
.widget-chart2 .widget-chart-flex + .widget-chart-flex .widget-numbers {
  margin-bottom: 0;
}
.widget-chart2 .widget-chat-wrapper-outer {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  max-width: 100%;
}
.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper {
  height: 70px;
  opacity: 0.8;
  position: relative;
  margin: 1rem auto -0.5rem;
}
.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper-lg {
  height: 130px;
}

.card-btm-border {
  border-bottom: transparent solid 4px;
}

.progress-box {
  text-align: center;
}
.progress-box h4 {
  font-size: 0.88rem;
  font-weight: bold;
  opacity: 0.6;
  text-transform: uppercase;
  padding-bottom: 0.3333333333rem;
}
.progress-box svg {
  margin: 0 auto;
}

.svg-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.1;
}
.svg-bg svg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.widget-numbers-sm {
  font-size: 1.5rem;
}

.widget-content {
  padding: 1rem;
  flex-direction: row;
  align-items: center;
}
.widget-content .widget-content-wrapper {
  display: flex;
  flex: 1 1;
  position: relative;
  align-items: center;
}
.widget-content .widget-content-left .widget-heading {
  opacity: 0.8;
  font-weight: bold;
}
.widget-content .widget-content-left .widget-subheading {
  opacity: 0.5;
}
.widget-content .widget-content-right {
  margin-left: auto;
}
.widget-content .widget-numbers {
  font-weight: bold;
  font-size: 1.8rem;
  display: block;
}
.widget-content .widget-content-outer {
  display: flex;
  flex: 1 1;
  flex-direction: column;
}
.widget-content .widget-progress-wrapper {
  margin-top: 1rem;
}
.widget-content .widget-progress-wrapper .progress-sub-label {
  margin-top: 0.3333333333rem;
  opacity: 0.5;
  display: flex;
  align-content: center;
  align-items: center;
}
.widget-content .widget-progress-wrapper .progress-sub-label .sub-label-right {
  margin-left: auto;
}
.widget-content .widget-content-right.widget-content-actions {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s;
}
.widget-content:hover .widget-content-right.widget-content-actions {
  visibility: visible;
  opacity: 1;
}

.profile-block {
  position: relative;
  overflow: hidden;
}
.profile-block .profile-blur {
  width: 100%;
  height: 100%;
  filter: blur(5px);
  transform: scale(1.8);
  position: absolute;
  left: -25%;
  top: -25%;
}
.profile-block .profile-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  left: 0;
  top: 0;
}
.profile-block .dropdown-menu-header .menu-header-content {
  padding: 3rem;
}
.profile-block .dropdown-menu-header .menu-header-content .menu-header-title {
  margin: 0.75rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-content .menu-header-subtitle {
  margin: 0.5rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane {
  margin: 0.5rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon {
  color: #fff;
  padding: 0;
  width: 44px;
  height: 44px;
  line-height: 37px;
  font-size: 1.1rem;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon:hover {
  background: rgba(255, 255, 255, 0.2);
}

.app-logo {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.app-logo-inverse {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.app-login-box .app-logo {
  margin-bottom: 3rem;
}
.app-login-box h4 {
  margin-bottom: 1.5rem;
  font-weight: normal;
}
.app-login-box h4 div {
  opacity: 0.6;
}
.app-login-box h4 span {
  font-size: 1.1rem;
}

.app-inner-layout.rm-sidebar .app-inner-layout__wrapper .app-inner-layout__content {
  width: auto;
  float: none;
}
.app-inner-layout .app-inner-layout__header {
  width: 100%;
  padding: 1.5rem;
  text-align: left;
}
.app-inner-layout .app-inner-layout__header .app-page-title {
  margin: 0;
  padding: 0;
  background: transparent;
}
.app-inner-layout .app-inner-layout__header {
  border-bottom: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__header-boxed {
  padding: 1.5rem;
}
.app-inner-layout .app-inner-layout__header-boxed .app-inner-layout__header {
  border-radius: 0.3rem;
}
.app-inner-layout .app-inner-layout__wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  min-height: 100vh;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content {
  flex: 1 1;
  display: flex;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content.card {
  box-shadow: 0 0 0 0 transparent;
  border-radius: 0;
  border: 0;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__top-pane {
  display: flex;
  align-content: center;
  align-items: center;
  text-align: left;
  padding: 0.75rem 1.5rem;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-left {
  display: flex;
  align-items: center;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-right {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__bottom-pane {
  padding: 1.5rem;
  border-top: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar {
  width: 270px;
  list-style: none;
  text-align: left;
  order: -1;
  flex: 0 0 270px;
  display: flex;
  margin: 0;
  position: relative;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .dropdown-item {
  white-space: normal;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar.card {
  box-shadow: 0 0 0 0 transparent;
  border-radius: 0;
  background: #f8f9fa;
  border: 0;
  border-right: #e9ecef solid 1px;
  border-left: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-footer,
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-header {
  background: #f8f9fa;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__aside {
  width: 60px;
}
.app-inner-layout .app-inner-layout__footer {
  width: 100%;
  height: 50px;
}

.app-wrapper-footer .app-footer {
  border-top: #e9ecef solid 1px;
}
.app-wrapper-footer .app-footer .app-footer__inner {
  border-left: #e9ecef solid 1px;
}

.chat-layout.app-inner-layout .app-inner-layout__sidebar {
  width: 360px;
  flex: 0 0 360px;
}
.chat-layout .app-inner-layout__top-pane h4 {
  font-size: 1.25rem;
}
.chat-layout .app-inner-layout__top-pane h4 div {
  font-size: 0.88rem;
}
.chat-layout .chat-box-wrapper {
  padding: 1.5rem;
}

@media (max-width: 1199.98px) {
  .chat-layout.app-inner-layout .app-inner-layout__sidebar .widget-content .widget-content-left .widget-subheading {
    white-space: normal;
  }
}
.mobile-app-menu-btn {
  display: none;
  margin: 3px 1.5rem 0 0;
}

.table_header {
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 5px;
  margin-top: 10px;
  font-weight: bold;
}

@media (max-width: 991.98px) {
  .app-inner-layout__sidebar {
    display: none !important;
  }
  .mobile-app-menu-btn {
    display: block;
  }
  .open-mobile-menu .app-inner-layout__sidebar {
    display: block !important;
  }
}
/*
 * Container style
 */
.ps {
  overflow: hidden !important;
  overflow-anchor: none;
  touch-action: auto;
}

/*
 * Scrollbar rail styles
 */
.ps__rail-x {
  display: none !important;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  height: 15px;
  /* there must be 'bottom' or 'top' for ps__rail-x */
  bottom: 0;
  /* please don't change 'position' */
  position: absolute;
  z-index: 7;
}

.ps__rail-y {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  width: 15px;
  /* there must be 'right' or 'left' for ps__rail-y */
  right: 0;
  /* please don't change 'position' */
  position: absolute;
  border-radius: 50px;
  z-index: 7;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent;
}

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 0.6;
}

.ps__rail-x:hover,
.ps__rail-y:hover,
.ps__rail-x:focus,
.ps__rail-y:focus {
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0.9;
}

/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
  height: 6px;
  /* there must be 'bottom' for ps__thumb-x */
  bottom: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__thumb-y {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transition: background-color 0.2s linear, width 0.2s ease-in-out;
  width: 6px;
  /* there must be 'right' for ps__thumb-y */
  right: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x {
  background-color: rgba(0, 0, 0, 0.12);
  height: 11px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y {
  background-color: rgba(0, 0, 0, 0.12);
  width: 11px;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important;
  }
}
.scrollbar-container {
  position: relative;
  height: 100%;
}

.scroll-area {
  overflow-x: hidden;
  height: 400px;
}

.scroll-area-xs {
  height: 150px;
  overflow-x: hidden;
}

.scroll-area-sm {
  height: 200px;
  overflow-x: hidden;
}

.scroll-area-md {
  height: 300px;
  overflow-x: hidden;
}

.scroll-area-lg {
  height: 400px;
  overflow-x: hidden;
}

.scroll-area-x {
  overflow-x: auto;
  width: 100%;
  max-width: 100%;
}

.shadow-overflow {
  position: relative;
}
.shadow-overflow::after, .shadow-overflow::before {
  width: 100%;
  bottom: auto;
  top: 0;
  left: 0;
  height: 1.5rem;
  position: absolute;
  z-index: 10;
  content: "";
  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);
}
.shadow-overflow::after {
  bottom: 0;
  top: auto;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);
}

.rc-tabs {
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.rc-tabs-bar,
.rc-tabs-nav-container {
  font-size: 14px;
  line-height: 1.5;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  outline: none;
  zoom: 1;
  transition: padding 0.45s;
}

.rc-tabs-ink-bar {
  margin-top: 0;
  border-radius: 0.25rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.rc-tabs-ink-bar-animated {
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;
}

.rc-tabs-tab-prev,
.rc-tabs-tab-next {
  -webkit-user-select: none;
  user-select: none;
  z-index: 1;
  line-height: 36px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  position: absolute;
}

.rc-tabs-tab-prev-icon,
.rc-tabs-tab-next-icon {
  position: relative;
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  line-height: inherit;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  font-smoothing: antialiased;
  text-stroke-width: 0;
  font-family: sans-serif;
}

.rc-tabs-tab-prev-icon:before,
.rc-tabs-tab-next-icon:before {
  display: block;
}

.rc-tabs-tab-btn-disabled {
  cursor: default;
  color: #495057;
}

.rc-tabs-nav-wrap {
  overflow: hidden;
}

.rc-tabs-nav {
  box-sizing: border-box;
  padding-left: 0;
  position: relative;
  margin: 0;
  float: left;
  list-style: none;
  display: inline-block;
  transform-origin: 0 0;
}
.rc-tabs-nav > div:first-child {
  z-index: 5;
  position: relative;
}

.rc-tabs-nav-animated {
  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);
}

.rc-tabs-nav:before,
.rc-tabs-nav:after {
  display: table;
  content: " ";
}

.rc-tabs-nav:after {
  clear: both;
}

.rc-tabs-tab {
  box-sizing: border-box;
  position: relative;
  display: block;
  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  padding: 8px 20px;
  cursor: pointer;
}

.rc-tabs-tab:hover {
  color: #545cd8;
}

.rc-tabs-tab-active,
.rc-tabs-tab-active:hover {
  color: #fff;
  cursor: default;
  transform: translateZ(0);
}

.rc-tabs-tab-disabled {
  cursor: default;
  color: #495057;
}

.rc-tabs-tab-disabled:hover {
  color: #495057;
}

.rc-tabs-content {
  zoom: 1;
}

.rc-tabs-content .rc-tabs-tabpane {
  overflow: hidden;
}

.rc-tabs-content-animated {
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  display: flex;
  will-change: transform;
}

.rc-tabs-content-animated .rc-tabs-tabpane {
  flex-shrink: 0;
}

.no-flexbox .rc-tabs-content {
  transform: none !important;
  overflow: hidden;
}

.no-csstransitions .rc-tabs-tabpane-inactive,
.no-flexbox .rc-tabs-tabpane-inactive,
.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {
  display: none;
}

.rc-tabs-bottom .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 100%;
  height: 35px;
}

.rc-tabs-top .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 100%;
  height: 35px;
}

.rc-tabs-top .rc-tabs-content {
  width: 100%;
}

.rc-tabs-top .rc-tabs-nav-container-scrolling {
  padding-left: 35px;
  padding-right: 35px;
}

.rc-tabs-top .rc-tabs-nav-scroll {
  width: 99999px;
}

.rc-tabs-top .rc-tabs-nav-swipe {
  position: relative;
  left: 0;
}

.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {
  display: flex;
  flex: 1 1;
  width: 100%;
}

.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {
  display: flex;
  flex-shrink: 0;
  margin-right: 0;
  padding: 8px 0;
  justify-content: center;
}

.rc-tabs-top .rc-tabs-nav-wrap {
  width: 100%;
  padding: 1.5rem 15px;
}

.rc-tabs-top .rc-tabs-content-animated {
  flex-direction: row;
}

.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {
  width: 100%;
}

.rc-tabs-top .rc-tabs-tab-next {
  right: 2px;
}

.rc-tabs-top .rc-tabs-tab-next-icon:before {
  content: ">";
}

.rc-tabs-top .rc-tabs-tab-prev {
  left: 0;
}

.rc-tabs-top .rc-tabs-tab-prev-icon:before {
  content: "<";
}

.rc-tabs-top .rc-tabs-tab-prev,
.rc-tabs-top .rc-tabs-tab-next {
  margin-right: -2px;
  width: 0;
  height: 0;
  top: 0;
  text-align: center;
  opacity: 0;
  transition: width 0.3s, height 0.3s, opacity 0.3s;
}

.rc-tabs-top .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 35px;
  height: 100%;
}

.rc-tabs-top .rc-tabs-ink-bar {
  height: 35px;
  bottom: 0;
  left: 0;
  background: #545cd8;
}

.rc-tabs-top .rc-tabs-tab {
  float: left;
  height: 100%;
  line-height: 1.3;
  margin-right: 0.75rem;
}

.rc-tabs-top .rc-tabs-tabpane-inactive {
  height: 0;
  overflow: visible;
}

/*!
 * Ladda
 * http://lab.hakim.se/ladda
 * MIT licensed
 *
 * Copyright (C) 2018 Hakim El Hattab, http://hakim.se
 */
/*************************************
 * CONFIG
 */
/*************************************
 * MIXINS
 */
/*************************************
 * Opacity animation for spin.js
 */
@keyframes ladda-spinner-line-fade {
  0%, 100% {
    opacity: 0.22; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}
/*************************************
 * BUTTON BASE
 */
.ladda-button {
  position: relative;
}

/* Spinner animation */
.ladda-button .ladda-spinner {
  position: absolute;
  z-index: 2;
  display: inline-block;
  width: 32px;
  top: 50%;
  margin-top: 0;
  opacity: 0;
  pointer-events: none;
}

/* Button label */
.ladda-button .ladda-label {
  position: relative;
  z-index: 3;
}

[class*=btn-outline-] .ladda-spinner div div div {
  background: #000 !important;
}
[class*=btn-outline-].ladda-button .ladda-label {
  transition: none !important;
}

/* Progress bar */
.ladda-button .ladda-progress {
  position: absolute;
  width: 0;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  display: none;
  transition: 0.1s linear all !important;
}

.ladda-button[data-loading] .ladda-progress {
  display: block;
}

/*************************************
 * EASING
 */
.ladda-button,
.ladda-button .ladda-spinner,
.ladda-button .ladda-label {
  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
}

.ladda-button[data-style=zoom-in],
.ladda-button[data-style=zoom-in] .ladda-spinner,
.ladda-button[data-style=zoom-in] .ladda-label,
.ladda-button[data-style=zoom-out],
.ladda-button[data-style=zoom-out] .ladda-spinner,
.ladda-button[data-style=zoom-out] .ladda-label {
  transition: 0.3s ease all !important;
}

/*************************************
 * EXPAND RIGHT
 */
.ladda-button[data-style=expand-right] .ladda-spinner {
  right: -6px;
}
.ladda-button[data-style=expand-right][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-right][data-size=xs] .ladda-spinner {
  right: -12px;
}
.ladda-button[data-style=expand-right][data-loading] {
  padding-right: 56px;
}
.ladda-button[data-style=expand-right][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-right][data-loading][data-size=s], .ladda-button[data-style=expand-right][data-loading][data-size=xs] {
  padding-right: 40px;
}

/*************************************
 * EXPAND LEFT
 */
.ladda-button[data-style=expand-left] .ladda-spinner {
  left: 26px;
}
.ladda-button[data-style=expand-left][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-left][data-size=xs] .ladda-spinner {
  left: 4px;
}
.ladda-button[data-style=expand-left][data-loading] {
  padding-left: 56px;
}
.ladda-button[data-style=expand-left][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-left][data-loading][data-size=s], .ladda-button[data-style=expand-left][data-loading][data-size=xs] {
  padding-left: 40px;
}

/*************************************
 * EXPAND UP
 */
.ladda-button[data-style=expand-up] {
  overflow: hidden;
}
.ladda-button[data-style=expand-up] .ladda-spinner {
  top: -32px;
  left: 50%;
  margin-left: 0;
}
.ladda-button[data-style=expand-up][data-loading] {
  padding-top: 54px;
}
.ladda-button[data-style=expand-up][data-loading] .ladda-spinner {
  opacity: 1;
  top: 26px;
  margin-top: 0;
}
.ladda-button[data-style=expand-up][data-loading][data-size=s], .ladda-button[data-style=expand-up][data-loading][data-size=xs] {
  padding-top: 32px;
}
.ladda-button[data-style=expand-up][data-loading][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-up][data-loading][data-size=xs] .ladda-spinner {
  top: 4px;
}

/*************************************
 * EXPAND DOWN
 */
.ladda-button[data-style=expand-down] {
  overflow: hidden;
}
.ladda-button[data-style=expand-down] .ladda-spinner {
  top: 52px;
  left: 50%;
  margin-left: 0;
}
.ladda-button[data-style=expand-down][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-down][data-size=xs] .ladda-spinner {
  top: 40px;
}
.ladda-button[data-style=expand-down][data-loading] {
  padding-bottom: 54px;
}
.ladda-button[data-style=expand-down][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-down][data-loading][data-size=s], .ladda-button[data-style=expand-down][data-loading][data-size=xs] {
  padding-bottom: 32px;
}

/*************************************
 * SLIDE LEFT
 */
.ladda-button[data-style=slide-left] {
  overflow: hidden;
}
.ladda-button[data-style=slide-left] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-left] .ladda-spinner {
  left: 100%;
  margin-left: 0;
}
.ladda-button[data-style=slide-left][data-loading] .ladda-label {
  opacity: 0;
  left: -100%;
}
.ladda-button[data-style=slide-left][data-loading] .ladda-spinner {
  opacity: 1;
  left: 50%;
}

/*************************************
 * SLIDE RIGHT
 */
.ladda-button[data-style=slide-right] {
  overflow: hidden;
}
.ladda-button[data-style=slide-right] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-right] .ladda-spinner {
  right: 100%;
  margin-left: 0;
  left: 16px;
}
[dir=rtl] .ladda-button[data-style=slide-right] .ladda-spinner {
  right: auto;
}
.ladda-button[data-style=slide-right][data-loading] .ladda-label {
  opacity: 0;
  left: 100%;
}
.ladda-button[data-style=slide-right][data-loading] .ladda-spinner {
  opacity: 1;
  left: 50%;
}

/*************************************
 * SLIDE UP
 */
.ladda-button[data-style=slide-up] {
  overflow: hidden;
}
.ladda-button[data-style=slide-up] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-up] .ladda-spinner {
  left: 50%;
  margin-left: 0;
  margin-top: 1em;
}
.ladda-button[data-style=slide-up][data-loading] .ladda-label {
  opacity: 0;
  top: -1em;
}
.ladda-button[data-style=slide-up][data-loading] .ladda-spinner {
  opacity: 1;
  margin-top: 0;
}

/*************************************
 * SLIDE DOWN
 */
.ladda-button[data-style=slide-down] {
  overflow: hidden;
}
.ladda-button[data-style=slide-down] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-down] .ladda-spinner {
  left: 50%;
  margin-left: 0;
  margin-top: -2em;
}
.ladda-button[data-style=slide-down][data-loading] .ladda-label {
  opacity: 0;
  top: 1em;
}
.ladda-button[data-style=slide-down][data-loading] .ladda-spinner {
  opacity: 1;
  margin-top: 0;
}

/*************************************
 * ZOOM-OUT
 */
.ladda-button[data-style=zoom-out] {
  overflow: hidden;
}

.ladda-button[data-style=zoom-out] .ladda-spinner {
  left: 50%;
  margin-left: 32px;
  transform: scale(2.5);
}

.ladda-button[data-style=zoom-out] .ladda-label {
  position: relative;
  display: inline-block;
}

.ladda-button[data-style=zoom-out][data-loading] .ladda-label {
  opacity: 0;
  transform: scale(0.5);
}

.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {
  opacity: 1;
  margin-left: 0;
  transform: none;
}

/*************************************
 * ZOOM-IN
 */
.ladda-button[data-style=zoom-in] {
  overflow: hidden;
}

.ladda-button[data-style=zoom-in] .ladda-spinner {
  left: 50%;
  margin-left: -16px;
  transform: scale(0.2);
}

.ladda-button[data-style=zoom-in] .ladda-label {
  position: relative;
  display: inline-block;
}

.ladda-button[data-style=zoom-in][data-loading] .ladda-label {
  opacity: 0;
  transform: scale(2.2);
}

.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {
  opacity: 1;
  margin-left: 0;
  transform: none;
}

/*************************************
 * CONTRACT
 */
.ladda-button[data-style=contract] {
  overflow: hidden;
  width: 100px;
}

.ladda-button[data-style=contract] .ladda-spinner {
  left: 50%;
  margin-left: 0;
}

.ladda-button[data-style=contract][data-loading] {
  border-radius: 50%;
  width: 52px;
}

.ladda-button[data-style=contract][data-loading] .ladda-label {
  opacity: 0;
}

.ladda-button[data-style=contract][data-loading] .ladda-spinner {
  opacity: 1;
}

/*************************************
 * OVERLAY
 */
.ladda-button[data-style=contract-overlay] {
  overflow: hidden;
  width: 100px;
  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);
}

.ladda-button[data-style=contract-overlay] .ladda-spinner {
  left: 50%;
  margin-left: 0;
}

.ladda-button[data-style=contract-overlay][data-loading] {
  border-radius: 50%;
  width: 52px;
  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/
  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);
}

.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {
  opacity: 0;
}

.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {
  opacity: 1;
}

[dir=rtl] .ladda-spinner > div {
  left: 25% !important;
}

/*!
 * Hamburgers
 * @description Tasty CSS-animated hamburgers
 * @author Jonathan Suh @jonsuh
 * @site https://jonsuh.com/hamburgers
 * @link https://github.com/jonsuh/hamburgers
 */
.hamburger {
  padding: 0px 0px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
}
.hamburger:hover {
  opacity: 0.7;
}
.hamburger.is-active:hover {
  opacity: 0.7;
}
.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner::before,
.hamburger.is-active .hamburger-inner::after {
  background-color: #545cd8;
}

.hamburger-box {
  width: 24px;
  height: 14px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -1px;
}
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  width: 24px;
  height: 2px;
  background-color: #545cd8;
  border-radius: 10px;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
}
.hamburger-inner::before, .hamburger-inner::after {
  content: "";
  display: block;
}
.hamburger-inner::before {
  top: -6px;
}
.hamburger-inner::after {
  bottom: -6px;
}

/*
 * Elastic
 */
.hamburger--elastic .hamburger-inner {
  top: 1px;
  transition-duration: 0.275s;
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.hamburger--elastic .hamburger-inner::before {
  top: 6px;
  transition: opacity 0.125s 0.275s ease;
}
.hamburger--elastic .hamburger-inner::after {
  top: 12px;
  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.hamburger--elastic.is-active .hamburger-inner {
  transform: translate3d(0, 6px, 0) rotate(135deg);
  transition-delay: 0.075s;
}
.hamburger--elastic.is-active .hamburger-inner::before {
  transition-delay: 0s;
  opacity: 0;
}
.hamburger--elastic.is-active .hamburger-inner::after {
  transform: translate3d(0, -12px, 0) rotate(-270deg);
  transition-delay: 0.075s;
}

.drawer-content-wrapper {
  background: #fff;
  position: relative;
  padding: 1.5rem;
}
.drawer-content-wrapper .drawer-heading {
  font-size: 0.968rem;
  color: #495057;
  margin: 0;
  background: #f8f9fa;
  padding: 0.75rem 1.5rem;
  border-bottom: #dee2e6 solid 1px;
  border-top: #dee2e6 solid 1px;
}
.drawer-content-wrapper .drawer-heading:first-child {
  border-top: 0;
}
.drawer-content-wrapper .drawer-section {
  padding: 1.5rem;
}
.drawer-content-wrapper > .app-sidebar__heading:first-child {
  margin-top: 0;
}

.drawer-nav-btn {
  border-radius: 30px;
  background: #fff;
  position: fixed;
  right: 0.75rem;
  top: 0.75rem;
  padding: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  z-index: 20;
}
.drawer-nav-btn .hamburger {
  margin-top: 4px;
}

body.stop-scrolling {
  height: 100%;
  overflow: hidden;
}

.sweet-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
  opacity: 0.5 !important;
}

.sweet-alert {
  background-color: #fff;
  width: 30%;
  padding: 1rem;
  border-radius: 0.25rem;
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -15%;
  margin-top: -15%;
  overflow: hidden;
  display: none;
  z-index: 99999;
  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);
}
.sweet-alert h2 {
  color: #495057;
  text-align: center;
  text-transform: none;
  position: relative;
  margin: 0.75rem 0;
  padding: 0;
  display: block;
}
.sweet-alert p {
  color: #adb5bd;
  text-align: center;
  position: relative;
  float: none;
  margin: 0;
  padding: 0;
}
.sweet-alert fieldset {
  border: none;
  position: relative;
}
.sweet-alert .sa-error-container {
  background-color: #f8f9fa;
  margin-left: -17px;
  margin-right: -17px;
  overflow: hidden;
  padding: 0 10px;
  max-height: 0;
  transition: padding 0.15s, max-height 0.15s;
}
.sweet-alert .sa-error-container.show {
  padding: 10px 0;
  max-height: 100px;
  transition: padding 0.25s, max-height 0.25s;
}
.sweet-alert .sa-error-container .icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #d92550;
  color: #fff;
  line-height: 24px;
  text-align: center;
  margin-right: 3px;
}
.sweet-alert .sa-error-container p {
  display: inline-block;
}
.sweet-alert .sa-input-error {
  position: absolute;
  top: 29px;
  right: 26px;
  width: 20px;
  height: 20px;
  opacity: 0;
  transform: scale(0.5);
  transform-origin: 50% 50%;
  transition: all 0.1s;
}
.sweet-alert .sa-input-error::before, .sweet-alert .sa-input-error::after {
  content: "";
  width: 20px;
  height: 6px;
  background-color: #d92550;
  border-radius: 3px;
  position: absolute;
  top: 50%;
  margin-top: -4px;
  left: 50%;
  margin-left: -9px;
}
.sweet-alert .sa-input-error::before {
  transform: rotate(-45deg);
}
.sweet-alert .sa-input-error::after {
  transform: rotate(45deg);
}
.sweet-alert .sa-input-error.show {
  opacity: 1;
  transform: scale(1);
}
.sweet-alert input {
  width: 100%;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid #d7d7d7;
  height: 43px;
  margin-top: 10px;
  margin-bottom: 17px;
  font-size: 18px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);
  padding: 0 12px;
  display: none;
  transition: all 0.3s;
}
.sweet-alert input:focus {
  outline: none;
  box-shadow: 0 0 3px #c4e6f5;
  border: 1px solid #b4dbed;
}
.sweet-alert .sweet-alert.show-input input {
  display: block;
}
.sweet-alert .sa-confirm-button-container {
  display: inline-block;
  position: relative;
}
.sweet-alert .la-ball-fall {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -27px;
  margin-top: 4px;
  opacity: 0;
  visibility: hidden;
}
.sweet-alert button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  font-size: 0.88rem;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s !important;
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.sweet-alert button:hover {
  color: #fff;
  background-color: rgb(20.7268907563%, 24.4355742297%, 81.9201680672%);
  border-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
}
.sweet-alert button:focus, .sweet-alert button.focus {
  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);
}
.sweet-alert button.disabled, .sweet-alert button:disabled {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.sweet-alert button:not(:disabled):not(.disabled):active, .sweet-alert button:not(:disabled):not(.disabled).active, .show > .sweet-alert button.dropdown-toggle {
  color: #fff;
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
  border-color: rgb(17.2058823529%, 20.7352941176%, 75.4411764706%);
}
.sweet-alert button:not(:disabled):not(.disabled):active:focus, .sweet-alert button:not(:disabled):not(.disabled).active:focus, .show > .sweet-alert button.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);
}
.sweet-alert button:hover, .sweet-alert button:focus {
  text-decoration: none;
}
.sweet-alert button:focus, .sweet-alert button.focus {
  outline: 0;
  box-shadow: none;
}
.sweet-alert button.disabled, .sweet-alert button:disabled {
  opacity: 0.65;
}
.sweet-alert button.cancel {
  font-weight: 400;
  color: #545cd8;
  background-color: transparent;
  border-color: transparent;
  margin-right: 0.5rem;
}
.sweet-alert button.cancel:hover {
  color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);
  text-decoration: underline;
  background-color: transparent;
  border-color: transparent;
}
.sweet-alert button.cancel:active, .sweet-alert button.cancel.active, .sweet-alert button.cancel:focus, .sweet-alert button.cancel.focus {
  text-decoration: none;
  border-color: transparent;
  box-shadow: none;
  background-color: transparent;
}
.sweet-alert button.cancel:disabled, .sweet-alert button.cancel.disabled {
  color: #6c757d;
  pointer-events: none;
}
.sweet-alert button.confirm[disabled] ~ .la-ball-fall {
  opacity: 1;
  visibility: visible;
  transition-delay: 0s;
}
.sweet-alert[data-has-cancel-button=false] button {
  box-shadow: none !important;
}
.sweet-alert[data-has-confirm-button=false][data-has-cancel-button=false] {
  padding-bottom: 40px;
}
.sweet-alert .sa-button-container {
  padding: 1rem 0 0;
}

.sa-icon {
  width: 80px;
  height: 80px;
  border: 4px solid #dee2e6;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
}
.sa-icon.sa-error {
  border-color: #d92550;
}
.sa-icon.sa-error .sa-x-mark {
  position: relative;
  display: block;
}
.sa-icon.sa-error .sa-line {
  position: absolute;
  height: 5px;
  width: 47px;
  background-color: #d92550;
  display: block;
  top: 37px;
  border-radius: 2px;
}
.sa-icon.sa-error .sa-line.sa-left {
  transform: rotate(45deg);
  left: 17px;
}
.sa-icon.sa-error .sa-line.sa-right {
  transform: rotate(-45deg);
  right: 16px;
}
.sa-icon.sa-warning {
  border-color: #f7b924;
}
.sa-icon.sa-warning .sa-body {
  position: absolute;
  width: 5px;
  height: 47px;
  left: 50%;
  top: 10px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #f7b924;
}
.sa-icon.sa-warning .sa-dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  left: 50%;
  bottom: 10px;
  background-color: #f7b924;
}
.sa-icon.sa-info {
  border-color: #30b1ff;
}
.sa-icon.sa-info::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 29px;
  left: 50%;
  bottom: 17px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #30b1ff;
}
.sa-icon.sa-info::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  top: 19px;
  background-color: #30b1ff;
}
.sa-icon.sa-success {
  border-color: #3ac47d;
}
.sa-icon.sa-success::before, .sa-icon.sa-success::after {
  content: "";
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  background: #fff;
  transform: rotate(45deg);
}
.sa-icon.sa-success::before {
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  transform: rotate(-45deg);
  transform-origin: 60px 60px;
}
.sa-icon.sa-success::after {
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  transform: rotate(-45deg);
  transform-origin: 0 60px;
}
.sa-icon.sa-success .sa-placeholder {
  width: 80px;
  height: 80px;
  border: 4px solid rgba(165, 220, 134, 0.2);
  border-radius: 40px;
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
}
.sa-icon.sa-success .sa-fix {
  width: 5px;
  height: 90px;
  background-color: #fff;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  transform: rotate(-45deg);
}
.sa-icon.sa-success .sa-line {
  height: 5px;
  background-color: #3ac47d;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2;
}
.sa-icon.sa-success .sa-line.sa-tip {
  width: 25px;
  left: 14px;
  top: 46px;
  transform: rotate(45deg);
}
.sa-icon.sa-success .sa-line.sa-long {
  width: 47px;
  right: 8px;
  top: 38px;
  transform: rotate(-45deg);
}
.sa-icon.sa-custom {
  background-size: contain;
  border-radius: 0;
  border: none;
  background-position: center center;
  background-repeat: no-repeat;
}

@media all and (max-width: 540px) {
  .sweet-alert {
    width: auto;
    margin-left: 0;
    margin-right: 0;
    left: 15px;
    right: 15px;
  }
}
/*
 * Animations
 */
@keyframes showSweetAlert {
  0% {
    transform: scale(0.7);
    -webkit-transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
    -webkit-transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
    -webkit-transform: scale(0.95);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
@keyframes hideSweetAlert {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
  100% {
    transform: scale(0.5);
    -webkit-transform: scale(0.5);
  }
}
@keyframes slideFromTop {
  0% {
    top: 0%;
  }
  100% {
    top: 50%;
  }
}
@keyframes slideToTop {
  0% {
    top: 50%;
  }
  100% {
    top: 0%;
  }
}
@keyframes slideFromBottom {
  0% {
    top: 70%;
  }
  100% {
    top: 50%;
  }
}
@keyframes slideToBottom {
  0% {
    top: 50%;
  }
  100% {
    top: 70%;
  }
}
.showSweetAlert[data-animation=pop] {
  animation: showSweetAlert 0.3s;
}

.showSweetAlert[data-animation=none] {
  animation: none;
}

.showSweetAlert[data-animation=slide-from-top] {
  animation: slideFromTop 0.3s;
}

.showSweetAlert[data-animation=slide-from-bottom] {
  animation: slideFromBottom 0.3s;
}

.hideSweetAlert[data-animation=pop] {
  animation: hideSweetAlert 0.2s;
}

.hideSweetAlert[data-animation=none] {
  animation: none;
}

.hideSweetAlert[data-animation=slide-from-top] {
  animation: slideToTop 0.4s;
}

.hideSweetAlert[data-animation=slide-from-bottom] {
  animation: slideToBottom 0.3s;
}
@keyframes animateSuccessTip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animateSuccessLong {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
@keyframes rotatePlaceholder {
  0% {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
    -webkit-transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
    -webkit-transform: rotate(-405deg);
  }
}
.animateSuccessTip {
  animation: animateSuccessTip 0.75s;
}

.animateSuccessLong {
  animation: animateSuccessLong 0.75s;
}

.sa-icon.sa-success.animate::after {
  animation: rotatePlaceholder 4.25s ease-in;
}
@keyframes animateErrorIcon {
  0% {
    transform: rotateX(100deg);
    -webkit-transform: rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    -webkit-transform: rotateX(0deg);
    opacity: 1;
  }
}
.animateErrorIcon {
  animation: animateErrorIcon 0.5s;
}
@keyframes animateXMark {
  0% {
    transform: scale(0.4);
    -webkit-transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  50% {
    transform: scale(0.4);
    -webkit-transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  80% {
    transform: scale(1.15);
    -webkit-transform: scale(1.15);
    margin-top: -6px;
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    margin-top: 0;
    opacity: 1;
  }
}
.animateXMark {
  animation: animateXMark 0.5s;
}
@keyframes pulseWarning {
  0% {
    border-color: #F8D486;
  }
  100% {
    border-color: #f7b924;
  }
}
.pulseWarning {
  animation: pulseWarning 0.75s infinite alternate;
}
@keyframes pulseWarningIns {
  0% {
    background-color: #F8D486;
  }
  100% {
    background-color: #f7b924;
  }
}
.pulseWarningIns {
  animation: pulseWarningIns 0.75s infinite alternate;
}
@keyframes rotate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* Internet Explorer 9 has some special quirks that are fixed here */
/* The icons are not animated. */
/* This file is automatically merged into sweet-alert.min.js through Gulp */
/* Error icon */
.sweet-alert .sa-icon.sa-error .sa-line.sa-left {
  -ms-transform: rotate(45deg) \\9 ;
}

.sweet-alert .sa-icon.sa-error .sa-line.sa-right {
  -ms-transform: rotate(-45deg) \\9 ;
}

/* Success icon */
.sweet-alert .sa-icon.sa-success {
  border-color: transparent \\9 ;
}

.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {
  -ms-transform: rotate(45deg) \\9 ;
}

.sweet-alert .sa-icon.sa-success .sa-line.sa-long {
  -ms-transform: rotate(-45deg) \\9 ;
}

/*!
 * Load Awesome v1.1.0 (http://github.danielcardoso.net/load-awesome/)
 * Copyright 2015 Daniel Cardoso <@DanielCardoso>
 * Licensed under MIT
 */
.la-ball-fall,
.la-ball-fall > div {
  position: relative;
  box-sizing: border-box;
}

.la-ball-fall {
  display: block;
  font-size: 0;
  color: #fff;
}

.la-ball-fall.la-dark {
  color: #333;
}

.la-ball-fall > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.la-ball-fall {
  width: 54px;
  height: 18px;
}

.la-ball-fall > div {
  width: 10px;
  height: 10px;
  margin: 4px;
  border-radius: 100%;
  opacity: 0;
  animation: ball-fall 1s ease-in-out infinite;
}

.la-ball-fall > div:nth-child(1) {
  animation-delay: -200ms;
}

.la-ball-fall > div:nth-child(2) {
  animation-delay: -100ms;
}

.la-ball-fall > div:nth-child(3) {
  animation-delay: 0ms;
}

.la-ball-fall.la-sm {
  width: 26px;
  height: 8px;
}

.la-ball-fall.la-sm > div {
  width: 4px;
  height: 4px;
  margin: 2px;
}

.la-ball-fall.la-2x {
  width: 108px;
  height: 36px;
}

.la-ball-fall.la-2x > div {
  width: 20px;
  height: 20px;
  margin: 8px;
}

.la-ball-fall.la-3x {
  width: 162px;
  height: 54px;
}

.la-ball-fall.la-3x > div {
  width: 30px;
  height: 30px;
  margin: 12px;
}

/*
 * Animation
 */
@keyframes ball-fall {
  0% {
    opacity: 0;
    transform: translateY(-145%);
  }
  10% {
    opacity: 0.5;
  }
  20% {
    opacity: 1;
    transform: translateY(0);
  }
  80% {
    opacity: 1;
    transform: translateY(0);
  }
  90% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
    transform: translateY(145%);
  }
}
.Toastify__toast-container {
  z-index: 9999;
  position: fixed;
  padding: 0;
  width: 320px;
  box-sizing: border-box;
  color: #fff;
}
.Toastify__toast-container--top-left {
  top: 1rem;
  left: 1rem;
}
.Toastify__toast-container--top-center {
  top: 1rem;
  left: 50%;
  margin-left: -160px;
}
.Toastify__toast-container--top-right {
  top: 1rem;
  right: 1rem;
}
.Toastify__toast-container--bottom-left {
  bottom: 1rem;
  left: 1rem;
}
.Toastify__toast-container--bottom-center {
  bottom: 1rem;
  left: 50%;
  margin-left: -160px;
}
.Toastify__toast-container--bottom-right {
  bottom: 1rem;
  right: 1rem;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast-container {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
  }
  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
    top: 0;
  }
  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
    bottom: 0;
  }
  .Toastify__toast-container--rtl {
    right: 0;
    left: auto;
    left: initial;
  }
}
.Toastify__toast {
  position: relative;
  min-height: 54px;
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 0.25rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
  display: flex;
  justify-content: space-between;
  max-height: 800px;
  overflow: hidden;
  font-family: sans-serif;
  cursor: pointer;
  direction: ltr;
}
.Toastify__toast--rtl {
  direction: rtl;
}
.Toastify__toast--default {
  background: #fff;
  color: #495057;
  box-shadow: 0 0.66875rem 2.3875rem rgba(84, 92, 216, 0.03), 0 1.1375rem 1.60625rem rgba(84, 92, 216, 0.03), 0 0.45rem 0.73125rem rgba(84, 92, 216, 0.05), 0 0.325rem 0.3875rem rgba(84, 92, 216, 0.03);
}
.Toastify__toast--info {
  background: #30b1ff;
  box-shadow: 0 0.66875rem 2.3875rem rgba(48, 177, 255, 0.03), 0 1.1375rem 1.60625rem rgba(48, 177, 255, 0.03), 0 0.45rem 0.73125rem rgba(48, 177, 255, 0.05), 0 0.325rem 0.3875rem rgba(48, 177, 255, 0.03);
}
.Toastify__toast--success {
  background: #3ac47d;
  box-shadow: 0 0.66875rem 2.3875rem rgba(58, 196, 125, 0.03), 0 1.1375rem 1.60625rem rgba(58, 196, 125, 0.03), 0 0.45rem 0.73125rem rgba(58, 196, 125, 0.05), 0 0.325rem 0.3875rem rgba(58, 196, 125, 0.03);
}
.Toastify__toast--warning {
  background: #f7b924;
  box-shadow: 0 0.66875rem 2.3875rem rgba(247, 185, 36, 0.03), 0 1.1375rem 1.60625rem rgba(247, 185, 36, 0.03), 0 0.45rem 0.73125rem rgba(247, 185, 36, 0.05), 0 0.325rem 0.3875rem rgba(247, 185, 36, 0.03);
}
.Toastify__toast--error {
  background: #d92550;
  box-shadow: 0 0.66875rem 2.3875rem rgba(217, 37, 80, 0.03), 0 1.1375rem 1.60625rem rgba(217, 37, 80, 0.03), 0 0.45rem 0.73125rem rgba(217, 37, 80, 0.05), 0 0.325rem 0.3875rem rgba(217, 37, 80, 0.03);
}
.Toastify__toast-body {
  margin: auto 0;
  padding: 0 0 0.4rem;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast {
    margin-bottom: 0;
  }
}
.Toastify__close-button {
  color: #fff;
  font-size: 14px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  position: absolute;
  top: 5px;
  right: 9px;
}
.Toastify__close-button--default {
  color: #000;
  opacity: 0.3;
}
.Toastify__close-button:hover, .Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    width: 96%;
  }
  100% {
    width: 0;
  }
}
.Toastify__progress-bar {
  position: absolute;
  bottom: 9%;
  left: 2%;
  width: 0;
  height: 5px;
  z-index: 9999;
  animation: Toastify__trackProgress linear 1;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 0.25rem;
}
.Toastify__progress-bar--rtl {
  right: 0;
  left: auto;
  left: initial;
}
.Toastify__progress-bar--default {
  background: #545cd8;
}
@keyframes Toastify__bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInUp {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes Toastify__bounceInDown {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}
.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}
.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}
.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}
.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}
.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}
.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
@keyframes Toastify__flipOut {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}
.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, 0, 0);
  }
}
@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, 0, 0);
  }
}
@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}
@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}
.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}
.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}
.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}
.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
}
.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
}
.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
}
.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
}

/* -- container -- */
.rodal,
.rodal-mask {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.rodal {
  position: fixed;
}

/* -- mask -- */
.rodal-mask {
  position: absolute;
  background-color: #000;
  opacity: 0.5;
}

/* -- dialog -- */
.rodal-dialog {
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 101;
  background: #fff;
  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);
  border-radius: 0.25rem;
  height: auto !important;
}

.rodal-dialog:focus {
  outline: none;
}

/* -- close button -- */
.rodal-close {
  position: absolute;
  cursor: pointer;
  top: 16px;
  right: 16px;
  width: 16px;
  height: 16px;
}

.rodal-close:before,
.rodal-close:after {
  position: absolute;
  content: "";
  height: 2px;
  width: 100%;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background: #adb5bd;
  border-radius: 100%;
  transition: background 0.2s;
}

.rodal-close:before {
  transform: rotate(45deg);
}

.rodal-close:after {
  transform: rotate(-45deg);
}

.rodal-close:hover:before,
.rodal-close:hover:after {
  background: #343a40;
}

/* -- fade -- */
@keyframes rodal-fade-enter {
  from {
    opacity: 0;
  }
}
.rodal-fade-enter {
  animation: rodal-fade-enter both ease-in;
}

@keyframes rodal-fade-leave {
  to {
    opacity: 0;
  }
}
.rodal-fade-leave {
  animation: rodal-fade-leave both ease-out;
}

@keyframes rodal-zoom-enter {
  from {
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-zoom-enter {
  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-zoom-leave {
  to {
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-zoom-leave {
  animation: rodal-zoom-leave both;
}

@keyframes rodal-slideDown-enter {
  from {
    transform: translate3d(0, -100px, 0);
  }
}
.rodal-slideDown-enter {
  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideDown-leave {
  to {
    transform: translate3d(0, -100px, 0);
  }
}
.rodal-slideDown-leave {
  animation: rodal-slideDown-leave both;
}

/* -- slideLeft -- */
@keyframes rodal-slideLeft-enter {
  from {
    transform: translate3d(-150px, 0, 0);
  }
}
.rodal-slideLeft-enter {
  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideLeft-leave {
  to {
    transform: translate3d(-150px, 0, 0);
  }
}
.rodal-slideLeft-leave {
  animation: rodal-slideLeft-leave both;
}

/* -- slideRight -- */
@keyframes rodal-slideRight-enter {
  from {
    transform: translate3d(150px, 0, 0);
  }
}
.rodal-slideRight-enter {
  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideRight-leave {
  to {
    transform: translate3d(150px, 0, 0);
  }
}
.rodal-slideRight-leave {
  animation: rodal-slideRight-leave both;
}

/* -- slideUp -- */
@keyframes rodal-slideUp-enter {
  from {
    transform: translate3d(0, 100px, 0);
  }
}
.rodal-slideUp-enter {
  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideUp-leave {
  to {
    transform: translate3d(0, 100px, 0);
  }
}
.rodal-slideUp-leave {
  animation: rodal-slideUp-leave both;
}

/* -- flip -- */
@keyframes rodal-flip-enter {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);
  }
  70% {
    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);
  }
  to {
    transform: perspective(400px);
  }
}
.rodal-flip-enter {
  animation: rodal-flip-enter both ease-in;
  backface-visibility: visible !important;
}

@keyframes rodal-flip-leave {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);
  }
}
.rodal-flip-leave {
  animation: rodal-flip-leave both;
  backface-visibility: visible !important;
}

/* -- rotate -- */
@keyframes rodal-rotate-enter {
  from {
    transform: rotate3d(0, 0, 1, -180deg) scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-rotate-enter {
  animation: rodal-rotate-enter both;
  transform-origin: center;
}

@keyframes rodal-rotate-leave {
  to {
    transform: rotate3d(0, 0, 1, 180deg) scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-rotate-leave {
  animation: rodal-rotate-leave both;
  transform-origin: center;
}

/* -- door -- */
@keyframes rodal-door-enter {
  from {
    transform: scale3d(0, 1, 1);
  }
}
.rodal-door-enter {
  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-door-leave {
  60% {
    transform: scale3d(0.01, 1, 1);
  }
  to {
    transform: scale3d(0, 1, 0.1);
  }
}
.rodal-door-leave {
  animation: rodal-door-leave both;
}

.react-sweet-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.react-sweet-progress-symbol {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 35px;
  height: 20px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 200;
}

.react-sweet-progress-symbol-absolute {
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  align-items: center;
  justify-content: center;
  transform: translate3d(-50%, -50%, 0);
}

.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {
  padding: 0;
  width: 100%;
}

.react-sweet-progress-circle-outer {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.react-sweet-progress-line {
  width: 100%;
  border-radius: 100px;
  background-color: #efefef;
  vertical-align: middle;
}

.react-sweet-progress-line-inner {
  position: relative;
  min-height: 10px;
  border-radius: 100px;
  transition: width 0.3s ease;
}

.react-sweet-progress-line-inner-status-active:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 10px;
  background: #fff;
  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;
  content: "";
  opacity: 0;
}

@keyframes active-anim {
  0% {
    width: 0;
    opacity: 0.1;
  }
  20% {
    width: 0;
    opacity: 0.5;
  }
  to {
    width: 100%;
    opacity: 0;
  }
}
.react-sweet-progress-circle path {
  stroke-linecap: round;
}

/* Slider */
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.slick-slider-sm .slick-slider {
  max-width: 450px;
}
.slick-slider-sm .slick-slider .slick-prev {
  left: -20px;
}
.slick-slider-sm .slick-slider .slick-next {
  right: -20px;
}

.slick-slider-md .slick-slider {
  max-width: 650px;
  margin: 0 auto;
}

.slick-slider-hover .slick-arrow {
  opacity: 0;
  background: #545cd8;
  color: #fff !important;
}
.slick-slider-hover .slick-prev {
  left: -30px;
}
.slick-slider-hover .slick-next {
  right: -30px;
}
.slick-slider-hover:hover .slick-arrow {
  opacity: 1;
}

.slick-list {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.slick-track {
  position: relative;
  left: 0;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before, .slick-track:after {
  content: "";
  display: table;
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
}
[dir=rtl] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}

/* Arrows */
.slick-prev,
.slick-next {
  position: absolute;
  display: block;
  height: 40px;
  width: 40px;
  cursor: pointer;
  color: #6c757d;
  top: 50%;
  transform: translate(0, -80%);
  padding: 0;
  border: none;
  outline: none;
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
  transition: all 0.2s;
  font-family: "Pe-icon-7-stroke";
  border-radius: 50px;
  background: #fff;
  z-index: 6;
  overflow: hidden;
}
.slick-prev::before,
.slick-next::before {
  font-size: 35px;
  height: 40px;
  line-height: 40px;
  width: 40px;
}
.slick-prev:hover, .slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  outline: none;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  color: #545cd8;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}

.slick-prev {
  left: 0;
}
.slick-prev:before {
  content: "\\e686";
}

.slick-next {
  right: 0;
}
.slick-next:before {
  content: "\\e684";
}

/* Dots */
.slick-dots {
  list-style: none;
  display: block;
  text-align: center;
  padding: 0;
  margin: 0.75rem 0 0;
  width: 100%;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  padding: 0;
  margin: 0 5px;
  cursor: pointer;
  transform: scale(0.8);
  transition: all 0.2s;
}
.slick-dots li button {
  border: 0;
  background: transparent;
  display: block;
  height: 14px;
  width: 14px;
  background: #545cd8;
  cursor: pointer;
  position: relative;
  border-radius: 20px;
  color: transparent;
}
.slick-dots li button::before {
  content: "";
  position: absolute;
  background: #fff;
  left: 50%;
  top: 50%;
  margin: -4px 0 0 -4px;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 20px;
}
.slick-dots li.slick-active {
  transform: scale(1.2);
}

.slick-center {
  transform: scale(1.1);
}

.slick-slider .slide-img-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  opacity: 0.4;
  z-index: 10;
}
.slick-slider .slider-content {
  position: relative;
  z-index: 15;
  text-align: center;
  margin: 0 6rem;
}
.slick-slider .slider-content h3 {
  font-size: 1.75rem;
  font-weight: normal;
  margin-bottom: 1.5rem;
}
.slick-slider .slider-content p {
  font-size: 1rem;
  opacity: 0.7;
}

.slider-light .slick-dots {
  position: absolute;
  bottom: 10px;
}
.slider-light .slick-dots li button {
  background: rgba(255, 255, 255, 0.25);
}
.slider-light .slick-prev,
.slider-light .slick-next {
  background: transparent;
  color: #fff;
  box-shadow: 0 0 0 0 transparent;
}
.slider-light .slick-prev:hover,
.slider-light .slick-next:hover {
  background: rgba(255, 255, 255, 0.15);
}
.slider-light .slick-next {
  right: 15px;
}
.slider-light .slick-prev {
  left: 15px;
}
.slider-light .slider-content {
  color: #fff;
}

.loading-indicator {
  text-align: center;
}

.loading-bullet {
  display: inline-block;
  opacity: 0;
  font-size: 2em;
  color: #02a17c;
}

.block-ui {
  position: relative;
  min-height: 8em;
}

.block-ui-container {
  position: absolute;
  z-index: 1010;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  min-height: 2em;
  cursor: wait;
  overflow: hidden;
}

.block-ui-container:focus {
  outline: none;
}

.block-ui-overlay {
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  background-color: white;
}

.block-ui-message-container {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  right: 0;
  text-align: center;
  transform: translateY(-50%);
  z-index: 10001;
}

.block-ui-message {
  color: #333;
  background: none;
  z-index: 1011;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-overlay-dark .block-ui-overlay {
  background: rgb(0, 0, 0);
}

.popover {
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}
.popover .grid-menu {
  margin-bottom: -0.5rem;
  padding: 1px;
}
.popover .grid-menu [class*=col-] {
  padding: 0.5rem;
}
.popover .grid-menu + .nav .nav-item-btn {
  margin-bottom: 0.5rem;
}
.popover .grid-menu-xl {
  margin-bottom: -0.3703703704rem;
}
.popover .grid-menu-xl [class*=col-] {
  padding: 0;
}
.popover .popover-inner .dropdown-menu-header {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  overflow: hidden;
  margin-top: -1px;
  margin-left: -1px;
  margin-right: -1px;
}

.rm-max-width > .popover {
  max-width: none;
  max-width: initial;
}

.rm-pointers > .popover .arrow {
  display: none !important;
}

.popover-primary {
  background-color: #545cd8 !important;
}

.popover-secondary {
  background-color: #6c757d !important;
}

.popover-success {
  background-color: #3ac47d !important;
}

.popover-info {
  background-color: #30b1ff !important;
}

.popover-warning {
  background-color: #f7b924 !important;
}

.popover-danger {
  background-color: #d92550 !important;
}

.popover-light {
  background-color: #eeeeee !important;
}

.popover-dark {
  background-color: #343a40 !important;
}

.popover-focus {
  background-color: #444054 !important;
}

.popover-alternate {
  background-color: #83588a !important;
}

.popover-custom .popover-body {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}
.popover-custom .popover-body .dropdown-menu-header {
  margin-top: 0;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  overflow: hidden;
}
.popover-custom .popover-body .dropdown-menu-header .menu-header-content {
  padding: 0 1.5rem;
}
.popover-custom .popover-body .dropdown-menu-header .dropdown-menu-header-inner.bg-light {
  color: rgba(0, 0, 0, 0.8);
}
.popover-custom.popover-custom-lg {
  min-width: 22rem;
}
.popover-custom.popover-custom-xl {
  min-width: 25rem;
}
.popover-custom.popover-custom-sm {
  min-width: 15rem;
}

.popover-bg {
  border: 0;
}
.popover-bg .arrow {
  display: none;
}
.popover-bg .popover-header {
  background: rgba(255, 255, 255, 0.1);
  border-bottom: 0;
  color: rgb(255, 255, 255);
}
.popover-bg .popover-header::before {
  display: none;
}
.popover-bg .popover-body {
  color: rgba(255, 255, 255, 0.7);
}
.popover-bg.text-dark .popover-header {
  color: rgba(0, 0, 0, 0.8);
}
.popover-bg.text-dark .popover-body {
  color: rgba(0, 0, 0, 0.7);
}

.tooltip-light > .tooltip .tooltip-inner {
  background: #fff;
  color: #343a40;
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
  border: rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125) solid 1px;
}
.tooltip-light > .tooltip .arrow {
  display: none;
}

.scrollable-block {
  margin-bottom: 50px;
  overflow: hidden;
  position: relative;
}
.scrollable-block .sticky {
  z-index: 2;
}

.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 1;
  min-height: 580px;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full, .rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: rgb(70%, 70%, 70%);
}

.rbc-header {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
  font-size: 90%;
  min-height: 0;
  flex: 1 0;
  flex-basis: auto !important;
}
.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-content {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  z-index: 4;
}

.rbc-today {
  background-color: #e0f3ff;
}

.rbc-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
}
.rbc-toolbar .rbc-toolbar-label {
  width: 100%;
  padding: 0 10px;
  text-align: center;
}
.rbc-toolbar button {
  color: #fff;
  display: inline-block;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  background: #545cd8;
  border: 1px solid #545cd8;
  padding: 0.375rem 1rem;
  border-radius: 0.25rem;
  line-height: normal;
  white-space: nowrap;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 0.88rem;
}
.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {
  background-image: none;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
  border-color: rgb(17.3915966387%, 20.9591036415%, 76.2554621849%);
}
.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {
  color: #fff;
  background-color: rgb(15.5344537815%, 18.7210084034%, 68.112605042%);
  border-color: rgb(12.5630252101%, 15.1400560224%, 55.0840336134%);
}
.rbc-toolbar button:focus {
  color: #fff;
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
  border-color: rgb(17.3915966387%, 20.9591036415%, 76.2554621849%);
}
.rbc-toolbar button:hover {
  color: #fff;
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
  border-color: rgb(17.3915966387%, 20.9591036415%, 76.2554621849%);
}

.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}
.rbc-btn-group > button:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.rbc-btn-group button + button {
  margin-left: -1px;
}
.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}
.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {
  margin-left: 10px;
}

.rbc-event {
  cursor: pointer;
  padding: 0.125rem;
  background-color: #545cd8;
  border-radius: 0.25rem;
  color: #fff;
}
.rbc-event.rbc-selected {
  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 0 1px 1px 1px;
}
.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}

.rbc-month-view {
  position: relative;
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  height: 100%;
}
.rbc-month-view .rbc-header {
  border-bottom: 1px solid #e9ecef;
}
.rbc-month-view .rbc-header + .rbc-header {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-month-view .rbc-header + .rbc-header {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  overflow: hidden;
  height: 100%;
}
.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #e9ecef;
}

.rbc-date-cell {
  padding-right: 5px;
  text-align: right;
  flex: 1 1;
}
.rbc-date-cell.rbc-now {
  font-weight: bold;
}
.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
}

.rbc-day-bg {
  flex: 1 0;
}
.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}

.rbc-off-range-bg {
  background: #f8f9fa;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}
.rbc-agenda-view table {
  width: 100%;
  border: 1px solid #e9ecef;
}
.rbc-agenda-view table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}
.rbc-agenda-view table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}
.rbc-agenda-view table tbody > tr > td + td {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-agenda-view table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-agenda-view table tbody > tr + tr {
  border-top: 1px solid #e9ecef;
}
.rbc-agenda-view table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}
.rbc-rtl .rbc-agenda-view table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}
.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}
.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #e9ecef;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}
.rbc-day-slot .rbc-event {
  border: 1px solid rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
  display: flex;
  max-height: 100%;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
}
.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
}
.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}
.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid white;
}

.rbc-time-slot {
  flex: 1 0;
}
.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-day-slot .rbc-event {
  position: absolute;
  z-index: 2;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  cursor: default;
  background-color: rgba(0, 0, 0, 0.5);
  color: #white;
  font-size: 75%;
  padding: 3px;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  border: 1px solid #e9ecef;
  min-height: 0;
}
.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}
.rbc-time-view .rbc-allday-cell {
  width: 100%;
  position: relative;
}
.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}
.rbc-time-view .rbc-row {
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
}
.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #e9ecef;
}
.rbc-time-header > .rbc-row > * + * {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-header > .rbc-row > * + * {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #e9ecef;
}
.rbc-time-header .rbc-gutter-cell {
  flex: none;
}
.rbc-time-header > .rbc-gutter-cell + * {
  width: 100%;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #e9ecef;
  overflow-y: auto;
  position: relative;
}
.rbc-time-content > .rbc-time-gutter {
  flex: none;
}
.rbc-time-content > * + * > * {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-time-content > .rbc-day-slot {
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 1;
  left: 0;
  height: 1px;
  background-color: #3ac47d;
  pointer-events: none;
}
.rbc-current-time-indicator::before {
  display: block;
  position: absolute;
  left: -3px;
  top: -3px;
  content: " ";
  background-color: #3ac47d;
  border-radius: 50%;
  width: 8px;
  height: 8px;
}
.rbc-rtl .rbc-current-time-indicator::before {
  left: 0;
  right: -3px;
}

.handle-bar {
  background: transparent !important;
  border-radius: 30px;
}
.handle-bar:active, .handle-bar:hover, .handle-bar.handle-bar_clone {
  background-color: #e9ecef !important;
}
.handle-bar.resize-not-allowed:hover {
  background-color: #e9ecef;
}
.handle-bar .handle-bar_drag {
  border-color: #545cd8 !important;
}

/**
 * Extra class applied to VirtualScroll through className prop
 */
.rst__virtualScrollOverride {
  overflow: auto !important;
}

.ReactVirtualized__Grid__innerScrollContainer {
  overflow: visible !important;
}

.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {
  direction: rtl;
}

.ReactVirtualized__Grid {
  outline: none;
}

.rst__node {
  min-width: 100%;
  white-space: nowrap;
  position: relative;
  text-align: left;
}

.rst__node.rst__rtl {
  text-align: right;
}

.rst__nodeContent {
  position: absolute;
  top: 0;
  bottom: 0;
}

/* ==========================================================================
   Scaffold

    Line-overlaid blocks used for showing the tree structure
   ========================================================================== */
.rst__lineBlock,
.rst__absoluteLineBlock {
  height: 100%;
  position: relative;
  display: inline-block;
}

.rst__absoluteLineBlock {
  position: absolute;
  top: 0;
}

.rst__lineHalfHorizontalRight::before,
.rst__lineFullVertical::after,
.rst__lineHalfVerticalTop::after,
.rst__lineHalfVerticalBottom::after {
  position: absolute;
  content: "";
  background-color: black;
}

/**
 * +-----+
 * |     |
 * |  +--+
 * |     |
 * +-----+
 */
.rst__lineHalfHorizontalRight::before {
  height: 1px;
  top: 50%;
  right: 0;
  width: 50%;
}

.rst__rtl.rst__lineHalfHorizontalRight::before {
  left: 0;
  right: auto;
  right: initial;
}

.rst__lineFullVertical::after,
.rst__lineHalfVerticalTop::after,
.rst__lineHalfVerticalBottom::after {
  width: 1px;
  left: 50%;
  top: 0;
  height: 100%;
}

.rst__rtl.rst__lineFullVertical::after,
.rst__rtl.rst__lineHalfVerticalTop::after,
.rst__rtl.rst__lineHalfVerticalBottom::after {
  right: 50%;
  left: auto;
  left: initial;
}

.rst__lineHalfVerticalTop::after {
  height: 50%;
}

.rst__lineHalfVerticalBottom::after {
  top: auto;
  bottom: 0;
  height: 50%;
}

/* Highlight line for pointing to dragged row destination
   ========================================================================== */
.rst__highlightLineVertical {
  z-index: 3;
}

.rst__highlightLineVertical::before {
  position: absolute;
  content: "";
  background-color: #545cd8;
  width: 8px;
  margin-left: -4px;
  left: 50%;
  top: 0;
  height: 100%;
}

.rst__rtl.rst__highlightLineVertical::before {
  margin-left: 0;
  margin-left: initial;
  margin-right: -4px;
  left: auto;
  left: initial;
  right: 50%;
}

@keyframes arrow-pulse {
  0% {
    transform: translate(0, 0);
    opacity: 0;
  }
  30% {
    transform: translate(0, 300%);
    opacity: 1;
  }
  70% {
    transform: translate(0, 700%);
    opacity: 1;
  }
  100% {
    transform: translate(0, 1000%);
    opacity: 0;
  }
}
.rst__highlightLineVertical::after {
  content: "";
  position: absolute;
  height: 0;
  margin-left: -4px;
  left: 50%;
  top: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid white;
  animation: arrow-pulse 1s infinite linear both;
}

.rst__rtl.rst__highlightLineVertical::after {
  margin-left: 0;
  margin-left: initial;
  margin-right: -4px;
  right: 50%;
  left: auto;
  left: initial;
}

/**
 * +-----+
 * |     |
 * |  +--+
 * |  |  |
 * +--+--+
 */
.rst__highlightTopLeftCorner::before {
  z-index: 3;
  content: "";
  position: absolute;
  border-top: solid 8px #545cd8;
  border-left: solid 8px #545cd8;
  box-sizing: border-box;
  height: calc(50% + 4px);
  top: 50%;
  margin-top: -4px;
  right: 0;
  width: calc(50% + 4px);
}

.rst__rtl.rst__highlightTopLeftCorner::before {
  border-right: solid 8px #545cd8;
  border-left: none;
  left: 0;
  right: auto;
  right: initial;
}

/**
 * +--+--+
 * |  |  |
 * |  |  |
 * |  +->|
 * +-----+
 */
.rst__highlightBottomLeftCorner {
  z-index: 3;
}

.rst__highlightBottomLeftCorner::before {
  content: "";
  position: absolute;
  border-bottom: solid 8px #545cd8;
  border-left: solid 8px #545cd8;
  box-sizing: border-box;
  height: calc(100% + 4px);
  top: 0;
  right: 12px;
  width: calc(50% - 8px);
}

.rst__rtl.rst__highlightBottomLeftCorner::before {
  border-right: solid 8px #545cd8;
  border-left: none;
  left: 12px;
  right: auto;
  right: initial;
}

.rst__highlightBottomLeftCorner::after {
  content: "";
  position: absolute;
  height: 0;
  right: 0;
  top: 100%;
  margin-top: -12px;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid #545cd8;
}

.rst__rtl.rst__highlightBottomLeftCorner::after {
  left: 0;
  right: auto;
  right: initial;
  border-right: 12px solid #545cd8;
  border-left: none;
}

.rst__rowWrapper {
  padding: 10px 10px 10px 0;
  height: 100%;
  box-sizing: border-box;
}

.rst__rtl.rst__rowWrapper {
  padding: 10px 0 10px 10px;
}

.rst__row {
  height: 100%;
  white-space: nowrap;
  display: flex;
}

.rst__row > * {
  box-sizing: border-box;
}

/**
 * The outline of where the element will go if dropped, displayed while dragging
 */
.rst__rowLandingPad,
.rst__rowCancelPad {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rst__rowLandingPad > *,
.rst__rowCancelPad > * {
  opacity: 0 !important;
}

.rst__rowLandingPad::before,
.rst__rowCancelPad::before {
  background-color: lightblue;
  border: 1px dashed #fff;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
}

/**
 * Alternate appearance of the landing pad when the dragged location is invalid
 */
.rst__rowCancelPad::before {
  background-color: #e6a8ad;
}

/**
 * Nodes matching the search conditions are highlighted
 */
.rst__rowSearchMatch {
  outline: solid 3px #0080ff;
}

/**
 * The node that matches the search conditions and is currently focused
 */
.rst__rowSearchFocus {
  outline: solid 3px #fc6421;
}

.rst__rowContents,
.rst__rowLabel,
.rst__rowToolbar,
.rst__moveHandle,
.rst__toolbarButton {
  display: inline-block;
  vertical-align: middle;
}

.rst__rowContents {
  position: relative;
  height: 100%;
  border: solid #dee2e6 1px;
  border-left: none;
  padding: 0 5px 0 10px;
  border-radius: 2px;
  min-width: 230px;
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
}

.rst__rtl.rst__rowContents {
  border-right: none;
  border-left: solid #dee2e6 1px;
  padding: 0 10px 0 5px;
}

.rst__rowContentsDragDisabled {
  border-left: solid #dee2e6 1px;
}

.rst__rtl.rst__rowContentsDragDisabled {
  border-right: solid #dee2e6 1px;
  border-left: solid #dee2e6 1px;
}

.rst__rowLabel {
  flex: 0 1 auto;
  padding-right: 20px;
}

.rst__rtl.rst__rowLabel {
  padding-left: 20px;
  padding-right: inherit;
}

.rst__rowToolbar {
  flex: 0 1 auto;
  display: flex;
}

.rst__moveHandle,
.rst__loadingHandle {
  height: 100%;
  width: 44px;
  background: #e9ecef url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center;
  border: solid #aaa 1px;
  cursor: move;
  border-radius: 1px;
  z-index: 1;
}

.rst__loadingHandle {
  cursor: default;
  background: #e9ecef;
}

@keyframes pointFade {
  0%, 19.999%, 100% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
}
.rst__loadingCircle {
  width: 80%;
  height: 80%;
  margin: 10%;
  position: relative;
}

.rst__loadingCirclePoint {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.rst__rtl.rst__loadingCirclePoint {
  right: 0;
  left: auto;
  left: initial;
}

.rst__loadingCirclePoint::before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 11%;
  height: 30%;
  background-color: #fff;
  border-radius: 30%;
  animation: pointFade 800ms infinite ease-in-out both;
}

.rst__loadingCirclePoint:nth-of-type(1) {
  transform: rotate(0deg);
}

.rst__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.rst__loadingCirclePoint:nth-of-type(1)::before,
.rst__loadingCirclePoint:nth-of-type(7)::before {
  animation-delay: -800ms;
}

.rst__loadingCirclePoint:nth-of-type(2) {
  transform: rotate(30deg);
}

.rst__loadingCirclePoint:nth-of-type(8) {
  transform: rotate(210deg);
}

.rst__loadingCirclePoint:nth-of-type(2)::before,
.rst__loadingCirclePoint:nth-of-type(8)::before {
  animation-delay: -666ms;
}

.rst__loadingCirclePoint:nth-of-type(3) {
  transform: rotate(60deg);
}

.rst__loadingCirclePoint:nth-of-type(9) {
  transform: rotate(240deg);
}

.rst__loadingCirclePoint:nth-of-type(3)::before,
.rst__loadingCirclePoint:nth-of-type(9)::before {
  animation-delay: -533ms;
}

.rst__loadingCirclePoint:nth-of-type(4) {
  transform: rotate(90deg);
}

.rst__loadingCirclePoint:nth-of-type(10) {
  transform: rotate(270deg);
}

.rst__loadingCirclePoint:nth-of-type(4)::before,
.rst__loadingCirclePoint:nth-of-type(10)::before {
  animation-delay: -400ms;
}

.rst__loadingCirclePoint:nth-of-type(5) {
  transform: rotate(120deg);
}

.rst__loadingCirclePoint:nth-of-type(11) {
  transform: rotate(300deg);
}

.rst__loadingCirclePoint:nth-of-type(5)::before,
.rst__loadingCirclePoint:nth-of-type(11)::before {
  animation-delay: -266ms;
}

.rst__loadingCirclePoint:nth-of-type(6) {
  transform: rotate(150deg);
}

.rst__loadingCirclePoint:nth-of-type(12) {
  transform: rotate(330deg);
}

.rst__loadingCirclePoint:nth-of-type(6)::before,
.rst__loadingCirclePoint:nth-of-type(12)::before {
  animation-delay: -133ms;
}

.rst__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.rst__loadingCirclePoint:nth-of-type(13) {
  transform: rotate(360deg);
}

.rst__loadingCirclePoint:nth-of-type(7)::before,
.rst__loadingCirclePoint:nth-of-type(13)::before {
  animation-delay: 0ms;
}

.rst__rowTitle {
  font-weight: bold;
}

.rst__rowTitleWithSubtitle {
  font-size: 85%;
  display: block;
  height: 0.8rem;
}

.rst__rowSubtitle {
  font-size: 70%;
  line-height: 1;
}

.rst__collapseButton,
.rst__expandButton {
  appearance: none;
  border: none;
  position: absolute;
  border-radius: 100%;
  box-shadow: 0 0 0 1px #000;
  width: 16px;
  height: 16px;
  padding: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.rst__rtl.rst__collapseButton,
.rst__rtl.rst__expandButton {
  transform: translate(50%, -50%);
}

.rst__collapseButton:focus,
.rst__expandButton:focus {
  outline: none;
  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;
}

.rst__collapseButton:hover:not(:active),
.rst__expandButton:hover:not(:active) {
  background-size: 24px;
  height: 20px;
  width: 20px;
}

.rst__collapseButton {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center;
}

.rst__expandButton {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center;
}

/**
 * Line for under a node with children
 */
.rst__lineChildren {
  height: 100%;
  display: inline-block;
  position: absolute;
}

.rst__lineChildren::after {
  content: "";
  position: absolute;
  background-color: black;
  width: 1px;
  left: 50%;
  bottom: 0;
  height: 10px;
}

.rst__rtl.rst__lineChildren::after {
  right: 50%;
  left: auto;
  left: initial;
}

.rst__placeholder {
  position: relative;
  height: 68px;
  max-width: 300px;
  padding: 10px;
}

.rst__placeholder,
.rst__placeholder > * {
  box-sizing: border-box;
}

.rst__placeholder::before {
  border: 3px dashed #e9ecef;
  content: "";
  position: absolute;
  top: 5px;
  right: 5px;
  bottom: 5px;
  left: 5px;
  z-index: -1;
}

/**
 * The outline of where the element will go if dropped, displayed while dragging
 */
.rst__placeholderLandingPad,
.rst__placeholderCancelPad {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rst__placeholderLandingPad *,
.rst__placeholderCancelPad * {
  opacity: 0 !important;
}

.rst__placeholderLandingPad::before,
.rst__placeholderCancelPad::before {
  background-color: lightblue;
  border-color: white;
}

/**
 * Alternate appearance of the landing pad when the dragged location is invalid
 */
.rst__placeholderCancelPad::before {
  background-color: #e6a8ad;
}

/* Collection default theme */
/* Grid default theme */
/* Table default theme */
.ReactVirtualized__Table__headerRow {
  font-weight: 700;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ReactVirtualized__Table__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ReactVirtualized__Table__headerTruncatedText {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ReactVirtualized__Table__headerColumn,
.ReactVirtualized__Table__rowColumn {
  margin-right: 10px;
  min-width: 0px;
}

.ReactVirtualized__Table__rowColumn {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ReactVirtualized__Table__headerColumn:first-of-type,
.ReactVirtualized__Table__rowColumn:first-of-type {
  margin-left: 10px;
}

.ReactVirtualized__Table__sortableHeaderColumn {
  cursor: pointer;
}

.ReactVirtualized__Table__sortableHeaderIconContainer {
  display: flex;
  align-items: center;
}

.ReactVirtualized__Table__sortableHeaderIcon {
  flex: 0 0 24px;
  height: 1em;
  width: 1em;
  fill: currentColor;
}

/* List default theme */
.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}
.ReactTable .-pagination input,
.ReactTable .-pagination select,
.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  display: block;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}
.ReactTable .-pagination input::-ms-expand,
.ReactTable .-pagination select::-ms-expand,
.ReactTable .rt-thead.-filters input::-ms-expand,
.ReactTable .rt-thead.-filters select::-ms-expand {
  background-color: transparent;
  border: 0;
}
.ReactTable .-pagination input:focus,
.ReactTable .-pagination select:focus,
.ReactTable .rt-thead.-filters input:focus,
.ReactTable .rt-thead.-filters select:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(73.6554621849%, 74.8879551821%, 93.9915966387%);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.ReactTable .-pagination input::placeholder,
.ReactTable .-pagination select::placeholder,
.ReactTable .rt-thead.-filters input::placeholder,
.ReactTable .rt-thead.-filters select::placeholder {
  color: #6c757d;
  opacity: 1;
}
.ReactTable .-pagination input:disabled, .ReactTable .-pagination input[readonly],
.ReactTable .-pagination select:disabled,
.ReactTable .-pagination select[readonly],
.ReactTable .rt-thead.-filters input:disabled,
.ReactTable .rt-thead.-filters input[readonly],
.ReactTable .rt-thead.-filters select:disabled,
.ReactTable .rt-thead.-filters select[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
          user-select: none;
}
.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #e9ecef;
}
.ReactTable .rt-thead.-headerGroups .rt-th,
.ReactTable .rt-thead.-headerGroups .rt-td {
  padding: 0.3rem;
  color: #6c757d;
}
.ReactTable .rt-thead.-headerGroups .rt-th:hover,
.ReactTable .rt-thead.-headerGroups .rt-td:hover {
  color: #6c757d;
}
.ReactTable .rt-thead.-headerGroups .rt-th:empty,
.ReactTable .rt-thead.-headerGroups .rt-td:empty {
  padding: 0;
}
.ReactTable .rt-thead.-filters {
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}
.ReactTable .rt-thead.-filters .rt-th {
  border-right: 1px solid #e9ecef;
}
.ReactTable .rt-thead.-filters.-header {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
}
.ReactTable .rt-thead .rt-tr {
  text-align: center;
}
.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  padding: 0.55rem;
  line-height: normal;
  position: relative;
  font-weight: bold;
  border-right: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
  color: #545cd8;
}
.ReactTable .rt-thead .rt-th:hover,
.ReactTable .rt-thead .rt-td:hover {
  color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);
}
.ReactTable .rt-thead .rt-th.-sort-asc,
.ReactTable .rt-thead .rt-td.-sort-asc {
  box-shadow: inset 0 3px 0 0 #545cd8;
}
.ReactTable .rt-thead .rt-th.-sort-desc,
.ReactTable .rt-thead .rt-td.-sort-desc {
  box-shadow: inset 0 -3px 0 0 #545cd8;
}
.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}
.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}
.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}
.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}
.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}
.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}
.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.ReactTable .rt-tbody .rt-tr-group {
  border-bottom: solid 1px #e9ecef;
}
.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}
.ReactTable .rt-tbody .rt-td {
  border-right: 1px solid #e9ecef;
  align-items: center;
  align-content: center;
  display: flex;
}
.ReactTable .rt-tbody .rt-td [contenteditable=true] {
  width: 100%;
  border: 1px solid transparent;
  background: #fff !important;
  border-radius: 0.2rem;
}
.ReactTable .rt-tbody .rt-td [contenteditable=true]:focus {
  padding: 3px 5px;
  border-color: rgb(73.6554621849%, 74.8879551821%, 93.9915966387%);
  outline: none;
}
.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
  text-overflow: clip;
}
.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}
.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0;
  text-overflow: ellipsis;
  padding: 0.55rem;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
}
.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}
.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  color: transparent;
  margin: 0 10px 0 0;
}
.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}
.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}
.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}
.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}
.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid #e9ecef;
}
.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}
.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}
.ReactTable.-fixed .-header {
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);
}
.ReactTable.-fixed .pagination-bottom {
  box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);
}
.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: #e0f3ff;
}
.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.ReactTable .-pagination .-btn {
  appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0.25rem;
  padding: 6px;
  font-size: 1em;
  color: #545cd8;
  background: #f8f9fa;
  transition: all 0.2s ease;
  cursor: pointer;
  outline: none;
  font-weight: bold;
}
.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: default;
}
.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: #545cd8;
  color: #fff;
}
.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}
.ReactTable .-pagination .-center {
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.ReactTable .-pagination .-totalPages {
  padding-left: 5px;
  font-weight: bold;
}
.ReactTable .-pagination .-pageInfo {
  display: inherit;
  margin: 3px 0 3px 10px;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
}
.ReactTable .-pagination .-pageJump {
  display: inline-block;
  margin: 0 5px;
}
.ReactTable .-pagination .-pageJump input {
  width: 70px;
  text-align: center;
}
.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}
.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}
.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}
.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: #545cd8;
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}
.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}
.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}

.table thead th,
.table td {
  vertical-align: middle;
}

.table th .filter {
  margin-top: 0.375rem;
  height: auto;
  padding: 0.3rem 0.5rem;
}

.caret-4-asc,
.caret-4-desc {
  font-family: "Linearicons-Free";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  margin-left: 0.375rem;
}

.table .sortable:hover .caret-4-asc,
.table .sortable:hover .caret-4-desc {
  color: #545cd8;
}

.table-lg th,
.table-lg td {
  padding: 1.1rem 0.825rem;
}

@font-face {
  font-family: "Linearicons-Free";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=lnr-],
[class*=" lnr-"] {
  font-family: "Linearicons-Free";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.lnr-home:before {
  content: "\\e800";
}

.lnr-apartment:before {
  content: "\\e801";
}

.lnr-pencil:before {
  content: "\\e802";
}

.lnr-magic-wand:before {
  content: "\\e803";
}

.lnr-drop:before {
  content: "\\e804";
}

.lnr-lighter:before {
  content: "\\e805";
}

.lnr-poop:before {
  content: "\\e806";
}

.lnr-sun:before {
  content: "\\e807";
}

.lnr-moon:before {
  content: "\\e808";
}

.lnr-cloud:before {
  content: "\\e809";
}

.lnr-cloud-upload:before {
  content: "\\e80a";
}

.lnr-cloud-download:before {
  content: "\\e80b";
}

.lnr-cloud-sync:before {
  content: "\\e80c";
}

.lnr-cloud-check:before {
  content: "\\e80d";
}

.lnr-database:before {
  content: "\\e80e";
}

.lnr-lock:before {
  content: "\\e80f";
}

.lnr-cog:before {
  content: "\\e810";
}

.lnr-trash:before {
  content: "\\e811";
}

.lnr-dice:before {
  content: "\\e812";
}

.lnr-heart:before {
  content: "\\e813";
}

.lnr-star:before {
  content: "\\e814";
}

.lnr-star-half:before {
  content: "\\e815";
}

.lnr-star-empty:before {
  content: "\\e816";
}

.lnr-flag:before {
  content: "\\e817";
}

.lnr-envelope:before {
  content: "\\e818";
}

.lnr-paperclip:before {
  content: "\\e819";
}

.lnr-inbox:before {
  content: "\\e81a";
}

.lnr-eye:before {
  content: "\\e81b";
}

.lnr-printer:before {
  content: "\\e81c";
}

.lnr-file-empty:before {
  content: "\\e81d";
}

.lnr-file-add:before {
  content: "\\e81e";
}

.lnr-enter:before {
  content: "\\e81f";
}

.lnr-exit:before {
  content: "\\e820";
}

.lnr-graduation-hat:before {
  content: "\\e821";
}

.lnr-license:before {
  content: "\\e822";
}

.lnr-music-note:before {
  content: "\\e823";
}

.lnr-film-play:before {
  content: "\\e824";
}

.lnr-camera-video:before {
  content: "\\e825";
}

.lnr-camera:before {
  content: "\\e826";
}

.lnr-picture:before {
  content: "\\e827";
}

.lnr-book:before {
  content: "\\e828";
}

.lnr-bookmark:before {
  content: "\\e829";
}

.lnr-user:before {
  content: "\\e82a";
}

.lnr-users:before {
  content: "\\e82b";
}

.lnr-shirt:before {
  content: "\\e82c";
}

.lnr-store:before {
  content: "\\e82d";
}

.lnr-cart:before {
  content: "\\e82e";
}

.lnr-tag:before {
  content: "\\e82f";
}

.lnr-phone-handset:before {
  content: "\\e830";
}

.lnr-phone:before {
  content: "\\e831";
}

.lnr-pushpin:before {
  content: "\\e832";
}

.lnr-map-marker:before {
  content: "\\e833";
}

.lnr-map:before {
  content: "\\e834";
}

.lnr-location:before {
  content: "\\e835";
}

.lnr-calendar-full:before {
  content: "\\e836";
}

.lnr-keyboard:before {
  content: "\\e837";
}

.lnr-spell-check:before {
  content: "\\e838";
}

.lnr-screen:before {
  content: "\\e839";
}

.lnr-smartphone:before {
  content: "\\e83a";
}

.lnr-tablet:before {
  content: "\\e83b";
}

.lnr-laptop:before {
  content: "\\e83c";
}

.lnr-laptop-phone:before {
  content: "\\e83d";
}

.lnr-power-switch:before {
  content: "\\e83e";
}

.lnr-bubble:before {
  content: "\\e83f";
}

.lnr-heart-pulse:before {
  content: "\\e840";
}

.lnr-construction:before {
  content: "\\e841";
}

.lnr-pie-chart:before {
  content: "\\e842";
}

.lnr-chart-bars:before {
  content: "\\e843";
}

.lnr-gift:before {
  content: "\\e844";
}

.lnr-diamond:before {
  content: "\\e845";
}

.lnr-linearicons:before {
  content: "\\e846";
}

.lnr-dinner:before {
  content: "\\e847";
}

.lnr-coffee-cup:before {
  content: "\\e848";
}

.lnr-leaf:before {
  content: "\\e849";
}

.lnr-paw:before {
  content: "\\e84a";
}

.lnr-rocket:before {
  content: "\\e84b";
}

.lnr-briefcase:before {
  content: "\\e84c";
}

.lnr-bus:before {
  content: "\\e84d";
}

.lnr-car:before {
  content: "\\e84e";
}

.lnr-train:before {
  content: "\\e84f";
}

.lnr-bicycle:before {
  content: "\\e850";
}

.lnr-wheelchair:before {
  content: "\\e851";
}

.lnr-select:before {
  content: "\\e852";
}

.lnr-earth:before {
  content: "\\e853";
}

.lnr-smile:before {
  content: "\\e854";
}

.lnr-sad:before {
  content: "\\e855";
}

.lnr-neutral:before {
  content: "\\e856";
}

.lnr-mustache:before {
  content: "\\e857";
}

.lnr-alarm:before {
  content: "\\e858";
}

.lnr-bullhorn:before {
  content: "\\e859";
}

.lnr-volume-high:before {
  content: "\\e85a";
}

.lnr-volume-medium:before {
  content: "\\e85b";
}

.lnr-volume-low:before {
  content: "\\e85c";
}

.lnr-volume:before {
  content: "\\e85d";
}

.lnr-mic:before {
  content: "\\e85e";
}

.lnr-hourglass:before {
  content: "\\e85f";
}

.lnr-undo:before {
  content: "\\e860";
}

.lnr-redo:before {
  content: "\\e861";
}

.lnr-sync:before {
  content: "\\e862";
}

.lnr-history:before {
  content: "\\e863";
}

.lnr-clock:before {
  content: "\\e864";
}

.lnr-download:before {
  content: "\\e865";
}

.lnr-upload:before {
  content: "\\e866";
}

.lnr-enter-down:before {
  content: "\\e867";
}

.lnr-exit-up:before {
  content: "\\e868";
}

.lnr-bug:before {
  content: "\\e869";
}

.lnr-code:before {
  content: "\\e86a";
}

.lnr-link:before {
  content: "\\e86b";
}

.lnr-unlink:before {
  content: "\\e86c";
}

.lnr-thumbs-up:before {
  content: "\\e86d";
}

.lnr-thumbs-down:before {
  content: "\\e86e";
}

.lnr-magnifier:before {
  content: "\\e86f";
}

.lnr-cross:before {
  content: "\\e870";
}

.lnr-menu:before {
  content: "\\e871";
}

.lnr-list:before {
  content: "\\e872";
}

.lnr-chevron-up:before, .caret-4-asc:before {
  content: "\\e873";
}

.lnr-chevron-down:before, .caret-4-desc:before {
  content: "\\e874";
}

.lnr-chevron-left:before {
  content: "\\e875";
}

.lnr-chevron-right:before {
  content: "\\e876";
}

.lnr-arrow-up:before {
  content: "\\e877";
}

.lnr-arrow-down:before {
  content: "\\e878";
}

.lnr-arrow-left:before {
  content: "\\e879";
}

.lnr-arrow-right:before {
  content: "\\e87a";
}

.lnr-move:before {
  content: "\\e87b";
}

.lnr-warning:before {
  content: "\\e87c";
}

.lnr-question-circle:before {
  content: "\\e87d";
}

.lnr-menu-circle:before {
  content: "\\e87e";
}

.lnr-checkmark-circle:before, .forms-wizard li.form-wizard-step-done em:before {
  content: "\\e87f";
}

.lnr-cross-circle:before {
  content: "\\e880";
}

.lnr-plus-circle:before {
  content: "\\e881";
}

.lnr-circle-minus:before {
  content: "\\e882";
}

.lnr-arrow-up-circle:before {
  content: "\\e883";
}

.lnr-arrow-down-circle:before {
  content: "\\e884";
}

.lnr-arrow-left-circle:before {
  content: "\\e885";
}

.lnr-arrow-right-circle:before {
  content: "\\e886";
}

.lnr-chevron-up-circle:before {
  content: "\\e887";
}

.lnr-chevron-down-circle:before {
  content: "\\e888";
}

.lnr-chevron-left-circle:before {
  content: "\\e889";
}

.lnr-chevron-right-circle:before {
  content: "\\e88a";
}

.lnr-crop:before {
  content: "\\e88b";
}

.lnr-frame-expand:before {
  content: "\\e88c";
}

.lnr-frame-contract:before {
  content: "\\e88d";
}

.lnr-layers:before {
  content: "\\e88e";
}

.lnr-funnel:before {
  content: "\\e88f";
}

.lnr-text-format:before {
  content: "\\e890";
}

.lnr-text-format-remove:before {
  content: "\\e891";
}

.lnr-text-size:before {
  content: "\\e892";
}

.lnr-bold:before {
  content: "\\e893";
}

.lnr-italic:before {
  content: "\\e894";
}

.lnr-underline:before {
  content: "\\e895";
}

.lnr-strikethrough:before {
  content: "\\e896";
}

.lnr-highlight:before {
  content: "\\e897";
}

.lnr-text-align-left:before {
  content: "\\e898";
}

.lnr-text-align-center:before {
  content: "\\e899";
}

.lnr-text-align-right:before {
  content: "\\e89a";
}

.lnr-text-align-justify:before {
  content: "\\e89b";
}

.lnr-line-spacing:before {
  content: "\\e89c";
}

.lnr-indent-increase:before {
  content: "\\e89d";
}

.lnr-indent-decrease:before {
  content: "\\e89e";
}

.lnr-pilcrow:before {
  content: "\\e89f";
}

.lnr-direction-ltr:before {
  content: "\\e8a0";
}

.lnr-direction-rtl:before {
  content: "\\e8a1";
}

.lnr-page-break:before {
  content: "\\e8a2";
}

.lnr-sort-alpha-asc:before {
  content: "\\e8a3";
}

.lnr-sort-amount-asc:before {
  content: "\\e8a4";
}

.lnr-hand:before {
  content: "\\e8a5";
}

.lnr-pointer-up:before {
  content: "\\e8a6";
}

.lnr-pointer-right:before {
  content: "\\e8a7";
}

.lnr-pointer-down:before {
  content: "\\e8a8";
}

.lnr-pointer-left:before {
  content: "\\e8a9";
}

/*
*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set
*/
@font-face {
  font-family: "Pe-icon-7-stroke";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=pe-7s-], [class*=" pe-7s-"] {
  display: inline-block;
  font-family: "Pe-icon-7-stroke";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* HELPER CLASS
 * -------------------------- */
/* FA based classes */
/*! Modified from font-awesome helper CSS classes - PIXEDEN
 *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (CSS: MIT License)
 */
/* makes the font 33% larger relative to the icon container */
.pe-lg {
  font-size: 1.1704rem;
  line-height: 0.75em;
  vertical-align: -15%;
}

.pe-2x {
  font-size: 1.76rem;
}

.pe-3x {
  font-size: 2.64rem;
}

.pe-4x {
  font-size: 3.52rem;
}

.pe-5x {
  font-size: 4.4rem;
}

.pe-fw {
  width: 1.2857142857em;
  text-align: center;
}

.pe-ul {
  padding-left: 0;
  margin-left: 2.1428571429em;
  list-style-type: none;
}
.pe-ul > li {
  position: relative;
}

.pe-li {
  position: absolute;
  left: -2.1428571429em;
  width: 2.1428571429em;
  top: 0.1428571429em;
  text-align: center;
}
.pe-li.pe-lg {
  left: -1.8571428571em;
}

.pe-border {
  padding: 0.2em 0.25em 0.15em;
  border: solid 0.08em #eeeeee;
  border-radius: 0.1em;
}

.pull-right {
  float: right;
}

.pe.pull-left {
  float: left;
  margin-right: 0.3em;
  margin-left: 0.3em;
}

.pe-spin {
  animation: spin 2s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.pe-rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.pe-rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.pe-rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.pe-flip-horizontal {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);
  transform: scale(-1, 1);
}

.pe-flip-vertical {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);
  transform: scale(1, -1);
}

.pe-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.pe-stack-1x,
.pe-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}

.pe-stack-1x {
  line-height: inherit;
}

.pe-stack-2x {
  font-size: 2em;
}

.pe-inverse {
  color: #ffffff;
}

/* Custom classes / mods - PIXEDEN */
.pe-va {
  vertical-align: middle;
}

.pe-border {
  border: solid 0.08em #eaeaea;
}

.pe-7s-album:before {
  content: "\\e6aa";
}

.pe-7s-arc:before {
  content: "\\e6ab";
}

.pe-7s-back-2:before {
  content: "\\e6ac";
}

.pe-7s-bandaid:before {
  content: "\\e6ad";
}

.pe-7s-car:before {
  content: "\\e6ae";
}

.pe-7s-diamond:before {
  content: "\\e6af";
}

.pe-7s-door-lock:before {
  content: "\\e6b0";
}

.pe-7s-eyedropper:before {
  content: "\\e6b1";
}

.pe-7s-female:before {
  content: "\\e6b2";
}

.pe-7s-gym:before {
  content: "\\e6b3";
}

.pe-7s-hammer:before {
  content: "\\e6b4";
}

.pe-7s-headphones:before {
  content: "\\e6b5";
}

.pe-7s-helm:before {
  content: "\\e6b6";
}

.pe-7s-hourglass:before {
  content: "\\e6b7";
}

.pe-7s-leaf:before {
  content: "\\e6b8";
}

.pe-7s-magic-wand:before {
  content: "\\e6b9";
}

.pe-7s-male:before {
  content: "\\e6ba";
}

.pe-7s-map-2:before {
  content: "\\e6bb";
}

.pe-7s-next-2:before {
  content: "\\e6bc";
}

.pe-7s-paint-bucket:before {
  content: "\\e6bd";
}

.pe-7s-pendrive:before {
  content: "\\e6be";
}

.pe-7s-photo:before {
  content: "\\e6bf";
}

.pe-7s-piggy:before {
  content: "\\e6c0";
}

.pe-7s-plugin:before {
  content: "\\e6c1";
}

.pe-7s-refresh-2:before {
  content: "\\e6c2";
}

.pe-7s-rocket:before {
  content: "\\e6c3";
}

.pe-7s-settings:before {
  content: "\\e6c4";
}

.pe-7s-shield:before {
  content: "\\e6c5";
}

.pe-7s-smile:before {
  content: "\\e6c6";
}

.pe-7s-usb:before {
  content: "\\e6c7";
}

.pe-7s-vector:before {
  content: "\\e6c8";
}

.pe-7s-wine:before {
  content: "\\e6c9";
}

.pe-7s-cloud-upload:before {
  content: "\\e68a";
}

.pe-7s-cash:before {
  content: "\\e68c";
}

.pe-7s-close:before {
  content: "\\e680";
}

.pe-7s-bluetooth:before {
  content: "\\e68d";
}

.pe-7s-cloud-download:before {
  content: "\\e68b";
}

.pe-7s-way:before {
  content: "\\e68e";
}

.pe-7s-close-circle:before {
  content: "\\e681";
}

.pe-7s-id:before {
  content: "\\e68f";
}

.pe-7s-angle-up:before {
  content: "\\e682";
}

.pe-7s-wristwatch:before {
  content: "\\e690";
}

.pe-7s-angle-up-circle:before {
  content: "\\e683";
}

.pe-7s-world:before {
  content: "\\e691";
}

.pe-7s-angle-right:before {
  content: "\\e684";
}

.pe-7s-volume:before {
  content: "\\e692";
}

.pe-7s-angle-right-circle:before {
  content: "\\e685";
}

.pe-7s-users:before {
  content: "\\e693";
}

.pe-7s-angle-left:before {
  content: "\\e686";
}

.pe-7s-user-female:before {
  content: "\\e694";
}

.pe-7s-angle-left-circle:before {
  content: "\\e687";
}

.pe-7s-up-arrow:before {
  content: "\\e695";
}

.pe-7s-angle-down:before {
  content: "\\e688";
}

.pe-7s-switch:before {
  content: "\\e696";
}

.pe-7s-angle-down-circle:before {
  content: "\\e689";
}

.pe-7s-scissors:before {
  content: "\\e697";
}

.pe-7s-wallet:before {
  content: "\\e600";
}

.pe-7s-safe:before {
  content: "\\e698";
}

.pe-7s-volume2:before {
  content: "\\e601";
}

.pe-7s-volume1:before {
  content: "\\e602";
}

.pe-7s-voicemail:before {
  content: "\\e603";
}

.pe-7s-video:before {
  content: "\\e604";
}

.pe-7s-user:before {
  content: "\\e605";
}

.pe-7s-upload:before {
  content: "\\e606";
}

.pe-7s-unlock:before {
  content: "\\e607";
}

.pe-7s-umbrella:before {
  content: "\\e608";
}

.pe-7s-trash:before {
  content: "\\e609";
}

.pe-7s-tools:before {
  content: "\\e60a";
}

.pe-7s-timer:before {
  content: "\\e60b";
}

.pe-7s-ticket:before {
  content: "\\e60c";
}

.pe-7s-target:before {
  content: "\\e60d";
}

.pe-7s-sun:before {
  content: "\\e60e";
}

.pe-7s-study:before {
  content: "\\e60f";
}

.pe-7s-stopwatch:before {
  content: "\\e610";
}

.pe-7s-star:before {
  content: "\\e611";
}

.pe-7s-speaker:before {
  content: "\\e612";
}

.pe-7s-signal:before {
  content: "\\e613";
}

.pe-7s-shuffle:before {
  content: "\\e614";
}

.pe-7s-shopbag:before {
  content: "\\e615";
}

.pe-7s-share:before {
  content: "\\e616";
}

.pe-7s-server:before {
  content: "\\e617";
}

.pe-7s-search:before {
  content: "\\e618";
}

.pe-7s-film:before {
  content: "\\e6a5";
}

.pe-7s-science:before {
  content: "\\e619";
}

.pe-7s-disk:before {
  content: "\\e6a6";
}

.pe-7s-ribbon:before {
  content: "\\e61a";
}

.pe-7s-repeat:before {
  content: "\\e61b";
}

.pe-7s-refresh:before {
  content: "\\e61c";
}

.pe-7s-add-user:before {
  content: "\\e6a9";
}

.pe-7s-refresh-cloud:before {
  content: "\\e61d";
}

.pe-7s-paperclip:before {
  content: "\\e69c";
}

.pe-7s-radio:before {
  content: "\\e61e";
}

.pe-7s-note2:before {
  content: "\\e69d";
}

.pe-7s-print:before {
  content: "\\e61f";
}

.pe-7s-network:before {
  content: "\\e69e";
}

.pe-7s-prev:before {
  content: "\\e620";
}

.pe-7s-mute:before {
  content: "\\e69f";
}

.pe-7s-power:before {
  content: "\\e621";
}

.pe-7s-medal:before {
  content: "\\e6a0";
}

.pe-7s-portfolio:before {
  content: "\\e622";
}

.pe-7s-like2:before {
  content: "\\e6a1";
}

.pe-7s-plus:before {
  content: "\\e623";
}

.pe-7s-left-arrow:before {
  content: "\\e6a2";
}

.pe-7s-play:before {
  content: "\\e624";
}

.pe-7s-key:before {
  content: "\\e6a3";
}

.pe-7s-plane:before {
  content: "\\e625";
}

.pe-7s-joy:before {
  content: "\\e6a4";
}

.pe-7s-photo-gallery:before {
  content: "\\e626";
}

.pe-7s-pin:before {
  content: "\\e69b";
}

.pe-7s-phone:before {
  content: "\\e627";
}

.pe-7s-plug:before {
  content: "\\e69a";
}

.pe-7s-pen:before {
  content: "\\e628";
}

.pe-7s-right-arrow:before {
  content: "\\e699";
}

.pe-7s-paper-plane:before {
  content: "\\e629";
}

.pe-7s-delete-user:before {
  content: "\\e6a7";
}

.pe-7s-paint:before {
  content: "\\e62a";
}

.pe-7s-bottom-arrow:before {
  content: "\\e6a8";
}

.pe-7s-notebook:before {
  content: "\\e62b";
}

.pe-7s-note:before {
  content: "\\e62c";
}

.pe-7s-next:before {
  content: "\\e62d";
}

.pe-7s-news-paper:before {
  content: "\\e62e";
}

.pe-7s-musiclist:before {
  content: "\\e62f";
}

.pe-7s-music:before {
  content: "\\e630";
}

.pe-7s-mouse:before {
  content: "\\e631";
}

.pe-7s-more:before {
  content: "\\e632";
}

.pe-7s-moon:before {
  content: "\\e633";
}

.pe-7s-monitor:before {
  content: "\\e634";
}

.pe-7s-micro:before {
  content: "\\e635";
}

.pe-7s-menu:before {
  content: "\\e636";
}

.pe-7s-map:before {
  content: "\\e637";
}

.pe-7s-map-marker:before {
  content: "\\e638";
}

.pe-7s-mail:before {
  content: "\\e639";
}

.pe-7s-mail-open:before {
  content: "\\e63a";
}

.pe-7s-mail-open-file:before {
  content: "\\e63b";
}

.pe-7s-magnet:before {
  content: "\\e63c";
}

.pe-7s-loop:before {
  content: "\\e63d";
}

.pe-7s-look:before {
  content: "\\e63e";
}

.pe-7s-lock:before {
  content: "\\e63f";
}

.pe-7s-lintern:before {
  content: "\\e640";
}

.pe-7s-link:before {
  content: "\\e641";
}

.pe-7s-like:before {
  content: "\\e642";
}

.pe-7s-light:before {
  content: "\\e643";
}

.pe-7s-less:before {
  content: "\\e644";
}

.pe-7s-keypad:before {
  content: "\\e645";
}

.pe-7s-junk:before {
  content: "\\e646";
}

.pe-7s-info:before {
  content: "\\e647";
}

.pe-7s-home:before {
  content: "\\e648";
}

.pe-7s-help2:before {
  content: "\\e649";
}

.pe-7s-help1:before {
  content: "\\e64a";
}

.pe-7s-graph3:before {
  content: "\\e64b";
}

.pe-7s-graph2:before {
  content: "\\e64c";
}

.pe-7s-graph1:before {
  content: "\\e64d";
}

.pe-7s-graph:before {
  content: "\\e64e";
}

.pe-7s-global:before {
  content: "\\e64f";
}

.pe-7s-gleam:before {
  content: "\\e650";
}

.pe-7s-glasses:before {
  content: "\\e651";
}

.pe-7s-gift:before {
  content: "\\e652";
}

.pe-7s-folder:before {
  content: "\\e653";
}

.pe-7s-flag:before {
  content: "\\e654";
}

.pe-7s-filter:before {
  content: "\\e655";
}

.pe-7s-file:before {
  content: "\\e656";
}

.pe-7s-expand1:before {
  content: "\\e657";
}

.pe-7s-exapnd2:before {
  content: "\\e658";
}

.pe-7s-edit:before {
  content: "\\e659";
}

.pe-7s-drop:before {
  content: "\\e65a";
}

.pe-7s-drawer:before {
  content: "\\e65b";
}

.pe-7s-download:before {
  content: "\\e65c";
}

.pe-7s-display2:before {
  content: "\\e65d";
}

.pe-7s-display1:before {
  content: "\\e65e";
}

.pe-7s-diskette:before {
  content: "\\e65f";
}

.pe-7s-date:before {
  content: "\\e660";
}

.pe-7s-cup:before {
  content: "\\e661";
}

.pe-7s-culture:before {
  content: "\\e662";
}

.pe-7s-crop:before {
  content: "\\e663";
}

.pe-7s-credit:before {
  content: "\\e664";
}

.pe-7s-copy-file:before {
  content: "\\e665";
}

.pe-7s-config:before {
  content: "\\e666";
}

.pe-7s-compass:before {
  content: "\\e667";
}

.pe-7s-comment:before {
  content: "\\e668";
}

.pe-7s-coffee:before {
  content: "\\e669";
}

.pe-7s-cloud:before {
  content: "\\e66a";
}

.pe-7s-clock:before {
  content: "\\e66b";
}

.pe-7s-check:before {
  content: "\\e66c";
}

.pe-7s-chat:before {
  content: "\\e66d";
}

.pe-7s-cart:before {
  content: "\\e66e";
}

.pe-7s-camera:before {
  content: "\\e66f";
}

.pe-7s-call:before {
  content: "\\e670";
}

.pe-7s-calculator:before {
  content: "\\e671";
}

.pe-7s-browser:before {
  content: "\\e672";
}

.pe-7s-box2:before {
  content: "\\e673";
}

.pe-7s-box1:before {
  content: "\\e674";
}

.pe-7s-bookmarks:before {
  content: "\\e675";
}

.pe-7s-bicycle:before {
  content: "\\e676";
}

.pe-7s-bell:before {
  content: "\\e677";
}

.pe-7s-battery:before {
  content: "\\e678";
}

.pe-7s-ball:before {
  content: "\\e679";
}

.pe-7s-back:before {
  content: "\\e67a";
}

.pe-7s-attention:before {
  content: "\\e67b";
}

.pe-7s-anchor:before {
  content: "\\e67c";
}

.pe-7s-albums:before {
  content: "\\e67d";
}

.pe-7s-alarm:before {
  content: "\\e67e";
}

.pe-7s-airplay:before {
  content: "\\e67f";
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -6px;
  position: absolute;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  box-sizing: content-box;
  position: absolute;
  border: 6px solid transparent;
  height: 0;
  width: 1px;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  content: "";
  z-index: -1;
  border-width: 6px;
  left: -6px;
  border-bottom-color: #dee2e6;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  top: 0;
  margin-top: -6px;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-top: none;
  border-bottom-color: #fff;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #dee2e6;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  bottom: 0;
  margin-bottom: -6px;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  border-bottom: none;
  border-top-color: #fff;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  bottom: -1px;
  border-top-color: #dee2e6;
}

.react-datepicker-wrapper {
  display: block;
  z-index: 100;
}

.react-datepicker {
  background-color: #fff;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  display: inline-block;
  position: relative;
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}
.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}
.react-datepicker--time-only .react-datepicker__time {
  border-radius: 0.3rem;
}
.react-datepicker--time-only .react-datepicker__time-box {
  border-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 102;
}
.react-datepicker-popper[data-placement^=bottom] {
  margin-top: 8px;
}
.react-datepicker-popper[data-placement^=top] {
  margin-bottom: 8px;
}
.react-datepicker-popper[data-placement^=right] {
  margin-left: 6px;
}
.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}
.react-datepicker-popper[data-placement^=left] {
  margin-right: 6px;
}
.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  padding-top: 10px;
  position: relative;
}
.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header {
  margin-top: 0;
  color: #343a40;
  font-weight: bold;
  font-size: 0.968rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  background: none;
  line-height: 2rem;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 15px;
  padding: 0;
  border: 0.35rem solid transparent;
  z-index: 1;
  height: 10px;
  width: 10px;
  text-indent: -999em;
  overflow: hidden;
}
.react-datepicker__navigation--previous {
  left: 10px;
  border-right-color: #ced4da;
}
.react-datepicker__navigation--previous:hover {
  border-right-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
}
.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(75.0866393069%, 78.137254902%, 81.187870497%);
  cursor: default;
}
.react-datepicker__navigation--next {
  right: 10px;
  border-left-color: #ced4da;
}
.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 80px;
}
.react-datepicker__navigation--next:hover {
  border-left-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
}
.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(75.0866393069%, 78.137254902%, 81.187870497%);
  cursor: default;
}
.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__navigation--years-previous {
  top: 4px;
  border-top-color: #ced4da;
}
.react-datepicker__navigation--years-previous:hover {
  border-top-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
}
.react-datepicker__navigation--years-upcoming {
  top: -4px;
  border-bottom-color: #ced4da;
}
.react-datepicker__navigation--years-upcoming:hover {
  border-bottom-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__month {
  margin: 0.5rem;
  text-align: center;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #dee2e6;
  width: 120px;
}
.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -122px;
  top: 0;
}
.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 120px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  padding: 0;
  height: calc(195px + 2rem / 2);
  overflow-y: scroll;
  width: 100%;
  box-sizing: content-box;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  padding: 5px 10px;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #e0f3ff;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #545cd8;
  color: #fff;
  font-weight: bold;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #545cd8;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ced4da;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ced4da;
  display: inline-block;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.25rem;
  background-color: #fff;
}

.react-datepicker__day-names {
  background: #f8f9fa;
  border-top: #dee2e6 solid 1px;
  margin-top: 10px;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #495057;
  display: inline-block;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__day {
  cursor: pointer;
  border-radius: 0.25rem;
}
.react-datepicker__day:hover {
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--today {
  font-weight: bold;
}
.react-datepicker__day--highlighted {
  border-radius: 0.25rem;
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--highlighted:hover {
  background-color: rgb(24.7983193277%, 28.3165266106%, 82.8487394958%);
}
.react-datepicker__day--highlighted-custom-1 {
  color: #f7b924;
}
.react-datepicker__day--highlighted-custom-2 {
  color: #444054;
}
.react-datepicker__day--selected {
  background-color: #3ac47d;
  color: #fff;
}
.react-datepicker__day--selected:hover {
  background-color: #3ac47d;
  color: #fff;
}
.react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range {
  background-color: #e0f3ff;
  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);
}
.react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover {
  background-color: #e0f3ff;
  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);
}
.react-datepicker__day--keyboard-selected {
  border-radius: 0.25rem;
  background-color: rgb(37.9651073028%, 81.6427358345%, 59.1709124595%);
  color: #fff;
}
.react-datepicker__day--keyboard-selected:hover {
  background-color: rgb(20.4616334723%, 69.146209665%, 44.0983480006%);
}
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
  background-color: #e0f3ff;
}
.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {
  background-color: #3ac47d;
  color: #fff;
}
.react-datepicker__day--disabled {
  cursor: default;
  color: #ced4da;
}
.react-datepicker__day--disabled:hover {
  background-color: transparent;
  color: #ced4da;
}

.react-datepicker__day--selecting-range-start,
.react-datepicker__day--selecting-range-end {
  background-color: #3ac47d !important;
  color: #fff !important;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}
.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  border-top-color: #ced4da;
  float: right;
  margin-left: 20px;
  top: 8px;
  position: relative;
  border-width: 0.35rem;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #fff;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
}
.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}
.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ced4da;
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
}
.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
  vertical-align: middle;
  position: absolute;
  height: 16px;
  width: 16px;
  top: 25%;
  right: 7px;
}
.react-datepicker__close-icon::after {
  background-color: #545cd8;
  border-radius: 50%;
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  content: "×";
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 1;
  margin: -8px auto 0;
  padding: 2px;
  position: absolute;
  right: 0px;
  text-align: center;
}

.react-datepicker__today-button {
  background: #fff;
  border-top: 1px solid #dee2e6;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 1040;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
}
.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}
@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.584rem;
}
.react-datepicker__portal .react-datepicker__navigation {
  border: 0.63rem solid transparent;
  margin-top: 3px;
}
.react-datepicker__portal .react-datepicker__navigation--previous {
  border-right-color: #545cd8;
}
.react-datepicker__portal .react-datepicker__navigation--previous:hover {
  border-right-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
}
.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(75.0866393069%, 78.137254902%, 81.187870497%);
  cursor: default;
}
.react-datepicker__portal .react-datepicker__navigation--next {
  border-left-color: #545cd8;
}
.react-datepicker__portal .react-datepicker__navigation--next:hover {
  border-left-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);
}
.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(75.0866393069%, 78.137254902%, 81.187870497%);
  cursor: default;
}

.rangeButtonSelectedStyle {
  background: #545cd8 !important;
}

.rangebuttonstyle {
  outline: none !important;
  color: #545cd8 !important;
}

.rc-slider-tooltip {
  z-index: 555;
}

.rc-tooltip.rc-tooltip-zoom-enter,
.rc-tooltip.rc-tooltip-zoom-leave {
  display: block;
}

.rc-tooltip-zoom-enter,
.rc-tooltip-zoom-appear {
  opacity: 0;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
  animation-play-state: paused;
}

.rc-tooltip-zoom-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);
  animation-play-state: paused;
}

.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,
.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {
  animation-name: rcToolTipZoomIn;
  animation-play-state: running;
}

.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {
  animation-name: rcToolTipZoomOut;
  animation-play-state: running;
}

@keyframes rcToolTipZoomIn {
  0% {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(0, 0);
  }
  100% {
    opacity: 1;
    transform-origin: 50% 50%;
    transform: scale(1, 1);
  }
}
@keyframes rcToolTipZoomOut {
  0% {
    opacity: 1;
    transform-origin: 50% 50%;
    transform: scale(1, 1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(0, 0);
  }
}
.rc-tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  visibility: visible;
  font-size: 12px;
  line-height: 1.5;
  opacity: 0.9;
}

.rc-tooltip-hidden {
  display: none;
}

.rc-tooltip-placement-top,
.rc-tooltip-placement-topLeft,
.rc-tooltip-placement-topRight {
  padding: 5px 0 9px 0;
}

.rc-tooltip-placement-right,
.rc-tooltip-placement-rightTop,
.rc-tooltip-placement-rightBottom {
  padding: 0 5px 0 9px;
}

.rc-tooltip-placement-bottom,
.rc-tooltip-placement-bottomLeft,
.rc-tooltip-placement-bottomRight {
  padding: 9px 0 5px 0;
}

.rc-tooltip-placement-left,
.rc-tooltip-placement-leftTop,
.rc-tooltip-placement-leftBottom {
  padding: 0 9px 0 5px;
}

.rc-tooltip-inner {
  padding: 12px 14px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  background-color: #343a40;
  border-radius: 6px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);
  min-height: 34px;
  font-weight: bold;
}

.rc-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.rc-tooltip-placement-top .rc-tooltip-arrow,
.rc-tooltip-placement-topLeft .rc-tooltip-arrow,
.rc-tooltip-placement-topRight .rc-tooltip-arrow {
  bottom: 4px;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #343a40;
}

.rc-tooltip-placement-top .rc-tooltip-arrow {
  left: 50%;
}

.rc-tooltip-placement-topLeft .rc-tooltip-arrow {
  left: 15%;
}

.rc-tooltip-placement-topRight .rc-tooltip-arrow {
  right: 15%;
}

.rc-tooltip-placement-right .rc-tooltip-arrow,
.rc-tooltip-placement-rightTop .rc-tooltip-arrow,
.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
  left: 4px;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #343a40;
}

.rc-tooltip-placement-right .rc-tooltip-arrow {
  top: 50%;
}

.rc-tooltip-placement-rightTop .rc-tooltip-arrow {
  top: 15%;
  margin-top: 0;
}

.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
  bottom: 15%;
}

.rc-tooltip-placement-left .rc-tooltip-arrow,
.rc-tooltip-placement-leftTop .rc-tooltip-arrow,
.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
  right: 4px;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #343a40;
}

.rc-tooltip-placement-left .rc-tooltip-arrow {
  top: 50%;
}

.rc-tooltip-placement-leftTop .rc-tooltip-arrow {
  top: 15%;
  margin-top: 0;
}

.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
  bottom: 15%;
}

.rc-tooltip-placement-bottom .rc-tooltip-arrow,
.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,
.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {
  top: 4px;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #343a40;
}

.rc-tooltip-placement-bottom .rc-tooltip-arrow {
  left: 50%;
}

.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {
  left: 15%;
}

.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {
  right: 15%;
}

.rc-slider {
  position: relative;
  height: 20px;
  padding: 8px 0 0;
  width: 100%;
  border-radius: 0.25rem;
  touch-action: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.rc-slider-rail {
  position: absolute;
  width: 100%;
  background-color: #e9ecef;
  height: 4px;
  border-radius: 0.25rem;
}

.rc-slider-track {
  position: absolute;
  left: 0;
  height: 4px;
  border-radius: 0.25rem;
  background-color: #545cd8;
}

.rc-slider-handle {
  position: absolute;
  margin-left: -8px;
  margin-top: -6px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  cursor: grab;
  border-radius: 50%;
  border: solid 2px #545cd8;
  background-color: #fff;
  touch-action: pan-x;
  transition: box-shadow 200ms;
}
.rc-slider-handle:focus {
  outline: none;
}
.rc-slider-handle:focus, .rc-slider-handle:active, .rc-slider-handle:hover {
  border-color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);
}
.rc-slider-handle:active {
  cursor: grabbing;
}

.rc-slider-mark {
  position: absolute;
  top: 18px;
  left: 0;
  width: 100%;
  font-size: 12px;
}

.rc-slider-mark-text {
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  color: #6c757d;
}

.rc-slider-mark-text-active {
  color: #343a40;
}

.rc-slider-step {
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
}

.rc-slider-dot {
  position: absolute;
  bottom: -2px;
  margin-left: -4px;
  width: 8px;
  height: 8px;
  border: 2px solid #dee2e6;
  background-color: #fff;
  cursor: pointer;
  border-radius: 50%;
  vertical-align: middle;
}

.rc-slider-dot-active {
  border-color: #545cd8;
}

.rc-slider-disabled {
  background-color: #e9ecef;
}

.rc-slider-disabled .rc-slider-track {
  background-color: #ced4da;
}

.rc-slider-disabled .rc-slider-handle,
.rc-slider-disabled .rc-slider-dot {
  border-color: #ced4da;
  box-shadow: none;
  background-color: #fff;
  cursor: not-allowed;
}

.rc-slider-disabled .rc-slider-mark-text,
.rc-slider-disabled .rc-slider-dot {
  cursor: not-allowed !important;
}

.rc-slider-vertical {
  width: 14px;
  height: 100%;
  padding: 0 5px;
}

.rc-slider-vertical .rc-slider-rail {
  height: 100%;
  width: 4px;
}

.rc-slider-vertical .rc-slider-track {
  left: 5px;
  bottom: 0;
  width: 4px;
}

.rc-slider-vertical .rc-slider-handle {
  margin-left: -6px;
  margin-bottom: -7px;
  touch-action: pan-y;
}

.rc-slider-vertical .rc-slider-mark {
  top: 0;
  left: 18px;
  height: 100%;
}

.rc-slider-vertical .rc-slider-step {
  height: 100%;
  width: 4px;
}

.rc-slider-vertical .rc-slider-dot {
  left: 2px;
  margin-bottom: -4px;
}

.rc-slider-vertical .rc-slider-dot:first-child {
  margin-bottom: -4px;
}

.rc-slider-vertical .rc-slider-dot:last-child {
  margin-bottom: -4px;
}

.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}

.rc-slider-tooltip-zoom-down-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}

.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,
.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {
  animation-name: rcSliderTooltipZoomDownIn;
  animation-play-state: running;
}

.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {
  animation-name: rcSliderTooltipZoomDownOut;
  animation-play-state: running;
}

.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  transform: scale(0, 0);
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.rc-slider-tooltip-zoom-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

@keyframes rcSliderTooltipZoomDownIn {
  0% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
  100% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
}
@keyframes rcSliderTooltipZoomDownOut {
  0% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
}
.rc-slider-tooltip {
  position: absolute;
  left: -9999px;
  top: -9999px;
  visibility: visible;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.rc-slider-tooltip-hidden {
  display: none;
}

.rc-slider-tooltip-placement-top {
  padding: 4px 0 8px 0;
}

.rc-slider-tooltip-inner {
  padding: 0 8px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #212529;
  border-radius: 0.25rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
  font-weight: bold;
}

.rc-slider-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
  bottom: 4px;
  left: 50%;
  margin-left: -4px;
  border-width: 4px 4px 0;
  border-top-color: #212529;
}

.rc-slider-primary .rc-slider-track {
  background-color: #545cd8;
}
.rc-slider-primary .rc-slider-handle {
  border-color: #545cd8;
  background-color: #fff;
}
.rc-slider-primary .rc-slider-handle:focus, .rc-slider-primary .rc-slider-handle:active, .rc-slider-primary .rc-slider-handle:hover {
  border-color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);
}
.rc-slider-primary .rc-slider-dot-active {
  border-color: #545cd8;
}

.rc-slider-secondary .rc-slider-track {
  background-color: #6c757d;
}
.rc-slider-secondary .rc-slider-handle {
  border-color: #6c757d;
  background-color: #fff;
}
.rc-slider-secondary .rc-slider-handle:focus, .rc-slider-secondary .rc-slider-handle:active, .rc-slider-secondary .rc-slider-handle:hover {
  border-color: rgb(28.4473617773%, 30.8179752588%, 32.9251872423%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.8), 0 0.125rem 0.5875rem rgba(108, 117, 125, 0.9);
}
.rc-slider-secondary .rc-slider-dot-active {
  border-color: #6c757d;
}

.rc-slider-success .rc-slider-track {
  background-color: #3ac47d;
}
.rc-slider-success .rc-slider-handle {
  border-color: #3ac47d;
  background-color: #fff;
}
.rc-slider-success .rc-slider-handle:focus, .rc-slider-success .rc-slider-handle:active, .rc-slider-success .rc-slider-handle:hover {
  border-color: rgb(15.8947043384%, 53.7131387988%, 34.2558283156%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.8), 0 0.125rem 0.5875rem rgba(58, 196, 125, 0.9);
}
.rc-slider-success .rc-slider-dot-active {
  border-color: #3ac47d;
}

.rc-slider-info .rc-slider-track {
  background-color: #30b1ff;
}
.rc-slider-info .rc-slider-handle {
  border-color: #30b1ff;
  background-color: #fff;
}
.rc-slider-info .rc-slider-handle:focus, .rc-slider-info .rc-slider-handle:active, .rc-slider-info .rc-slider-handle:hover {
  border-color: rgb(0%, 55.3537936914%, 88.8235294118%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.8), 0 0.125rem 0.5875rem rgba(48, 177, 255, 0.9);
}
.rc-slider-info .rc-slider-dot-active {
  border-color: #30b1ff;
}

.rc-slider-warning .rc-slider-track {
  background-color: #f7b924;
}
.rc-slider-warning .rc-slider-handle {
  border-color: #f7b924;
  background-color: #fff;
}
.rc-slider-warning .rc-slider-handle:focus, .rc-slider-warning .rc-slider-handle:active, .rc-slider-warning .rc-slider-handle:hover {
  border-color: rgb(78.1264576315%, 56.00846506%, 2.8539345254%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.8), 0 0.125rem 0.5875rem rgba(247, 185, 36, 0.9);
}
.rc-slider-warning .rc-slider-dot-active {
  border-color: #f7b924;
}

.rc-slider-danger .rc-slider-track {
  background-color: #d92550;
}
.rc-slider-danger .rc-slider-handle {
  border-color: #d92550;
  background-color: #fff;
}
.rc-slider-danger .rc-slider-handle:focus, .rc-slider-danger .rc-slider-handle:active, .rc-slider-danger .rc-slider-handle:hover {
  border-color: rgb(59.4681179558%, 10.1397251814%, 21.923730122%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.8), 0 0.125rem 0.5875rem rgba(217, 37, 80, 0.9);
}
.rc-slider-danger .rc-slider-dot-active {
  border-color: #d92550;
}

.rc-slider-light .rc-slider-track {
  background-color: #eeeeee;
}
.rc-slider-light .rc-slider-handle {
  border-color: #eeeeee;
  background-color: #fff;
}
.rc-slider-light .rc-slider-handle:focus, .rc-slider-light .rc-slider-handle:active, .rc-slider-light .rc-slider-handle:hover {
  border-color: rgb(78.3333333333%, 78.3333333333%, 78.3333333333%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.8), 0 0.125rem 0.5875rem rgba(238, 238, 238, 0.9);
}
.rc-slider-light .rc-slider-dot-active {
  border-color: #eeeeee;
}

.rc-slider-dark .rc-slider-track {
  background-color: #343a40;
}
.rc-slider-dark .rc-slider-handle {
  border-color: #343a40;
  background-color: #fff;
}
.rc-slider-dark .rc-slider-handle:focus, .rc-slider-dark .rc-slider-handle:active, .rc-slider-dark .rc-slider-handle:hover {
  border-color: rgb(6.9438810007%, 7.7450980392%, 8.5463150778%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.8), 0 0.125rem 0.5875rem rgba(52, 58, 64, 0.9);
}
.rc-slider-dark .rc-slider-dot-active {
  border-color: #343a40;
}

.rc-slider-focus .rc-slider-track {
  background-color: #444054;
}
.rc-slider-focus .rc-slider-handle {
  border-color: #444054;
  background-color: #fff;
}
.rc-slider-focus .rc-slider-handle:focus, .rc-slider-focus .rc-slider-handle:active, .rc-slider-focus .rc-slider-handle:hover {
  border-color: rgb(12.8828828829%, 12.1250662427%, 15.9141494436%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.8), 0 0.125rem 0.5875rem rgba(68, 64, 84, 0.9);
}
.rc-slider-focus .rc-slider-dot-active {
  border-color: #444054;
}

.rc-slider-alternate .rc-slider-track {
  background-color: #83588a;
}
.rc-slider-alternate .rc-slider-handle {
  border-color: #83588a;
  background-color: #fff;
}
.rc-slider-alternate .rc-slider-handle:focus, .rc-slider-alternate .rc-slider-handle:active, .rc-slider-alternate .rc-slider-handle:hover {
  border-color: rgb(33.9831684886%, 22.8283879924%, 35.799062988%);
  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.8), 0 0.125rem 0.5875rem rgba(131, 88, 138, 0.9);
}
.rc-slider-alternate .rc-slider-dot-active {
  border-color: #83588a;
}

.rc-slider-line .rc-slider-handle {
  border-radius: 0;
  border-width: 0 3px 0 0;
  margin-left: -8px;
  width: 10px;
  background-color: transparent;
  box-shadow: 0 0 0 transparent !important;
}

.rc-slider-square .rc-slider-handle {
  border-radius: 3px;
  border-widtH: 1px;
}
.rc-slider-square .rc-slider-handle:before {
  position: absolute;
  height: 8px;
  width: 4px;
  border: #adb5bd solid 1px;
  border-width: 0 1px;
  display: block;
  content: "";
  top: 50%;
  left: 50%;
  margin: -4px -2px;
}

.rc-slider-lg.rc-slider {
  height: 20px;
  padding: 8px 0 0;
}
.rc-slider-lg .rc-slider-rail {
  height: 4px;
}
.rc-slider-lg .rc-slider-track {
  height: 4px;
}
.rc-slider-lg .rc-slider-handle {
  margin-left: -10px;
  margin-top: -8px;
  width: 20px;
  height: 20px;
}
.rc-slider-lg.rc-slider-line .rc-slider-handle {
  margin-left: -8px;
  width: 10px;
}
.rc-slider-lg.rc-slider-square .rc-slider-handle:before {
  height: 10px;
  width: 6px;
  margin: -5px -3px;
}

.rc-slider-sm.rc-slider {
  height: 20px;
  padding: 8px 0 0;
}
.rc-slider-sm .rc-slider-rail {
  height: 4px;
}
.rc-slider-sm .rc-slider-track {
  height: 4px;
}
.rc-slider-sm .rc-slider-handle {
  margin-left: -6px;
  margin-top: -4px;
  width: 12px;
  height: 12px;
}
.rc-slider-sm.rc-slider-line .rc-slider-handle {
  margin-left: -8px;
  width: 10px;
}
.rc-slider-sm.rc-slider-square .rc-slider-handle:before {
  height: 6px;
  margin: -3px 0 0 -1px;
  border: 0;
  width: 2px;
  background: #adb5bd;
}

.rdw-option-wrapper {
  border: 1px solid #F1F1F1;
  padding: 5px;
  min-width: 25px;
  height: 20px;
  border-radius: 2px;
  margin: 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-option-wrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-option-wrapper:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-option-active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-option-disabled {
  opacity: 0.3;
  cursor: default;
}

.rdw-dropdown-wrapper {
  height: 30px;
  background: white;
  cursor: pointer;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  margin: 0 3px;
  text-transform: capitalize;
  background: white;
}

.rdw-dropdown-wrapper:focus {
  outline: none;
}

.rdw-dropdown-wrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
  background-color: #FFFFFF;
}

.rdw-dropdown-wrapper:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-dropdown-carettoopen {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 35%;
  right: 10%;
  border-top: 6px solid black;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.rdw-dropdown-carettoclose {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 35%;
  right: 10%;
  border-bottom: 6px solid black;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.rdw-dropdown-selectedtext {
  display: flex;
  position: relative;
  height: 100%;
  align-items: center;
  padding: 0 5px;
}

.rdw-dropdown-optionwrapper {
  z-index: 100;
  position: relative;
  border: 1px solid #F1F1F1;
  width: 98%;
  background: white;
  border-radius: 2px;
  margin: 0;
  padding: 0;
  max-height: 250px;
  overflow-y: scroll;
}

.rdw-dropdown-optionwrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
  background-color: #FFFFFF;
}

.rdw-dropdownoption-default {
  min-height: 25px;
  display: flex;
  align-items: center;
  padding: 0 5px;
}

.rdw-dropdownoption-highlighted {
  background: #F1F1F1;
}

.rdw-dropdownoption-active {
  background: #f5f5f5;
}

.rdw-dropdownoption-disabled {
  opacity: 0.3;
  cursor: default;
}

.rdw-inline-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-inline-dropdown {
  width: 50px;
}

.rdw-inline-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-block-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-block-dropdown {
  width: 110px;
}

.rdw-fontsize-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-fontsize-dropdown {
  min-width: 40px;
}

.rdw-fontsize-option {
  display: flex;
  justify-content: center;
}

.rdw-fontfamily-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-fontfamily-dropdown {
  width: 115px;
}

.rdw-fontfamily-placeholder {
  white-space: nowrap;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rdw-fontfamily-optionwrapper {
  width: 140px;
}

.rdw-list-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-list-dropdown {
  width: 50px;
  z-index: 90;
}

.rdw-list-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-text-align-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-text-align-dropdown {
  width: 50px;
  z-index: 90;
}

.rdw-text-align-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-right-aligned-block {
  text-align: right;
}

.rdw-left-aligned-block {
  text-align: left !important;
}

.rdw-center-aligned-block {
  text-align: center !important;
}

.rdw-justify-aligned-block {
  text-align: justify !important;
}

.rdw-right-aligned-block > div {
  display: inline-block;
}

.rdw-left-aligned-block > div {
  display: inline-block;
}

.rdw-center-aligned-block > div {
  display: inline-block;
}

.rdw-justify-aligned-block > div {
  display: inline-block;
}

.rdw-colorpicker-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-colorpicker-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 175px;
  height: 175px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-colorpicker-modal-header {
  display: flex;
  padding-bottom: 5px;
}

.rdw-colorpicker-modal-style-label {
  font-size: 15px;
  width: 50%;
  text-align: center;
  cursor: pointer;
  padding: 0 10px 5px;
}

.rdw-colorpicker-modal-style-label-active {
  border-bottom: 2px solid #0a66b7;
}

.rdw-colorpicker-modal-options {
  margin: 5px auto;
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  overflow: scroll;
}

.rdw-colorpicker-cube {
  width: 22px;
  height: 22px;
  border: 1px solid #F1F1F1;
}

.rdw-colorpicker-option {
  margin: 3px;
  padding: 0;
  min-height: 20px;
  border: none;
  width: 22px;
  height: 22px;
  min-width: 22px;
  box-shadow: 1px 2px 1px #BFBDBD inset;
}

.rdw-colorpicker-option:hover {
  box-shadow: 1px 2px 1px #BFBDBD;
}

.rdw-colorpicker-option:active {
  box-shadow: -1px -2px 1px #BFBDBD;
}

.rdw-colorpicker-option-active {
  box-shadow: 0px 0px 2px 2px #BFBDBD;
}

.rdw-link-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-link-dropdown {
  width: 50px;
}

.rdw-link-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-link-dropdownPlaceholder {
  margin-left: 8px;
}

.rdw-link-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  height: 205px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-link-modal-label {
  font-size: 15px;
}

.rdw-link-modal-input {
  margin-top: 5px;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  height: 25px;
  margin-bottom: 15px;
  padding: 0 5px;
}

.rdw-link-modal-input:focus {
  outline: none;
}

.rdw-link-modal-buttonsection {
  margin: 0 auto;
}

.rdw-link-modal-target-option {
  margin-bottom: 20px;
}

.rdw-link-modal-target-option > span {
  margin-left: 5px;
}

.rdw-link-modal-btn {
  margin-left: 10px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-link-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-link-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-link-modal-btn:focus {
  outline: none !important;
}

.rdw-link-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-link-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-history-dropdown {
  width: 50px;
}

.rdw-embedded-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-embedded-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  height: 180px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  justify-content: space-between;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-embedded-modal-header {
  font-size: 15px;
  display: flex;
}

.rdw-embedded-modal-header-option {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rdw-embedded-modal-header-label {
  width: 95px;
  border: 1px solid #f1f1f1;
  margin-top: 5px;
  background: #6EB8D4;
  border-bottom: 2px solid #0a66b7;
}

.rdw-embedded-modal-link-section {
  display: flex;
  flex-direction: column;
}

.rdw-embedded-modal-link-input {
  width: 88%;
  height: 35px;
  margin: 10px 0;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 15px;
  padding: 0 5px;
}

.rdw-embedded-modal-link-input-wrapper {
  display: flex;
  align-items: center;
}

.rdw-embedded-modal-link-input:focus {
  outline: none;
}

.rdw-embedded-modal-btn-section {
  display: flex;
  justify-content: center;
}

.rdw-embedded-modal-btn {
  margin: 0 3px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-embedded-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-embedded-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-embedded-modal-btn:focus {
  outline: none !important;
}

.rdw-embedded-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-embedded-modal-size {
  align-items: center;
  display: flex;
  margin: 8px 0;
  justify-content: space-between;
}

.rdw-embedded-modal-size-input {
  width: 80%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
}

.rdw-embedded-modal-size-input:focus {
  outline: none;
}

.rdw-emoji-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-emoji-modal {
  overflow: auto;
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-wrap: wrap;
  width: 235px;
  height: 180px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-emoji-icon {
  margin: 2.5px;
  height: 24px;
  width: 24px;
  cursor: pointer;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rdw-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.rdw-spinner > div {
  width: 12px;
  height: 12px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.rdw-spinner .rdw-bounce1 {
  animation-delay: -0.32s;
}

.rdw-spinner .rdw-bounce2 {
  animation-delay: -0.16s;
}
@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.rdw-image-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-image-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-image-modal-header {
  font-size: 15px;
  margin: 10px 0;
  display: flex;
}

.rdw-image-modal-header-option {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rdw-image-modal-header-label {
  width: 80px;
  background: #f1f1f1;
  border: 1px solid #f1f1f1;
  margin-top: 5px;
}

.rdw-image-modal-header-label-highlighted {
  background: #6EB8D4;
  border-bottom: 2px solid #0a66b7;
}

.rdw-image-modal-upload-option {
  width: 100%;
  color: gray;
  cursor: pointer;
  display: flex;
  border: none;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  background-color: #f1f1f1;
  outline: 2px dashed gray;
  outline-offset: -10px;
  margin: 10px 0;
  padding: 9px 0;
}

.rdw-image-modal-upload-option-highlighted {
  outline: 2px dashed #0a66b7;
}

.rdw-image-modal-upload-option-label {
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
}

.rdw-image-modal-upload-option-label span {
  padding: 0 20px;
}

.rdw-image-modal-upload-option-image-preview {
  max-width: 100%;
  max-height: 200px;
}

.rdw-image-modal-upload-option-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.rdw-image-modal-url-section {
  display: flex;
  align-items: center;
}

.rdw-image-modal-url-input {
  width: 90%;
  height: 35px;
  margin: 15px 0 12px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 15px;
  padding: 0 5px;
}

.rdw-image-modal-btn-section {
  margin: 10px auto 0;
}

.rdw-image-modal-url-input:focus {
  outline: none;
}

.rdw-image-modal-btn {
  margin: 0 5px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-image-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-image-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-image-modal-btn:focus {
  outline: none !important;
}

.rdw-image-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-image-modal-spinner {
  position: absolute;
  top: -3px;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
}

.rdw-image-modal-alt-input {
  width: 70%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
  margin-left: 5px;
}

.rdw-image-modal-alt-input:focus {
  outline: none;
}

.rdw-image-modal-alt-lbl {
  font-size: 12px;
}

.rdw-image-modal-size {
  align-items: center;
  display: flex;
  margin: 8px 0;
  justify-content: space-between;
}

.rdw-image-modal-size-input {
  width: 40%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
}

.rdw-image-modal-size-input:focus {
  outline: none;
}

.rdw-image-mandatory-sign {
  color: red;
  margin-left: 3px;
  margin-right: 3px;
}

.rdw-remove-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-history-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-history-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-history-dropdown {
  width: 50px;
}

.rdw-link-decorator-wrapper {
  position: relative;
}

.rdw-link-decorator-icon {
  position: absolute;
  left: 40%;
  top: 0;
  cursor: pointer;
  background-color: white;
}

.rdw-mention-link {
  text-decoration: none;
  color: #1236ff;
  background-color: #f0fbff;
  padding: 1px 2px;
  border-radius: 2px;
}

.rdw-suggestion-wrapper {
  position: relative;
}

.rdw-suggestion-dropdown {
  position: absolute;
  display: flex;
  flex-direction: column;
  border: 1px solid #F1F1F1;
  min-width: 100px;
  max-height: 150px;
  overflow: auto;
  background: white;
  z-index: 100;
}

.rdw-suggestion-option {
  padding: 7px 5px;
  border-bottom: 1px solid #f1f1f1;
}

.rdw-suggestion-option-active {
  background-color: #F1F1F1;
}

.rdw-hashtag-link {
  text-decoration: none;
  color: #1236ff;
  background-color: #f0fbff;
  padding: 1px 2px;
  border-radius: 2px;
}

.rdw-image-alignment-options-popup {
  position: absolute;
  background: white;
  display: flex;
  padding: 5px 2px;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  width: 105px;
  cursor: pointer;
  z-index: 100;
}

.rdw-alignment-option-left {
  justify-content: flex-start;
}

.rdw-image-alignment-option {
  height: 15px;
  width: 15px;
  min-width: 15px;
}

.rdw-image-alignment {
  position: relative;
}

.rdw-image-imagewrapper {
  position: relative;
}

.rdw-image-center {
  display: flex;
  justify-content: center;
}

.rdw-image-left {
  display: flex;
}

.rdw-image-right {
  display: flex;
  justify-content: flex-end;
}

.rdw-image-alignment-options-popup-right {
  right: 0;
}

.rdw-editor-main {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
}

.rdw-editor-toolbar {
  padding: 6px 5px 0;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  display: flex;
  justify-content: flex-start;
  background: white;
  flex-wrap: wrap;
  font-size: 15px;
  margin-bottom: 5px;
  -webkit-user-select: none;
          user-select: none;
}

.public-DraftStyleDefault-block {
  margin: 1em 0;
}

.rdw-editor-wrapper:focus {
  outline: none;
}

.rdw-editor-wrapper {
  box-sizing: content-box;
}

.rdw-editor-main blockquote {
  border-left: 5px solid #f1f1f1;
  padding-left: 5px;
}

.rdw-editor-main pre {
  background: #f1f1f1;
  border-radius: 3px;
  padding: 1px 10px;
} /**
* Draft v0.9.1
*
* Copyright (c) 2013-present, Facebook, Inc.
* All rights reserved.
*
* This source code is licensed under the BSD-style license found in the
* LICENSE file in the root directory of this source tree. An additional grant
* of patent rights can be found in the PATENTS file in the same directory.
*/
.DraftEditor-editorContainer, .DraftEditor-root, .public-DraftEditor-content {
  height: inherit;
  text-align: left;
  text-align: initial;
}

.public-DraftEditor-content[contenteditable=true] {
  -webkit-user-modify: read-write-plaintext-only;
}

.DraftEditor-root {
  position: relative;
}

.DraftEditor-editorContainer {
  background-color: rgba(255, 255, 255, 0);
  border-left: 0.1px solid transparent;
  position: relative;
  z-index: 1;
}

.public-DraftEditor-block {
  position: relative;
}

.DraftEditor-alignLeft .public-DraftStyleDefault-block {
  text-align: left;
}

.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {
  left: 0;
  text-align: left;
}

.DraftEditor-alignCenter .public-DraftStyleDefault-block {
  text-align: center;
}

.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.DraftEditor-alignRight .public-DraftStyleDefault-block {
  text-align: right;
}

.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {
  right: 0;
  text-align: right;
}

.public-DraftEditorPlaceholder-root {
  color: #9197a3;
  position: absolute;
  z-index: 0;
}

.public-DraftEditorPlaceholder-hasFocus {
  color: #bdc1c9;
}

.DraftEditorPlaceholder-hidden {
  display: none;
}

.public-DraftStyleDefault-block {
  position: relative;
  white-space: pre-wrap;
}

.public-DraftStyleDefault-ltr {
  direction: ltr;
  text-align: left;
}

.public-DraftStyleDefault-rtl {
  direction: rtl;
  text-align: right;
}

.public-DraftStyleDefault-listLTR {
  direction: ltr;
}

.public-DraftStyleDefault-listRTL {
  direction: rtl;
}

.public-DraftStyleDefault-ol, .public-DraftStyleDefault-ul {
  margin: 16px 0;
  padding: 0;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {
  margin-left: 1.5em;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {
  margin-right: 1.5em;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {
  margin-left: 3em;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {
  margin-right: 3em;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {
  margin-left: 4.5em;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {
  margin-right: 4.5em;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {
  margin-left: 6em;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {
  margin-right: 6em;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {
  margin-left: 7.5em;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {
  margin-right: 7.5em;
}

.public-DraftStyleDefault-unorderedListItem {
  list-style-type: square;
  position: relative;
}

.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {
  list-style-type: disc;
}

.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {
  list-style-type: circle;
}

.public-DraftStyleDefault-orderedListItem {
  list-style-type: none;
  position: relative;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {
  left: -36px;
  position: absolute;
  text-align: right;
  width: 30px;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {
  position: absolute;
  right: -36px;
  text-align: left;
  width: 30px;
}

.public-DraftStyleDefault-orderedListItem:before {
  content: counter(ol0) ". ";
  counter-increment: ol0;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {
  content: counter(ol1) ". ";
  counter-increment: ol1;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {
  content: counter(ol2) ". ";
  counter-increment: ol2;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {
  content: counter(ol3) ". ";
  counter-increment: ol3;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {
  content: counter(ol4) ". ";
  counter-increment: ol4;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {
  counter-reset: ol0;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {
  counter-reset: ol1;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {
  counter-reset: ol2;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {
  counter-reset: ol3;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {
  counter-reset: ol4;
}

.demo-editor {
  height: 275px !important;
  border: 1px solid #F1F1F1 !important;
  padding: 5px !important;
  border-radius: 2px !important;
}

.has-switch {
  border-radius: 30px;
  cursor: pointer;
  display: inline-block;
  line-height: 1.72222;
  overflow: hidden;
  position: relative;
  text-align: left;
  width: 60px;
  -webkit-user-select: none;
          user-select: none;
}

.has-switch.deactivate {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.has-switch.deactivate label,
.has-switch.deactivate span {
  cursor: default !important;
}

.has-switch > div {
  position: relative;
  top: 0;
  width: 100px;
}

.has-switch > div.switch-animate {
  transition: left 0.25s ease-out;
}

.has-switch > div.switch-off {
  left: -35px;
}

.has-switch > div.switch-on {
  left: 0;
}

.has-switch > div label {
  background-color: #FFFFFF;
  background: rgb(255, 255, 255);
  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%);
  background-size: 150% 150%;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.has-switch input[type=checkbox] {
  display: none;
}

.has-switch span {
  cursor: pointer;
  float: left;
  font-size: 11px;
  font-weight: 400;
  height: 24px;
  line-height: 15px;
  margin: 0;
  padding-bottom: 6px;
  padding-top: 5px;
  position: relative;
  text-align: center;
  text-indent: -10px;
  width: 50%;
  z-index: 1;
  transition: 0.25s ease-out;
}

.has-switch span.switch-left {
  background-color: #545cd8;
  border-left: 1px solid rgba(0, 0, 0, 0);
  border-radius: 30px 0 0 30px;
  color: #FFFFFF;
}

.has-switch .switch-off span.switch-left {
  background-color: #ced4da !important;
}

.has-switch span.switch-right {
  border-radius: 0 30px 30px 0;
  background-color: #545cd8;
  color: #ffffff;
  text-indent: 1px;
}

.has-switch .switch-off span.switch-right {
  background-color: #ced4da !important;
}

.has-switch label {
  border-radius: 12px;
  float: left;
  height: 22px;
  margin: 1px -13px;
  padding: 0;
  position: relative;
  vertical-align: middle;
  width: 22px;
  z-index: 100;
  transition: 0.25s ease-out;
}

.has-switch .switch-on .fa-check:before {
  margin-left: 10px;
}

.has-switch:hover .switch-on label {
  margin: 1px -17px;
  width: 26px;
}

.has-switch:hover .switch-off label {
  margin: 1px -13px;
  width: 26px;
}

.has-switch-sm.has-switch span {
  height: 18px;
  line-height: 18px;
  padding: 0;
}
.has-switch-sm.has-switch label {
  height: 16px;
  width: 16px;
  margin: 1px -8px;
}
.has-switch-sm.has-switch .switch-off label {
  margin: 1px -13px;
}
.has-switch-sm.has-switch:hover .switch-on label {
  margin: 1px -11px;
  width: 20px;
}
.has-switch-sm.has-switch:hover .switch-off label {
  margin: 1px -13px;
  width: 20px;
}

.dropzone-wrapper {
  width: 100%;
  border: #ced4da dashed 2px;
  border-radius: 0.3rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  height: 230px;
  transition: all 0.2s;
}
.dropzone-wrapper:hover {
  border-color: #545cd8;
}
.dropzone-wrapper > div {
  width: 100%;
  height: 100%;
  outline: none !important;
  display: flex;
  align-items: center;
}
.dropzone-wrapper.dropzone-wrapper-lg {
  height: 300px;
}
.dropzone-wrapper.dropzone-wrapper-sm {
  height: 150px;
}
.dropzone-wrapper input {
  width: 100%;
  height: 100%;
}
.dropzone-wrapper .dropzone-content {
  margin: 0 auto;
  color: #6c757d;
}
.dropzone-wrapper[aria-disabled=true] {
  border-color: #dee2e6;
}
.dropzone-wrapper[aria-disabled=true] .dropzone-content {
  color: #ced4da;
}

.rbt {
  outline: none;
}
.rbt-menu {
  margin-bottom: 2px;
}
.rbt-menu > li a {
  overflow: hidden;
  text-overflow: ellipsis;
}
.rbt-menu > li a:focus {
  outline: none;
}
.rbt-menu-pagination-option {
  text-align: center;
}
.rbt .rbt-input-main::-ms-clear {
  display: none;
}
.rbt-input-multi {
  cursor: text;
  overflow: hidden;
  position: relative;
}
.rbt-input-multi.form-control[disabled] {
  background-color: #e9ecef;
  opacity: 1;
}
.rbt-input-multi input::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
.rbt-input-multi input:-ms-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi input::-webkit-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi .rbt-input-wrapper {
  margin-top: 2px;
  overflow: hidden;
}
.rbt-input-multi .rbt-input-main {
  height: auto;
}
.rbt-input-multi .rbt-input-hint-container {
  display: inline-block;
}
.rbt-input-multi.input-lg .rbt-input-main, .rbt-input-multi.form-control-lg .rbt-input-main {
  height: auto;
}
.rbt-input-multi.input-sm .rbt-input-main, .rbt-input-multi.form-control-sm .rbt-input-main {
  height: auto;
}
.rbt-close {
  z-index: 1;
}
.rbt-close-lg {
  font-size: 24px;
}
.rbt-token {
  background-color: #e0f3ff;
  border: 0;
  border-radius: 0.25rem;
  color: #545cd8;
  display: inline-block;
  line-height: 1em;
  margin: 0 3px 3px 0;
  padding: 4px 7px;
  position: relative;
}
.rbt-token-disabled {
  background-color: #f8f9fa;
  color: #adb5bd;
  pointer-events: none;
}
.rbt-token-removeable {
  cursor: pointer;
  padding-right: 21px;
}
.rbt-token-active {
  background-color: #545cd8;
  color: #fff;
  outline: none;
  text-decoration: none;
}
.rbt-token .rbt-token-remove-button {
  bottom: 0;
  color: #495057;
  font-size: inherit;
  font-weight: normal;
  opacity: 1;
  outline: none;
  padding: 3px 7px;
  position: absolute;
  right: 0;
  text-shadow: none;
  top: -1px;
}
.rbt-loader {
  animation: loader-animation 600ms infinite linear;
  border: 1px solid #e0f3ff;
  border-radius: 50%;
  border-top-color: rgb(67.8431372549%, 87.5521821632%, 100%);
  display: block;
  height: 16px;
  width: 16px;
}
.rbt-loader-lg {
  height: 20px;
  width: 20px;
}
.rbt-aux {
  display: flex;
  align-items: center;
  bottom: 0;
  justify-content: center;
  pointer-events: none; /* Don't block clicks on the input */
  position: absolute;
  right: 0;
  top: 0;
  width: 34px;
}
.rbt-aux-lg {
  width: 46px;
}
.rbt-aux .rbt-close {
  margin-top: -1px;
  pointer-events: auto; /* Override pointer-events: none; above */
}
.has-aux .rbt-input {
  padding-right: 34px;
}
.rbt-highlight-text {
  background-color: inherit;
  color: inherit;
  font-weight: bold;
  padding: 0;
}

/* Input Groups */
.input-group > .rbt {
  flex: 1 1;
}
.input-group > .rbt .rbt-input-hint-container {
  display: flex;
}
.input-group > .rbt .rbt-input-hint {
  z-index: 5;
}
.input-group > .rbt .rbt-aux {
  z-index: 5;
}
.input-group > .rbt:not(:first-child) .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .rbt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

@keyframes loader-animation {
  to {
    transform: rotate(1turn);
  }
}
.input-group > .rbt .rbt-input-hint-container {
  flex: 1 1;
  height: 100%;
}

.rw-btn,
.rw-input-reset,
.rw-input,
.rw-filter-input,
.rw-dropdown-list-autofill {
  color: inherit;
  padding: 0;
  margin: 0;
  border: none;
  box-shadow: none;
  background: none;
  background-image: none;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  touch-action: manipulation;
}

.rw-btn::-moz-focus-inner {
  padding: 0;
  border: 0;
}

select.rw-input, select.rw-filter-input, select.rw-dropdown-list-autofill {
  text-transform: none;
}

html input[type=button].rw-input, html input[type=button].rw-filter-input, html input[type=button].rw-dropdown-list-autofill {
  -webkit-appearance: button;
  cursor: pointer;
}

textarea.rw-input, textarea.rw-filter-input, textarea.rw-dropdown-list-autofill {
  overflow: auto;
  resize: vertical;
}

button[disabled].rw-input, button[disabled].rw-filter-input, button[disabled].rw-dropdown-list-autofill,
fieldset[disabled] .rw-input,
fieldset[disabled] .rw-filter-input,
fieldset[disabled] .rw-dropdown-list-autofill,
html input[disabled].rw-input,
html input[disabled].rw-filter-input,
html input[disabled].rw-dropdown-list-autofill {
  cursor: not-allowed;
}

button.rw-input::-moz-focus-inner, button.rw-filter-input::-moz-focus-inner, button.rw-dropdown-list-autofill::-moz-focus-inner,
input.rw-input::-moz-focus-inner,
input.rw-filter-input::-moz-focus-inner,
input.rw-dropdown-list-autofill::-moz-focus-inner {
  border: 0;
  padding: 0;
}

input[type=checkbox],
input[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

/* -------------- */
@font-face {
  font-family: "RwWidgets";
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("svg");
}
.rw-i {
  display: inline-block;
  color: #495057;
  font-family: RwWidgets;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.rw-i-caret-down:before {
  content: "\\e803";
}

.rw-i-caret-up:before {
  content: "\\e800";
}

.rw-i-chevron-left:before {
  content: "\\f104";
}

.rw-i-chevron-right:before {
  content: "\\f105";
}

.rw-i-clock-o:before {
  content: "\\e805";
}

.rw-i-calendar:before {
  content: "\\e804";
}

.rw-i-search:before {
  content: "\\e801";
}

/* for debugging */
@keyframes react-widgets-autofill-start {
  from {
    /**/
  }
  to {
    /**/
  }
}
@keyframes react-widgets-autofill-cancel {
  from {
    /**/
  }
  to {
    /**/
  }
}
.rw-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.rw-widget {
  background-clip: border-box;
  border: none;
  color: #333333;
  font-size: 1em;
  font-family: inherit;
  outline: none;
  position: relative;
}
.rw-widget > .rw-widget-container {
  width: 100%;
  margin: 0;
}

.rw-widget-container {
  background-color: #fff;
  border: #ced4da 1px solid;
  border-radius: 0.25rem;
}
.rw-widget-container.rw-state-focus, .rw-widget-container.rw-state-focus:hover, .rw-state-focus > .rw-widget-container, .rw-state-focus > .rw-widget-container:hover {
  background-color: #fff;
  border-color: #545cd8;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.rw-widget-container.rw-state-readonly, .rw-state-readonly > .rw-widget-container {
  cursor: not-allowed;
}
.rw-widget-container.rw-state-disabled, .rw-widget-container.rw-state-disabled:hover, .rw-widget-container.rw-state-disabled:active, .rw-state-disabled > .rw-widget-container, .rw-state-disabled > .rw-widget-container:hover, .rw-state-disabled > .rw-widget-container:active, fieldset[disabled] .rw-widget-container, fieldset[disabled] .rw-widget-container:hover, fieldset[disabled] .rw-widget-container:active {
  box-shadow: none;
  box-shadow: none;
  cursor: not-allowed;
}

.rw-widget-picker {
  position: relative;
  overflow: hidden;
  border-collapse: separate;
  display: inline-table;
  height: calc(1.5em + 0.75rem + 2px);
}
.rw-widget-picker > * {
  position: relative;
  border: none;
  outline: none;
  width: 100%;
  height: 100%;
  display: table-cell;
}
.rw-widget-picker > .rw-select {
  width: 1%;
  white-space: nowrap;
}
.rw-open > .rw-widget-picker {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.rw-open-up > .rw-widget-picker {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
fieldset[disabled] .rw-widget-picker, .rw-state-disabled > .rw-widget-picker {
  background-color: rgb(93.5%, 93.5%, 93.5%);
}

.rw-select {
  cursor: pointer;
}
.rw-select > * {
  width: 1.9em;
}
.rw-state-readonly .rw-select, .rw-state-disabled .rw-select {
  cursor: not-allowed;
}

.rw-select-bordered {
  cursor: pointer;
}
.rw-select-bordered:hover, .rw-select-bordered:active {
  background-color: #e0f3ff;
}
.rw-select-bordered:hover .rw-i, .rw-select-bordered:active .rw-i {
  color: #545cd8;
}
.rw-select-bordered:active {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.rw-state-disabled .rw-select-bordered, .rw-state-disabled .rw-select-bordered:hover, .rw-state-disabled .rw-select-bordered:active, .rw-state-readonly .rw-select-bordered, .rw-state-readonly .rw-select-bordered:hover, .rw-state-readonly .rw-select-bordered:active, fieldset[disabled] .rw-select-bordered, fieldset[disabled] .rw-select-bordered:hover, fieldset[disabled] .rw-select-bordered:active {
  cursor: not-allowed;
  background-color: inherit;
  background-image: none;
  box-shadow: none;
}
.rw-state-disabled .rw-select-bordered .rw-i, .rw-state-disabled .rw-select-bordered:hover .rw-i, .rw-state-disabled .rw-select-bordered:active .rw-i, .rw-state-readonly .rw-select-bordered .rw-i, .rw-state-readonly .rw-select-bordered:hover .rw-i, .rw-state-readonly .rw-select-bordered:active .rw-i, fieldset[disabled] .rw-select-bordered .rw-i, fieldset[disabled] .rw-select-bordered:hover .rw-i, fieldset[disabled] .rw-select-bordered:active .rw-i {
  color: inherit;
}
.rw-select-bordered {
  border: none;
  border-left: #ced4da 1px solid;
}
.rw-rtl .rw-select-bordered {
  border-right: #ced4da 1px solid;
  border-left: none;
}

.rw-rtl {
  direction: rtl;
}

.rw-input-reset::-moz-placeholder, .rw-input::-moz-placeholder, .rw-filter-input::-moz-placeholder, .rw-dropdown-list-autofill::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.rw-input-reset:-ms-input-placeholder, .rw-input:-ms-input-placeholder, .rw-filter-input:-ms-input-placeholder, .rw-dropdown-list-autofill:-ms-input-placeholder {
  color: #999;
}
.rw-input-reset::-webkit-input-placeholder, .rw-input::-webkit-input-placeholder, .rw-filter-input::-webkit-input-placeholder, .rw-dropdown-list-autofill::-webkit-input-placeholder {
  color: #999;
}
.rw-input-reset, .rw-input, .rw-filter-input, .rw-dropdown-list-autofill {
  outline: 0;
}

.rw-input, .rw-filter-input, .rw-dropdown-list-autofill {
  color: #495057;
  padding: 0 0.857em;
  background-color: #fff;
}
.rw-input[type=text]::-ms-clear, [type=text].rw-filter-input::-ms-clear, [type=text].rw-dropdown-list-autofill::-ms-clear {
  display: none;
}
.rw-input[disabled], [disabled].rw-filter-input, [disabled].rw-dropdown-list-autofill, fieldset[disabled] .rw-input, fieldset[disabled] .rw-filter-input, fieldset[disabled] .rw-dropdown-list-autofill {
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
  background-color: rgb(93.5%, 93.5%, 93.5%);
  border-color: #ced4da;
}
.rw-input[readonly], [readonly].rw-filter-input, [readonly].rw-dropdown-list-autofill {
  cursor: not-allowed;
}

.rw-i.rw-loading {
  display: block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) no-repeat center;
  min-width: 16px;
  width: 1.9em;
  height: 16px;
}
.rw-i.rw-loading:before {
  content: "";
}

.rw-placeholder {
  color: #999;
}

.rw-detect-autofill:-webkit-autofill {
  animation-name: react-widgets-autofill-start;
  -webkit-transition: background-color 50000s ease-in-out 0s;
  transition: background-color 50000s ease-in-out 0s;
}
.rw-detect-autofill:not(:-webkit-autofill) {
  animation-name: react-widgets-autofill-cancel;
}

.rw-webkit-autofill .rw-widget-container,
.rw-input:-webkit-autofill,
.rw-filter-input:-webkit-autofill,
.rw-dropdown-list-autofill:-webkit-autofill {
  background-color: rgb(250, 255, 189) !important;
  background-image: none !important;
  color: rgb(0, 0, 0) !important;
}

.rw-widget-input, .rw-filter-input {
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

.rw-widget-input.rw-state-focus, .rw-state-focus.rw-filter-input {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25), inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

.rw-list {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 1em;
  outline: 0;
  overflow: auto;
  max-height: 200px;
}

.rw-list-option {
  -webkit-user-select: none;
          user-select: none;
  color: #333333;
  cursor: pointer;
  border: 1px solid transparent;
}
.rw-list-option.rw-state-focus, .rw-list-option.rw-state-focus:hover {
  background-color: #545cd8;
  border-color: #545cd8;
  color: #e0f3ff;
}
.rw-list-option.rw-state-focus:hover, .rw-list-option.rw-state-focus:hover:hover {
  background-color: #545cd8;
  border-color: #545cd8;
  color: #e0f3ff;
}
.rw-list-option:hover, .rw-list-option:hover.rw-state-focus {
  background-color: #e0f3ff;
  border-color: #e0f3ff;
  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);
}
.rw-list-option.rw-state-selected, .rw-list-option.rw-state-selected:hover {
  background-color: #545cd8;
  border-color: #545cd8;
  color: #fff;
}
fieldset[disabled] .rw-list-option, .rw-list-option.rw-state-disabled, .rw-list-option.rw-state-readonly {
  box-shadow: none;
  cursor: not-allowed;
  color: #999999;
  filter: alpha(opacity=7);
  opacity: 0.7;
}
fieldset[disabled] .rw-list-option:hover, .rw-list-option.rw-state-disabled:hover, .rw-list-option.rw-state-readonly:hover {
  background: none;
  border-color: transparent;
}

.rw-list-empty,
.rw-list-option,
.rw-list-optgroup {
  padding: 0.4rem 1.5rem;
  outline: 0;
}

.rw-list-optgroup {
  font-weight: bold;
  padding-top: 7px;
}

.rw-list-option-create {
  border-top: 1px #ced4da solid;
}

.rw-dropdown-list-autofill {
  padding: 0;
}

.rw-dropdown-list .rw-select,
.rw-dropdown-list .rw-select .rw-btn {
  height: 100%;
}

.rw-dropdown-list-input {
  background-color: transparent;
  vertical-align: middle;
  padding-right: 0;
  /* ellipsis */
}
.rw-dropdown-list-input {
  max-width: 1px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.rw-rtl .rw-dropdown-list-input {
  padding-right: 0.857em;
  padding-left: 0;
}

.rw-filter-input {
  position: relative;
  margin: 4px;
  padding-right: 0;
}
.rw-filter-input .rw-rtl {
  padding-right: 0.857em;
  padding-left: 0;
}
.rw-filter-input .rw-select,
.rw-filter-input .rw-btn {
  opacity: 0.75;
  filter: alpha(opacity=75);
  cursor: text;
}
.rw-filter-input > .rw-select, .rw-filter-input > .rw-select:active, .rw-filter-input > .rw-select:hover {
  background: none;
  cursor: auto;
  cursor: initial;
  box-shadow: none;
}

.rw-number-picker .rw-btn {
  cursor: pointer;
}
.rw-number-picker .rw-btn:hover, .rw-number-picker .rw-btn:active {
  background-color: #e0f3ff;
}
.rw-number-picker .rw-btn:hover .rw-i, .rw-number-picker .rw-btn:active .rw-i {
  color: #545cd8;
}
.rw-number-picker .rw-btn:active {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.rw-state-disabled .rw-number-picker .rw-btn, .rw-state-disabled .rw-number-picker .rw-btn:hover, .rw-state-disabled .rw-number-picker .rw-btn:active, .rw-state-readonly .rw-number-picker .rw-btn, .rw-state-readonly .rw-number-picker .rw-btn:hover, .rw-state-readonly .rw-number-picker .rw-btn:active, fieldset[disabled] .rw-number-picker .rw-btn, fieldset[disabled] .rw-number-picker .rw-btn:hover, fieldset[disabled] .rw-number-picker .rw-btn:active {
  cursor: not-allowed;
  background-color: inherit;
  background-image: none;
  box-shadow: none;
}
.rw-state-disabled .rw-number-picker .rw-btn .rw-i, .rw-state-disabled .rw-number-picker .rw-btn:hover .rw-i, .rw-state-disabled .rw-number-picker .rw-btn:active .rw-i, .rw-state-readonly .rw-number-picker .rw-btn .rw-i, .rw-state-readonly .rw-number-picker .rw-btn:hover .rw-i, .rw-state-readonly .rw-number-picker .rw-btn:active .rw-i, fieldset[disabled] .rw-number-picker .rw-btn .rw-i, fieldset[disabled] .rw-number-picker .rw-btn:hover .rw-i, fieldset[disabled] .rw-number-picker .rw-btn:active .rw-i {
  color: inherit;
}
.rw-number-picker .rw-btn {
  height: calc(calc(1.5em + 0.75rem + 2px)/2 - 1px);
  /** ie8 fallback **/
  margin-top: -1px\\9 ;
  height: calc(1.5em + 0.75rem + 2px)/2\\9 ;
  /** --- **/
  line-height: calc(1.5em + 0.75rem + 2px)/2;
  line-height: calc(calc(1.5em + 0.75rem + 2px)/2 - 1px);
  display: block;
  border: none;
}
.rw-number-picker .rw-select {
  vertical-align: middle;
}
.rw-number-picker .rw-select:hover, .rw-number-picker .rw-select:active {
  box-shadow: none;
}

.rw-select-list {
  overflow: auto;
  position: relative;
}
.rw-select-list .rw-list {
  max-height: none;
  font-size: 1em;
}

.rw-select-list-label {
  display: block;
  position: relative;
  font-weight: normal;
  cursor: inherit;
  padding-left: 20px;
  margin: 0;
}
.rw-rtl .rw-select-list-label {
  padding-left: 0;
  padding-right: 20px;
}

input.rw-select-list-input {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  top: 0.1em/9;
  margin: 0;
  line-height: normal;
  cursor: inherit;
}
.rw-rtl input.rw-select-list-input {
  left: auto;
  right: 0;
}

.rw-loading-mask {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) no-repeat center;
  position: absolute;
  background-color: #fff;
  border-radius: 0.25rem;
  opacity: 0.7;
  filter: alpha(opacity=70);
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.rw-multiselect {
  cursor: text;
}
.rw-multiselect .rw-input-reset, .rw-multiselect .rw-input, .rw-multiselect .rw-dropdown-list-autofill, .rw-multiselect .rw-filter-input {
  height: calc(calc(1.5em + 0.75rem + 2px) - 2px);
  /** ie8 fallback **/
  margin-top: -2px\\9 ;
  height: calc(1.5em + 0.75rem + 2px)\\9 ;
  /** --- **/
  border-width: 0;
  width: auto;
  max-width: 100%;
  padding: 0 0.857em;
}
.rw-multiselect .rw-select, .rw-multiselect .rw-select:hover, .rw-multiselect .rw-select:active {
  box-shadow: none;
  background: none;
}

.rw-multiselect-taglist {
  margin: 0;
  padding: 0;
  list-style: none;
  display: inline;
  outline: none;
}

.rw-multiselect-tag {
  display: inline-table;
  color: #212529;
  padding: 0 0.35em 0 0.35em;
  margin-left: calc(calc(1.5em + 0.75rem + 2px)/5 - 1px);
  margin-top: calc(calc(1.5em + 0.75rem + 2px)/5 - 1px);
  height: calc(1.5em + 0.75rem + 2px)/1.5;
  border-radius: 0.2rem;
  background-color: #e0f3ff;
  border: 1px solid rgb(57.8431372549%, 83.6812144213%, 100%);
  cursor: default;
  vertical-align: top;
  text-align: center;
  overflow: hidden;
  max-width: 100%;
}
.rw-multiselect-tag > * {
  display: table-cell;
  vertical-align: middle;
  height: 100%;
}
.rw-rtl .rw-multiselect-tag {
  margin-left: 0;
  margin-right: calc(calc(1.5em + 0.75rem + 2px)/5 - 1px);
  padding: 0 0.35em 0 0.35em;
}
.rw-multiselect-tag.rw-state-focus, .rw-multiselect-tag.rw-state-focus:hover {
  background-color: #545cd8;
  border-color: #545cd8;
  color: #e0f3ff;
}
.rw-multiselect-tag.rw-state-readonly, .rw-multiselect-tag.rw-state-disabled, .rw-state-readonly .rw-multiselect-tag, .rw-state-disabled .rw-multiselect-tag, fieldset[disabled] .rw-multiselect-tag {
  cursor: not-allowed;
}
.rw-multiselect-tag.rw-state-disabled, .rw-state-disabled .rw-multiselect-tag, fieldset[disabled] .rw-multiselect-tag {
  opacity: 0.65;
  filter: alpha(opacity=65);
}
fieldset[disabled] .rw-multiselect-tag {
  box-shadow: none;
  cursor: not-allowed;
}

.rw-multiselect-tag-btn {
  color: #212529;
  margin-left: 0.25em;
}
.rw-rtl .rw-multiselect-tag-btn {
  margin-left: 0;
  margin-right: 0.25em;
}

.rw-popup-container {
  position: absolute;
  z-index: 1005;
  top: 100%;
  left: -6px;
  right: -6px;
}
.rw-popup-container.rw-dropup {
  top: auto;
  bottom: 100%;
}
.rw-state-focus .rw-popup-container {
  z-index: 1006;
}

.rw-popup-transition {
  width: 100%;
  margin-bottom: 6px;
  padding: 0 6px;
}
.rw-dropup > .rw-popup-transition {
  margin-bottom: 0;
  margin-top: 6px;
}

.rw-popup {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
  border: #ced4da 1px solid;
  background: #fff;
}
.rw-dropup .rw-popup {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.2rem;
  border-top-left-radius: 0.2rem;
  box-shadow: 0 -0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 -0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 -0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 -0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}

.rw-popup-transition {
  transition: transform 200ms;
}

.rw-popup-transition-entering {
  overflow: hidden;
}
.rw-popup-transition-entering .rw-popup-transition {
  transform: translateY(0);
  transition-timing-function: ease-out;
}

.rw-popup-transition-exiting .rw-popup-transition {
  transition-timing-function: ease-in;
}

.rw-popup-transition-exiting,
.rw-popup-transition-exited {
  overflow: hidden;
}
.rw-popup-transition-exiting .rw-popup-transition,
.rw-popup-transition-exited .rw-popup-transition {
  transform: translateY(-100%);
}
.rw-popup-transition-exiting.rw-dropup .rw-popup-transition,
.rw-popup-transition-exited.rw-dropup .rw-popup-transition {
  transform: translateY(100%);
}

.rw-popup-transition-exited {
  display: none;
}

.rw-state-disabled {
  box-shadow: none;
  cursor: not-allowed;
}

.ui-theme-settings {
  position: fixed;
  z-index: 155;
  right: -30px;
  top: 0;
  height: 100vh;
  transform: translate(500px);
  transition: all 0.2s;
  box-shadow: -0.46875rem 0 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), -0.9375rem 0 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), -0.25rem 0 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), -0.125rem 0 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
}
.ui-theme-settings .btn-open-options {
  border-radius: 50px;
  position: absolute;
  left: -114px;
  bottom: 80px;
  padding: 0;
  height: 54px;
  line-height: 54px;
  width: 54px;
  text-align: center;
  display: block;
  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
  margin-top: -27px;
}
.ui-theme-settings .btn-open-options svg {
  top: 50%;
  left: 50%;
  position: absolute;
  margin: -0.5em 0 0 -0.5em;
}
.ui-theme-settings .theme-settings__inner {
  background: #fff;
  width: 500px;
  height: 100vh;
  padding: 0;
}
.ui-theme-settings.settings-open {
  transform: translate(0);
  right: 0;
}
.ui-theme-settings .theme-settings-swatches {
  text-align: center;
}
.ui-theme-settings .theme-settings-swatches .swatch-holder-img {
  width: 72px;
  height: auto;
  border-radius: 3px;
}
.ui-theme-settings .theme-settings-swatches .swatch-holder-img img {
  width: 100%;
}
.ui-theme-settings .themeoptions-heading {
  font-size: 1.1rem;
  color: #495057;
  margin: 0;
  background: #f8f9fa;
  padding: 0.75rem 1.5rem;
  border-bottom: #dee2e6 solid 1px;
  border-top: #dee2e6 solid 1px;
  display: flex;
  align-items: center;
  align-content: center;
}
.ui-theme-settings .themeoptions-heading:first-child {
  border-top: 0;
}
.ui-theme-settings .list-group-item h5 {
  color: #545cd8;
  font-size: 0.968rem;
  text-transform: uppercase;
  margin: 0;
  text-align: center;
}

.swatch-holder {
  width: 24px;
  height: 24px;
  line-height: 24px;
  margin: 5px 5px 0;
  transition: all 0.2s;
  opacity: 0.7;
  display: inline-block;
  border-radius: 30px;
}
.swatch-holder.active {
  border: #fff solid 2px;
  box-shadow: 0 0 0 5px #545cd8;
  opacity: 1;
}
.swatch-holder:hover {
  opacity: 1;
}

.swatch-holder-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.font-icon-wrapper {
  text-align: center;
  border: #e9ecef solid 1px;
  border-radius: 0.25rem;
  margin: 0 0 10px;
  padding: 5px;
}
.font-icon-wrapper.font-icon-lg {
  float: left;
  padding: 10px;
  text-align: center;
  margin-right: 15px;
  min-width: 64px;
}
.font-icon-wrapper.font-icon-lg i {
  font-size: 2.5rem;
}
.font-icon-wrapper:hover {
  background: #f8f9fa;
  color: #545cd8;
}
.font-icon-wrapper:hover p {
  color: #6c757d;
}
.font-icon-wrapper i {
  font-size: 1.65rem;
}
.font-icon-wrapper p {
  color: #adb5bd;
  font-size: 0.8066666667rem;
  margin: 5px 0 0;
}

.btn-icon-vertical {
  min-width: 100px;
}

.card.mb-3 {
  margin-bottom: 30px !important;
}

.demo-image-bg {
  height: 350px;
  margin-bottom: 30px;
}

.loader-wrapper {
  width: 150px;
  height: 100px;
  float: left;
}

.slider-item {
  background: #dee2e6;
  border-radius: 0.25rem;
  color: #6c757d;
  font-size: 36px;
  padding: 0;
  position: relative;
  height: 150px;
  line-height: 150px;
  text-align: center;
  margin: 0 1.5rem;
  transition: all 0.2s;
}

.slick-center .slider-item {
  background: #adb5bd;
  color: #495057;
}

.after-img {
  max-width: 100%;
}

@media only screen and (max-width: 1320px) {
  .header-user-info {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .app-main {
    display: block;
  }
  .dropdown-menu::before, .dropdown-menu::after {
    display: none;
  }
  .app-sidebar {
    flex: 0 0 280px !important;
    width: 280px !important;
    transform: translateX(-280px);
  }
  .app-sidebar .app-header__logo {
    display: none;
  }
  .sidebar-mobile-open .app-sidebar {
    transform: translateX(0);
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading {
    text-indent: 0;
    text-indent: initial;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {
    display: none;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-link {
    text-indent: 0;
    text-indent: initial;
    padding: 0 1.5rem 0 45px;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-icon {
    text-indent: 0;
    text-indent: initial;
    left: 5px;
    margin-left: 0;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-state-icon {
    visibility: visible;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible {
    padding: 0.5em 0 0 2rem;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
    height: 2.3em;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {
    padding-left: 1em;
  }
  .sidebar-mobile-open .app-sidebar .app-header__logo {
    width: auto !important;
  }
  .sidebar-mobile-open .app-sidebar .app-header__logo .logo-src {
    width: 97px !important;
    margin-left: auto;
    margin-right: 0;
  }
  .sidebar-mobile-open .fixed-sidebar .app-sidebar {
    height: 100%;
  }
  .sidebar-mobile-open .sidebar-mobile-overlay {
    display: block;
  }
  .app-main .app-main__outer {
    padding-left: 0 !important;
    width: auto;
  }
  .app-header {
    justify-content: space-between;
  }
  .app-header .app-header__logo {
    display: none;
    order: 2;
    background: transparent !important;
    border: 0 !important;
  }
  .app-header .app-header__content {
    visibility: hidden;
    opacity: 0;
    box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);
    position: absolute;
    left: 5%;
    width: 90%;
    top: 0;
    transition: all 0.2s;
    background: #fff;
    border-radius: 50px;
    padding: 0 10px;
    overflow: hidden;
  }
  .app-header .app-header__content .header-btn-lg {
    margin-left: 0.5rem;
    padding: 0 0.5rem;
  }
  .app-header .app-header__content .header-btn-lg .hamburger-box {
    margin-top: 5px;
  }
  .app-header .app-header__content .header-btn-lg + .header-btn-lg {
    display: none;
  }
  .app-header .app-header__content .app-header-left .nav {
    display: none;
  }
  .app-header .app-header__content.header-mobile-open {
    visibility: visible;
    opacity: 1;
    top: 80px;
  }
  .app-header .app-header__mobile-menu {
    display: flex;
    order: 1;
  }
  .app-header .app-header__menu {
    display: flex;
    order: 3;
  }
  .app-header.header-text-light .app-header__menu > span .btn, .app-header.header-text-light .app-header__menu > .btn {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.1);
  }
  .app-header.header-text-light .header-mobile-open {
    background: #343a40;
  }
  .popover,
  .dropdown-menu {
    position: fixed !important;
    z-index: 50;
    left: 5% !important;
    top: 50% !important;
    width: 90% !important;
    transform: translateY(-50%) !important;
    min-width: 10px !important;
  }
  .popover .btn-icon-vertical .btn-icon-wrapper,
  .dropdown-menu .btn-icon-vertical .btn-icon-wrapper {
    display: none;
  }
  .popover {
    max-width: none;
    max-width: initial;
  }
  .popover .arrow {
    display: none !important;
  }
  .app-page-title {
    text-align: center;
  }
  .app-page-title .page-title-heading,
  .app-page-title .page-title-wrapper {
    margin: 0 auto;
    display: block;
  }
  .app-page-title .page-title-actions {
    margin: 15px auto 0;
  }
  .app-page-title .page-title-actions .breadcrumb-item,
  .app-page-title .page-title-actions .breadcrumb,
  .app-page-title .page-title-subheading .breadcrumb-item,
  .app-page-title .page-title-subheading .breadcrumb {
    display: inline-block;
  }
  .app-footer .app-footer__inner .app-footer-right {
    display: none;
  }
  .app-footer .app-footer__inner .app-footer-left {
    width: 100%;
  }
  .app-footer .app-footer__inner .app-footer-left .footer-dots {
    margin: 0 auto;
  }
  .fixed-footer.closed-sidebar .app-footer .app-footer__inner {
    margin-left: 0 !important;
  }
  .widget-content .widget-numbers {
    font-size: 1.6rem;
    line-height: 1;
  }
  .slick-slider-sm .slick-slider {
    max-width: 650px !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big {
    display: block !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {
    display: inline-block !important;
    padding: 0 1.5rem !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big .RRT__showmore {
    margin-top: -20px;
  }
  .ReactTable .-pagination .-center {
    display: none;
  }
  .ReactTable .-pagination .-previous {
    padding-right: 3px;
  }
  .bg-transparent.list-group-item {
    border-color: transparent;
  }
  .tabs-lg-alternate.card-header > .nav .nav-item .widget-number {
    font-size: 1.5rem;
  }
  .page-title-head {
    display: block;
  }
}
@media (max-width: 991.98px) {
  .app-page-title .page-title-icon,
  .ui-theme-settings {
    display: none;
  }
  .card-header.responsive-center {
    display: block;
    text-align: center;
    height: auto;
    padding: 1.5rem;
  }
  .card-header.responsive-center .nav,
  .card-header.responsive-center .btn-actions-pane-right {
    margin: 0.75rem 0 0;
  }
  .card-header.responsive-center .nav .d-inline-block.ml-2,
  .card-header.responsive-center .btn-actions-pane-right .d-inline-block.ml-2 {
    width: 100% !important;
    text-align: left;
    margin: 0 !important;
  }
  .slick-slider-sm .slick-slider {
    max-width: 650px !important;
  }
}
@media (min-width: 992px) {
  .slick-slider-sm .slick-slider {
    max-width: 850px !important;
  }
}
@media (max-width: 1199.98px) {
  .-hide-paging .-pagination .-center {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .app-main .app-main__inner {
    padding: 15px 15px 0;
  }
  .mbg-3,
  body .card.mb-3 {
    margin-bottom: 15px !important;
  }
  .app-page-title {
    padding: 15px;
    margin: -15px -15px 30px;
  }
  .body-tabs.body-tabs-layout {
    margin-left: -15px;
    margin-right: -15px;
    padding: 0 15px;
  }
  .app-main .app-main__inner > .RRT__container > .RRT__panel {
    margin-top: 15px;
  }
  .popover,
  .dropdown-menu {
    width: 80%;
    left: 10%;
  }
  body .card-header {
    height: auto;
    display: block;
    padding: 0.75rem 1.5rem;
    text-align: center;
  }
  body .card-header .btn-actions-pane-right {
    padding: 0.75rem 0 0;
  }
  body .card-header .actions-icon-btn {
    padding: 0;
  }
  .card-header.card-header-tab .card-header-title {
    display: inline-flex !important;
    line-height: 1;
  }
  .card-header.card-header-tab > .nav {
    margin: 0.75rem 0 -0.75rem;
    display: table !important;
    width: 100%;
  }
  .card-header.card-header-tab > .nav .nav-item {
    display: table-cell;
  }
  .header-icon {
    display: none;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {
    display: block;
    text-align: center;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {
    margin-right: 0 !important;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
    margin-top: 1rem;
  }
  .slick-slider-sm .slick-slider .slick-prev {
    left: 15px;
  }
  .slick-slider-sm .slick-slider .slick-next {
    right: 15px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1500px) {
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {
    display: block;
    text-align: center;
  }
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {
    margin-right: 0 !important;
  }
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
    margin-top: 1rem;
  }
}
.off-overflow .rt-table {
  overflow: visible !important;
  overflow: initial !important;
}

#taskCKEditor .ck-editor__editable_inline {
  min-height: 200px;
}

.custom-datetimepicker-task {
  width: 400px;
}

#reportCKEditor .ck-editor__editable_inline {
  min-height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/assets/base.scss","webpack://./src/assets/themes/default/_variables.scss","webpack://./src/assets/components/bootstrap4/mixins/_list-group.scss","webpack://./src/assets/components/bootstrap4/mixins/_hover.scss","webpack://./src/assets/components/bootstrap4/mixins/_background-variant.scss","webpack://./src/assets/components/bootstrap4/_root.scss","webpack://./src/assets/components/bootstrap4/_reboot.scss","webpack://./src/assets/components/bootstrap4/_variables.scss","webpack://./src/assets/components/bootstrap4/vendor/_rfs.scss","webpack://./src/assets/components/bootstrap4/_type.scss","webpack://./src/assets/components/bootstrap4/mixins/_lists.scss","webpack://./src/assets/components/bootstrap4/_images.scss","webpack://./src/assets/components/bootstrap4/mixins/_image.scss","webpack://./src/assets/components/bootstrap4/mixins/_border-radius.scss","webpack://./src/assets/components/bootstrap4/_code.scss","webpack://./src/assets/components/bootstrap4/_grid.scss","webpack://./src/assets/components/bootstrap4/mixins/_grid.scss","webpack://./src/assets/components/bootstrap4/mixins/_breakpoints.scss","webpack://./src/assets/components/bootstrap4/mixins/_grid-framework.scss","webpack://./src/assets/components/bootstrap4/_tables.scss","webpack://./src/assets/components/bootstrap4/mixins/_table-row.scss","webpack://./src/assets/components/bootstrap4/_forms.scss","webpack://./src/assets/components/bootstrap4/mixins/_transition.scss","webpack://./src/assets/components/bootstrap4/mixins/_forms.scss","webpack://./src/assets/components/bootstrap4/mixins/_gradients.scss","webpack://./src/assets/components/bootstrap4/_buttons.scss","webpack://./src/assets/components/bootstrap4/mixins/_buttons.scss","webpack://./src/assets/components/bootstrap4/_transitions.scss","webpack://./src/assets/components/bootstrap4/_dropdown.scss","webpack://./src/assets/components/bootstrap4/mixins/_caret.scss","webpack://./src/assets/components/bootstrap4/mixins/_nav-divider.scss","webpack://./src/assets/components/bootstrap4/_button-group.scss","webpack://./src/assets/components/bootstrap4/_input-group.scss","webpack://./src/assets/components/bootstrap4/_custom-forms.scss","webpack://./src/assets/components/bootstrap4/_nav.scss","webpack://./src/assets/components/bootstrap4/_navbar.scss","webpack://./src/assets/components/bootstrap4/_card.scss","webpack://./src/assets/components/bootstrap4/_breadcrumb.scss","webpack://./src/assets/components/bootstrap4/_pagination.scss","webpack://./src/assets/components/bootstrap4/mixins/_pagination.scss","webpack://./src/assets/components/bootstrap4/_badge.scss","webpack://./src/assets/components/bootstrap4/mixins/_badge.scss","webpack://./src/assets/components/bootstrap4/_jumbotron.scss","webpack://./src/assets/components/bootstrap4/_alert.scss","webpack://./src/assets/components/bootstrap4/mixins/_alert.scss","webpack://./src/assets/components/bootstrap4/_progress.scss","webpack://./src/assets/components/bootstrap4/_media.scss","webpack://./src/assets/components/bootstrap4/_list-group.scss","webpack://./src/assets/components/bootstrap4/_close.scss","webpack://./src/assets/components/bootstrap4/_toasts.scss","webpack://./src/assets/components/bootstrap4/_modal.scss","webpack://./src/assets/components/bootstrap4/_tooltip.scss","webpack://./src/assets/components/bootstrap4/mixins/_reset-text.scss","webpack://./src/assets/components/bootstrap4/_popover.scss","webpack://./src/assets/components/bootstrap4/_carousel.scss","webpack://./src/assets/components/bootstrap4/mixins/_clearfix.scss","webpack://./src/assets/components/bootstrap4/_spinners.scss","webpack://./src/assets/components/bootstrap4/utilities/_align.scss","webpack://./src/assets/components/bootstrap4/utilities/_background.scss","webpack://./src/assets/components/bootstrap4/utilities/_borders.scss","webpack://./src/assets/components/bootstrap4/utilities/_display.scss","webpack://./src/assets/components/bootstrap4/utilities/_embed.scss","webpack://./src/assets/components/bootstrap4/utilities/_flex.scss","webpack://./src/assets/components/bootstrap4/utilities/_float.scss","webpack://./src/assets/components/bootstrap4/utilities/_overflow.scss","webpack://./src/assets/components/bootstrap4/utilities/_position.scss","webpack://./src/assets/components/bootstrap4/utilities/_screenreaders.scss","webpack://./src/assets/components/bootstrap4/mixins/_screen-reader.scss","webpack://./src/assets/components/bootstrap4/utilities/_shadows.scss","webpack://./src/assets/components/bootstrap4/utilities/_sizing.scss","webpack://./src/assets/components/bootstrap4/utilities/_stretched-link.scss","webpack://./src/assets/components/bootstrap4/utilities/_spacing.scss","webpack://./src/assets/components/bootstrap4/utilities/_text.scss","webpack://./src/assets/components/bootstrap4/mixins/_text-truncate.scss","webpack://./src/assets/components/bootstrap4/mixins/_text-emphasis.scss","webpack://./src/assets/components/bootstrap4/mixins/_text-hide.scss","webpack://./src/assets/components/bootstrap4/utilities/_visibility.scss","webpack://./src/assets/layout/generic/_generic-base.scss","webpack://./src/assets/layout/generic/_animations.scss","webpack://./src/assets/layout/header/_header-base.scss","webpack://./src/assets/layout/_layout-variables.scss","webpack://./src/assets/layout/header/modifiers/_fixed-header.scss","webpack://./src/assets/layout/header/modifiers/_header-dots.scss","webpack://./src/assets/layout/header/modifiers/_header-megamenu.scss","webpack://./src/assets/layout/header/modifiers/_header-buttons.scss","webpack://./src/assets/layout/header/themes/_header-light.scss","webpack://./src/assets/layout/header/themes/_header-dark.scss","webpack://./src/assets/layout/sidebar/_sidebar-base.scss","webpack://./src/assets/layout/sidebar/modifiers/_navmenu-vertical.scss","webpack://./src/assets/layout/sidebar/themes/_sidebar-light.scss","webpack://./src/assets/layout/sidebar/themes/_sidebar-dark.scss","webpack://./src/assets/layout/sidebar/modifiers/_fixed-sidebar.scss","webpack://./src/assets/layout/sidebar/modifiers/_closed-sidebar.scss","webpack://./src/assets/layout/main/_main-base.scss","webpack://./src/assets/layout/main/themes/_main-white.scss","webpack://./src/assets/layout/main/themes/_main-gray.scss","webpack://./src/assets/layout/footer/_footer-base.scss","webpack://./src/assets/layout/footer/_fixed-footer.scss","webpack://./src/assets/layout/elements/page-title/_page-title-base.scss","webpack://./src/assets/layout/elements/search-box/_search-box.scss","webpack://./src/assets/utils/helpers/_opacity.scss","webpack://./src/assets/utils/helpers/_grayscale.scss","webpack://./src/assets/utils/_helpers.scss","webpack://./src/assets/utils/_backgrounds.scss","webpack://./node_modules/animate-sass/helpers/_base.scss","webpack://./node_modules/animate-sass/helpers/_mixins.scss","webpack://./node_modules/animate-sass/helpers/_settings.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeIn.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeInDown.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeInUp.scss","webpack://./node_modules/animate-sass/animations/fade-exit/_fadeOut.scss","webpack://./node_modules/animate-sass/animations/lightspeed/_lightSpeedIn.scss","webpack://./node_modules/animate-sass/animations/lightspeed/_lightSpeedOut.scss","webpack://./src/assets/utils/_comps-animations.scss","webpack://./src/assets/elements/_buttons.scss","webpack://./src/assets/elements/_dropdown.scss","webpack://./src/assets/elements/_navs.scss","webpack://./src/assets/elements/_badges.scss","webpack://./src/assets/elements/_cards.scss","webpack://./src/assets/elements/_tabs.scss","webpack://./src/assets/elements/_accordions.scss","webpack://./src/assets/elements/_modals.scss","webpack://./src/assets/elements/_loaders.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse.scss","webpack://./node_modules/loaders.css/src/_mixins.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse-sync.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale.scss","webpack://./node_modules/loaders.css/src/animations/ball-rotate.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate-pulse.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-ripple.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-ripple-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-beat.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-triangle-trace.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse-rise.scss","webpack://./node_modules/loaders.css/src/animations/ball-grid-beat.scss","webpack://./node_modules/loaders.css/src/animations/ball-grid-pulse.scss","webpack://./node_modules/loaders.css/src/animations/ball-spin-fade-loader.scss","webpack://./node_modules/loaders.css/src/animations/ball-spin-loader.scss","webpack://./node_modules/loaders.css/src/animations/ball-zig-zag.scss","webpack://./node_modules/loaders.css/src/animations/ball-zig-zag-deflect.scss","webpack://./node_modules/loaders.css/src/animations/line-scale.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-random.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-pulse-out.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-pulse-out-rapid.scss","webpack://./node_modules/loaders.css/src/animations/line-spin-fade-loader.scss","webpack://./node_modules/loaders.css/src/animations/triangle-skew-spin.scss","webpack://./node_modules/loaders.css/src/animations/square-spin.scss","webpack://./node_modules/loaders.css/src/animations/pacman.scss","webpack://./node_modules/loaders.css/src/animations/cube-transition.scss","webpack://./node_modules/loaders.css/src/animations/semi-circle-spin.scss","webpack://./src/assets/elements/_progressbar.scss","webpack://./src/assets/elements/_timeline.scss","webpack://./src/assets/elements/listgroup.scss","webpack://./src/assets/elements/_forms.scss","webpack://./src/assets/elements/_pagination.scss","webpack://./src/assets/elements/_chat.scss","webpack://./src/assets/elements/_forms-wizard.scss","webpack://./src/assets/widgets/chart-boxes/_chart-boxes.scss","webpack://./src/assets/widgets/content-boxes/_content-boxes.scss","webpack://./src/assets/widgets/profile-boxes/_profile-boxes.scss","webpack://./src/assets/pages/_userpages.scss","webpack://./src/assets/applications/_applications-base.scss","webpack://./src/assets/applications/_chat.scss","webpack://./src/assets/applications/_responsive.scss","webpack://./src/assets/components/perfect-scrollbar/_perfect-scrollbar.scss","webpack://./src/assets/components/rc-tabs/_rc-tabs.scss","webpack://./src/assets/components/loading-buttons/_loading-buttons.scss","webpack://./src/assets/components/hamburgers/hamburgers.scss","webpack://./src/assets/components/hamburgers/_base.scss","webpack://./src/assets/components/hamburgers/types/_elastic.scss","webpack://./src/assets/components/drawer/_drawer.scss","webpack://./src/assets/components/notifications/_sweetalerts.scss","webpack://./src/assets/components/notifications/toastify/_toastContainer.scss","webpack://./src/assets/components/notifications/toastify/_variables.scss","webpack://./src/assets/components/notifications/toastify/_toast.scss","webpack://./src/assets/components/notifications/toastify/_closeButton.scss","webpack://./src/assets/components/notifications/toastify/_progressBar.scss","webpack://./src/assets/components/notifications/toastify/animations/_bounce.scss","webpack://./src/assets/components/notifications/toastify/animations/_zoom.scss","webpack://./src/assets/components/notifications/toastify/animations/_flip.scss","webpack://./src/assets/components/notifications/toastify/animations/_slide.scss","webpack://./src/assets/components/modals/_rodal.scss","webpack://./src/assets/components/progress-bar/_progress-bar.scss","webpack://./src/assets/components/slick-carousel/slick/_slick.scss","webpack://./src/assets/components/slick-carousel/slick/_slick-theme.scss","webpack://./src/assets/components/block-loading/_block-loading.scss","webpack://./src/assets/components/popovers-tooltips/_popovers-tooltips.scss","webpack://./src/assets/components/sticky-elements/_sticky-elements.scss","webpack://./src/assets/components/calendar/scss/_reset.scss","webpack://./src/assets/components/calendar/_calendar.scss","webpack://./src/assets/components/calendar/scss/_variables.scss","webpack://./src/assets/components/calendar/scss/_toolbar.scss","webpack://./src/assets/components/calendar/scss/_event.scss","webpack://./src/assets/components/calendar/scss/_month.scss","webpack://./src/assets/components/calendar/scss/_agenda.scss","webpack://./src/assets/components/calendar/scss/_time-column.scss","webpack://./src/assets/components/calendar/scss/_time-grid.scss","webpack://./src/assets/components/splitters/_splitters.scss","webpack://./src/assets/components/tree-view/_tree-view.scss","webpack://./src/assets/components/tables/_tables.scss","webpack://./src/assets/components/icons/_linearicons.scss","webpack://./node_modules/pe7-icon/dist/scss/pe-icon-7-stroke.scss","webpack://./node_modules/pe7-icon/dist/scss/_path.scss","webpack://./node_modules/pe7-icon/dist/scss/_core.scss","webpack://./node_modules/pe7-icon/dist/scss/_helper.scss","webpack://./node_modules/pe7-icon/dist/scss/_icons.scss","webpack://./node_modules/pe7-icon/dist/scss/_variables.scss","webpack://./src/assets/components/forms/datepicker/_mixins.scss","webpack://./src/assets/components/forms/datepicker/_variables.scss","webpack://./src/assets/components/forms/datepicker/_datepicker.scss","webpack://./src/assets/components/forms/rangeslider/_tooltip.scss","webpack://./src/assets/components/forms/rangeslider/_rangeslider.scss","webpack://./src/assets/components/forms/wysiwyg/_wysiwyg.scss","webpack://./src/assets/components/forms/toggle-switch/_switch.scss","webpack://./src/assets/components/forms/dropzone/_dropzone.scss","webpack://./src/assets/components/forms/typeahead/_typeahead.scss","webpack://./src/assets/components/forms/typeahead/_mixins.scss","webpack://./src/assets/components/react-widgets/scss/normalize.scss","webpack://./src/assets/components/react-widgets/scss/icons.scss","webpack://./src/assets/components/react-widgets/scss/widget.scss","webpack://./src/assets/components/react-widgets/scss/mixins.scss","webpack://./src/assets/components/react-widgets/scss/variables.scss","webpack://./src/assets/components/react-widgets/scss/list.scss","webpack://./src/assets/components/react-widgets/scss/dropdown-list.scss","webpack://./src/assets/components/react-widgets/scss/number-picker.scss","webpack://./src/assets/components/react-widgets/scss/select-list.scss","webpack://./src/assets/components/react-widgets/scss/multiselect.scss","webpack://./src/assets/components/react-widgets/scss/popup.scss","webpack://./src/assets/components/react-widgets/scss/state.scss","webpack://./src/assets/demo-ui/elements/_theme-options.scss","webpack://./src/assets/demo-ui/_demo.scss","webpack://./src/assets/layout/responsive/_responsive-base.scss","webpack://./src/assets/tasking/tasking.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC+Kd;EACE,qBA1GW;ADnEf;;AC4KE;EACE,qBA1GW;AD/Df;;ACwKE;EACE,qBA1GW;AD3Df;;ACoKE;EACE,qBA1GW;ADvDf;;ACgKE;EACE,qBA1GW;ADnDf;;AC4JE;EACE,qBA1GW;AD/Cf;;ACwJE;EACE,qBA1GW;AD3Cf;;ACoJE;EACE,qBA1GW;ADvCf;;ACgJE;EACE,qBA1GW;ADnCf;;AC4IE;EACE,qBA1GW;AD/Bf;;AEpCE;EACE,0DDmLsE;EClLtE,qEDkLuC;AD3I3C;AG5BE;EDPM,0DD8KkE;EC7KlE,qEAAA;AFsCR;AEnCM;EACE,WAAA;EACA,qEDwKkE;ECvKlE,iEDuKkE;ADlI1E;;AElDE;EACE,0DDmLsE;EClLtE,qEDkLuC;AD7H3C;AG1CE;EDPM,0DD8KkE;EC7KlE,oEAAA;AFoDR;AEjDM;EACE,WAAA;EACA,qEDwKkE;ECvKlE,iEDuKkE;ADpH1E;;AEhEE;EACE,yDDmLsE;EClLtE,oEDkLuC;AD/G3C;AGxDE;EDPM,yDD8KkE;EC7KlE,oEAAA;AFkER;AE/DM;EACE,WAAA;EACA,oEDwKkE;ECvKlE,gEDuKkE;ADtG1E;;AE9EE;EACE,8CDmLsE;EClLtE,2DDkLuC;ADjG3C;AGtEE;EDPM,8CD8KkE;EC7KlE,2DAAA;AFgFR;AE7EM;EACE,WAAA;EACA,yDDwKkE;ECvKlE,qDDuKkE;ADxF1E;;AE5FE;EACE,wDDmLsE;EClLtE,qEDkLuC;ADnF3C;AGpFE;EDPM,wDD8KkE;EC7KlE,kEAAA;AF8FR;AE3FM;EACE,WAAA;EACA,mEDwKkE;ECvKlE,+DDuKkE;AD1E1E;;AE1GE;EACE,yDDmLsE;EClLtE,oEDkLuC;ADrE3C;AGlGE;EDPM,yDD8KkE;EC7KlE,oEAAA;AF4GR;AEzGM;EACE,WAAA;EACA,oEDwKkE;ECvKlE,gEDuKkE;AD5D1E;;AExHE;EACE,0DDmLsE;EClLtE,qEDkLuC;ADvD3C;AGhHE;EDPM,0DD8KkE;EC7KlE,qEAAA;AF0HR;AEvHM;EACE,WAAA;EACA,qEDwKkE;ECvKlE,iEDuKkE;AD9C1E;;AEtIE;EACE,0DDmLsE;EClLtE,oEDkLuC;ADzC3C;AG9HE;EDPM,0DD8KkE;EC7KlE,oEAAA;AFwIR;AErIM;EACE,WAAA;EACA,qEDwKkE;ECvKlE,iEDuKkE;ADhC1E;;AEpJE;EACE,0DDmLsE;EClLtE,qEDkLuC;AD3B3C;AG5IE;EDPM,0DD8KkE;EC7KlE,qEAAA;AFsJR;AEnJM;EACE,WAAA;EACA,qEDwKkE;ECvKlE,iEDuKkE;ADlB1E;;AElKE;EACE,0DDmLsE;EClLtE,oEDkLuC;ADb3C;AG1JE;EDPM,0DD8KkE;EC7KlE,qEAAA;AFoKR;AEjKM;EACE,WAAA;EACA,qEDwKkE;ECvKlE,iEDuKkE;ADJ1E;;AI9KE;EACE,oCAAA;AJiLJ;;AGvKE;;;ECLI,+EAAA;AJkLN;;AIxLE;EACE,oCAAA;AJ2LJ;;AGjLE;;;ECLI,gFAAA;AJ4LN;;AIlME;EACE,oCAAA;AJqMJ;;AG3LE;;;ECLI,gFAAA;AJsMN;;AI5ME;EACE,oCAAA;AJ+MJ;;AGrME;;;ECLI,oEAAA;AJgNN;;AItNE;EACE,oCAAA;AJyNJ;;AG/ME;;;ECLI,8EAAA;AJ0NN;;AIhOE;EACE,oCAAA;AJmOJ;;AGzNE;;;ECLI,gFAAA;AJoON;;AI1OE;EACE,oCAAA;AJ6OJ;;AGnOE;;;ECLI,gFAAA;AJ8ON;;AIpPE;EACE,oCAAA;AJuPJ;;AG7OE;;;ECLI,gFAAA;AJwPN;;AI9PE;EACE,oCAAA;AJiQJ;;AGvPE;;;ECLI,+EAAA;AJkQN;;AIxQE;EACE,oCAAA;AJ2QJ;;AGjQE;;;ECLI,gFAAA;AJ4QN;;AKvRA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,gBAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,+MAAA;EACA,6GAAA;ALuSF;;AMtSA;;;EAGE,sBAAA;ANySF;;AMtSA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;ANySF;;AMnSA;EACE,cAAA;ANsSF;;AM5RA;EACE,SAAA;EACA,kMCiO4B;ECjJxB,kBAtCa;EFxCjB,gBC0O4B;EDzO5B,gBC8O4B;ED7O5B,cL9BS;EK+BT,gBAAA;EACA,sBL3CQ;AD0UV;;AMvRA;EACE,qBAAA;AN0RF;;AMjRA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;ANoRF;;AMvQA;EACE,aAAA;EACA,qBCgN4B;AP0D9B;;AMnQA;EACE,aAAA;EACA,mBCoF0B;APkL5B;;AM3PA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,sCAAA;UAAA,8BAAA;AN8PF;;AM3PA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AN8PF;;AM3PA;;;EAGE,aAAA;EACA,mBAAA;AN8PF;;AM3PA;;;;EAIE,gBAAA;AN8PF;;AM3PA;EACE,gBCiJ4B;AP6G9B;;AM3PA;EACE,qBAAA;EACA,cAAA;AN8PF;;AM3PA;EACE,gBAAA;AN8PF;;AM3PA;;EAEE,mBCoI4B;AP0H9B;;AM3PA;EEpFI,cAAA;ARmVJ;;AMtPA;;EAEE,kBAAA;EE/FE,cAAA;EFiGF,cAAA;EACA,wBAAA;ANyPF;;AMtPA;EAAM,eAAA;AN0PN;;AMzPA;EAAM,WAAA;AN6PN;;AMtPA;EACE,cLpCW;EKqCX,qBCXwC;EDYxC,6BAAA;ANyPF;AGraE;EG+KE,mCCdsC;EDetC,0BCdsC;APuQ1C;;AM/OA;EACE,cAAA;EACA,qBAAA;ANkPF;AG1aE;EG2LE,cAAA;EACA,qBAAA;ANkPJ;AM/OE;EACE,UAAA;ANiPJ;;AMxOA;;;;EAIE,iGCoD4B;ECzM1B,cAAA;ARiYJ;;AMxOA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;ANwOF;;AMhOA;EAEE,gBAAA;ANkOF;;AM1NA;EACE,sBAAA;EACA,kBAAA;AN6NF;;AM1NA;EAGE,gBAAA;EACA,sBAAA;AN2NF;;AMnNA;EACE,yBAAA;ANsNF;;AMnNA;EACE,oBLzImB;EK0InB,uBL1ImB;EK2InB,cCpQS;EDqQT,gBAAA;EACA,oBAAA;ANsNF;;AMnNA;EAGE,mBAAA;ANoNF;;AM5MA;EAEE,qBAAA;EACA,qBC4JsC;APkDxC;;AMxMA;EAEE,gBAAA;AN0MF;;AMnMA;EACE,mBAAA;EACA,0CAAA;ANsMF;;AMnMA;;;;;EAKE,SAAA;EACA,oBAAA;EEtPE,kBAAA;EFwPF,oBAAA;ANsMF;;AMnMA;;EAEE,iBAAA;ANsMF;;AMnMA;;EAEE,oBAAA;ANsMF;;AMhMA;EACE,iBAAA;ANmMF;;AM5LA;;;;EAIE,0BAAA;AN+LF;;AMtLI;;;;EACE,eAAA;AN4LN;;AMtLA;;;;EAIE,UAAA;EACA,kBAAA;ANyLF;;AMtLA;;EAEE,sBAAA;EACA,UAAA;ANyLF;;AMrLA;;;;EASE,2BAAA;ANmLF;;AMhLA;EACE,cAAA;EAEA,gBAAA;ANkLF;;AM/KA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AN4KF;;AMvKA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EElSI,iBAtCa;EF0UjB,oBAAA;EACA,cAAA;EACA,mBAAA;AN0KF;;AMvKA;EACE,wBAAA;AN0KF;;AMtKA;;EAEE,YAAA;ANyKF;;AMtKA;EAKE,oBAAA;EACA,wBAAA;ANqKF;;AM9JA;EACE,wBAAA;ANiKF;;AMzJA;EACE,aAAA;EACA,0BAAA;AN4JF;;AMrJA;EACE,qBAAA;ANwJF;;AMrJA;EACE,kBAAA;EACA,eAAA;ANwJF;;AMrJA;EACE,aAAA;ANwJF;;AMnJA;EACE,wBAAA;ANsJF;;ASjnBA;;EAEE,qBFiS4B;EE/R5B,gBR8EqB;EQ7ErB,gBFiS4B;APkV9B;;AS/mBA;EDgHM,iBAtCa;ARyiBnB;;ASlnBA;ED+GM,eAtCa;AR6iBnB;;ASrnBA;ED8GM,kBAtCa;ARijBnB;;ASxnBA;ED6GM,iBAtCa;ARqjBnB;;AS3nBA;ED4GM,kBAtCa;ARyjBnB;;AS9nBA;ED2GM,eAtCa;AR6jBnB;;AShoBA;EDyGM,kBAtCa;ECjEjB,gBFmS4B;APgW9B;;AS/nBA;EDmGM,eAtCa;EC3DjB,gBFsR4B;EErR5B,gBF6Q4B;APqX9B;;AShoBA;ED8FM,iBAtCa;ECtDjB,gBFkR4B;EEjR5B,gBFwQ4B;AP2X9B;;ASjoBA;EDyFM,iBAtCa;ECjDjB,gBF8Q4B;EE7Q5B,gBFmQ4B;APiY9B;;ASloBA;EDoFM,iBAtCa;EC5CjB,gBF0Q4B;EEzQ5B,gBF8P4B;APuY9B;;AS7nBA;EACE,gBF0EO;EEzEP,mBFyEO;EExEP,SAAA;EACA,wCAAA;ATgoBF;;ASxnBA;;EDMI,cAAA;ECHF,gBFsN4B;APqa9B;;ASxnBA;;EAEE,cF8P4B;EE7P5B,yBFsQ4B;APqX9B;;ASnnBA;EC/EE,eAAA;EACA,gBAAA;AVssBF;;ASnnBA;ECpFE,eAAA;EACA,gBAAA;AV2sBF;;ASrnBA;EACE,qBAAA;ATwnBF;AStnBE;EACE,oBFgP0B;APwY9B;;AS9mBA;EDjCI,cAAA;ECmCF,yBAAA;ATinBF;;AS7mBA;EACE,mBFiBO;ECFH,kBAtCa;ARwoBnB;;AS7mBA;EACE,cAAA;ED7CE,cAAA;EC+CF,cF1GS;AP0tBX;AS9mBE;EACE,aAAA;ATgnBJ;;AWnuBA;ECIE,eAAA;EAGA,YAAA;AZiuBF;;AWluBA;EACE,gBJ++BkC;EI9+BlC,sBJRS;EIST,yBAAA;EEXE,sBNqO0B;EK/N5B,eAAA;EAGA,YAAA;AZ0uBF;;AW5tBA;EAEE,qBAAA;AX8tBF;;AW3tBA;EACE,qBAAA;EACA,cAAA;AX8tBF;;AW3tBA;EHkCI,cAAA;EGhCF,cJ3BS;APyvBX;;AcrwBA;ENuEI,gBAAA;EMrEF,cPoCQ;EOnCR,sBAAA;AdwwBF;AcrwBE;EACE,cAAA;AduwBJ;;AclwBA;EACE,sBAAA;EN0DE,gBAAA;EMxDF,WPTS;EOUT,yBPDS;EMXP,qBNuO0B;AP2iB9B;AclwBE;EACE,UAAA;ENkDA,eAAA;EMhDA,gBPoQ0B;APggB9B;;Ac9vBA;EACE,cAAA;ENyCE,gBAAA;EMvCF,cPjBS;APkxBX;Ac9vBE;ENoCE,kBAAA;EMlCA,cAAA;EACA,kBAAA;AdgwBJ;;Ac3vBA;EACE,iBPwiCkC;EOviClC,kBAAA;Ad8vBF;;AevyBE;ECAA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AhB2yBF;AiBxvBI;EFvDF;ICYI,gBT6LiB;EP0mBrB;AACF;AiB7vBI;EFvDF;ICYI,gBT6LiB;EP+mBrB;AACF;AiBlwBI;EFvDF;ICYI,gBT6LiB;EPonBrB;AACF;AiBvwBI;EFvDF;ICYI,iBT6LiB;EPynBrB;AACF;;AevzBE;ECZA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AhBu0BF;;AerzBE;ECJA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AhB6zBF;;AetzBE;EACE,eAAA;EACA,cAAA;AfyzBJ;AevzBI;;EAEE,gBAAA;EACA,eAAA;AfyzBN;;AkB11BE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AlBk2BJ;;AkB/0BM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AlBk1BR;;AkBh1BM;EACE,cAAA;EACA,WAAA;EACA,eAAA;AlBm1BR;;AkB/0BQ;EFFN,uBAAA;EAIA,wBAAA;AhBk1BF;;AkBp1BQ;EFFN,wBAAA;EAIA,yBAAA;AhBu1BF;;AkBz1BQ;EFFN,aAAA;EAIA,cAAA;AhB41BF;;AkB91BQ;EFFN,wBAAA;EAIA,yBAAA;AhBi2BF;;AkBn2BQ;EFFN,wBAAA;EAIA,yBAAA;AhBs2BF;;AkBx2BQ;EFFN,aAAA;EAIA,cAAA;AhB22BF;;AkB72BQ;EFFN,wBAAA;EAIA,yBAAA;AhBg3BF;;AkBl3BQ;EFFN,wBAAA;EAIA,yBAAA;AhBq3BF;;AkBv3BQ;EFFN,aAAA;EAIA,cAAA;AhB03BF;;AkB53BQ;EFFN,wBAAA;EAIA,yBAAA;AhB+3BF;;AkBj4BQ;EFFN,wBAAA;EAIA,yBAAA;AhBo4BF;;AkBt4BQ;EFFN,cAAA;EAIA,eAAA;AhBy4BF;;AkBt4BM;EAAwB,SAAA;AlB04B9B;;AkBx4BM;EAAuB,SAAA;AlB44B7B;;AkBz4BQ;EAAwB,QADb;AlB84BnB;;AkB74BQ;EAAwB,QADb;AlBk5BnB;;AkBj5BQ;EAAwB,QADb;AlBs5BnB;;AkBr5BQ;EAAwB,QADb;AlB05BnB;;AkBz5BQ;EAAwB,QADb;AlB85BnB;;AkB75BQ;EAAwB,QADb;AlBk6BnB;;AkBj6BQ;EAAwB,QADb;AlBs6BnB;;AkBr6BQ;EAAwB,QADb;AlB06BnB;;AkBz6BQ;EAAwB,QADb;AlB86BnB;;AkB76BQ;EAAwB,QADb;AlBk7BnB;;AkBj7BQ;EAAwB,SADb;AlBs7BnB;;AkBr7BQ;EAAwB,SADb;AlB07BnB;;AkBz7BQ;EAAwB,SADb;AlB87BnB;;AkBv7BU;EFTR,0BAAA;AhBo8BF;;AkB37BU;EFTR,2BAAA;AhBw8BF;;AkB/7BU;EFTR,gBAAA;AhB48BF;;AkBn8BU;EFTR,2BAAA;AhBg9BF;;AkBv8BU;EFTR,2BAAA;AhBo9BF;;AkB38BU;EFTR,gBAAA;AhBw9BF;;AkB/8BU;EFTR,2BAAA;AhB49BF;;AkBn9BU;EFTR,2BAAA;AhBg+BF;;AkBv9BU;EFTR,gBAAA;AhBo+BF;;AkB39BU;EFTR,2BAAA;AhBw+BF;;AkB/9BU;EFTR,2BAAA;AhB4+BF;;AiBj+BI;EC9BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElBmgCN;EkBjgCI;IACE,cAAA;IACA,WAAA;IACA,eAAA;ElBmgCN;EkB//BM;IFFN,uBAAA;IAIA,wBAAA;EhBigCA;EkBngCM;IFFN,wBAAA;IAIA,yBAAA;EhBqgCA;EkBvgCM;IFFN,aAAA;IAIA,cAAA;EhBygCA;EkB3gCM;IFFN,wBAAA;IAIA,yBAAA;EhB6gCA;EkB/gCM;IFFN,wBAAA;IAIA,yBAAA;EhBihCA;EkBnhCM;IFFN,aAAA;IAIA,cAAA;EhBqhCA;EkBvhCM;IFFN,wBAAA;IAIA,yBAAA;EhByhCA;EkB3hCM;IFFN,wBAAA;IAIA,yBAAA;EhB6hCA;EkB/hCM;IFFN,aAAA;IAIA,cAAA;EhBiiCA;EkBniCM;IFFN,wBAAA;IAIA,yBAAA;EhBqiCA;EkBviCM;IFFN,wBAAA;IAIA,yBAAA;EhByiCA;EkB3iCM;IFFN,cAAA;IAIA,eAAA;EhB6iCA;EkB1iCI;IAAwB,SAAA;ElB6iC5B;EkB3iCI;IAAuB,SAAA;ElB8iC3B;EkB3iCM;IAAwB,QADb;ElB+iCjB;EkB9iCM;IAAwB,QADb;ElBkjCjB;EkBjjCM;IAAwB,QADb;ElBqjCjB;EkBpjCM;IAAwB,QADb;ElBwjCjB;EkBvjCM;IAAwB,QADb;ElB2jCjB;EkB1jCM;IAAwB,QADb;ElB8jCjB;EkB7jCM;IAAwB,QADb;ElBikCjB;EkBhkCM;IAAwB,QADb;ElBokCjB;EkBnkCM;IAAwB,QADb;ElBukCjB;EkBtkCM;IAAwB,QADb;ElB0kCjB;EkBzkCM;IAAwB,SADb;ElB6kCjB;EkB5kCM;IAAwB,SADb;ElBglCjB;EkB/kCM;IAAwB,SADb;ElBmlCjB;EkB5kCQ;IFTR,cAAA;EhBwlCA;EkB/kCQ;IFTR,0BAAA;EhB2lCA;EkBllCQ;IFTR,2BAAA;EhB8lCA;EkBrlCQ;IFTR,gBAAA;EhBimCA;EkBxlCQ;IFTR,2BAAA;EhBomCA;EkB3lCQ;IFTR,2BAAA;EhBumCA;EkB9lCQ;IFTR,gBAAA;EhB0mCA;EkBjmCQ;IFTR,2BAAA;EhB6mCA;EkBpmCQ;IFTR,2BAAA;EhBgnCA;EkBvmCQ;IFTR,gBAAA;EhBmnCA;EkB1mCQ;IFTR,2BAAA;EhBsnCA;EkB7mCQ;IFTR,2BAAA;EhBynCA;AACF;AiB/mCI;EC9BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElBgpCN;EkB9oCI;IACE,cAAA;IACA,WAAA;IACA,eAAA;ElBgpCN;EkB5oCM;IFFN,uBAAA;IAIA,wBAAA;EhB8oCA;EkBhpCM;IFFN,wBAAA;IAIA,yBAAA;EhBkpCA;EkBppCM;IFFN,aAAA;IAIA,cAAA;EhBspCA;EkBxpCM;IFFN,wBAAA;IAIA,yBAAA;EhB0pCA;EkB5pCM;IFFN,wBAAA;IAIA,yBAAA;EhB8pCA;EkBhqCM;IFFN,aAAA;IAIA,cAAA;EhBkqCA;EkBpqCM;IFFN,wBAAA;IAIA,yBAAA;EhBsqCA;EkBxqCM;IFFN,wBAAA;IAIA,yBAAA;EhB0qCA;EkB5qCM;IFFN,aAAA;IAIA,cAAA;EhB8qCA;EkBhrCM;IFFN,wBAAA;IAIA,yBAAA;EhBkrCA;EkBprCM;IFFN,wBAAA;IAIA,yBAAA;EhBsrCA;EkBxrCM;IFFN,cAAA;IAIA,eAAA;EhB0rCA;EkBvrCI;IAAwB,SAAA;ElB0rC5B;EkBxrCI;IAAuB,SAAA;ElB2rC3B;EkBxrCM;IAAwB,QADb;ElB4rCjB;EkB3rCM;IAAwB,QADb;ElB+rCjB;EkB9rCM;IAAwB,QADb;ElBksCjB;EkBjsCM;IAAwB,QADb;ElBqsCjB;EkBpsCM;IAAwB,QADb;ElBwsCjB;EkBvsCM;IAAwB,QADb;ElB2sCjB;EkB1sCM;IAAwB,QADb;ElB8sCjB;EkB7sCM;IAAwB,QADb;ElBitCjB;EkBhtCM;IAAwB,QADb;ElBotCjB;EkBntCM;IAAwB,QADb;ElButCjB;EkBttCM;IAAwB,SADb;ElB0tCjB;EkBztCM;IAAwB,SADb;ElB6tCjB;EkB5tCM;IAAwB,SADb;ElBguCjB;EkBztCQ;IFTR,cAAA;EhBquCA;EkB5tCQ;IFTR,0BAAA;EhBwuCA;EkB/tCQ;IFTR,2BAAA;EhB2uCA;EkBluCQ;IFTR,gBAAA;EhB8uCA;EkBruCQ;IFTR,2BAAA;EhBivCA;EkBxuCQ;IFTR,2BAAA;EhBovCA;EkB3uCQ;IFTR,gBAAA;EhBuvCA;EkB9uCQ;IFTR,2BAAA;EhB0vCA;EkBjvCQ;IFTR,2BAAA;EhB6vCA;EkBpvCQ;IFTR,gBAAA;EhBgwCA;EkBvvCQ;IFTR,2BAAA;EhBmwCA;EkB1vCQ;IFTR,2BAAA;EhBswCA;AACF;AiB5vCI;EC9BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElB6xCN;EkB3xCI;IACE,cAAA;IACA,WAAA;IACA,eAAA;ElB6xCN;EkBzxCM;IFFN,uBAAA;IAIA,wBAAA;EhB2xCA;EkB7xCM;IFFN,wBAAA;IAIA,yBAAA;EhB+xCA;EkBjyCM;IFFN,aAAA;IAIA,cAAA;EhBmyCA;EkBryCM;IFFN,wBAAA;IAIA,yBAAA;EhBuyCA;EkBzyCM;IFFN,wBAAA;IAIA,yBAAA;EhB2yCA;EkB7yCM;IFFN,aAAA;IAIA,cAAA;EhB+yCA;EkBjzCM;IFFN,wBAAA;IAIA,yBAAA;EhBmzCA;EkBrzCM;IFFN,wBAAA;IAIA,yBAAA;EhBuzCA;EkBzzCM;IFFN,aAAA;IAIA,cAAA;EhB2zCA;EkB7zCM;IFFN,wBAAA;IAIA,yBAAA;EhB+zCA;EkBj0CM;IFFN,wBAAA;IAIA,yBAAA;EhBm0CA;EkBr0CM;IFFN,cAAA;IAIA,eAAA;EhBu0CA;EkBp0CI;IAAwB,SAAA;ElBu0C5B;EkBr0CI;IAAuB,SAAA;ElBw0C3B;EkBr0CM;IAAwB,QADb;ElBy0CjB;EkBx0CM;IAAwB,QADb;ElB40CjB;EkB30CM;IAAwB,QADb;ElB+0CjB;EkB90CM;IAAwB,QADb;ElBk1CjB;EkBj1CM;IAAwB,QADb;ElBq1CjB;EkBp1CM;IAAwB,QADb;ElBw1CjB;EkBv1CM;IAAwB,QADb;ElB21CjB;EkB11CM;IAAwB,QADb;ElB81CjB;EkB71CM;IAAwB,QADb;ElBi2CjB;EkBh2CM;IAAwB,QADb;ElBo2CjB;EkBn2CM;IAAwB,SADb;ElBu2CjB;EkBt2CM;IAAwB,SADb;ElB02CjB;EkBz2CM;IAAwB,SADb;ElB62CjB;EkBt2CQ;IFTR,cAAA;EhBk3CA;EkBz2CQ;IFTR,0BAAA;EhBq3CA;EkB52CQ;IFTR,2BAAA;EhBw3CA;EkB/2CQ;IFTR,gBAAA;EhB23CA;EkBl3CQ;IFTR,2BAAA;EhB83CA;EkBr3CQ;IFTR,2BAAA;EhBi4CA;EkBx3CQ;IFTR,gBAAA;EhBo4CA;EkB33CQ;IFTR,2BAAA;EhBu4CA;EkB93CQ;IFTR,2BAAA;EhB04CA;EkBj4CQ;IFTR,gBAAA;EhB64CA;EkBp4CQ;IFTR,2BAAA;EhBg5CA;EkBv4CQ;IFTR,2BAAA;EhBm5CA;AACF;AiBz4CI;EC9BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElB06CN;EkBx6CI;IACE,cAAA;IACA,WAAA;IACA,eAAA;ElB06CN;EkBt6CM;IFFN,uBAAA;IAIA,wBAAA;EhBw6CA;EkB16CM;IFFN,wBAAA;IAIA,yBAAA;EhB46CA;EkB96CM;IFFN,aAAA;IAIA,cAAA;EhBg7CA;EkBl7CM;IFFN,wBAAA;IAIA,yBAAA;EhBo7CA;EkBt7CM;IFFN,wBAAA;IAIA,yBAAA;EhBw7CA;EkB17CM;IFFN,aAAA;IAIA,cAAA;EhB47CA;EkB97CM;IFFN,wBAAA;IAIA,yBAAA;EhBg8CA;EkBl8CM;IFFN,wBAAA;IAIA,yBAAA;EhBo8CA;EkBt8CM;IFFN,aAAA;IAIA,cAAA;EhBw8CA;EkB18CM;IFFN,wBAAA;IAIA,yBAAA;EhB48CA;EkB98CM;IFFN,wBAAA;IAIA,yBAAA;EhBg9CA;EkBl9CM;IFFN,cAAA;IAIA,eAAA;EhBo9CA;EkBj9CI;IAAwB,SAAA;ElBo9C5B;EkBl9CI;IAAuB,SAAA;ElBq9C3B;EkBl9CM;IAAwB,QADb;ElBs9CjB;EkBr9CM;IAAwB,QADb;ElBy9CjB;EkBx9CM;IAAwB,QADb;ElB49CjB;EkB39CM;IAAwB,QADb;ElB+9CjB;EkB99CM;IAAwB,QADb;ElBk+CjB;EkBj+CM;IAAwB,QADb;ElBq+CjB;EkBp+CM;IAAwB,QADb;ElBw+CjB;EkBv+CM;IAAwB,QADb;ElB2+CjB;EkB1+CM;IAAwB,QADb;ElB8+CjB;EkB7+CM;IAAwB,QADb;ElBi/CjB;EkBh/CM;IAAwB,SADb;ElBo/CjB;EkBn/CM;IAAwB,SADb;ElBu/CjB;EkBt/CM;IAAwB,SADb;ElB0/CjB;EkBn/CQ;IFTR,cAAA;EhB+/CA;EkBt/CQ;IFTR,0BAAA;EhBkgDA;EkBz/CQ;IFTR,2BAAA;EhBqgDA;EkB5/CQ;IFTR,gBAAA;EhBwgDA;EkB//CQ;IFTR,2BAAA;EhB2gDA;EkBlgDQ;IFTR,2BAAA;EhB8gDA;EkBrgDQ;IFTR,gBAAA;EhBihDA;EkBxgDQ;IFTR,2BAAA;EhBohDA;EkB3gDQ;IFTR,2BAAA;EhBuhDA;EkB9gDQ;IFTR,gBAAA;EhB0hDA;EkBjhDQ;IFTR,2BAAA;EhB6hDA;EkBphDQ;IFTR,2BAAA;EhBgiDA;AACF;AmB9kDA;EACE,WAAA;EACA,mBZ2HO;EY1HP,cZSS;APukDX;AmB7kDE;;EAEE,gBlB0HiB;EkBzHjB,mBAAA;EACA,6BAAA;AnB+kDJ;AmB5kDE;EACE,sBAAA;EACA,gCAAA;AnB8kDJ;AmB3kDE;EACE,6BAAA;AnB6kDJ;;AmBnkDE;;EAEE,elBoGoB;ADk+CxB;;AmB7jDA;EACE,yBAAA;AnBgkDF;AmB9jDE;;EAEE,yBAAA;AnBgkDJ;AmB5jDI;;EAEE,wBAAA;AnB8jDN;;AmBxjDE;;;;EAIE,SAAA;AnB2jDJ;;AmBljDE;EACE,qClBqDc;ADggDlB;;AGpnDE;EgB2EI,cZvEK;EYwEL,yBlBmBmB;AD0hDzB;;AoB/nDI;;;EAGE,qED2F+B;AnBuiDrC;AoB9nDM;;;;EAIE,iEDmFyE;AnB6iDjF;;AGroDE;EiBiBM,qEAJe;ApB4nDvB;AoBtnDQ;;EAEE,qEARa;ApBgoDvB;;AoBnpDI;;;EAGE,qED2F+B;AnB2jDrC;AoBlpDM;;;;EAIE,iEDmFyE;AnBikDjF;;AGzpDE;EiBiBM,oEAJe;ApBgpDvB;AoB1oDQ;;EAEE,oEARa;ApBopDvB;;AoBvqDI;;;EAGE,oED2F+B;AnB+kDrC;AoBtqDM;;;;EAIE,gEDmFyE;AnBqlDjF;;AG7qDE;EiBiBM,oEAJe;ApBoqDvB;AoB9pDQ;;EAEE,oEARa;ApBwqDvB;;AoB3rDI;;;EAGE,2DD2F+B;AnBmmDrC;AoB1rDM;;;;EAIE,uDDmFyE;AnBymDjF;;AGjsDE;EiBiBM,2DAJe;ApBwrDvB;AoBlrDQ;;EAEE,2DARa;ApB4rDvB;;AoB/sDI;;;EAGE,qED2F+B;AnBunDrC;AoB9sDM;;;;EAIE,gEDmFyE;AnB6nDjF;;AGrtDE;EiBiBM,kEAJe;ApB4sDvB;AoBtsDQ;;EAEE,kEARa;ApBgtDvB;;AoBnuDI;;;EAGE,oED2F+B;AnB2oDrC;AoBluDM;;;;EAIE,iEDmFyE;AnBipDjF;;AGzuDE;EiBiBM,oEAJe;ApBguDvB;AoB1tDQ;;EAEE,oEARa;ApBouDvB;;AoBvvDI;;;EAGE,qED2F+B;AnB+pDrC;AoBtvDM;;;;EAIE,iEDmFyE;AnBqqDjF;;AG7vDE;EiBiBM,qEAJe;ApBovDvB;AoB9uDQ;;EAEE,qEARa;ApBwvDvB;;AoB3wDI;;;EAGE,oED2F+B;AnBmrDrC;AoB1wDM;;;;EAIE,iEDmFyE;AnByrDjF;;AGjxDE;EiBiBM,oEAJe;ApBwwDvB;AoBlwDQ;;EAEE,oEARa;ApB4wDvB;;AoB/xDI;;;EAGE,qED2F+B;AnBusDrC;AoB9xDM;;;;EAIE,iEDmFyE;AnB6sDjF;;AGryDE;EiBiBM,qEAJe;ApB4xDvB;AoBtxDQ;;EAEE,qEARa;ApBgyDvB;;AoBnzDI;;;EAGE,oED2F+B;AnB2tDrC;AoBlzDM;;;;EAIE,iEDmFyE;AnBiuDjF;;AGzzDE;EiBiBM,qEAJe;ApBgzDvB;AoB1yDQ;;EAEE,qEARa;ApBozDvB;;AoBv0DI;;;EAGE,yBnBkGmB;ADwuDzB;;AGv0DE;EiBiBM,2DAJe;ApB8zDvB;AoBxzDQ;;EAEE,2DARa;ApBk0DvB;;AmB1uDI;EACE,WZ3GK;EY4GL,yBZpGK;EYqGL,iEZ2PwB;APk/C9B;AmBxuDI;EACE,clBtGK;EkBuGL,yBlB5GK;EkB6GL,qBlB5GK;ADs1DX;;AmBruDA;EACE,WZ3HS;EY4HT,yBZpHS;AP41DX;AmBtuDE;;;EAGE,iEZuO0B;APigD9B;AmBruDE;EACE,SAAA;AnBuuDJ;AmBnuDI;EACE,2CZ2NwB;AP0gD9B;AG12DE;EgB4IM,WZjJG;EYkJH,4CZqNsB;AP4gD9B;;AiBjzDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBmtDN;EmBhtDM;IACE,SAAA;EnBktDR;AACF;AiB7zDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnB8tDN;EmB3tDM;IACE,SAAA;EnB6tDR;AACF;AiBx0DI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnByuDN;EmBtuDM;IACE,SAAA;EnBwuDR;AACF;AiBn1DI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBovDN;EmBjvDM;IACE,SAAA;EnBmvDR;AACF;AmB7vDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AnB8vDR;AmB3vDQ;EACE,SAAA;AnB6vDV;;AqB16DA;EACE,cAAA;EACA,WAAA;EACA,mCdqesC;EcpetC,yBAAA;EbqHI,eAtCa;Ea5EjB,gBd8Q4B;Ec7Q5B,gBdkR4B;EcjR5B,cdDS;EcET,sBdTS;EcUT,4BAAA;EACA,yBAAA;ERbE,sBNqO0B;EepOxB,wEDkBJ;ArBw6DF;AsBr7DI;EDLJ;ICMM,gBAAA;EtBw7DJ;AACF;AqB16DE;EACE,6BAAA;EACA,SAAA;ArB46DJ;AuB57DE;EACE,cAAA;EACA,sBhBRO;EgBSP,iEtByIuB;EsBxIvB,UAAA;EAKE,gDhBgXwB;AP0kD9B;AqB56DE;EACE,cdxBO;Ec0BP,UAAA;ArB66DJ;AqBr6DE;EAEE,yBdxCO;Ec0CP,UAAA;ArBq6DJ;;AqBh6DE;EAME,cdhDO;EciDP,sBdxDO;APs9DX;;AqBz5DA;;EAEE,cAAA;EACA,WAAA;ArB45DF;;AqBl5DA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EbZE,kBAAA;EacF,gBd0M4B;AP2sD9B;;AqBl5DA;EACE,+BAAA;EACA,kCAAA;EboCI,kBAtCa;EaIjB,gBduI4B;AP8wD9B;;AqBl5DA;EACE,gCAAA;EACA,mCAAA;Eb6BI,mBAtCa;EaWjB,gBdiI4B;APoxD9B;;AqB54DA;EACE,cAAA;EACA,WAAA;EACA,qBd8Q4B;Ec7Q5B,wBd6Q4B;Ec5Q5B,gBAAA;EACA,gBd6K4B;Ec5K5B,cdpGS;EcqGT,6BAAA;EACA,yBAAA;EACA,mBAAA;ArB+4DF;AqB74DE;EAEE,gBAAA;EACA,eAAA;ArB84DJ;;AqBl4DA;EACE,kCdsWsC;EcrWtC,uBAAA;EbXI,mBAtCa;EamDjB,gBdyF4B;EMhO1B,qBNuO0B;APsyD9B;;AqBl4DA;EACE,gCd+VsC;Ec9VtC,oBAAA;EbnBI,kBAtCa;Ea2DjB,gBdgF4B;EM/N1B,qBNsO0B;AP+yD9B;;AqBh4DE;EAEE,YAAA;ArBk4DJ;;AqB93DA;EACE,YAAA;ArBi4DF;;AqBz3DA;EACE,mBdoVsC;APwiDxC;;AqBz3DA;EACE,cAAA;EACA,mBdqUsC;APujDxC;;AqBp3DA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ArBu3DF;AqBr3DE;;EAEE,kBAAA;EACA,iBAAA;ArBu3DJ;;AqB92DA;EACE,kBAAA;EACA,cAAA;EACA,qBd0SsC;APukDxC;;AqB92DA;EACE,kBAAA;EACA,kBpBvF0B;EoBwF1B,qBAAA;ArBi3DF;AqB/2DE;EACE,cdxMO;APyjEX;;AqB72DA;EACE,gBAAA;ArBg3DF;;AqB72DA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBdyRsC;APulDxC;AqB72DE;EACE,gBAAA;EACA,aAAA;EACA,uBdoRoC;EcnRpC,cAAA;ArB+2DJ;;AuB1jEE;EACE,aAAA;EACA,WAAA;EACA,mBhBodoC;EC5apC,cAAA;EetCA,cFmNqC;ArB02DzC;;AuB1jEE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EfmFE,mBAtCa;Ee3Cf,gBhBkP0B;EgBjP1B,WAAA;EACA,wCAAA;EV3CA,sBNqO0B;APo4D9B;;AuBzjEI;EAEE,qBF8LmC;EE3LjC,oChBgbgC;EgB/ahC,yDF0LwD;EEzLxD,4BAAA;EACA,2DAAA;EACA,gEAAA;AvByjER;AuBtjEM;EACE,qBFmLiC;EElLjC,gDAAA;AvBwjER;AuBrjEM;;;EAEE,cAAA;AvBwjER;;AuBjjEI;EAGI,oChBwZgC;EgBvZhC,kFAAA;AvBkjER;;AuB5iEI;EAEE,qBF0JmC;EEvJjC,sDhBqeoC;EgBpepC,wNAAA;AvB4iER;AuBziEM;EACE,qBFkJiC;EEjJjC,gDAAA;AvB2iER;AuBxiEM;;;EAEE,cAAA;AvB2iER;;AuBliEM;;;EAEE,cAAA;AvBsiER;;AuB9hEM;EACE,cFwHiC;ArBy6DzC;AuB9hEM;;;EAEE,cAAA;AvBiiER;;AuBzhEM;EACE,cF0GiC;ArBk7DzC;AuB1hEQ;EACE,qBFuG+B;ArBq7DzC;AuBxhEM;;;EAEE,cAAA;AvB2hER;AuBvhEQ;EACE,iEAAA;ECnJN,qEDoJ2B;AvByhE/B;AuBphEQ;EACE,gDAAA;AvBshEV;AuBnhEQ;EACE,qBFiF+B;ArBo8DzC;;AuB3gEM;EACE,qBFsEiC;ArBw8DzC;AuB3gEM;;;EAEE,cAAA;AvB8gER;AuB1gEQ;EACE,qBF4D+B;EE3D/B,gDAAA;AvB4gEV;;AuBzqEE;EACE,aAAA;EACA,WAAA;EACA,mBhBodoC;EC5apC,cAAA;EetCA,cFmNqC;ArBy9DzC;;AuBzqEE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EfmFE,mBAtCa;Ee3Cf,gBhBkP0B;EgBjP1B,WAAA;EACA,wCAAA;EV3CA,sBNqO0B;APm/D9B;;AuBxqEI;EAEE,qBF8LmC;EE3LjC,oChBgbgC;EgB/ahC,yDF0LwD;EEzLxD,4BAAA;EACA,2DAAA;EACA,gEAAA;AvBwqER;AuBrqEM;EACE,qBFmLiC;EElLjC,gDAAA;AvBuqER;AuBpqEM;;;EAEE,cAAA;AvBuqER;;AuBhqEI;EAGI,oChBwZgC;EgBvZhC,kFAAA;AvBiqER;;AuB3pEI;EAEE,qBF0JmC;EEvJjC,sDhBqeoC;EgBpepC,wNAAA;AvB2pER;AuBxpEM;EACE,qBFkJiC;EEjJjC,gDAAA;AvB0pER;AuBvpEM;;;EAEE,cAAA;AvB0pER;;AuBjpEM;;;EAEE,cAAA;AvBqpER;;AuB7oEM;EACE,cFwHiC;ArBwhEzC;AuB7oEM;;;EAEE,cAAA;AvBgpER;;AuBxoEM;EACE,cF0GiC;ArBiiEzC;AuBzoEQ;EACE,qBFuG+B;ArBoiEzC;AuBvoEM;;;EAEE,cAAA;AvB0oER;AuBtoEQ;EACE,iEAAA;ECnJN,qEDoJ2B;AvBwoE/B;AuBnoEQ;EACE,gDAAA;AvBqoEV;AuBloEQ;EACE,qBFiF+B;ArBmjEzC;;AuB1nEM;EACE,qBFsEiC;ArBujEzC;AuB1nEM;;;EAEE,cAAA;AvB6nER;AuBznEQ;EACE,qBF4D+B;EE3D/B,gDAAA;AvB2nEV;;AqBpjEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ArBujEF;AqBljEE;EACE,WAAA;ArBojEJ;AiBlwEI;EImNA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;ErBkjEJ;EqB9iEE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;ErBgjEJ;EqB5iEE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;ErB8iEJ;EqB1iEE;IACE,qBAAA;ErB4iEJ;EqBziEE;;IAEE,WAAA;ErB2iEJ;EqBtiEE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;ErBwiEJ;EqBtiEE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBd2LkC;Ic1LlC,cAAA;ErBwiEJ;EqBriEE;IACE,mBAAA;IACA,uBAAA;ErBuiEJ;EqBriEE;IACE,gBAAA;ErBuiEJ;AACF;;AyBx2EA;EACE,qBAAA;EAEA,gBlBkR4B;EkBjR5B,cxBWS;EwBVT,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECsFA,yBAAA;ElB0BI,eAtCa;EkBcjB,gBnByL4B;EM3R1B,sBNqO0B;EepOxB,qFGWJ;AzB62EF;AsBn3EI;EGLJ;IHMM,gBAAA;EtBs3EJ;AACF;AGv3EE;EsBQE,cxBCO;EwBAP,qBAAA;AzBk3EJ;AyB/2EE;EAEE,UAAA;EACA,gBxBsEmB;AD0yEvB;AyB52EE;EAEE,alB8Y0B;AP+9D9B;AyB91EA;;EAEE,oBAAA;AzBg2EF;;AyBv1EE;ECrDA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADk1Ef;AG54EE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,gEATqG;A1Bw5EzG;A0B54EE;EAMI,uDAAA;A1By4EN;A0Bp4EE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;AD+1Ef;A0B93EE;EAGE,WAAA;EACA,oEAtC+I;EA0C/I,iEA1CyL;A1Bq6E7L;A0Bz3EI;EAKI,uDAAA;A1Bu3ER;;AyBl3EE;ECrDA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD62Ef;AGv6EE;EuBAE,WAAA;EFNA,kEED2D;EAS3D,iEATqG;A1Bm7EzG;A0Bv6EE;EAMI,uDAAA;A1Bo6EN;A0B/5EE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;AD03Ef;A0Bz5EE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1Bg8E7L;A0Bp5EI;EAKI,uDAAA;A1Bk5ER;;AyB74EE;ECrDA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADw4Ef;AGl8EE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,iEATqG;A1B88EzG;A0Bl8EE;EAMI,6EAAA;A1B+7EN;A0B17EE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADq5Ef;A0Bp7EE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1B29E7L;A0B/6EI;EAKI,6EAAA;A1B66ER;;AyBx6EE;ECrDA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADm6Ef;AG79EE;EuBAE,WAAA;EFNA,0DED2D;EAS3D,qDATqG;A1By+EzG;A0B79EE;EAMI,6CAAA;A1B09EN;A0Br9EE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADg7Ef;A0B/8EE;EAGE,WAAA;EACA,yDAtC+I;EA0C/I,qDA1CyL;A1Bs/E7L;A0B18EI;EAKI,6CAAA;A1Bw8ER;;AyBn8EE;ECrDA,cAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD87Ef;AGx/EE;EuBAE,cAAA;EFNA,oEED2D;EAS3D,+DATqG;A1BogFzG;A0Bx/EE;EAMI,6EAAA;A1Bq/EN;A0Bh/EE;EAEE,cAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;AD28Ef;A0B1+EE;EAGE,cAAA;EACA,mEAtC+I;EA0C/I,gEA1CyL;A1BihF7L;A0Br+EI;EAKI,6EAAA;A1Bm+ER;;AyB99EE;ECrDA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADy9Ef;AGnhFE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,iEATqG;A1B+hFzG;A0BnhFE;EAMI,6EAAA;A1BghFN;A0B3gFE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADs+Ef;A0BrgFE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1B4iF7L;A0BhgFI;EAKI,6EAAA;A1B8/ER;;AyBz/EE;ECrDA,cAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADo/Ef;AG9iFE;EuBAE,cAAA;EFNA,qEED2D;EAS3D,iEATqG;A1B0jFzG;A0B9iFE;EAMI,6EAAA;A1B2iFN;A0BtiFE;EAEE,cAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADigFf;A0BhiFE;EAGE,cAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1BukF7L;A0B3hFI;EAKI,6EAAA;A1ByhFR;;AyBphFE;ECrDA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD+gFf;AGzkFE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,iEATqG;A1BqlFzG;A0BzkFE;EAMI,6EAAA;A1BskFN;A0BjkFE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;AD4hFf;A0B3jFE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,+DA1CyL;A1BkmF7L;A0BtjFI;EAKI,6EAAA;A1BojFR;;AyB/iFE;ECrDA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD0iFf;AGpmFE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,gEATqG;A1BgnFzG;A0BpmFE;EAMI,kEAAA;A1BimFN;A0B5lFE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADujFf;A0BtlFE;EAGE,WAAA;EACA,oEAtC+I;EA0C/I,iEA1CyL;A1B6nF7L;A0BjlFI;EAKI,kEAAA;A1B+kFR;;AyB1kFE;ECrDA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADqkFf;AG/nFE;EuBAE,WAAA;EFNA,oEED2D;EAS3D,iEATqG;A1B2oFzG;A0B/nFE;EAMI,kEAAA;A1B4nFN;A0BvnFE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADklFf;A0BjnFE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1BwpF7L;A0B5mFI;EAKI,kEAAA;A1B0mFR;;AyB/lFE;ECJA,czBSa;EyBRb,qBzBQa;AD+lFf;AGzpFE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADomFf;A0BpmFE;EAEE,0CAAA;A1BqmFJ;A0BlmFE;EAEE,czBPW;EyBQX,6BAAA;A1BmmFJ;A0BhmFE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADgnFf;A0B9lFI;EAKI,0CAAA;A1B4lFR;;AyBxnFE;ECJA,czBSa;EyBRb,qBzBQa;ADwnFf;AGlrFE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;AD6nFf;A0B7nFE;EAEE,4CAAA;A1B8nFJ;A0B3nFE;EAEE,czBPW;EyBQX,6BAAA;A1B4nFJ;A0BznFE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADyoFf;A0BvnFI;EAKI,4CAAA;A1BqnFR;;AyBjpFE;ECJA,czBSa;EyBRb,qBzBQa;ADipFf;AG3sFE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADspFf;A0BtpFE;EAEE,2CAAA;A1BupFJ;A0BppFE;EAEE,czBPW;EyBQX,6BAAA;A1BqpFJ;A0BlpFE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADkqFf;A0BhpFI;EAKI,2CAAA;A1B8oFR;;AyB1qFE;ECJA,czBSa;EyBRb,qBzBQa;AD0qFf;AGpuFE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;AD+qFf;A0B/qFE;EAEE,2CAAA;A1BgrFJ;A0B7qFE;EAEE,czBPW;EyBQX,6BAAA;A1B8qFJ;A0B3qFE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;AD2rFf;A0BzqFI;EAKI,2CAAA;A1BuqFR;;AyBnsFE;ECJA,czBSa;EyBRb,qBzBQa;ADmsFf;AG7vFE;EuBqDE,cALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADwsFf;A0BxsFE;EAEE,2CAAA;A1BysFJ;A0BtsFE;EAEE,czBPW;EyBQX,6BAAA;A1BusFJ;A0BpsFE;EAGE,cAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADotFf;A0BlsFI;EAKI,2CAAA;A1BgsFR;;AyB5tFE;ECJA,czBSa;EyBRb,qBzBQa;AD4tFf;AGtxFE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADiuFf;A0BjuFE;EAEE,0CAAA;A1BkuFJ;A0B/tFE;EAEE,czBPW;EyBQX,6BAAA;A1BguFJ;A0B7tFE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;AD6uFf;A0B3tFI;EAKI,0CAAA;A1BytFR;;AyBrvFE;ECJA,czBSa;EyBRb,qBzBQa;ADqvFf;AG/yFE;EuBqDE,cALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;AD0vFf;A0B1vFE;EAEE,4CAAA;A1B2vFJ;A0BxvFE;EAEE,czBPW;EyBQX,6BAAA;A1ByvFJ;A0BtvFE;EAGE,cAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADswFf;A0BpvFI;EAKI,4CAAA;A1BkvFR;;AyB9wFE;ECJA,czBSa;EyBRb,qBzBQa;AD8wFf;AGx0FE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADmxFf;A0BnxFE;EAEE,yCAAA;A1BoxFJ;A0BjxFE;EAEE,czBPW;EyBQX,6BAAA;A1BkxFJ;A0B/wFE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;AD+xFf;A0B7wFI;EAKI,yCAAA;A1B2wFR;;AyBvyFE;ECJA,czBSa;EyBRb,qBzBQa;ADuyFf;AGj2FE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;AD4yFf;A0B5yFE;EAEE,yCAAA;A1B6yFJ;A0B1yFE;EAEE,czBPW;EyBQX,6BAAA;A1B2yFJ;A0BxyFE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADwzFf;A0BtyFI;EAKI,yCAAA;A1BoyFR;;AyBh0FE;ECJA,czBSa;EyBRb,qBzBQa;ADg0Ff;AG13FE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADq0Ff;A0Br0FE;EAEE,2CAAA;A1Bs0FJ;A0Bn0FE;EAEE,czBPW;EyBQX,6BAAA;A1Bo0FJ;A0Bj0FE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADi1Ff;A0B/zFI;EAKI,2CAAA;A1B6zFR;;AyB90FA;EACE,gBlB8M4B;EkB7M5B,cxBoEW;EwBnEX,qBlB6FwC;APovF1C;AGp5FE;EsBsEE,mClB2FsC;EkB1FtC,0BlB2FsC;APsvF1C;AyB90FE;EAEE,0BlBsFsC;EkBrFtC,gBAAA;AzB+0FJ;AyB50FE;EAEE,clBjFO;EkBkFP,oBAAA;AzB60FJ;;AyBl0FA;ECLE,oBAAA;ElB0BI,kBAtCa;EkBcjB,gBnB6H4B;EM/N1B,qBNsO0B;APwsF9B;;AyBr0FA;ECTE,uBAAA;ElB0BI,mBAtCa;EkBcjB,gBnB8H4B;EMhO1B,qBNuO0B;AP8sF9B;;AyBn0FA;EACE,cAAA;EACA,WAAA;AzBs0FF;AyBn0FE;EACE,kBlBuT0B;AP8gF9B;;AyB7zFE;;;EACE,WAAA;AzBk0FJ;;A2Bx8FA;ELMM,gCKLJ;A3B28FF;AsBj8FI;EKXJ;ILYM,gBAAA;EtBo8FJ;AACF;A2B98FE;EACE,UAAA;A3Bg9FJ;;A2B38FE;EACE,aAAA;A3B88FJ;;A2B18FA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELXI,6BKYJ;A3B68FF;AsBp9FI;EKGJ;ILFM,gBAAA;EtBu9FJ;AACF;;A4Bn+FA;;;;EAIE,kBAAA;A5Bs+FF;;A4Bn+FA;EACE,mBAAA;A5Bs+FF;A6Bl9FI;EACE,qBAAA;EACA,oBtB0NwB;EsBzNxB,uBtBwNwB;EsBvNxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A7Bq/FF;A6Bh8FI;EACE,cAAA;A7Bk8FN;;A4B5+FA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,arBipBkC;EqBhpBlC,aAAA;EACA,WAAA;EACA,gB3BmFmB;E2BlFnB,kBAAA;EACA,oBAAA;EpBsGI,eAtCa;EoB9DjB,crBXS;EqBYT,gBAAA;EACA,gBAAA;EACA,sBrBvBS;EqBwBT,4BAAA;EACA,qCAAA;Ef3BE,sBNqO0B;APsyF9B;;A4Bv+FI;EACE,WAAA;EACA,OAAA;A5B0+FN;;A4Bv+FI;EACE,QAAA;EACA,UAAA;A5B0+FN;;AiB99FI;EWnBA;IACE,WAAA;IACA,OAAA;E5Bq/FJ;E4Bl/FE;IACE,QAAA;IACA,UAAA;E5Bo/FJ;AACF;AiBz+FI;EWnBA;IACE,WAAA;IACA,OAAA;E5B+/FJ;E4B5/FE;IACE,QAAA;IACA,UAAA;E5B8/FJ;AACF;AiBn/FI;EWnBA;IACE,WAAA;IACA,OAAA;E5BygGJ;E4BtgGE;IACE,QAAA;IACA,UAAA;E5BwgGJ;AACF;AiB7/FI;EWnBA;IACE,WAAA;IACA,OAAA;E5BmhGJ;E4BhhGE;IACE,QAAA;IACA,UAAA;E5BkhGJ;AACF;A4B3gGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBrBorBgC;APy1EpC;A6B5iGI;EACE,qBAAA;EACA,oBtB0NwB;EsBzNxB,uBtBwNwB;EsBvNxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A7BwkGF;A6B1hGI;EACE,cAAA;A7B4hGN;;A4BjhGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBrBsqBgC;AP82EpC;A6BjkGI;EACE,qBAAA;EACA,oBtB0NwB;EsBzNxB,uBtBwNwB;EsBvNxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A7BslGF;A6B/iGI;EACE,cAAA;A7BijGN;A4B5hGI;EACE,iBAAA;A5B8hGN;;A4BxhGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBrBqpBgC;APs4EpC;A6BzlGI;EACE,qBAAA;EACA,oBtB0NwB;EsBzNxB,uBtBwNwB;EsBvNxB,WAAA;A7B2lGN;A6BhlGM;EACE,aAAA;A7BklGR;A6B/kGM;EACE,qBAAA;EACA,qBtBuMsB;EsBtMtB,uBtBqMsB;EsBpMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A7BgnGF;A6B/kGI;EACE,cAAA;A7BilGN;A4B3iGI;EACE,iBAAA;A5B6iGN;;A4BriGE;EAIE,WAAA;EACA,YAAA;A5BqiGJ;;A4BhiGA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A9BkpGF;;A4BhiGA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,gBrB4J4B;EqB3J5B,crBhHS;EqBiHT,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;A5BmiGF;AGvpGE;EyBmIE,uDrB0mBgC;EqBzmBhC,qBAAA;EJ9IA,yBvBqGqB;ADikGzB;A4BphGE;EAEE,WrBnJO;EqBoJP,qBAAA;EJrJA,yBvB6IkB;AD8hGtB;A4BlhGE;EAEE,crBpJO;EqBqJP,oBAAA;EACA,6BAAA;A5BmhGJ;;A4B3gGA;EACE,cAAA;A5B8gGF;;A4B1gGA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EpBpDI,mBAtCa;EoB4FjB,crBxKS;EqByKT,mBAAA;A5B6gGF;;A4BzgGA;EACE,cAAA;EACA,sBAAA;EACA,crB7KS;APyrGX;;A+BtsGA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A/BysGF;A+BvsGE;;EACE,kBAAA;EACA,cAAA;A/B0sGJ;AGzsGE;;E4BII,UAAA;A/BysGN;A+BvsGI;;;;EAGE,UAAA;A/B0sGN;;A+BpsGA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A/BusGF;A+BrsGE;EACE,WAAA;A/BusGJ;;A+BjsGE;;EAEE,iBAAA;A/BosGJ;A+BhsGE;;ElBxBE,0BkB0B6B;ElBzB7B,6BkByB6B;A/BmsGjC;A+BhsGE;;ElBfE,yBkBiB4B;ElBhB5B,4BkBgB4B;A/BmsGhC;;A+BnrGA;EACE,wBAAA;EACA,uBAAA;A/BsrGF;A+BprGE;EAGE,cAAA;A/BorGJ;A+BjrGE;EACE,eAAA;A/BmrGJ;;A+B/qGA;EACE,uBAAA;EACA,sBAAA;A/BkrGF;;A+B/qGA;EACE,sBAAA;EACA,qBAAA;A/BkrGF;;A+B9pGA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A/BiqGF;A+B/pGE;;EAEE,WAAA;A/BiqGJ;A+B9pGE;;EAEE,gBAAA;A/BgqGJ;A+B5pGE;;ElBlGE,6BkBoG8B;ElBnG9B,4BkBmG8B;A/B+pGlC;A+B5pGE;;ElBrHE,yBkBuH2B;ElBtH3B,0BkBsH2B;A/B+pG/B;;A+B7oGE;;EAEE,gBAAA;A/BgpGJ;A+B9oGI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A/BkpGN;;AgC3yGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AhC8yGF;AgC5yGE;;;;EAIE,kBAAA;EACA,cAAA;EAGA,SAAA;EACA,gBAAA;AhC4yGJ;AgC1yGI;;;;;;;;;;;;EAGE,iBAAA;AhCqzGN;AgChzGE;;;EAGE,UAAA;AhCkzGJ;AgC9yGE;EACE,UAAA;AhCgzGJ;AgC3yGI;;EnBxBA,0BmBwBkD;EnBvBlD,6BmBuBkD;AhCgzGtD;AgC/yGI;;EnBXA,yBmBWkD;EnBVlD,4BmBUkD;AhCozGtD;AgC/yGE;EACE,aAAA;EACA,mBAAA;AhCizGJ;AgC/yGI;EnBlCA,0BmBmC4E;EnBlC5E,6BmBkC4E;AhCkzGhF;AgCjzGI;EnBtBA,yBmBsBqE;EnBrBrE,4BmBqBqE;AhCqzGzE;;AgC1yGA;;EAEE,aAAA;AhC6yGF;AgCxyGE;;EACE,kBAAA;EACA,UAAA;AhC2yGJ;AgCzyGI;;EACE,UAAA;AhC4yGN;AgCxyGE;;;;;;;;EAIE,iBAAA;AhC8yGJ;;AgC1yGA;EAAuB,kBAAA;AhC8yGvB;;AgC7yGA;EAAsB,iBAAA;AhCizGtB;;AgCzyGA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;ExBsBI,eAtCa;EwBkBjB,gBzBgL4B;EyB/K5B,gBzBoL4B;EyBnL5B,czB/FS;EyBgGT,kBAAA;EACA,mBAAA;EACA,2D/BYqB;E+BXrB,yBAAA;EnB5GE,sBNqO0B;APorG9B;AgCzyGE;;EAEE,aAAA;AhC2yGJ;;AgCjyGA;;EAEE,gCzB6WsC;APu7FxC;;AgCjyGA;;;;;;EAME,oBAAA;ExBbI,kBAtCa;EwBqDjB,gBzBsF4B;EM/N1B,qBNsO0B;APwsG9B;;AgCjyGA;;EAEE,kCzB2VsC;APy8FxC;;AgCjyGA;;;;;;EAME,uBAAA;ExB9BI,mBAtCa;EwBsEjB,gBzBsE4B;EMhO1B,qBNuO0B;APwtG9B;;AgCjyGA;;EAEE,sBAAA;AhCoyGF;;AgCzxGA;;;;;;EnB3JI,0BmBiK2B;EnBhK3B,6BmBgK2B;AhC6xG/B;;AgC1xGA;;;;;;EnBtJI,yBmB4J0B;EnB3J1B,4BmB2J0B;AhC8xG9B;;AiCp9GA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;AjCu9GF;;AiCp9GA;EACE,oBAAA;EACA,kB1BqfsC;APk+FxC;;AiCp9GA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AjCu9GF;AiCr9GE;EACE,W1BpBO;E0BqBP,qB1ByN0B;EiB/O1B,yBvB6IkB;ADi2GtB;AiCn9GE;EAKI,gD1BgWwB;APinG9B;AiC78GE;EACE,4C1BqboC;AP0hGxC;AiC58GE;EACE,W1BxCO;E0ByCP,qEhC2GiC;EgC1GjC,4C1B6e4C;APi+FhD;AiCz8GI;EACE,c1B1CK;APq/GX;AiCz8GM;EACE,yB1BjDG;AP4/GX;;AiCj8GA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AjCo8GF;AiCj8GE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W1B0boC;E0BzbpC,Y1ByboC;E0BxbpC,oBAAA;EACA,WAAA;EACA,sB1B5EO;E0B6EP,yBAAA;AjCm8GJ;AiC97GE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W1B2aoC;E0B1apC,Y1B0aoC;E0BzapC,WAAA;EACA,iCAAA;AjCg8GJ;;AiCt7GE;EpBtGE,sBNqO0B;AP2zG9B;AiCr7GI;EACE,yD1Bkb0C;APqgGhD;AiCl7GI;EACE,qB1B8HwB;EiB/O1B,yBvB6IkB;ADy5GtB;AiCj7GI;EACE,yD1B2aiD;APwgGvD;AiC96GI;EACE,wChCkByC;AD85G/C;AiC96GI;EACE,wChCeyC;ADi6G/C;;AiCt6GE;EAEE,kB1B0Z4C;AP8gGhD;AiCp6GI;EACE,yD1BsZ0C;APghGhD;AiCj6GI;EACE,wChCRyC;AD26G/C;;AiCz5GA;EACE,qBAAA;AjC45GF;AiCz5GI;EACE,cAAA;EACA,c1BkY0C;E0BjY1C,mBAAA;EAEA,qB1BgY0C;AP0hGhD;AiCv5GI;EACE,wBAAA;EACA,0BAAA;EACA,uB1B2X0C;E0B1X1C,wB1B0X0C;E0BzX1C,yB1B3KK;E0B6KL,qB1BsX0C;EeziB1C,yIWoLA;AjCw5GN;AsBvkHI;EWuKA;IXtKE,gBAAA;EtB0kHJ;AACF;AiCx5GI;EACE,sB1BzLK;E0B0LL,8BAAA;AjC05GN;AiCr5GI;EACE,wChCnDyC;AD08G/C;;AiC34GA;EACE,qBAAA;EACA,WAAA;EACA,mC1BwRsC;E0BvRtC,0CAAA;EzBxFI,eAtCa;EyBiIjB,gB1BiE4B;E0BhE5B,gB1BqE4B;E0BpE5B,c1B9MS;E0B+MT,sBAAA;EACA,2F1BmWkC;E0BlWlC,sB1BxNS;E0ByNT,yBAAA;EpB3NE,sBNqO0B;E0BP5B,gBAAA;AjC44GF;AiC14GE;EACE,4C1B0PoC;E0BzPpC,UAAA;EAIE,gD1BmW8B;APsiGpC;AiCt4GI;EAME,c1BtOK;E0BuOL,sB1B9OK;APinHX;AiC/3GE;EAEE,YAAA;EACA,sB1BmI0B;E0BlI1B,sBAAA;AjCg4GJ;AiC73GE;EACE,c1BpPO;E0BqPP,yB1BzPO;APwnHX;AiC33GE;EACE,aAAA;AjC63GJ;;AiCz3GA;EACE,kC1BmOsC;E0BlOtC,oB1B2H4B;E0B1H5B,uB1B0H4B;E0BzH5B,oB1B0H4B;EC1QxB,mBAtCa;ARmjHnB;;AiCz3GA;EACE,gC1B4NsC;E0B3NtC,mB1BwH4B;E0BvH5B,sB1BuH4B;E0BtH5B,kB1BuH4B;EC/QxB,kBAtCa;AR2jHnB;;AiCp3GA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC1B0MsC;E0BzMtC,gBAAA;AjCu3GF;;AiCp3GA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC1BkMsC;E0BjMtC,SAAA;EACA,UAAA;AjCu3GF;AiCr3GE;EACE,4C1B+KoC;E0B9KpC,gD1BoF0B;APmyG9B;AiCp3GE;EACE,yB1B7SO;APmqHX;AiCl3GI;EACE,iB1BoUa;APgjGnB;AiCh3GE;EACE,0BAAA;AjCk3GJ;;AiC92GA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC1BoKsC;E0BnKtC,yBAAA;EAEA,gB1BlD4B;E0BmD5B,gB1B9C4B;E0B+C5B,c1BjUS;E0BkUT,sB1BzUS;E0B0UT,yBAAA;EpB5UE,sBNqO0B;APw9G9B;AiC72GE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B1B8IoC;E0B7IpC,yBAAA;EACA,gB1B9D0B;E0B+D1B,c1BjVO;E0BkVP,iBAAA;ET1VA,yBjBGO;E0ByVP,oBAAA;EpB7VA,kCoB8VuB;AjC+2G3B;;AiCr2GA;EACE,WAAA;EACA,2BAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;AjCw2GF;AiCt2GE;EACE,aAAA;AjCw2GJ;AiCp2GI;EAA0B,gE1B8Oe;APynG7C;AiCt2GI;EAA0B,gE1B6Oe;AP4nG7C;AiCx2GI;EAA0B,gE1B4Oe;AP+nG7C;AiCx2GE;EACE,SAAA;AjC02GJ;AiCv2GE;EACE,W1B8NyC;E0B7NzC,Y1B6NyC;E0B5NzC,oBAAA;ET/XA,yBvB6IkB;EgCoPlB,S1B6NyC;EM/lBzC,mBNgmByC;Ee/lBvC,oHWoYF;EXpYE,4GWoYF;AjCw2GJ;AsBvuHI;EWuXF;IXtXI,wBAAA;IAAA,gBAAA;EtB0uHJ;AACF;AiCr3GE;EASE,gBAAA;AjC+2GJ;AiC72GI;ETvYA,qEvBwJ2B;AD+lH/B;AiC32GE;EACE,W1BuMgC;E0BtMhC,c1BuMgC;E0BtMhC,kBAAA;EACA,e1BsMgC;E0BrMhC,yB1B7YO;E0B8YP,yBAAA;EpBnZA,mBNylBgC;APwqGpC;AiCz2GE;EACE,W1BmMyC;E0BlMzC,Y1BkMyC;EiB3lBzC,yBvB6IkB;EgC8QlB,S1BmMyC;EM/lBzC,mBNgmByC;Ee/lBvC,iHW8ZF;EX9ZE,4GW8ZF;AjC02GJ;AsBnwHI;EWkZF;IXjZI,qBAAA;IAAA,gBAAA;EtBswHJ;AACF;AiCt3GE;EAQE,gBAAA;AjCi3GJ;AiC/2GI;ETjaA,qEvBwJ2B;AD2nH/B;AiC72GE;EACE,W1B6KgC;E0B5KhC,c1B6KgC;E0B5KhC,kBAAA;EACA,e1B4KgC;E0B3KhC,yB1BvaO;E0BwaP,yBAAA;EpB7aA,mBNylBgC;APosGpC;AiC32GE;EACE,W1ByKyC;E0BxKzC,Y1BwKyC;E0BvKzC,aAAA;EACA,oB1BvD0B;E0BwD1B,mB1BxD0B;EiB9X1B,yBvB6IkB;EgC2SlB,S1BsKyC;EM/lBzC,mBNgmByC;Ee/lBvC,gHW2bF;EX3bE,4GW2bF;AjC42GJ;AsBlyHI;EW4aF;IX3aI,oBAAA;IAAA,gBAAA;EtBqyHJ;AACF;AiC33GE;EAWE,gBAAA;AjCm3GJ;AiCj3GI;ET9bA,qEvBwJ2B;AD0pH/B;AiC/2GE;EACE,W1BgJgC;E0B/IhC,c1BgJgC;E0B/IhC,kBAAA;EACA,e1B+IgC;E0B9IhC,6BAAA;EACA,yBAAA;EACA,oBAAA;AjCi3GJ;AiC72GE;EACE,yB1B3cO;EMLP,mBNylBgC;APuuGpC;AiC52GE;EACE,kBAAA;EACA,yB1BjdO;EMLP,mBNylBgC;AP4uGpC;AiC12GI;EACE,yB1BrdK;APi0HX;AiCz2GI;EACE,eAAA;AjC22GN;AiCx2GI;EACE,yB1B7dK;APu0HX;AiCv2GI;EACE,eAAA;AjCy2GN;AiCt2GI;EACE,yB1BreK;AP60HX;;AiCn2GA;;;EXhfM,4GWmfJ;AjCs2GF;AsBp1HI;EW2eJ;;;IX1eM,gBAAA;EtBy1HJ;AACF;;AkCj2HA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlCo2HF;;AkCj2HA;EACE,cAAA;EACA,oBAAA;AlCo2HF;AGn2HE;E+BEE,qBAAA;AlCo2HJ;AkCh2HE;EACE,c3BVO;E2BWP,oBAAA;EACA,eAAA;AlCk2HJ;;AkC11HA;EACE,gCAAA;AlC61HF;AkC31HE;EACE,mBAAA;AlC61HJ;AkC11HE;EACE,6BAAA;ErB3BA,+BN4N0B;EM3N1B,gCN2N0B;AP6pH9B;AGv3HE;E+B6BI,qC3B0oB8B;APmtGpC;AkC11HI;EACE,c3BpCK;E2BqCL,6BAAA;EACA,yBAAA;AlC41HN;AkCx1HE;;EAEE,c3B3CO;E2B4CP,sB3BnDO;E2BoDP,kC3B+nBgC;AP2tGpC;AkCv1HE;EAEE,gBAAA;ErBlDA,yBqBoD2B;ErBnD3B,0BqBmD2B;AlCw1H/B;;AkC90HE;ErBvEE,sBNqO0B;APorH9B;AkC90HE;;EAEE,W3B3EO;E2B4EP,yBjCgEkB;ADgxHtB;;AkCt0HE;EACE,cAAA;EACA,kBAAA;AlCy0HJ;;AkCp0HE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AlCu0HJ;;AkC7zHE;EACE,aAAA;AlCg0HJ;AkC9zHE;EACE,cAAA;AlCg0HJ;;AmCp6HA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AnCu6HF;AmCn6HE;;EAEE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AnCq6HJ;;AmC55HA;EACE,qBAAA;EACA,sB5BoqBkC;E4BnqBlC,yB5BmqBkC;E4BlqBlC,kB5BoFO;ECFH,kBAtCa;E2B1CjB,oBAAA;EACA,mBAAA;AnC+5HF;AG/7HE;EgCmCE,qBAAA;AnC+5HJ;;AmCt5HA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnCy5HF;AmCv5HE;EACE,gBAAA;EACA,eAAA;AnCy5HJ;AmCt5HE;EACE,gBAAA;EACA,WAAA;AnCw5HJ;;AmC/4HA;EACE,qBAAA;EACA,mB5B2lBkC;E4B1lBlC,sB5B0lBkC;APwzGpC;;AmCt4HA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AnCu4HF;;AmCn4HA;EACE,wBAAA;E3BmBI,kBAtCa;E2BqBjB,cAAA;EACA,6BAAA;EACA,6BAAA;EtB3GE,sBNqO0B;AP6wH9B;AGv+HE;EgCoGE,qBAAA;AnCs4HJ;;AmCh4HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,0BAAA;AnCm4HF;;AiB37HI;EkBoEI;;IAEE,gBAAA;IACA,eAAA;EnC23HR;AACF;AiBh9HI;EkB+EA;IAUI,qBAAA;IACA,2BAAA;EnC23HN;EmCz3HM;IACE,mBAAA;EnC23HR;EmCz3HQ;IACE,kBAAA;EnC23HV;EmCx3HQ;IACE,qB5ByiBwB;I4BxiBxB,oB5BwiBwB;EPk1GlC;EmCr3HM;;IAEE,iBAAA;EnCu3HR;EmCp3HM;IACE,wBAAA;IAGA,gBAAA;EnCo3HR;EmCj3HM;IACE,aAAA;EnCm3HR;AACF;AiB99HI;EkBoEI;;IAEE,gBAAA;IACA,eAAA;EnC65HR;AACF;AiBl/HI;EkB+EA;IAUI,qBAAA;IACA,2BAAA;EnC65HN;EmC35HM;IACE,mBAAA;EnC65HR;EmC35HQ;IACE,kBAAA;EnC65HV;EmC15HQ;IACE,qB5ByiBwB;I4BxiBxB,oB5BwiBwB;EPo3GlC;EmCv5HM;;IAEE,iBAAA;EnCy5HR;EmCt5HM;IACE,wBAAA;IAGA,gBAAA;EnCs5HR;EmCn5HM;IACE,aAAA;EnCq5HR;AACF;AiBhgII;EkBoEI;;IAEE,gBAAA;IACA,eAAA;EnC+7HR;AACF;AiBphII;EkB+EA;IAUI,qBAAA;IACA,2BAAA;EnC+7HN;EmC77HM;IACE,mBAAA;EnC+7HR;EmC77HQ;IACE,kBAAA;EnC+7HV;EmC57HQ;IACE,qB5ByiBwB;I4BxiBxB,oB5BwiBwB;EPs5GlC;EmCz7HM;;IAEE,iBAAA;EnC27HR;EmCx7HM;IACE,wBAAA;IAGA,gBAAA;EnCw7HR;EmCr7HM;IACE,aAAA;EnCu7HR;AACF;AiBliII;EkBoEI;;IAEE,gBAAA;IACA,eAAA;EnCi+HR;AACF;AiBtjII;EkB+EA;IAUI,qBAAA;IACA,2BAAA;EnCi+HN;EmC/9HM;IACE,mBAAA;EnCi+HR;EmC/9HQ;IACE,kBAAA;EnCi+HV;EmC99HQ;IACE,qB5ByiBwB;I4BxiBxB,oB5BwiBwB;EPw7GlC;EmC39HM;;IAEE,iBAAA;EnC69HR;EmC19HM;IACE,wBAAA;IAGA,gBAAA;EnC09HR;EmCv9HM;IACE,aAAA;EnCy9HR;AACF;AmChgIQ;;EAEE,gBAAA;EACA,eAAA;AnCkgIV;AmCvgII;EAUI,qBAAA;EACA,2BAAA;AnCggIR;AmC9/HQ;EACE,mBAAA;AnCggIV;AmC9/HU;EACE,kBAAA;AnCggIZ;AmC7/HU;EACE,qB5ByiBwB;E4BxiBxB,oB5BwiBwB;APu9GpC;AmC1/HQ;;EAEE,iBAAA;AnC4/HV;AmCz/HQ;EACE,wBAAA;EAGA,gBAAA;AnCy/HV;AmCt/HQ;EACE,aAAA;AnCw/HV;;AmC1+HE;EACE,yB5B6hBgC;APg9GpC;AG/pIE;EgCqLI,yB5B0hB8B;APm9GpC;AmCx+HI;EACE,yB5BkhB8B;APw9GpC;AGrqIE;EgC8LM,yB5BghB4B;AP09GpC;AmCv+HM;EACE,yB5B8gB4B;AP29GpC;AmCr+HI;;;;EAIE,yB5BqgB8B;APk+GpC;AmCn+HE;EACE,yB5B8fgC;E4B7fhC,gC5BkgBgC;APm+GpC;AmCl+HE;EACE,yD5B6fgC;APu+GpC;AmCj+HE;EACE,yB5BqfgC;AP8+GpC;AmCl+HI;EACE,yB5Bqf8B;AP++GpC;AG9rIE;EgC6NM,yB5Bkf4B;APk/GpC;;AmC59HE;EACE,W5B/OO;AP8sIX;AGrsIE;EgCyOI,W5BlPK;APitIX;AmC19HI;EACE,+B5Bud8B;APqgHpC;AG3sIE;EgCkPM,gC5Bqd4B;APugHpC;AmCz9HM;EACE,gC5Bmd4B;APwgHpC;AmCv9HI;;;;EAIE,W5BvQK;APguIX;AmCr9HE;EACE,+B5BmcgC;E4BlchC,sC5BucgC;APghHpC;AmCp9HE;EACE,yD5BkcgC;APohHpC;AmCn9HE;EACE,+B5B0bgC;AP2hHpC;AmCp9HI;EACE,W5BvRK;AP6uIX;AGpuIE;EgCiRM,W5B1RG;APgvIX;;AoCnvIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,sB7BHS;E6BIT,2BAAA;EACA,6EAAA;EvBPE,sBNqO0B;APyhI9B;AoCpvIE;EACE,eAAA;EACA,cAAA;ApCsvIJ;AoClvII;EvBPA,+BN4N0B;EM3N1B,gCN2N0B;APiiI9B;AoChvII;EvBCA,mCN8M0B;EM7M1B,kCN6M0B;APqiI9B;;AoC9uIA;EAGE,cAAA;EACA,gB7B+wBkC;APg+GpC;;AoC3uIA;EACE,sB7BywBkC;APq+GpC;;AoC3uIA;EACE,qBAAA;EACA,gBAAA;ApC8uIF;;AoC3uIA;EACE,gBAAA;ApC8uIF;;AGrxIE;EiC4CE,qBAAA;ApC6uIJ;AoC1uIE;EACE,oB7BwvBgC;APo/GpC;;AoCpuIA;EACE,wBAAA;EACA,gBAAA;EAEA,sBnC1DM;EmC2DN,oFAAA;ApCsuIF;AoCpuIE;EvBtEE,0DuBuEuB;ApCsuI3B;AoCluII;EACE,aAAA;ApCouIN;;AoC/tIA;EACE,wBAAA;EACA,sBnC1EM;EmC2EN,iFAAA;ApCkuIF;AoChuIE;EvBtFE,0DuBuFuB;ApCkuI3B;;AoCztIA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;ApC4tIF;;AoCztIA;EACE,uBAAA;EACA,sBAAA;ApC4tIF;;AoCxtIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB7BssBkC;APqhHpC;;AoCxtIA;EACE,WAAA;EvBvHE,kCNmzBgC;APgiHpC;;AoCvtIA;EACE,WAAA;EvBpHE,2CN0yBgC;EMzyBhC,4CNyyBgC;APsiHpC;;AoCxtIA;EACE,WAAA;EvB3GE,+CN4xBgC;EM3xBhC,8CN2xBgC;AP4iHpC;;AoCttIA;EACE,aAAA;EACA,sBAAA;ApCytIF;AoCvtIE;EACE,mB7B6qBgC;AP4iHpC;AiBhzII;EmBkFJ;IASI,mBAAA;IACA,mBAAA;IACA,kBAAA;EpCytIF;EoCvtIE;IACE,aAAA;IAEA,SAAA;IACA,sBAAA;IACA,kB7BgqB8B;I6B/pB9B,gBAAA;IACA,iB7B8pB8B;EP0jHlC;AACF;;AoC/sIA;EACE,aAAA;EACA,sBAAA;ApCktIF;AoC9sIE;EACE,mB7B6oBgC;APmkHpC;AiBv0II;EmBgHJ;IAWI,mBAAA;EpCgtIF;EoC7sIE;IAEE,SAAA;IACA,gBAAA;EpC8sIJ;EoC5sII;IACE,cAAA;IACA,cAAA;EpC8sIN;EoCzsIM;IvBjLJ,0BuBkLmC;IvBjLnC,6BuBiLmC;EpC4sIrC;EoC1sIQ;;IAGE,0BAAA;EpC2sIV;EoCzsIQ;;IAGE,6BAAA;EpC0sIV;EoCtsIM;IvBlLJ,yBuBmLkC;IvBlLlC,4BuBkLkC;EpCysIpC;EoCvsIQ;;IAGE,yBAAA;EpCwsIV;EoCtsIQ;;IAGE,4BAAA;EpCusIV;AACF;;AoC1rIE;EACE,sB7BokBgC;APynHpC;AiBh3II;EmBiLJ;IAMI,e7BglBgC;I6B/kBhC,mB7BglBgC;I6B/kBhC,UAAA;IACA,SAAA;EpC6rIF;EoC3rIE;IACE,qBAAA;IACA,WAAA;EpC6rIJ;AACF;;AoCnrIE;EACE,gBAAA;ApCsrIJ;AoCnrIM;EvBpQF,gBuBqQ2B;ApCqrI/B;AoClrIM;EACE,gBAAA;EvBzQJ,gBuB0Q2B;ApCorI/B;AoChrII;EACE,gBAAA;EvBxPF,6BuByPgC;EvBxPhC,4BuBwPgC;ApCmrIpC;AoChrII;EvB1QA,yBuB2Q6B;EvB1Q7B,0BuB0Q6B;ApCmrIjC;AoChrII;EACE,mBAAA;ApCkrIN;;AqC/8IA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB9B6gCkC;E8B5gClC,gBAAA;EACA,yB9BGS;EMJP,sBNqO0B;AP+uI9B;;AqC78IE;EACE,oB9BkgCgC;AP88GpC;AqC98II;EACE,qBAAA;EACA,qB9B8/B8B;E8B7/B9B,c9BLK;E8BML,Y9BmgC8B;AP68GpC;AqCt8IE;EACE,0BAAA;ArCw8IJ;AqCr8IE;EACE,qBAAA;ArCu8IJ;AqCp8IE;EACE,c9BzBO;AP+9IX;;AsC5+IA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGAE,sBNqO0B;APywI9B;;AsC7+IA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iB/BwwBkC;E+BvwBlC,c/B+JwC;E+B9JxC,sB/BNS;E+BOT,yBAAA;AtCg/IF;AsC9+IE;EACE,UAAA;EACA,mC/B2JsC;E+B1JtC,qBAAA;EACA,yB/BXO;E+BYP,qB/BXO;AP2/IX;AsC7+IE;EACE,UAAA;EACA,U/BiwBgC;E+BhwBhC,gBrCwE0B;ADu6I9B;;AsCz+II;EACE,cAAA;EzBCF,+BNuM0B;EMtM1B,kCNsM0B;APsyI9B;AsCz+II;EzBlBA,gCNqN0B;EMpN1B,mCNoN0B;AP0yI9B;AsCx+IE;EACE,UAAA;EACA,W/BvCO;E+BwCP,yBrCoGkB;EqCnGlB,qB/BqM0B;APqyI9B;AsCv+IE;EACE,c/BvCO;E+BwCP,oBAAA;EAEA,YAAA;EACA,sB/BjDO;E+BkDP,qB/B/CO;APuhJX;;AuC9hJE;EACE,uBAAA;E/B2HE,iBAtCa;E+BnFf,gBhC8N0B;APm0I9B;AuC5hJM;E1BwBF,8BNwM0B;EMvM1B,iCNuM0B;APg0I9B;AuC3hJM;E1BKF,+BNsN0B;EMrN1B,kCNqN0B;APo0I9B;;AuC5iJE;EACE,uBAAA;E/B2HE,mBAtCa;E+BnFf,gBhC+N0B;APg1I9B;AuC1iJM;E1BwBF,8BNyM0B;EMxM1B,iCNwM0B;AP60I9B;AuCziJM;E1BKF,+BNuN0B;EMtN1B,kCNsN0B;APi1I9B;;AwCxjJA;EACE,qBAAA;EACA,qBAAA;EhCiEE,cAAA;EgC/DF,gBjCmR4B;EiClR5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BRE,sBNqO0B;EepOxB,qIkBSJ;AxC2jJF;AsB/jJI;EkBNJ;IlBOM,gBAAA;EtBkkJJ;AACF;AG/jJE;EqCGI,qBAAA;AxC+jJN;;AwC1jJE;EACE,aAAA;AxC6jJJ;;AwCxjJA;EACE,kBAAA;EACA,SAAA;AxC2jJF;;AwCpjJA;EACE,oBjCg3BkC;EiC/2BlC,mBjC+2BkC;EMn5BhC,oBNs5BgC;APssHpC;;AwC/iJE;ECjDA,WAAA;EACA,yBxCoEa;ADgiJf;AGtlJE;EsCVI,WAAA;EACA,oEAAA;AzCmmJN;AyChmJI;EAEE,UAAA;EACA,+CAAA;AzCimJN;;AwC5jJE;ECjDA,WAAA;EACA,yBxCoEa;AD6iJf;AGnmJE;EsCVI,WAAA;EACA,qEAAA;AzCgnJN;AyC7mJI;EAEE,UAAA;EACA,iDAAA;AzC8mJN;;AwCzkJE;ECjDA,WAAA;EACA,yBxCoEa;AD0jJf;AGhnJE;EsCVI,WAAA;EACA,qEAAA;AzC6nJN;AyC1nJI;EAEE,UAAA;EACA,gDAAA;AzC2nJN;;AwCtlJE;ECjDA,WAAA;EACA,yBxCoEa;ADukJf;AG7nJE;EsCVI,WAAA;EACA,yDAAA;AzC0oJN;AyCvoJI;EAEE,UAAA;EACA,gDAAA;AzCwoJN;;AwCnmJE;ECjDA,cAAA;EACA,yBxCoEa;ADolJf;AG1oJE;EsCVI,cAAA;EACA,mEAAA;AzCupJN;AyCppJI;EAEE,UAAA;EACA,gDAAA;AzCqpJN;;AwChnJE;ECjDA,WAAA;EACA,yBxCoEa;ADimJf;AGvpJE;EsCVI,WAAA;EACA,qEAAA;AzCoqJN;AyCjqJI;EAEE,UAAA;EACA,+CAAA;AzCkqJN;;AwC7nJE;ECjDA,cAAA;EACA,yBxCoEa;AD8mJf;AGpqJE;EsCVI,cAAA;EACA,qEAAA;AzCirJN;AyC9qJI;EAEE,UAAA;EACA,iDAAA;AzC+qJN;;AwC1oJE;ECjDA,WAAA;EACA,yBxCoEa;AD2nJf;AGjrJE;EsCVI,WAAA;EACA,qEAAA;AzC8rJN;AyC3rJI;EAEE,UAAA;EACA,8CAAA;AzC4rJN;;AwCvpJE;ECjDA,WAAA;EACA,yBxCoEa;ADwoJf;AG9rJE;EsCVI,WAAA;EACA,oEAAA;AzC2sJN;AyCxsJI;EAEE,UAAA;EACA,8CAAA;AzCysJN;;AwCpqJE;ECjDA,WAAA;EACA,yBxCoEa;ADqpJf;AG3sJE;EsCVI,WAAA;EACA,qEAAA;AzCwtJN;AyCrtJI;EAEE,UAAA;EACA,gDAAA;AzCstJN;;A0CnuJA;EACE,kBAAA;EACA,mBnC0yBkC;EmCxyBlC,yBnCKS;EMJP,qBNsO0B;AP+/I9B;AiB9qJI;EyB5DJ;IAQI,kBAAA;E1CsuJF;AACF;;A0CnuJA;EACE,gBAAA;EACA,eAAA;E7BTE,gB6BUqB;A1CsuJzB;;A2CjvJA;EACE,kBAAA;EACA,wBAAA;EACA,mBpCm8BkC;EoCl8BlC,6BAAA;E9BHE,sBNqO0B;APmhJ9B;;A2ChvJA;EAEE,cAAA;A3CkvJF;;A2C9uJA;EACE,gBpCwQ4B;APy+I9B;;A2CzuJA;EACE,mBAAA;A3C4uJF;A2CzuJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,wBAAA;EACA,cAAA;A3C2uJJ;;A2CjuJE;EC9CA,0DD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;A3CsuJvE;A4CjxJE;EACE,qEAAA;A5CmxJJ;A4ChxJE;EACE,0DAAA;A5CkxJJ;;A2C7uJE;EC9CA,0DD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;A3CkvJvE;A4C7xJE;EACE,oEAAA;A5C+xJJ;A4C5xJE;EACE,0DAAA;A5C8xJJ;;A2CzvJE;EC9CA,yDD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,gED6CqE;A3C8vJvE;A4CzyJE;EACE,oEAAA;A5C2yJJ;A4CxyJE;EACE,yDAAA;A5C0yJJ;;A2CrwJE;EC9CA,8CD+CqH;EnB1CnH,2DmB0CuB;EC7CzB,uDD6CqE;A3C0wJvE;A4CrzJE;EACE,2DAAA;A5CuzJJ;A4CpzJE;EACE,yDAAA;A5CszJJ;;A2CjxJE;EC9CA,wDD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;A3CsxJvE;A4Cj0JE;EACE,kEAAA;A5Cm0JJ;A4Ch0JE;EACE,yDAAA;A5Ck0JJ;;A2C7xJE;EC9CA,yDD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,gED6CqE;A3CkyJvE;A4C70JE;EACE,oEAAA;A5C+0JJ;A4C50JE;EACE,yDAAA;A5C80JJ;;A2CzyJE;EC9CA,0DD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;A3C8yJvE;A4Cz1JE;EACE,qEAAA;A5C21JJ;A4Cx1JE;EACE,0DAAA;A5C01JJ;;A2CrzJE;EC9CA,0DD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,gED6CqE;A3C0zJvE;A4Cr2JE;EACE,oEAAA;A5Cu2JJ;A4Cp2JE;EACE,uDAAA;A5Cs2JJ;;A2Cj0JE;EC9CA,0DD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;A3Cs0JvE;A4Cj3JE;EACE,qEAAA;A5Cm3JJ;A4Ch3JE;EACE,uDAAA;A5Ck3JJ;;A2C70JE;EC9CA,0DD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,gED6CqE;A3Ck1JvE;A4C73JE;EACE,qEAAA;A5C+3JJ;A4C53JE;EACE,0DAAA;A5C83JJ;;A6Ct4JE;EACE;IAAO,2BAAA;E7C04JT;E6Cz4JE;IAAK,wBAAA;E7C44JP;AACF;A6Cz4JA;EACE,aAAA;EACA,YtC48BkC;EsC38BlC,gBAAA;ErCoHI,kBAtCa;EqC5EjB,yBtCJS;EMJP,sBNqO0B;AP+qJ9B;;A6Cv4JA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WtCfS;EsCgBT,kBAAA;EACA,mBAAA;EACA,yB5C8HgB;EqBjJZ,2BuBoBJ;A7C04JF;AsBz5JI;EuBOJ;IvBNM,gBAAA;EtB45JJ;AACF;;A6C54JA;ErBcE,qMAAA;EqBZA,0BAAA;A7C+4JF;;A6C34JE;EACE,kDAAA;A7C84JJ;A6C54JI;EAHF;IAII,eAAA;E7C+4JJ;AACF;;A8Cv7JA;EACE,aAAA;EACA,uBAAA;A9C07JF;;A8Cv7JA;EACE,SAAA;A9C07JF;;A+C57JA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;A/C67JF;;A+Cp7JA;EACE,WAAA;EACA,cxCPS;EwCQT,mBAAA;A/Cu7JF;AG77JE;E4CUE,UAAA;EACA,cxCbO;EwCcP,qBAAA;EACA,yBxCrBO;AP28JX;A+Cn7JE;EACE,cxCjBO;EwCkBP,yBxCzBO;AP88JX;;A+C56JA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAEA,mBAAA;EAEA,sBxC3CS;EwC4CT,sCAAA;A/C66JF;A+C36JE;ElCvCE,+BN4N0B;EM3N1B,gCN2N0B;AP0vJ9B;A+C36JE;EACE,gBAAA;ElC9BA,mCN8M0B;EM7M1B,kCN6M0B;AP+vJ9B;A+C36JE;EAEE,cxCnDO;EwCoDP,oBAAA;EACA,sBxC3DO;APu+JX;A+Cx6JE;EACE,UAAA;EACA,WxCjEO;EwCkEP,yB9C0EkB;E8CzElB,qBxC2K0B;AP+vJ9B;;A+C75JI;EACE,mBAAA;A/Cg6JN;A+C95JM;EACE,kBAAA;EACA,gBAAA;A/Cg6JR;A+C95JQ;ElC3DJ,+BNuM0B;EMtM1B,kCNsM0B;EM1L1B,0BkCgDuC;A/Ci6J3C;A+C95JQ;EACE,eAAA;ElC/EN,gCNqN0B;EMpN1B,mCNoN0B;EM9K1B,4BkC0CyC;A/Ci6J7C;;AiB38JI;E8B2BA;IACE,mBAAA;E/Co7JJ;E+Cl7JI;IACE,kBAAA;IACA,gBAAA;E/Co7JN;E+Cl7JM;IlC3DJ,+BNuM0B;IMtM1B,kCNsM0B;IM1L1B,0BkCgDuC;E/Cq7JzC;E+Cl7JM;IACE,eAAA;IlC/EN,gCNqN0B;IMpN1B,mCNoN0B;IM9K1B,4BkC0CyC;E/Cq7J3C;AACF;AiBh+JI;E8B2BA;IACE,mBAAA;E/Cw8JJ;E+Ct8JI;IACE,kBAAA;IACA,gBAAA;E/Cw8JN;E+Ct8JM;IlC3DJ,+BNuM0B;IMtM1B,kCNsM0B;IM1L1B,0BkCgDuC;E/Cy8JzC;E+Ct8JM;IACE,eAAA;IlC/EN,gCNqN0B;IMpN1B,mCNoN0B;IM9K1B,4BkC0CyC;E/Cy8J3C;AACF;AiBp/JI;E8B2BA;IACE,mBAAA;E/C49JJ;E+C19JI;IACE,kBAAA;IACA,gBAAA;E/C49JN;E+C19JM;IlC3DJ,+BNuM0B;IMtM1B,kCNsM0B;IM1L1B,0BkCgDuC;E/C69JzC;E+C19JM;IACE,eAAA;IlC/EN,gCNqN0B;IMpN1B,mCNoN0B;IM9K1B,4BkC0CyC;E/C69J3C;AACF;AiBxgKI;E8B2BA;IACE,mBAAA;E/Cg/JJ;E+C9+JI;IACE,kBAAA;IACA,gBAAA;E/Cg/JN;E+C9+JM;IlC3DJ,+BNuM0B;IMtM1B,kCNsM0B;IM1L1B,0BkCgDuC;E/Ci/JzC;E+C9+JM;IACE,eAAA;IlC/EN,gCNqN0B;IMpN1B,mCNoN0B;IM9K1B,4BkC0CyC;E/Ci/J3C;AACF;A+Cp+JE;EACE,eAAA;EACA,cAAA;ElCjHA,gBkCkHuB;A/Cs+J3B;A+Cp+JI;EACE,mBAAA;A/Cs+JN;A+Cj+JI;EACE,aAAA;A/Cm+JN;A+C99JI;EACE,gBAAA;EACA,gBAAA;A/Cg+JN;;AEpmKE;EACE,0D6C+IsE;E7C9ItE,qE6C8IuC;A/Cy9J3C;AG5lKE;EDPM,0D6C0IkE;E7CzIlE,qEAAA;AFsmKR;AEnmKM;EACE,WAAA;EACA,qE6CoIkE;E7CnIlE,iE6CmIkE;A/Ck+J1E;;AElnKE;EACE,0D6C+IsE;E7C9ItE,qE6C8IuC;A/Cu+J3C;AG1mKE;EDPM,0D6C0IkE;E7CzIlE,oEAAA;AFonKR;AEjnKM;EACE,WAAA;EACA,qE6CoIkE;E7CnIlE,iE6CmIkE;A/Cg/J1E;;AEhoKE;EACE,yD6C+IsE;E7C9ItE,oE6C8IuC;A/Cq/J3C;AGxnKE;EDPM,yD6C0IkE;E7CzIlE,oEAAA;AFkoKR;AE/nKM;EACE,WAAA;EACA,oE6CoIkE;E7CnIlE,gE6CmIkE;A/C8/J1E;;AE9oKE;EACE,8C6C+IsE;E7C9ItE,2D6C8IuC;A/CmgK3C;AGtoKE;EDPM,8C6C0IkE;E7CzIlE,2DAAA;AFgpKR;AE7oKM;EACE,WAAA;EACA,yD6CoIkE;E7CnIlE,qD6CmIkE;A/C4gK1E;;AE5pKE;EACE,wD6C+IsE;E7C9ItE,qE6C8IuC;A/CihK3C;AGppKE;EDPM,wD6C0IkE;E7CzIlE,kEAAA;AF8pKR;AE3pKM;EACE,WAAA;EACA,mE6CoIkE;E7CnIlE,+D6CmIkE;A/C0hK1E;;AE1qKE;EACE,yD6C+IsE;E7C9ItE,oE6C8IuC;A/C+hK3C;AGlqKE;EDPM,yD6C0IkE;E7CzIlE,oEAAA;AF4qKR;AEzqKM;EACE,WAAA;EACA,oE6CoIkE;E7CnIlE,gE6CmIkE;A/CwiK1E;;AExrKE;EACE,0D6C+IsE;E7C9ItE,qE6C8IuC;A/C6iK3C;AGhrKE;EDPM,0D6C0IkE;E7CzIlE,qEAAA;AF0rKR;AEvrKM;EACE,WAAA;EACA,qE6CoIkE;E7CnIlE,iE6CmIkE;A/CsjK1E;;AEtsKE;EACE,0D6C+IsE;E7C9ItE,oE6C8IuC;A/C2jK3C;AG9rKE;EDPM,0D6C0IkE;E7CzIlE,oEAAA;AFwsKR;AErsKM;EACE,WAAA;EACA,qE6CoIkE;E7CnIlE,iE6CmIkE;A/CokK1E;;AEptKE;EACE,0D6C+IsE;E7C9ItE,qE6C8IuC;A/CykK3C;AG5sKE;EDPM,0D6C0IkE;E7CzIlE,qEAAA;AFstKR;AEntKM;EACE,WAAA;EACA,qE6CoIkE;E7CnIlE,iE6CmIkE;A/CklK1E;;AEluKE;EACE,0D6C+IsE;E7C9ItE,oE6C8IuC;A/CulK3C;AG1tKE;EDPM,0D6C0IkE;E7CzIlE,qEAAA;AFouKR;AEjuKM;EACE,WAAA;EACA,qE6CoIkE;E7CnIlE,iE6CmIkE;A/CgmK1E;;AgDnvKA;EACE,YAAA;ExC8HI,iBAtCa;EwCtFjB,gBzCyR4B;EyCxR5B,cAAA;EACA,WzCYS;EyCXT,yBzCgkCkC;EyC/jClC,YAAA;AhDsvKF;AGjvKE;E6CDE,WzCMO;EyCLP,qBAAA;AhDqvKJ;AGjvKE;E6CCI,aAAA;AhDmvKN;;AgDxuKA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;AhD2uKF;;AgDruKA;EACE,oBAAA;AhDwuKF;;AiD/wKA;EACE,gB1C43BkC;E0C33BlC,gBAAA;EzC6HI,mBAtCa;EyCpFjB,2C1C63BkC;E0C53BlC,4BAAA;EACA,oCAAA;EACA,gD1C83BkC;E0C73BlC,mCAAA;UAAA,2BAAA;EACA,UAAA;EpCLE,sBNg4BgC;APu5IpC;AiD/wKE;EACE,sB1Cg3BgC;APi6IpC;AiD9wKE;EACE,UAAA;AjDgxKJ;AiD7wKE;EACE,cAAA;EACA,UAAA;AjD+wKJ;AiD5wKE;EACE,aAAA;AjD8wKJ;;AiD1wKA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c1CtBS;E0CuBT,2C1Cq2BkC;E0Cp2BlC,4BAAA;EACA,4CAAA;AjD6wKF;;AiD1wKA;EACE,gB1Co1BkC;APy7IpC;;AkDjzKA;EAEE,gBAAA;AlDmzKF;AkDjzKE;EACE,kBAAA;EACA,gBAAA;AlDmzKJ;;AkD9yKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a3CopBkC;E2CnpBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AlD+yKF;;AkDxyKA;EACE,kBAAA;EACA,WAAA;EACA,c3C63BkC;E2C33BlC,oBAAA;AlD0yKF;AkDvyKE;E5BrCI,mC4BsCF;AlDyyKJ;AsB10KI;E4BgCF;I5B/BI,gBAAA;EtB60KJ;AACF;AkD/yKE;EAEE,8B3Ck5BgC;AP85IpC;AkD9yKE;EACE,e3Cg5BgC;APg6IpC;;AkD5yKA;EACE,aAAA;EACA,6BAAA;AlD+yKF;AkD7yKE;EACE,8BAAA;EACA,gBAAA;AlD+yKJ;AkD5yKE;;EAEE,cAAA;AlD8yKJ;AkD3yKE;EACE,gBAAA;AlD6yKJ;;AkDzyKA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AlD4yKF;AkDzyKE;EACE,cAAA;EACA,0BAAA;EACA,WAAA;AlD2yKJ;AkDvyKE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AlDyyKJ;AkDvyKI;EACE,gBAAA;AlDyyKN;AkDtyKI;EACE,aAAA;AlDwyKN;;AkDlyKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB3CrGS;E2CsGT,4BAAA;EACA,oCAAA;ErCzGE,qBNsO0B;E2CzH5B,UAAA;AlDiyKF;;AkD7xKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a3C8iBkC;E2C7iBlC,YAAA;EACA,aAAA;EACA,sB3C5GS;AP44KX;AkD7xKE;EAAS,UAAA;AlDgyKX;AkD/xKE;EAAS,Y3CgzByB;APk/IpC;;AkD7xKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kB3C8yBkC;E2C7yBlC,gCAAA;ErC7HE,8BN6N0B;EM5N1B,+BN4N0B;APksK9B;AkD/xKE;EACE,kB3CyyBgC;E2CvyBhC,8BAAA;AlDgyKJ;;AkD3xKA;EACE,gBAAA;EACA,gB3CwI4B;APspK9B;;AkDzxKA;EACE,kBAAA;EAGA,cAAA;EACA,a3C+vBkC;AP2hJpC;;AkDtxKA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,a3CuvBkC;E2CtvBlC,6BAAA;ErC/IE,kCN+M0B;EM9M1B,iCN8M0B;AP2tK9B;AkDvxKE;EAAuB,oBAAA;AlD0xKzB;AkDzxKE;EAAsB,qBAAA;AlD4xKxB;;AkDxxKA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AlD2xKF;;AiBx5KI;EiCmIF;IACE,gB3C4vBgC;I2C3vBhC,oBAAA;ElDyxKF;EkDtxKA;IACE,+BAAA;ElDwxKF;EkDtxKE;IACE,gCAAA;ElDwxKJ;EkDpxKA;IACE,+BAAA;ElDsxKF;EkDpxKE;IACE,4BAAA;ElDsxKJ;EkD9wKA;IAAY,gB3CquBsB;EP4iJlC;AACF;AiB96KI;EiCgKF;;IAEE,gB3C6tBgC;EPojJlC;AACF;AiBp7KI;EiCuKF;IAAY,iB3CutBsB;EP0jJlC;AACF;AmDp/KA;EACE,kBAAA;EACA,a5CwqBkC;E4CvqBlC,cAAA;EACA,S5C60BkC;E6Cj1BlC,kM7C+Q4B;E6C7Q5B,kBAAA;EACA,gB7CuR4B;E6CtR5B,gB7C2R4B;E6C1R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E5CgHI,mBAtCa;E2C9EjB,qBAAA;EACA,UAAA;AnDggLF;AmD9/KE;EAAS,Y5Ci0ByB;APgsJpC;AmD//KE;EACE,kBAAA;EACA,cAAA;EACA,a5Ci0BgC;E4Ch0BhC,c5Ci0BgC;APgsJpC;AmD//KI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDigLN;;AmD5/KA;EACE,iBAAA;AnD+/KF;AmD7/KE;EACE,SAAA;AnD+/KJ;AmD7/KI;EACE,MAAA;EACA,6BAAA;EACA,sB5CvBK;APshLX;;AmD1/KA;EACE,iBAAA;AnD6/KF;AmD3/KE;EACE,OAAA;EACA,a5CmyBgC;E4ClyBhC,c5CiyBgC;AP4tJpC;AmD3/KI;EACE,QAAA;EACA,oCAAA;EACA,wB5CvCK;APoiLX;;AmDx/KA;EACE,iBAAA;AnD2/KF;AmDz/KE;EACE,MAAA;AnD2/KJ;AmDz/KI;EACE,SAAA;EACA,6BAAA;EACA,yB5CrDK;APgjLX;;AmDt/KA;EACE,iBAAA;AnDy/KF;AmDv/KE;EACE,QAAA;EACA,a5CqwBgC;E4CpwBhC,c5CmwBgC;APsvJpC;AmDv/KI;EACE,OAAA;EACA,oCAAA;EACA,uB5CrEK;AP8jLX;;AmDp+KA;EACE,gB5C+tBkC;E4C9tBlC,uBAAA;EACA,W5CvGS;E4CwGT,kBAAA;EACA,sB5C/FS;EMZP,sBNqO0B;AP82K9B;;AqDxlLA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a9CsqBkC;E8CrqBlC,cAAA;EACA,gBpDqIkB;EmD1IlB,kM7C+Q4B;E6C7Q5B,kBAAA;EACA,gB7CuR4B;E6CtR5B,gB7C2R4B;E6C1R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E5CgHI,mBAtCa;E6C7EjB,qBAAA;EACA,sB9CNS;E8COT,4BAAA;EACA,6EAAA;ExCVE,qBNsO0B;AP04K9B;AqDlmLE;EACE,kBAAA;EACA,cAAA;EACA,W9C81BgC;E8C71BhC,c9C81BgC;E8C71BhC,gBAAA;ArDomLJ;AqDlmLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArDmmLN;;AqD9lLA;EACE,qB9C+0BkC;APkxJpC;AqD/lLE;EACE,iCAAA;ArDimLJ;AqD/lLI;EACE,SAAA;EACA,6BAAA;EACA,qC9C00B8B;APuxJpC;AqD9lLI;EACE,W9CqLwB;E8CpLxB,6BAAA;EACA,sB9C7CK;AP6oLX;;AqD3lLA;EACE,mB9C2zBkC;APmyJpC;AqD5lLE;EACE,+BAAA;EACA,a9CuzBgC;E8CtzBhC,Y9CqzBgC;E8CpzBhC,gBAAA;ArD8lLJ;AqD5lLI;EACE,OAAA;EACA,oCAAA;EACA,uC9CmzB8B;AP2yJpC;AqD3lLI;EACE,S9C8JwB;E8C7JxB,oCAAA;EACA,wB9CpEK;APiqLX;;AqDxlLA;EACE,kB9CoyBkC;APuzJpC;AqDzlLE;EACE,8BAAA;ArD2lLJ;AqDzlLI;EACE,MAAA;EACA,oCAAA;EACA,wC9C+xB8B;AP4zJpC;AqDxlLI;EACE,Q9C0IwB;E8CzIxB,oCAAA;EACA,yB9CxFK;APkrLX;AqDrlLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,W9C2wBgC;E8C1wBhC,oBAAA;EACA,WAAA;EACA,6BAAA;ArDulLJ;;AqDnlLA;EACE,oB9CowBkC;APk1JpC;AqDplLE;EACE,gCAAA;EACA,a9CgwBgC;E8C/vBhC,Y9C8vBgC;E8C7vBhC,gBAAA;ArDslLJ;AqDplLI;EACE,QAAA;EACA,oCAAA;EACA,sC9C4vB8B;AP01JpC;AqDnlLI;EACE,U9CuGwB;E8CtGxB,oCAAA;EACA,uB9C3HK;APgtLX;;AqD/jLA;EACE,uBAAA;EACA,gBAAA;E7C3BI,kBAtCa;E6CoEjB,sBpD/IM;EoDgJN,2CAAA;ExChJE,0CwCiJoB;ExChJpB,2CwCgJoB;ArDkkLxB;AqD/jLE;EACE,aAAA;ArDikLJ;;AqD7jLA;EACE,uBAAA;EACA,c9CzJS;APytLX;;AsD5tLA;EACE,kBAAA;AtD+tLF;;AsD5tLA;EACE,mBAAA;AtD+tLF;;AsD5tLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtD+tLF;AuDtvLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDwvLJ;;AsDhuLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhC5BI,sCgC6BJ;AtDmuLF;AsB3vLI;EgCiBJ;IhChBM,gBAAA;EtB8vLJ;AACF;;AsDruLA;;;EAGE,cAAA;AtDwuLF;;AsDruLA;;EAEE,2BAAA;AtDwuLF;;AsDruLA;;EAEE,4BAAA;AtDwuLF;;AsD/tLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDkuLJ;AsD/tLE;;;EAGE,UAAA;EACA,UAAA;AtDiuLJ;AsD9tLE;;EAEE,UAAA;EACA,UAAA;EhCtEE,2BgCuEF;AtDguLJ;AsBlyLI;EgC8DF;;IhC7DI,gBAAA;EtBsyLJ;AACF;;AsD7tLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,U/C87BmC;E+C77BnC,W/C1FS;E+C2FT,kBAAA;EACA,Y/C47BmC;EezhC/B,8BgC8FJ;AtD+tLF;AsBxzLI;EgC2EJ;;IhC1EM,gBAAA;EtB4zLJ;AACF;AGzzLE;;;EmDwFE,W/CjGO;E+CkGP,qBAAA;EACA,UAAA;EACA,Y/Cq7BiC;APizJrC;;AsDnuLA;EACE,OAAA;AtDsuLF;;AsDjuLA;EACE,QAAA;AtDouLF;;AsD7tLA;;EAEE,qBAAA;EACA,W/C86BmC;E+C76BnC,Y/C66BmC;E+C56BnC,mCAAA;AtDguLF;;AsD9tLA;EACE,yD/C26BmC;APszJrC;;AsD/tLA;EACE,yD/Cy6BmC;APyzJrC;;AsDztLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iB/Co4BmC;E+Cn4BnC,gB/Cm4BmC;E+Cl4BnC,gBAAA;AtD2tLF;AsDztLE;EACE,uBAAA;EACA,cAAA;EACA,W/Ck4BiC;E+Cj4BjC,W/Ck4BiC;E+Cj4BjC,iB/Cm4BiC;E+Cl4BjC,gB/Ck4BiC;E+Cj4BjC,mBAAA;EACA,eAAA;EACA,sB/ChKO;E+CiKP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EhCtKE,6BgCuKF;AtD0tLJ;AsB53LI;EgCmJF;IhClJI,gBAAA;EtB+3LJ;AACF;AsD5tLE;EACE,UAAA;AtD8tLJ;;AsDrtLA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,W/C3LS;E+C4LT,kBAAA;AtDwtLF;;AwDv5LA;EACE;IAAK,yBAAA;ExD25LL;AACF;AwDz5LA;EACE,qBAAA;EACA,WjD8iCsB;EiD7iCtB,YjD6iCsB;EiD5iCtB,2BAAA;EACA,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AxD05LF;;AwDv5LA;EACE,WjDuiCwB;EiDtiCxB,YjDsiCwB;EiDriCxB,mBjDuiCwB;APm3J1B;;AwDn5LA;EACE;IACE,mBAAA;ExDs5LF;EwDp5LA;IACE,UAAA;ExDs5LF;AACF;AwDn5LA;EACE,qBAAA;EACA,WjD+gCsB;EiD9gCtB,YjD8gCsB;EiD7gCtB,2BAAA;EACA,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AxDo5LF;;AwDj5LA;EACE,WjDwgCwB;EiDvgCxB,YjDugCwB;AP64J1B;;AyDv8LA;EAAqB,mCAAA;AzD28LrB;;AyD18LA;EAAqB,8BAAA;AzD88LrB;;AyD78LA;EAAqB,iCAAA;AzDi9LrB;;AyDh9LA;EAAqB,iCAAA;AzDo9LrB;;AyDn9LA;EAAqB,sCAAA;AzDu9LrB;;AyDt9LA;EAAqB,mCAAA;AzD09LrB;;AI59LE;EACE,oCAAA;AJ+9LJ;;AGr9LE;;;ECLI,+EAAA;AJg+LN;;AIt+LE;EACE,oCAAA;AJy+LJ;;AG/9LE;;;ECLI,gFAAA;AJ0+LN;;AIh/LE;EACE,oCAAA;AJm/LJ;;AGz+LE;;;ECLI,gFAAA;AJo/LN;;AI1/LE;EACE,oCAAA;AJ6/LJ;;AGn/LE;;;ECLI,oEAAA;AJ8/LN;;AIpgME;EACE,oCAAA;AJugMJ;;AG7/LE;;;ECLI,8EAAA;AJwgMN;;AI9gME;EACE,oCAAA;AJihMJ;;AGvgME;;;ECLI,gFAAA;AJkhMN;;AIxhME;EACE,oCAAA;AJ2hMJ;;AGjhME;;;ECLI,gFAAA;AJ4hMN;;AIliME;EACE,oCAAA;AJqiMJ;;AG3hME;;;ECLI,gFAAA;AJsiMN;;AI5iME;EACE,oCAAA;AJ+iMJ;;AGriME;;;ECLI,+EAAA;AJgjMN;;AItjME;EACE,oCAAA;AJyjMJ;;AG/iME;;;ECLI,gFAAA;AJ0jMN;;A0DzjMA;EACE,iCAAA;A1D4jMF;;A0DzjMA;EACE,wCAAA;A1D4jMF;;A2DvkMA;EAAkB,oCAAA;A3D2kMlB;;A2D1kMA;EAAkB,wCAAA;A3D8kMlB;;A2D7kMA;EAAkB,0CAAA;A3DilMlB;;A2DhlMA;EAAkB,2CAAA;A3DolMlB;;A2DnlMA;EAAkB,yCAAA;A3DulMlB;;A2DrlMA;EAAmB,oBAAA;A3DylMnB;;A2DxlMA;EAAmB,wBAAA;A3D4lMnB;;A2D3lMA;EAAmB,0BAAA;A3D+lMnB;;A2D9lMA;EAAmB,2BAAA;A3DkmMnB;;A2DjmMA;EAAmB,yBAAA;A3DqmMnB;;A2DlmME;EACE,gCAAA;A3DqmMJ;;A2DtmME;EACE,gCAAA;A3DymMJ;;A2D1mME;EACE,gCAAA;A3D6mMJ;;A2D9mME;EACE,gCAAA;A3DinMJ;;A2DlnME;EACE,gCAAA;A3DqnMJ;;A2DtnME;EACE,gCAAA;A3DynMJ;;A2D1nME;EACE,gCAAA;A3D6nMJ;;A2D9nME;EACE,gCAAA;A3DioMJ;;A2DloME;EACE,gCAAA;A3DqoMJ;;A2DtoME;EACE,gCAAA;A3DyoMJ;;A2DroMA;EACE,6BAAA;A3DwoMF;;A2DjoMA;EACE,gCAAA;A3DooMF;;A2DjoMA;EACE,iCAAA;A3DooMF;;A2DjoMA;EACE,0CAAA;EACA,2CAAA;A3DooMF;;A2DjoMA;EACE,2CAAA;EACA,8CAAA;A3DooMF;;A2DjoMA;EACE,8CAAA;EACA,6CAAA;A3DooMF;;A2DjoMA;EACE,0CAAA;EACA,6CAAA;A3DooMF;;A2DjoMA;EACE,gCAAA;A3DooMF;;A2DjoMA;EACE,6BAAA;A3DooMF;;A2DjoMA;EACE,+BAAA;A3DooMF;;A2DjoMA;EACE,2BAAA;A3DooMF;;AuD5sME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD+sMJ;;A4DxsMM;EAAwB,wBAAA;A5D4sM9B;;A4D5sMM;EAAwB,0BAAA;A5DgtM9B;;A4DhtMM;EAAwB,gCAAA;A5DotM9B;;A4DptMM;EAAwB,yBAAA;A5DwtM9B;;A4DxtMM;EAAwB,yBAAA;A5D4tM9B;;A4D5tMM;EAAwB,6BAAA;A5DguM9B;;A4DhuMM;EAAwB,8BAAA;A5DouM9B;;A4DpuMM;EAAwB,wBAAA;A5DwuM9B;;A4DxuMM;EAAwB,+BAAA;A5D4uM9B;;AiB3rMI;E2CjDE;IAAwB,wBAAA;E5DivM5B;E4DjvMI;IAAwB,0BAAA;E5DovM5B;E4DpvMI;IAAwB,gCAAA;E5DuvM5B;E4DvvMI;IAAwB,yBAAA;E5D0vM5B;E4D1vMI;IAAwB,yBAAA;E5D6vM5B;E4D7vMI;IAAwB,6BAAA;E5DgwM5B;E4DhwMI;IAAwB,8BAAA;E5DmwM5B;E4DnwMI;IAAwB,wBAAA;E5DswM5B;E4DtwMI;IAAwB,+BAAA;E5DywM5B;AACF;AiBztMI;E2CjDE;IAAwB,wBAAA;E5D8wM5B;E4D9wMI;IAAwB,0BAAA;E5DixM5B;E4DjxMI;IAAwB,gCAAA;E5DoxM5B;E4DpxMI;IAAwB,yBAAA;E5DuxM5B;E4DvxMI;IAAwB,yBAAA;E5D0xM5B;E4D1xMI;IAAwB,6BAAA;E5D6xM5B;E4D7xMI;IAAwB,8BAAA;E5DgyM5B;E4DhyMI;IAAwB,wBAAA;E5DmyM5B;E4DnyMI;IAAwB,+BAAA;E5DsyM5B;AACF;AiBtvMI;E2CjDE;IAAwB,wBAAA;E5D2yM5B;E4D3yMI;IAAwB,0BAAA;E5D8yM5B;E4D9yMI;IAAwB,gCAAA;E5DizM5B;E4DjzMI;IAAwB,yBAAA;E5DozM5B;E4DpzMI;IAAwB,yBAAA;E5DuzM5B;E4DvzMI;IAAwB,6BAAA;E5D0zM5B;E4D1zMI;IAAwB,8BAAA;E5D6zM5B;E4D7zMI;IAAwB,wBAAA;E5Dg0M5B;E4Dh0MI;IAAwB,+BAAA;E5Dm0M5B;AACF;AiBnxMI;E2CjDE;IAAwB,wBAAA;E5Dw0M5B;E4Dx0MI;IAAwB,0BAAA;E5D20M5B;E4D30MI;IAAwB,gCAAA;E5D80M5B;E4D90MI;IAAwB,yBAAA;E5Di1M5B;E4Dj1MI;IAAwB,yBAAA;E5Do1M5B;E4Dp1MI;IAAwB,6BAAA;E5Du1M5B;E4Dv1MI;IAAwB,8BAAA;E5D01M5B;E4D11MI;IAAwB,wBAAA;E5D61M5B;E4D71MI;IAAwB,+BAAA;E5Dg2M5B;AACF;A4Dv1MA;EAEI;IAAqB,wBAAA;E5Dy1MvB;E4Dz1ME;IAAqB,0BAAA;E5D41MvB;E4D51ME;IAAqB,gCAAA;E5D+1MvB;E4D/1ME;IAAqB,yBAAA;E5Dk2MvB;E4Dl2ME;IAAqB,yBAAA;E5Dq2MvB;E4Dr2ME;IAAqB,6BAAA;E5Dw2MvB;E4Dx2ME;IAAqB,8BAAA;E5D22MvB;E4D32ME;IAAqB,wBAAA;E5D82MvB;E4D92ME;IAAqB,+BAAA;E5Di3MvB;AACF;A6Dv4MA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A7Dy4MF;A6Dv4ME;EACE,cAAA;EACA,WAAA;A7Dy4MJ;A6Dt4ME;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A7Dw4MJ;;A6D/3MI;EACE,2BAAA;A7Dk4MN;;A6Dn4MI;EACE,mBAAA;A7Ds4MN;;A6Dv4MI;EACE,gBAAA;A7D04MN;;A6D34MI;EACE,iBAAA;A7D84MN;;A8Dv6MI;EAAgC,8BAAA;A9D26MpC;;A8D16MI;EAAgC,iCAAA;A9D86MpC;;A8D76MI;EAAgC,sCAAA;A9Di7MpC;;A8Dh7MI;EAAgC,yCAAA;A9Do7MpC;;A8Dl7MI;EAA8B,0BAAA;A9Ds7MlC;;A8Dr7MI;EAA8B,4BAAA;A9Dy7MlC;;A8Dx7MI;EAA8B,kCAAA;A9D47MlC;;A8D37MI;EAA8B,yBAAA;A9D+7MlC;;A8D97MI;EAA8B,uBAAA;A9Dk8MlC;;A8Dj8MI;EAA8B,uBAAA;A9Dq8MlC;;A8Dp8MI;EAA8B,yBAAA;A9Dw8MlC;;A8Dv8MI;EAA8B,yBAAA;A9D28MlC;;A8Dz8MI;EAAoC,sCAAA;A9D68MxC;;A8D58MI;EAAoC,oCAAA;A9Dg9MxC;;A8D/8MI;EAAoC,kCAAA;A9Dm9MxC;;A8Dl9MI;EAAoC,yCAAA;A9Ds9MxC;;A8Dr9MI;EAAoC,wCAAA;A9Dy9MxC;;A8Dv9MI;EAAiC,kCAAA;A9D29MrC;;A8D19MI;EAAiC,gCAAA;A9D89MrC;;A8D79MI;EAAiC,8BAAA;A9Di+MrC;;A8Dh+MI;EAAiC,gCAAA;A9Do+MrC;;A8Dn+MI;EAAiC,+BAAA;A9Du+MrC;;A8Dr+MI;EAAkC,oCAAA;A9Dy+MtC;;A8Dx+MI;EAAkC,kCAAA;A9D4+MtC;;A8D3+MI;EAAkC,gCAAA;A9D++MtC;;A8D9+MI;EAAkC,uCAAA;A9Dk/MtC;;A8Dj/MI;EAAkC,sCAAA;A9Dq/MtC;;A8Dp/MI;EAAkC,iCAAA;A9Dw/MtC;;A8Dt/MI;EAAgC,2BAAA;A9D0/MpC;;A8Dz/MI;EAAgC,iCAAA;A9D6/MpC;;A8D5/MI;EAAgC,+BAAA;A9DggNpC;;A8D//MI;EAAgC,6BAAA;A9DmgNpC;;A8DlgNI;EAAgC,+BAAA;A9DsgNpC;;A8DrgNI;EAAgC,8BAAA;A9DygNpC;;AiB7/MI;E6ClDA;IAAgC,8BAAA;E9DojNlC;E8DnjNE;IAAgC,iCAAA;E9DsjNlC;E8DrjNE;IAAgC,sCAAA;E9DwjNlC;E8DvjNE;IAAgC,yCAAA;E9D0jNlC;E8DxjNE;IAA8B,0BAAA;E9D2jNhC;E8D1jNE;IAA8B,4BAAA;E9D6jNhC;E8D5jNE;IAA8B,kCAAA;E9D+jNhC;E8D9jNE;IAA8B,yBAAA;E9DikNhC;E8DhkNE;IAA8B,uBAAA;E9DmkNhC;E8DlkNE;IAA8B,uBAAA;E9DqkNhC;E8DpkNE;IAA8B,yBAAA;E9DukNhC;E8DtkNE;IAA8B,yBAAA;E9DykNhC;E8DvkNE;IAAoC,sCAAA;E9D0kNtC;E8DzkNE;IAAoC,oCAAA;E9D4kNtC;E8D3kNE;IAAoC,kCAAA;E9D8kNtC;E8D7kNE;IAAoC,yCAAA;E9DglNtC;E8D/kNE;IAAoC,wCAAA;E9DklNtC;E8DhlNE;IAAiC,kCAAA;E9DmlNnC;E8DllNE;IAAiC,gCAAA;E9DqlNnC;E8DplNE;IAAiC,8BAAA;E9DulNnC;E8DtlNE;IAAiC,gCAAA;E9DylNnC;E8DxlNE;IAAiC,+BAAA;E9D2lNnC;E8DzlNE;IAAkC,oCAAA;E9D4lNpC;E8D3lNE;IAAkC,kCAAA;E9D8lNpC;E8D7lNE;IAAkC,gCAAA;E9DgmNpC;E8D/lNE;IAAkC,uCAAA;E9DkmNpC;E8DjmNE;IAAkC,sCAAA;E9DomNpC;E8DnmNE;IAAkC,iCAAA;E9DsmNpC;E8DpmNE;IAAgC,2BAAA;E9DumNlC;E8DtmNE;IAAgC,iCAAA;E9DymNlC;E8DxmNE;IAAgC,+BAAA;E9D2mNlC;E8D1mNE;IAAgC,6BAAA;E9D6mNlC;E8D5mNE;IAAgC,+BAAA;E9D+mNlC;E8D9mNE;IAAgC,8BAAA;E9DinNlC;AACF;AiBtmNI;E6ClDA;IAAgC,8BAAA;E9D4pNlC;E8D3pNE;IAAgC,iCAAA;E9D8pNlC;E8D7pNE;IAAgC,sCAAA;E9DgqNlC;E8D/pNE;IAAgC,yCAAA;E9DkqNlC;E8DhqNE;IAA8B,0BAAA;E9DmqNhC;E8DlqNE;IAA8B,4BAAA;E9DqqNhC;E8DpqNE;IAA8B,kCAAA;E9DuqNhC;E8DtqNE;IAA8B,yBAAA;E9DyqNhC;E8DxqNE;IAA8B,uBAAA;E9D2qNhC;E8D1qNE;IAA8B,uBAAA;E9D6qNhC;E8D5qNE;IAA8B,yBAAA;E9D+qNhC;E8D9qNE;IAA8B,yBAAA;E9DirNhC;E8D/qNE;IAAoC,sCAAA;E9DkrNtC;E8DjrNE;IAAoC,oCAAA;E9DorNtC;E8DnrNE;IAAoC,kCAAA;E9DsrNtC;E8DrrNE;IAAoC,yCAAA;E9DwrNtC;E8DvrNE;IAAoC,wCAAA;E9D0rNtC;E8DxrNE;IAAiC,kCAAA;E9D2rNnC;E8D1rNE;IAAiC,gCAAA;E9D6rNnC;E8D5rNE;IAAiC,8BAAA;E9D+rNnC;E8D9rNE;IAAiC,gCAAA;E9DisNnC;E8DhsNE;IAAiC,+BAAA;E9DmsNnC;E8DjsNE;IAAkC,oCAAA;E9DosNpC;E8DnsNE;IAAkC,kCAAA;E9DssNpC;E8DrsNE;IAAkC,gCAAA;E9DwsNpC;E8DvsNE;IAAkC,uCAAA;E9D0sNpC;E8DzsNE;IAAkC,sCAAA;E9D4sNpC;E8D3sNE;IAAkC,iCAAA;E9D8sNpC;E8D5sNE;IAAgC,2BAAA;E9D+sNlC;E8D9sNE;IAAgC,iCAAA;E9DitNlC;E8DhtNE;IAAgC,+BAAA;E9DmtNlC;E8DltNE;IAAgC,6BAAA;E9DqtNlC;E8DptNE;IAAgC,+BAAA;E9DutNlC;E8DttNE;IAAgC,8BAAA;E9DytNlC;AACF;AiB9sNI;E6ClDA;IAAgC,8BAAA;E9DowNlC;E8DnwNE;IAAgC,iCAAA;E9DswNlC;E8DrwNE;IAAgC,sCAAA;E9DwwNlC;E8DvwNE;IAAgC,yCAAA;E9D0wNlC;E8DxwNE;IAA8B,0BAAA;E9D2wNhC;E8D1wNE;IAA8B,4BAAA;E9D6wNhC;E8D5wNE;IAA8B,kCAAA;E9D+wNhC;E8D9wNE;IAA8B,yBAAA;E9DixNhC;E8DhxNE;IAA8B,uBAAA;E9DmxNhC;E8DlxNE;IAA8B,uBAAA;E9DqxNhC;E8DpxNE;IAA8B,yBAAA;E9DuxNhC;E8DtxNE;IAA8B,yBAAA;E9DyxNhC;E8DvxNE;IAAoC,sCAAA;E9D0xNtC;E8DzxNE;IAAoC,oCAAA;E9D4xNtC;E8D3xNE;IAAoC,kCAAA;E9D8xNtC;E8D7xNE;IAAoC,yCAAA;E9DgyNtC;E8D/xNE;IAAoC,wCAAA;E9DkyNtC;E8DhyNE;IAAiC,kCAAA;E9DmyNnC;E8DlyNE;IAAiC,gCAAA;E9DqyNnC;E8DpyNE;IAAiC,8BAAA;E9DuyNnC;E8DtyNE;IAAiC,gCAAA;E9DyyNnC;E8DxyNE;IAAiC,+BAAA;E9D2yNnC;E8DzyNE;IAAkC,oCAAA;E9D4yNpC;E8D3yNE;IAAkC,kCAAA;E9D8yNpC;E8D7yNE;IAAkC,gCAAA;E9DgzNpC;E8D/yNE;IAAkC,uCAAA;E9DkzNpC;E8DjzNE;IAAkC,sCAAA;E9DozNpC;E8DnzNE;IAAkC,iCAAA;E9DszNpC;E8DpzNE;IAAgC,2BAAA;E9DuzNlC;E8DtzNE;IAAgC,iCAAA;E9DyzNlC;E8DxzNE;IAAgC,+BAAA;E9D2zNlC;E8D1zNE;IAAgC,6BAAA;E9D6zNlC;E8D5zNE;IAAgC,+BAAA;E9D+zNlC;E8D9zNE;IAAgC,8BAAA;E9Di0NlC;AACF;AiBtzNI;E6ClDA;IAAgC,8BAAA;E9D42NlC;E8D32NE;IAAgC,iCAAA;E9D82NlC;E8D72NE;IAAgC,sCAAA;E9Dg3NlC;E8D/2NE;IAAgC,yCAAA;E9Dk3NlC;E8Dh3NE;IAA8B,0BAAA;E9Dm3NhC;E8Dl3NE;IAA8B,4BAAA;E9Dq3NhC;E8Dp3NE;IAA8B,kCAAA;E9Du3NhC;E8Dt3NE;IAA8B,yBAAA;E9Dy3NhC;E8Dx3NE;IAA8B,uBAAA;E9D23NhC;E8D13NE;IAA8B,uBAAA;E9D63NhC;E8D53NE;IAA8B,yBAAA;E9D+3NhC;E8D93NE;IAA8B,yBAAA;E9Di4NhC;E8D/3NE;IAAoC,sCAAA;E9Dk4NtC;E8Dj4NE;IAAoC,oCAAA;E9Do4NtC;E8Dn4NE;IAAoC,kCAAA;E9Ds4NtC;E8Dr4NE;IAAoC,yCAAA;E9Dw4NtC;E8Dv4NE;IAAoC,wCAAA;E9D04NtC;E8Dx4NE;IAAiC,kCAAA;E9D24NnC;E8D14NE;IAAiC,gCAAA;E9D64NnC;E8D54NE;IAAiC,8BAAA;E9D+4NnC;E8D94NE;IAAiC,gCAAA;E9Di5NnC;E8Dh5NE;IAAiC,+BAAA;E9Dm5NnC;E8Dj5NE;IAAkC,oCAAA;E9Do5NpC;E8Dn5NE;IAAkC,kCAAA;E9Ds5NpC;E8Dr5NE;IAAkC,gCAAA;E9Dw5NpC;E8Dv5NE;IAAkC,uCAAA;E9D05NpC;E8Dz5NE;IAAkC,sCAAA;E9D45NpC;E8D35NE;IAAkC,iCAAA;E9D85NpC;E8D55NE;IAAgC,2BAAA;E9D+5NlC;E8D95NE;IAAgC,iCAAA;E9Di6NlC;E8Dh6NE;IAAgC,+BAAA;E9Dm6NlC;E8Dl6NE;IAAgC,6BAAA;E9Dq6NlC;E8Dp6NE;IAAgC,+BAAA;E9Du6NlC;E8Dt6NE;IAAgC,8BAAA;E9Dy6NlC;AACF;A+Dp9NI;EAAwB,sBAAA;A/Du9N5B;;A+Dt9NI;EAAwB,uBAAA;A/D09N5B;;A+Dz9NI;EAAwB,sBAAA;A/D69N5B;;AiBz6NI;E8CtDA;IAAwB,sBAAA;E/Do+N1B;E+Dn+NE;IAAwB,uBAAA;E/Ds+N1B;E+Dr+NE;IAAwB,sBAAA;E/Dw+N1B;AACF;AiBr7NI;E8CtDA;IAAwB,sBAAA;E/D++N1B;E+D9+NE;IAAwB,uBAAA;E/Di/N1B;E+Dh/NE;IAAwB,sBAAA;E/Dm/N1B;AACF;AiBh8NI;E8CtDA;IAAwB,sBAAA;E/D0/N1B;E+Dz/NE;IAAwB,uBAAA;E/D4/N1B;E+D3/NE;IAAwB,sBAAA;E/D8/N1B;AACF;AiB38NI;E8CtDA;IAAwB,sBAAA;E/DqgO1B;E+DpgOE;IAAwB,uBAAA;E/DugO1B;E+DtgOE;IAAwB,sBAAA;E/DygO1B;AACF;AgE/gOE;EAAsB,yBAAA;AhEkhOxB;;AgElhOE;EAAsB,2BAAA;AhEshOxB;;AiErhOE;EAAyB,2BAAA;AjEyhO3B;;AiEzhOE;EAAyB,6BAAA;AjE6hO3B;;AiE7hOE;EAAyB,6BAAA;AjEiiO3B;;AiEjiOE;EAAyB,0BAAA;AjEqiO3B;;AiEriOE;EAAyB,2BAAA;AjEyiO3B;;AiEpiOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DypBkC;AP84MpC;;AiEpiOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1DipBkC;APs5MpC;;AiEniOE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a1DyoBgC;EP85MlC;AACF;;AkEjkOA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AnEmkOF;;AmEzjOE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AnE2jOJ;;AoEvlOA;EAAa,8DAAA;ApE2lOb;;AoE1lOA;EAAU,wDAAA;ApE8lOV;;AoE7lOA;EAAa,uDAAA;ApEimOb;;AoEhmOA;EAAe,2BAAA;ApEomOf;;AqEnmOI;EAAuB,qBAAA;ArEumO3B;;AqEvmOI;EAAuB,qBAAA;ArE2mO3B;;AqE3mOI;EAAuB,qBAAA;ArE+mO3B;;AqE/mOI;EAAuB,sBAAA;ArEmnO3B;;AqEnnOI;EAAuB,sBAAA;ArEunO3B;;AqEvnOI;EAAuB,sBAAA;ArE2nO3B;;AqE3nOI;EAAuB,sBAAA;ArE+nO3B;;AqE/nOI;EAAuB,sBAAA;ArEmoO3B;;AqEnoOI;EAAuB,uBAAA;ArEuoO3B;;AqEvoOI;EAAuB,uBAAA;ArE2oO3B;;AqEvoOA;EAAU,0BAAA;ArE2oOV;;AqE1oOA;EAAU,2BAAA;ArE8oOV;;AqE1oOA;EAAc,2BAAA;ArE8oOd;;AqE7oOA;EAAc,4BAAA;ArEipOd;;AqE/oOA;EAAU,uBAAA;ArEmpOV;;AqElpOA;EAAU,wBAAA;ArEspOV;;AsEpqOE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AtEqqOJ;;AuE3qOQ;EAAgC,oBAAA;AvE+qOxC;;AuE9qOQ;;EAEE,wBAAA;AvEirOV;;AuE/qOQ;;EAEE,0BAAA;AvEkrOV;;AuEhrOQ;;EAEE,2BAAA;AvEmrOV;;AuEjrOQ;;EAEE,yBAAA;AvEorOV;;AuEnsOQ;EAAgC,0BAAA;AvEusOxC;;AuEtsOQ;;EAEE,8BAAA;AvEysOV;;AuEvsOQ;;EAEE,gCAAA;AvE0sOV;;AuExsOQ;;EAEE,iCAAA;AvE2sOV;;AuEzsOQ;;EAEE,+BAAA;AvE4sOV;;AuE3tOQ;EAAgC,yBAAA;AvE+tOxC;;AuE9tOQ;;EAEE,6BAAA;AvEiuOV;;AuE/tOQ;;EAEE,+BAAA;AvEkuOV;;AuEhuOQ;;EAEE,gCAAA;AvEmuOV;;AuEjuOQ;;EAEE,8BAAA;AvEouOV;;AuEnvOQ;EAAgC,uBAAA;AvEuvOxC;;AuEtvOQ;;EAEE,2BAAA;AvEyvOV;;AuEvvOQ;;EAEE,6BAAA;AvE0vOV;;AuExvOQ;;EAEE,8BAAA;AvE2vOV;;AuEzvOQ;;EAEE,4BAAA;AvE4vOV;;AuE3wOQ;EAAgC,yBAAA;AvE+wOxC;;AuE9wOQ;;EAEE,6BAAA;AvEixOV;;AuE/wOQ;;EAEE,+BAAA;AvEkxOV;;AuEhxOQ;;EAEE,gCAAA;AvEmxOV;;AuEjxOQ;;EAEE,8BAAA;AvEoxOV;;AuEnyOQ;EAAgC,uBAAA;AvEuyOxC;;AuEtyOQ;;EAEE,2BAAA;AvEyyOV;;AuEvyOQ;;EAEE,6BAAA;AvE0yOV;;AuExyOQ;;EAEE,8BAAA;AvE2yOV;;AuEzyOQ;;EAEE,4BAAA;AvE4yOV;;AuE3zOQ;EAAgC,qBAAA;AvE+zOxC;;AuE9zOQ;;EAEE,yBAAA;AvEi0OV;;AuE/zOQ;;EAEE,2BAAA;AvEk0OV;;AuEh0OQ;;EAEE,4BAAA;AvEm0OV;;AuEj0OQ;;EAEE,0BAAA;AvEo0OV;;AuEn1OQ;EAAgC,2BAAA;AvEu1OxC;;AuEt1OQ;;EAEE,+BAAA;AvEy1OV;;AuEv1OQ;;EAEE,iCAAA;AvE01OV;;AuEx1OQ;;EAEE,kCAAA;AvE21OV;;AuEz1OQ;;EAEE,gCAAA;AvE41OV;;AuE32OQ;EAAgC,0BAAA;AvE+2OxC;;AuE92OQ;;EAEE,8BAAA;AvEi3OV;;AuE/2OQ;;EAEE,gCAAA;AvEk3OV;;AuEh3OQ;;EAEE,iCAAA;AvEm3OV;;AuEj3OQ;;EAEE,+BAAA;AvEo3OV;;AuEn4OQ;EAAgC,wBAAA;AvEu4OxC;;AuEt4OQ;;EAEE,4BAAA;AvEy4OV;;AuEv4OQ;;EAEE,8BAAA;AvE04OV;;AuEx4OQ;;EAEE,+BAAA;AvE24OV;;AuEz4OQ;;EAEE,6BAAA;AvE44OV;;AuE35OQ;EAAgC,0BAAA;AvE+5OxC;;AuE95OQ;;EAEE,8BAAA;AvEi6OV;;AuE/5OQ;;EAEE,gCAAA;AvEk6OV;;AuEh6OQ;;EAEE,iCAAA;AvEm6OV;;AuEj6OQ;;EAEE,+BAAA;AvEo6OV;;AuEn7OQ;EAAgC,wBAAA;AvEu7OxC;;AuEt7OQ;;EAEE,4BAAA;AvEy7OV;;AuEv7OQ;;EAEE,8BAAA;AvE07OV;;AuEx7OQ;;EAEE,+BAAA;AvE27OV;;AuEz7OQ;;EAEE,6BAAA;AvE47OV;;AuEp7OQ;EAAwB,2BAAA;AvEw7OhC;;AuEv7OQ;;EAEE,+BAAA;AvE07OV;;AuEx7OQ;;EAEE,iCAAA;AvE27OV;;AuEz7OQ;;EAEE,kCAAA;AvE47OV;;AuE17OQ;;EAEE,gCAAA;AvE67OV;;AuE58OQ;EAAwB,0BAAA;AvEg9OhC;;AuE/8OQ;;EAEE,8BAAA;AvEk9OV;;AuEh9OQ;;EAEE,gCAAA;AvEm9OV;;AuEj9OQ;;EAEE,iCAAA;AvEo9OV;;AuEl9OQ;;EAEE,+BAAA;AvEq9OV;;AuEp+OQ;EAAwB,wBAAA;AvEw+OhC;;AuEv+OQ;;EAEE,4BAAA;AvE0+OV;;AuEx+OQ;;EAEE,8BAAA;AvE2+OV;;AuEz+OQ;;EAEE,+BAAA;AvE4+OV;;AuE1+OQ;;EAEE,6BAAA;AvE6+OV;;AuE5/OQ;EAAwB,0BAAA;AvEggPhC;;AuE//OQ;;EAEE,8BAAA;AvEkgPV;;AuEhgPQ;;EAEE,gCAAA;AvEmgPV;;AuEjgPQ;;EAEE,iCAAA;AvEogPV;;AuElgPQ;;EAEE,+BAAA;AvEqgPV;;AuEphPQ;EAAwB,wBAAA;AvEwhPhC;;AuEvhPQ;;EAEE,4BAAA;AvE0hPV;;AuExhPQ;;EAEE,8BAAA;AvE2hPV;;AuEzhPQ;;EAEE,+BAAA;AvE4hPV;;AuE1hPQ;;EAEE,6BAAA;AvE6hPV;;AuEvhPI;EAAmB,uBAAA;AvE2hPvB;;AuE1hPI;;EAEE,2BAAA;AvE6hPN;;AuE3hPI;;EAEE,6BAAA;AvE8hPN;;AuE5hPI;;EAEE,8BAAA;AvE+hPN;;AuE7hPI;;EAEE,4BAAA;AvEgiPN;;AiBziPI;EsDlDI;IAAgC,oBAAA;EvEgmPtC;EuE/lPM;;IAEE,wBAAA;EvEimPR;EuE/lPM;;IAEE,0BAAA;EvEimPR;EuE/lPM;;IAEE,2BAAA;EvEimPR;EuE/lPM;;IAEE,yBAAA;EvEimPR;EuEhnPM;IAAgC,0BAAA;EvEmnPtC;EuElnPM;;IAEE,8BAAA;EvEonPR;EuElnPM;;IAEE,gCAAA;EvEonPR;EuElnPM;;IAEE,iCAAA;EvEonPR;EuElnPM;;IAEE,+BAAA;EvEonPR;EuEnoPM;IAAgC,yBAAA;EvEsoPtC;EuEroPM;;IAEE,6BAAA;EvEuoPR;EuEroPM;;IAEE,+BAAA;EvEuoPR;EuEroPM;;IAEE,gCAAA;EvEuoPR;EuEroPM;;IAEE,8BAAA;EvEuoPR;EuEtpPM;IAAgC,uBAAA;EvEypPtC;EuExpPM;;IAEE,2BAAA;EvE0pPR;EuExpPM;;IAEE,6BAAA;EvE0pPR;EuExpPM;;IAEE,8BAAA;EvE0pPR;EuExpPM;;IAEE,4BAAA;EvE0pPR;EuEzqPM;IAAgC,yBAAA;EvE4qPtC;EuE3qPM;;IAEE,6BAAA;EvE6qPR;EuE3qPM;;IAEE,+BAAA;EvE6qPR;EuE3qPM;;IAEE,gCAAA;EvE6qPR;EuE3qPM;;IAEE,8BAAA;EvE6qPR;EuE5rPM;IAAgC,uBAAA;EvE+rPtC;EuE9rPM;;IAEE,2BAAA;EvEgsPR;EuE9rPM;;IAEE,6BAAA;EvEgsPR;EuE9rPM;;IAEE,8BAAA;EvEgsPR;EuE9rPM;;IAEE,4BAAA;EvEgsPR;EuE/sPM;IAAgC,qBAAA;EvEktPtC;EuEjtPM;;IAEE,yBAAA;EvEmtPR;EuEjtPM;;IAEE,2BAAA;EvEmtPR;EuEjtPM;;IAEE,4BAAA;EvEmtPR;EuEjtPM;;IAEE,0BAAA;EvEmtPR;EuEluPM;IAAgC,2BAAA;EvEquPtC;EuEpuPM;;IAEE,+BAAA;EvEsuPR;EuEpuPM;;IAEE,iCAAA;EvEsuPR;EuEpuPM;;IAEE,kCAAA;EvEsuPR;EuEpuPM;;IAEE,gCAAA;EvEsuPR;EuErvPM;IAAgC,0BAAA;EvEwvPtC;EuEvvPM;;IAEE,8BAAA;EvEyvPR;EuEvvPM;;IAEE,gCAAA;EvEyvPR;EuEvvPM;;IAEE,iCAAA;EvEyvPR;EuEvvPM;;IAEE,+BAAA;EvEyvPR;EuExwPM;IAAgC,wBAAA;EvE2wPtC;EuE1wPM;;IAEE,4BAAA;EvE4wPR;EuE1wPM;;IAEE,8BAAA;EvE4wPR;EuE1wPM;;IAEE,+BAAA;EvE4wPR;EuE1wPM;;IAEE,6BAAA;EvE4wPR;EuE3xPM;IAAgC,0BAAA;EvE8xPtC;EuE7xPM;;IAEE,8BAAA;EvE+xPR;EuE7xPM;;IAEE,gCAAA;EvE+xPR;EuE7xPM;;IAEE,iCAAA;EvE+xPR;EuE7xPM;;IAEE,+BAAA;EvE+xPR;EuE9yPM;IAAgC,wBAAA;EvEizPtC;EuEhzPM;;IAEE,4BAAA;EvEkzPR;EuEhzPM;;IAEE,8BAAA;EvEkzPR;EuEhzPM;;IAEE,+BAAA;EvEkzPR;EuEhzPM;;IAEE,6BAAA;EvEkzPR;EuE1yPM;IAAwB,2BAAA;EvE6yP9B;EuE5yPM;;IAEE,+BAAA;EvE8yPR;EuE5yPM;;IAEE,iCAAA;EvE8yPR;EuE5yPM;;IAEE,kCAAA;EvE8yPR;EuE5yPM;;IAEE,gCAAA;EvE8yPR;EuE7zPM;IAAwB,0BAAA;EvEg0P9B;EuE/zPM;;IAEE,8BAAA;EvEi0PR;EuE/zPM;;IAEE,gCAAA;EvEi0PR;EuE/zPM;;IAEE,iCAAA;EvEi0PR;EuE/zPM;;IAEE,+BAAA;EvEi0PR;EuEh1PM;IAAwB,wBAAA;EvEm1P9B;EuEl1PM;;IAEE,4BAAA;EvEo1PR;EuEl1PM;;IAEE,8BAAA;EvEo1PR;EuEl1PM;;IAEE,+BAAA;EvEo1PR;EuEl1PM;;IAEE,6BAAA;EvEo1PR;EuEn2PM;IAAwB,0BAAA;EvEs2P9B;EuEr2PM;;IAEE,8BAAA;EvEu2PR;EuEr2PM;;IAEE,gCAAA;EvEu2PR;EuEr2PM;;IAEE,iCAAA;EvEu2PR;EuEr2PM;;IAEE,+BAAA;EvEu2PR;EuEt3PM;IAAwB,wBAAA;EvEy3P9B;EuEx3PM;;IAEE,4BAAA;EvE03PR;EuEx3PM;;IAEE,8BAAA;EvE03PR;EuEx3PM;;IAEE,+BAAA;EvE03PR;EuEx3PM;;IAEE,6BAAA;EvE03PR;EuEp3PE;IAAmB,uBAAA;EvEu3PrB;EuEt3PE;;IAEE,2BAAA;EvEw3PJ;EuEt3PE;;IAEE,6BAAA;EvEw3PJ;EuEt3PE;;IAEE,8BAAA;EvEw3PJ;EuEt3PE;;IAEE,4BAAA;EvEw3PJ;AACF;AiBl4PI;EsDlDI;IAAgC,oBAAA;EvEw7PtC;EuEv7PM;;IAEE,wBAAA;EvEy7PR;EuEv7PM;;IAEE,0BAAA;EvEy7PR;EuEv7PM;;IAEE,2BAAA;EvEy7PR;EuEv7PM;;IAEE,yBAAA;EvEy7PR;EuEx8PM;IAAgC,0BAAA;EvE28PtC;EuE18PM;;IAEE,8BAAA;EvE48PR;EuE18PM;;IAEE,gCAAA;EvE48PR;EuE18PM;;IAEE,iCAAA;EvE48PR;EuE18PM;;IAEE,+BAAA;EvE48PR;EuE39PM;IAAgC,yBAAA;EvE89PtC;EuE79PM;;IAEE,6BAAA;EvE+9PR;EuE79PM;;IAEE,+BAAA;EvE+9PR;EuE79PM;;IAEE,gCAAA;EvE+9PR;EuE79PM;;IAEE,8BAAA;EvE+9PR;EuE9+PM;IAAgC,uBAAA;EvEi/PtC;EuEh/PM;;IAEE,2BAAA;EvEk/PR;EuEh/PM;;IAEE,6BAAA;EvEk/PR;EuEh/PM;;IAEE,8BAAA;EvEk/PR;EuEh/PM;;IAEE,4BAAA;EvEk/PR;EuEjgQM;IAAgC,yBAAA;EvEogQtC;EuEngQM;;IAEE,6BAAA;EvEqgQR;EuEngQM;;IAEE,+BAAA;EvEqgQR;EuEngQM;;IAEE,gCAAA;EvEqgQR;EuEngQM;;IAEE,8BAAA;EvEqgQR;EuEphQM;IAAgC,uBAAA;EvEuhQtC;EuEthQM;;IAEE,2BAAA;EvEwhQR;EuEthQM;;IAEE,6BAAA;EvEwhQR;EuEthQM;;IAEE,8BAAA;EvEwhQR;EuEthQM;;IAEE,4BAAA;EvEwhQR;EuEviQM;IAAgC,qBAAA;EvE0iQtC;EuEziQM;;IAEE,yBAAA;EvE2iQR;EuEziQM;;IAEE,2BAAA;EvE2iQR;EuEziQM;;IAEE,4BAAA;EvE2iQR;EuEziQM;;IAEE,0BAAA;EvE2iQR;EuE1jQM;IAAgC,2BAAA;EvE6jQtC;EuE5jQM;;IAEE,+BAAA;EvE8jQR;EuE5jQM;;IAEE,iCAAA;EvE8jQR;EuE5jQM;;IAEE,kCAAA;EvE8jQR;EuE5jQM;;IAEE,gCAAA;EvE8jQR;EuE7kQM;IAAgC,0BAAA;EvEglQtC;EuE/kQM;;IAEE,8BAAA;EvEilQR;EuE/kQM;;IAEE,gCAAA;EvEilQR;EuE/kQM;;IAEE,iCAAA;EvEilQR;EuE/kQM;;IAEE,+BAAA;EvEilQR;EuEhmQM;IAAgC,wBAAA;EvEmmQtC;EuElmQM;;IAEE,4BAAA;EvEomQR;EuElmQM;;IAEE,8BAAA;EvEomQR;EuElmQM;;IAEE,+BAAA;EvEomQR;EuElmQM;;IAEE,6BAAA;EvEomQR;EuEnnQM;IAAgC,0BAAA;EvEsnQtC;EuErnQM;;IAEE,8BAAA;EvEunQR;EuErnQM;;IAEE,gCAAA;EvEunQR;EuErnQM;;IAEE,iCAAA;EvEunQR;EuErnQM;;IAEE,+BAAA;EvEunQR;EuEtoQM;IAAgC,wBAAA;EvEyoQtC;EuExoQM;;IAEE,4BAAA;EvE0oQR;EuExoQM;;IAEE,8BAAA;EvE0oQR;EuExoQM;;IAEE,+BAAA;EvE0oQR;EuExoQM;;IAEE,6BAAA;EvE0oQR;EuEloQM;IAAwB,2BAAA;EvEqoQ9B;EuEpoQM;;IAEE,+BAAA;EvEsoQR;EuEpoQM;;IAEE,iCAAA;EvEsoQR;EuEpoQM;;IAEE,kCAAA;EvEsoQR;EuEpoQM;;IAEE,gCAAA;EvEsoQR;EuErpQM;IAAwB,0BAAA;EvEwpQ9B;EuEvpQM;;IAEE,8BAAA;EvEypQR;EuEvpQM;;IAEE,gCAAA;EvEypQR;EuEvpQM;;IAEE,iCAAA;EvEypQR;EuEvpQM;;IAEE,+BAAA;EvEypQR;EuExqQM;IAAwB,wBAAA;EvE2qQ9B;EuE1qQM;;IAEE,4BAAA;EvE4qQR;EuE1qQM;;IAEE,8BAAA;EvE4qQR;EuE1qQM;;IAEE,+BAAA;EvE4qQR;EuE1qQM;;IAEE,6BAAA;EvE4qQR;EuE3rQM;IAAwB,0BAAA;EvE8rQ9B;EuE7rQM;;IAEE,8BAAA;EvE+rQR;EuE7rQM;;IAEE,gCAAA;EvE+rQR;EuE7rQM;;IAEE,iCAAA;EvE+rQR;EuE7rQM;;IAEE,+BAAA;EvE+rQR;EuE9sQM;IAAwB,wBAAA;EvEitQ9B;EuEhtQM;;IAEE,4BAAA;EvEktQR;EuEhtQM;;IAEE,8BAAA;EvEktQR;EuEhtQM;;IAEE,+BAAA;EvEktQR;EuEhtQM;;IAEE,6BAAA;EvEktQR;EuE5sQE;IAAmB,uBAAA;EvE+sQrB;EuE9sQE;;IAEE,2BAAA;EvEgtQJ;EuE9sQE;;IAEE,6BAAA;EvEgtQJ;EuE9sQE;;IAEE,8BAAA;EvEgtQJ;EuE9sQE;;IAEE,4BAAA;EvEgtQJ;AACF;AiB1tQI;EsDlDI;IAAgC,oBAAA;EvEgxQtC;EuE/wQM;;IAEE,wBAAA;EvEixQR;EuE/wQM;;IAEE,0BAAA;EvEixQR;EuE/wQM;;IAEE,2BAAA;EvEixQR;EuE/wQM;;IAEE,yBAAA;EvEixQR;EuEhyQM;IAAgC,0BAAA;EvEmyQtC;EuElyQM;;IAEE,8BAAA;EvEoyQR;EuElyQM;;IAEE,gCAAA;EvEoyQR;EuElyQM;;IAEE,iCAAA;EvEoyQR;EuElyQM;;IAEE,+BAAA;EvEoyQR;EuEnzQM;IAAgC,yBAAA;EvEszQtC;EuErzQM;;IAEE,6BAAA;EvEuzQR;EuErzQM;;IAEE,+BAAA;EvEuzQR;EuErzQM;;IAEE,gCAAA;EvEuzQR;EuErzQM;;IAEE,8BAAA;EvEuzQR;EuEt0QM;IAAgC,uBAAA;EvEy0QtC;EuEx0QM;;IAEE,2BAAA;EvE00QR;EuEx0QM;;IAEE,6BAAA;EvE00QR;EuEx0QM;;IAEE,8BAAA;EvE00QR;EuEx0QM;;IAEE,4BAAA;EvE00QR;EuEz1QM;IAAgC,yBAAA;EvE41QtC;EuE31QM;;IAEE,6BAAA;EvE61QR;EuE31QM;;IAEE,+BAAA;EvE61QR;EuE31QM;;IAEE,gCAAA;EvE61QR;EuE31QM;;IAEE,8BAAA;EvE61QR;EuE52QM;IAAgC,uBAAA;EvE+2QtC;EuE92QM;;IAEE,2BAAA;EvEg3QR;EuE92QM;;IAEE,6BAAA;EvEg3QR;EuE92QM;;IAEE,8BAAA;EvEg3QR;EuE92QM;;IAEE,4BAAA;EvEg3QR;EuE/3QM;IAAgC,qBAAA;EvEk4QtC;EuEj4QM;;IAEE,yBAAA;EvEm4QR;EuEj4QM;;IAEE,2BAAA;EvEm4QR;EuEj4QM;;IAEE,4BAAA;EvEm4QR;EuEj4QM;;IAEE,0BAAA;EvEm4QR;EuEl5QM;IAAgC,2BAAA;EvEq5QtC;EuEp5QM;;IAEE,+BAAA;EvEs5QR;EuEp5QM;;IAEE,iCAAA;EvEs5QR;EuEp5QM;;IAEE,kCAAA;EvEs5QR;EuEp5QM;;IAEE,gCAAA;EvEs5QR;EuEr6QM;IAAgC,0BAAA;EvEw6QtC;EuEv6QM;;IAEE,8BAAA;EvEy6QR;EuEv6QM;;IAEE,gCAAA;EvEy6QR;EuEv6QM;;IAEE,iCAAA;EvEy6QR;EuEv6QM;;IAEE,+BAAA;EvEy6QR;EuEx7QM;IAAgC,wBAAA;EvE27QtC;EuE17QM;;IAEE,4BAAA;EvE47QR;EuE17QM;;IAEE,8BAAA;EvE47QR;EuE17QM;;IAEE,+BAAA;EvE47QR;EuE17QM;;IAEE,6BAAA;EvE47QR;EuE38QM;IAAgC,0BAAA;EvE88QtC;EuE78QM;;IAEE,8BAAA;EvE+8QR;EuE78QM;;IAEE,gCAAA;EvE+8QR;EuE78QM;;IAEE,iCAAA;EvE+8QR;EuE78QM;;IAEE,+BAAA;EvE+8QR;EuE99QM;IAAgC,wBAAA;EvEi+QtC;EuEh+QM;;IAEE,4BAAA;EvEk+QR;EuEh+QM;;IAEE,8BAAA;EvEk+QR;EuEh+QM;;IAEE,+BAAA;EvEk+QR;EuEh+QM;;IAEE,6BAAA;EvEk+QR;EuE19QM;IAAwB,2BAAA;EvE69Q9B;EuE59QM;;IAEE,+BAAA;EvE89QR;EuE59QM;;IAEE,iCAAA;EvE89QR;EuE59QM;;IAEE,kCAAA;EvE89QR;EuE59QM;;IAEE,gCAAA;EvE89QR;EuE7+QM;IAAwB,0BAAA;EvEg/Q9B;EuE/+QM;;IAEE,8BAAA;EvEi/QR;EuE/+QM;;IAEE,gCAAA;EvEi/QR;EuE/+QM;;IAEE,iCAAA;EvEi/QR;EuE/+QM;;IAEE,+BAAA;EvEi/QR;EuEhgRM;IAAwB,wBAAA;EvEmgR9B;EuElgRM;;IAEE,4BAAA;EvEogRR;EuElgRM;;IAEE,8BAAA;EvEogRR;EuElgRM;;IAEE,+BAAA;EvEogRR;EuElgRM;;IAEE,6BAAA;EvEogRR;EuEnhRM;IAAwB,0BAAA;EvEshR9B;EuErhRM;;IAEE,8BAAA;EvEuhRR;EuErhRM;;IAEE,gCAAA;EvEuhRR;EuErhRM;;IAEE,iCAAA;EvEuhRR;EuErhRM;;IAEE,+BAAA;EvEuhRR;EuEtiRM;IAAwB,wBAAA;EvEyiR9B;EuExiRM;;IAEE,4BAAA;EvE0iRR;EuExiRM;;IAEE,8BAAA;EvE0iRR;EuExiRM;;IAEE,+BAAA;EvE0iRR;EuExiRM;;IAEE,6BAAA;EvE0iRR;EuEpiRE;IAAmB,uBAAA;EvEuiRrB;EuEtiRE;;IAEE,2BAAA;EvEwiRJ;EuEtiRE;;IAEE,6BAAA;EvEwiRJ;EuEtiRE;;IAEE,8BAAA;EvEwiRJ;EuEtiRE;;IAEE,4BAAA;EvEwiRJ;AACF;AiBljRI;EsDlDI;IAAgC,oBAAA;EvEwmRtC;EuEvmRM;;IAEE,wBAAA;EvEymRR;EuEvmRM;;IAEE,0BAAA;EvEymRR;EuEvmRM;;IAEE,2BAAA;EvEymRR;EuEvmRM;;IAEE,yBAAA;EvEymRR;EuExnRM;IAAgC,0BAAA;EvE2nRtC;EuE1nRM;;IAEE,8BAAA;EvE4nRR;EuE1nRM;;IAEE,gCAAA;EvE4nRR;EuE1nRM;;IAEE,iCAAA;EvE4nRR;EuE1nRM;;IAEE,+BAAA;EvE4nRR;EuE3oRM;IAAgC,yBAAA;EvE8oRtC;EuE7oRM;;IAEE,6BAAA;EvE+oRR;EuE7oRM;;IAEE,+BAAA;EvE+oRR;EuE7oRM;;IAEE,gCAAA;EvE+oRR;EuE7oRM;;IAEE,8BAAA;EvE+oRR;EuE9pRM;IAAgC,uBAAA;EvEiqRtC;EuEhqRM;;IAEE,2BAAA;EvEkqRR;EuEhqRM;;IAEE,6BAAA;EvEkqRR;EuEhqRM;;IAEE,8BAAA;EvEkqRR;EuEhqRM;;IAEE,4BAAA;EvEkqRR;EuEjrRM;IAAgC,yBAAA;EvEorRtC;EuEnrRM;;IAEE,6BAAA;EvEqrRR;EuEnrRM;;IAEE,+BAAA;EvEqrRR;EuEnrRM;;IAEE,gCAAA;EvEqrRR;EuEnrRM;;IAEE,8BAAA;EvEqrRR;EuEpsRM;IAAgC,uBAAA;EvEusRtC;EuEtsRM;;IAEE,2BAAA;EvEwsRR;EuEtsRM;;IAEE,6BAAA;EvEwsRR;EuEtsRM;;IAEE,8BAAA;EvEwsRR;EuEtsRM;;IAEE,4BAAA;EvEwsRR;EuEvtRM;IAAgC,qBAAA;EvE0tRtC;EuEztRM;;IAEE,yBAAA;EvE2tRR;EuEztRM;;IAEE,2BAAA;EvE2tRR;EuEztRM;;IAEE,4BAAA;EvE2tRR;EuEztRM;;IAEE,0BAAA;EvE2tRR;EuE1uRM;IAAgC,2BAAA;EvE6uRtC;EuE5uRM;;IAEE,+BAAA;EvE8uRR;EuE5uRM;;IAEE,iCAAA;EvE8uRR;EuE5uRM;;IAEE,kCAAA;EvE8uRR;EuE5uRM;;IAEE,gCAAA;EvE8uRR;EuE7vRM;IAAgC,0BAAA;EvEgwRtC;EuE/vRM;;IAEE,8BAAA;EvEiwRR;EuE/vRM;;IAEE,gCAAA;EvEiwRR;EuE/vRM;;IAEE,iCAAA;EvEiwRR;EuE/vRM;;IAEE,+BAAA;EvEiwRR;EuEhxRM;IAAgC,wBAAA;EvEmxRtC;EuElxRM;;IAEE,4BAAA;EvEoxRR;EuElxRM;;IAEE,8BAAA;EvEoxRR;EuElxRM;;IAEE,+BAAA;EvEoxRR;EuElxRM;;IAEE,6BAAA;EvEoxRR;EuEnyRM;IAAgC,0BAAA;EvEsyRtC;EuEryRM;;IAEE,8BAAA;EvEuyRR;EuEryRM;;IAEE,gCAAA;EvEuyRR;EuEryRM;;IAEE,iCAAA;EvEuyRR;EuEryRM;;IAEE,+BAAA;EvEuyRR;EuEtzRM;IAAgC,wBAAA;EvEyzRtC;EuExzRM;;IAEE,4BAAA;EvE0zRR;EuExzRM;;IAEE,8BAAA;EvE0zRR;EuExzRM;;IAEE,+BAAA;EvE0zRR;EuExzRM;;IAEE,6BAAA;EvE0zRR;EuElzRM;IAAwB,2BAAA;EvEqzR9B;EuEpzRM;;IAEE,+BAAA;EvEszRR;EuEpzRM;;IAEE,iCAAA;EvEszRR;EuEpzRM;;IAEE,kCAAA;EvEszRR;EuEpzRM;;IAEE,gCAAA;EvEszRR;EuEr0RM;IAAwB,0BAAA;EvEw0R9B;EuEv0RM;;IAEE,8BAAA;EvEy0RR;EuEv0RM;;IAEE,gCAAA;EvEy0RR;EuEv0RM;;IAEE,iCAAA;EvEy0RR;EuEv0RM;;IAEE,+BAAA;EvEy0RR;EuEx1RM;IAAwB,wBAAA;EvE21R9B;EuE11RM;;IAEE,4BAAA;EvE41RR;EuE11RM;;IAEE,8BAAA;EvE41RR;EuE11RM;;IAEE,+BAAA;EvE41RR;EuE11RM;;IAEE,6BAAA;EvE41RR;EuE32RM;IAAwB,0BAAA;EvE82R9B;EuE72RM;;IAEE,8BAAA;EvE+2RR;EuE72RM;;IAEE,gCAAA;EvE+2RR;EuE72RM;;IAEE,iCAAA;EvE+2RR;EuE72RM;;IAEE,+BAAA;EvE+2RR;EuE93RM;IAAwB,wBAAA;EvEi4R9B;EuEh4RM;;IAEE,4BAAA;EvEk4RR;EuEh4RM;;IAEE,8BAAA;EvEk4RR;EuEh4RM;;IAEE,+BAAA;EvEk4RR;EuEh4RM;;IAEE,6BAAA;EvEk4RR;EuE53RE;IAAmB,uBAAA;EvE+3RrB;EuE93RE;;IAEE,2BAAA;EvEg4RJ;EuE93RE;;IAEE,6BAAA;EvEg4RJ;EuE93RE;;IAEE,8BAAA;EvEg4RJ;EuE93RE;;IAEE,4BAAA;EvEg4RJ;AACF;AwEh8RA;EAAkB,4GAAA;AxEm8RlB;;AwE/7RA;EAAiB,8BAAA;AxEm8RjB;;AwEl8RA;EAAiB,8BAAA;AxEs8RjB;;AwEr8RA;EAAiB,8BAAA;AxEy8RjB;;AwEx8RA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;AzEq9RF;;AwEt8RI;EAAwB,2BAAA;AxE08R5B;;AwEz8RI;EAAwB,4BAAA;AxE68R5B;;AwE58RI;EAAwB,6BAAA;AxEg9R5B;;AiB36RI;EuDvCA;IAAwB,2BAAA;ExEu9R1B;EwEt9RE;IAAwB,4BAAA;ExEy9R1B;EwEx9RE;IAAwB,6BAAA;ExE29R1B;AACF;AiBv7RI;EuDvCA;IAAwB,2BAAA;ExEk+R1B;EwEj+RE;IAAwB,4BAAA;ExEo+R1B;EwEn+RE;IAAwB,6BAAA;ExEs+R1B;AACF;AiBl8RI;EuDvCA;IAAwB,2BAAA;ExE6+R1B;EwE5+RE;IAAwB,4BAAA;ExE++R1B;EwE9+RE;IAAwB,6BAAA;ExEi/R1B;AACF;AiB78RI;EuDvCA;IAAwB,2BAAA;ExEw/R1B;EwEv/RE;IAAwB,4BAAA;ExE0/R1B;EwEz/RE;IAAwB,6BAAA;ExE4/R1B;AACF;AwEv/RA;EAAmB,oCAAA;AxE0/RnB;;AwEz/RA;EAAmB,oCAAA;AxE6/RnB;;AwE5/RA;EAAmB,qCAAA;AxEggSnB;;AwE5/RA;EAAuB,2BAAA;AxEggSvB;;AwE//RA;EAAuB,+BAAA;AxEmgSvB;;AwElgSA;EAAuB,2BAAA;AxEsgSvB;;AwErgSA;EAAuB,2BAAA;AxEygSvB;;AwExgSA;EAAuB,8BAAA;AxE4gSvB;;AwE3gSA;EAAuB,6BAAA;AxE+gSvB;;AwE3gSA;EAAc,sBAAA;AxE+gSd;;A0EtjSE;EACE,yBAAA;A1EyjSJ;;AG/iSE;EuELM,qEAAA;A1EwjSR;;A0E9jSE;EACE,yBAAA;A1EikSJ;;AGvjSE;EuELM,qEAAA;A1EgkSR;;A0EtkSE;EACE,yBAAA;A1EykSJ;;AG/jSE;EuELM,qEAAA;A1EwkSR;;A0E9kSE;EACE,yBAAA;A1EilSJ;;AGvkSE;EuELM,yDAAA;A1EglSR;;A0EtlSE;EACE,yBAAA;A1EylSJ;;AG/kSE;EuELM,kEAAA;A1EwlSR;;A0E9lSE;EACE,yBAAA;A1EimSJ;;AGvlSE;EuELM,oEAAA;A1EgmSR;;A0EtmSE;EACE,yBAAA;A1EymSJ;;AG/lSE;EuELM,qEAAA;A1EwmSR;;A0E9mSE;EACE,yBAAA;A1EinSJ;;AGvmSE;EuELM,kEAAA;A1EgnSR;;A0EtnSE;EACE,yBAAA;A1EynSJ;;AG/mSE;EuELM,qEAAA;A1EwnSR;;A0E9nSE;EACE,yBAAA;A1EioSJ;;AGvnSE;EuELM,oEAAA;A1EgoSR;;AwEzlSA;EAAa,yBAAA;AxE6lSb;;AwE5lSA;EAAc,yBAAA;AxEgmSd;;AwE9lSA;EAAiB,oCAAA;AxEkmSjB;;AwEjmSA;EAAiB,0CAAA;AxEqmSjB;;AwEjmSA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A3E4pSF;;AwErmSA;EAAwB,gCAAA;AxEymSxB;;AwEvmSA;EACE,iCAAA;EACA,oCAAA;AxE0mSF;;AwErmSA;EAAc,yBAAA;AxEymSd;;A4E1qSA;EACE,8BAAA;A5E6qSF;;A4E1qSA;EACE,6BAAA;A5E6qSF;;A6EtrSA;;;EAGE,wBAAA;A7EyrSF;;A6EtrSA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;A7EyrSF;;A8EnsSA;EACE,4BAAA;EACA,UAAA;A9EssSF;A8EpsSE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;A9EssSJ;;A8EzrSA;EACE,4BAAA;EACA,UAAA;A9E4rSF;A8E1rSE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;A9E4rSJ;;A8EtrSA;EACE,4BAAA;EACA,UAAA;A9EyrSF;A8EvrSE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;A9EyrSJ;;A+EjuSA;EACE,YCWgC;EDVhC,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;A/EouSF;A+EluSE;EACE,0U9EmGiB;ADioSrB;A+EjuSE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,YCP8B;AhF0uSlC;A+EjuSI;EACE,aAAA;EACA,mBAAA;A/EmuSN;A+EhuSI;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;A/EkuSN;A+E7tSI;EAEE,mBAAA;A/E8tSN;A+E3tSI;EACE,iB9EmDS;AD0qSf;;A+ExtSA;EACE,iBAAA;EACA,YCnCgC;EDoChC,YC1CgC;ED2ChC,aAAA;EACA,mBAAA;EACA,sBAAA;A/E2tSF;A+EztSE;EACE,YC7C8B;ED8C9B,WC7C8B;ED8C9B,oDAAA;A/E2tSJ;;A+EvtSA;;EAEE,aAAA;EACA,iBAAA;EACA,YCpDgC;EDqDhC,mBAAA;A/E0tSF;;AiF1xSE;EACE,eAAA;EACA,WAAA;EACA,MAAA;AjF6xSJ;AiF3xSI;EACE,mBAAA;AjF6xSN;AiFzxSE;EACE,iBAAA;AjF2xSJ;AiFtxSM;EACE,kBAAA;AjFwxSR;;AkF1ySA;EACE,iBAAA;EACA,aAAA;AlF6ySF;AkF3ySE;EACE,aAAA;EACA,qBAAA;AlF6ySJ;AkF1ySE;EACE,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AlF4ySJ;AkF1ySI;ErEbA,mBqEcyB;EACvB,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AlF4ySN;AkF1ySM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;AlF4ySR;AkFvySI;EACE,YAAA;EACA,wBAAA;ErEjCF,mBqEkCyB;AlFyyS7B;AkFtySI;EACE,cAAA;AlFwySN;AkFrySI;EACE;IACE,UAAA;ElFuySN;AACF;AkFpySI;EACE,iBAAA;AlFsySN;AkFnySI;EACE,eAAA;AlFqySN;AkFnySM;EACE,YAAA;AlFqySR;AkFjySI;EACE,QAAA;EACA,UAAA;EACA,SAAA;AlFmySN;;AmFl2SI;EACE,clFeK;EkFdL,6BAAA;EACA,8BAAA;AnFq2SN;AmFn2SM;EACE,gBAAA;AnFq2SR;AmFl2SM;EACE,clFQG;AD41SX;AmFj2SM;EACE,eAAA;AnFm2SR;;AoFl3SA;EACE,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;ApFq3SF;AoFn3SE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mB7EJO;E6EKP,UAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;ApFq3SJ;AoFl3SE;;;EAGE,mBnFJO;ADw3SX;;AqFx4SI;EACE,+BAAA;ArF24SN;AqFz4SM;EACE,+BAAA;ArF24SR;AqFx4SM;EACE,yBAAA;ArF04SR;AqFn4SQ;EACE,8BAAA;EACA,oBAAA;ArFq4SV;AqFl4SQ;EACE,+CAAA;EACA,oBAAA;EACA,UAAA;ArFo4SV;AqFh4SU;EACE,+BAAA;ArFk4SZ;AqF/3SU;EACE,gDAAA;ArFi4SZ;AqF73SQ;EACE,yBAAA;ArF+3SV;AqFz3SQ;;;EAGE,+BAAA;ArF23SV;AqFv3SU;EACE,2FAAA;ArFy3SZ;AqFj3SQ;EACE,8BAAA;ArFm3SV;AqF/2SU;EAKE,0CAAA;ArF62SZ;AqFv2SQ;EACE,oCAAA;ArFy2SV;AqFv2SU;EACE,+BAAA;ArFy2SZ;AqFt2SU;EACE,oCAAA;ArFw2SZ;AqFj2SM;EACE,oCAAA;ArFm2SR;AqF71SM;;;;;;;;EAIE,qDAAA;ArFm2SR;AqF/1SI;EACE,sCAAA;ArFi2SN;AqF91SI;;;EAGE,oCAAA;ArFg2SN;AqF51SM;EACE,oDAAA;ArF81SR;AqFz1SM;;;EAGE,oCAAA;ArF21SR;;AsFx9SI;EACE,yBAAA;AtF29SN;AsFz9SM;EACE,yBAAA;AtF29SR;AsFx9SM;EACE,mBAAA;AtF09SR;AsFn9SQ;EACE,wBAAA;EACA,oBAAA;AtFq9SV;AsFl9SQ;EACE,yCAAA;EACA,oBAAA;EACA,UAAA;AtFo9SV;AsFh9SU;EACE,yBAAA;AtFk9SZ;AsF/8SU;EACE,0CAAA;AtFi9SZ;AsF78SQ;EACE,yBAAA;AtF+8SV;AsFz8SQ;;;EAGE,yBAAA;AtF28SV;AsFp8SQ;EACE,8BAAA;AtFs8SV;AsFj8SQ;EACE,8BAAA;AtFm8SV;AsFj8SU;EACE,yBAAA;AtFm8SZ;AsFh8SU;EACE,8BAAA;AtFk8SZ;AsF37SM;EACE,8BAAA;AtF67SR;AsFv7SM;;;;;;;;EAIE,+CAAA;AtF67SR;AsFz7SI;EACE,gCAAA;AtF27SN;AsFx7SI;;;EAGE,8BAAA;AtF07SN;AsFt7SM;EACE,oDAAA;AtFw7SR;;AuF/hTA;EACE,YPKgC;EOJhC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBPCgC;EOAhC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBPGgC;EOFhC,oBAAA;AvFkiTF;AuFhiTE;EACE,0BAAA;AvFkiTJ;AuF/hTE;EACE,WAAA;EACA,WAAA;AvFiiTJ;AuF9hTE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AvFgiTJ;AuF7hTE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;AvF+hTJ;AuF5hTE;EACE,0CAAA;AvF8hTJ;;AuF1hTA;EACE,yBAAA;EACA,iBtF4Ca;EsF3Cb,iBAAA;EACA,iBAAA;EACA,ctFRM;EsFSN,mBAAA;EACA,kBAAA;AvF6hTF;;AuF1hTA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;AvF6hTF;;AwF7lTA;EACE,kBAAA;AxFgmTF;AwF9lTE;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;AxFgmTJ;AwF7lTE;;EAEE,SAAA;EACA,UAAA;EACA,kBAAA;AxF+lTJ;AwF7lTE;EACE,gBAAA;AxF+lTJ;AwF7lTI;EACE,UAAA;EACA,yBAAA;AxF+lTN;AwF5lTI;EACE,6EAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;E3E9BF,sBNqO0B;EiFrMxB,cvFfK;EuFgBL,mBAAA;AxF8lTN;AwF5lTM;EACE,mBvFkEiB;EuFjEjB,qBAAA;AxF8lTR;AwF3lTQ;EACE,YAAA;AxF6lTV;AwF1lTQ;EACE,UAAA;AxF4lTV;AwFxlTM;EACE,cvFXA;EuFYA,mBvFmDiB;ADuiTzB;AwFvlTM;EAEE,iBAAA;AxFwlTR;AwFplTI;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AxFslTN;AwFnlTI;EACE,2BAAA;EACA,UAAA;EACA,QAAA;AxFqlTN;AwFnlTM;EACE,0BAAA;AxFqlTR;AwFjlTI;EACE,yBAAA;AxFmlTN;AwFjlTM;EACE,uBAAA;AxFmlTR;AwFjlTQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,mBvFMe;EuFLf,kBAAA;EACA,UAAA;EACA,MAAA;E3EnGN,mB2EoG6B;AxFmlTjC;AwFhlTQ;EACE,aAAA;EACA,kBAAA;EACA,cvF3FC;EuF4FD,eAAA;AxFklTV;AwFhlTU;EACE,cvFvEJ;ADypTR;AwF/kTU;EACE,aAAA;AxFilTZ;AwF9kTU;EACE,cvF/EJ;EuFgFI,mBvFjBa;ADimTzB;AwF3kTM;EACE,SAAA;EACA,gBAAA;AxF6kTR;AwF1kTM;EACE,iBAAA;AxF4kTR;;AyFhtTE;EACE,0BAAA;AzFmtTJ;AyFjtTI;EACE,+BAAA;AzFmtTN;AyFjtTM;EACE,+CAAA;AzFmtTR;AyF7sTQ;EACE,+BAAA;AzF+sTV;AyF7sTU;EACE,yBAAA;EACA,oCAAA;AzF+sTZ;AyF5sTU;EACE,oCAAA;AzF8sTZ;AyFxsTY;EACE,+BAAA;AzF0sTd;AyFxsTc;EACE,oCAAA;EACA,+BAAA;AzF0sThB;AyFvsTc;EACE,yBAAA;AzFysThB;AyFpsTY;EACE,oCAAA;AzFssTd;AyFjsTQ;;EAEE,YAAA;AzFmsTV;AyF9rTI;EACE,oCAAA;AzFgsTN;AyF5rTM;EACE,oCAAA;AzF8rTR;AyFzrTM;EACE,oDAAA;AzF2rTR;AyFxrTM;;;EAGE,0CAAA;AzF0rTR;;A0FnwTE;EACE,0BAAA;A1FswTJ;A0FpwTI;EACE,yBAAA;A1FswTN;A0FpwTM;EACE,yCAAA;A1FswTR;A0FhwTQ;EACE,yBAAA;A1FkwTV;A0FhwTU;EACE,mBAAA;EACA,8BAAA;A1FkwTZ;A0F/vTU;EACE,8BAAA;A1FiwTZ;A0F3vTY;EACE,yBAAA;A1F6vTd;A0F3vTc;EACE,8BAAA;A1F6vThB;A0FzvTY;EACE,8BAAA;A1F2vTd;A0FvvTU;;EAEE,YAAA;A1FyvTZ;A0FnvTI;EACE,8BAAA;A1FqvTN;A0FjvTM;EACE,8BAAA;A1FmvTR;A0F7uTM;;;EAGE,oCAAA;A1F+uTR;;A2F/yTE;EACE,eAAA;EACA,aAAA;A3FkzTJ;A2F7yTI;EACE,UAAA;EACA,mBXJ4B;AhFmzTlC;A2FxyTM;EACE,aAAA;A3F0yTR;A2FnyTM;EACE,aAAA;A3FqyTR;A2FjyTI;EAEE,kBX1B4B;AhF4zTlC;A2FhyTM;EACE,aAAA;A3FkyTR;A2FtxTM;EACE,iBXzC0B;AhFi0TlC;A2FnxTQ;EACE,WX/CwB;EWgDxB,UAAA;A3FqxTV;A2FnxTU;EACE,aAAA;A3FqxTZ;A2FlxTU;EACE,kBAAA;A3FoxTZ;;A4F/0TE;EACE,yBAAA;EACA,WZE8B;EYD9B,eZC8B;EYA9B,cAAA;EACA,WAAA;A5Fk1TJ;A4F90TM;EACE,mBAAA;A5Fg1TR;A4F90TQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mB3FmFe;E2FlFf,gBAAA;A5Fg1TV;A4F50TM;EACE,mBAAA;EACA,UAAA;A5F80TR;A4F30TM;EACE,cAAA;EACA,SAAA;EACA,kBAAA;A5F60TR;A4F10TM;EACE,kBAAA;A5F40TR;A4Fx0TQ;EACE,UAAA;A5F00TV;A4Fx0TU;EACE,SAAA;A5F00TZ;A4Fp0TI;EACE,0BAAA;EACA,uBAAA;A5Fs0TN;A4Fl0TQ;EACE,cAAA;EAAA,oBAAA;A5Fo0TV;A4Fn0TU;EACE,aAAA;A5Fq0TZ;A4Fj0TQ;EACE,cAAA;EAAA,oBAAA;EACA,wBAAA;A5Fm0TV;A4Fh0TQ;EACE,cAAA;EAAA,oBAAA;EACA,SAAA;EACA,cAAA;A5Fk0TV;A4F/zTQ;EACE,mBAAA;A5Fi0TV;A4F7zTU;EACE,uBAAA;A5F+zTZ;A4F7zTY;EACE,aAAA;A5F+zTd;A4F1zTY;EACE,iBAAA;A5F4zTd;A4FhzTM;EACE,gBAAA;EACA,YAAA;EACA,4BAAA;EAAA,4BAAA;A5FkzTR;A4F9yTQ;EACE,kBAAA;EACA,YAAA;EACA,2BAAA;A5FgzTV;A4FxyTM;EACE,WZpH0B;AhF85TlC;A4FxyTQ;EACE,aAAA;A5F0yTV;A4FvyTQ;EACE,kBAAA;A5FyyTV;A4FjyTI;EACE,kBZpI4B;AhFu6TlC;A4F7xTM;EACE,kBAAA;A5F+xTR;A4FvxTM;;EACE,WAAA;EACA,aAAA;A5F0xTR;A4FxxTQ;;EACE,aAAA;A5F2xTV;A4FrxTM;EACE,aAAA;EACA,WZhK0B;EYiK1B,4BAAA;A5FuxTR;A4FrxTQ;EACE,yBAAA;EACA,cAAA;EACA,WAAA;A5FuxTV;A4FpxTQ;EACE,aAAA;A5FsxTV;A4FjxTQ;EACE,YZjLwB;AhFo8TlC;A4FjxTU;EACE,WZhLsB;EYiLtB,SAAA;A5FmxTZ;A4F5wTI;EACE,yBAAA;A5F8wTN;A4FzwTI;EACE,yBAAA;A5F2wTN;;A6Fp9TA;EACE,UAAA;EACA,kBAAA;EACA,aAAA;A7Fu9TF;A6Fr9TE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;A7Fu9TJ;A6Fp9TE;EACE,oBAAA;EACA,SAAA;A7Fs9TJ;A6Fn9TM;EACE,gBtFwMsB;AP6wT9B;A6Fj9TQ;EACE,mBAAA;A7Fm9TV;;A6Ft8TM;EACE,gBAAA;A7Fy8TR;A6Ft8TM;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;A7Fw8TR;A6Ft8TQ;EACE,iBAAA;A7Fw8TV;A6Fr8TQ;EACE,kBtF0nB0B;AP60SpC;A6Fp8TQ;EACE,W5F5CF;ADk/TR;A6Fn8TQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;A7Fq8TV;A6Fn8TU;EACE,YAAA;EACA,aAAA;EhF/DR,sBNqO0B;EsFpKlB,iIACQ;A7Fo8TpB;;A8F9/TE;EACE,mBAVe;A9F2gUnB;A8F9/TE;EACE,mBAba;A9F6gUjB;A8F7/TE;EACE,qCAAA;A9F+/TJ;A8F5/TE;;EAEE,mBArBY;A9FmhUhB;A8F1/TI;EACE,oCAAA;A9F4/TN;;A+F/gUE;EACE,mBAVe;A/F4hUnB;A+F/gUE;EACE,mBAba;EAcb,+BAAA;A/FihUJ;A+F9gUE;EACE,+BAAA;A/FghUJ;A+F7gUE;;EAEE,mBAtBY;A/FqiUhB;A+F5gUE;EACE,6BAAA;A/F8gUJ;A+F1gUI;EACE,0CAAA;A/F4gUN;A+FvgUI;EACE,+BApCe;A/F6iUrB;A+FrgUE;EACE,iBAAA;A/FugUJ;A+FpgUE;EACE,0CAAA;A/FsgUJ;A+FlgUM;EACE,oBAAA;EACA,iB9FiCO;E8FhCP,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;A/FogUR;A+FlgUQ;EACE,kBAAA;EACA,WAAA;EACA,mB9FxBF;EYvCJ,mBkFgE6B;EACvB,WAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;A/FogUV;A+F9/TE;EACE,yBAAA;A/FggUJ;;AgG9kUA;EACE,YhBWgC;AhFskUlC;AgG/kUE;EACE,2BAAA;EACA,YhBO8B;EgBN9B,oBAAA;EAEA,aAAA;EACA,qBAAA;EACA,mBAAA;AhGglUJ;AgG9kUI;EACE,aAAA;EACA,mBAAA;AhGglUN;AgG7kUI;EACE,iBAAA;EACA,aAAA;AhG+kUN;;AgGxkUA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AhG2kUF;AgGzkUE;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,mB/FrBO;ADgmUX;;AgGvkUA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;AhG0kUF;AgGxkUE;EACE,UAAA;AhG0kUJ;AgGxkUI;EACE,SAAA;EACA,kBAAA;AhG0kUN;AgGtkUE;EACE,iBAAA;AhGwkUJ;AgGrkUE;EACE,qBAAA;EACA,UAAA;AhGukUJ;;AiGnoUE;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AjGsoUJ;AiGpoUI;EACE,kBjBH4B;EiBI5B,kWAAA;AjGsoUN;AiG9nUE;EACE,oBjBP8B;AhFuoUlC;AiG3nUM;EACE,4BAAA;AjG6nUR;;AkGtpUA;EACE,a3F0N4B;E2FzN5B,wBAAA;EACA,kBAAA;AlGypUF;AkGvpUE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AlGypUJ;AkGtpUE;;EAEE,SAAA;EACA,UAAA;AlGwpUJ;AkGrpUE;EACE,kB3FkR0B;E2FjR1B,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AlGupUJ;AkGppUE;EACE,gBAAA;EACA,kBjG6Da;EiG5Db,YAAA;AlGspUJ;AkGppUI;EACE,UAAA;EACA,eAAA;EACA,uBAAA;AlGspUN;AkGlpUE;EACE,iBAAA;AlGopUJ;AkGlpUI;EACE,SAAA;EACA,UAAA;EACA,uBAAA;AlGopUN;AkGhpUE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBjG3CI;EiG4CJ,0UjGqDiB;EY1GjB,sBNqO0B;E2F9K1B,WAAA;EACA,YAAA;AlGkpUJ;AkGhpUI;EACE,YAAA;AlGkpUN;AkG/oUI;EACE,kBAAA;AlGipUN;AkG7oUE;EACE,4BAAA;AlG+oUJ;AkG5oUE;EAEE,8BAAA;EACA,wBAAA;AlG6oUJ;AkG3oUE;EACE;IAEE,4BAAA;IACA,wBAAA;ElG4oUJ;AACF;AkGzoUE;EACE,SAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AlG2oUJ;;AkGtoUE;ErF9FE,mBqF+FuB;AlGyoU3B;;AkGloUE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;AlGqoUJ;;AmGjvUA;EACE,kBAAA;EACA,6BAAA;AnGovUF;AmGlvUE;EACE,YAPkB;EAQlB,WARkB;EASlB,gBAAA;EACA,kBAAA;EACA,gCAAA;AnGovUJ;AmGlvUI;EACE,WAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,wDAAA;EACA,sBAAA;EACA,kBlG6DW;ADurUjB;AmGjvUI;EACE,WA/BgB;EAgChB,YAhCgB;EAiChB,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;EACA,+BAAA;EtFtCF,mBsFuCyB;AnGmvU7B;AmGjvUM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yDAAA;AnGmvUR;AmGjvUQ;EAEE,kBAAA;EACA,WAAA;AnGkvUV;AmG/uUQ;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mBlGvBF;ADwwUR;AmG9uUQ;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,mBAAA;EACA,yBAAA;AnGgvUV;AmG1uUE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;EACA,4DAAA;EACA,sBAAA;AnG4uUJ;AmG1uUI;EAEE,kBAAA;EACA,WAAA;EACA,mBlGxDE;EkGyDF,kBAAA;AnG2uUN;AmGxuUI;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;AnG0uUN;AmGvuUI;EACE,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;AnGyuUN;AmGruUE;EACE,YAAA;AnGuuUJ;AmGruUI;EACE,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,wDAAA;AnGuuUN;AmGruUM;EACE,UAAA;EACA,6BAAA;AnGuuUR;AmGpuUM;EACE,WApIc;EAqId,YArIc;EAsId,SAAA;EACA,mBAAA;AnGsuUR;AmGpuUQ;EACE,yBAAA;AnGsuUV;AmGjuUI;EACE,WAAA;EACA,uBAAA;EACA,wBAAA;EACA,wDAAA;EACA,sBAAA;AnGmuUN;AmGjuUM;EACE,qBAAA;AnGmuUR;AmG/tUI;EACE,UAAA;AnGiuUN;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,uBAAA;ApG+3UF;;AoG53UA;EACE,wBAAA;ApG+3UF;;AoG53UA;EACE,uBAAA;ApG+3UF;;AoG53UA;EACE,uBAAA;ApG+3UF;;AoG53UA;EACE,uBAAA;ApG+3UF;;AoG53UA;EACE,uBAAA;ApG+3UF;;AoG53UA;EACE,uBAAA;ApG+3UF;;AoG53UA;EACE,uBAAA;ApG+3UF;;AoG53UA;EACE,uBAAA;ApG+3UF;;AoG53UA;EACE,uBAAA;ApG+3UF;;AoG53UA;EACE,qBAAA;ApG+3UF;;AqG78UA;EACE,gCAAA;ArGg9UF;;AqG78UA;EACE,iCAAA;ArGg9UF;;AqG78UA;EACE,iCAAA;ArGg9UF;;AqG78UA;EACE,iCAAA;ArGg9UF;;AqG78UA;EACE,iCAAA;ArGg9UF;;AqG78UA;EACE,iCAAA;ArGg9UF;;AqG78UA;EACE,iCAAA;ArGg9UF;;AqG78UA;EACE,kCAAA;ArGg9UF;;AsGz+UA;EACE,0CAAA;AtG4+UF;;AsGz+UA;EACE,2CAAA;AtG4+UF;;AsGz+UA;EACE,6CAAA;AtG4+UF;;AsGz+UA;EACE,8CAAA;AtG4+UF;;AsGz+UA;EACE,2BAAA;AtG4+UF;;AsGz+UA;EACE,0BAAA;AtG4+UF;;AsGz+UA;EzFzBI,sBNqO0B;APiyU9B;;AsGv+UA;EACE,4BAAA;EACA,6BAAA;AtG0+UF;;AsGv+UA;EACE,cAAA;AtG0+UF;AsGx+UE;EACE,cAAA;AtG0+UJ;;AsGt+UA;EACE,cAAA;AtGy+UF;;AsGt+UA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AtGy+UF;;AsGr+UE;EACE,MAAA;EACA,UAAA;EACA,YAAA;AtGw+UJ;;AsGl+UA;EACE,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,4BAAA;AtGq+UF;;AsGh+UA;EACE,4BAAA;AtGm+UF;;AsGh+UA;EACE,4BAAA;AtGm+UF;;AsGh+UA;EACE,4BAAA;AtGm+UF;;AsG99UA;EACE,wCAAA;AtGi+UF;;AsG59UA;EACE,wBAAA;AtG+9UF;;AsG59UA;EACE,uBAAA;AtG+9UF;;AsG59UA;EACE,YAAA;AtG+9UF;;AsG59UA;EACE,aAAA;AtG+9UF;;AsG59UA;EACE,mBAAA;AtG+9UF;;AsG19UA;EACE,6BAAA;AtG69UF;;AsG19UA;EACE,4BAAA;AtG69UF;;AsG19UA;EACE,4BAAA;AtG69UF;;AsG19UA;EACE,0BAAA;AtG69UF;;AsG19UA;EACE,UAAA;AtG69UF;;AsG19UA;EACE,cAAA;AtG69UF;;AsGx9UA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AtG29UF;;AsGx9UA;EACE,SAAA;AtG29UF;;AsGt9UA;EACE,gB/F9BO;E+F+BP,mB/F/BO;E+FgCP,WAAA;EACA,gBAAA;EACA,mBrGnJS;AD4mVX;;AsGt9UA;EACE,aAAA;EAAA,gBAAA;AtGy9UF;;AsGp9UA;EACE,eAAA;EACA,kBAAA;AtGu9UF;AsGr9UE;EACE,crG5JO;EqG6JP,kB/FoH0B;APm2U9B;AsGp9UE;EACE,crGnKO;EqGoKP,iBrG5FW;ADkjVf;;AsGh9UA;EACE,8BAAA;AtGm9UF;AsGv8UA;EACE;IACE,6BAAA;EtGk9UF;EsGh9UA;IACE,2BAAA;EtGk9UF;AACF;AsG78UA;EACE,WAAA;AtG+8UF;;AsG58UA;EACE,sBAAA;AtG+8UF;;AsG18UA;EACE,mB/FH4B;APg9U9B;;AsGx8UA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AtG28UF;AsGz8UE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AtG28UJ;AsGx8UE;EACE,gBAAA;EACA,cAAA;EACA,crGpOO;EqGqOP,mBAAA;AtG08UJ;AsGv8UE;EACE,kBAAA;EACA,cAAA;AtGy8UJ;;AuGrsVA;EACE,0FAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,gFAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,2GAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,0GAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,yEAAA;AvGwsVF;;AuGrsVA;EACE,6EAAA;AvGwsVF;;AuGrsVA;EACE,8EAAA;AvGwsVF;;AuGrsVA;EACE,0FAAA;AvGwsVF;;AuGrsVA;EACE,8KAAA;EACA,+BAAA;AvGwsVF;;AuGrsVA;EACE,wEAAA;AvGwsVF;;AuGrsVA;EACE,iFAAA;AvGwsVF;;AuGrsVA;EACE,kCAAA;AvGwsVF;;AwGnzVA;;;;CAAA;AAMA;EACC,mCAAA;AxGqzVD;;AwGlzVA;ECII,4BAAA;EAAA,yBAAA;AzGqzVJ;AwGrzVC;EACE,mCENuB;A1G6zV1B;AwGpzVC;ECJG,gCAAA;AzG4zVJ;AwGpzVC;ECRG,mCAAA;AzGg0VJ;AwGnzVC;ECbG,mCAAA;AzGo0VJ;AyG/yVI;EEjCF;IAAI,UAAA;E3G61VJ;E2G51VA;IAAM,UAAA;E3G+1VN;AACF;A2G71VC;EFQG,sBAAA;AzGy1VJ;A4G11VC;EACC;IACC,UAAA;IACA,4BAAA;E5Gu2VD;E4Gp2VA;IACC,UAAA;IACA,wBAAA;E5Gs2VD;AACF;A4Gn2VC;EHXG,0BAAA;AzGk3VJ;A6Gn3VC;EACC;IACC,UAAA;IACA,2BAAA;E7Gg4VD;E6G73VA;IACC,UAAA;IACA,wBAAA;E7G+3VD;AACF;A6G53VC;EJXG,wBAAA;AzG24VJ;AyGt3VI;EKjCF;IAAI,UAAA;E9Go6VJ;E8Gn6VA;IAAM,UAAA;E9Gs6VN;AACF;A8Gp6VC;ELQG,uBAAA;AzGg6VJ;A+Gt6VC;EACC;IAAK,yCAAA;IAAmD,UAAA;E/G67VxD;E+G57VA;IAAM,wCAAA;IAAkD,UAAA;E/Gg8VxD;E+G/7VA;IAAM,uCAAA;IAAqD,UAAA;E/Gm8V3D;E+Gl8VA;IAAO,qCAAA;IAAuC,UAAA;E/Gs8V9C;AACF;A+Gp8VC;ENDG,4BAAA;EAAA,mCAAA;AzG28VJ;AgHn9VC;EACC;IAAK,qCAAA;IAAuC,UAAA;EhHk+V5C;EgHj+VA;IAAO,yCAAA;IAAmD,UAAA;EhHq+V1D;AACF;AgHn+VC;EPGG,6BAAA;EAAA,kCAAA;AzGs+VJ;;AiH3+VE;EACE,iEAAA;AjH8+VJ;;AiHz+VE;EACE,cAAA;EACA,iEAAA;AjH4+VJ;;AiHv+VE;EACE,iEAAA;EACA,uBAAA;EACA,oBAAA;AjH0+VJ;;AiHt+VA;EACE;IACE,iBAAA;IACA,kBAAA;IACA,UAAA;EjHy+VF;EiHv+VA;IACE,eAAA;IACA,mBAAA;IACA,UAAA;EjHy+VF;AACF;AiHt+VA;EACE,oBAAA;AjHw+VF;;AkHhhWA;EACE,iBAAA;AlHmhWF;;AkH/gWE;EACE,iBAAA;EACA,gBAAA;AlHkhWJ;AkH/gWE;EACE,iBAAA;AlHihWJ;AkH9gWE;ErGbE,gBqGcuB;AlHghW3B;;AkH5gWA;EACE,iBAAA;EACA,gBAAA;AlH+gWF;AkH3gWE;ErGME,4BqGJ4B;ErGK5B,+BqGL4B;ErGV5B,6BqGW6B;ErGV7B,gCqGU6B;AlH8gWjC;;AkHvgWA;EACE,oBAAA;AlH0gWF;;AkHrgWA;EACE,sBAAA;AlHwgWF;AkHrgWI;EACE,mBAAA;EACA,eAAA;AlHugWN;AkHngWE;EACE,oBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;AlHqgWJ;AkHlgWE;EACE,qBAAA;AlHogWJ;AkHhgWI;EACE,eAAA;AlHkgWN;AkH7/VI;EACE,eAAA;AlH+/VN;;AkHz/VE;EACE,cAAA;EACA,eAAA;AlH4/VJ;;AkHt/VA;EACE,kBAAA;AlHy/VF;AkHv/VE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,0CAAA;EAGA,gBAAA;AlHy/VJ;AkHt/VE;EACE,WAAA;EACA,wCAAA;EACA,gCAAA;AlHw/VJ;AkHp/VI;ErG/EA,4BqGgF8B;ErG/E9B,+BqG+E8B;ErG9F9B,6BqG+F+B;ErG9F/B,gCqG8F+B;AlHw/VnC;;AkHj/VA;EACE,iBAAA;EACA,oBAAA;AlHo/VF;AkHl/VE;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AlHo/VJ;AkHj/VE;EACE,qBAAA;AlHm/VJ;AkH/+VI;EACE,eAAA;AlHi/VN;AkH5+VI;EACE,eAAA;AlH8+VN;AkHv+VI;EACE,UAAA;AlHy+VN;AkHp+VI;EACE,oBAAA;AlHs+VN;AkHj+VI;EACE,+BAAA;AlHm+VN;AkH/9VM;EACE,qBAAA;AlHi+VR;AkH19VQ;EACE,sBAAA;AlH49VV;;AkHr9VA;EACE,4BAAA;AlHw9VF;;AkHn9VA;EACE,cjH7KS;EiH8KT,qBjHlLS;EiHmLT,sBAAA;AlHs9VF;AkHp9VE;EACE,yBAAA;EACA,6BAAA;AlHs9VJ;AkHp9VI;EACE,cjH9JE;EiH+JF,mBjH5LK;ADkpWX;AkHl9VE;EAEE,cjH7LO;EiH8LP,qBjHlMO;ADqpWX;AkH/8VI;EACE,gBAAA;AlHi9VN;;AkH18VI;EACE,gCAAA;EACA,gCAAA;EACA,2BAAA;EAAA,wBAAA;EACA,wBAAA;EACA,2BAAA;EACA,WjHtNE;ADmqWR;;AkHt8VA;ErGtOI,2BqGuOqB;AlHy8VzB;;AkHn8VE;ExF7IA,wBAAA;ElB0BI,iBAtCa;EkBcjB,gBnByL4B;EM3R1B,sBNqO0B;APk9V9B;;AkHp8VE;ExFnJA,oBAAA;ElB0BI,iBAtCa;EkBcjB,gBnB6H4B;EM/N1B,qBNsO0B;APw9V9B;;AkHr8VE;ExFzJA,qBAAA;ElB0BI,iBAtCa;EkBcjB,gBnB8H4B;EMhO1B,qBNuO0B;AP89V9B;;AkHp8VE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;AlHu8VJ;;AkHj8VI;EACE,MAAA;AlHo8VN;;AkH/7VA;EACE,+CAAA;AlHk8VF;;AkHz1VE;EA5BA,gHAAA;EACA,qEAuBQ;EAtBR,iEAsBQ;EArBR,WAAA;AlHy3VF;AkHv3VE;EAGE,2JAAA;EACA,WAAA;EACA,iEAAA;AlHu3VJ;AkHp3VE;EAIE,sBAAA;EACA,4EAAA;AlHm3VJ;AkHt2VI;EACE,mGAAA;AlHw2VN;AkHt2VM;EACE,mGAAA;AlHw2VR;;AkH/2VE;EA5BA,gHAAA;EACA,qEAuBQ;EAtBR,iEAsBQ;EArBR,WAAA;AlH+4VF;AkH74VE;EAGE,0JAAA;EACA,WAAA;EACA,iEAAA;AlH64VJ;AkH14VE;EAIE,sBAAA;EACA,4EAAA;AlHy4VJ;AkH53VI;EACE,uGAAA;AlH83VN;AkH53VM;EACE,uGAAA;AlH83VR;;AkHr4VE;EA5BA,gHAAA;EACA,qEAuBQ;EAtBR,iEAsBQ;EArBR,WAAA;AlHq6VF;AkHn6VE;EAGE,0JAAA;EACA,WAAA;EACA,iEAAA;AlHm6VJ;AkHh6VE;EAIE,sBAAA;EACA,4EAAA;AlH+5VJ;AkHl5VI;EACE,qGAAA;AlHo5VN;AkHl5VM;EACE,qGAAA;AlHo5VR;;AkH35VE;EA5BA,oGAAA;EACA,yDAuBQ;EAtBR,qDAsBQ;EArBR,WAAA;AlH27VF;AkHz7VE;EAGE,qIAAA;EACA,WAAA;EACA,qDAAA;AlHy7VJ;AkHt7VE;EAIE,sBAAA;EACA,gEAAA;AlHq7VJ;AkHx6VI;EACE,qGAAA;AlH06VN;AkHx6VM;EACE,qGAAA;AlH06VR;;AkHj7VE;EA5BA,6GAAA;EACA,kEAuBQ;EAtBR,8DAsBQ;EArBR,WAAA;AlHi9VF;AkH/8VE;EAGE,wJAAA;EACA,WAAA;EACA,gEAAA;AlH+8VJ;AkH58VE;EAIE,sBAAA;EACA,0EAAA;AlH28VJ;AkH97VI;EACE,qGAAA;AlHg8VN;AkH97VM;EACE,qGAAA;AlHg8VR;;AkHv8VE;EA5BA,+GAAA;EACA,oEAuBQ;EAtBR,gEAsBQ;EArBR,WAAA;AlHu+VF;AkHr+VE;EAGE,0JAAA;EACA,WAAA;EACA,gEAAA;AlHq+VJ;AkHl+VE;EAIE,sBAAA;EACA,0EAAA;AlHi+VJ;AkHp9VI;EACE,mGAAA;AlHs9VN;AkHp9VM;EACE,mGAAA;AlHs9VR;;AkH79VE;EA5BA,gHAAA;EACA,qEAuBQ;EAtBR,iEAsBQ;EArBR,WAAA;AlH6/VF;AkH3/VE;EAGE,0JAAA;EACA,WAAA;EACA,8DAAA;AlH2/VJ;AkHx/VE;EAIE,sBAAA;EACA,0EAAA;AlHu/VJ;AkH1+VI;EACE,iGAAA;AlH4+VN;AkH1+VM;EACE,iGAAA;AlH4+VR;;AkHn/VE;EA5BA,+GAAA;EACA,oEAuBQ;EAtBR,gEAsBQ;EArBR,WAAA;AlHmhWF;AkHjhWE;EAGE,2JAAA;EACA,WAAA;EACA,iEAAA;AlHihWJ;AkH9gWE;EAIE,sBAAA;EACA,4EAAA;AlH6gWJ;AkHhgWI;EACE,qGAAA;AlHkgWN;AkHhgWM;EACE,qGAAA;AlHkgWR;;AkHzgWE;EA5BA,gHAAA;EACA,qEAuBQ;EAtBR,iEAsBQ;EArBR,cAAA;AlHyiWF;AkHviWE;EAGE,2JAAA;EACA,cAAA;EACA,iEAAA;AlHuiWJ;AkHpiWE;EAIE,yBAAA;EACA,gCAAA;AlHmiWJ;AkHthWI;EACE,uGAAA;AlHwhWN;AkHthWM;EACE,uGAAA;AlHwhWR;;AkH/hWE;EA5BA,6GAAA;EACA,kEAuBQ;EAtBR,8DAsBQ;EArBR,WAAA;AlH+jWF;AkH7jWE;EAGE,wJAAA;EACA,WAAA;EACA,mBAAA;AlH6jWJ;AkH1jWE;EAIE,sBAAA;EACA,uEAAA;AlHyjWJ;AkH5iWI;EACE,iGAAA;AlH8iWN;AkH5iWM;EACE,iGAAA;AlH8iWR;;AkHviWE;EACE,0CAAA;AlH0iWJ;;AkH9hWE;ExFpZA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADw3Wf;AGl7WE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,gEATqG;A1B87WzG;A0Bl7WE;EAMI,uDAAA;A1B+6WN;A0B16WE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADq4Wf;A0Bp6WE;EAGE,WAAA;EACA,oEAtC+I;EA0C/I,iEA1CyL;A1B28W7L;A0B/5WI;EAKI,uDAAA;A1B65WR;AkHtjWI;EACE,mGAAA;AlHwjWN;AkHtjWM;EACE,mGAAA;AlHwjWR;;AkH/jWE;ExFpZA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADy5Wf;AGn9WE;EuBAE,WAAA;EFNA,kEED2D;EAS3D,iEATqG;A1B+9WzG;A0Bn9WE;EAMI,uDAAA;A1Bg9WN;A0B38WE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADs6Wf;A0Br8WE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1B4+W7L;A0Bh8WI;EAKI,uDAAA;A1B87WR;AkHvlWI;EACE,uGAAA;AlHylWN;AkHvlWM;EACE,uGAAA;AlHylWR;;AkHhmWE;ExFpZA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD07Wf;AGp/WE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,iEATqG;A1BggXzG;A0Bp/WE;EAMI,6EAAA;A1Bi/WN;A0B5+WE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADu8Wf;A0Bt+WE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1B6gX7L;A0Bj+WI;EAKI,6EAAA;A1B+9WR;AkHxnWI;EACE,qGAAA;AlH0nWN;AkHxnWM;EACE,qGAAA;AlH0nWR;;AkHjoWE;ExFpZA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD29Wf;AGrhXE;EuBAE,WAAA;EFNA,0DED2D;EAS3D,qDATqG;A1BiiXzG;A0BrhXE;EAMI,6CAAA;A1BkhXN;A0B7gXE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADw+Wf;A0BvgXE;EAGE,WAAA;EACA,yDAtC+I;EA0C/I,qDA1CyL;A1B8iX7L;A0BlgXI;EAKI,6CAAA;A1BggXR;AkHzpWI;EACE,qGAAA;AlH2pWN;AkHzpWM;EACE,qGAAA;AlH2pWR;;AkHlqWE;ExFpZA,cAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD4/Wf;AGtjXE;EuBAE,cAAA;EFNA,oEED2D;EAS3D,+DATqG;A1BkkXzG;A0BtjXE;EAMI,6EAAA;A1BmjXN;A0B9iXE;EAEE,cAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;ADygXf;A0BxiXE;EAGE,cAAA;EACA,mEAtC+I;EA0C/I,gEA1CyL;A1B+kX7L;A0BniXI;EAKI,6EAAA;A1BiiXR;AkH1rWI;EACE,qGAAA;AlH4rWN;AkH1rWM;EACE,qGAAA;AlH4rWR;;AkHnsWE;ExFpZA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD6hXf;AGvlXE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,iEATqG;A1BmmXzG;A0BvlXE;EAMI,6EAAA;A1BolXN;A0B/kXE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;AD0iXf;A0BzkXE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1BgnX7L;A0BpkXI;EAKI,6EAAA;A1BkkXR;AkH3tWI;EACE,mGAAA;AlH6tWN;AkH3tWM;EACE,mGAAA;AlH6tWR;;AkHpuWE;ExFpZA,cAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD8jXf;AGxnXE;EuBAE,cAAA;EFNA,qEED2D;EAS3D,iEATqG;A1BooXzG;A0BxnXE;EAMI,6EAAA;A1BqnXN;A0BhnXE;EAEE,cAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;AD2kXf;A0B1mXE;EAGE,cAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1BipX7L;A0BrmXI;EAKI,6EAAA;A1BmmXR;AkH5vWI;EACE,uGAAA;AlH8vWN;AkH5vWM;EACE,uGAAA;AlH8vWR;;AkHrwWE;ExFpZA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;AD+lXf;AGzpXE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,iEATqG;A1BqqXzG;A0BzpXE;EAMI,6EAAA;A1BspXN;A0BjpXE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;AD4mXf;A0B3oXE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,+DA1CyL;A1BkrX7L;A0BtoXI;EAKI,6EAAA;A1BooXR;AkH7xWI;EACE,iGAAA;AlH+xWN;AkH7xWM;EACE,iGAAA;AlH+xWR;;AkHtyWE;ExFpZA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADgoXf;AG1rXE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,gEATqG;A1BssXzG;A0B1rXE;EAMI,kEAAA;A1BurXN;A0BlrXE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;AD6oXf;A0B5qXE;EAGE,WAAA;EACA,oEAtC+I;EA0C/I,iEA1CyL;A1BmtX7L;A0BvqXI;EAKI,kEAAA;A1BqqXR;AkH9zWI;EACE,iGAAA;AlHg0WN;AkH9zWM;EACE,iGAAA;AlHg0WR;;AkHv0WE;ExFpZA,WAAA;EFAE,yBvBgEW;EyB9Db,qBzB8Da;ADiqXf;AG3tXE;EuBAE,WAAA;EFNA,oEED2D;EAS3D,iEATqG;A1BuuXzG;A0B3tXE;EAMI,kEAAA;A1BwtXN;A0BntXE;EAEE,WAAA;EACA,yBzBuCW;EyBtCX,qBzBsCW;AD8qXf;A0B7sXE;EAGE,WAAA;EACA,qEAtC+I;EA0C/I,iEA1CyL;A1BovX7L;A0BxsXI;EAKI,kEAAA;A1BssXR;AkH/1WI;EACE,qGAAA;AlHi2WN;AkH/1WM;EACE,qGAAA;AlHi2WR;;AkHz1WI;EACE,mGAAA;AlH41WN;;AkH71WI;EACE,uGAAA;AlHg2WN;;AkHj2WI;EACE,qGAAA;AlHo2WN;;AkHr2WI;EACE,qGAAA;AlHw2WN;;AkHz2WI;EACE,qGAAA;AlH42WN;;AkH72WI;EACE,mGAAA;AlHg3WN;;AkHj3WI;EACE,uGAAA;AlHo3WN;;AkHr3WI;EACE,iGAAA;AlHw3WN;;AkHz3WI;EACE,iGAAA;AlH43WN;;AkH73WI;EACE,qGAAA;AlHg4WN;;AkH13WE;ExFnXA,czBSa;EyBRb,qBzBQa;ADyuXf;AGnyXE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;AD8uXf;A0B9uXE;EAEE,0CAAA;A1B+uXJ;A0B5uXE;EAEE,czBPW;EyBQX,6BAAA;A1B6uXJ;A0B1uXE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;AD0vXf;A0BxuXI;EAKI,0CAAA;A1BsuXR;AkHh5WI;EACE,mGAAA;AlHk5WN;AkHh5WM;EAIE,mGAAA;AlH+4WR;AkH54WM;EACE,oDAAA;AlH84WR;;AkH55WE;ExFnXA,czBSa;EyBRb,qBzBQa;AD2wXf;AGr0XE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADgxXf;A0BhxXE;EAEE,4CAAA;A1BixXJ;A0B9wXE;EAEE,czBPW;EyBQX,6BAAA;A1B+wXJ;A0B5wXE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;AD4xXf;A0B1wXI;EAKI,4CAAA;A1BwwXR;AkHl7WI;EACE,uGAAA;AlHo7WN;AkHl7WM;EAIE,uGAAA;AlHi7WR;AkH96WM;EACE,sDAAA;AlHg7WR;;AkH97WE;ExFnXA,czBSa;EyBRb,qBzBQa;AD6yXf;AGv2XE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADkzXf;A0BlzXE;EAEE,2CAAA;A1BmzXJ;A0BhzXE;EAEE,czBPW;EyBQX,6BAAA;A1BizXJ;A0B9yXE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;AD8zXf;A0B5yXI;EAKI,2CAAA;A1B0yXR;AkHp9WI;EACE,qGAAA;AlHs9WN;AkHp9WM;EAIE,qGAAA;AlHm9WR;AkHh9WM;EACE,qDAAA;AlHk9WR;;AkHh+WE;ExFnXA,czBSa;EyBRb,qBzBQa;AD+0Xf;AGz4XE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADo1Xf;A0Bp1XE;EAEE,2CAAA;A1Bq1XJ;A0Bl1XE;EAEE,czBPW;EyBQX,6BAAA;A1Bm1XJ;A0Bh1XE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADg2Xf;A0B90XI;EAKI,2CAAA;A1B40XR;AkHt/WI;EACE,qGAAA;AlHw/WN;AkHt/WM;EAIE,qGAAA;AlHq/WR;AkHl/WM;EACE,qDAAA;AlHo/WR;;AkHlgXE;ExFnXA,czBSa;EyBRb,qBzBQa;ADi3Xf;AG36XE;EuBqDE,cALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADs3Xf;A0Bt3XE;EAEE,2CAAA;A1Bu3XJ;A0Bp3XE;EAEE,czBPW;EyBQX,6BAAA;A1Bq3XJ;A0Bl3XE;EAGE,cAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADk4Xf;A0Bh3XI;EAKI,2CAAA;A1B82XR;AkHxhXI;EACE,qGAAA;AlH0hXN;AkHxhXM;EAIE,qGAAA;AlHuhXR;AkHphXM;EACE,qDAAA;AlHshXR;;AkHpiXE;ExFnXA,czBSa;EyBRb,qBzBQa;ADm5Xf;AG78XE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADw5Xf;A0Bx5XE;EAEE,0CAAA;A1By5XJ;A0Bt5XE;EAEE,czBPW;EyBQX,6BAAA;A1Bu5XJ;A0Bp5XE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADo6Xf;A0Bl5XI;EAKI,0CAAA;A1Bg5XR;AkH1jXI;EACE,mGAAA;AlH4jXN;AkH1jXM;EAIE,mGAAA;AlHyjXR;AkHtjXM;EACE,oDAAA;AlHwjXR;;AkHtkXE;ExFnXA,czBSa;EyBRb,qBzBQa;ADq7Xf;AG/+XE;EuBqDE,cALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;AD07Xf;A0B17XE;EAEE,4CAAA;A1B27XJ;A0Bx7XE;EAEE,czBPW;EyBQX,6BAAA;A1By7XJ;A0Bt7XE;EAGE,cAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADs8Xf;A0Bp7XI;EAKI,4CAAA;A1Bk7XR;AkH5lXI;EACE,uGAAA;AlH8lXN;AkH5lXM;EAIE,uGAAA;AlH2lXR;AkHxlXM;EACE,sDAAA;AlH0lXR;;AkHxmXE;ExFnXA,czBSa;EyBRb,qBzBQa;ADu9Xf;AGjhYE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;AD49Xf;A0B59XE;EAEE,yCAAA;A1B69XJ;A0B19XE;EAEE,czBPW;EyBQX,6BAAA;A1B29XJ;A0Bx9XE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;ADw+Xf;A0Bt9XI;EAKI,yCAAA;A1Bo9XR;AkH9nXI;EACE,iGAAA;AlHgoXN;AkH9nXM;EAIE,iGAAA;AlH6nXR;AkH1nXM;EACE,mDAAA;AlH4nXR;;AkH1oXE;ExFnXA,czBSa;EyBRb,qBzBQa;ADy/Xf;AGnjYE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;AD8/Xf;A0B9/XE;EAEE,yCAAA;A1B+/XJ;A0B5/XE;EAEE,czBPW;EyBQX,6BAAA;A1B6/XJ;A0B1/XE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;AD0gYf;A0Bx/XI;EAKI,yCAAA;A1Bs/XR;AkHhqXI;EACE,iGAAA;AlHkqXN;AkHhqXM;EAIE,iGAAA;AlH+pXR;AkH5pXM;EACE,mDAAA;AlH8pXR;;AkH5qXE;ExFnXA,czBSa;EyBRb,qBzBQa;AD2hYf;AGrlYE;EuBqDE,WALgD;EAMhD,yBzBIW;EyBHX,qBzBGW;ADgiYf;A0BhiYE;EAEE,2CAAA;A1BiiYJ;A0B9hYE;EAEE,czBPW;EyBQX,6BAAA;A1B+hYJ;A0B5hYE;EAGE,WAAA;EACA,yBzBfW;EyBgBX,qBzBhBW;AD4iYf;A0B1hYI;EAKI,2CAAA;A1BwhYR;AkHlsXI;EACE,qGAAA;AlHosXN;AkHlsXM;EAIE,qGAAA;AlHisXR;AkH9rXM;EACE,qDAAA;AlHgsXR;;AkH1rXA;EACE,kBAAA;E5F/bI,qF4FgcJ;AlH6rXF;AsBxnYI;E4FybJ;I5FxbM,gBAAA;EtB2nYJ;AACF;;AkH/rXA;EACE,iEAAA;AlHksXF;;AkH/rXA;EACE,cAAA;AlHksXF;;AmH9oYA;EACE,0UAAA;EAIA,kBlHmFe;EkHjFf,gB5GuuBkC;APs6WpC;AmH3oYE;EACE,mBAAA;AnH6oYJ;AmH1oYE;EACE,yBAAA;EACA,0BAAA;EACA,clH0BI;EkHzBJ,iBAAA;AnH4oYJ;AmHzoYE;EACE,kBlHmEa;EkHlEb,aAAA;EACA,mBAAA;EACA,uDAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AnH2oYJ;AmHzoYI;EACE,eAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AnH2oYN;AmHvoYM;EACE,YAAA;AnHyoYR;AmHpoYE;EACE,0UAAA;AnHsoYJ;;AmH/nYA;EtGlDI,mBsGmDqB;EACvB,gBlHoDmB;AD8kYrB;AmHhoYE;EtGtDE,mBsGuDuB;AnHkoY3B;AmH/nYE;EACE,qBAAA;EACA,sBAAA;AnHioYJ;AmH9nYE;EACE,qBAAA;EACA,sBAAA;EtGxDA,4BsGyD2B;EtGxD3B,6BsGwD2B;AnHioY/B;AmH9nYE;;EtG5DE,4BsG8D2B;EtG7D3B,6BsG6D2B;AnHioY/B;;AmH3nYI;EACE,gBAAA;EACA,clHxCE;ADsqYR;;AmHvnYI;EACE,mBlHhDE;EkHiDF,WlH/EE;ADysYR;;AmHpnYE;EACE,gBAAA;AnHunYJ;AmHpnYE;EACE,gBAAA;AnHsnYJ;;AmH/mYE;;;EtGjGE,+BN4N0B;EM3N1B,gCN2N0B;AP2/X9B;;AmH/mYA;EACE,WlHzGM;EkH0GN,oBAAA;EACA,sBlHZmB;EkHanB,kBAAA;EACA,UAAA;AnHknYF;AmHhnYE;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;AnHknYJ;AmH/mYE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AnHinYJ;AmH9mYE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AnHgnYJ;AmH9mYI;EACE,oBAAA;AnHgnYN;AmH7mYI;EACE,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AnH+mYN;AmH7mYM;EACE,kBAAA;AnH+mYR;AmH3mYI;EACE,gBAAA;EACA,kBAAA;AnH6mYN;AmHzmYE;EACE,oBAAA;AnH2mYJ;;AmHvmYA;EACE,gBAAA;EACA,kB5GoH4B;E4GnH5B,SAAA;AnH0mYF;;AmHvmYA;EACE,gM5GyF4B;E4GxF5B,eAAA;EACA,YAAA;AnH0mYF;;AmHtmYE;EACE,uBAAA;EACA,YAAA;AnHymYJ;AmHvmYI;EACE,gBlHrFe;AD8rYrB;AmHrmYE;EACE,+BAAA;AnHumYJ;AmHrmYI;EACE,UAAA;AnHumYN;;AmH/lYE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AnHkmYJ;;AmH7lYE;EACE,cAAA;AnHgmYJ;;AmH1lYI;EACE,MAAA;AnH6lYN;;AmHxlYA;EACE,+CAAA;AnH2lYF;;AmHplYE;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;AnHslYJ;AmHnlYE;EACE,gB5GxPO;E4GyPP,UAAA;AnHqlYJ;AmHllYE;EACE,SAAA;EACA,+B5G+egC;E4G9ehC,UAAA;AnHolYJ;AmHhlYI;EAEE,SAAA;EACA,YAAA;AnHilYN;AmH9kYI;EACE,YAAA;AnHglYN;AmH3kYI;EAEE,UAAA;EACA,WAAA;EACA,QAAA;AnH4kYN;AmHzkYI;EACE,QAAA;EACA,WAAA;AnH2kYN;AmHtkYI;EAEE,WAAA;EACA,UAAA;EACA,QAAA;AnHukYN;AmHpkYI;EACE,QAAA;EACA,UAAA;AnHskYN;AmHjkYI;EAEE,UAAA;EACA,UAAA;AnHkkYN;AmH/jYI;EACE,UAAA;AnHikYN;AmH5jYI;EAEE,aAAA;AnH6jYN;;AmHtjYA;EACE,YAAA;EACA,a5GxMO;APiwYT;AmHvjYE;EACE,oBAAA;EACA,e5GxD0B;E4GyD1B,cAAA;EACA,mBAAA;AnHyjYJ;AmHtjYE;EACE,gBAAA;AnHwjYJ;;AmHpjYA;EACE,YAAA;AnHujYF;;AmHljYA;EACE,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EtG5VE,gBsG6VqB;EACvB,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mCAAA;AnHqjYF;AmHnjYE;EAEE,aAAA;AnHojYJ;;AoH75YE;EACE,mBAAA;ApHg6YJ;;AoH55YA;EACE,aAAA;EACA,mBAAA;EACA,uDAAA;EACA,eAAA;ApH+5YF;AoH75YE;EACE,cnH6BI;EmH5BJ,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;ApH+5YJ;AoH55YE;EACE,cnHHO;ADi6YX;AoH55YI;EACE,YAAA;EACA,cnHgBE;AD84YR;AoHx5YI;EACE,YAAA;ApH05YN;;AoHp5YE;EACE,yBAAA;EACA,0BAAA;EACA,cnHxBO;EmHyBP,iBAAA;EACA,oBAAA;ApHu5YJ;AoHp5YE;EACE,oBAAA;ApHs5YJ;AoHn5YE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBnHxCO;AD67YX;;AoHh5YE;EACE,gBAAA;ApHm5YJ;;AoH54YI;EAEE,WnH1DE;ADw8YR;AoH54YM;EACE,WnH7DA;EmH8DA,YAAA;ApH84YR;AoH14YI;EACE,yBAAA;ApH44YN;;AoHn4YE;EACE,6BAAA;EACA,gCAAA;ApHs4YJ;AoHp4YI;EACE,UAAA;ApHs4YN;AiBz6YI;EmGyCA;IACE,sBAAA;EpHm4YJ;EoHh4YE;IACE,uBAAA;EpHk4YJ;EoH/3YE;IACE,qBAAA;EpHi4YJ;AACF;AoH93YE;EACE,sBAAA;ApHg4YJ;AiBv7YI;EmG8DE;IACE,sBAAA;EpH43YN;EoHz3YI;IACE,uBAAA;EpH23YN;EoHx3YI;IACE,qBAAA;EpH03YN;AACF;AoHt3YE;EACE,cAAA;EACA,SAAA;EACA,eAAA;ApHw3YJ;;AqHhgZE;E5EFA,WAAA;EACA,yBxCoEa;ADk8Yf;AGx/YE;EsCVI,WAAA;EACA,oEAAA;AzCqgZN;AyClgZI;EAEE,UAAA;EACA,+CAAA;AzCmgZN;;AqH7gZE;E5EFA,WAAA;EACA,yBxCoEa;AD+8Yf;AGrgZE;EsCVI,WAAA;EACA,qEAAA;AzCkhZN;AyC/gZI;EAEE,UAAA;EACA,iDAAA;AzCghZN;;AqH1hZE;E5EFA,WAAA;EACA,yBxCoEa;AD49Yf;AGlhZE;EsCVI,WAAA;EACA,qEAAA;AzC+hZN;AyC5hZI;EAEE,UAAA;EACA,gDAAA;AzC6hZN;;AqHviZE;E5EFA,WAAA;EACA,yBxCoEa;ADy+Yf;AG/hZE;EsCVI,WAAA;EACA,yDAAA;AzC4iZN;AyCziZI;EAEE,UAAA;EACA,gDAAA;AzC0iZN;;AqHpjZE;E5EFA,cAAA;EACA,yBxCoEa;ADs/Yf;AG5iZE;EsCVI,cAAA;EACA,mEAAA;AzCyjZN;AyCtjZI;EAEE,UAAA;EACA,gDAAA;AzCujZN;;AqHjkZE;E5EFA,WAAA;EACA,yBxCoEa;ADmgZf;AGzjZE;EsCVI,WAAA;EACA,qEAAA;AzCskZN;AyCnkZI;EAEE,UAAA;EACA,+CAAA;AzCokZN;;AqH9kZE;E5EFA,cAAA;EACA,yBxCoEa;ADghZf;AGtkZE;EsCVI,cAAA;EACA,qEAAA;AzCmlZN;AyChlZI;EAEE,UAAA;EACA,iDAAA;AzCilZN;;AqH3lZE;E5EFA,WAAA;EACA,yBxCoEa;AD6hZf;AGnlZE;EsCVI,WAAA;EACA,qEAAA;AzCgmZN;AyC7lZI;EAEE,UAAA;EACA,8CAAA;AzC8lZN;;AqHxmZE;E5EFA,WAAA;EACA,yBxCoEa;AD0iZf;AGhmZE;EsCVI,WAAA;EACA,oEAAA;AzC6mZN;AyC1mZI;EAEE,UAAA;EACA,8CAAA;AzC2mZN;;AqHrnZE;E5EFA,WAAA;EACA,yBxCoEa;ADujZf;AG7mZE;EsCVI,WAAA;EACA,qEAAA;AzC0nZN;AyCvnZI;EAEE,UAAA;EACA,gDAAA;AzCwnZN;;AqH7nZA;EACE,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;ArHgoZF;;AqH7nZA;EACE,gBpHFM;ADkoZR;;AqH7nZA;EACE,mBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;ExGnBE,mBwGoBqB;EACvB,cAAA;ArHgoZF;;AqH7nZA;EACE,WAAA;EACA,YAAA;ArHgoZF;;AqH7nZA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ArHgoZF;AqH9nZE;EACE,WAAA;EACA,WAAA;EACA,YAAA;ExGrCA,sBNqO0B;E8G9L1B,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,gBpHlCI;ADkqZR;;AqH5nZA;EACE,UAAA;EACA,WAAA;ArH+nZF;;AqH3nZE;EACE,gBAAA;ArH8nZJ;AqH3nZE;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;ArH6nZJ;AqH3nZI;EACE,WAAA;EACA,YAAA;ArH6nZN;AqH1nZI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;ArH4nZN;AqHxnZE;EACE,SAAA;EACA,WAAA;ArH0nZJ;;AqHrnZE;EACE,QAAA;EACA,UAAA;ArHwnZJ;AqHrnZE;EACE,QAAA;EACA,UAAA;ArHunZJ;AqHpnZE;EACE,SAAA;EACA,WAAA;ArHsnZJ;AqHnnZE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;ArHqnZJ;;AqHjnZA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;ArHonZF;;AqH/mZA;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;ArHknZF;AqHhnZE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;ArHknZJ;AqHhnZI;EACE,cAAA;ArHknZN;AqH/mZI;EACE,SAAA;EACA,WAAA;EACA,YAAA;ArHinZN;AqH7mZE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;ArH+mZJ;AqH7mZI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,MAAA;EACA,QAAA;ArH+mZN;AqH7mZM;EACE,SAAA;EACA,QAAA;EACA,SAAA;ArH+mZR;;AqHvmZE;EACE,mBpHzDqB;EoH0DrB,sEAAA;EACA,cpH1HI;EoH2HJ,kBAAA;EACA,YAAA;ArH0mZJ;AqHxmZI;EACE,kBAAA;EACA,sBAAA;EACA,iB9GwHwB;E8GvHxB,cAAA;EACA,YAAA;ArH0mZN;AqHtmZE;EACE,eAAA;ArHwmZJ;AqHtmZI;EACE,UAAA;ArHwmZN;;AqHhmZI;EACE,YAAA;ArHmmZN;;AqH9lZA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;ExGrME,mBwGsMqB;ArHimZzB;AqH/lZE;ExGxME,iCwGyMuB;ArHimZ3B;;AqH5lZE;EACE,WAAA;EACA,YAAA;ArH+lZJ;AqH3lZI;EACE,e9GyEwB;APohZ9B;;AqHvlZE;EACE,WAAA;EACA,YAAA;ArH0lZJ;AqHtlZI;EACE,kB9G6DwB;AP2hZ9B;;AqHllZE;EACE,WAAA;EACA,YAAA;ArHqlZJ;AqHjlZI;EACE,iBpHzJS;AD4uZf;;AqH7kZE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;ArHglZJ;AqH5kZI;EACE,iBAAA;EACA,kBpHzKW;ADuvZjB;AqHzkZI;EACE,mBAAA;ArH2kZN;;AqHtkZA;EACE,sBAAA;EACA,gBAAA;ArHykZF;AqHvkZE;EACE,WAAA;EACA,YAAA;ArHykZJ;;AqHpkZE;EACE,UAAA;EACA,kBAAA;ArHukZJ;AqHrkZI;EACE,UAAA;ArHukZN;AqHpkZI;EACE,kBAAA;ArHskZN;AqHpkZI;EACE,kBAAA;ArHskZN;AqHpkZI;EACE,kBAAA;ArHskZN;AqHpkZI;EACE,kBAAA;ArHskZN;AqHnkZI;EAEE,yBAAA;ArHokZN;AqHriZA;EACE,oCAAA;EACA,2CAAA;EACA,kBAAA;ArH8jZF;AqH5jZE;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,gEAAA;EACA,2CAAA;ArH2jZJ;AqHxjZE;EACE,8BAAA;EACA,gCAAA;ArH0jZJ;;AsH95ZA;EACE,0UrH4GmB;EqH3GnB,eAAA;EACA,oBAAA;AtHi6ZF;AsH/5ZE;EACE,SAAA;AtHi6ZJ;AsH/5ZI;EzGIA,+BN4N0B;EM3N1B,gCN2N0B;APmsZ9B;AsH55ZI;;;EAEE,oCAAA;EACA,+BAAA;AtH+5ZN;AsH15ZI;;EAEE,yBAAA;AtH45ZN;AsHx5ZE;EACE,aAAA;EACA,mBAAA;AtH05ZJ;;AsHt5ZA;EACE,iBAAA;EACA,mBAAA;AtHy5ZF;;AsHt5ZA;EACE,kBAAA;AtHy5ZF;;AsHr5ZE;EACE,eAAA;EACA,gBAAA;AtHw5ZJ;AsHt5ZI;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;AtHw5ZN;AsH/5ZE;EAUE,crHpCO;AD47ZX;AsHt5ZI;EACE,crHhBE;ADw6ZR;;AsHn5ZA;;EAEE,yBAAA;EACA,8DAAA;EACA,iBAAA;EACA,kBrHoBe;ADk4ZjB;;AsHn5ZA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AtHs5ZF;AsHp5ZE;EACE,SAAA;EACA,UAAA;EACA,YAAA;AtHs5ZJ;AsHn5ZE;EACE,cAAA;AtHq5ZJ;AsHj5ZI;EACE,WAAA;EACA,iBAAA;AtHm5ZN;AsHh5ZI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AtHk5ZN;AsH94ZE;EACE,kBAAA;EACA,sBAAA;AtHg5ZJ;AsH74ZE;EACE,sBAAA;EACA,YAAA;EACA,WAAA;AtH+4ZJ;AsH74ZI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AtH+4ZN;AsH54ZI;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EACA,crHzGK;ADu/ZX;AsH54ZM;EACE,WAAA;EzG5HJ,mByG6H2B;EACvB,mBrHvFA;EqHwFA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;AtH84ZR;AsH34ZM;EACE,crHlGA;AD++ZR;AsH14ZM;EACE,crHtGA;ADk/ZR;AsH14ZQ;EACE,UAAA;AtH44ZV;AsHp4ZM;EACE,mBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;AtHs4ZR;AsHj4ZQ;EACE,mBAAA;AtHm4ZV;;AsH53ZA;EACE,6BAAA;EACA,iBAAA;AtH+3ZF;;AsH33ZE;EACE,0UAAA;AtH83ZJ;;AsHt3ZE;EACE,0UAAA;AtHy3ZJ;;AsHl3ZA;EACE,sB/G6mBkC;E+G5mBlC,mBrH3Ga;EqH4Gb,+DAAA;AtHq3ZF;;AsHj3ZE;EACE,sMAAA;AtHo3ZJ;;AsHr3ZE;EACE,8MAAA;AtHw3ZJ;;AsHz3ZE;EACE,0MAAA;AtH43ZJ;;AsH73ZE;EACE,0MAAA;AtHg4ZJ;;AsHj4ZE;EACE,0MAAA;AtHo4ZJ;;AsHr4ZE;EACE,sMAAA;AtHw4ZJ;;AsHz4ZE;EACE,8MAAA;AtH44ZJ;;AsH74ZE;EACE,kMAAA;AtHg5ZJ;;AsHj5ZE;EACE,kMAAA;AtHo5ZJ;;AsHr5ZE;EACE,0MAAA;AtHw5ZJ;;AsH/4ZA;EACE,sBAAA;EACA,YAAA;AtHk5ZF;;AsH74ZI;EACE,0UrH/Ge;AD+/ZrB;;AuH5maA;;EAEE,mBhH6HO;APk/ZT;;AuH5maA;EACE,iBAAA;AvH+maF;AuH7maE;EACE,eAAA;AvH+maJ;;AuHxmaI;EACE,yBAAA;AvH2maN;AuHxmaI;EACE,ctHqBE;ADqlaR;;AuHlmaI;EACE,yBAAA;AvHqmaN;AuHlmaI;EACE,mBtHQE;AD4laR;AuHlmaM;EACE,sBAAA;AvHomaR;;AuH5laA;EACE,kBAAA;AvH+laF;;AuH5laA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;AvH+laF;;AuH5laA;EACE,sBAAA;AvH+laF;;AuH5laA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;AvH+laF;AuH7laE;EACE,ctHzBI;ADwnaR;AuH5laE;EACE,UAAA;AvH8laJ;;AuH1laA;EACE,ctHlCM;AD+naR;;AuH1laA;EACE,YAAA;EACA,mBAAA;AvH6laF;;AuH1laA;EACE,UAAA;AvH6laF;;AuH1laA;EACE,kBAAA;AvH6laF;;AuH1laA;EACE,kBAAA;AvH6laF;;AuH1laA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;AvH6laF;;AuHvlaE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EAEA,cAAA;EACA,aAAA;E1G7GA,mB0G8GuB;EACvB,yBAAA;EACA,UAAA;AvHylaJ;AuHvlaI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,ctHrFE;AD8qaR;AuHvlaM;EACE,ctH7GG;ADssaX;AuHtlaM;EACE,WtH1HA;ADktaR;AuHtlaQ;EACE,WtH7HF;ADqtaR;AuHnlaI;EACE,uBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,eAAA;AvHolaN;AuHllaM;EACE,kBAAA;EACA,WAAA;EACA,gBtH7IA;EsH8IA,WAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;E1G1JJ,mB0G2J2B;AvHola/B;AuHjlaM;EACE,uBAAA;EACA,gBAAA;E1GhKJ,mB0GiK2B;EACvB,6BAAA;AvHmlaR;AuHhlaM;EACE,iBAAA;AvHklaR;;AuH1kaA;EACE,gBhHnDO;APgoaT;;AuHrkaA;E1GvLI,sBNqO0B;EgH5C5B,mBtHlJM;EsHmJN,eAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,WhHoB4B;EgHnB5B,QAAA;EACA,iBAAA;EACA,iBAAA;AvHwkaF;AuHtkaE;EACE,aAAA;AvHwkaJ;;AuHnkaA;EACE,kBAAA;EACA,UAAA;EACA,WtHzMM;EsH0MN,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AvHskaF;;AuHnkaA;EACE,iIAAA;AvHskaF;;AuHjkaA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,gBtH/HmB;EsHgInB,kBAAA;EACA,oBAAA;EACA,kBtHlJe;EsHmJf,ctHxNS;EsHyNT,gBAAA;EACA,gBAAA;EACA,sBhHzOS;EgH0OT,4BAAA;EACA,qCAAA;E1G7OE,sBNqO0B;EgHU5B,0UtHrImB;ADysarB;AuHlkaE;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,gBhHgC0B;EgH/B1B,chH5OO;EgH6OP,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;AvHokaJ;AuHlkaI;EAEE,kEAAA;EACA,qBAAA;EACA,mBtH5JmB;AD+tazB;;AuH9jaA;EACE,cAAA;AvHikaF;AuH/jaE;EACE,ctHpOI;ADqyaR;;AuH3jaA;EACE,WAAA;AvH8jaF;;AuH3jaA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,yBtHnPM;EYvCJ,mB0G2RqB;EACvB,yDAAA;EACA,UAAA;AvH8jaF;;AuH1jaE;EACE,kBAAA;AvH6jaJ;AuH3jaI;EACE,eAAA;EACA,mBAAA;AvH6jaN;AuH3jaM;EACE,oBAAA;EACA,gBAAA;AvH6jaR;AuHxjaE;EACE,qCAAA;EACA,oBAAA;AvH0jaJ;AuHvjaE;EACE,ahHzLK;EgH0LL,SAAA;AvHyjaJ;AuHpjaI;EACE,+BAAA;AvHsjaN;AuHpjaM;EACE,WtHtTA;AD42aR;AuHljaI;EACE,WtH3TE;AD+2aR;AuHjjaI;EACE,+DAAA;AvHmjaN;;AuH7iaE;EACE,uBAAA;EACA,kBAAA;EACA,UAAA;AvHgjaJ;AuH9iaI;EACE,gBAAA;EACA,YAAA;EACA,6BAAA;AvHgjaN;AuH5iaE;EACE,kBAAA;EACA,WvC3V8B;EuC4V9B,UAAA;AvH8iaJ;AuH3iaE;EACE,sBAAA;AvH6iaJ;AuH1iaE;EACE,WtH5VI;ADw4aR;AuHziaE;EACE,YAAA;EACA,aAAA;E1G1WA,sBNqO0B;EgHuI1B,iIAAA;AvH2iaJ;;AuHpiaE;EACE,aAAA;AvHuiaJ;AuHpiaE;EACE,QAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;AvHsiaJ;AuHniaE;EACE,YAAA;AvHqiaJ;;AuHjiaA;EACE,gCAAA;AvHoiaF;AuHliaE;EACE,qBAAA;EACA,mBAAA;EACA,kBtHpTa;ADw1ajB;AuHhiaI;EACE,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AvHkiaN;AuH/haI;EACE,WAAA;EACA,gBAAA;AvHiiaN;;AuH1haE;;EACE,SAAA;EACA,UAAA;EACA,kBAAA;AvH8haJ;AuH5haI;;;EAEE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2FAAA;EACA,oHAAA;AvH+haN;AuH5haI;;EACE,SAAA;EACA,SAAA;EAEA,yFAAA;EACA,oHAAA;AvH8haN;;AuHthaE;EACE,UAAA;EACA,YAAA;AvHyhaJ;AuHvhaI;EACE,ehHrKwB;EgHsKxB,gBAAA;AvHyhaN;AuHthaI;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;AvHwhaN;AuHrhaI;EACE,SAAA;AvHuhaN;AuHrhaM;EACE,iBAAA;EACA,+BAAA;EACA,mBtHzcG;ADg+aX;AuHrhaQ;EACE,gBtH7cF;ADo+aR;AuHthaU;EACE,WtHrcJ;EsHscI,YAAA;AvHwhaZ;AuHphaQ;EACE,gBtHrdF;EsHsdE,gBAAA;AvHshaV;AuHnhaQ;EACE,gBtH1dF;AD++aR;AuHnhaU;EACE,WtHndJ;EsHodI,YAAA;AvHqhaZ;AuH/gaQ;EACE,eAAA;AvHihaV;;AwHlgbA;E3GGI,sBNqO0B;EiHtO5B,yBAAA;AxHqgbF;AwHngbE;EACE,+BAAA;AxHqgbJ;AwHngbI;EACE,aAAA;EACA,YAAA;AxHqgbN;AwHngbM;;;EAGE,qBAAA;AxHqgbR;AwHjgbQ;EACE,SAAA;AxHmgbV;AwH9/aI;EACE,oCAAA;AxHggbN;AwH9/aM;EACE,4BvHdG;AD8gbX;;AyH5hbA;;EAEE,mBxHWS;ADohbX;;AyH5hbA;E5GqBI,mCN8M0B;EM7M1B,kCN6M0B;AP8za9B;;AyH7hbA;EACE,4LxH4GsB;EYnHpB,sBNqO0B;APm0a9B;;A0H3gbA;;EAAA;AC9BA;EACE;IACE,mBAAA;IACA,UAAA;E3H+ibF;E2H7ibA;IACE,qBAAA;IACA,YAAA;E3H+ibF;E2H7ibA;IACE,mBAAA;IACA,UAAA;E3H+ibF;AACF;A2HzibI;EACE,0EAAA;A3H2ibN;A2H5ibI;EACE,0EAAA;A3H8ibN;A2H/ibI;EACE,0EAAA;A3HijbN;A2HljbI;EACE,sEAAA;A3HojbN;A2H5ibE;EC9BA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;ED8BE,qBAAA;A3HijbJ;;A6H9kbA;EACE;IACE,2BAAA;E7HilbF;E6H/kbA;IACE,4BAAA;E7HilbF;E6H/kbA;IACE,wBAAA;E7HilbF;AACF;A6H5kbI;EACE,2DAAA;A7H8kbN;A6H/kbI;EACE,2DAAA;A7HilbN;A6HllbI;EACE,2DAAA;A7HolbN;A6HrlbI;EACE,uDAAA;A7HulbN;A6H/kbE;ED5BA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EC4BE,qBAAA;A7HolbJ;;A8HlnbA;EACE;IACE,mBAAA;E9HqnbF;E8HnnbA;IACE,mBAAA;IACA,UAAA;E9HqnbF;AACF;A8HhnbE;EFdA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EEcE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,gDAAA;A9HqnbJ;;A+HxobA;EACE;IACE,uBAAA;E/H2obF;E+HzobA;IACE,yBAAA;E/H2obF;E+HzobA;IACE,yBAAA;E/H2obF;AACF;A+HxobA;EACE,kBAAA;A/H0obF;A+HxobE;EHjBA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EGiBE,kBAAA;A/H6obJ;A+H3obI;EACE,qEAAA;A/H6obN;A+H1obI;EH3BF,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EK6BH,WAAA;EACA,kBAAA;EACA,YAAA;A/H+obN;A+H5obI;EACE,QAAA;EACA,WAAA;A/H8obN;A+H3obI;EACE,QAAA;EACA,UAAA;A/H6obN;;AgIrrbA;EACE;IACE,gCAAA;EhIwrbF;EgItrbA;IACE,oCAAA;EhIwrbF;EgItrbA;IACC,kCAAA;EhIwrbD;AACF;AgInrbE;EJhBA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EIgBE,yBAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;AhIwrbJ;;AiIhtbA;EACE;IACE,gCAAA;EjImtbF;EiIjtbA;IACE,oCAAA;EjImtbF;EiIjtbA;IACC,kCAAA;EjImtbD;AACF;AiIhtbA;EACE;IACE,qBAAA;EjIktbF;EiIhtbA;IACE,mBAAA;EjIktbF;AACF;AiI/sbA;EACE,kBAAA;EACA,4BAAA;AjIitbF;AiI/sbE;ELvBA,yBAAA;EK0BE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AjIgtbJ;AiI9sbI;EACE,mBhIOE;EgINF,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,mEAAA;AjIgtbN;AiI7sbI;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,qDAAA;EACA,oEAAA;EACA,sBAAA;AjI+sbN;;AkIpwbA;EACE;IACE,gCAAA;ElIuwbF;EkIrwbA;IACE,oCAAA;ElIuwbF;EkIrwbA;IACC,kCAAA;ElIuwbD;AACF;AkIpwbA;EACE,kBAAA;AlIswbF;AkIpwbE;ENbA,yBAAA;EMgBE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,4CAAA;AlIqwbJ;AkInwbI;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,qDAAA;EACA,4BAAA;AlIqwbN;;AmI1ybA;EACE;IACE,qBAAA;IACA,UAAA;EnI6ybF;EmI3ybA;IACE,mBAAA;IACA,YAAA;EnI6ybF;EmI3ybA;IACE,UAAA;EnI6ybF;AACF;AmIxybE;EPdA,yBAAA;EOiBE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,+EAAA;AnIyybJ;;AoI7zbA;EACE;IACE,qBAAA;IACA,UAAA;EpIg0bF;EoI9zbA;IACE,mBAAA;IACA,YAAA;EpIg0bF;EoI9zbA;IACE,UAAA;EpIg0bF;AACF;AoI3zbI;EACE,sBAAA;ApI6zbN;AoI9zbI;EACE,sBAAA;ApIg0bN;AoIj0bI;EACE,sBAAA;ApIm0bN;AoIp0bI;EACE,sBAAA;ApIs0bN;AoIj0bA;EAGE,kBAAA;EACA,4BAAA;ApIi0bF;AoI/zbE;ER7BA,yBAAA;EQgCE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WApCG;EAqCH,YArCG;EAsCH,mBAAA;EACA,yBAAA;EACA,2FAAA;ApIg0bJ;;AqIz2bA;EACE;IACE,YAAA;IACA,sBAAA;ErI42bF;EqI12bA;IACE,UAAA;IACA,mBAAA;ErI42bF;AACF;AqIv2bE;ETfA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;ESeE,qBAAA;EACA,4CAAA;ArI42bJ;AqI12bI;EACE,kCAAA;ArI42bN;;AsI93bA;EACE;IACE,mBAAA;IACA,UAAA;EtIi4bF;EsI/3bA;IACE,UAAA;EtIi4bF;EsI/3bA;IACE,mBAAA;IACA,UAAA;EtIi4bF;AACF;AsI53bI;EACE,sBAAA;AtI83bN;AsI/3bI;EACE,sBAAA;AtIi4bN;AsI53bA;EAGE,kBAAA;EACA,4BAAA;AtI43bF;AsI13bE;EVjCA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EUiCE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAvCG;EAwCH,YAxCG;EAyCH,oDAAA;AtI+3bJ;;AuIv6bA;EACE;IACE,iCAAA;EvI06bF;EuIx6bA;IACE,+BAAA;EvI06bF;EuIx6bA;IACE,8BAAA;EvI06bF;AACF;AuIv6bA;EACE;IACE,gCAAA;EvIy6bF;EuIv6bA;IACE,iCAAA;EvIy6bF;EuIv6bA;IACE,8BAAA;EvIy6bF;AACF;AuIt6bA;EACE;IACE,gCAAA;EvIw6bF;EuIt6bA;IACE,kCAAA;EvIw6bF;EuIt6bA;IACE,8BAAA;EvIw6bF;AACF;AuIv5bA;EACE,kBAAA;AvIy5bF;AuIp6bI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;AvIs6bN;AuI36bI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;AvI66bN;AuIl7bI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;AvIo7bN;AuI/6bA;EAGE,wDAAA;AvI+6bF;AuI76bE;EXvDA,yBAAA;EW0DE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AvI86bJ;AuI56bI;EACE,SAnEG;AvIi/bT;AuI36bI;EACE,UAAA;AvI66bN;AuI16bI;EACE,SA3EG;EA4EH,UA5EG;AvIw/bT;;AwIt/bA;EACE;IACE,qBAAA;ExIy/bF;EwIv/bA;IACE,4BAAA;ExIy/bF;EwIv/bA;IACE,qBAAA;ExIy/bF;EwIv/bA;IACE,2BAAA;ExIy/bF;EwIv/bA;IACE,wBAAA;IACA,mBAAA;ExIy/bF;AACF;AwIt/bA;EACE;IACE,qBAAA;ExIw/bF;EwIt/bA;IACE,2BAAA;ExIw/bF;EwIt/bA;IACE,qBAAA;ExIw/bF;EwIt/bA;IACE,4BAAA;ExIw/bF;EwIt/bA;IACE,wBAAA;IACA,sBAAA;ExIw/bF;AACF;AwIn/bE;EZ5CA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EY4CE,qBAAA;EACA,sBAAA;EACA,6DAAA;EACA,mCAAA;EACA,kBAAA;AxIw/bJ;AwIt/bI;EACE,oCAAA;AxIw/bN;AwIr/bI;EACE,mCAAA;AxIu/bN;;AyIhjcA;EACE;IACE,YAAA;EzImjcF;EyIjjcA;IACE,UAAA;EzImjcF;AACF;AyI9icI;EACE,sBAAA;EACA,yBAAA;AzIgjcN;AyIljcI;EACE,sBAAA;EACA,yBAAA;AzIojcN;AyItjcI;EACE,qBAAA;EACA,yBAAA;AzIwjcN;AyI1jcI;EACE,sBAAA;EACA,yBAAA;AzI4jcN;AyI9jcI;EACE,uBAAA;EACA,yBAAA;AzIgkcN;AyIlkcI;EACE,sBAAA;EACA,yBAAA;AzIokcN;AyItkcI;EACE,sBAAA;EACA,yBAAA;AzIwkcN;AyI1kcI;EACE,sBAAA;EACA,yBAAA;AzI4kcN;AyI9kcI;EACE,sBAAA;EACA,yBAAA;AzIglcN;AyI1kcA;EAEE,WAAA;AzI2kcF;AyIzkcE;EbzBA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EayBE,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,mCAAA;EACA,kBAAA;AzI8kcJ;;A0I7mcA;EACE;IACE,mBAAA;E1IgncF;E0I9mcA;IACE,qBAAA;IACA,YAAA;E1IgncF;E0I9mcA;IACE,mBAAA;IACA,UAAA;E1IgncF;AACF;A0I3mcI;EACE,uBAAA;EACA,yBAAA;A1I6mcN;A0I/mcI;EACE,sBAAA;EACA,wBAAA;A1IincN;A0InncI;EACE,sBAAA;EACA,yBAAA;A1IqncN;A0IvncI;EACE,uBAAA;EACA,yBAAA;A1IyncN;A0I3ncI;EACE,sBAAA;EACA,wBAAA;A1I6ncN;A0I/ncI;EACE,sBAAA;EACA,yBAAA;A1IiocN;A0InocI;EACE,sBAAA;EACA,yBAAA;A1IqocN;A0IvocI;EACE,uBAAA;EACA,yBAAA;A1IyocN;A0I3ocI;EACE,sBAAA;EACA,yBAAA;A1I6ocN;A0IvocA;EAEE,WAAA;A1IwocF;A0ItocE;Ed9BA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;Ec8BE,qBAAA;EACA,WAAA;EACA,+BAAA;EACA,mCAAA;EACA,kBAAA;A1I2ocJ;;A2I5qcA;EACE;IACE,YAAA;IACA,qBAAA;E3I+qcF;E2I7qcA;IACE,UAAA;IACA,mBAAA;E3I+qcF;AACF;A2I1qcI;EAKI,SApBC;EAqBD,OAAA;EAwBF,0DAAA;A3IipcN;A2I/qcI;EAQI,oBANQ;EAOR,qBAPQ;EA4BV,0DAAA;A3IspcN;A2IprcI;EAWI,MAAA;EACA,UA3BC;EA6CH,0DAAA;A3I2pcN;A2IzrcI;EAcI,qBAAA;EACA,qBAbQ;EA4BV,yDAAA;A3IgqcN;A2I9rcI;EAiBI,UAAA;EACA,OAAA;EAYF,0DAAA;A3IqqcN;A2InscI;EAoBI,qBAAA;EACA,sBAAA;EASF,0DAAA;A3I0qcN;A2IxscI;EAuBI,MAAA;EACA,WAAA;EAMF,0DAAA;A3I+qcN;A2I7scI;EA0BI,oBAxBQ;EAyBR,sBAAA;EAGF,0DAAA;A3IorcN;A2I/qcA;EAGE,kBAAA;EACA,UAAA;EACA,WAAA;A3I+qcF;A2I7qcE;Ef5DA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;Ee4DE,kBAAA;A3IkrcJ;;A4I9ucA;EACE;IACE,YAAA;E5IivcF;E4I/ucA;IACE,UAAA;E5IivcF;AACF;A4I5ucI;EAKI,SAlBC;EAmBD,OAAA;EAwBF,mDAAA;A5ImtcN;A4IjvcI;EAQI,oBANQ;EAOR,qBAPQ;EA4BV,mDAAA;A5IwtcN;A4ItvcI;EAWI,MAAA;EACA,UAzBC;EA2CH,mDAAA;A5I6tcN;A4I3vcI;EAcI,qBAAA;EACA,qBAbQ;EA4BV,mDAAA;A5IkucN;A4IhwcI;EAiBI,UAAA;EACA,OAAA;EAYF,mDAAA;A5IuucN;A4IrwcI;EAoBI,qBAAA;EACA,sBAAA;EASF,mDAAA;A5I4ucN;A4I1wcI;EAuBI,MAAA;EACA,WAAA;EAMF,mDAAA;A5IivcN;A4I/wcI;EA0BI,oBAxBQ;EAyBR,sBAAA;EAGF,mDAAA;A5IsvcN;A4IjvcA;EAEE,kBAAA;A5IkvcF;A4IhvcE;EhBlDA,yBAAA;EgBqDE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;A5IivcJ;;A6I1ycA;EACE;IACE,kCAAA;E7I6ycF;E6I3ycA;IACE,iCAAA;E7I6ycF;E6I3ycA;IACE,0BAAA;E7I6ycF;AACF;A6I1ycA;EACE;IACE,gCAAA;E7I4ycF;E6I1ycA;IACE,iCAAA;E7I4ycF;E6I1ycA;IACE,0BAAA;E7I4ycF;AACF;A6IzycA;EACE,kBAAA;EACA,kCAAA;A7I2ycF;A6IzycE;EjBhCA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EiBgCE,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;A7I8ycJ;A6I5ycI;EACE,2CAAA;A7I8ycN;A6I3ycI;EACE,2CAAA;A7I6ycN;;A8Iv1cA;EACE;IACE,kCAAA;E9I01cF;E8Ix1cA;IACE,iCAAA;E9I01cF;E8Ix1cA;IACE,0BAAA;E9I01cF;E8Ix1cA;IACE,iCAAA;E9I01cF;E8Ix1cA;IACE,kCAAA;E9I01cF;E8Ix1cA;IACE,0BAAA;E9I01cF;AACF;A8Iv1cA;EACE;IACE,gCAAA;E9Iy1cF;E8Iv1cA;IACE,iCAAA;E9Iy1cF;E8Iv1cA;IACE,0BAAA;E9Iy1cF;E8Iv1cA;IACE,iCAAA;E9Iy1cF;E8Iv1cA;IACE,gCAAA;E9Iy1cF;E8Iv1cA;IACE,0BAAA;E9Iy1cF;AACF;A8It1cA;EACE,kBAAA;EACA,kCAAA;A9Iw1cF;A8It1cE;ElBlDA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EkBkDE,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;A9I21cJ;A8Iz1cI;EACE,mDAAA;A9I21cN;A8Ix1cI;EACE,mDAAA;A9I01cN;;A0Hl2cA;;EAAA;AqBrDA;EACE;IACE,oBAAA;E/I65cF;E+I35cA;IACE,sBAAA;E/I65cF;E+I35cA;IACE,oBAAA;E/I65cF;AACF;A+Ix5cI;EACE,2EAAA;A/I05cN;A+I35cI;EACE,2EAAA;A/I65cN;A+I95cI;EACE,2EAAA;A/Ig6cN;A+Ij6cI;EACE,2EAAA;A/Im6cN;A+Ip6cI;EACE,wEAAA;A/Is6cN;A+I95cE;EnB1BA,yB3H2CM;E2HxBN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EmB0BE,qBAAA;A/Im6cJ;;AgJ/7cA;EACE;IACE,mBAAA;EhJk8cF;EgJh8cA;IAEE,qBAAA;EhJi8cF;EgJ/7cA;IACE,mBAAA;EhJi8cF;AACF;AgJ57cI;EACE,qBAAA;EACA,yBAAA;AhJ87cN;AgJh8cI;EACE,sBAAA;EACA,yBAAA;AhJk8cN;AgJp8cI;EACE,uBAAA;EACA,sBAAA;AhJs8cN;AgJx8cI;EACE,sBAAA;EACA,yBAAA;AhJ08cN;AgJl8cE;EpB3BA,yB3H2CM;E2HxBN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EoB2BE,qBAAA;EACA,gCAAA;EACA,mCAAA;EACA,kBAAA;AhJu8cJ;;AiJt+cA;EACE;IACE,oBAAA;EjJy+cF;EiJv+cA;IACE,sBAAA;EjJy+cF;EiJv+cA;IACE,oBAAA;EjJy+cF;AACF;AiJp+cE;ErBjBA,yB3H2CM;E2HxBN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EqBiBE,qBAAA;EACA,wFAAA;AjJy+cJ;AiJv+cI;EACE,iCAAA;AjJy+cN;AiJt+cI;EACE,iCAAA;AjJw+cN;;AkJngdA;EACE;IACE,oBAAA;ElJsgdF;EkJpgdA;IACE,sBAAA;ElJsgdF;EkJpgdA;IACE,oBAAA;ElJsgdF;AACF;AkJjgdE;EtBhBA,yB3H2CM;E2HxBN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EsBgBE,qBAAA;EACA,sBAAA;EACA,8FAAA;AlJsgdJ;AkJpgdI;EACE,kCAAA;AlJsgdN;AkJngdI;EACE,8BAAA;AlJqgdN;;AmJ7hdA;EACE;IACE,YAAA;EnJgidF;EmJ9hdA;IACE,UAAA;EnJgidF;AACF;AmJ3hdI;EAKI,SAlBC;EAmBD,OAAA;EA8BF,iEAAA;AnJ4/cN;AmJhidI;EAQI,oBANQ;EAOR,qBAPQ;EAQR,yBAAA;EA0BF,iEAAA;AnJkgdN;AmJtidI;EAYI,MAAA;EACA,UA1BC;EA2BD,wBAAA;EAsBF,gEAAA;AnJwgdN;AmJ5idI;EAgBI,qBAAA;EACA,qBAfQ;EAgBR,wBAAA;EAkBF,iEAAA;AnJ8gdN;AmJljdI;EAoBI,UAAA;EACA,OAAA;EAeF,iEAAA;AnJmhdN;AmJvjdI;EAuBI,qBAAA;EACA,sBAAA;EACA,yBAAA;EAWF,iEAAA;AnJyhdN;AmJ7jdI;EA2BI,MAAA;EACA,WAAA;EACA,wBAAA;EAOF,iEAAA;AnJ+hdN;AmJnkdI;EA+BI,oBA7BQ;EA8BR,sBAAA;EACA,wBAAA;EAGF,6DAAA;AnJqidN;AmJhidA;EAEE,kBAAA;EACA,UAAA;EACA,UAAA;AnJiidF;AmJ/hdE;EvB/DA,yB3H2CM;E2HxBN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EuB+DE,kBAAA;EACA,UAAA;EACA,YAAA;AnJoidJ;;A0HxidA;;EAAA;A0B7DA;EACE;IACE,wDAAA;EpJ2mdF;EoJzmdA;IACE,6DAAA;EpJ2mdF;EoJzmdA;IACE,wDAAA;EpJ2mdF;EoJzmdA;IACE,mDAAA;EpJ2mdF;AACF;AoJtmdE;ExBjBA,yBAAA;EwBoBE,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,gFAAA;ApJumdJ;;AqJlodA;EACE;IACE,wDAAA;ErJqodF;EqJnodA;IACE,6DAAA;ErJqodF;EqJnodA;IACE,wDAAA;ErJqodF;EqJnodA;IACE,mDAAA;ErJqodF;AACF;AqJhodE;EzBfA,yBAAA;EyBkBE,WAAA;EACA,YAAA;EACA,mBpJmBI;EoJlBJ,yEAAA;ArJiodJ;;AsJrpdA;EACI;IACK,yBAAA;EtJwpdP;EsJtpdE;IACK,yBAAA;EtJwpdP;EsJtpdE;IACK,yBAAA;EtJwpdP;AACF;AsJrpdA;EACI;IACK,wBAAA;EtJupdP;EsJrpdE;IACK,uBAAA;EtJupdP;EsJrpdE;IACK,wBAAA;EtJupdP;AACF;AsJ1odA;EACE;IACE,YAAA;EtJ4odF;EsJ1odA;IACE,qCAAA;EtJ4odF;AACF;AsJvodI;EACE,iDAAA;AtJyodN;AsJ1odI;EACE,iDAAA;AtJ4odN;AsJ7odI;EACE,iDAAA;AtJ+odN;AsJhpdI;EACE,6CAAA;AtJkpdN;AsJ7odA;EAGE,kBAAA;AtJ6odF;AsJ3odE;EA/BE,UAAA;EACA,WAAA;EACA,oCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mBAjCG;EA4DH,iDAAA;EACA,kBAAA;EACA,WAAA;AtJmpdJ;AsJhpdE;EAtCE,UAAA;EACA,WAAA;EACA,oCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mBAjCG;EAmEH,mDAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AtJwpdJ;AsJrpdE;;;;E1B5EA,yB3H2CM;E2HjCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;E4BiFL,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;AtJypdJ;;AuJ5udA;EACE;IACE,qDAAA;EvJ+udF;EuJ7udA;IACE,gDAAA;EvJ+udF;EuJ7udA;IACE,sDAAA;EvJ+udF;EuJ7udA;IACE,0BAAA;EvJ+udF;AACF;AuJ5udA;EACE,kBAAA;EACA,kCAAA;AvJ8udF;AuJ5udE;E3BpBA,yBAAA;E2BuBE,WAxBG;EAyBH,YAzBG;EA0BH,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yBtJWI;EsJVJ,uDAAA;AvJ6udJ;AuJ3udI;EACE,sBAAA;AvJ6udN;;AwJ5wdA;EACE;IACE,uBAAA;ExJ+wdF;EwJ7wdA;IACE,yBAAA;ExJ+wdF;EwJ7wdA;IACE,yBAAA;ExJ+wdF;AACF;AwJ5wdA;EACE,kBAAA;EACA,WAjBK;EAkBL,YAlBK;EAmBL,gBAAA;AxJ8wdF;AwJ5wdE;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8CAAA;EACA,6FAAA;EACA,WAAA;EACA,YAAA;AxJ8wdJ;;AyJxydI;E5IgBA,gCNqN0B;EMpN1B,mCNoN0B;APwkd9B;AyJxydE;EACE,cAAA;AzJ0ydJ;AyJvydE;EACE,cAAA;AzJyydJ;AyJtydE;E5IbE,mB4IcuB;AzJwyd3B;;AyJlydE;;EAEE,kBAAA;AzJqydJ;AyJnydI;;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBxJvBE;EwJwBF,2CAAA;AzJsydN;;AyJjydA;EACE;IACE,YAAA;IACA,QAAA;EzJoydF;EyJlydA;IACE,UAAA;IACA,WAAA;EzJoydF;AACF;A0Jv1dA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;A1Jy1dF;A0Jv1dE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A1Jy1dJ;A0Jt1dE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBzJFO;EYXP,sBNqO0B;APiod9B;;A0Jp1dA;EACE,kBAAA;EACA,gBAAA;A1Ju1dF;A0Jr1dE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A1Ju1dJ;A0Jp1dE;EACE,gBAAA;A1Js1dJ;;A0Jl1dA;EACE,kBAAA;EACA,iBAAA;EACA,iBzJoDa;ADiydf;A0Jn1dE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A1Jq1dJ;A0Jl1dE;EACE,iBzJ2CW;EyJ1CX,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;A1Jo1dJ;A0Jj1dE;EACE,czJtCO;EyJuCP,kBAAA;A1Jm1dJ;A0Jh1dE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,mBAAA;EACA,iBAAA;EACA,czJlDO;EyJmDP,0BAAA;EACA,mBAAA;A1Jk1dJ;;A0J90dA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;A1Ji1dF;A0J/0dE;EACE,0BAAA;A1Ji1dJ;;A0J70dA;EACE,eAAA;EACA,gBAAA;A1Jg1dF;A0J90dE;EACE,aAAA;A1Jg1dJ;;A0J30dE;EACE,UAAA;A1J80dJ;A0J30dE;EACE,iBAAA;A1J60dJ;A0J10dE;EACE,SAAA;A1J40dJ;;A0Jx0dA;EACE,iBAAA;A1J20dF;A0Jz0dE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBzJtGO;EYXP,sBNqO0B;APwtd9B;A0Jx0dE;EACE,mBnJMK;APo0dT;A0Jv0dE;EACE,iBAAA;A1Jy0dJ;A0Jt0dE;EACE,WAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;A1Jw0dJ;A0Jt0dI;EACE,WAAA;EACA,YAAA;EACA,gBzJ7HE;EYTJ,mB6IuIyB;EACvB,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;A1Jw0dN;A0Jt0dM;EACE,cAAA;EACA,iBAAA;EACA,cAAA;A1Jw0dR;A0Jr0dM;EACE,cAAA;A1Ju0dR;;A0J/zdA;EACE,iBAAA;A1Jk0dF;A0Jh0dE;EACE,kBAAA;A1Jk0dJ;A0J/zdE;EACE,mBAAA;EACA,0BAAA;EACA,UAAA;A1Ji0dJ;A0J9zdE;EACE,YAAA;EACA,WAAA;EACA,mBzJpKO;EyJqKP,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;E7InLA,mB6IoLuB;A1Jg0d3B;A0J9zdI;EACE,WAAA;EACA,kBAAA;EACA,gBzJhLE;EyJiLF,SAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;E7I/LF,mB6IgMyB;A1Jg0d7B;A0J5zdE;EACE,oBAAA;A1J8zdJ;;A0JxzdI;EACE,mBzJ3IS;ADs8df;;A0J5zdI;EACE,mBzJ3IS;AD08df;;A0Jh0dI;EACE,mBzJ3IS;AD88df;;A0Jp0dI;EACE,mBzJ3IS;ADk9df;;A0Jx0dI;EACE,mBzJ3IS;ADs9df;;A0J50dI;EACE,mBzJ3IS;AD09df;;A0Jh1dI;EACE,mBzJ3IS;AD89df;;A0Jp1dI;EACE,mBzJ3IS;ADk+df;;A0Jx1dI;EACE,mBzJ3IS;ADs+df;;A0J51dI;EACE,mBzJ3IS;AD0+df;;A0Jn1dA;EACE,kBAAA;A1Js1dF;;A0Jn1dA;EACE,mBAAA;EACA,2BAAA;A1Js1dF;A0JjzdA;EACE;IACE,UAAA;IAKA,qBAAA;E1J80dF;E0J30dA;IACE,UAAA;IAKA,qBAAA;E1J60dF;E0J10dA;IAKE,mBAAA;E1J40dF;AACF;A0Jx0dA;EACE,kBAAA;A1J00dF;;A0Jv0dA;EACE,mBAAA;EAGA,2BAAA;A1J00dF;;A0Jv0dA;EACE;IAGE,mCAAA;E1J00dF;AACF;A0Jt0dA;EACE;IACE,mBAAA;IAGA,mCAAA;E1Jw0dF;AACF;A0JlydA;EACE;IACE,UAAA;IAKA,6BAAA;E1J8zdF;E0J3zdA;IACE,UAAA;IAKA,2BAAA;E1J6zdF;E0J1zdA;IAKE,wBAAA;E1J4zdF;AACF;A0JtxdA;EACE;IACE,UAAA;IAKA,4BAAA;E1JkzdF;E0J/ydA;IACE,UAAA;IAKA,4BAAA;E1JizdF;E0J9ydA;IAKE,wBAAA;E1JgzdF;AACF;A2J1ueE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;E9IDA,qBNsO0B;EoJnO1B,cAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;A3J4ueJ;A2JvueM;EACE,YAAA;A3JyueR;A2JpueE;;EAEE,qBAAA;A3JsueJ;;A2JlueA;EACE,aAAA;A3JqueF;;A2JjueE;EACE,SAAA;EACA,iBAAA;A3JoueJ;;A2J/teE;EACE,SAAA;EACA,uBAAA;A3JkueJ;;A4JtweM;E/I6BF,yB+I5BgC;E/I6BhC,4B+I7BgC;E/IchC,2C+IbiC;E/IcjC,8C+IdiC;A5J2werC;A4JtweE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;A5JwweJ;A4JrweM;E/IEF,0B+IDiC;E/IEjC,6B+IFiC;A5JwwerC;;A4J/veI;EACE,kBAAA;EACA,cAAA;EACA,SAAA;A5JkweN;A4J9veE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;A5JgweJ;A4J9veI;E/IpBA,0B+IqB+B;E/IpB/B,6B+IoB+B;A5JiwenC;;A4J1veA;EACE,kB3JwCe;E2JvCf,iBAAA;A5J6veF;;A4JxveA;EACE,iB3JkCa;E2JjCb,SAAA;EACA,c3JfM;AD0weR;A4JzveE;EACE,c3J1CO;E2J2CP,mBAAA;EACA,kB3J0Ba;ADiuejB;;A4JvveA;EACE,wBAAA;EACA,qBAAA;A5J0veF;;A6JxzeI;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBtJswB8B;EsJrwB9B,ctJ6JoC;EsJ5JpC,sBtJRK;EsJSL,yBAAA;A7J2zeN;A6JzzeM;EACE,UAAA;EACA,mCtJyJkC;EsJxJlC,qBAAA;EACA,yBtJbG;EsJcH,qBtJbG;APw0eX;A6JxzeM;EACE,UAAA;EACA,UtJ+vB4B;EsJ9vB5B,gB5JsEsB;ADove9B;A6JtzeM;EACE,eAAA;A7JwzeR;A6JnzeM;EACE,cAAA;EhJLJ,+BNuM0B;EMtM1B,kCNsM0B;APqne9B;A6JlzeM;EhJxBF,gCNqN0B;EMpN1B,mCNoN0B;APyne9B;A6JjzeI;EACE,UAAA;EACA,WtJ7CK;EsJ8CL,yB5J8FgB;E4J7FhB,qBtJ+LwB;APone9B;A6JjzeM;EACE,WtJlDG;APq2eX;A6J/yeI;EACE,ctJjDK;EsJkDL,oBAAA;EAEA,YAAA;EACA,sBtJ3DK;EsJ4DL,qBtJzDK;APy2eX;;A6JxyeE;EhJtEE,8BgJuEuB;EACvB,gBAAA;A7J2yeJ;;A8Jt3eA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;A9Jy3eF;A8Jv3eE;EACE,cAAA;A9Jy3eJ;A8Jt3eE;EACE,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,mB7J4FqB;E6J3FrB,SAAA;EACA,uBAAA;EjJZA,mBiJauB;EACvB,+BvJuN0B;EuJtN1B,SAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;A9Jw3eJ;A8Jt3eI;EACE,gBAAA;EACA,mBAAA;EACA,mB9EvB4B;E8EwB5B,cAAA;A9Jw3eN;A8Jp3eE;EACE,iBAAA;A9Js3eJ;A8Jp3eI;EjJhCA,mBiJiCyB;EACvB,4BAAA;EACA,gCvJkMwB;EuJjMxB,iBAAA;A9Js3eN;A8Jp3eM;EACE,iBAAA;EACA,oB9EvC0B;E8EwC1B,cAAA;A9Js3eR;;A+Jl6eA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;ElJHE,sBNqO0B;APose9B;A+Jn6eE;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,c9JCO;E8JAP,kBAAA;A/Jq6eJ;A+Jn6eI;EAEE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,mB9JZK;E8JaL,UAAA;EACA,oBAAA;A/Jo6eN;A+Jj6eI;EACE,SAAA;A/Jm6eN;A+Jh6eI;EACE,OAAA;A/Jk6eN;A+J95eM;ElJRF,4BkJSgC;ElJRhC,+BkJQgC;A/Ji6epC;A+J55eM;ElJ5BF,6BkJ6BiC;ElJ5BjC,gCkJ4BiC;A/J+5erC;A+J35eI;EACE,kBAAA;EACA,iBxJ6OwB;EwJ5OxB,mB9JvCK;E8JwCL,W9J5CE;E8J6CF,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ElJ1DF,mBkJ2DyB;EACvB,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;A/J65eN;A+J15eI;EACE,c9JpDK;ADg9eX;A+J35eM;EACE,mB9J/BA;AD47eR;A+J15eM;EACE,mB9JnCA;AD+7eR;A+Jv5eM;EACE,+BAAA;EAEA,mB9JnCA;E8JoCA,gBAAA;A/Jw5eR;A+Jv5eQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;A/Jy5eV;A+Jr5eM;EAEE,mB9JjDA;ADu8eR;A+Jl5eI;EACE,c9JtFK;AD0+eX;;A+J14eI;EACE,kB9J3BW;ADw6ejB;A+J34eM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;A/J64eR;;A+Jr4eE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;A/Jw4eJ;A+Jt4eI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;ElJ5IF,qBNsO0B;EwJxFxB,oBAAA;A/Jw4eN;A+Jt4eM;EAEE,aAAA;A/Ju4eR;A+Jp4eM;EACE,qBAAA;A/Js4eR;A+Jn4eM;EACE,mB9J/IG;ADohfX;A+Jl4eM;EACE,mB9JvHA;E8JwHA,W9JtJA;AD0hfR;A+Jl4eQ;EACE,oCAAA;A/Jo4eV;A+J93eE;EACE,UAAA;EACA,cAAA;A/Jg4eJ;;A+J73eA;EAEI;IACE,cAAA;IACA,UAAA;IACA,WAAA;IACA,0BAAA;E/J+3eJ;E+J73eI;IACE,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,gBAAA;IACA,qBAAA;IlJ3LJ,qBNsO0B;IwJzCtB,oBAAA;E/J+3eN;E+J73eM;IAEE,aAAA;E/J83eR;E+J33eM;IACE,qBAAA;E/J63eR;E+J13eM;IACE,mB9J9LC;ED0jfT;E+Jz3eM;IACE,mB9JtKF;I8JuKE,W9JrMF;EDgkfN;E+Jz3eQ;IACE,oCAAA;E/J23eV;E+Jr3eE;IACE,UAAA;IACA,cAAA;E/Ju3eJ;AACF;AgKhlfA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AhKklfF;;AgK/kfA;EACE,kBAAA;EACA,azJmHO;EyJlHP,kBAAA;AhKklfF;AgKhlfE;EACE,YAAA;EACA,gBAAA;AhKklfJ;AgK/kfE;EACE,eAAA;EACA,kBzJyGK;APw+eT;AgK/kfI;EACE,iB/JkES;AD+gff;AgK7kfE;EACE,kBAAA;EACA,UAAA;AhK+kfJ;AgK5kfE;EACE,yBAAA;AhK8kfJ;AgK5kfI;EACE,gBAAA;AhK8kfN;AgK1kfE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EnJtBA,mCN8M0B;EM7M1B,kCN6M0B;EyJtL1B,gBAAA;AhK6kfJ;AgK1kfE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AhK4kfJ;AgK1kfI;EAGE,mBAAA;AhK0kfN;AgKtkfE;EACE,mBAAA;EACA,cAAA;EACA,YAAA;AhKwkfJ;AgKtkfI;EACE,aAAA;AhKwkfN;AgKrkfI;EACE,kBAAA;AhKukfN;AgKnkfE;EACE,gBAAA;AhKqkfJ;AgKlkfE;EACE,oBAAA;AhKokfJ;AgKlkfI;EACE,WAAA;EACA,sBAAA;EACA,yUAAA;EAIA,eAAA;EACA,gB/JpFE;ADqpfR;AgK7jfE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AhK+jfJ;AgK7jfI;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AhK+jfN;AgK3jfE;EACE,gBzJYK;APijfT;AgK3jfI;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AhK6jfN;AgK3jfM;EACE,mBAAA;AhK6jfR;AgK1jfM;EnJnHF,yBmJoH+B;EnJnH/B,0BmJmH+B;EnJtG/B,mCN8M0B;EM7M1B,kCN6M0B;APu9e9B;AgK5jfQ;EACE,kCzJoGoB;AP09e9B;AgKvjfE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBzJhBK;APykfT;AgKvjfI;EACE,gBAAA;AhKyjfN;AgKtjfI;EACE,SAAA;AhKwjfN;AgKrjfI;EACE,aAAA;AhKujfN;AgKnjfE;EACE,mBAAA;EACA,mBAAA;AhKqjfJ;AgKnjfI;EACE,eAAA;EACA,kBAAA;AhKqjfN;AgKljfI;EACE,cAAA;AhKojfN;AgKjjfI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AhKmjfN;AgKjjfM;EACE,aAAA;AhKmjfR;AgKhjfM;EACE,sBAAA;AhKkjfR;AgK9ifI;EACE,WAAA;AhKgjfN;AgK5ifE;EACE,mBAAA;AhK8ifJ;AgK3ifE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;AhK6ifJ;;AgKzifA;EACE,kBAAA;EACA,WzJ9EO;EyJ+EP,SzJ/EO;EyJgFP,WAAA;AhK4ifF;AgK1ifE;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AhK4ifJ;;AgKpifM;;EACE,UAAA;AhKwifR;;AgK/hfM;EACE,gBzJnOG;EMFP,sBNqO0B;APmif9B;;AgK3hfA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EAEA,kBAAA;EACA,gBAAA;AhK6hfF;AgK3hfE;EACE,iBAAA;EACA,mBAAA;AhK6hfJ;AgK1hfE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;AhK4hfJ;AgK1hfI;EACE,aAAA;AhK4hfN;AgKvhfE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AhKyhfJ;AgKvhfI;EACE,gBAAA;AhKyhfN;AgKrhfE;EACE,WAAA;EACA,eAAA;AhKuhfJ;;AgKlhfE;EACE,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AhKqhfJ;AgK/gfI;EACE,iBAAA;AhKihfN;AgK9gfI;EACE,mBAAA;AhKghfN;AgK5gfM;EACE,gBAAA;AhK8gfR;AgKzgfE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;AhK2gfJ;AgKzgfI;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AhK2gfN;AgKxgfI;EACE,aAAA;AhK0gfN;;AgKngfA;EACE,oCAAA;AhKsgfF;;AgKjgfA;EACE,kBAAA;AhKogfF;AgKlgfE;EACE,kB/J5Pa;E+J6Pb,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,+BAAA;AhKogfJ;AgKjgfE;EACE,cAAA;AhKmgfJ;;AgK//eA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AhKkgfF;AgKhgfE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AhKkgfJ;;AgK9/eA;EACE,iBAAA;AhKigfF;;AiK72fA;EACE,a1J0HO;E0JzHP,mBAAA;EACA,mBAAA;AjKg3fF;AiK92fE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AjKg3fJ;AiK32fI;EACE,YAAA;EACA,iBAAA;AjK62fN;AiK12fI;EACE,YAAA;AjK42fN;AiKx2fE;EACE,iBAAA;AjK02fJ;AiKv2fE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;AjKy2fJ;AiKt2fE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;AjKw2fJ;AiKr2fE;EACE,gB1JkFK;APqxfT;AiKr2fI;EACE,2BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AjKu2fN;AiKj2fM;EACE,iBAAA;AjKm2fR;AiK71fI;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;AjK+1fN;AiKz1fM;EACE,mBAAA;EACA,UAAA;AjK21fR;;AkKv6fA;EACE,kBAAA;EACA,gBAAA;AlK06fF;AkKx6fE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AlK06fJ;AkKv6fE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;AlKy6fJ;AkKp6fI;EACE,alFvB4B;AhF67flC;AkKp6fM;EACE,mBAAA;AlKs6fR;AkKn6fM;EACE,kBAAA;AlKq6fR;AkKj6fI;EACE,kBAAA;AlKm6fN;AkKj6fM;EACE,WjK7BA;EiK8BA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBjK2CO;ADw3ff;AkKj6fQ;EACE,oCAAA;AlKm6fV;;AmKp9fA;EACE,YnFQgC;EmFPhC,WnFQgC;EmFPhC,oDAAA;AnKu9fF;;AmKp9fA;EACE,YnFEgC;EmFDhC,WnFEgC;EmFDhC,oDAAA;AnKu9fF;;AmKn9fE;EACE,mBnFX8B;AhFi+flC;AmKn9fE;EACE,qBnFd8B;EmFe9B,mBAAA;AnKq9fJ;AmKn9fI;EACE,YAAA;AnKq9fN;AmKl9fI;EACE,iBlK+DS;ADq5ff;;AoKp+fM;EACE,WAAA;EACA,WAAA;ApKu+fR;AoKl+fE;EACE,WAAA;EACA,epFf8B;EoFgB9B,gBAAA;ApKo+fJ;AoKl+fI;EACE,SAAA;EACA,UAAA;EACA,uBAAA;ApKo+fN;AoK5+fE;EAWE,gCAAA;ApKo+fJ;AoKj+fE;EACE,epF5B8B;AhF+/flC;AoKj+fI;EvJ/BA,qBNsO0B;AP6xf9B;AoK/9fE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;ApKi+fJ;AoK/9fI;EACE,SAAA;EACA,aAAA;ApKi+fN;AoK/9fM;EACE,+BAAA;EACA,gBAAA;EACA,SAAA;ApKi+fR;AoK99fM;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ApKg+fR;AoK79fM;EACE,aAAA;EACA,mBAAA;ApK+9fR;AoK59fM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;ApK89fR;AoK39fM;EACE,epFvE0B;EoFwE1B,6BAAA;ApK69fR;AoKz9fI;EACE,YAjF8B;EAkF9B,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;ApK29fN;AoKz9fM;EACE,mBAAA;ApK29fR;AoKx9fM;EACE,+BAAA;EACA,gBAAA;EACA,mBnKpFG;EmKqFH,SAAA;EACA,+BAAA;EACA,8BAAA;ApK09fR;AoKv9fM;;EAEE,mBnK5FG;ADqjgBX;AoKr9fI;EACE,WA7G8B;ApKokgBpC;AoKn9fE;EACE,WAAA;EACA,YAlHgC;ApKukgBpC;;AoKh9fE;EACE,6BAAA;ApKm9fJ;AoKj9fI;EACE,8BAAA;ApKm9fN;;AqK7kgBI;EACE,YAL0B;EAM1B,eAAA;ArKglgBN;AqK5kgBE;EACE,kB9J0R0B;APozf9B;AqK5kgBI;EACE,kBpK2EW;ADmggBjB;AqK1kgBE;EACE,erFd8B;AhF0lgBlC;;AiBvhgBI;EoJ7CI;IACE,mBAAA;ErKwkgBR;AACF;AoK59fA;EACE,aAAA;EACA,sBAAA;ApK89fF;;AoK39fA;EACE,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;ApK89fF;;AiBzigBI;EqJtEF;IACE,wBAAA;EtKmngBF;EsKhngBA;IACE,cAAA;EtKkngBF;EsK7mgBE;IACE,yBAAA;EtK+mgBJ;AACF;AuK9ngBA;;EAAA;AAGA;EACE,2BAAA;EACA,qBAAA;EACA,kBAAA;AvKgogBF;;AuK7ngBA;;EAAA;AAGA;EACE,wBAAA;EACA,UAAA;EACA,6DAAA;EACA,YAAA;EACA,mDAAA;EACA,SAAA;EACA,mCAAA;EACA,kBAAA;EACA,UAAA;AvKgogBF;;AuK7ngBA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,WAAA;EACA,mDAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;E1J3BE,mB0J4BqB;EACvB,UAAA;AvKgogBF;;AuK7ngBA;;EAEE,cAAA;EACA,6BAAA;AvKgogBF;;AuK7ngBA;;;;;;EAME,YAAA;AvKgogBF;;AuK7ngBA;;;;EAIE,oCAAA;EACA,YAAA;AvKgogBF;;AuK7ngBA;;EAAA;AAGA;EACE,oCAAA;EACA,kBAAA;EACA,iEAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AvKgogBF;;AuK7ngBA;EACE,oCAAA;EACA,kBAAA;EACA,gEAAA;EACA,UAAA;EACA,0CAAA;EACA,UAAA;EACA,mCAAA;EACA,kBAAA;AvKgogBF;;AuK7ngBA;;EAEE,qCAAA;EACA,YAAA;AvKgogBF;;AuK7ngBA;;EAEE,qCAAA;EACA,WAAA;AvKgogBF;;AuK7ngBA,gBAAA;AACA;EACE;IACE,yBAAA;EvKgogBF;AACF;AuK7ngBA;EACE;IACE,yBAAA;EvK+ngBF;AACF;AuK5ngBA;EACE,kBAAA;EACA,YAAA;AvK8ngBF;;AuKzngBA;EACE,kBAAA;EACA,aAAA;AvK4ngBF;;AuKzngBA;EACE,aAAA;EACA,kBAAA;AvK4ngBF;;AuKzngBA;EACE,aAAA;EACA,kBAAA;AvK4ngBF;;AuKzngBA;EACE,aAAA;EACA,kBAAA;AvK4ngBF;;AuKzngBA;EACE,aAAA;EACA,kBAAA;AvK4ngBF;;AuKzngBA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AvK4ngBF;;AuKzngBA;EACE,kBAAA;AvK4ngBF;AuK1ngBE;EAEE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,cvFvJ8B;EuFwJ9B,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2FAAA;EACA,oHAAA;AvK2ngBJ;AuKxngBE;EACE,SAAA;EACA,SAAA;EAEA,yFAAA;EACA,oHAAA;AvKyngBJ;;AwKlygBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;AxKqygBF;;AwKlygBA;;EAEE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,OAAA;EACA,yBAAA;AxKqygBF;;AwKlygBA;EACE,aAAA;E3JhBE,sBNqO0B;EiKnN5B,iIACQ;AxKoygBV;;AwK/xgBA;EACE,yDAAA;AxKkygBF;;AwK/xgBA;;EAEE,yBAAA;EAGA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AxKkygBF;;AwK/xgBA;;EAEE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,2BAAA;EACA,oBAAA;EACA,uBAAA;AxKkygBF;;AwK/xgBA;;EAEE,cAAA;AxKkygBF;;AwK/xgBA;EACE,eAAA;EACA,cvKjDS;ADm1gBX;;AwK/xgBA;EACE,gBAAA;AxKkygBF;;AwK/xgBA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AxKkygBF;AwKhygBE;EACE,UAAA;EACA,kBAAA;AxKkygBJ;;AwK9xgBA;EACE,yDAAA;AxKiygBF;;AwK9xgBA;;EAEE,cAAA;EACA,YAAA;AxKiygBF;;AwK9xgBA;EACE,WAAA;AxKiygBF;;AwK9xgBA;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,qDAAA;EACA,iBAAA;EACA,eAAA;AxKiygBF;;AwK9xgBA;EACE,cvKzEM;AD02gBR;;AwK9xgBA;;EAEE,WvK5GM;EuK6GN,eAAA;EACA,wBAAA;AxKiygBF;;AwK9xgBA;EACE,eAAA;EACA,cvK5GS;AD64gBX;;AwK9xgBA;EACE,cvKhHS;ADi5gBX;;AwK9xgBA;EACE,OAAA;AxKiygBF;;AwK9xgBA;EACE,gBAAA;AxKiygBF;;AwK9xgBA;EACE,0JAAA;EAEA,aAAA;EACA,sBAAA;AxKiygBF;;AwK9xgBA;EAEE,cAAA;AxKiygBF;;AwK9xgBA;EACE,0BAAA;EACA,gBAAA;AxKiygBF;;AwK9xgBA;;;EAGE,aAAA;AxKiygBF;;AwK9xgBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AxKiygBF;;AwK7xgBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AxKgygBF;;AwK7xgBA;EACE,WAAA;AxKgygBF;;AwK7xgBA;EACE,kBAAA;EACA,mBAAA;AxKgygBF;;AwK7xgBA;EACE,cAAA;AxKgygBF;;AwK7xgBA;EACE,kBAAA;EACA,OAAA;AxKgygBF;;AwK7xgBA;EAEE,aAAA;EAEA,SAAA;EACA,WAAA;AxKgygBF;;AwK7xgBA;EAEE,aAAA;EAEA,cAAA;EACA,eAAA;EACA,cAAA;EAEA,uBAAA;AxKgygBF;;AwK7xgBA;EACE,WAAA;EACA,oBAAA;AxKgygBF;;AwK7xgBA;EAEE,mBAAA;AxKgygBF;;AwK7xgBA;EACE,WAAA;AxKgygBF;;AwK7xgBA;EACE,UAAA;AxKgygBF;;AwK7xgBA;EACE,YAAA;AxKgygBF;;AwK7xgBA;EACE,OAAA;AxKgygBF;;AwK7xgBA;EACE,YAAA;AxKgygBF;;AwK7xgBA;;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,kBAAA;EACA,UAAA;EACA,iDAAA;AxKgygBF;;AwK7xgBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AxKgygBF;;AwK7xgBA;EACE,YAAA;EACA,SAAA;EACA,OAAA;EACA,mBvKhOM;ADgghBR;;AwK7xgBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AxKgygBF;;AwK7xgBA;EACE,SAAA;EACA,iBAAA;AxKgygBF;;AyKxjhBA;;;;;;EAAA;AASA;;EAAA;AAOA;;EAAA;AAYA;;EAAA;AAIA;EACE;IACE,aAAA,EAAA,oBAAA;EzK2ihBF;EyKzihBA;IACE,UAAA;EzK2ihBF;AACF;AyKvihBA;;EAAA;AAIA;EACE,kBAAA;AzKwihBF;;AyKpihBA,sBAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,WA3CY;EA4CZ,QAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;AzKuihBF;;AyKpihBA,iBAAA;AACA;EACE,kBAAA;EACA,UAAA;AzKuihBF;;AyKnihBE;EACE,2BAAA;AzKsihBJ;AyKnihBE;EACE,2BAAA;AzKqihBJ;;AyKjihBA,iBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,8BAAA;EACA,aAAA;EAlEA,sCAAA;AzKumhBF;;AyKjihBA;EACE,cAAA;AzKoihBF;;AyKhihBA;;EAAA;AAIA;;;EA/EE,uEAAA;AzKonhBF;;AyK/hhBA;;;;;;EArFE,oCAAA;AzK6nhBF;;AyK9hhBA;;EAAA;AAKE;EACE,WAAA;AzK+hhBJ;AyK5hhBE;EAEE,YAAA;AzK6hhBJ;AyK1hhBE;EACE,mBAAA;AzK4hhBJ;AyK1hhBI;EACE,UAAA;AzK4hhBN;AyKzhhBI;EAEE,mBAAA;AzK0hhBN;;AyKphhBA;;EAAA;AAKE;EACE,UAAA;AzKqhhBJ;AyKlhhBE;EAEE,SAAA;AzKmhhBJ;AyKhhhBE;EACE,kBAAA;AzKkhhBJ;AyKhhhBI;EACE,UAAA;AzKkhhBN;AyK/ghBI;EAEE,kBAAA;AzKghhBN;;AyK1ghBA;;EAAA;AAIA;EACE,gBAAA;AzK4ghBF;AyK1ghBE;EACE,UAAA;EACA,SAAA;EACA,cAAA;AzK4ghBJ;AyKzghBE;EACE,iBAAA;AzK2ghBJ;AyKzghBI;EACE,UAAA;EACA,SAAA;EACA,aAAA;AzK2ghBN;AyKxghBI;EAEE,iBAAA;AzKyghBN;AyKvghBM;EACE,QAAA;AzKyghBR;;AyKlghBA;;EAAA;AAIA;EACE,gBAAA;AzKoghBF;AyKlghBE;EACE,SAAA;EACA,SAAA;EACA,cAAA;AzKoghBJ;AyKjghBE;EAEE,SAAA;AzKkghBJ;AyK//gBE;EACE,oBAAA;AzKighBJ;AyK//gBI;EACE,UAAA;AzKighBN;AyK9/gBI;EAEE,oBAAA;AzK+/gBN;;AyKz/gBA;;EAAA;AAGA;EACE,gBAAA;AzK4/gBF;AyK1/gBE;EACE,kBAAA;AzK4/gBJ;AyK1/gBE;EACE,UAAA;EACA,cAAA;AzK4/gBJ;AyKx/gBI;EACE,UAAA;EACA,WAAA;AzK0/gBN;AyKx/gBI;EACE,UAAA;EACA,SAAA;AzK0/gBN;;AyKp/gBA;;EAAA;AAGA;EACE,gBAAA;AzKu/gBF;AyKr/gBE;EACE,kBAAA;AzKu/gBJ;AyKr/gBE;EACE,WAAA;EACA,cAAA;EACA,UAAA;AzKu/gBJ;AyKr/gBI;EACE,WAAA;AzKu/gBN;AyKl/gBI;EACE,UAAA;EACA,UAAA;AzKo/gBN;AyKl/gBI;EACE,UAAA;EACA,SAAA;AzKo/gBN;;AyK9+gBA;;EAAA;AAGA;EACE,gBAAA;AzKi/gBF;AyK/+gBE;EACE,kBAAA;AzKi/gBJ;AyK/+gBE;EACE,SAAA;EACA,cAAA;EACA,eAAA;AzKi/gBJ;AyK7+gBI;EACE,UAAA;EACA,SAAA;AzK++gBN;AyK7+gBI;EACE,UAAA;EACA,aAAA;AzK++gBN;;AyKz+gBA;;EAAA;AAGA;EACE,gBAAA;AzK4+gBF;AyK1+gBE;EACE,kBAAA;AzK4+gBJ;AyK1+gBE;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AzK4+gBJ;AyKx+gBI;EACE,UAAA;EACA,QAAA;AzK0+gBN;AyKx+gBI;EACE,UAAA;EACA,aAAA;AzK0+gBN;;AyKp+gBA;;EAAA;AAIA;EACE,gBAAA;AzKs+gBF;;AyKp+gBA;EACE,SAAA;EACA,iBAhWY;EAYZ,qBAsVoB;AzKs+gBtB;;AyKp+gBA;EACE,kBAAA;EACA,qBAAA;AzKu+gBF;;AyKp+gBA;EACE,UAAA;EA9VA,qBAgWoB;AzKs+gBtB;;AyKp+gBA;EACE,UAAA;EACA,cAAA;EApWA,eAsWoB;AzKs+gBtB;;AyKl+gBA;;EAAA;AAIA;EACE,gBAAA;AzKo+gBF;;AyKl+gBA;EACE,SAAA;EACA,kBAAA;EAnXA,qBAqXoB;AzKo+gBtB;;AyKl+gBA;EACE,kBAAA;EACA,qBAAA;AzKq+gBF;;AyKl+gBA;EACE,UAAA;EA7XA,qBA+XoB;AzKo+gBtB;;AyKl+gBA;EACE,UAAA;EACA,cAAA;EAnYA,eAqYoB;AzKo+gBtB;;AyKh+gBA;;EAAA;AAIA;EACE,gBAAA;EACA,YAAA;AzKk+gBF;;AyKh+gBA;EACE,SAAA;EACA,cAAA;AzKm+gBF;;AyKh+gBA;EACE,kBAAA;EACA,WAAA;AzKm+gBF;;AyKj+gBA;EACE,UAAA;AzKo+gBF;;AyKl+gBA;EACE,UAAA;AzKq+gBF;;AyKh+gBA;;EAAA;AAIA;EACE,gBAAA;EACA,YAAA;EAEA,+CAAA;AzKi+gBF;;AyK/9gBA;EACE,SAAA;EACA,cAAA;AzKk+gBF;;AyK/9gBA;EACE,kBAAA;EACA,WAAA;EAEA,+CAAA;EACA,iDAAA;AzKi+gBF;;AyK/9gBA;EACE,UAAA;AzKk+gBF;;AyKh+gBA;EACE,UAAA;AzKm+gBF;;AyK/9gBA;EACE,oBAAA;AzKk+gBF;;A0K57hBA;;;;;;EAAA;ACCA;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0BAAA;EACA,kCAAA;EAGA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;A3Kk8hBF;A2Kh8hBE;EAKI,YDP2B;A1Kq8hBjC;A2Kz7hBI;EAKI,YDjByB;A1Kw8hBjC;A2Kn7hBI;;;EAGE,yB1KEE;ADm7hBR;;A2Kh7hBA;EACE,WDnC+B;ECoC/B,YAAA;EACA,qBAAA;EACA,kBAAA;A3Km7hBF;;A2Kh7hBA;EACE,cAAA;EACA,QAAA;EACA,gBAAA;A3Km7hBF;A2Kj7hBE;EAGE,WDjD6B;ECkD7B,WDjD6B;ECkD7B,yB1KpBI;E0KqBJ,mBDhD6B;ECiD7B,kBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;A3Ki7hBJ;A2K96hBE;EAEE,WAAA;EACA,cAAA;A3K+6hBJ;A2K56hBE;EACE,SAAA;A3K86hBJ;A2K36hBE;EACE,YAAA;A3K66hBJ;;A4K//hBE;;EAAA;AAIE;EACE,QAAA;EACA,2BAAA;EACA,kEAAA;A5KigiBN;A4K//hBM;EACE,QAAA;EACA,sCAAA;A5KigiBR;A4K9/hBM;EACE,SAAA;EACA,mEAAA;A5KggiBR;A4K3/hBM;EAGE,gDAAA;EACA,wBAAA;A5K2/hBR;A4Kz/hBQ;EACE,oBAAA;EACA,UAAA;A5K2/hBV;A4Kx/hBQ;EACE,mDAAA;EACA,wBAAA;A5K0/hBV;;A6K3hiBA;EACE,gB5KWM;E4KVN,kBAAA;EACA,e7FCgC;AhF6hiBlC;A6K5hiBE;EACE,mB5KoFW;E4KnFX,c5KYO;E4KXP,SAAA;EACA,mB5KIO;E4KHP,uBAAA;EACA,gCAAA;EACA,6BAAA;A7K8hiBJ;A6K5hiBI;EACE,aAAA;A7K8hiBN;A6K1hiBE;EACE,e7FhB8B;AhF4iiBlC;A6KzhiBE;EACE,aAAA;A7K2hiBJ;;A6KvhiBA;EhKzBI,mBgK0BqB;EACvB,gB5KlBM;E4KmBN,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,mDtK2M4B;EsK1M5B,WAAA;A7K0hiBF;A6KxhiBE;EACE,eAAA;A7K0hiBJ;;A8KnkiBA;EACE,YAAA;EACA,gBAAA;A9KskiBF;;A8KnkiBA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,avK6pBkC;EuK5pBlC,sBvKKS;EuKJT,uBAAA;A9KskiBF;;A8KnkiBA;EACE,sB7KHM;E6KIN,UAAA;EACA,avK8GO;EM5HL,sBNqO0B;EuKrN5B,kBAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,4L7K0FsB;AD4+hBxB;A8KpkiBE;EACE,c7KZO;E6KaP,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;A9KskiBJ;A8KnkiBE;EACE,c7KxBO;E6KyBP,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;A9KqkiBJ;A8KlkiBE;EACE,YAAA;EACA,kBAAA;A9KokiBJ;A8KjkiBE;EACE,yB7K1CO;E6K2CP,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,2CAAA;A9KmkiBJ;A8KjkiBI;EACE,eAAA;EACA,iBAAA;EACA,2CAAA;A9KmkiBN;A8KhkiBI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yB7K3BA;E6K4BA,W7K/DE;E6KgEF,iBAAA;EACA,kBAAA;EACA,iBAAA;A9KkkiBN;A8K/jiBI;EACE,qBAAA;A9KikiBN;A8K7jiBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EAEA,qBAAA;EAEA,yBAAA;EAEA,oBAAA;A9K+jiBJ;A8K7jiBI;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yB7KzDA;E6K0DA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;A9K+jiBN;A8K5jiBI;EAEE,yBAAA;A9K8jiBN;A8K3jiBI;EAEE,wBAAA;A9K6jiBN;A8K1jiBI;EACE,UAAA;EAEA,mBAAA;A9K4jiBN;A8KxjiBE;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CAAA;EACA,eAAA;EACA,aAAA;EAEA,oBAAA;A9K0jiBJ;A8KvjiBE;EACE,aAAA;EACA,2BAAA;EACA,yBAAA;A9KyjiBJ;A8KtjiBE;EACE,cAAA;A9KwjiBJ;A8KrjiBE;EACE,qBAAA;EACA,kBAAA;A9KujiBJ;A8KpjiBE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;A9KsjiBJ;A8KnjiBE;EACE,qBAAA;EACA,gBvK4G0B;EuK3G1B,kBAAA;EACA,mBAAA;EACA,kB7KxFa;E6KyFb,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EpJhFF,yBAAA;ElB0BI,kBAtCa;EkBcjB,gBnByL4B;EM3R1B,sBNqO0B;EkKrN5B,gGAAA;E/IfA,WAAA;EFAE,yBvBsCI;EyBpCN,qBzBoCM;ADssiBR;AGtuiBE;EuBAE,WAAA;EFNA,qEED2D;EAS3D,gEATqG;A1BkviBzG;A0BtuiBE;EAMI,uDAAA;A1BmuiBN;A0B9tiBE;EAEE,WAAA;EACA,yBzBaI;EyBZJ,qBzBYI;ADmtiBR;A0BxtiBE;EAGE,WAAA;EACA,oEAtC+I;EA0C/I,iEA1CyL;A1B+viB7L;A0BntiBI;EAKI,uDAAA;A1BitiBR;AGvviBE;E2K4KI,qBAAA;A9K8kiBN;A8K3kiBI;EAEE,UAAA;EACA,gB7KjGiB;AD6qiBvB;A8KxkiBI;EAEE,avKuOwB;APk2hB9B;A8KpkiBE;EACE,gBvK6E0B;EuK5E1B,c5DqMS;E4DpMT,6BAAA;EACA,yBAAA;EACA,oBAAA;A9KskiBJ;AG5wiBE;E2KyMI,0D5DgMa;E4D/Lb,0BvKxCoC;EuKyCpC,6BAAA;EACA,yBAAA;A9KskiBN;A8KnkiBI;EAIE,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;A9KkkiBN;A8K/jiBI;EAEE,cvK1NK;EuK2NL,oBAAA;A9KgkiBN;A8K5jiBE;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;A9K8jiBJ;A8K3jiBE;EACE,2BAAA;A9K6jiBJ;A8K1jiBE;EACE,oBAAA;A9K4jiBJ;A8KzjiBE;EACE,iBAAA;A9K2jiBJ;;A8KtjiBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;A9KyjiBF;A8KvjiBE;EACE,qB7K3NE;ADoxiBN;A8KvjiBI;EACE,kBAAA;EACA,cAAA;A9KyjiBN;A8KtjiBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yB7KtOA;E6KuOA,cAAA;EACA,SAAA;EACA,kBAAA;A9KwjiBN;A8KtjiBM;EAEE,wBAAA;EACA,UAAA;A9KwjiBR;A8KrjiBM;EAEE,yBAAA;EACA,WAAA;A9KujiBR;A8KljiBE;EACE,qB7KxPK;AD4yiBT;A8KljiBI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EAEA,kBAAA;EACA,iBAAA;EACA,yB7KnQG;ADuziBT;A8KjjiBI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EAEA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,yB7K/QG;ADk0iBT;A8K/iiBE;EACE,qB7KjRG;ADk0iBP;A8K/iiBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yB7K5RC;AD60iBP;A8K9iiBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,yB7KvSC;ADu1iBP;A8K5iiBE;EACE,qB7K9SI;AD41iBR;A8K5iiBI;EAEE,WAAA;EAEA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gB7K9VE;E6KgWF,wBAAA;A9K6iiBN;A8K1iiBI;EAEE,8BAAA;EACA,SAAA;EACA,WAAA;EAEA,yBAAA;EAEA,2BAAA;A9K4iiBN;A8KziiBI;EAEE,8BAAA;EACA,UAAA;EACA,UAAA;EAEA,yBAAA;EAEA,wBAAA;A9K2iiBN;A8KxiiBI;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;A9K0iiBN;A8KviiBI;EACE,UAAA;EACA,YAAA;EACA,sB7K1YE;E6K2YF,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEA,yBAAA;A9KyiiBN;A8KtiiBI;EACE,WAAA;EACA,yB7K/WE;E6KgXF,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;A9KwiiBN;A8KtiiBM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEA,wBAAA;A9KwiiBR;A8KriiBM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEA,yBAAA;A9KuiiBR;A8KliiBE;EACE,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,4BAAA;A9KoiiBJ;;A8KhiiBA;EACE;IACE,WAAA;IACA,cAAA;IACA,eAAA;IACA,UAAA;IACA,WAAA;E9KmiiBF;AACF;A8KhiiBA;;EAAA;AAsBA;EACE;IACE,qBAAA;IACA,6BAAA;E9KiiiBF;E8K/hiBA;IACE,sBAAA;IACA,8BAAA;E9KiiiBF;E8K/hiBA;IACE,sBAAA;IACA,8BAAA;E9KiiiBF;E8K/hiBA;IACE,mBAAA;IACA,2BAAA;E9KiiiBF;AACF;A8KnhiBA;EACE;IACE,mBAAA;IACA,2BAAA;E9K+hiBF;E8K7hiBA;IACE,qBAAA;IACA,6BAAA;E9K+hiBF;AACF;A8KnhiBA;EACE;IACE,OAAA;E9K6hiBF;E8K3hiBA;IACE,QAAA;E9K6hiBF;AACF;A8KjhiBA;EACE;IACE,QAAA;E9K2hiBF;E8KzhiBA;IACE,OAAA;E9K2hiBF;AACF;A8K/giBA;EACE;IACE,QAAA;E9KyhiBF;E8KvhiBA;IACE,QAAA;E9KyhiBF;AACF;A8K7giBA;EACE;IACE,QAAA;E9KuhiBF;E8KrhiBA;IACE,QAAA;E9KuhiBF;AACF;A8KphiBA;EAEE,8BAAA;A9KshiBF;;A8KnhiBA;EAEE,eAAA;A9KshiBF;;A8KnhiBA;EAEE,4BAAA;A9KshiBF;;A8KnhiBA;EAEE,+BAAA;A9KshiBF;;A8KnhiBA;EAEE,8BAAA;A9KshiBF;;A8KnhiBA;EAEE,eAAA;A9KshiBF;;A8KnhiBA;EAEE,0BAAA;A9KshiBF;;A8KnhiBA;EAEE,6BAAA;A9KshiBF;A8Kv/hBA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;E9KqhiBF;E8KnhiBA;IACE,QAAA;IACA,SAAA;IACA,SAAA;E9KqhiBF;E8KnhiBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E9KqhiBF;E8KnhiBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E9KqhiBF;E8KnhiBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E9KqhiBF;AACF;A8K3/hBA;EACE;IACE,QAAA;IACA,WAAA;IACA,SAAA;E9KmhiBF;E8KjhiBA;IACE,QAAA;IACA,WAAA;IACA,SAAA;E9KmhiBF;E8KjhiBA;IACE,WAAA;IACA,QAAA;IACA,SAAA;E9KmhiBF;E8KjhiBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E9KmhiBF;AACF;A8K7/hBA;EACE;IACE,yBAAA;IACA,iCAAA;E9KihiBF;E8K/giBA;IACE,yBAAA;IACA,iCAAA;E9KihiBF;E8K/giBA;IACE,0BAAA;IACA,kCAAA;E9KihiBF;E8K/giBA;IACE,0BAAA;IACA,kCAAA;E9KihiBF;AACF;A8K9giBA;EAEE,kCAAA;A9KghiBF;;A8K7giBA;EAEE,mCAAA;A9KghiBF;;A8K7giBA;EAEE,0CAAA;A9KghiBF;A8KhgiBA;EACE;IACE,0BAAA;IACA,kCAAA;IACA,UAAA;E9K+giBF;E8K7giBA;IACE,wBAAA;IACA,gCAAA;IACA,UAAA;E9K+giBF;AACF;A8K5giBA;EAEE,gCAAA;A9K8giBF;A8Kj/hBA;EACE;IACE,qBAAA;IACA,6BAAA;IACA,gBAAA;IACA,UAAA;E9K6giBF;E8K3giBA;IACE,qBAAA;IACA,6BAAA;IACA,gBAAA;IACA,UAAA;E9K6giBF;E8K3giBA;IACE,sBAAA;IACA,8BAAA;IACA,gBAAA;E9K6giBF;E8K3giBA;IACE,mBAAA;IACA,2BAAA;IACA,aAAA;IACA,UAAA;E9K6giBF;AACF;A8K1giBA;EAEE,4BAAA;A9K4giBF;A8KhgiBA;EACE;IACE,qBAAA;E9K2giBF;E8KzgiBA;IACE,qB7K30BK;EDs1jBP;AACF;A8KxgiBA;EAEE,gDAAA;A9K0giBF;A8K9/hBA;EACE;IACE,yBAAA;E9KygiBF;E8KvgiBA;IACE,yB7Kl2BK;ED22jBP;AACF;A8KtgiBA;EAEE,mDAAA;A9KwgiBF;A8K5/hBA;EACE;IACE,uBAAA;E9KugiBF;E8KrgiBA;IACE,yBAAA;E9KugiBF;AACF;A8KpgiBA,oEAAA;AACA,gCAAA;AACA,2EAAA;AACA,eAAA;AACA;EACE,gCAAA;A9KsgiBF;;A8KlgiBA;EACE,iCAAA;A9KqgiBF;;A8KjgiBA,iBAAA;AACA;EACE,6BAAA;A9KogiBF;;A8KhgiBA;EACE,gCAAA;A9KmgiBF;;A8K//hBA;EACE,iCAAA;A9KkgiBF;;A8K9/hBA;;;;EAAA;AAKA;;EAEE,kBAAA;EAGA,sBAAA;A9KigiBF;;A8K9/hBA;EACE,cAAA;EACA,YAAA;EACA,WAAA;A9KigiBF;;A8K9/hBA;EACE,WAAA;A9KigiBF;;A8K9/hBA;EACE,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,4BAAA;A9KigiBF;;A8K9/hBA;EACE,WAAA;EACA,YAAA;A9KigiBF;;A8K9/hBA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EAIA,4CAAA;A9KigiBF;;A8K9/hBA;EAIE,uBAAA;A9KigiBF;;A8K9/hBA;EAIE,uBAAA;A9KigiBF;;A8K9/hBA;EAIE,oBAAA;A9KigiBF;;A8K9/hBA;EACE,WAAA;EACA,WAAA;A9KigiBF;;A8K9/hBA;EACE,UAAA;EACA,WAAA;EACA,WAAA;A9KigiBF;;A8K9/hBA;EACE,YAAA;EACA,YAAA;A9KigiBF;;A8K9/hBA;EACE,WAAA;EACA,YAAA;EACA,WAAA;A9KigiBF;;A8K9/hBA;EACE,YAAA;EACA,YAAA;A9KigiBF;;A8K9/hBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;A9KigiBF;;A8K9/hBA;;EAAA;AA0FA;EACE;IACE,UAAA;IAIA,4BAAA;E9K8/hBF;E8K5/hBA;IACE,YAAA;E9K8/hBF;E8K5/hBA;IACE,UAAA;IAIA,wBAAA;E9K8/hBF;E8K5/hBA;IACE,UAAA;IAIA,wBAAA;E9K8/hBF;E8K5/hBA;IACE,YAAA;E9K8/hBF;E8K5/hBA;IACE,UAAA;IAIA,2BAAA;E9K8/hBF;AACF;A+K7qkBA;EACI,aCgBS;EDfT,eAAA;EACA,UAAA;EACA,YCHa;EDIb,sBAAA;EACA,W9KQI;ADuqkBR;A+K9qkBI;EACI,SxKyHC;EwKxHD,UxKwHC;APwjkBT;A+K9qkBI;EACI,SxKqHC;EwKpHD,SAAA;EACA,mBAAA;A/KgrkBR;A+K9qkBI;EACI,SxKgHC;EwK/GD,WxK+GC;APikkBT;A+K9qkBI;EACI,YxK4GC;EwK3GD,UxK2GC;APqkkBT;A+K9qkBI;EACI,YxKwGC;EwKvGD,SAAA;EACA,mBAAA;A/KgrkBR;A+K9qkBI;EACI,YxKmGC;EwKlGD,WxKkGC;AP8kkBT;;A+K5qkBA;EACI;IACI,YAAA;IACA,UAAA;IACA,OAAA;IACA,SAAA;E/K+qkBN;E+K9qkBM;IAGI,MAAA;E/K8qkBV;E+K5qkBM;IAGI,SAAA;E/K4qkBV;E+K1qkBM;IACE,QAAA;IACA,UAAA;IAAA,aAAA;E/K4qkBR;AACF;AiLlukBA;EACI,kBAAA;EACA,gBDCkB;ECAlB,sBAAA;EACA,mBAAA;EACA,a1K4HK;EM5HL,sBNqO0B;E0KnO1B,0UhLwGiB;EgLvGjB,aAAA;EACA,8BAAA;EACA,iBDNkB;ECOlB,gBAAA;EACA,uBDIa;ECHb,eAAA;EACA,cAAA;AjLoukBJ;AiLnukBI;EACI,cAAA;AjLqukBR;AiLnukBI;EACI,gBDZW;ECaX,chLCG;EAoJT,sMAAA;ADilkBF;AiLnukBI;EACI,mBhL8BD;EAmHL,0MAAA;ADqlkBF;AiLnukBI;EACI,mBhLwBA;EAqHN,0MAAA;ADylkBF;AiLnukBI;EACI,mBhLmBC;EAsHP,0MAAA;AD6lkBF;AiLnukBI;EACI,mBhLaF;EAwHJ,sMAAA;ADimkBF;AiLnukBI;EACI,cAAA;EACA,mBAAA;AjLqukBR;;AiLjukBA;EACE;IACE,gBAAA;EjLoukBF;AACF;AkLpxkBA;EACE,WjLaM;EiLZN,eAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AlLsxkBF;AkLrxkBE;EACE,WAAA;EACA,YAAA;AlLuxkBJ;AkLpxkBE;EAEE,UAAA;AlLqxkBJ;;AmLzykBA;EACE;IACE,UAAA;EnL4ykBF;EmL1ykBA;IACE,QAAA;EnL4ykBF;AACF;AmLzykBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,aHEW;EGDX,2CAAA;EACA,0CAAA;EtKZE,sBNqO0B;APmlkB9B;AmLzykBE;EACE,QAAA;EACA,UAAA;EAAA,aAAA;AnL2ykBJ;AmLzykBE;EACE,mBlLmBI;ADwxkBR;AoLh0kBA;EACI;IAJA,8DAAA;EpLu0kBF;EoL5zkBE;IACI,UAAA;IACA,oCAAA;EpL8zkBN;EoL5zkBE;IACI,UAAA;IACA,mCAAA;EpL8zkBN;EoL5zkBE;IACI,kCAAA;EpL8zkBN;EoL5zkBE;IACI,kCAAA;EpL8zkBN;EoL5zkBE;IACI,eAAA;EpL8zkBN;AACF;AoL3zkBA;EACI;IACI,UAAA;IACA,mCAAA;EpL6zkBN;EoL3zkBE;IACI,UAAA;IACA,oCAAA;EpL6zkBN;AACF;AoL1zkBA;EACI;IA1CA,8DAAA;EpLu2kBF;EoLtzkBE;IACI,UAAA;IACA,qCAAA;EpLwzkBN;EoLtzkBE;IACI,UAAA;IACA,kCAAA;EpLwzkBN;EoLtzkBE;IACI,mCAAA;EpLwzkBN;EoLtzkBE;IACI,iCAAA;EpLwzkBN;EoLtzkBE;IACI,eAAA;EpLwzkBN;AACF;AoLrzkBA;EACI;IACI,UAAA;IACA,kCAAA;EpLuzkBN;EoLrzkBE;IACI,UAAA;IACA,qCAAA;EpLuzkBN;AACF;AoLpzkBA;EACI;IAhFA,8DAAA;EpLu4kBF;EoLhzkBE;IACI,UAAA;IACA,oCAAA;EpLkzkBN;EoLhzkBE;IACI,UAAA;IACA,mCAAA;EpLkzkBN;EoLhzkBE;IACI,kCAAA;EpLkzkBN;EoLhzkBE;IACI,kCAAA;EpLkzkBN;EoLhzkBE;IACI,+BAAA;EpLkzkBN;AACF;AoL/ykBA;EACI;IACI,mCAAA;EpLizkBN;EoL/ykBE;IAEI,UAAA;IACA,kCAAA;EpLgzkBN;EoL9ykBE;IACI,UAAA;IACA,qCAAA;EpLgzkBN;AACF;AoL7ykBA;EACI;IA1HA,8DAAA;EpL06kBF;EoLzykBE;IACI,UAAA;IACA,qCAAA;EpL2ykBN;EoLzykBE;IACI,UAAA;IACA,kCAAA;EpL2ykBN;EoLzykBE;IACI,mCAAA;EpL2ykBN;EoLzykBE;IACI,iCAAA;EpL2ykBN;EoLzykBE;IACI,eAAA;EpL2ykBN;AACF;AoLxykBA;EACI;IACI,kCAAA;EpL0ykBN;EoLxykBE;IAEI,UAAA;IACA,mCAAA;EpLyykBN;EoLvykBE;IACI,UAAA;IACA,oCAAA;EpLyykBN;AACF;AoLrykBI;EAEI,sCAAA;ApLsykBR;AoLpykBI;EAEI,uCAAA;ApLqykBR;AoLnykBI;EACI,sCAAA;ApLqykBR;AoLnykBI;EACI,oCAAA;ApLqykBR;;AoLhykBI;EAEI,uCAAA;ApLkykBR;AoLhykBI;EAEI,wCAAA;ApLiykBR;AoL/xkBI;EACI,qCAAA;ApLiykBR;AoL/xkBI;EACI,uCAAA;ApLiykBR;;AqLn+kBA;EACI;IACI,UAAA;IACA,iCAAA;ErLs+kBN;EqLp+kBE;IACI,UAAA;ErLs+kBN;AACF;AqLn+kBA;EACI;IACI,UAAA;ErLq+kBN;EqLn+kBE;IACI,UAAA;IACA,iCAAA;ErLq+kBN;EqLn+kBE;IACI,UAAA;ErLq+kBN;AACF;AqLl+kBA;EACI,gCAAA;ArLo+kBJ;;AqLj+kBA;EACI,iCAAA;ArLo+kBJ;;AsLhglBA;EACI;IACI,sDAAA;IACA,kCAAA;IACA,UAAA;EtLmglBN;EsLjglBE;IACI,uDAAA;IACA,kCAAA;EtLmglBN;EsLjglBE;IACI,sDAAA;IACA,UAAA;EtLmglBN;EsLjglBE;IACI,sDAAA;EtLmglBN;EsLjglBE;IACI,6BAAA;EtLmglBN;AACF;AsLhglBA;EACI;IACI,6BAAA;EtLkglBN;EsLhglBE;IACI,uDAAA;IACA,UAAA;EtLkglBN;EsLhglBE;IACI,sDAAA;IACA,UAAA;EtLkglBN;AACF;AsL//kBA;EACI,gCAAA;AtLiglBJ;;AsL9/kBA;EACI,iCAAA;AtLiglBJ;;AuLtilBA;EACI;IACI,kCAAA;IACA,mBAAA;EvLyilBN;EuLvilBE;IARA,+BAAA;EvLkjlBF;AACF;AuLtilBA;EACI;IACI,mCAAA;IACA,mBAAA;EvLwilBN;EuLtilBE;IAlBA,+BAAA;EvL2jlBF;AACF;AuLrilBA;EACI;IACI,kCAAA;IACA,mBAAA;EvLuilBN;EuLrilBE;IA5BA,+BAAA;EvLoklBF;AACF;AuLpilBA;EACI;IACI,mCAAA;IACA,mBAAA;EvLsilBN;EuLpilBE;IAtCA,+BAAA;EvL6klBF;AACF;AuLnilBA;EACI;IA5CA,+BAAA;EvLkllBF;EuLnilBE;IACI,kBAAA;IACA,kCAAA;EvLqilBN;AACF;AuLlilBA;EACI;IAtDA,+BAAA;EvL2llBF;EuLlilBE;IACI,kBAAA;IACA,mCAAA;EvLoilBN;AACF;AuLjilBA;EACI;IAhEA,+BAAA;EvLomlBF;EuLjilBE;IACI,kBAAA;IACA,mCAAA;EvLmilBN;AACF;AuLhilBA;EACI;IA1EA,+BAAA;EvL6mlBF;EuLhilBE;IACI,kBAAA;IACA,oCAAA;EvLkilBN;AACF;AuL9hlBI;EAEI,qCAAA;AvL+hlBR;AuL7hlBI;EAEI,sCAAA;AvL8hlBR;AuL5hlBI;EACI,qCAAA;AvL8hlBR;AuL5hlBI;EACI,mCAAA;AvL8hlBR;;AuLzhlBI;EAEI,sCAAA;AvL2hlBR;AuLzhlBI;EAEI,uCAAA;AvL0hlBR;AuLxhlBI;EACI,oCAAA;AvL0hlBR;AuLxhlBI;EACI,sCAAA;AvL0hlBR;;AwL5olBA,oBAAA;AACA;;EAEE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AxL+olBF;;AwL5olBA;EACE,eAAA;AxL+olBF;;AwL5olBA,eAAA;AACA;EACE,kBAAA;EACA,sBAAA;EACA,YjL+5BkC;APgvjBpC;;AwL5olBA,iBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,gBvLfM;EuLgBN,4LvL0FsB;EYnHpB,sBNqO0B;EiL1M5B,uBAAA;AxL+olBF;;AwL5olBA;EACE,aAAA;AxL+olBF;;AwL5olBA,uBAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AxL+olBF;;AwL5olBA;;EAEE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,mBvLvCS;EuLwCT,mBAAA;EACA,2BAAA;AxL+olBF;;AwL5olBA;EACE,wBAAA;AxL+olBF;;AwL5olBA;EACE,yBAAA;AxL+olBF;;AwL5olBA;;EAEE,mBvLnDS;ADkslBX;;AwL5olBA,eAAA;AAEA;EACE;IACE,UAAA;ExL8olBF;AACF;AwL3olBA;EACE,wCAAA;AxL6olBF;;AwL1olBA;EACE;IACE,UAAA;ExL6olBF;AACF;AwL1olBA;EACE,yCAAA;AxL4olBF;;AwLzolBA;EACE;IACE,iCAAA;ExL4olBF;AACF;AwLzolBA;EACE,6DAAA;AxL2olBF;;AwLxolBA;EACE;IACE,iCAAA;ExL2olBF;AACF;AwLxolBA;EACE,gCAAA;AxL0olBF;;AwLvolBA;EACE;IACE,oCAAA;ExL0olBF;AACF;AwLvolBA;EACE,kEAAA;AxLyolBF;;AwLtolBA;EACE;IACE,oCAAA;ExLyolBF;AACF;AwLtolBA;EACE,qCAAA;AxLwolBF;;AwLrolBA,oBAAA;AAEA;EACE;IACE,oCAAA;ExLuolBF;AACF;AwLpolBA;EACE,kEAAA;AxLsolBF;;AwLnolBA;EACE;IACE,oCAAA;ExLsolBF;AACF;AwLnolBA;EACE,qCAAA;AxLqolBF;;AwLlolBA,qBAAA;AAEA;EACE;IACE,mCAAA;ExLoolBF;AACF;AwLjolBA;EACE,mEAAA;AxLmolBF;;AwLholBA;EACE;IACE,mCAAA;ExLmolBF;AACF;AwLholBA;EACE,sCAAA;AxLkolBF;;AwL/nlBA,kBAAA;AAEA;EACE;IACE,mCAAA;ExLiolBF;AACF;AwL9nlBA;EACE,gEAAA;AxLgolBF;;AwL7nlBA;EACE;IACE,mCAAA;ExLgolBF;AACF;AwL7nlBA;EACE,mCAAA;AxL+nlBF;;AwL5nlBA,eAAA;AAEA;EACE;IACE,sDAAA;ExL8nlBF;EwL5nlBA;IACE,uDAAA;ExL8nlBF;EwL5nlBA;IACE,6BAAA;ExL8nlBF;AACF;AwL3nlBA;EACE,wCAAA;EACA,uCAAA;AxL6nlBF;;AwL1nlBA;EACE;IACE,6BAAA;ExL6nlBF;EwL3nlBA;IACE,uDAAA;ExL6nlBF;EwL3nlBA;IACE,sDAAA;ExL6nlBF;AACF;AwL1nlBA;EACE,gCAAA;EACA,uCAAA;AxL4nlBF;;AwLznlBA,iBAAA;AAEA;EACE;IACE,4DAAA;ExL2nlBF;AACF;AwLxnlBA;EACE,kCAAA;EACA,wBAAA;AxL0nlBF;;AwLvnlBA;EACE;IACE,2DAAA;ExL0nlBF;AACF;AwLvnlBA;EACE,kCAAA;EACA,wBAAA;AxLynlBF;;AwLtnlBA,eAAA;AAEA;EACE;IACE,2BAAA;ExLwnlBF;AACF;AwLrnlBA;EACE,6DAAA;AxLunlBF;;AwLpnlBA;EACE;IACE,8BAAA;ExLunlBF;EwLrnlBA;IACE,6BAAA;ExLunlBF;AACF;AwLpnlBA;EACE,gCAAA;AxLsnlBF;;AyLp5lBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AzLu5lBF;;AyLp5lBA;EACE,aAAA;EACA,mBAAA;EAEA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AzLu5lBF;;AyLp5lBA;EAEE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,qCAAA;AzLu5lBF;;AyLp5lBA;EACE,UAAA;EACA,WAAA;AzLu5lBF;;AyLp5lBA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;AzLu5lBF;;AyLp5lBA;EACE,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;AzLu5lBF;;AyLp5lBA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;AzLu5lBF;;AyLp5lBA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,gEAAA;EACA,WAAA;EACA,UAAA;AzLu5lBF;;AyLp5lBA;EACE;IACE,QAAA;IACA,YAAA;EzLu5lBF;EyLr5lBA;IACE,QAAA;IACA,YAAA;EzLu5lBF;EyLr5lBA;IACE,WAAA;IACA,UAAA;EzLu5lBF;AACF;AyLp5lBA;EACE,qBAAA;AzLs5lBF;;A0L5+lBA,WAAA;AAEA;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EAEA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;A1L8+lBF;;A0L1+lBE;EACE,gBAAA;A1L6+lBJ;A0L3+lBI;EACE,WAAA;A1L6+lBN;A0L1+lBI;EACE,YAAA;A1L4+lBN;;A0Lt+lBE;EACE,gBAAA;EACA,cAAA;A1Ly+lBJ;;A0Lp+lBE;EACE,UAAA;EACA,mBAAA;EACA,sBAAA;A1Lu+lBJ;A0Lp+lBE;EACE,WAAA;A1Ls+lBJ;A0Ll+lBE;EACE,YAAA;A1Lo+lBJ;A0L/9lBI;EACE,UAAA;A1Li+lBN;;A0L59lBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;A1L+9lBF;A0L79lBE;EACE,aAAA;A1L+9lBJ;A0L59lBE;EACE,eAAA;EACA,YAAA;A1L89lBJ;;A0L19lBA;;EAME,+BAAA;A1L69lBF;;A0L19lBA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A1L69lBF;A0L39lBE;EAEE,WAAA;EACA,cAAA;A1L49lBJ;A0Lz9lBE;EACE,WAAA;A1L29lBJ;A0Lx9lBE;EACE,kBAAA;A1L09lBJ;;A0Lt9lBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;A1Ly9lBF;A0Lx9lBE;EACE,YAAA;A1L09lBJ;A0Lx9lBE;EACE,cAAA;A1L09lBJ;A0Lx9lBE;EACE,aAAA;A1L09lBJ;A0Lr+lBA;EAcE,aAAA;A1L09lBF;A0Lx9lBE;EACE,oBAAA;A1L09lBJ;A0Lv9lBE;EACE,cAAA;A1Ly9lBJ;A0Lt9lBE;EACE,kBAAA;A1Lw9lBJ;A0Lr9lBE;EACE,cAAA;EACA,YAAA;EACA,6BAAA;A1Lu9lBJ;;A0Ln9lBA;EACE,aAAA;A1Ls9lBF;;A2L/lmBA,WAAA;AAEA;;EAEE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,c1LFS;E0LGT,QAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,0U1LmFmB;E0LlFnB,oBAAA;EACA,+BAAA;E9KzBE,mB8K0BqB;EACvB,gB1LlBM;E0LmBN,UAAA;EACA,gBAAA;A3LimmBF;A2L/lmBE;;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;A3LkmmBJ;A2L/lmBE;;;EACE,aAAA;EACA,4CpLqM0B;EoLpM1B,c1LFI;ADqmmBR;A2LhmmBE;;EACE,aAvCuB;A3L0omB3B;;A2L/lmBA;EACE,OAAA;A3LkmmBF;A2LjmmBE;EACE,gBAlDmB;A3LqpmBvB;;A2L9lmBA;EACE,QAAA;A3LimmBF;A2LhmmBE;EACE,gBA3DmB;A3L6pmBvB;;A2L9lmBA,SAAA;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;A3LgmmBF;A2L/lmBE;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;A3LimmBJ;A2L/lmBI;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mB1LjDE;E0LkDF,eAAA;EACA,kBAAA;E9K1FF,mB8K2FyB;EACvB,kBAAA;A3LimmBN;A2L/lmBM;EACE,WAAA;EACA,kBAAA;EACA,gB1LxFA;E0LyFA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;E9KvGJ,mB8KwG2B;A3LimmB/B;A2L7lmBI;EACE,qBAAA;A3L+lmBN;;A2L1lmBA;EACE,qBAAA;A3L6lmBF;;A2LzlmBE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;A3L4lmBJ;A2LzlmBE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;A3L2lmBJ;A2LzlmBI;EACE,kBpLsJwB;EoLrJxB,mBAAA;EACA,qB3G7I4B;AhFwumBlC;A2LxlmBI;EACE,epLiIwB;EoLhIxB,YAAA;A3L0lmBN;;A2LllmBE;EACE,kBAAA;EACA,YAAA;A3LqlmBJ;A2LnlmBI;EACE,qCAAA;A3LqlmBN;A2LjlmBE;;EAEE,uBAAA;EACA,W1L3JI;E0L4JJ,+BAAA;A3LmlmBJ;A2LjlmBI;;EACE,qCAAA;A3LolmBN;A2LhlmBE;EACE,WAAA;A3LklmBJ;A2L/kmBE;EACE,UAAA;A3LilmBJ;A2L9kmBE;EACE,W1L5KI;AD4vmBR;;A4L1wmBA;EACE,kBAAA;A5L6wmBF;;A4L1wmBA;EACE,qBAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;A5L6wmBF;;A4L1wmBA;EACE,kBAAA;EACA,eAAA;A5L6wmBF;;A4L1wmBA;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;A5L6wmBF;;A4L1wmBA;EACE,aAAA;A5L6wmBF;;A4L1wmBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;A5L6wmBF;;A4L1wmBA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;A5L6wmBF;;A4L1wmBA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;A5L4wmBF;;A4LxwmBE;EACE,wBAAA;A5L2wmBJ;;A6Lv0mBA;EACE,0U5L0GmB;ADgumBrB;A6Lx0mBE;EACE,sBAAA;EACA,YAAA;A7L00mBJ;A6Lx0mBI;EACE,etLi2B8B;APy+kBpC;A6Lt0mBM;EACE,qBtL41B4B;AP4+kBpC;A6Ln0mBE;EACE,+BAAA;A7Lq0mBJ;A6Ln0mBI;EACE,UAAA;A7Lq0mBN;A6Lh0mBI;EhLjBA,8BN6N0B;EM5N1B,+BN4N0B;EsL1MxB,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;A7Lm0mBN;;A6L7zmBE;EACE,eAAA;EAAA,kBAAA;A7Lg0mBJ;;A6L1zmBI;EACE,wBAAA;A7L6zmBN;;A6LvzmBE;EACE,oCAAA;A7L0zmBJ;;A6L3zmBE;EACE,oCAAA;A7L8zmBJ;;A6L/zmBE;EACE,oCAAA;A7Lk0mBJ;;A6Ln0mBE;EACE,oCAAA;A7Ls0mBJ;;A6Lv0mBE;EACE,oCAAA;A7L00mBJ;;A6L30mBE;EACE,oCAAA;A7L80mBJ;;A6L/0mBE;EACE,oCAAA;A7Lk1mBJ;;A6Ln1mBE;EACE,oCAAA;A7Ls1mBJ;;A6Lv1mBE;EACE,oCAAA;A7L01mBJ;;A6L31mBE;EACE,oCAAA;A7L81mBJ;;A6Lr1mBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;A7Lw1mBJ;A6Lt1mBI;EACE,aAAA;EhL1DF,8BN6N0B;EM5N1B,+BN4N0B;EsLjKxB,gBAAA;A7Ly1mBN;A6Lv1mBM;EACE,iBAAA;A7Ly1mBR;A6Lt1mBM;EACE,yBAAA;A7Lw1mBR;A6Ln1mBE;EACE,gBAAA;A7Lq1mBJ;A6Ll1mBE;EACE,gBAAA;A7Lo1mBJ;A6Lj1mBE;EACE,gBAAA;A7Lm1mBJ;;A6L/0mBA;EACE,SAAA;A7Lk1mBF;A6Lh1mBE;EACE,aAAA;A7Lk1mBJ;A6L/0mBE;EACE,oCAAA;EACA,gBAAA;EACA,yBAAA;A7Li1mBJ;A6L/0mBI;EACE,aAAA;A7Li1mBN;A6L70mBE;EACE,+BAAA;A7L+0mBJ;A6L30mBI;EACE,yBAAA;A7L60mBN;A6L10mBI;EACE,yBAAA;A7L40mBN;;A6Ln0mBI;EACE,gB5L1HE;E4L2HF,c5LnHK;E4LoHL,0U5L3Be;E4L4Bf,6EAAA;A7Ls0mBN;A6Ln0mBI;EACE,aAAA;A7Lq0mBN;;A8Ll9mBA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;A9Lq9mBF;A8Lp9mBE;EACE,UAAA;A9Ls9mBJ;;A+L79mBA;EACE,cAAA;EACA,aAAA;EACA,SAAA;A/Lg+mBF;;A+L79mBA;EACE,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;A/Lg+mBF;;A+L79mBA;EACE,mBAAA;A/Lg+mBF;;A+L79mBA;EACE,SAAA;EACA,UAAA;A/Lg+mBF;;AgM/+mBA;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACE,SAAA;EACA,iBAAA;AhMk/mBJ;;AgM/+mBA;;;EAGE,mBAAA;AhMk/mBF;;AgM/+mBA;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AhMk/mBF;;AgM/+mBA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AhMk/mBF;;AgM/+mBA;EACE,cAAA;AhMk/mBF;;AgM/+mBA;EACE,yBCxCmB;AjM0hnBrB;;AgM/+mBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AhMk/mBF;AgM/+mBI;EACE,cAAA;EACA,qBAAA;AhMi/mBN;;AgM5+mBA;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;AhM++mBF;;AgM5+mBA;EACE,yB/LmCuB;AD48mBzB;;AkMljnBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AlMqjnBF;AkMnjnBE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AlMqjnBJ;AkMljnBE;EACE,WjMJI;EiMKJ,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBjMqBI;EiMpBJ,yBAAA;EACA,sBAAA;EACA,sB3LgN0B;E2L/M1B,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;AlMojnBJ;AkMljnBI;EAEE,sBAAA;EACA,gDAAA;EACA,oEAnCc;EAoCd,iEAnCU;AlMslnBhB;AkMjjnBM;EAEE,WjM5BA;EiM6BA,oEAAA;EACA,iEAAA;AlMkjnBR;AkM9inBI;EACE,WjMnCE;EiMoCF,oEAhDc;EAiDd,iEAhDU;AlMgmnBhB;AkM7inBI;EACE,WjMzCE;EiM0CF,oEAtDc;EAuDd,iEAtDU;AlMqmnBhB;;AkM1inBA;EACE,qBAAA;EACA,mBAAA;AlM6inBF;AkM3inBE;EACE,0BAAA;EACA,6BAAA;AlM6inBJ;AkM1inBE;EACE,yBAAA;EACA,4BAAA;AlM4inBJ;AkMzinBE;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;AlM2inBJ;AkMxinBE;EACE,kBAAA;EACA,0BAAA;EACA,6BAAA;AlM0inBJ;AkMvinBE;EACE,gBAAA;AlMyinBJ;AkMtinBE;EACE,iBAAA;AlMwinBJ;AkMrinBE;EACE,cAAA;EACA,kBAAA;AlMuinBJ;AkMpinBE;EAEE,iBAAA;AlMqinBJ;;AmM1onBA;EACE,eAAA;EACA,iB5L4uBkC;E4L3uBlC,yBlMuCM;EkMtCN,sB5LoO4B;E4LnO5B,WlMOM;ADsonBR;AmM3onBE;EACE,oEAAA;AnM6onBJ;;AmMzonBA;EAEE,cAAA;AnM2onBF;;AmMxonBA;EACE,kDAAA;AnM2onBF;;AmMxonBA;EACE,yBAAA;EACA,4BAAA;AnM2onBF;;AmMzonBA;EACE,0BAAA;EACA,6BAAA;AnM4onBF;;AmMxonBA;EACE,yBAAA;EACA,0BAAA;AnM2onBF;;AmMzonBA;EACE,4BAAA;EACA,6BAAA;AnM4onBF;;AoMhrnBA;EACE,aAAA;EACA,mBAAA;ApMmrnBF;;AoMhrnBA;EACE,sBAAA;ApMmrnBF;AoM5qnBA;EACE,oCHLwB;AjMmrnB1B;;AoM1qnBA;EAEE,0CAAA;EACA,UHJa;EGKb,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;ApM4qnBF;;AoMzqnBA;EACE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,YAAA;ApM2qnBF;AoMzqnBE;EACE,gCAAA;ApM2qnBJ;AoMxqnBE;EACE,8BAAA;ApM0qnBJ;AoMvqnBE;EACE,oBAAA;EACA,+BAAA;ApMyqnBJ;;AoMrqnBA;EACE,aAAA;EACA,mBAAA;ApMwqnBF;;AoMrqnBA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EAEA,YAAA;ApMuqnBF;AoMrqnBE;EACE,6BAAA;ApMuqnBJ;;AoMnqnBA;EACE,kBAAA;EACA,iBAAA;EACA,SAAA;ApMsqnBF;AoMpqnBE;EACE,iBAAA;ApMsqnBJ;AoMlqnBI;EACE,cAAA;EACA,qBAAA;ApMoqnBN;;AoM/pnBA;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;ApMiqnBF;;AoM9pnBA;EACA,SAAA;ApMiqnBA;AoMhqnBE;EACE,8BAAA;ApMkqnBJ;AoM/pnBE;EACE,oBAAA;EACA,+BAAA;ApMiqnBJ;;AoM7pnBA;EACI,mBnMnGO;ADmwnBX;;AoM7pnBA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;ApMgqnBF;AoM9pnBE;EACE,eAAA;ApMgqnBJ;;AoM5pnBA;EACE,gCAAA;EACA,6BAAA;EACA,iBAAA;ApM+pnBF;;AqMnynBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;ArMsynBF;AqMpynBE;EACE,WAAA;EACA,yBAAA;ArMsynBJ;AqMpynBI;EACE,iBAAA;EACA,mBAAA;ArMsynBN;AqMlynBI;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;ArMoynBN;AqMjynBI;EACE,8BAAA;ArMmynBN;AqM/xnBM;EACE,oBAAA;EACA,+BAAA;ArMiynBR;AqM7xnBI;EACE,6BAAA;ArM+xnBN;AqM5xnBI;EACE,gBAAA;EACA,gBAAA;EACA,gCAAA;ArM8xnBN;AqM5xnBM;EACE,iBAAA;ArM8xnBR;;AqMxxnBA;EACE,yBAAA;ArM2xnBF;AqMzxnBE;EACE,aAAA;ArM2xnBJ;AqMzxnBE;EACE,aAAA;ArM2xnBJ;;AqMvxnBA;;EAEE,mBAAA;ArM0xnBF;;AqMrxnBA;EACE,WAAA;ArMwxnBF;;AsM11nBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AtM61nBF;AsM31nBE;EACE,SAAA;AtM61nBJ;;AsMx1nBA;EACE,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;AtM21nBF;;AsMx1nBA;;EAEE,UAAA;AtM21nBF;;AsMx1nBA;EACE,cAAA;AtM21nBF;;AsMx1nBA;EACE,kBAAA;AtM21nBF;AsMz1nBE;EACE,oEAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AtM21nBJ;AsMx1nBE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;AtM01nBJ;AsMv1nBE;EACE,WAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AtMy1nBJ;AsMt1nBE;EACE,2BAAA;AtMw1nBJ;;AsMp1nBA;EACE,SAAA;AtMu1nBF;AsMr1nBE;EACE,iBAAA;AtMu1nBJ;;AsMn1nBA;EACE,kBAAA;AtMs1nBF;;AsMn1nBA;EACE,kBAAA;EACA,UAAA;AtMs1nBF;;AuM/5nBA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,oCNIwB;EMHxB,aNEqB;EMDrB,cAAA;EACA,YAAA;AvMk6nBF;;AuM/5nBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;AvMk6nBF;AuMh6nBE;EACE,mBAAA;AvMk6nBJ;AuM/5nBE;EACE,WAAA;EACA,kBAAA;AvMi6nBJ;AuM95nBE;EACE,kBAAA;EACA,UAAA;AvMg6nBJ;AuM75nBE;EACE,gBAAA;AvM+5nBJ;;AuM15nBA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;AvM65nBF;AuM35nBE;EACE,+BAAA;AvM65nBJ;AuM15nBE;EACE,qBAAA;EACA,8BAAA;AvM45nBJ;AuMz5nBE;EACE,8BAAA;AvM25nBJ;AuMx5nBE;EACE,oBAAA;EACA,+BAAA;AvM05nBJ;AuMv5nBE;EACE,gCAAA;AvMy5nBJ;AuMt5nBE;EACE,UAAA;AvMw5nBJ;AuMr5nBE;EACE,WAAA;AvMu5nBJ;;AuMn5nBA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AvMs5nBF;AuMp5nBE;EACE,UAAA;AvMs5nBJ;AuMn5nBE;EACE,8BAAA;AvMq5nBJ;AuMl5nBE;EACE,oBAAA;EACA,+BAAA;AvMo5nBJ;AuMj5nBE;EACE,WAAA;EACA,yBAAA;UAAA,iBAAA;AvMm5nBJ;;AuM/4nBA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EAEA,yBtM3DM;EsM4DN,oBAAA;AvMi5nBF;AuM/4nBE;EACE,cAAA;EAEA,kBAAA;EACA,UAAA;EACA,SAAA;EAEA,YAAA;EACA,yBtMtEI;EsMwEJ,kBAAA;EACA,UAAA;EACA,WAAA;AvM84nBJ;AuM34nBE;EACE,OAAA;EACA,WAAA;AvM64nBJ;;AwM9goBA;EACE,kCAAA;E3LEE,mB2LDqB;AxMihoBzB;AwM/goBE;EAGE,oCAAA;AxM+goBJ;AwM5goBE;EACE,yBvMGO;AD2goBX;AwM3goBE;EACE,gCAAA;AxM6goBJ;;AyM9hoBA;;EAAA;AAGA;EACE,yBAAA;AzMiioBF;;AyM9hoBA;EACE,4BAAA;AzMiioBF;;AyM9hoBA;EACE,cAAA;AzMiioBF;;AyM9hoBA;EACE,aAAA;AzMiioBF;;AyM9hoBA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AzMiioBF;;AyM9hoBA;EACE,iBAAA;AzMiioBF;;AyM9hoBA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;AzMiioBF;;AyM9hoBA;;;;+EAAA;AAKA;;EAEE,YAAA;EACA,kBAAA;EACA,qBAAA;AzMiioBF;;AyM9hoBA;EACE,kBAAA;EACA,MAAA;AzMiioBF;;AyM9hoBA;;;;EAIE,kBAAA;EACA,WAAA;EACA,uBAAA;AzMiioBF;;AyM9hoBA;;;;;;EAAA;AAOA;EACE,WAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;AzMiioBF;;AyM9hoBA;EACE,OAAA;EACA,WAAA;EAAA,cAAA;AzMiioBF;;AyM9hoBA;;;EAGE,UAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;AzMiioBF;;AyM9hoBA;;;EAGE,UAAA;EACA,UAAA;EAAA,aAAA;AzMiioBF;;AyM9hoBA;EACE,WAAA;AzMiioBF;;AyM9hoBA;EACE,SAAA;EACA,SAAA;EACA,WAAA;AzMiioBF;;AyM9hoBA;+EAAA;AAEA;EACE,UAAA;AzMiioBF;;AyM/hoBA;EACE,kBAAA;EACA,WAAA;EACA,yBxMvEM;EwMwEN,UAAA;EACA,iBAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;AzMkioBF;;AyM/hoBA;EACE,cAAA;EAAA,oBAAA;EACA,kBAAA;EACA,UAAA;EAAA,aAAA;EACA,UAAA;AzMkioBF;;AyM/hoBA;EACE;IACE,0BAAA;IACA,UAAA;EzMkioBF;EyMhioBA;IACE,6BAAA;IACA,UAAA;EzMkioBF;EyMhioBA;IACE,6BAAA;IACA,UAAA;EzMkioBF;EyMhioBA;IACE,8BAAA;IACA,UAAA;EzMkioBF;AACF;AyMhioBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,SAAA;EACA,MAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;EACA,8CAAA;AzMkioBF;;AyM/hoBA;EACE,cAAA;EAAA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EAAA,aAAA;AzMkioBF;;AyM/hoBA;;;;;;EAAA;AAOA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;AzMkioBF;;AyM/hoBA;EACE,+BAAA;EACA,iBAAA;EACA,OAAA;EACA,WAAA;EAAA,cAAA;AzMkioBF;;AyM/hoBA;;;;;;EAAA;AAOA;EACE,UAAA;AzMkioBF;;AyMhioBA;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,8BAAA;EACA,sBAAA;EACA,wBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AzMmioBF;;AyMhioBA;EACE,+BAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EAAA,cAAA;AzMmioBF;;AyMhioBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAAA;EACA,qCAAA;EACA,+BAAA;AzMmioBF;;AyMhioBA;EACE,OAAA;EACA,WAAA;EAAA,cAAA;EACA,gCAAA;EACA,iBAAA;AzMmioBF;;AyMhioBA;EACE,yBAAA;EACA,YAAA;EACA,sBAAA;AzMmioBF;;AyMhioBA;EACE,yBAAA;AzMmioBF;;AyMhioBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;AzMmioBF;;AyMjioBA;EACE,sBAAA;AzMoioBF;;AyMjioBA;;EAAA;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,wBAAA;AzMoioBF;;AyMlioBA;;EAEE,qBAAA;AzMqioBF;;AyMnioBA;;EAEE,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AzMsioBF;;AyMnioBA;;EAAA;AAGA;EACE,yBAAA;AzMsioBF;;AyMnioBA;;EAAA;AAGA;EACE,0BAAA;AzMsioBF;;AyMnioBA;;EAAA;AAGA;EACE,0BAAA;AzMsioBF;;AyMnioBA;;;;;EAKE,qBAAA;EACA,sBAAA;AzMsioBF;;AyMnioBA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AzMsioBF;;AyMnioBA;EACE,kBAAA;EACA,8BAAA;EACA,qBAAA;AzMsioBF;;AyMnioBA;EACE,8BAAA;AzMsioBF;;AyMnioBA;EACE,+BAAA;EACA,8BAAA;AzMsioBF;;AyMnioBA;EACE,cAAA;EACA,mBAAA;AzMsioBF;;AyMpioBA;EACE,kBAAA;EACA,sBAAA;AzMuioBF;;AyMpioBA;EACE,cAAA;EACA,aAAA;AzMuioBF;;AyMpioBA;;EAEE,YAAA;EACA,WAAA;EACA,6EAAA;EAGA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AzMqioBF;;AyMlioBA;EACE,eAAA;EACA,mBxM1WS;AD+4oBX;;AyMlioBA;EACE;IAGE,UAAA;EzMmioBF;EyMjioBA;IACE,UAAA;EzMmioBF;AACF;AyMhioBA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AzMkioBF;;AyM/hoBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AzMkioBF;;AyM/hoBA;EACE,QAAA;EACA,UAAA;EAAA,aAAA;AzMkioBF;;AyM/hoBA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,sBxMpZM;EwMqZN,kBAAA;EACA,oDAAA;AzMkioBF;;AyMhioBA;EACE,uBAAA;AzMmioBF;;AyMjioBA;EACE,yBAAA;AzMoioBF;;AyMlioBA;;EAEE,uBAAA;AzMqioBF;;AyMnioBA;EACE,wBAAA;AzMsioBF;;AyMpioBA;EACE,yBAAA;AzMuioBF;;AyMrioBA;;EAEE,uBAAA;AzMwioBF;;AyMtioBA;EACE,wBAAA;AzMyioBF;;AyMvioBA;EACE,yBAAA;AzM0ioBF;;AyMxioBA;;EAEE,uBAAA;AzM2ioBF;;AyMzioBA;EACE,wBAAA;AzM4ioBF;;AyM1ioBA;EACE,yBAAA;AzM6ioBF;;AyM3ioBA;;EAEE,uBAAA;AzM8ioBF;;AyM5ioBA;EACE,yBAAA;AzM+ioBF;;AyM7ioBA;EACE,yBAAA;AzMgjoBF;;AyM9ioBA;;EAEE,uBAAA;AzMijoBF;;AyM/ioBA;EACE,yBAAA;AzMkjoBF;;AyMhjoBA;EACE,yBAAA;AzMmjoBF;;AyMjjoBA;;EAEE,uBAAA;AzMojoBF;;AyMljoBA;EACE,yBAAA;AzMqjoBF;;AyMnjoBA;EACE,yBAAA;AzMsjoBF;;AyMpjoBA;;EAEE,oBAAA;AzMujoBF;;AyMpjoBA;EACE,iBAAA;AzMujoBF;;AyMpjoBA;EACE,cAAA;EACA,cAAA;EACA,cAAA;AzMujoBF;;AyMpjoBA;EACE,cAAA;EACA,cAAA;AzMujoBF;;AyMpjoBA;;EAEE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;EACA,eAAA;AzMujoBF;;AyMrjoBA;;EAEE,+BAAA;AzMwjoBF;;AyMtjoBA;;EAEE,aAAA;EACA,+CAAA;AzMyjoBF;;AyMvjoBA;;EAEE,qBAAA;EACA,YAAA;EACA,WAAA;AzM0joBF;;AyMvjoBA;EACE,0EAAA;AzM0joBF;;AyMrjoBA;EACE,0EAAA;AzMwjoBF;;AyMnjoBA;;EAAA;AAGA;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;AzMsjoBF;;AyMpjoBA;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AzMujoBF;;AyMpjoBA;EACE,UAAA;EACA,UAAA;EAAA,aAAA;AzMujoBF;;AyMpjoBA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AzMujoBF;;AyMrjoBA;;EAEE,sBAAA;AzMwjoBF;;AyMtjoBA;EACE,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AzMyjoBF;;AyMtjoBA;;EAAA;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,wBAAA;AzMyjoBF;;AyMvjoBA;;EAEE,qBAAA;AzM0joBF;;AyMxjoBA;;EAEE,2BAAA;EACA,mBAAA;AzM2joBF;;AyMxjoBA;;EAAA;AAGA;EACE,yBAAA;AzM2joBF;;AyMxjoBA,6BAAA;AAQA,uBAAA;AAQA,wBAAA;AAQA;EACE,gBAAA;EACA,yBAAA;EAGA,aAAA;EAIA,mBAAA;EAGA,mBAAA;AzMsioBF;;AyMpioBA;EAGE,aAAA;EAIA,mBAAA;EAGA,mBAAA;AzMuioBF;;AyMpioBA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AzMuioBF;;AyMpioBA;;EAEE,kBAAA;EACA,cAAA;AzMuioBF;;AyMrioBA;EACE,uBAAA;EACA,mBAAA;AzMwioBF;;AyMrioBA;;EAEE,iBAAA;AzMwioBF;;AyMtioBA;EACE,eAAA;AzMyioBF;;AyMtioBA;EAGE,aAAA;EAGA,mBAAA;AzMyioBF;;AyMvioBA;EAGE,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AzM0ioBF;;AyMvioBA,uBAAA;AC1sBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;A1MqvpBF;A0MnvpBE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;A1MqvpBJ;A0MlvpBE;;;;EAIE,cAAA;EACA,WAAA;EACA,cnMRO;EmMSP,sBnMhBO;EmMiBP,4BAAA;EACA,yBAAA;EAEA,kCnModoC;EmMndpC,uBAAA;EACA,gBnMwM0B;EMhO1B,qBNuO0B;EmM3MxB,sBnMyMwB;EkKrN5B,mFAAA;AzK8vpBF;A0M1upBI;;;;EACE,6BAAA;EACA,SAAA;A1M+upBN;AuB7wpBE;;;;EACE,cAAA;EACA,sBhBRO;EgBSP,iEtByIuB;EsBxIvB,UAAA;EAKE,gDhBgXwB;AP85oB9B;A0MnvpBI;;;;EACE,cnMrCK;EmMsCL,UAAA;A1MwvpBN;A0MrvpBI;;;;;;;EAEE,yBnM/CK;EmMgDL,UAAA;A1M4vpBN;A0MxvpBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;A1M0vpBJ;A0MxvpBI;EACE,+BAAA;EACA,gCAAA;A1M0vpBN;A0MxvpBM;;EAEE,ezM8DgB;EyM7DhB,czMtDG;ADgzpBX;A0MxvpBQ;;EACE,czMzDC;ADozpBX;A0MxvpBQ;;EACE,UAAA;A1M2vpBV;A0MrvpBI;EACE,gCAAA;EACA,mBzM1EK;ADi0pBX;A0MrvpBM;EACE,+BAAA;A1MuvpBR;A0MpvpBM;EACE,4CAAA;A1MsvpBR;A0MlvpBI;EACE,kBAAA;A1MovpBN;A0MjvpBI;;EAEE,gBzM4Be;EyM3Bf,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gCAAA;EACA,mEAAA;EACA,qCAAA;EACA,czMtEE;ADyzpBR;A0MjvpBM;;EACE,0DAAA;A1MovpBR;A0MhvpBI;;EAEE,mCAAA;A1MkvpBN;A0M/upBI;;EAEE,oCAAA;A1MivpBN;A0M9upBI;;EAEE,eAAA;A1MgvpBN;A0M7upBI;;EAEE,eAAA;A1M+upBN;A0M5upBI;EACE,iBAAA;A1M8upBN;A0M3upBI;EACE,gBAAA;A1M6upBN;A0M1upBI;EACE,gBAAA;EACA,uBAAA;A1M4upBN;A0MzupBI;EACE,2BAAA;A1M2upBN;A0MxupBI;;EAEE,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;A1M0upBN;A0MvupBI;EACE,oCAAA;EACA,uBzM9JE;EyM+JF,iBAAA;EACA,gBAAA;A1MyupBN;A0MtupBI;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;A1MwupBN;A0MpupBE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;A1MsupBJ;A0MpupBI;EACE,gCAAA;A1MsupBN;A0MnupBI;EACE,gBAAA;A1MqupBN;A0MlupBI;EACE,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;A1MoupBN;A0MlupBM;EACE,WAAA;EACA,6BAAA;EACA,2BAAA;E7L3MJ,qBNuO0B;APyspB9B;A0MlupBQ;EACE,gBAAA;EACA,iEzM5DiB;EyM6DjB,aAAA;A1MoupBV;A0M/tpBI;EACE,eAAA;A1MiupBN;A0M9tpBI;EACE,eAAA;EACA,mBAAA;A1MgupBN;A0M5tpBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;A1M8tpBJ;A0M3tpBE;EACE,cAAA;EACA,oBAAA;A1M6tpBJ;A0M1tpBE;;EAEE,SAAA;EACA,uBAAA;EACA,gBzM/GiB;EyMiHjB,qBAAA;EACA,uDAAA;A1M2tpBJ;A0MztpBI;;EACE,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;A1M4tpBN;A0MxtpBE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;A1M0tpBJ;A0MztpBI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EACA,eAAA;A1M2tpBN;A0MztpBI;EACE,0CAAA;A1M2tpBN;A0MvtpBE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;A1MytpBJ;A0MttpBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;A1MwtpBJ;A0MttpBI;EACE,+BAAA;A1MwtpBN;A0MvtpBM;EACE,eAAA;A1MytpBR;A0MptpBE;EACE,+BAAA;A1MstpBJ;A0MltpBI;EACE,2CAAA;A1MotpBN;A0MjtpBI;EACE,4CAAA;A1MmtpBN;A0M/spBE;EACE,mBzMxNqB;ADy6pBzB;A0M9spBE;EACE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA;A1MgtpBJ;A0M9spBI;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,sBnM3GwB;EmM4GxB,YAAA;EACA,cAAA;EACA,czM5SE;EyM6SF,mBzM1UK;EyM2UL,yBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;A1MgtpBN;A0M7spBI;EACE,YAAA;EACA,eAAA;A1M+spBN;A0M5spBI;EACE,mBzM1TE;EyM2TF,WzMzVE;ADuiqBR;A0M3spBI;;EAEE,SAAA;EACA,kBAAA;A1M6spBN;A0M1spBI;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;A1M4spBN;A0MzspBI;EACE,iBAAA;EACA,iBAAA;A1M2spBN;A0MxspBI;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;A1M0spBN;A0MvspBI;EACE,qBAAA;EACA,aAAA;A1MyspBN;A0MtspBI;EACE,WAAA;EACA,kBAAA;A1MwspBN;A0MrspBI;EACE,gBAAA;A1MuspBN;A0MnspBE;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;A1MqspBJ;A0MlspBE;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;A1MospBJ;A0MjspBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,czM9YI;EyM+YJ,2BAAA;EACA,yDAAA;A1MmspBJ;A0MhspBE;EACE,UAAA;EACA,UAAA;EACA,mBAAA;A1MkspBJ;A0M/rpBE;EACE,0BAAA;A1MispBJ;A0M9rpBE;;EAEE,2BAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;A1MgspBJ;;A0M3rpBA;;EAEE,sBAAA;A1M8rpBF;;A0M1rpBE;EACE,oBAAA;EACA,YAAA;EACA,sBAAA;A1M6rpBJ;;A0MzrpBA;;EAEE,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;A1M4rpBF;;A0MxrpBE;;EAEE,czMlcI;AD6nqBR;;A0M5qpBE;;EAEE,wBAAA;A1M+qpBJ;;A2M1qqBA;EACE,+BAAA;EACA,6CAAA;EACA,iTAAA;EAKA,mBAAA;EACA,kBAAA;A3MyqqBF;A2MtqqBA;;EAEE,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;A3MuqqBF;;A2MpqqBA;EACE,gBAAA;A3MuqqBF;;A2MrqqBA;EACE,gBAAA;A3MwqqBF;;A2MtqqBA;EACE,gBAAA;A3MyqqBF;;A2MvqqBA;EACE,gBAAA;A3M0qqBF;;A2MxqqBA;EACE,gBAAA;A3M2qqBF;;A2MzqqBA;EACE,gBAAA;A3M4qqBF;;A2M1qqBA;EACE,gBAAA;A3M6qqBF;;A2M3qqBA;EACE,gBAAA;A3M8qqBF;;A2M5qqBA;EACE,gBAAA;A3M+qqBF;;A2M7qqBA;EACE,gBAAA;A3MgrqBF;;A2M9qqBA;EACE,gBAAA;A3MirqBF;;A2M/qqBA;EACE,gBAAA;A3MkrqBF;;A2MhrqBA;EACE,gBAAA;A3MmrqBF;;A2MjrqBA;EACE,gBAAA;A3MorqBF;;A2MlrqBA;EACE,gBAAA;A3MqrqBF;;A2MnrqBA;EACE,gBAAA;A3MsrqBF;;A2MprqBA;EACE,gBAAA;A3MurqBF;;A2MrrqBA;EACE,gBAAA;A3MwrqBF;;A2MtrqBA;EACE,gBAAA;A3MyrqBF;;A2MvrqBA;EACE,gBAAA;A3M0rqBF;;A2MxrqBA;EACE,gBAAA;A3M2rqBF;;A2MzrqBA;EACE,gBAAA;A3M4rqBF;;A2M1rqBA;EACE,gBAAA;A3M6rqBF;;A2M3rqBA;EACE,gBAAA;A3M8rqBF;;A2M5rqBA;EACE,gBAAA;A3M+rqBF;;A2M7rqBA;EACE,gBAAA;A3MgsqBF;;A2M9rqBA;EACE,gBAAA;A3MisqBF;;A2M/rqBA;EACE,gBAAA;A3MksqBF;;A2MhsqBA;EACE,gBAAA;A3MmsqBF;;A2MjsqBA;EACE,gBAAA;A3MosqBF;;A2MlsqBA;EACE,gBAAA;A3MqsqBF;;A2MnsqBA;EACE,gBAAA;A3MssqBF;;A2MpsqBA;EACE,gBAAA;A3MusqBF;;A2MrsqBA;EACE,gBAAA;A3MwsqBF;;A2MtsqBA;EACE,gBAAA;A3MysqBF;;A2MvsqBA;EACE,gBAAA;A3M0sqBF;;A2MxsqBA;EACE,gBAAA;A3M2sqBF;;A2MzsqBA;EACE,gBAAA;A3M4sqBF;;A2M1sqBA;EACE,gBAAA;A3M6sqBF;;A2M3sqBA;EACE,gBAAA;A3M8sqBF;;A2M5sqBA;EACE,gBAAA;A3M+sqBF;;A2M7sqBA;EACE,gBAAA;A3MgtqBF;;A2M9sqBA;EACE,gBAAA;A3MitqBF;;A2M/sqBA;EACE,gBAAA;A3MktqBF;;A2MhtqBA;EACE,gBAAA;A3MmtqBF;;A2MjtqBA;EACE,gBAAA;A3MotqBF;;A2MltqBA;EACE,gBAAA;A3MqtqBF;;A2MntqBA;EACE,gBAAA;A3MstqBF;;A2MptqBA;EACE,gBAAA;A3MutqBF;;A2MrtqBA;EACE,gBAAA;A3MwtqBF;;A2MttqBA;EACE,gBAAA;A3MytqBF;;A2MvtqBA;EACE,gBAAA;A3M0tqBF;;A2MxtqBA;EACE,gBAAA;A3M2tqBF;;A2MztqBA;EACE,gBAAA;A3M4tqBF;;A2M1tqBA;EACE,gBAAA;A3M6tqBF;;A2M3tqBA;EACE,gBAAA;A3M8tqBF;;A2M5tqBA;EACE,gBAAA;A3M+tqBF;;A2M7tqBA;EACE,gBAAA;A3MguqBF;;A2M9tqBA;EACE,gBAAA;A3MiuqBF;;A2M/tqBA;EACE,gBAAA;A3MkuqBF;;A2MhuqBA;EACE,gBAAA;A3MmuqBF;;A2MjuqBA;EACE,gBAAA;A3MouqBF;;A2MluqBA;EACE,gBAAA;A3MquqBF;;A2MnuqBA;EACE,gBAAA;A3MsuqBF;;A2MpuqBA;EACE,gBAAA;A3MuuqBF;;A2MruqBA;EACE,gBAAA;A3MwuqBF;;A2MtuqBA;EACE,gBAAA;A3MyuqBF;;A2MvuqBA;EACE,gBAAA;A3M0uqBF;;A2MxuqBA;EACE,gBAAA;A3M2uqBF;;A2MzuqBA;EACE,gBAAA;A3M4uqBF;;A2M1uqBA;EACE,gBAAA;A3M6uqBF;;A2M3uqBA;EACE,gBAAA;A3M8uqBF;;A2M5uqBA;EACE,gBAAA;A3M+uqBF;;A2M7uqBA;EACE,gBAAA;A3MgvqBF;;A2M9uqBA;EACE,gBAAA;A3MivqBF;;A2M/uqBA;EACE,gBAAA;A3MkvqBF;;A2MhvqBA;EACE,gBAAA;A3MmvqBF;;A2MjvqBA;EACE,gBAAA;A3MovqBF;;A2MlvqBA;EACE,gBAAA;A3MqvqBF;;A2MnvqBA;EACE,gBAAA;A3MsvqBF;;A2MpvqBA;EACE,gBAAA;A3MuvqBF;;A2MrvqBA;EACE,gBAAA;A3MwvqBF;;A2MtvqBA;EACE,gBAAA;A3MyvqBF;;A2MvvqBA;EACE,gBAAA;A3M0vqBF;;A2MxvqBA;EACE,gBAAA;A3M2vqBF;;A2MzvqBA;EACE,gBAAA;A3M4vqBF;;A2M1vqBA;EACE,gBAAA;A3M6vqBF;;A2M3vqBA;EACE,gBAAA;A3M8vqBF;;A2M5vqBA;EACE,gBAAA;A3M+vqBF;;A2M7vqBA;EACE,gBAAA;A3MgwqBF;;A2M9vqBA;EACE,gBAAA;A3MiwqBF;;A2M/vqBA;EACE,gBAAA;A3MkwqBF;;A2MhwqBA;EACE,gBAAA;A3MmwqBF;;A2MjwqBA;EACE,gBAAA;A3MowqBF;;A2MlwqBA;EACE,gBAAA;A3MqwqBF;;A2MnwqBA;EACE,gBAAA;A3MswqBF;;A2MpwqBA;EACE,gBAAA;A3MuwqBF;;A2MrwqBA;EACE,gBAAA;A3MwwqBF;;A2MtwqBA;EACE,gBAAA;A3MywqBF;;A2MvwqBA;EACE,gBAAA;A3M0wqBF;;A2MxwqBA;EACE,gBAAA;A3M2wqBF;;A2MzwqBA;EACE,gBAAA;A3M4wqBF;;A2M1wqBA;EACE,gBAAA;A3M6wqBF;;A2M3wqBA;EACE,gBAAA;A3M8wqBF;;A2M5wqBA;EACE,gBAAA;A3M+wqBF;;A2M7wqBA;EACE,gBAAA;A3MgxqBF;;A2M9wqBA;EACE,gBAAA;A3MixqBF;;A2M/wqBA;EACE,gBAAA;A3MkxqBF;;A2MhxqBA;EACE,gBAAA;A3MmxqBF;;A2MjxqBA;EACE,gBAAA;A3MoxqBF;;A2MlxqBA;EACE,gBAAA;A3MqxqBF;;A2MnxqBA;EACE,gBAAA;A3MsxqBF;;A2MpxqBA;EACE,gBAAA;A3MuxqBF;;A2MrxqBA;EACE,gBAAA;A3MwxqBF;;A2MtxqBA;EACE,gBAAA;A3MyxqBF;;A2MvxqBA;EACE,gBAAA;A3M0xqBF;;A2MxxqBA;EACE,gBAAA;A3M2xqBF;;A2MzxqBA;EACE,gBAAA;A3M4xqBF;;A2M1xqBA;EACE,gBAAA;A3M6xqBF;;A2M3xqBA;EACE,gBAAA;A3M8xqBF;;A2M5xqBA;EACE,gBAAA;A3M+xqBF;;A2M7xqBA;EACE,gBAAA;A3MgyqBF;;A2M9xqBA;EACE,gBAAA;A3MiyqBF;;A2M/xqBA;EACE,gBAAA;A3MkyqBF;;A2MhyqBA;EACE,gBAAA;A3MmyqBF;;A2MjyqBA;EACE,gBAAA;A3MoyqBF;;A2MlyqBA;EACE,gBAAA;A3MqyqBF;;A2MnyqBA;EACE,gBAAA;A3MsyqBF;;A2MpyqBA;EACE,gBAAA;A3MuyqBF;;A2MryqBA;EACE,gBAAA;A3MwyqBF;;A2MtyqBA;EACE,gBAAA;A3MyyqBF;;A2MvyqBA;EACE,gBAAA;A3M0yqBF;;A2MxyqBA;EACE,gBAAA;A3M2yqBF;;A2MzyqBA;EACE,gBAAA;A3M4yqBF;;A2M1yqBA;EACE,gBAAA;A3M6yqBF;;A2M3yqBA;EACE,gBAAA;A3M8yqBF;;A2M5yqBA;EACE,gBAAA;A3M+yqBF;;A2M7yqBA;EACE,gBAAA;A3MgzqBF;;A2M9yqBA;EACE,gBAAA;A3MizqBF;;A2M/yqBA;EACE,gBAAA;A3MkzqBF;;A2MhzqBA;EACE,gBAAA;A3MmzqBF;;A2MjzqBA;EACE,gBAAA;A3MozqBF;;A2MlzqBA;EACE,gBAAA;A3MqzqBF;;A2MnzqBA;EACE,gBAAA;A3MszqBF;;A2MpzqBA;EACE,gBAAA;A3MuzqBF;;A2MrzqBA;EACE,gBAAA;A3MwzqBF;;A2MtzqBA;EACE,gBAAA;A3MyzqBF;;A2MvzqBA;EACE,gBAAA;A3M0zqBF;;A2MxzqBA;EACE,gBAAA;A3M2zqBF;;A2MzzqBA;EACE,gBAAA;A3M4zqBF;;A2M1zqBA;EACE,gBAAA;A3M6zqBF;;A2M3zqBA;EACE,gBAAA;A3M8zqBF;;A2M5zqBA;EACE,gBAAA;A3M+zqBF;;A2M7zqBA;EACE,gBAAA;A3Mg0qBF;;A2M9zqBA;EACE,gBAAA;A3Mi0qBF;;A2M/zqBA;EACE,gBAAA;A3Mk0qBF;;A2Mh0qBA;EACE,gBAAA;A3Mm0qBF;;A2Mj0qBA;EACE,gBAAA;A3Mo0qBF;;A2Ml0qBA;EACE,gBAAA;A3Mq0qBF;;A2Mn0qBA;EACE,gBAAA;A3Ms0qBF;;A2Mp0qBA;EACE,gBAAA;A3Mu0qBF;;A2Mr0qBA;EACE,gBAAA;A3Mw0qBF;;A2Mt0qBA;EACE,gBAAA;A3My0qBF;;A2Mv0qBA;EACE,gBAAA;A3M00qBF;;A2Mx0qBA;EACE,gBAAA;A3M20qBF;;A2Mz0qBA;EACE,gBAAA;A3M40qBF;;A2M10qBA;EACE,gBAAA;A3M60qBF;;A2M30qBA;EACE,gBAAA;A3M80qBF;;A2M50qBA;EACE,gBAAA;A3M+0qBF;;A2M70qBA;EACE,gBAAA;A3Mg1qBF;;A4M32rBA;;CAAA;ACAA;EACC,+BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;A7M82rBD;A8Mt3rBA;EACC,qBAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;A9Mu3rBD;;A+Ml4rBA;+BAAA;AAGA,qBAAA;AAEA;;;EAAA;AAKA,6DAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;A/Mk4rBF;;A+M/3rBA;EACE,kBAAA;A/Mk4rBF;;A+M/3rBA;EACE,kBAAA;A/Mk4rBF;;A+M/3rBA;EACE,kBAAA;A/Mk4rBF;;A+M/3rBA;EACE,iBAAA;A/Mk4rBF;;A+M/3rBA;EACE,qBAAA;EACA,kBAAA;A/Mk4rBF;;A+M/3rBA;EACE,eAAA;EACA,2BAAA;EACA,qBAAA;A/Mk4rBF;A+Mh4rBE;EACE,kBAAA;A/Mk4rBJ;;A+M93rBA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;A/Mi4rBF;A+M/3rBE;EACE,qBAAA;A/Mi4rBJ;;A+M73rBA;EACE,4BAAA;EACA,4BAAA;EACA,oBAAA;A/Mg4rBF;;A+M73rBA;EACE,YAAA;A/Mg4rBF;;A+M53rBE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;A/M+3rBJ;;A+M33rBA;EACE,kCAAA;A/M83rBF;;A+M33rBA;EACE;IACE,uBAAA;E/M83rBF;E+M53rBA;IACE,yBAAA;E/M83rBF;AACF;A+M33rBA;EACE,gEAAA;EACA,wBAAA;A/M63rBF;;A+M13rBA;EACE,gEAAA;EACA,yBAAA;A/M63rBF;;A+M13rBA;EACE,gEAAA;EACA,yBAAA;A/M63rBF;;A+M13rBA;EACE,0EAAA;EACA,uBAAA;A/M63rBF;;A+M13rBA;EACE,0EAAA;EACA,uBAAA;A/M63rBF;;A+M13rBA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;A/M63rBF;;A+M13rBA;;EAEE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;A/M63rBF;;A+M13rBA;EACE,oBAAA;A/M63rBF;;A+M13rBA;EACE,cAAA;A/M63rBF;;A+M13rBA;EACE,cAAA;A/M63rBF;;A+M13rBA,oCAAA;AACA;EACE,sBAAA;A/M63rBF;;A+M13rBA;EACE,4BAAA;A/M63rBF;;AgNrhsBA;EACE,gBCGe;AjNqhsBjB;;AgNrhsBA;EACE,gBAAA;AhNwhsBF;;AgNthsBA;EACE,gBCFgB;AjN2hsBlB;;AgNvhsBA;EACE,gBCJiB;AjN8hsBnB;;AgNxhsBA;EACE,gBCNa;AjNiisBf;;AgNzhsBA;EACE,gBCRiB;AjNoisBnB;;AgN1hsBA;EACE,gBCVmB;AjNuisBrB;;AgN3hsBA;EACE,gBCZoB;AjN0isBtB;;AgN5hsBA;EACE,gBCdgB;AjN6isBlB;;AgN7hsBA;EACE,gBChBa;AjNgjsBf;;AgN9hsBA;EACE,gBClBgB;AjNmjsBlB;;AgN/hsBA;EACE,gBCpBoB;AjNsjsBtB;;AgNhisBA;EACE,gBCtBc;AjNyjsBhB;;AgNjisBA;EACE,gBCxBmB;AjN4jsBrB;;AgNlisBA;EACE,gBC1Bc;AjN+jsBhB;;AgNnisBA;EACE,gBC5BoB;AjNkksBtB;;AgNpisBA;EACE,gBC9Bc;AjNqksBhB;;AgNrisBA;EACE,gBChCe;AjNwksBjB;;AgNtisBA;EACE,gBClCgB;AjN2ksBlB;;AgNvisBA;EACE,gBCpCsB;AjN8ksBxB;;AgNxisBA;EACE,gBCtCkB;AjNilsBpB;;AgNzisBA;EACE,gBCxCe;AjNolsBjB;;AgN1isBA;EACE,gBC1Ce;AjNulsBjB;;AgN3isBA;EACE,gBC5CgB;AjN0lsBlB;;AgN5isBA;EACE,gBC9CmB;AjN6lsBrB;;AgN7isBA;EACE,gBChDgB;AjNgmsBlB;;AgN9isBA;EACE,gBClDkB;AjNmmsBpB;;AgN/isBA;EACE,gBCpDgB;AjNsmsBlB;;AgNhjsBA;EACE,gBCtDe;AjNymsBjB;;AgNjjsBA;EACE,gBCxDa;AjN4msBf;;AgNljsBA;EACE,gBC1DgB;AjN+msBlB;;AgNnjsBA;EACE,gBC5Dc;AjNknsBhB;;AgNpjsBA;EACE,gBC9DsB;AjNqnsBxB;;AgNrjsBA;EACE,gBChEc;AjNwnsBhB;;AgNtjsBA;EACE,gBClEe;AjN2nsBjB;;AgNvjsBA;EACE,gBCpEmB;AjN8nsBrB;;AgNxjsBA;EACE,gBCtEwB;AjNiosB1B;;AgNzjsBA;EACE,gBCxEa;AjNoosBf;;AgN1jsBA;EACE,gBC1EsB;AjNuosBxB;;AgN3jsBA;EACE,gBC5EY;AjN0osBd;;AgN5jsBA;EACE,gBC9EkB;AjN6osBpB;;AgN7jsBA;EACE,gBChFoB;AjNgpsBtB;;AgN9jsBA;EACE,gBClFyB;AjNmpsB3B;;AgN/jsBA;EACE,gBCpFe;AjNspsBjB;;AgNhksBA;EACE,gBCtFqB;AjNypsBvB;;AgNjksBA;EACE,gBCxFgB;AjN4psBlB;;AgNlksBA;EACE,gBC1F4B;AjN+psB9B;;AgNnksBA;EACE,gBC5Fe;AjNkqsBjB;;AgNpksBA;EACE,gBC9FoB;AjNqqsBtB;;AgNrksBA;EACE,gBChGqB;AjNwqsBvB;;AgNtksBA;EACE,gBClG2B;AjN2qsB7B;;AgNvksBA;EACE,gBCpGkB;AjN8qsBpB;;AgNxksBA;EACE,gBCtGoB;AjNirsBtB;;AgNzksBA;EACE,gBCxGgB;AjNorsBlB;;AgN1ksBA;EACE,gBC1G2B;AjNursB7B;;AgN3ksBA;EACE,gBC5GkB;AjN0rsBpB;;AgN5ksBA;EACE,gBC9GgB;AjN6rsBlB;;AgN7ksBA;EACE,gBChHc;AjNgssBhB;;AgN9ksBA;EACE,gBClHiB;AjNmssBnB;;AgN/ksBA;EACE,gBCpHiB;AjNsssBnB;;AgNhlsBA;EACE,gBCtHmB;AjNyssBrB;;AgNjlsBA;EACE,gBCxHe;AjN4ssBjB;;AgNllsBA;EACE,gBC1Hc;AjN+ssBhB;;AgNnlsBA;EACE,gBC5HgB;AjNktsBlB;;AgNplsBA;EACE,gBC9HgB;AjNqtsBlB;;AgNrlsBA;EACE,gBChIkB;AjNwtsBpB;;AgNtlsBA;EACE,gBClIe;AjN2tsBjB;;AgNvlsBA;EACE,gBCpIe;AjN8tsBjB;;AgNxlsBA;EACE,gBCtIe;AjNiusBjB;;AgNzlsBA;EACE,gBCxIgB;AjNousBlB;;AgN1lsBA;EACE,gBC1IgB;AjNuusBlB;;AgN3lsBA;EACE,gBC5Ia;AjN0usBf;;AgN5lsBA;EACE,gBC9Ie;AjN6usBjB;;AgN7lsBA;EACE,gBChJmB;AjNgvsBrB;;AgN9lsBA;EACE,gBClJc;AjNmvsBhB;;AgN/lsBA;EACE,gBCpJiB;AjNsvsBnB;;AgNhmsBA;EACE,gBCtJgB;AjNyvsBlB;;AgNjmsBA;EACE,gBCxJiB;AjN4vsBnB;;AgNlmsBA;EACE,gBC1JiB;AjN+vsBnB;;AgNnmsBA;EACE,gBC5Je;AjNkwsBjB;;AgNpmsBA;EACE,gBC9JgB;AjNqwsBlB;;AgNrmsBA;EACE,gBChKgB;AjNwwsBlB;;AgNtmsBA;EACE,gBClKc;AjN2wsBhB;;AgNvmsBA;EACE,gBCpKiB;AjN8wsBnB;;AgNxmsBA;EACE,gBCtKc;AjNixsBhB;;AgNzmsBA;EACE,gBCxKgB;AjNoxsBlB;;AgN1msBA;EACE,gBC1KgB;AjNuxsBlB;;AgN3msBA;EACE,gBC5KiB;AjN0xsBnB;;AgN5msBA;EACE,gBC9KkB;AjN6xsBpB;;AgN7msBA;EACE,gBChLuB;AjNgysBzB;;AgN9msBA;EACE,gBClLmB;AjNmysBrB;;AgN/msBA;EACE,gBCpLe;AjNsysBjB;;AgNhnsBA;EACE,gBCtLe;AjNyysBjB;;AgNjnsBA;EACE,gBCxLe;AjN4ysBjB;;AgNlnsBA;EACE,gBC1LiB;AjN+ysBnB;;AgNnnsBA;EACE,gBC5Lc;AjNkzsBhB;;AgNpnsBA;EACE,gBC9Lc;AjNqzsBhB;;AgNrnsBA;EACE,gBChMe;AjNwzsBjB;;AgNtnsBA;EACE,gBClMe;AjN2zsBjB;;AgNvnsBA;EACE,gBCpMmB;AjN8zsBrB;;AgNxnsBA;EACE,gBCtMe;AjNi0sBjB;;AgNznsBA;EACE,gBCxMc;AjNo0sBhB;;AgN1nsBA;EACE,gBC1MoB;AjNu0sBtB;;AgN3nsBA;EACE,gBC5Mc;AjN00sBhB;;AgN5nsBA;EACE,gBC9Ma;AjN60sBf;;AgN7nsBA;EACE,gBChNe;AjNg1sBjB;;AgN9nsBA;EACE,gBClNa;AjNm1sBf;;AgN/nsBA;EACE,gBCpNuB;AjNs1sBzB;;AgNhosBA;EACE,gBCtNa;AjNy1sBf;;AgNjosBA;EACE,gBCxNe;AjN41sBjB;;AgNlosBA;EACE,gBC1Nc;AjN+1sBhB;;AgNnosBA;EACE,gBC5Na;AjNk2sBf;;AgNposBA;EACE,gBC9NqB;AjNq2sBvB;;AgNrosBA;EACE,gBChOqB;AjNw2sBvB;;AgNtosBA;EACE,gBClOqB;AjN22sBvB;;AgNvosBA;EACE,gBCpOe;AjN82sBjB;;AgNxosBA;EACE,gBCtOsB;AjNi3sBxB;;AgNzosBA;EACE,gBCxOkB;AjNo3sBpB;;AgN1osBA;EACE,gBC1Oc;AjNu3sBhB;;AgN3osBA;EACE,gBC5Oc;AjN03sBhB;;AgN5osBA;EACE,gBC9OoB;AjN63sBtB;;AgN7osBA;EACE,gBChPmB;AjNg4sBrB;;AgN9osBA;EACE,gBClPe;AjNm4sBjB;;AgN/osBA;EACE,gBCpPe;AjNs4sBjB;;AgNhpsBA;EACE,gBCtPc;AjNy4sBhB;;AgNjpsBA;EACE,gBCxPc;AjN44sBhB;;AgNlpsBA;EACE,gBC1PiB;AjN+4sBnB;;AgNnpsBA;EACE,gBC5Pe;AjNk5sBjB;;AgNppsBA;EACE,gBC9Pc;AjNq5sBhB;;AgNrpsBA;EACE,gBChQa;AjNw5sBf;;AgNtpsBA;EACE,gBClQoB;AjN25sBtB;;AgNvpsBA;EACE,gBCpQc;AjN85sBhB;;AgNxpsBA;EACE,gBCtQmB;AjNi6sBrB;;AgNzpsBA;EACE,gBCxQwB;AjNo6sB1B;;AgN1psBA;EACE,gBC1QgB;AjNu6sBlB;;AgN3psBA;EACE,gBC5Qc;AjN06sBhB;;AgN5psBA;EACE,gBC9Qc;AjN66sBhB;;AgN7psBA;EACE,gBChRc;AjNg7sBhB;;AgN9psBA;EACE,gBClRiB;AjNm7sBnB;;AgN/psBA;EACE,gBCpRc;AjNs7sBhB;;AgNhqsBA;EACE,gBCtRc;AjNy7sBhB;;AgNjqsBA;EACE,gBCxRe;AjN47sBjB;;AgNlqsBA;EACE,gBC1Rc;AjN+7sBhB;;AgNnqsBA;EACE,gBC5RgB;AjNk8sBlB;;AgNpqsBA;EACE,gBC9Rc;AjNq8sBhB;;AgNrqsBA;EACE,gBChSc;AjNw8sBhB;;AgNtqsBA;EACE,gBClSc;AjN28sBhB;;AgNvqsBA;EACE,gBCpSe;AjN88sBjB;;AgNxqsBA;EACE,gBCtSe;AjNi9sBjB;;AgNzqsBA;EACE,gBCxSgB;AjNo9sBlB;;AgN1qsBA;EACE,gBC1SgB;AjNu9sBlB;;AgN3qsBA;EACE,gBC5SgB;AjN09sBlB;;AgN5qsBA;EACE,gBC9Se;AjN69sBjB;;AgN7qsBA;EACE,gBChTgB;AjNg+sBlB;;AgN9qsBA;EACE,gBClTe;AjNm+sBjB;;AgN/qsBA;EACE,gBCpTiB;AjNs+sBnB;;AgNhrsBA;EACE,gBCtTc;AjNy+sBhB;;AgNjrsBA;EACE,gBCxTgB;AjN4+sBlB;;AgNlrsBA;EACE,gBC1Tc;AjN++sBhB;;AgNnrsBA;EACE,gBC5TgB;AjNk/sBlB;;AgNprsBA;EACE,gBC9Tc;AjNq/sBhB;;AgNrrsBA;EACE,gBChUiB;AjNw/sBnB;;AgNtrsBA;EACE,gBClUiB;AjN2/sBnB;;AgNvrsBA;EACE,gBCpUc;AjN8/sBhB;;AgNxrsBA;EACE,gBCtUc;AjNigtBhB;;AgNzrsBA;EACE,gBCxUgB;AjNogtBlB;;AgN1rsBA;EACE,gBC1UkB;AjNugtBpB;;AgN3rsBA;EACE,gBC5UkB;AjN0gtBpB;;AgN5rsBA;EACE,gBC9UkB;AjN6gtBpB;;AgN7rsBA;EACE,gBChVkB;AjNghtBpB;;AgN9rsBA;EACE,gBClVc;AjNmhtBhB;;AgN/rsBA;EACE,gBCpVa;AjNshtBf;;AgNhssBA;EACE,gBCtViB;AjNyhtBnB;;AgNjssBA;EACE,gBCxVc;AjN4htBhB;;AgNlssBA;EACE,gBC1VgB;AjN+htBlB;;AgNnssBA;EACE,gBC5VmB;AjNkitBrB;;AgNpssBA;EACE,gBC9VgB;AjNqitBlB;;AgNrssBA;EACE,gBChWiB;AjNwitBnB;;AgNtssBA;EACE,gBClWiB;AjN2itBnB;;AgNvssBA;EACE,gBCpWgB;AjN8itBlB;;AgNxssBA;EACE,gBCtWe;AjNijtBjB;;AgNzssBA;EACE,gBCxWe;AjNojtBjB;;AgN1ssBA;EACE,gBC1We;AjNujtBjB;;AgN3ssBA;EACE,gBC5Wc;AjN0jtBhB;;AgN5ssBA;EACE,gBC9Wc;AjN6jtBhB;;AgN7ssBA;EACE,gBChXgB;AjNgktBlB;;AgN9ssBA;EACE,gBClXc;AjNmktBhB;;AgN/ssBA;EACE,gBCpXoB;AjNsktBtB;;AgNhtsBA;EACE,gBCtXiB;AjNyktBnB;;AgNjtsBA;EACE,gBCxXc;AjN4ktBhB;;AgNltsBA;EACE,gBC1Xc;AjN+ktBhB;;AgNntsBA;EACE,gBC5XmB;AjNkltBrB;;AgNptsBA;EACE,gBC9XiB;AjNqltBnB;;AgNrtsBA;EACE,gBChYc;AjNwltBhB;;AgNttsBA;EACE,gBClYiB;AjN2ltBnB;;AgNvtsBA;EACE,gBCpYc;AjN8ltBhB;;AgNxtsBA;EACE,gBCtYc;AjNimtBhB;;AgNztsBA;EACE,gBCxYmB;AjNomtBrB;;AgN1tsBA;EACE,gBC1YgB;AjNumtBlB;;AgN3tsBA;EACE,gBC5YgB;AjN0mtBlB;;AgN5tsBA;EACE,gBC9Ye;AjN6mtBjB;;AgN7tsBA;EACE,gBChZiB;AjNgntBnB;;AkN7ztBA;;;EACE,iBAAA;EACA,kBAAA;AlNk0tBF;AkNh0tBE;;;;;EAEE,uBAAA;EACA,kBAAA;EACA,6BAAA;EAEA,SAAA;EACA,UAAA;AlNo0tBJ;AkNj0tBE;;;EACE,WAAA;EACA,WAAA;EACA,iBCEwB;EDAxB,UAAA;EACA,4BjNHO;ADu0tBX;;AkNh0tBA;EAGE,MAAA;EACA,gBAAA;AlNi0tBF;AkN/ztBE;EAEE,gBAAA;EACA,yBjNnBI;ADm1tBR;AkN7ztBE;EACE,SAAA;EACA,4BjNrBO;ADo1tBX;;AkN3ztBA;;;EAGE,SAAA;EACA,mBAAA;AlN8ztBF;AkN5ztBE;;;;;EAEE,mBAAA;EACA,sBAAA;AlNi0tBJ;AkN9ztBE;;;EACE,YAAA;EACA,yBjNvCO;ADy2tBX;;AoNv3tBA;EACE,cAAA;EACA,YAAA;ApN03tBF;;AoNv3tBA;EACE,sBnNKM;EmNJN,cnNWS;EmNVT,yBAAA;EACA,sB7M8N4B;E6M7N5B,qBAAA;EACA,kBAAA;EAEA,0UnN+FmB;AD0xtBrB;;AoNr3tBE;EACE,UAAA;ApNw3tBJ;AoNr3tBE;EACE,cAAA;ApNu3tBJ;AoNp3tBE;EACE,qBAAA;ApNs3tBJ;AoNn3tBE;EACE,qBAAA;ApNq3tBJ;;AoNj3tBA;EACE,kBAAA;EACA,UAAA;ApNo3tBF;;AoNj3tBA;EACE,YAAA;ApNo3tBF;AoNl3tBE;EACE,eAAA;ApNo3tBJ;AoN72tBE;EACE,kBAAA;ApN+2tBJ;AoNx2tBE;EACE,gBD3CwB;AnNq5tB5B;AoNx2tBI;EACE,UAAA;EACA,WAAA;ApN02tBN;AoNt2tBE;EACE,iBDpDwB;AnN45tB5B;AoNt2tBI;EACE,UAAA;EACA,WAAA;ApNw2tBN;;AoNn2tBA;EACE,kBAAA;EACA,sBnNpEM;EmNqEN,gCAAA;EACA,+B7MsJ4B;E6MrJ5B,gC7MqJ4B;E6MpJ5B,iBAAA;EACA,kBAAA;ApNs2tBF;AoNp2tBE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;ApNs2tBJ;;AoNl2tBA;;;;;;EAME,qBAAA;EACA,aAAA;ApNq2tBF;;AoNl2tBA;;EAEE,aAAA;EACA,cnNvFS;EmNwFT,iBAAA;EACA,mBAAA;ApNq2tBF;;AoNl2tBA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;ApNq2tBF;;AoNl2tBA;EACE,gBAAA;EACA,iBD1GsB;EC2GtB,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iCAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;ApNq2tBF;AoNn2tBE;EACE,UAAA;EACA,2BnNvHO;AD49tBX;AoNn2tBI;EACE,sEAAA;ApNq2tBN;AoNl2tBI;EAEE,qEDxIkC;ECyIlC,eAAA;ApNm2tBN;AoN/1tBE;EACE,WAAA;EACA,0BnNtIO;ADu+tBX;AoN/1tBI;EACE,WAAA;ApNi2tBN;AoN91tBI;EACE,qEAAA;ApNg2tBN;AoN71tBI;EAEE,oED3JkC;EC4JlC,eAAA;ApN81tBN;AoN11tBE;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;ApN41tBJ;AoN11tBI;EACE,QAAA;EACA,yBnNhKK;AD4/tBX;AoN11tBM;EACE,oEAAA;ApN41tBR;AoNx1tBI;EACE,SAAA;EACA,4BnNzKK;ADmguBX;AoNx1tBM;EACE,uEAAA;ApN01tBR;;AoNp1tBA;EACE,WAAA;ApNu1tBF;;AoNp1tBA;EACE,cDxLmB;ECyLnB,kBAAA;ApNu1tBF;;AoNp1tBA;EACE,YAAA;EACA,8BAAA;EACA,YAAA;ApNu1tBF;AoNr1tBE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;ApNu1tBJ;AoNp1tBE;EACE,kBAAA;EACA,iBAAA;ApNs1tBJ;AoNp1tBI;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;ApNs1tBN;AoNp1tBM;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;ApNs1tBR;AoNp1tBQ;EACE,iBAAA;ApNs1tBV;AoNp1tBU;EACE,eAAA;EACA,yBnNxIa;AD89tBzB;AoNn1tBU;EACE,yBDjPiB;ECkPjB,WnN1OJ;EmN2OI,iBAAA;ApNq1tBZ;AoNn1tBY;EACE,yBDtPe;AnN2kuB7B;AoNj1tBU;EACE,cnN/OD;ADkkuBX;AoNj1tBY;EACE,eAAA;EACA,6BAAA;ApNm1tBd;;AoN10tBA;EACE,cnN7PS;EmN8PT,qBAAA;EACA,WDjQsB;ECkQtB,iBDlQsB;ECmQtB,kBAAA;EACA,gBDvQuB;AnNoluBzB;AoN30tBE;EACE,eAAA;ApN60tBJ;AoN30tBI;EACE,sB7MhDwB;E6MiDxB,sBnN7QE;AD0luBR;;AoNx0tBA;EACE,mBnNlRS;EmNmRT,6BAAA;EACA,gBAAA;ApN20tBF;;AoNx0tBA;;EAEE,mBAAA;ApN20tBF;;AoNx0tBA;;;EAGE,cnNzRS;EmN0RT,qBAAA;EACA,WDhSsB;ECiStB,iBDjSsB;ECkStB,kBAAA;EACA,gBDtSuB;AnNinuBzB;;AoNx0tBA;EACE,eAAA;EvMlTE,sBNqO0B;APy5tB9B;AoNz0tBE;EACE,yBnN/QI;EmNgRJ,WnN9SI;ADynuBR;AoNx0tBE;EACE,iBAAA;ApN00tBJ;AoNv0tBE;EACE,sB7M1F0B;E6M2F1B,yBnNzRI;EmN0RJ,WnNxTI;ADiouBR;AoNv0tBI;EACE,qEAAA;ApNy0tBN;AoNt0tBI;EACE,cnN1RG;ADkmuBT;AoNr0tBI;EACE,cnNnSG;AD0muBT;AoNn0tBE;EACE,yBnNlSI;EmNmSJ,WnNzUI;AD8ouBR;AoNn0tBI;EACE,yBnNtSE;EmNuSF,WnN7UE;ADkpuBR;AoNj0tBE;EAEE,yBnNtPqB;EmNuPrB,uD7M2ZgC;APu6sBpC;AoNh0tBI;EACE,yBnN1PmB;EmN2PnB,uD7MuZ8B;AP26sBpC;AoN7ztBE;EACE,sB7MlI0B;E6MmI1B,qEAAA;EACA,WnNhWI;AD+puBR;AoN7ztBI;EACE,oEAAA;ApN+ztBN;AoN3ztBE;EACE,yBnN3QqB;ADwkuBzB;AoNzztBI;EACE,yBnNvUE;EmNwUF,WnN9WE;ADyquBR;AoNvztBE;EACE,eAAA;EACA,cnNhXO;ADyquBX;AoNvztBI;EACE,6BAAA;EACA,cnNpXK;AD6quBX;;AoNnztBA;;EAEE,oCAAA;EACA,sBAAA;ApNsztBF;;AoNnztBA;;;EAGE,6BAAA;EACA,sB7M5K4B;APk+tB9B;AoNpztBE;;;EACE,eAAA;ApNwztBJ;AoNtztBI;;;;;;EAEE,oEAAA;ApN4ztBN;AoNxztBE;;;EAEE,yBnNjZO;EmNkZP,YAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,qBDtZ0B;AnNituB9B;;AoNvztBA;;;EAGE,sBnNjaM;EmNkaN,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,sB7M5M4B;E6M6M5B,yBAAA;ApN0ztBF;AoNxztBE;;;EACE,eAAA;ApN4ztBJ;AoNzztBE;;;EACE,aAAA;EACA,kBAAA;ApN6ztBJ;;AoNzztBA;;;EAGE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;ApN4ztBF;AoN1ztBE;;;EACE,+B7MnO0B;E6MoO1B,gC7MpO0B;APkiuB9B;AoN3ztBE;;;EACE,yBAAA;EAGA,iBAAA;EACA,kC7M5O0B;E6M6O1B,mC7M7O0B;AP4iuB9B;AoN5ztBE;;;EACE,yBnNzcO;ADywuBX;AoN9ztBI;;;EACE,uEAAA;ApNk0tBN;AoN/ztBI;;;EACE,oEAAA;ApNm0tBN;AoN/ztBE;;;EACE,kBAAA;EACA,UAAA;ApNm0tBJ;;AoN/ztBA;EACE,6BAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;ApNk0tBF;AoNh0tBE;EACE,yBDpfyB;ECqfzB,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,WnNhfI;EmNifJ,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;ApNk0tBJ;;AoN9ztBA;EACE,gBnNhgBM;EmNigBN,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;ApNi0tBF;;AoN9ztBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,a7M6IkC;E6M5IlC,oCAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;ApNi0tBF;AoN/ztBE;;;EAGE,WAAA;EACA,iBAAA;ApNi0tBJ;AoN7ztBE;EACE;;;IAGE,WAAA;IACA,iBAAA;EpN+ztBJ;AACF;AoN5ztBE;;EAEE,mBAAA;ApN8ztBJ;AoN3ztBE;EACE,iCAAA;EACA,eAAA;ApN6ztBJ;AoN1ztBE;EACE,2BnNnhBI;AD+0uBR;AoN1ztBI;EACE,sEAAA;ApN4ztBN;AoNzztBI;EAEE,qED9jBkC;EC+jBlC,eAAA;ApN0ztBN;AoNtztBE;EACE,0BnNjiBI;ADy1uBR;AoNtztBI;EACE,qEAAA;ApNwztBN;AoNrztBI;EAEE,oED5kBkC;EC6kBlC,eAAA;ApNsztBN;;AoNjztBA;EACE,8BAAA;ApNoztBF;;AoNjztBA;EACE,wBAAA;EACA,yBAAA;ApNoztBF;;AqNr5uBA;EACE,YAAA;ArNw5uBF;;AqNr5uBA;;EAEE,cAAA;ArNw5uBF;;AqNr5uBA;;EAEE,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,+DAAA;EACA,4BAAA;ArNw5uBF;;AqNr5uBA;EACE,wBAAA;EACA,yBAAA;EACA,8DAAA;EACA,4BAAA;ArNw5uBF;;AqNr5uBA;;EAEE,+BAAA;EACA,6BAAA;ArNw5uBF;;AqNr5uBA;EACE,gCAAA;EACA,6BAAA;ArNw5uBF;;AqNr5uBA;EACE;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;ErNw5uBF;EqNt5uBA;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;ErNw5uBF;AACF;AqNr5uBA;EACE;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;ErNu5uBF;EqNr5uBA;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;ErNu5uBF;AACF;AqNp5uBA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;ArNs5uBF;;AqNn5uBA;EACE,aAAA;ArNs5uBF;;AqNn5uBA;;;EAGE,oBAAA;ArNs5uBF;;AqNn5uBA;;;EAGE,oBAAA;ArNs5uBF;;AqNn5uBA;;;EAGE,oBAAA;ArNs5uBF;;AqNn5uBA;;;EAGE,oBAAA;ArNs5uBF;;AqNn5uBA;EACE,kBAAA;EACA,WpNxFM;EoNyFN,gBAAA;EACA,qBAAA;EACA,yBpNnFS;EoNoFT,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;ArNs5uBF;;AqNn5uBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;ArNs5uBF;;AqNn5uBA;;;EAGE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBpNxGS;AD8/uBX;;AqNn5uBA;EACE,SAAA;ArNs5uBF;;AqNn5uBA;EACE,SAAA;ArNs5uBF;;AqNn5uBA;EACE,UAAA;ArNs5uBF;;AqNn5uBA;;;EAGE,SAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BpN7HS;ADmhvBX;;AqNn5uBA;EACE,QAAA;ArNs5uBF;;AqNn5uBA;EACE,QAAA;EACA,aAAA;ArNs5uBF;;AqNn5uBA;EACE,WAAA;ArNs5uBF;;AqNn5uBA;;;EAGE,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BpNnJS;ADyivBX;;AqNn5uBA;EACE,QAAA;ArNs5uBF;;AqNn5uBA;EACE,QAAA;EACA,aAAA;ArNs5uBF;;AqNn5uBA;EACE,WAAA;ArNs5uBF;;AqNn5uBA;;;EAGE,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,4BpNzKS;AD+jvBX;;AqNn5uBA;EACE,SAAA;ArNs5uBF;;AqNn5uBA;EACE,SAAA;ArNs5uBF;;AqNn5uBA;EACE,UAAA;ArNs5uBF;;AsN/lvBA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EzMDE,sBNqO0B;E+MjO5B,kBAAA;EACA,sBAAA;EACA,6CAAA;AtNkmvBF;;AsN/lvBA;EACE,kBAAA;EACA,WAAA;EACA,yBrNDS;EqNET,WAAA;EzMbE,sBNqO0B;AP24uB9B;;AsN/lvBA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EzMpBE,sBNqO0B;E+M/M5B,yBrNiBM;ADilvBR;;AsN/lvBA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBrN3BM;EqN6BN,mBAAA;EACA,4BAAA;AtNkmvBF;AsNhmvBE;EACE,aAAA;AtNkmvBJ;AsN/lvBE;EAGE,iEAAA;EACA,sGAAA;AtN+lvBJ;AsN3lvBE;EAEE,gBAAA;AtN6lvBJ;;AsNzlvBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;AtN4lvBF;;AsNzlvBA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,crN1DS;ADspvBX;;AsNzlvBA;EACE,crN5DS;ADwpvBX;;AsNzlvBA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;AtN4lvBF;;AsNzlvBA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,sBrNrFM;EqNsFN,eAAA;EACA,kBAAA;EACA,sBAAA;AtN4lvBF;;AsNzlvBA;EACE,qBrN9DM;AD0pvBR;;AsNzlvBA;EACE,yBrN9FS;AD0rvBX;;AsNzlvBA;EACE,yBrNhGS;AD4rvBX;;AsNzlvBA;;EAEE,qBrNrGS;EqNsGT,gBAAA;EACA,sBrN3GM;EqN4GN,mBAAA;AtN4lvBF;;AsNzlvBA;;EAEE,8BAAA;AtN4lvBF;;AsNzlvBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AtN4lvBF;;AsNzlvBA;EACE,YAAA;EACA,UAAA;AtN4lvBF;;AsNzlvBA;EACE,SAAA;EACA,SAAA;EACA,UAAA;AtN4lvBF;;AsNzlvBA;EACE,iBAAA;EACA,mBAAA;EAEA,mBAAA;AtN4lvBF;;AsNzlvBA;EACE,MAAA;EACA,UAAA;EACA,YAAA;AtN4lvBF;;AsNzlvBA;EACE,YAAA;EACA,UAAA;AtN4lvBF;;AsNzlvBA;EACE,SAAA;EACA,mBAAA;AtN4lvBF;;AsNzlvBA;EACE,mBAAA;AtN4lvBF;;AsNzlvBA;EACE,mBAAA;AtN4lvBF;;AsNzlvBA;;EAEE,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;AtN4lvBF;;AsNzlvBA;EACE,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;AtN4lvBF;;AsNzlvBA;;EAEE,yCAAA;EACA,6BAAA;AtN4lvBF;;AsNzlvBA;EACE,0CAAA;EACA,6BAAA;AtN4lvBF;;AsNzlvBA;;EAEE,sBAAA;EACA,yDAAA;AtN4lvBF;;AsNzlvBA;EACE,iEAAA;AtN4lvBF;;AsNzlvBA;EACE;IACE,UAAA;IACA,0BAAA;IACA,sBAAA;EtN4lvBF;EsN1lvBA;IACE,0BAAA;IACA,sBAAA;EtN4lvBF;AACF;AsNzlvBA;EACE;IACE,0BAAA;IACA,sBAAA;EtN2lvBF;EsNzlvBA;IACE,UAAA;IACA,0BAAA;IACA,sBAAA;EtN2lvBF;AACF;AsNxlvBA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,6CAAA;AtN0lvBF;;AsNvlvBA;EACE,aAAA;AtN0lvBF;;AsNvlvBA;EACE,oBAAA;AtN0lvBF;;AsNvlvBA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WrNtPM;EqNuPN,kBAAA;EACA,qBAAA;EACA,yBrNhPS;EYlBP,sBNqO0B;E+M+B5B,0UrN1JmB;EqN2JnB,iBAAA;AtN0lvBF;;AsNvlvBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;AtN0lvBF;;AsNvlvBA;EACE,WAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBrNnQS;AD61vBX;;AsNnlvBI;EACE,yBrN5NS;ADkzvBf;AsNnlvBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;AD82vBR;AsNnlvBM;EAGE,iEAAA;EACA,sGAAA;AtNmlvBR;AsN9kvBI;EACE,qBrN7OS;AD6zvBf;;AsNlmvBI;EACE,yBrN5NS;ADi0vBf;AsNlmvBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;AD63vBR;AsNlmvBM;EAGE,iEAAA;EACA,0GAAA;AtNkmvBR;AsN7lvBI;EACE,qBrN7OS;AD40vBf;;AsNjnvBI;EACE,yBrN5NS;ADg1vBf;AsNjnvBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;AD44vBR;AsNjnvBM;EAGE,iEAAA;EACA,wGAAA;AtNinvBR;AsN5mvBI;EACE,qBrN7OS;AD21vBf;;AsNhovBI;EACE,yBrN5NS;AD+1vBf;AsNhovBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;AD25vBR;AsNhovBM;EAGE,qDAAA;EACA,wGAAA;AtNgovBR;AsN3nvBI;EACE,qBrN7OS;AD02vBf;;AsN/ovBI;EACE,yBrN5NS;AD82vBf;AsN/ovBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;AD06vBR;AsN/ovBM;EAGE,8DAAA;EACA,wGAAA;AtN+ovBR;AsN1ovBI;EACE,qBrN7OS;ADy3vBf;;AsN9pvBI;EACE,yBrN5NS;AD63vBf;AsN9pvBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;ADy7vBR;AsN9pvBM;EAGE,gEAAA;EACA,sGAAA;AtN8pvBR;AsNzpvBI;EACE,qBrN7OS;ADw4vBf;;AsN7qvBI;EACE,yBrN5NS;AD44vBf;AsN7qvBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;ADw8vBR;AsN7qvBM;EAGE,iEAAA;EACA,0GAAA;AtN6qvBR;AsNxqvBI;EACE,qBrN7OS;ADu5vBf;;AsN5rvBI;EACE,yBrN5NS;AD25vBf;AsN5rvBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;ADu9vBR;AsN5rvBM;EAGE,8DAAA;EACA,oGAAA;AtN4rvBR;AsNvrvBI;EACE,qBrN7OS;ADs6vBf;;AsN3svBI;EACE,yBrN5NS;AD06vBf;AsN3svBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;ADs+vBR;AsN3svBM;EAGE,iEAAA;EACA,oGAAA;AtN2svBR;AsNtsvBI;EACE,qBrN7OS;ADq7vBf;;AsN1tvBI;EACE,yBrN5NS;ADy7vBf;AsN1tvBI;EACE,qBrNhOS;EqNiOT,sBrNzRE;ADq/vBR;AsN1tvBM;EAGE,gEAAA;EACA,wGAAA;AtN0tvBR;AsNrtvBI;EACE,qBrN7OS;ADo8vBf;;AsN/svBE;EzMtTE,gByMuTuB;EACvB,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,wCAAA;AtNktvBJ;;AsN7svBE;EzMjUE,kByMkUuB;EACvB,iBAAA;AtNgtvBJ;AsN9svBI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;AtNgtvBN;;AsNxsvBE;EACE,YAAA;EACA,gBAAA;AtN2svBJ;AsNxsvBE;EACE,WAAA;AtN0svBJ;AsNvsvBE;EACE,WAAA;AtNysvBJ;AsNtsvBE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AtNwsvBJ;AsNpsvBI;EACE,iBAAA;EACA,WAAA;AtNssvBN;AsNhsvBM;EACE,YAAA;EACA,UAAA;EACA,iBAAA;AtNksvBR;;AsN1rvBE;EACE,YAAA;EACA,gBAAA;AtN6rvBJ;AsN1rvBE;EACE,WAAA;AtN4rvBJ;AsNzrvBE;EACE,WAAA;AtN2rvBJ;AsNxrvBE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AtN0rvBJ;AsNtrvBI;EACE,iBAAA;EACA,WAAA;AtNwrvBN;AsNlrvBM;EACE,WAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,mBrNnZG;ADukwBX;;AuN1lwBA;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AvN6lwBF;;AuN3lwBA;EACE,+BAAA;AvN8lwBF;;AuN5lwBA;EACE,qCAAA;AvN+lwBF;;AuN7lwBA;EACE,qCAAA;AvNgmwBF;;AuN9lwBA;EACE,YAAA;EACA,eAAA;AvNimwBF;;AuN/lwBA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;AvNkmwBF;;AuNhmwBA;EACE,aAAA;AvNmmwBF;;AuNjmwBA;EACE,+BAAA;EACA,yBAAA;AvNomwBF;;AuNlmwBA;EACE,qCAAA;AvNqmwBF;;AuNnmwBA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;AvNsmwBF;;AuNpmwBA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;AvNumwBF;;AuNrmwBA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AvNwmwBF;;AuNtmwBA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AvNymwBF;;AuNvmwBA;EACE,+BAAA;EACA,yBAAA;AvN0mwBF;;AuNxmwBA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AvN2mwBF;;AuNzmwBA;EACE,mBAAA;AvN4mwBF;;AuN1mwBA;EACE,mBAAA;AvN6mwBF;;AuN3mwBA;EACE,YAAA;EACA,eAAA;AvN8mwBF;;AuN5mwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AvN+mwBF;;AuN7mwBA;EACE,WAAA;AvNgnwBF;;AuN9mwBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AvNinwBF;;AuN/mwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AvNknwBF;;AuNhnwBA;EACE,YAAA;AvNmnwBF;;AuNjnwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AvNonwBF;;AuNlnwBA;EACE,eAAA;AvNqnwBF;;AuNnnwBA;EACE,aAAA;EACA,uBAAA;AvNsnwBF;;AuNpnwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AvNunwBF;;AuNrnwBA;EACE,YAAA;AvNwnwBF;;AuNtnwBA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AvNynwBF;;AuNvnwBA;EACE,YAAA;AvN0nwBF;;AuNxnwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AvN2nwBF;;AuNznwBA;EACE,WAAA;EACA,WAAA;AvN4nwBF;;AuN1nwBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AvN6nwBF;;AuN3nwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AvN8nwBF;;AuN5nwBA;EACE,WAAA;EACA,WAAA;AvN+nwBF;;AuN7nwBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AvNgowBF;;AuN9nwBA;EACE,iBAAA;AvNiowBF;;AuN/nwBA;EACE,2BAAA;AvNkowBF;;AuNhowBA;EACE,6BAAA;AvNmowBF;;AuNjowBA;EACE,8BAAA;AvNoowBF;;AuNlowBA;EACE,qBAAA;AvNqowBF;;AuNnowBA;EACE,qBAAA;AvNsowBF;;AuNpowBA;EACE,qBAAA;AvNuowBF;;AuNrowBA;EACE,qBAAA;AvNwowBF;;AuNtowBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AvNyowBF;;AuNvowBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;AvN0owBF;;AuNxowBA;EACE,aAAA;EACA,mBAAA;AvN2owBF;;AuNzowBA;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AvN4owBF;;AuN1owBA;EACE,gCAAA;AvN6owBF;;AuN3owBA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AvN8owBF;;AuN5owBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AvN+owBF;;AuN7owBA;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;AvNgpwBF;;AuN9owBA;EACE,+BAAA;AvNipwBF;;AuN/owBA;EACE,iCAAA;AvNkpwBF;;AuNhpwBA;EACE,mCAAA;AvNmpwBF;;AuNjpwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AvNopwBF;;AuNlpwBA;EACE,WAAA;AvNqpwBF;;AuNnpwBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AvNspwBF;;AuNppwBA;EACE,gBAAA;AvNupwBF;;AuNrpwBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;AvNwpwBF;;AuNtpwBA;EACE,eAAA;AvNypwBF;;AuNvpwBA;EACE,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AvN0pwBF;;AuNxpwBA;EACE,aAAA;AvN2pwBF;;AuNzpwBA;EACE,cAAA;AvN4pwBF;;AuN1pwBA;EACE,mBAAA;AvN6pwBF;;AuN3pwBA;EACE,gBAAA;AvN8pwBF;;AuN5pwBA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AvN+pwBF;;AuN7pwBA;EACE,+BAAA;AvNgqwBF;;AuN9pwBA;EACE,qCAAA;AvNiqwBF;;AuN/pwBA;EACE,wBAAA;AvNkqwBF;;AuNhqwBA;EACE,mBAAA;AvNmqwBF;;AuNjqwBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AvNoqwBF;;AuNlqwBA;EACE,WAAA;AvNqqwBF;;AuNnqwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AvNsqwBF;;AuNpqwBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,+BAAA;AvNuqwBF;;AuNrqwBA;EACE,eAAA;EACA,aAAA;AvNwqwBF;;AuNtqwBA;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AvNyqwBF;;AuNvqwBA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;AvN0qwBF;;AuNxqwBA;EACE,aAAA;EACA,sBAAA;AvN2qwBF;;AuNzqwBA;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AvN4qwBF;;AuN1qwBA;EACE,aAAA;EACA,mBAAA;AvN6qwBF;;AuN3qwBA;EACE,aAAA;AvN8qwBF;;AuN5qwBA;EACE,aAAA;EACA,uBAAA;AvN+qwBF;;AuN7qwBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AvNgrwBF;;AuN9qwBA;EACE,+BAAA;AvNirwBF;;AuN/qwBA;EACE,qCAAA;AvNkrwBF;;AuNhrwBA;EACE,wBAAA;AvNmrwBF;;AuNjrwBA;EACE,mBAAA;AvNorwBF;;AuNlrwBA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;AvNqrwBF;;AuNnrwBA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AvNsrwBF;;AuNprwBA;EACE,aAAA;AvNurwBF;;AuNrrwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AvNwrwBF;;AuNtrwBA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;AvNyrwBF;;AuNvrwBA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AvN0rwBF;;AuNxrwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AvN2rwBF;;AuNzrwBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,qBAAA;EAEA,wDAAA;AvN2rwBF;;AuNzrwBA;EAEE,uBAAA;AvN4rwBF;;AuN1rwBA;EAEE,uBAAA;AvN6rwBF;AuNvrwBA;EACE;IAEE,mBAAA;EvNkswBF;EuNjswBE;IAEA,mBAAA;EvNmswBF;AACF;AuNjswBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AvNmswBF;;AuNjswBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;AvNoswBF;;AuNlswBA;EACE,eAAA;EACA,cAAA;EACA,aAAA;AvNqswBF;;AuNnswBA;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AvNsswBF;;AuNpswBA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AvNuswBF;;AuNrswBA;EACE,mBAAA;EACA,gCAAA;AvNwswBF;;AuNtswBA;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,cAAA;EACA,cAAA;AvNyswBF;;AuNvswBA;EACE,2BAAA;AvN0swBF;;AuNxswBA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AvN2swBF;;AuNzswBA;EACE,eAAA;AvN4swBF;;AuN1swBA;EACE,eAAA;EACA,iBAAA;AvN6swBF;;AuN3swBA;EACC,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AvN8swBD;;AuN5swBA;EACE,aAAA;EACA,mBAAA;AvN+swBF;;AuN7swBA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AvNgtwBF;;AuN9swBA;EACE,mBAAA;AvNitwBF;;AuN/swBA;EACE,aAAA;AvNktwBF;;AuNhtwBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AvNmtwBF;;AuNjtwBA;EACE,+BAAA;AvNotwBF;;AuNltwBA;EACE,qCAAA;AvNqtwBF;;AuNntwBA;EACE,wBAAA;AvNstwBF;;AuNptwBA;EACE,mBAAA;AvNutwBF;;AuNrtwBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AvNwtwBF;;AuNttwBA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AvNytwBF;;AuNvtwBA;EACE,aAAA;AvN0twBF;;AuNxtwBA;EACE,eAAA;AvN2twBF;;AuNztwBA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;AvN4twBF;;AuN1twBA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AvN6twBF;;AuN3twBA;EACE,aAAA;AvN8twBF;;AuN5twBA;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;AvN+twBF;;AuN7twBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AvNguwBF;;AuN9twBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AvNiuwBF;;AuN/twBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AvNkuwBF;;AuNhuwBA;EACE,WAAA;AvNmuwBF;;AuNjuwBA;EACE,kBAAA;AvNouwBF;;AuNluwBA;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,eAAA;EACA,uBAAA;AvNquwBF;;AuNnuwBA;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AvNsuwBF;;AuNpuwBA;EACE,kBAAA;AvNuuwBF;;AuNruwBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AvNwuwBF;;AuNtuwBA;EACE,gBAAA;EACA,gCAAA;AvNyuwBF;;AuNvuwBA;EACE,yBAAA;AvN0uwBF;;AuNxuwBA;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AvN2uwBF;;AuNzuwBA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AvN4uwBF;;AuN1uwBA;EACE,2BAAA;AvN6uwBF;;AuN3uwBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AvN8uwBF;;AuN5uwBA;EACE,kBAAA;AvN+uwBF;;AuN7uwBA;EACE,kBAAA;AvNgvwBF;;AuN9uwBA;EACE,aAAA;EACA,uBAAA;AvNivwBF;;AuN/uwBA;EACE,aAAA;AvNkvwBF;;AuNhvwBA;EACE,aAAA;EACA,yBAAA;AvNmvwBF;;AuNjvwBA;EACE,QAAA;AvNovwBF;;AuNlvwBA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;AvNqvwBF;;AuNnvwBA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AvNsvwBF;;AuNpvwBA;EACE,aAAA;AvNuvwBF;;AuNrvwBA;EACE,aAAA;AvNwvwBF;;AuNtvwBA;EACE,uBAAA;AvNyvwBF;;AuNvvwBA;EACE,8BAAA;EACA,iBAAA;AvN0vwBF;;AuNxvwBA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;AvN2vwBF,EuN1vwBC;;;;;;;;;CAAA;AAUD;EAA2E,eAAA;EAAe,gBAAA;EAAA,mBAAA;AvN6vwB1F;;AuN7vwB6G;EAAkD,8CAAA;AvNiwwB/J;;AuNjwwB6M;EAAkB,kBAAA;AvNqwwB/N;;AuNrwwBiP;EAA6B,wCAAA;EAAqC,oCAAA;EAAmC,kBAAA;EAAkB,UAAA;AvN4wwBxW;;AuN5wwBkX;EAA0B,kBAAA;AvNgxwB5Y;;AuNhxwB8Z;EAAuD,gBAAA;AvNoxwBrd;;AuNpxwBqe;EAA2D,OAAA;EAAO,gBAAA;AvNyxwBviB;;AuNzxwBujB;EAAyD,kBAAA;AvN6xwBhnB;;AuN7xwBkoB;EAA6D,cAAA;EAAc,kBAAA;EAAkB,WAAA;AvNmywB/tB;;AuNnywB0uB;EAAwD,iBAAA;AvNuywBlyB;;AuNvywBmzB;EAA4D,QAAA;EAAQ,iBAAA;AvN4ywBv3B;;AuN5ywBw4B;EAAoC,cAAA;EAAc,kBAAA;EAAkB,UAAA;AvNkzwB58B;;AuNlzwBs9B;EAAwC,cAAA;AvNszwB9/B;;AuNtzwB4gC;EAA+B,aAAA;AvN0zwB3iC;;AuN1zwBwjC;EAAgC,kBAAA;EAAkB,qBAAA;AvN+zwB1mC;;AuN/zwB+nC;EAA8B,cAAA;EAAc,gBAAA;AvNo0wB3qC;;AuNp0wB2rC;EAA8B,cAAA;EAAc,iBAAA;AvNy0wBvuC;;AuNz0wBwvC;EAAkC,cAAA;AvN60wB1xC;;AuN70wBwyC;EAAkC,cAAA;AvNi1wB10C;;AuNj1wBw1C;EAA0D,cAAA;EAAc,UAAA;AvNs1wBh6C;;AuNt1wB06C;EAAkE,kBAAA;AvN01wB5+C;;AuN11wB8/C;EAAkE,mBAAA;AvN81wBhkD;;AuN91wBmlD;EAAkE,gBAAA;AvNk2wBrpD;;AuNl2wBqqD;EAAkE,iBAAA;AvNs2wBvuD;;AuNt2wBwvD;EAAkE,kBAAA;AvN02wB1zD;;AuN12wB40D;EAAkE,mBAAA;AvN82wB94D;;AuN92wBi6D;EAAkE,gBAAA;AvNk3wBn+D;;AuNl3wBm/D;EAAkE,iBAAA;AvNs3wBrjE;;AuNt3wBskE;EAAkE,kBAAA;AvN03wBxoE;;AuN13wB0pE;EAAkE,mBAAA;AvN83wB5tE;;AuN93wB+uE;EAA4C,uBAAA;EAAuB,kBAAA;AvNm4wBlzE;;AuNn4wBo0E;EAA4E,qBAAA;AvNu4wBh5E;;AuNv4wBq6E;EAA4E,uBAAA;AvN24wBj/E;;AuN34wBwgF;EAA0C,qBAAA;EAAqB,kBAAA;AvNg5wBvkF;;AuNh5wBylF;EAAkF,WAAA;EAAW,kBAAA;EAAkB,iBAAA;EAAiB,WAAA;AvNu5wBztF;;AuNv5wBouF;EAAkF,kBAAA;EAAkB,YAAA;EAAY,gBAAA;EAAgB,WAAA;AvN85wBp2F;;AuN95wB+2F;EAAiD,0BAAA;EAA0B,sBAAA;AvNm6wB17F;;AuNn6wBg9F;EAAiF,0BAAA;EAA0B,sBAAA;AvNw6wB3jG;;AuNx6wBilG;EAAiF,0BAAA;EAA0B,sBAAA;AvN66wB5rG;;AuN76wBktG;EAAiF,0BAAA;EAA0B,sBAAA;AvNk7wB7zG;;AuNl7wBm1G;EAAiF,0BAAA;EAA0B,sBAAA;AvNu7wB97G;;AuNv7wBo9G;EAAgE,kBAAA;AvN27wBphH;;AuN37wBsiH;EAAgE,kBAAA;AvN+7wBtmH;;AuN/7wBwnH;EAAgE,kBAAA;AvNm8wBxrH;;AuNn8wB0sH;EAAgE,kBAAA;AvNu8wB1wH;;AuNv8wB4xH;EAAgE,kBAAA;AvN28wB51H;;AuNz8wBA;EACE,wBAAA;EACA,oCAAA;EACA,uBAAA;EACA,6BAAA;AvN48wBF;;AwNhyyBA;EACE,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;AxNmyyBF;;AwNhyyBA;EACE,YAAA;EACA,yBAAA;EACA,0BAAA;AxNmyyBF;;AwNjyyBA;;EAEE,0BAAA;AxNoyyBF;;AwNlyyBA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;AxNqyyBF;;AwNnyyBA;EACE,+BAAA;AxNsyyBF;;AwNpyyBA;EACE,WAAA;AxNuyyBF;;AwNpyyBA;EACE,OAAA;AxNuyyBF;;AwN9xyBA;EACE,yBAAA;EANA,8BAOwB;EANxB,sFAAA;EACA,0BAAA;EAOA,kEAAA;EACA,eAAA;AxNkyyBF;;AwNhyyBA;EACE,aAAA;AxNmyyBF;;AwNjyyBA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,0BAAA;AxNoyyBF;;AwNlyyBA;EACE,yBvN9BM;EuN+BN,uCAAA;EACA,4BAAA;EACA,cAAA;AxNqyyBF;;AwNnyyBA;EACE,oCAAA;AxNsyyBF;;AwNpyyBA;EACE,4BAAA;EACA,yBvNxCM;EuNyCN,cAAA;EACA,gBAAA;AxNuyyBF;;AwNryyBA;EACE,oCAAA;AxNwyyBF;;AwNryyBA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EAEA,0BAAA;AxNwyyBF;;AwNtyyBA;EACE,iBAAA;AxNyyyBF;;AwNvyyBA;EACE,iBAAA;EACA,WAAA;AxN0yyBF;;AwNxyyBA;EACE,iBAAA;EACA,WAAA;AxN2yyBF;;AwNpyyBI;EACE,YAAA;EACA,iBAAA;EACA,UAAA;AxNuyyBN;AwNryyBI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AxNuyyBN;AwNnyyBM;EACE,iBAAA;AxNqyyBR;AwNhyyBM;EACE,iBAAA;EACA,WAAA;AxNkyyBR;AwN/xyBM;EACE,iBAAA;EACA,WAAA;AxNiyyBR;;AyNj7yBA;EACE,WAAA;EACA,0BAAA;E5MCE,qBNsO0B;EkNrO5B,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;AzNo7yBF;AyNl7yBE;EACE,qBxN8BI;ADs5yBR;AyNj7yBE;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;AzNm7yBJ;AyNh7yBE;EACE,aAAA;AzNk7yBJ;AyN/6yBE;EACE,aAAA;AzNi7yBJ;AyN96yBE;EACE,WAAA;EACA,YAAA;AzNg7yBJ;AyN76yBE;EACE,cAAA;EACA,cxNpBO;ADm8yBX;AyN56yBE;EACE,qBxN3BO;ADy8yBX;AyN56yBI;EACE,cxN7BK;AD28yBX;;A0N39yBA;EACE,aAAA;A1N89yBF;A0N59yBE;EACE,kBAAA;A1N89yBJ;A0N59yBI;EACE,gBAAA;EACA,uBAAA;A1N89yBN;A0N59yBM;EACE,aAAA;A1N89yBR;A0N19yBI;EACE,kBAAA;A1N49yBN;A0Nv9yBE;EACE,aAAA;A1Ny9yBJ;A0Nt9yBE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;A1Nw9yBJ;A0Nr9yBI;EACE,yBAAA;EACA,UAAA;A1Nu9yBN;A2Nr9yBE;EACE,cDCuB;ECAvB,UAAA;A3Nu9yBJ;A2Nn9yBE;EACE,cDLuB;A1N09yB3B;A2Nj9yBE;EACE,cDVuB;A1N69yB3B;A0N19yBI;EACE,eAAA;EACA,gBAAA;A1N49yBN;A0Nz9yBI;EACE,YAAA;A1N29yBN;A0Nx9yBI;EACE,qBAAA;A1N09yBN;A0Np9yBQ;EACE,YAAA;A1Ns9yBV;A0Nj9yBQ;EACE,YAAA;A1Nm9yBV;A0N78yBE;EACE,UAAA;A1N+8yBJ;A0N78yBI;EACE,eAAA;A1N+8yBN;A0N38yBE;EACE,yBzN2BqB;EyN1BrB,SAAA;E7M5EA,sBNqO0B;EmNvJ1B,czNvCI;EyNwCJ,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;A1N68yBJ;A0N38yBI;EACE,yBzN5EK;EyN6EL,czNzEK;EyN0EL,oBAAA;A1N68yBN;A0N18yBI;EACE,eAAA;EACA,mBAAA;A1N48yBN;A0Nz8yBI;EACE,yBzN1DE;EyN2DF,WzNzFE;EyN0FF,aAAA;EACA,qBAAA;A1N28yBN;A0Nx8yBI;EACE,SAAA;EACA,czNzFK;EyN0FL,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;A1N08yBN;A0Nt8yBE;ECvHA,iDDwHqB;EACnB,yBAAA;EACA,kBAAA;EACA,2DAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;A1N08yBJ;A0Nx8yBI;EACE,YAAA;EACA,WAAA;A1N08yBN;A0Nt8yBE;EClHA,aAAA;EDoHE,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA,EAAA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;A1N48yBJ;A0N18yBI;EACE,WAAA;A1N48yBN;A0Nz8yBI;EACE,gBAAA;EACA,oBAAA,EAAA,yCAAA;A1N28yBN;A0Nv8yBE;EACE,mBAAA;A1Ny8yBJ;A0Nt8yBE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;A1Nw8yBJ;;A0Np8yBA,iBAAA;AACA;EC5IE,SD6Ic;A1N28yBhB;A0Nz8yBE;ECvJA,aAAA;A3NumzBF;A0N58yBE;EAEE,UAAA;A1N68yBJ;A0N18yBE;EAEE,UAAA;A1N28yBJ;A0Nx8yBE;EACE,yBAAA;EACA,4BAAA;A1N08yBJ;A0Nv8yBE;EACE,0BAAA;EACA,6BAAA;A1Ny8yBJ;;A0Nr8yBA;EACE;IACE,wBAAA;E1Nw8yBF;AACF;A0N97yBE;ECrLA,SDsLgB;EACd,YAAA;A1Ny8yBJ;;A4N9pzBA;;;;;EAEE,cAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EAEI,0BAAA;A5NoqzBN;;A4NjqzBA;EACE,UAAA;EACA,SAAA;A5NoqzBF;;A4NjqzBA;EACE,oBAAA;A5NoqzBF;;A4NjqzBA;EACE,0BAAA;EACA,eAAA;A5NoqzBF;;A4NjqzBA;EACE,cAAA;EACA,gBAAA;A5NoqzBF;;A4NhqzBA;;;;;;;EAGE,mBAAA;A5NuqzBF;;A4NpqzBA;;;;EAEE,SAAA;EACA,UAAA;A5NyqzBF;;A4NtqzBA;;EAEE,sBAAA;EACA,UAAA;A5NyqzBF;;A4NtqzBA,mBAAA;ACvDA;EACE,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;EACA,uPAAA;A7NiuzBF;A6N1tzBA;EACE,qBAAA;EACA,c5NMS;E4NLT,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,kCAAA;EACC,mCAAA;A7N4tzBH;;A6NztzBA;EAA0B,gBAAA;A7N6tzB1B;;A6N5tzBA;EAAwB,gBAAA;A7NguzBxB;;A6N/tzBA;EAA4B,gBAAA;A7NmuzB5B;;A6NluzBA;EAA6B,gBAAA;A7NsuzB7B;;A6NpuzBA;EAAuB,gBAAA;A7NwuzBvB;;A6NvuzBA;EAAwB,gBAAA;A7N2uzBxB;;A6N1uzBA;EAAsB,gBAAA;A7N8uzBtB;;A8N9wzBA,kBAAA;AAKA;EACE;IACE,GAAA;E9N6wzBF;E8N3wzBA;IACE,GAAA;E9N6wzBF;AACF;A8N1wzBA;EACE;IACE,GAAA;E9N4wzBF;E8N1wzBA;IACE,GAAA;E9N4wzBF;AACF;A8NzwzBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;A9N2wzBF;;A8NxwzBA;EChCE,2BAAA;EDmCA,YAAA;EACA,cElCuB;EFmCvB,cE9BuB;EF+BvB,oBE9BuB;EF+BvB,aAAA;EACA,kBAAA;A9N0wzBF;A8NvwzBE;EACE,WAAA;EACA,SAAA;A9NywzBJ;;A8NrwzBA;EACE,sBvN7CS;EuN8CT,yBAAA;EACA,sBvNoL4B;APolzB9B;A8NpwzBI;EAEE,sBvNrDK;EuNsDL,qB7NsFgB;E6NrFhB,gDvNwUwB;AP67yB9B;A8NjwzBE;EAEE,mBAAA;A9NkwzBJ;A8N5vzBI;EAGE,gBAAA;ECXJ,gBAAA;EACA,mBAAA;A/NwwzBF;;A8NxvzBA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mCvNsZsC;APq2yBxC;A8NzvzBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;A9N2vzBJ;A8NxvzBE;EACE,SAAA;EACA,mBAAA;A9N0vzBJ;A8NvvzBE;ECxEA,6BDyEgC;ECxE/B,4BDwE+B;A9N0vzBlC;A8NvvzBE;ECvEA,0BDwE6B;ECvE5B,yBDuE4B;A9N0vzB/B;A8NvvzBE;EAEE,0CE3GqB;AhOm2zBzB;;A8NpvzBA;EACE,eAAA;A9NuvzBF;A8NrvzBE;EACE,YAAA;A9NuvzBJ;A8NpvzBE;EAEE,mBAAA;A9NqvzBJ;;A8NjvzBA;ECvBE,eAAA;A/N4wzBF;A+N1wzBE;EAEE,yB9NLqB;ADgxzBzB;A+NzwzBI;EACE,c9NvEE;ADk1zBR;A+NvwzBE;EACE,gDxNwT0B;APi9yB9B;A+NnwzBI;EAGE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;A/NmwzBN;A+NhwzBM;EACE,cAAA;A/NkwzBR;A8NvwzBA;EAGE,YAAA;EACA,8BAAA;A9NuwzBF;A8NrwzBE;EACE,+BAAA;EACA,iBAAA;A9NuwzBJ;;A8NnwzBA;EACE,cAAA;A9NswzBF;;A+N5zzBE;EACE,WCvBwB;EDwBxB,UAAA;A/N+zzBJ;A+N7zzBE;EAA0B,WC1BA;AhO01zB5B;A+N/zzBE;EAAgC,WC3BN;AhO61zB5B;A8N9wzBA;EAEE,UAAA;A9N+wzBF;;A8N5wzBA;EAGE,cvN7IS;EuN8IT,kBAAA;EACA,sBvNtJS;APm6zBX;A8N3wzBE;EACE,aAAA;A9N6wzBJ;A8N1wzBE;ECjGA,gBAAA;EACA,mBAAA;EDmGE,UAAA;EACA,0CEhKqB;EFiKrB,qBvN7JO;APy6zBX;A8NzwzBE;EACE,mBAAA;A9N2wzBJ;;A8NvwzBA;EACE,cAAA;EACA,qEAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;A9N0wzBF;A8NxwzBE;EACE,WAAA;A9N0wzBJ;;A8NtwzBA;EACE,WEzH0B;AhOk4zB5B;;A8NpwzBE;EACE,4CAAA;EAGA,0DAAA;EAAA,kDAAA;A9NqwzBJ;A8NlwzBE;EACE,6CAAA;A9NowzBJ;;A8NhwzBA;;;;EAEE,+CAAA;EACA,iCAAA;EACA,8BAAA;A9NqwzBF;;A8NjwzBA;EACE,gDvNkQsC;APkgzBxC;;A8NjwzBA;EACE,sFAAA;A9NowzBF;;AiO/9zBA;EFYE,SAAA;EACA,UAAA;EACA,gBAAA;EEZA,cDOuB;ECNvB,UAAA;EACA,cAAA;EACA,iBAAA;AjOo+zBF;;AiOj+zBA;EACE,yBAAA;UAAA,iBAAA;EACA,cDNuB;ECOvB,eAAA;EACA,6BAAA;AjOo+zBF;A+Nv7zBE;EAEE,yB9NwFkB;E8NvFlB,qB9NuFkB;E8NtFlB,c9N8CqB;AD04zBzB;A+N57zBE;EAEE,yB9NwFkB;E8NvFlB,qB9NuFkB;E8NtFlB,c9N8CqB;AD+4zBzB;AiOr+zBE;EFqBA,yB9NiEuB;E8NhEvB,qB9NgEuB;E8N/DvB,uDxNitBkC;APkwyBpC;A+N/8zBE;EAEE,yB9NNI;E8NOJ,qB9NPI;E8NQJ,W9NtCI;ADs/zBR;AiOt+zBE;EFoCA,gBAAA;EACA,mBAAA;EAKA,cAAA;EACA,wBAAA;EACA,YAAA;A/Ni8zBF;AiOv+zBI;EACE,gBAAA;EACA,yBAAA;AjOy+zBN;;AiOp+zBA;;;EAGE,sBAAA;EACA,UAAA;AjOu+zBF;;AiOp+zBA;EACE,iBAAA;EACA,gBAAA;AjOu+zBF;;AiOp+zBA;EACE,6BAAA;AjOu+zBF;;AkO/h0BA;EAGE,UAAA;AlOgi0BF;;AkO3h0BE;;EAEE,YAAA;AlO8h0BJ;;AkO1h0BA;EACE,6BAAA;EACA,sBAAA;EACA,gBAAA;EAEA,aAAA;AlO4h0BF;AkO3h0BE;EACE,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AlO6h0BJ;AkO1h0BE;EACE,sBFoCwB;EEnCxB,eAAA;AlO4h0BJ;;AkOxh0BA;EAIE,kBAAA;EACA,WAAA;EACA,gBAAA;AlOwh0BF;AkOth0BE;EACE,sBFsBwB;EErBxB,eAAA;AlOwh0BJ;AkOrh0BE;;EHxCA,aG0CmB;EHxCnB,yBAAA;EGyCE,YAAA;AlOwh0BJ;AkOph0BI;EAGE,gBAAA;EACA,YAAA;EAAA,eAAA;EACA,gBAAA;AlOoh0BN;;AmO1k0BE;EJwGA,eAAA;A/Ns+zBF;A+Np+zBE;EAEE,yB9NLqB;AD0+zBzB;A+Nn+zBI;EACE,c9NvEE;AD4i0BR;A+Nj+zBE;EACE,gDxNwT0B;AP2qzB9B;A+N79zBI;EAGE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;A/N69zBN;A+N19zBM;EACE,cAAA;A/N49zBR;AmOhm0BE;EJ+FA,iDAAA;EAEA,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,UAAA;EIhGE,0CANW;EAOX,sDAAA;EACA,cAAA;EACA,YAAA;AnOom0BJ;AmOjm0BE;EACE,sBAAA;AnOmm0BJ;AmOjm0BI;EAEE,gBAAA;AnOkm0BN;;AoOrn0BA;EACE,cAAA;EACA,kBAAA;ApOwn0BF;AoOtn0BE;EACE,gBAAA;EACA,cJGqB;AhOqn0BzB;;AoOpn0BA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;ApOun0BF;AoOrn0BE;EACE,eAAA;EACA,mBAAA;ApOun0BJ;;AoOnn0BA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;ApOsn0BF;AoOpn0BE;EACE,UAAA;EACA,QAAA;ApOsn0BJ;;AoOln0BA;EACE,WAAA;EACA,qEAAA;EACA,kBAAA;EACA,sBAAA;EACA,sB7N6L4B;EwNpO5B,YKyCiB;ELvCjB,yBAAA;EKwCA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;ApOqn0BF;;AqOxq0BA;EACE,YAAA;ArO2q0BF;AqOzq0BE;ENgGA,+CAAA;EAEA,mBAAA;EACA,mBAAA;EACA,sCAAA;EACA,UAAA;EMlGE,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;ArO8q0BJ;AqO1q0BI;EAGE,gBAAA;EACA,gBAAA;ArO0q0BN;;AqOrq0BA;ENVE,SAAA;EACA,UAAA;EACA,gBAAA;EMUA,eAAA;EACA,aAAA;ArO0q0BF;;AqOvq0BA;EACE,qBAAA;EACA,c9NdS;E8NeT,0BAAA;EACA,sDL4HgC;EK3HhC,qDL2HgC;EK1HhC,uCL2HgC;EK1HhC,qB9NyM4B;E8NxM5B,yBpOuEuB;EoOtEvB,2DAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ArO0q0BF;AqOxq0BE;EACE,mBAAA;EACA,sBAAA;EACA,YAAA;ArO0q0BJ;AqOvq0BE;EACE,cAAA;EACA,uDLwG8B;EKvG9B,0BAAA;ArOyq0BJ;A+Nrq0BE;EAEE,yB9NwFkB;E8NvFlB,qB9NuFkB;E8NtFlB,c9N8CqB;ADwn0BzB;AqOvq0BE;EAKE,mBAAA;ArOqq0BJ;AqOlq0BE;EN9DA,aMiEmB;EN/DnB,yBAAA;A/Nku0BF;AqOhq0BE;ENRA,gBAAA;EACA,mBAAA;A/N2q0BF;;AqO/p0BA;EACE,c9NhES;E8NiET,mBAAA;ArOkq0BF;AqOhq0BE;EACE,cAAA;EACA,oBAAA;ArOkq0BJ;;AsOtv0BA;EACE,kBAAA;EACA,aNoH0B;EMnH1B,SAAA;EACA,UAAA;EACA,WAAA;AtOyv0BF;AsOvv0BE;EACE,SAAA;EACA,YAAA;AtOyv0BJ;AsOtv0BE;EACE,aN0GwB;AhO8o0B5B;;AsOpv0BA;EAEE,WAAA;EACA,kBN8F0B;EM7F1B,cAAA;AtOsv0BF;AsOpv0BE;EACE,gBAAA;EACA,eNyFwB;AhO6p0B5B;;AsOlv0BA;EPOE,0BON2B;EPO1B,yBOP0B;EPC3B,kCxN4M4B;EwN3M3B,iCxN2M2B;E+N1M5B,0UrO6EmB;EqO5EnB,yBAAA;EACA,gB/N7BS;APmx0BX;AsOpv0BE;EPNA,6BOOgC;EPN/B,4BOM+B;EPFhC,+BxNuM4B;EwNtM3B,8BxNsM2B;E+NlM1B,8UrO4EyB;AD2q0B7B;;AsOnv0BA;EACE,2BAAA;AtOsv0BF;;AsOnv0BA;EACE,gBAAA;AtOsv0BF;AsOpv0BE;EACE,wBAAA;EACA,oCAAA;AtOsv0BJ;;AsOjv0BE;EACE,mCAAA;AtOov0BJ;;AsOhv0BA;;EAEE,gBAAA;AtOmv0BF;AsOjv0BE;;EACE,4BAAA;AtOov0BJ;AsOjv0BE;;EACE,2BAAA;AtOov0BJ;;AsOhv0BA;EACE,aAAA;AtOmv0BF;;AuOj00BA;ERiEE,gBAAA;EACA,mBAAA;A/Now0BF;;AwOj00BA;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,8UAAA;AxOo00BF;AwO/z0BE;E3NdE,mB2NeuB;EACvB,kBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,0UvOiFiB;EuOhFjB,iBAAA;AxOi00BJ;AwO/z0BI;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;AxOi00BN;AwO7z0BE;EACE,gBvO5BI;EuO6BJ,YAvCkB;EAwClB,aAAA;EACA,UAAA;AxO+z0BJ;AwO5z0BE;EACE,uBAAA;EACA,QAAA;AxO8z0BJ;AwO3z0BE;EACE,kBAAA;AxO6z0BJ;AwO3z0BI;EACE,WAAA;EACA,YAAA;E3NrDF,kB2NsDyB;AxO6z0B7B;AwO3z0BM;EACE,WAAA;AxO6z0BR;AwOxz0BE;EACE,iBvOuBW;EuOtBX,cvOhDO;EuOiDP,SAAA;EACA,mBvOxDO;EuOyDP,uBAAA;EACA,gCAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AxO0z0BJ;AwOxz0BI;EACE,aAAA;AxO0z0BN;AwOrz0BI;EACE,cvO1CE;EuO2CF,mBvOKS;EuOJT,yBAAA;EACA,SAAA;EACA,kBAAA;AxOuz0BN;;AwOlz0BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;E3NjGE,mB2NkGqB;AxOqz0BzB;AwOnz0BE;EACE,sBAAA;EACA,6BAAA;EACA,UAAA;AxOqz0BJ;AwOlz0BE;EACE,UAAA;AxOoz0BJ;;AwOhz0BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AxOmz0BF;;AyOp60BA;EACE,kBAAA;EACA,yBAAA;E5NHE,sBNqO0B;EkOhO5B,gBAAA;EACA,YAAA;AzOu60BF;AyOr60BE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AzOu60BJ;AyOr60BI;EACE,iBlO6QwB;AP0p0B9B;AyOn60BE;EACE,mBxOXO;EwOYP,cxOiBI;ADo50BR;AyOn60BI;EACE,cxOVK;AD+60BX;AyOj60BE;EACE,kBAAA;AzOm60BJ;AyOh60BE;EACE,cxOpBO;EwOqBP,0BAAA;EACA,eAAA;AzOk60BJ;;AyO950BA;EACE,gBAAA;AzOi60BF;;AyO950BA;EACE,8BAAA;AzOi60BF;;AyO550BA;EACE,aAAA;EACA,mBlOoK4B;AP2v0B9B;;AyO150BA;EACE,YAAA;EACA,aAAA;EACA,WAAA;AzO650BF;;AyOx50BA;EACE,mBxOtDS;EYZP,sBNqO0B;EkOjK5B,cxOrDS;EwOsDT,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AzO250BF;;AyOv50BE;EACE,mBxOnEO;EwOoEP,cxOlEO;AD490BX;;AyOp50BA;EACE,eAAA;AzOu50BF;;A0On/0BA;EACE;IACE,aAAA;E1Os/0BF;AACF;AiBl70BI;EyN/DF;IACE,cAAA;E1Oo/0BF;E0Oh/0BE;IAEE,aAAA;E1Oi/0BJ;E0O7+0BA;IACE,0BAAA;IACA,uBAAA;IACA,6BAAA;E1O++0BF;E0O7+0BE;IACE,aAAA;E1O++0BJ;E0Oz+0BE;IAEE,wBAAA;E1O0+0BJ;E0Ot+0BM;IACE,cAAA;IAAA,oBAAA;E1Ow+0BR;E0Ot+0BQ;IACE,aAAA;E1Ow+0BV;E0Op+0BM;IACE,cAAA;IAAA,oBAAA;IACA,wBAAA;E1Os+0BR;E0On+0BM;IACE,cAAA;IAAA,oBAAA;IACA,SAAA;IACA,cAAA;E1Oq+0BR;E0Ol+0BM;IACE,mBAAA;E1Oo+0BR;E0Oh+0BQ;IACE,uBAAA;E1Ok+0BV;E0Oh+0BU;IACE,aAAA;E1Ok+0BZ;E0O790BU;IACE,iBAAA;E1O+90BZ;E0Oz90BI;IACE,sBAAA;E1O290BN;E0Oz90BM;IACE,sBAAA;IACA,iBAAA;IACA,eAAA;E1O290BR;E0Ot90BE;IACE,YAAA;E1Ow90BJ;E0Or90BE;IACE,cAAA;E1Ou90BJ;E0Oj90BE;IACE,0BAAA;IACA,WAAA;E1Om90BJ;E0O/80BA;IACE,8BAAA;E1Oi90BF;E0O/80BE;IACE,aAAA;IACA,QAAA;IACA,kCAAA;IACA,oBAAA;E1Oi90BJ;E0O980BE;IACE,kBAAA;IACA,UAAA;IACA,0UzOTe;IyOUf,kBAAA;IACA,QAAA;IACA,UAAA;IACA,MAAA;IACA,oBAAA;IACA,gBzOhHE;IYTJ,mB6N0HyB;IACvB,eAAA;IACA,gBAAA;E1Og90BJ;E0O980BI;IACE,mBAAA;IACA,iBAAA;E1Og90BN;E0O980BM;IACE,eAAA;E1Og90BR;E0O780BM;IACE,aAAA;E1O+80BR;E0O180BM;IACE,aAAA;E1O480BR;E0Ox80BI;IACE,mBAAA;IACA,UAAA;IACA,SAAA;E1O080BN;E0Ot80BE;IACE,aAAA;IACA,QAAA;E1Ow80BJ;E0Or80BE;IACE,aAAA;IACA,QAAA;E1Ou80BJ;E0Ol80BM;IAEE,oCAAA;IACA,sCAAA;E1Om80BR;E0O/70BI;IACE,mBzO3JG;ED4l1BT;E0O370BA;;IAEE,0BAAA;IACA,WAAA;IACA,mBAAA;IACA,mBAAA;IACA,qBAAA;IACA,sCAAA;IACA,0BAAA;E1O670BF;E0O370BE;;IACE,aAAA;E1O870BJ;E0Oz70BA;IACE,eAAA;IAAA,kBAAA;E1O270BF;E0Oz70BE;IACE,wBAAA;E1O270BJ;E0Ov70BA;IACE,kBAAA;E1Oy70BF;E0Ov70BE;;IAEE,cAAA;IACA,cAAA;E1Oy70BJ;E0Ot70BE;IACE,mBAAA;E1Ow70BJ;E0On70BI;;;;IAEE,qBAAA;E1Ou70BN;E0O/60BE;IACE,aAAA;E1Oi70BJ;E0O960BE;IACE,WAAA;E1Og70BJ;E0O960BI;IACE,cAAA;E1Og70BN;E0Ox60BM;IACE,yBAAA;E1O060BR;E0Oj60BE;IACE,iBAAA;IACA,cAAA;E1Om60BJ;E0O950BE;IACE,2BAAA;E1Og60BJ;E0O350BE;IACE,yBAAA;E1O650BJ;E0O350BI;IACE,gCAAA;IACA,4BAAA;E1O650BN;E0O150BI;IACE,iBAAA;E1O450BN;E0Ot50BE;IACE,aAAA;E1Ow50BJ;E0Or50BE;IACE,kBAAA;E1Ou50BJ;E0On50BA;IACE,yBAAA;E1Oq50BF;E0O/40BI;IACE,iBAAA;E1Oi50BN;E0O540BA;IACE,cAAA;E1O840BF;AACF;AiB3n1BI;EyNkPF;;IAEE,aAAA;E1O440BF;E0Ox40BE;IACE,cAAA;IACA,kBAAA;IACA,YAAA;IACA,e1J/T4B;EhFys1BhC;E0Ox40BI;;IAEE,mBAAA;E1O040BN;E0Ox40BM;;IACE,sBAAA;IACA,gBAAA;IACA,oBAAA;E1O240BR;E0Op40BE;IACE,2BAAA;E1Os40BJ;AACF;AiBjq1BI;EyNkSA;IACE,2BAAA;E1Ok40BJ;AACF;AiBzp1BI;EyN6RF;IACE,aAAA;E1O+30BF;AACF;AiB9p1BI;EyNmSF;IACE,oBAAA;E1O830BF;E0O330BA;;IAEE,8BAAA;E1O630BF;E0O130BA;IACE,aAAA;IACA,wBAAA;E1O430BF;E0Oz30BA;IACE,kBAAA;IACA,mBAAA;IACA,eAAA;E1O230BF;E0Ox30BA;IACE,gBAAA;E1O030BF;E0Ov30BA;;IAEE,UAAA;IACA,SAAA;E1Oy30BF;E0Ot30BA;IACE,YAAA;IACA,cAAA;IACA,uBAAA;IACA,kBAAA;E1Ow30BF;E0Ot30BE;IACE,oBAAA;E1Ow30BJ;E0Or30BE;IACE,UAAA;E1Ou30BJ;E0Oj30BI;IACE,+BAAA;IACA,cAAA;E1Om30BN;E0Oh30BI;IACE,0BAAA;IACA,yBAAA;IACA,WAAA;E1Ok30BN;E0Oh30BM;IACE,mBAAA;E1Ok30BR;E0O520BA;IACE,aAAA;E1O820BF;E0Oz20BE;;IACE,cAAA;IACA,kBAAA;E1O420BJ;E0O120BI;;IACE,0BAAA;E1O620BN;E0O120BI;;IACE,gBAAA;E1O620BN;E0Ox20BA;IACE,UAAA;E1O020BF;E0Ov20BA;IACE,WAAA;E1Oy20BF;AACF;A0Ot20BA;EAEI;IACE,cAAA;IACA,kBAAA;E1Ou20BJ;E0Or20BI;IACE,0BAAA;E1Ou20BN;E0Op20BI;IACE,gBAAA;E1Os20BN;AACF;A2O1z1BE;EACE,4BAAA;EAAA,4BAAA;A3O4z1BJ;;A2Otz1BE;EACE,iBAAA;A3Oyz1BJ;;A2Opz1BA;EACE,YAAA;A3Ouz1BF;;A2Olz1BE;EACE,iBAAA;A3Oqz1BJ","sourcesContent":["@charset \"UTF-8\";\n.border-primary {\n  border-color: #545cd8;\n}\n\n.border-secondary {\n  border-color: #6c757d;\n}\n\n.border-success {\n  border-color: #3ac47d;\n}\n\n.border-info {\n  border-color: #30b1ff;\n}\n\n.border-warning {\n  border-color: #f7b924;\n}\n\n.border-danger {\n  border-color: #d92550;\n}\n\n.border-light {\n  border-color: #eeeeee;\n}\n\n.border-dark {\n  border-color: #343a40;\n}\n\n.border-focus {\n  border-color: #444054;\n}\n\n.border-alternate {\n  border-color: #83588a;\n}\n\n.list-group-item-primary {\n  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);\n  background-color: rgb(81.2235294118%, 82.1019607843%, 95.7176470588%);\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);\n  background-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);\n  border-color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);\n}\n\n.list-group-item-secondary {\n  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);\n  background-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);\n  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);\n  border-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);\n}\n\n.list-group-item-success {\n  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);\n  background-color: rgb(78.368627451%, 93.5215686275%, 85.7254901961%);\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);\n  background-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);\n  border-color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);\n}\n\n.list-group-item-info {\n  color: rgb(9.7882352941%, 36.0941176471%, 52%);\n  background-color: rgb(77.2705882353%, 91.4352941176%, 100%);\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: rgb(9.7882352941%, 36.0941176471%, 52%);\n  background-color: rgb(67.2705882353%, 87.6671781756%, 100%);\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(9.7882352941%, 36.0941176471%, 52%);\n  border-color: rgb(9.7882352941%, 36.0941176471%, 52%);\n}\n\n.list-group-item-warning {\n  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);\n  background-color: rgb(99.1215686275%, 92.3137254902%, 75.9529411765%);\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);\n  background-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);\n  border-color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);\n}\n\n.list-group-item-danger {\n  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);\n  background-color: rgb(95.8274509804%, 76.062745098%, 80.7843137255%);\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);\n  background-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);\n  border-color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);\n}\n\n.list-group-item-light {\n  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);\n  background-color: rgb(98.1333333333%, 98.1333333333%, 98.1333333333%);\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);\n  background-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);\n  border-color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);\n}\n\n.list-group-item-dark {\n  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);\n  background-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);\n  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);\n  border-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);\n}\n\n.list-group-item-focus {\n  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);\n  background-color: rgb(79.4666666667%, 79.0274509804%, 81.2235294118%);\n}\n.list-group-item-focus.list-group-item-action:hover, .list-group-item-focus.list-group-item-action:focus {\n  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);\n  background-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);\n}\n.list-group-item-focus.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);\n  border-color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);\n}\n\n.list-group-item-alternate {\n  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);\n  background-color: rgb(86.3843137255%, 81.662745098%, 87.1529411765%);\n}\n.list-group-item-alternate.list-group-item-action:hover, .list-group-item-alternate.list-group-item-action:focus {\n  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);\n  background-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);\n}\n.list-group-item-alternate.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);\n  border-color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);\n}\n\n.bg-primary {\n  background-color: #545cd8 !important;\n}\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%) !important;\n}\n\n.bg-secondary {\n  background-color: #6c757d !important;\n}\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%) !important;\n}\n\n.bg-success {\n  background-color: #3ac47d !important;\n}\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%) !important;\n}\n\n.bg-info {\n  background-color: #30b1ff !important;\n}\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: rgb(0%, 61.5856777494%, 98.8235294118%) !important;\n}\n\n.bg-warning {\n  background-color: #f7b924 !important;\n}\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%) !important;\n}\n\n.bg-danger {\n  background-color: #d92550 !important;\n}\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%) !important;\n}\n\n.bg-light {\n  background-color: #eeeeee !important;\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%) !important;\n}\n\n.bg-dark {\n  background-color: #343a40 !important;\n}\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%) !important;\n}\n\n.bg-focus {\n  background-color: #444054 !important;\n}\n\na.bg-focus:hover, a.bg-focus:focus,\nbutton.bg-focus:hover,\nbutton.bg-focus:focus {\n  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%) !important;\n}\n\n.bg-alternate {\n  background-color: #83588a !important;\n}\n\na.bg-alternate:hover, a.bg-alternate:focus,\nbutton.bg-alternate:hover,\nbutton.bg-alternate:focus {\n  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%) !important;\n}\n\n:root {\n  --blue: #007bff;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #dc3545;\n  --orange: #fd7e14;\n  --yellow: #ffc107;\n  --green: #28a745;\n  --teal: #20c997;\n  --cyan: #17a2b8;\n  --white: #fff;\n  --gray: #6c757d;\n  --gray-dark: #343a40;\n  --primary: #545cd8;\n  --secondary: #6c757d;\n  --success: #3ac47d;\n  --info: #30b1ff;\n  --warning: #f7b924;\n  --danger: #d92550;\n  --light: #eeeeee;\n  --dark: #343a40;\n  --focus: #444054;\n  --alternate: #83588a;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: left;\n  background-color: #fff;\n}\n\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: #545cd8;\n  text-decoration: none;\n  background-color: transparent;\n}\na:hover {\n  color: rgb(0%, 33.7647058824%, 70%);\n  text-decoration: underline;\n}\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):focus {\n  outline: 0;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.55rem;\n  padding-bottom: 0.55rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\nbutton::-moz-focus-inner,\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=radio],\ninput[type=checkbox] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ninput[type=date],\ninput[type=time],\ninput[type=datetime-local],\ninput[type=month] {\n  -webkit-appearance: listbox;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\nh1, .h1 {\n  font-size: 2.5rem;\n}\n\nh2, .h2 {\n  font-size: 2rem;\n}\n\nh3, .h3 {\n  font-size: 1.75rem;\n}\n\nh4, .h4 {\n  font-size: 1.5rem;\n}\n\nh5, .h5 {\n  font-size: 1.25rem;\n}\n\nh6, .h6 {\n  font-size: 1rem;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 90%;\n  color: #6c757d;\n}\n\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-break: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.2rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 700;\n}\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 576px) {\n  .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 1140px;\n  }\n}\n\n.container-fluid {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.no-gutters > .col,\n.no-gutters > [class*=col-] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.col-xl,\n.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,\n.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,\n.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,\n.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,\n.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.col-1 {\n  flex: 0 0 8.3333333333%;\n  max-width: 8.3333333333%;\n}\n\n.col-2 {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%;\n}\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%;\n}\n\n.col-5 {\n  flex: 0 0 41.6666666667%;\n  max-width: 41.6666666667%;\n}\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 58.3333333333%;\n  max-width: 58.3333333333%;\n}\n\n.col-8 {\n  flex: 0 0 66.6666666667%;\n  max-width: 66.6666666667%;\n}\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 83.3333333333%;\n  max-width: 83.3333333333%;\n}\n\n.col-11 {\n  flex: 0 0 91.6666666667%;\n  max-width: 91.6666666667%;\n}\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.order-first {\n  order: -1;\n}\n\n.order-last {\n  order: 13;\n}\n\n.order-0 {\n  order: 0;\n}\n\n.order-1 {\n  order: 1;\n}\n\n.order-2 {\n  order: 2;\n}\n\n.order-3 {\n  order: 3;\n}\n\n.order-4 {\n  order: 4;\n}\n\n.order-5 {\n  order: 5;\n}\n\n.order-6 {\n  order: 6;\n}\n\n.order-7 {\n  order: 7;\n}\n\n.order-8 {\n  order: 8;\n}\n\n.order-9 {\n  order: 9;\n}\n\n.order-10 {\n  order: 10;\n}\n\n.order-11 {\n  order: 11;\n}\n\n.order-12 {\n  order: 12;\n}\n\n.offset-1 {\n  margin-left: 8.3333333333%;\n}\n\n.offset-2 {\n  margin-left: 16.6666666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.3333333333%;\n}\n\n.offset-5 {\n  margin-left: 41.6666666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.3333333333%;\n}\n\n.offset-8 {\n  margin-left: 66.6666666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.3333333333%;\n}\n\n.offset-11 {\n  margin-left: 91.6666666667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-sm-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-sm-first {\n    order: -1;\n  }\n  .order-sm-last {\n    order: 13;\n  }\n  .order-sm-0 {\n    order: 0;\n  }\n  .order-sm-1 {\n    order: 1;\n  }\n  .order-sm-2 {\n    order: 2;\n  }\n  .order-sm-3 {\n    order: 3;\n  }\n  .order-sm-4 {\n    order: 4;\n  }\n  .order-sm-5 {\n    order: 5;\n  }\n  .order-sm-6 {\n    order: 6;\n  }\n  .order-sm-7 {\n    order: 7;\n  }\n  .order-sm-8 {\n    order: 8;\n  }\n  .order-sm-9 {\n    order: 9;\n  }\n  .order-sm-10 {\n    order: 10;\n  }\n  .order-sm-11 {\n    order: 11;\n  }\n  .order-sm-12 {\n    order: 12;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-md-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-md-first {\n    order: -1;\n  }\n  .order-md-last {\n    order: 13;\n  }\n  .order-md-0 {\n    order: 0;\n  }\n  .order-md-1 {\n    order: 1;\n  }\n  .order-md-2 {\n    order: 2;\n  }\n  .order-md-3 {\n    order: 3;\n  }\n  .order-md-4 {\n    order: 4;\n  }\n  .order-md-5 {\n    order: 5;\n  }\n  .order-md-6 {\n    order: 6;\n  }\n  .order-md-7 {\n    order: 7;\n  }\n  .order-md-8 {\n    order: 8;\n  }\n  .order-md-9 {\n    order: 9;\n  }\n  .order-md-10 {\n    order: 10;\n  }\n  .order-md-11 {\n    order: 11;\n  }\n  .order-md-12 {\n    order: 12;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-lg-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-lg-first {\n    order: -1;\n  }\n  .order-lg-last {\n    order: 13;\n  }\n  .order-lg-0 {\n    order: 0;\n  }\n  .order-lg-1 {\n    order: 1;\n  }\n  .order-lg-2 {\n    order: 2;\n  }\n  .order-lg-3 {\n    order: 3;\n  }\n  .order-lg-4 {\n    order: 4;\n  }\n  .order-lg-5 {\n    order: 5;\n  }\n  .order-lg-6 {\n    order: 6;\n  }\n  .order-lg-7 {\n    order: 7;\n  }\n  .order-lg-8 {\n    order: 8;\n  }\n  .order-lg-9 {\n    order: 9;\n  }\n  .order-lg-10 {\n    order: 10;\n  }\n  .order-lg-11 {\n    order: 11;\n  }\n  .order-lg-12 {\n    order: 12;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-xl-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-xl-first {\n    order: -1;\n  }\n  .order-xl-last {\n    order: 13;\n  }\n  .order-xl-0 {\n    order: 0;\n  }\n  .order-xl-1 {\n    order: 1;\n  }\n  .order-xl-2 {\n    order: 2;\n  }\n  .order-xl-3 {\n    order: 3;\n  }\n  .order-xl-4 {\n    order: 4;\n  }\n  .order-xl-5 {\n    order: 5;\n  }\n  .order-xl-6 {\n    order: 6;\n  }\n  .order-xl-7 {\n    order: 7;\n  }\n  .order-xl-8 {\n    order: 8;\n  }\n  .order-xl-9 {\n    order: 9;\n  }\n  .order-xl-10 {\n    order: 10;\n  }\n  .order-xl-11 {\n    order: 11;\n  }\n  .order-xl-12 {\n    order: 12;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #212529;\n}\n.table th,\n.table td {\n  padding: 0.55rem;\n  vertical-align: top;\n  border-top: 1px solid #e9ecef;\n}\n.table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #e9ecef;\n}\n.table tbody + tbody {\n  border-top: 2px solid #e9ecef;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem;\n}\n\n.table-bordered {\n  border: 1px solid #e9ecef;\n}\n.table-bordered th,\n.table-bordered td {\n  border: 1px solid #e9ecef;\n}\n.table-bordered thead th,\n.table-bordered thead td {\n  border-bottom-width: 2px;\n}\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody + tbody {\n  border: 0;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n\n.table-hover tbody tr:hover {\n  color: #212529;\n  background-color: #e0f3ff;\n}\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: rgb(81.2235294118%, 82.1019607843%, 95.7176470588%);\n}\n.table-primary th,\n.table-primary td,\n.table-primary thead th,\n.table-primary tbody + tbody {\n  border-color: rgb(65.1294117647%, 66.7607843137%, 92.0470588235%);\n}\n\n.table-hover .table-primary:hover {\n  background-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);\n}\n.table-hover .table-primary:hover > td,\n.table-hover .table-primary:hover > th {\n  background-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);\n}\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);\n}\n.table-secondary th,\n.table-secondary td,\n.table-secondary thead th,\n.table-secondary tbody + tbody {\n  border-color: rgb(70.0235294118%, 71.8588235294%, 73.4901960784%);\n}\n\n.table-hover .table-secondary:hover {\n  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);\n}\n.table-hover .table-secondary:hover > td,\n.table-hover .table-secondary:hover > th {\n  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);\n}\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: rgb(78.368627451%, 93.5215686275%, 85.7254901961%);\n}\n.table-success th,\n.table-success td,\n.table-success thead th,\n.table-success tbody + tbody {\n  border-color: rgb(59.8274509804%, 87.968627451%, 73.4901960784%);\n}\n\n.table-hover .table-success:hover {\n  background-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);\n}\n.table-hover .table-success:hover > td,\n.table-hover .table-success:hover > th {\n  background-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);\n}\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: rgb(77.2705882353%, 91.4352941176%, 100%);\n}\n.table-info th,\n.table-info td,\n.table-info thead th,\n.table-info tbody + tbody {\n  border-color: rgb(57.7882352941%, 84.0941176471%, 100%);\n}\n\n.table-hover .table-info:hover {\n  background-color: rgb(67.2705882353%, 87.6671781756%, 100%);\n}\n.table-hover .table-info:hover > td,\n.table-hover .table-info:hover > th {\n  background-color: rgb(67.2705882353%, 87.6671781756%, 100%);\n}\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: rgb(99.1215686275%, 92.3137254902%, 75.9529411765%);\n}\n.table-warning th,\n.table-warning td,\n.table-warning thead th,\n.table-warning tbody + tbody {\n  border-color: rgb(98.368627451%, 85.7254901961%, 55.3411764706%);\n}\n\n.table-hover .table-warning:hover {\n  background-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);\n}\n.table-hover .table-warning:hover > td,\n.table-hover .table-warning:hover > th {\n  background-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);\n}\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: rgb(95.8274509804%, 76.062745098%, 80.7843137255%);\n}\n.table-danger th,\n.table-danger td,\n.table-danger thead th,\n.table-danger tbody + tbody {\n  border-color: rgb(92.2509803922%, 55.5450980392%, 64.3137254902%);\n}\n\n.table-hover .table-danger:hover {\n  background-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);\n}\n.table-hover .table-danger:hover > td,\n.table-hover .table-danger:hover > th {\n  background-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);\n}\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: rgb(98.1333333333%, 98.1333333333%, 98.1333333333%);\n}\n.table-light th,\n.table-light td,\n.table-light thead th,\n.table-light tbody + tbody {\n  border-color: rgb(96.5333333333%, 96.5333333333%, 96.5333333333%);\n}\n\n.table-hover .table-light:hover {\n  background-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);\n}\n.table-hover .table-light:hover > td,\n.table-hover .table-light:hover > th {\n  background-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);\n}\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);\n}\n.table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody + tbody {\n  border-color: rgb(58.6039215686%, 59.8274509804%, 61.0509803922%);\n}\n\n.table-hover .table-dark:hover {\n  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);\n}\n.table-hover .table-dark:hover > td,\n.table-hover .table-dark:hover > th {\n  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);\n}\n\n.table-focus,\n.table-focus > th,\n.table-focus > td {\n  background-color: rgb(79.4666666667%, 79.0274509804%, 81.2235294118%);\n}\n.table-focus th,\n.table-focus td,\n.table-focus thead th,\n.table-focus tbody + tbody {\n  border-color: rgb(61.8666666667%, 61.0509803922%, 65.1294117647%);\n}\n\n.table-hover .table-focus:hover {\n  background-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);\n}\n.table-hover .table-focus:hover > td,\n.table-hover .table-focus:hover > th {\n  background-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);\n}\n\n.table-alternate,\n.table-alternate > th,\n.table-alternate > td {\n  background-color: rgb(86.3843137255%, 81.662745098%, 87.1529411765%);\n}\n.table-alternate th,\n.table-alternate td,\n.table-alternate thead th,\n.table-alternate tbody + tbody {\n  border-color: rgb(74.7137254902%, 65.9450980392%, 76.1411764706%);\n}\n\n.table-hover .table-alternate:hover {\n  background-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);\n}\n.table-hover .table-alternate:hover > td,\n.table-hover .table-alternate:hover > th {\n  background-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);\n}\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: #e0f3ff;\n}\n\n.table-hover .table-active:hover {\n  background-color: rgb(77.8431372549%, 91.4231499051%, 100%);\n}\n.table-hover .table-active:hover > td,\n.table-hover .table-active:hover > th {\n  background-color: rgb(77.8431372549%, 91.4231499051%, 100%);\n}\n\n.table .thead-dark th {\n  color: #fff;\n  background-color: #343a40;\n  border-color: rgb(27.1162947938%, 30.2450980392%, 33.3739012847%);\n}\n.table .thead-light th {\n  color: #6c757d;\n  background-color: #f8f9fa;\n  border-color: #e9ecef;\n}\n\n.table-dark {\n  color: #fff;\n  background-color: #343a40;\n}\n.table-dark th,\n.table-dark td,\n.table-dark thead th {\n  border-color: rgb(27.1162947938%, 30.2450980392%, 33.3739012847%);\n}\n.table-dark.table-bordered {\n  border: 0;\n}\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n.table-dark.table-hover tbody tr:hover {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.075);\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-sm > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-md > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-lg > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-xl > .table-bordered {\n    border: 0;\n  }\n}\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.table-responsive > .table-bordered {\n  border: 0;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: rgb(73.6554621849%, 74.8879551821%, 93.9915966387%);\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n\nselect.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #212529;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\nselect.form-control[size], select.form-control[multiple] {\n  height: auto;\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n.form-row > .col,\n.form-row > [class*=col-] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n.form-check-input:disabled ~ .form-check-label {\n  color: #6c757d;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #28a745;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(40, 167, 69, 0.9);\n  border-radius: 0.25rem;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #28a745;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: center right calc(0.375em + 0.1875rem);\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n.was-validated .form-control:valid ~ .valid-feedback,\n.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,\n.form-control.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .custom-select:valid, .custom-select.is-valid {\n  border-color: #28a745;\n  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n.was-validated .custom-select:valid ~ .valid-feedback,\n.was-validated .custom-select:valid ~ .valid-tooltip, .custom-select.is-valid ~ .valid-feedback,\n.custom-select.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control-file:valid ~ .valid-feedback,\n.was-validated .form-control-file:valid ~ .valid-tooltip, .form-control-file.is-valid ~ .valid-feedback,\n.form-control-file.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #28a745;\n}\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #28a745;\n}\n.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n  border-color: #28a745;\n}\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  border-color: rgb(20.2728047741%, 80.9036658142%, 34.1176470588%);\n  background-color: rgb(20.2728047741%, 80.9036658142%, 34.1176470588%);\n}\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #28a745;\n}\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #28a745;\n}\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #dc3545;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(220, 53, 69, 0.9);\n  border-radius: 0.25rem;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #dc3545;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center right calc(0.375em + 0.1875rem);\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .form-control:invalid ~ .invalid-feedback,\n.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,\n.form-control.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .custom-select:invalid, .custom-select.is-invalid {\n  border-color: #dc3545;\n  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .custom-select:invalid ~ .invalid-feedback,\n.was-validated .custom-select:invalid ~ .invalid-tooltip, .custom-select.is-invalid ~ .invalid-feedback,\n.custom-select.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control-file:invalid ~ .invalid-feedback,\n.was-validated .form-control-file:invalid ~ .invalid-tooltip, .form-control-file.is-invalid ~ .invalid-feedback,\n.form-control-file.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #dc3545;\n}\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #dc3545;\n}\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n  border-color: #dc3545;\n}\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  border-color: rgb(89.2280963018%, 37.8307272276%, 42.7550260611%);\n  background-color: rgb(89.2280963018%, 37.8307272276%, 42.7550260611%);\n}\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #dc3545;\n}\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #dc3545;\n}\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n.form-inline .form-check {\n  width: 100%;\n}\n@media (min-width: 576px) {\n  .form-inline label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-group {\n    display: flex;\n    flex: 0 0 auto;\n    flex-flow: row wrap;\n    align-items: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n  .form-inline .input-group,\n  .form-inline .custom-select {\n    width: auto;\n  }\n  .form-inline .form-check {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n  .form-inline .form-check-input {\n    position: relative;\n    flex-shrink: 0;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n  .form-inline .custom-control {\n    align-items: center;\n    justify-content: center;\n  }\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #495057;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: #495057;\n  text-decoration: none;\n}\n.btn:focus, .btn.focus {\n  outline: 0;\n  box-shadow: none;\n}\n.btn.disabled, .btn:disabled {\n  opacity: 0.65;\n}\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: rgb(20.7268907563%, 24.4355742297%, 81.9201680672%);\n  border-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n}\n.btn-primary:focus, .btn-primary.focus {\n  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n  border-color: rgb(17.2058823529%, 20.7352941176%, 75.4411764706%);\n}\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary:hover {\n  color: #fff;\n  background-color: rgb(35.4001514769%, 38.3501641%, 40.9723975427%);\n  border-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.btn-secondary:focus, .btn-secondary.focus {\n  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n  border-color: rgb(30.7649583439%, 33.3287048725%, 35.6075906758%);\n}\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: rgb(19.3199011888%, 65.2879419484%, 41.6377180794%);\n  border-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);\n}\n.btn-success:focus, .btn-success.focus {\n  box-shadow: 0 0 0 0 rgba(34.3333333333%, 80.3333333333%, 56.6666666667%, 0.5);\n}\n.btn-success.disabled, .btn-success:disabled {\n  color: #fff;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);\n  border-color: rgb(17.0364366219%, 57.5714065154%, 36.7164582368%);\n}\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(34.3333333333%, 80.3333333333%, 56.6666666667%, 0.5);\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info:hover {\n  color: #fff;\n  background-color: rgb(3.8235294118%, 63.7595907928%, 100%);\n  border-color: rgb(0%, 61.5856777494%, 98.8235294118%);\n}\n.btn-info:focus, .btn-info.focus {\n  box-shadow: 0 0 0 0 rgba(31%, 74%, 100%, 0.5);\n}\n.btn-info.disabled, .btn-info:disabled {\n  color: #fff;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(0%, 61.5856777494%, 98.8235294118%);\n  border-color: rgb(0%, 58.4697357204%, 93.8235294118%);\n}\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(31%, 74%, 100%, 0.5);\n}\n\n.btn-warning {\n  color: #212529;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning:hover {\n  color: #212529;\n  background-color: rgb(92.5978232703%, 66.3829143992%, 3.3825688866%);\n  border-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);\n}\n.btn-warning:focus, .btn-warning.focus {\n  box-shadow: 0 0 0 0 rgba(84.2745098039%, 63.8431372549%, 14.4117647059%, 0.5);\n}\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #212529;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {\n  color: #212529;\n  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);\n  border-color: rgb(82.9502461778%, 59.4666148398%, 3.0301459791%);\n}\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(84.2745098039%, 63.8431372549%, 14.4117647059%, 0.5);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: rgb(72.2830785858%, 12.3247645515%, 26.6481395708%);\n  border-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);\n}\n.btn-danger:focus, .btn-danger.focus {\n  box-shadow: 0 0 0 0 rgba(87.3333333333%, 27.3333333333%, 41.6666666667%, 0.5);\n}\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);\n  border-color: rgb(63.7397714992%, 10.8680716381%, 23.4985332716%);\n}\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(87.3333333333%, 27.3333333333%, 41.6666666667%, 0.5);\n}\n\n.btn-light {\n  color: #212529;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light:hover {\n  color: #212529;\n  background-color: rgb(85.8333333333%, 85.8333333333%, 85.8333333333%);\n  border-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);\n}\n.btn-light:focus, .btn-light.focus {\n  box-shadow: 0 0 0 0 rgba(81.2745098039%, 81.5098039216%, 81.7450980392%, 0.5);\n}\n.btn-light.disabled, .btn-light:disabled {\n  color: #212529;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {\n  color: #212529;\n  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);\n  border-color: rgb(80.8333333333%, 80.8333333333%, 80.8333333333%);\n}\n.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(81.2745098039%, 81.5098039216%, 81.7450980392%, 0.5);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: rgb(13.6680189317%, 15.2450980392%, 16.8221771467%);\n  border-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);\n}\n.btn-dark:focus, .btn-dark.focus {\n  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);\n}\n.btn-dark.disabled, .btn-dark:disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);\n  border-color: rgb(9.185260311%, 10.2450980392%, 11.3049357674%);\n}\n.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);\n}\n\n.btn-focus {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus:hover {\n  color: #fff;\n  background-color: rgb(19.7747747748%, 18.6115527292%, 24.4276629571%);\n  border-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);\n}\n.btn-focus:focus, .btn-focus.focus {\n  box-shadow: 0 0 0 0 rgba(37.6666666667%, 36.3333333333%, 43%, 0.5);\n}\n.btn-focus.disabled, .btn-focus:disabled {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus:not(:disabled):not(.disabled):active, .btn-focus:not(:disabled):not(.disabled).active, .show > .btn-focus.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);\n  border-color: rgb(15.1801801802%, 14.2872284049%, 18.7519872814%);\n}\n.btn-focus:not(:disabled):not(.disabled):active:focus, .btn-focus:not(:disabled):not(.disabled).active:focus, .show > .btn-focus.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(37.6666666667%, 36.3333333333%, 43%, 0.5);\n}\n\n.btn-alternate {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate:hover {\n  color: #fff;\n  background-color: rgb(42.6778587541%, 28.669095957%, 44.9583550234%);\n  border-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);\n}\n.btn-alternate:focus, .btn-alternate.focus {\n  box-shadow: 0 0 0 0 rgba(58.6666666667%, 44.3333333333%, 61%, 0.5);\n}\n.btn-alternate.disabled, .btn-alternate:disabled {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate:not(:disabled):not(.disabled):active, .btn-alternate:not(:disabled):not(.disabled).active, .show > .btn-alternate.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);\n  border-color: rgb(36.8813985771%, 24.7752906472%, 38.8521603332%);\n}\n.btn-alternate:not(:disabled):not(.disabled):active:focus, .btn-alternate:not(:disabled):not(.disabled).active:focus, .show > .btn-alternate.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(58.6666666667%, 44.3333333333%, 61%, 0.5);\n}\n\n.btn-outline-primary {\n  color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n  color: #545cd8;\n  background-color: transparent;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n\n.btn-outline-success {\n  color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:focus, .btn-outline-success.focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n  color: #3ac47d;\n  background-color: transparent;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n\n.btn-outline-info {\n  color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:focus, .btn-outline-info.focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n  color: #30b1ff;\n  background-color: transparent;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n\n.btn-outline-warning {\n  color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:hover {\n  color: #212529;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n  color: #f7b924;\n  background-color: transparent;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n\n.btn-outline-danger {\n  color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n  color: #d92550;\n  background-color: transparent;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n\n.btn-outline-light {\n  color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:hover {\n  color: #212529;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:focus, .btn-outline-light.focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n  color: #eeeeee;\n  background-color: transparent;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {\n  color: #212529;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n\n.btn-outline-focus {\n  color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:hover {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:focus, .btn-outline-focus.focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus.disabled, .btn-outline-focus:disabled {\n  color: #444054;\n  background-color: transparent;\n}\n.btn-outline-focus:not(:disabled):not(.disabled):active, .btn-outline-focus:not(:disabled):not(.disabled).active, .show > .btn-outline-focus.dropdown-toggle {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:not(:disabled):not(.disabled):active:focus, .btn-outline-focus:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-focus.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n\n.btn-outline-alternate {\n  color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:hover {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:focus, .btn-outline-alternate.focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate.disabled, .btn-outline-alternate:disabled {\n  color: #83588a;\n  background-color: transparent;\n}\n.btn-outline-alternate:not(:disabled):not(.disabled):active, .btn-outline-alternate:not(:disabled):not(.disabled).active, .show > .btn-outline-alternate.dropdown-toggle {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:not(:disabled):not(.disabled):active:focus, .btn-outline-alternate:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-alternate.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #545cd8;\n  text-decoration: none;\n}\n.btn-link:hover {\n  color: rgb(0%, 33.7647058824%, 70%);\n  text-decoration: underline;\n}\n.btn-link:focus, .btn-link.focus {\n  text-decoration: underline;\n  box-shadow: none;\n}\n.btn-link:disabled, .btn-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\n\ninput[type=submit].btn-block,\ninput[type=reset].btn-block,\ninput[type=button].btn-block {\n  width: 100%;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 15rem;\n  padding: 0.65rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropleft .dropdown-toggle::after {\n  display: none;\n}\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {\n  right: auto;\n  bottom: auto;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.4rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);\n  text-decoration: none;\n  background-color: #e0f3ff;\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #545cd8;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.65rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.968rem;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.4rem 1.5rem;\n  color: #212529;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover {\n  z-index: 1;\n}\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0;\n}\n.btn-group-toggle > .btn input[type=radio],\n.btn-group-toggle > .btn input[type=checkbox],\n.btn-group-toggle > .btn-group > .btn input[type=radio],\n.btn-group-toggle > .btn-group > .btn input[type=checkbox] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-control-plaintext,\n.input-group > .custom-select,\n.input-group > .custom-file {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  margin-bottom: 0;\n}\n.input-group > .form-control + .form-control,\n.input-group > .form-control + .custom-select,\n.input-group > .form-control + .custom-file,\n.input-group > .form-control-plaintext + .form-control,\n.input-group > .form-control-plaintext + .custom-select,\n.input-group > .form-control-plaintext + .custom-file,\n.input-group > .custom-select + .form-control,\n.input-group > .custom-select + .custom-select,\n.input-group > .custom-select + .custom-file,\n.input-group > .custom-file + .form-control,\n.input-group > .custom-file + .custom-select,\n.input-group > .custom-file + .custom-file {\n  margin-left: -1px;\n}\n.input-group > .form-control:focus,\n.input-group > .custom-select:focus,\n.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n  z-index: 3;\n}\n.input-group > .custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n.input-group > .form-control:not(:last-child),\n.input-group > .custom-select:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > .form-control:not(:first-child),\n.input-group > .custom-select:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .custom-file {\n  display: flex;\n  align-items: center;\n}\n.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > .custom-file:not(:first-child) .custom-file-label {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n}\n.input-group-prepend .btn,\n.input-group-append .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group-prepend .btn:focus,\n.input-group-append .btn:focus {\n  z-index: 3;\n}\n.input-group-prepend .btn + .btn,\n.input-group-prepend .btn + .input-group-text,\n.input-group-prepend .input-group-text + .input-group-text,\n.input-group-prepend .input-group-text + .btn,\n.input-group-append .btn + .btn,\n.input-group-append .btn + .input-group-text,\n.input-group-append .input-group-text + .input-group-text,\n.input-group-append .input-group-text + .btn {\n  margin-left: -1px;\n}\n\n.input-group-prepend {\n  margin-right: -1px;\n}\n\n.input-group-append {\n  margin-left: -1px;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: rgb(93.8431372549%, 97.6166982922%, 100%);\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n.input-group-text input[type=radio],\n.input-group-text input[type=checkbox] {\n  margin-top: 0;\n}\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: calc(1.5em + 1rem + 2px);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 1.75rem;\n}\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: 1.32rem;\n  padding-left: 1.5rem;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem;\n}\n\n.custom-control-input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff;\n  border-color: #007bff;\n  background-color: #545cd8;\n}\n.custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: rgb(50%, 74.1176470588%, 100%);\n}\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  color: #fff;\n  background-color: rgb(89.9411764706%, 90.4117647059%, 97.7058823529%);\n  border-color: rgb(70%, 84.4705882353%, 100%);\n}\n.custom-control-input:disabled ~ .custom-control-label {\n  color: #6c757d;\n}\n.custom-control-input:disabled ~ .custom-control-label::before {\n  background-color: #e9ecef;\n}\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n}\n.custom-control-label::before {\n  position: absolute;\n  top: 0.16rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  pointer-events: none;\n  content: \"\";\n  background-color: #fff;\n  border: #adb5bd solid 1px;\n}\n.custom-control-label::after {\n  position: absolute;\n  top: 0.16rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: \"\";\n  background: no-repeat 50%/50% 50%;\n}\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 0.25rem;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\");\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  border-color: #007bff;\n  background-color: #545cd8;\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\");\n}\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(84, 92, 216, 0.5);\n}\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(84, 92, 216, 0.5);\n}\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(84, 92, 216, 0.5);\n}\n\n.custom-switch {\n  padding-left: 2.25rem;\n}\n.custom-switch .custom-control-label::before {\n  left: -2.25rem;\n  width: 1.75rem;\n  pointer-events: all;\n  border-radius: 0.5rem;\n}\n.custom-switch .custom-control-label::after {\n  top: calc(0.16rem + 2px);\n  left: calc(-2.25rem + 2px);\n  width: calc(1rem - 4px);\n  height: calc(1rem - 4px);\n  background-color: #adb5bd;\n  border-radius: 0.5rem;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-switch .custom-control-label::after {\n    transition: none;\n  }\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n  background-color: #fff;\n  transform: translateX(0.75rem);\n}\n.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(84, 92, 216, 0.5);\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  vertical-align: middle;\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  appearance: none;\n}\n.custom-select:focus {\n  border-color: rgb(50%, 74.1176470588%, 100%);\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.custom-select:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n.custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.custom-select:disabled {\n  color: #6c757d;\n  background-color: #e9ecef;\n}\n.custom-select::-ms-expand {\n  display: none;\n}\n\n.custom-select-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.custom-select-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem;\n}\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin: 0;\n  opacity: 0;\n}\n.custom-file-input:focus ~ .custom-file-label {\n  border-color: rgb(50%, 74.1176470588%, 100%);\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.custom-file-input:disabled ~ .custom-file-label {\n  background-color: #e9ecef;\n}\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"Browse\";\n}\n.custom-file-input ~ .custom-file-label[data-browse]::after {\n  content: attr(data-browse);\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n.custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: calc(1.5em + 0.75rem);\n  padding: 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #495057;\n  content: \"Browse\";\n  background-color: #e9ecef;\n  border-left: inherit;\n  border-radius: 0 0.25rem 0.25rem 0;\n}\n\n.custom-range {\n  width: 100%;\n  height: calc(1rem + 0.4rem);\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.custom-range:focus {\n  outline: none;\n}\n.custom-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.custom-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.custom-range:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.custom-range::-moz-focus-outer {\n  border: 0;\n}\n.custom-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #545cd8;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.custom-range::-webkit-slider-thumb {\n  appearance: none;\n}\n.custom-range::-webkit-slider-thumb:active {\n  background-color: rgb(89.9411764706%, 90.4117647059%, 97.7058823529%);\n}\n.custom-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.custom-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #545cd8;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.custom-range::-moz-range-thumb {\n  appearance: none;\n}\n.custom-range::-moz-range-thumb:active {\n  background-color: rgb(89.9411764706%, 90.4117647059%, 97.7058823529%);\n}\n.custom-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.custom-range::-ms-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0;\n  margin-right: 0.2rem;\n  margin-left: 0.2rem;\n  background-color: #545cd8;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-ms-thumb {\n    transition: none;\n  }\n}\n.custom-range::-ms-thumb {\n  appearance: none;\n}\n.custom-range::-ms-thumb:active {\n  background-color: rgb(89.9411764706%, 90.4117647059%, 97.7058823529%);\n}\n.custom-range::-ms-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: transparent;\n  border-color: transparent;\n  border-width: 0.5rem;\n}\n.custom-range::-ms-fill-lower {\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n.custom-range::-ms-fill-upper {\n  margin-right: 15px;\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n.custom-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n.custom-range:disabled::-webkit-slider-runnable-track {\n  cursor: default;\n}\n.custom-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n.custom-range:disabled::-moz-range-track {\n  cursor: default;\n}\n.custom-range:disabled::-ms-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-control-label::before,\n  .custom-file-label,\n  .custom-select {\n    transition: none;\n  }\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n}\n.nav-link:hover, .nav-link:focus {\n  text-decoration: none;\n}\n.nav-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6;\n}\n.nav-tabs .nav-item {\n  margin-bottom: -1px;\n}\n.nav-tabs .nav-link {\n  border: 1px solid transparent;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  border-color: #e9ecef #e9ecef #dee2e6;\n}\n.nav-tabs .nav-link.disabled {\n  color: #6c757d;\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #495057;\n  background-color: #fff;\n  border-color: #dee2e6 #dee2e6 #fff;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  border-radius: 0.25rem;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #545cd8;\n}\n\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n}\n.navbar > .container, .navbar > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar > .body-tabs.body-tabs-layout.body-tabs-big,\n.navbar > .container-fluid {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n.navbar-toggler:hover, .navbar-toggler:focus {\n  text-decoration: none;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container, .navbar-expand-sm > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-sm > .body-tabs.body-tabs-layout.body-tabs-big,\n  .navbar-expand-sm > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-sm > .container, .navbar-expand-sm > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-sm > .body-tabs.body-tabs-layout.body-tabs-big,\n  .navbar-expand-sm > .container-fluid {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container, .navbar-expand-md > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-md > .body-tabs.body-tabs-layout.body-tabs-big,\n  .navbar-expand-md > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-md > .container, .navbar-expand-md > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-md > .body-tabs.body-tabs-layout.body-tabs-big,\n  .navbar-expand-md > .container-fluid {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container, .navbar-expand-lg > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-lg > .body-tabs.body-tabs-layout.body-tabs-big,\n  .navbar-expand-lg > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-lg > .container, .navbar-expand-lg > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-lg > .body-tabs.body-tabs-layout.body-tabs-big,\n  .navbar-expand-lg > .container-fluid {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container, .navbar-expand-xl > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-xl > .body-tabs.body-tabs-layout.body-tabs-big,\n  .navbar-expand-xl > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xl > .container, .navbar-expand-xl > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand-xl > .body-tabs.body-tabs-layout.body-tabs-big,\n  .navbar-expand-xl > .container-fluid {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n.navbar-expand > .container, .navbar-expand > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand > .body-tabs.body-tabs-layout.body-tabs-big,\n.navbar-expand > .container-fluid {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n.navbar-expand > .container, .navbar-expand > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar-expand > .body-tabs.body-tabs-layout.body-tabs-big,\n.navbar-expand > .container-fluid {\n  flex-wrap: nowrap;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-text a {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: #fff;\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.75);\n}\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff;\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n.navbar-dark .navbar-text a {\n  color: #fff;\n}\n.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n  color: #fff;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125);\n  border-radius: 0.25rem;\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group:first-child .list-group-item:first-child {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.card > .list-group:last-child .list-group-item:last-child {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1.25rem;\n}\n\n.card-title {\n  margin-bottom: 0.75rem;\n}\n\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: 1.25rem;\n}\n\n.card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125);\n}\n.card-header:first-child {\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n}\n.card-header + .list-group .list-group-item:first-child {\n  border-top: 0;\n}\n\n.card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: #fff;\n  border-top: 1px solid rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125);\n}\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n}\n\n.card-img {\n  width: 100%;\n  border-radius: calc(0.25rem - 1px);\n}\n\n.card-img-top {\n  width: 100%;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.card-img-bottom {\n  width: 100%;\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card-deck {\n  display: flex;\n  flex-direction: column;\n}\n.card-deck .card {\n  margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n  .card-deck {\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n  .card-deck .card {\n    display: flex;\n    flex: 1 0 0%;\n    flex-direction: column;\n    margin-right: 15px;\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n}\n\n.card-group {\n  display: flex;\n  flex-direction: column;\n}\n.card-group > .card {\n  margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n  .card-group {\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.card-columns .card {\n  margin-bottom: 0.75rem;\n}\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n  }\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.accordion > .card {\n  overflow: hidden;\n}\n.accordion > .card:not(:first-of-type) .card-header:first-child {\n  border-radius: 0;\n}\n.accordion > .card:not(:first-of-type):not(:last-of-type) {\n  border-bottom: 0;\n  border-radius: 0;\n}\n.accordion > .card:first-of-type {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.accordion > .card:last-of-type {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.accordion > .card .card-header {\n  margin-bottom: -1px;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  display: inline-block;\n  padding-right: 0.5rem;\n  color: #6c757d;\n  content: \"/\";\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n.breadcrumb-item.active {\n  color: #6c757d;\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.25rem;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #007bff;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n.page-link:hover {\n  z-index: 2;\n  color: rgb(0%, 33.7647058824%, 70%);\n  text-decoration: none;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n.page-link:focus {\n  z-index: 2;\n  outline: 0;\n  box-shadow: none;\n}\n\n.page-item:first-child .page-link, .pagination .page-number:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.page-item:last-child .page-link, .pagination .page-number:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.page-item.active .page-link, .pagination .active.page-number .page-link {\n  z-index: 1;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #007bff;\n}\n.page-item.disabled .page-link, .pagination .disabled.page-number .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.1rem;\n  line-height: 1.5;\n}\n.pagination-lg .page-item:first-child .page-link, .pagination-lg .pagination .page-number:first-child .page-link, .pagination .pagination-lg .page-number:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n.pagination-lg .page-item:last-child .page-link, .pagination-lg .pagination .page-number:last-child .page-link, .pagination .pagination-lg .page-number:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.968rem;\n  line-height: 1.5;\n}\n.pagination-sm .page-item:first-child .page-link, .pagination-sm .pagination .page-number:first-child .page-link, .pagination .pagination-sm .page-number:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n.pagination-sm .page-item:last-child .page-link, .pagination-sm .pagination .page-number:last-child .page-link, .pagination .pagination-sm .page-number:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n}\na.badge:hover, a.badge:focus {\n  text-decoration: none;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: #fff;\n  background-color: #545cd8;\n}\na.badge-primary:hover, a.badge-primary:focus {\n  color: #fff;\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n}\na.badge-primary:focus, a.badge-primary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(84, 92, 216, 0.5);\n}\n\n.badge-secondary {\n  color: #fff;\n  background-color: #6c757d;\n}\na.badge-secondary:hover, a.badge-secondary:focus {\n  color: #fff;\n  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\na.badge-secondary:focus, a.badge-secondary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.badge-success {\n  color: #fff;\n  background-color: #3ac47d;\n}\na.badge-success:hover, a.badge-success:focus {\n  color: #fff;\n  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);\n}\na.badge-success:focus, a.badge-success.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(58, 196, 125, 0.5);\n}\n\n.badge-info {\n  color: #fff;\n  background-color: #30b1ff;\n}\na.badge-info:hover, a.badge-info:focus {\n  color: #fff;\n  background-color: rgb(0%, 61.5856777494%, 98.8235294118%);\n}\na.badge-info:focus, a.badge-info.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(48, 177, 255, 0.5);\n}\n\n.badge-warning {\n  color: #212529;\n  background-color: #f7b924;\n}\na.badge-warning:hover, a.badge-warning:focus {\n  color: #212529;\n  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);\n}\na.badge-warning:focus, a.badge-warning.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(247, 185, 36, 0.5);\n}\n\n.badge-danger {\n  color: #fff;\n  background-color: #d92550;\n}\na.badge-danger:hover, a.badge-danger:focus {\n  color: #fff;\n  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);\n}\na.badge-danger:focus, a.badge-danger.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(217, 37, 80, 0.5);\n}\n\n.badge-light {\n  color: #212529;\n  background-color: #eeeeee;\n}\na.badge-light:hover, a.badge-light:focus {\n  color: #212529;\n  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);\n}\na.badge-light:focus, a.badge-light.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(238, 238, 238, 0.5);\n}\n\n.badge-dark {\n  color: #fff;\n  background-color: #343a40;\n}\na.badge-dark:hover, a.badge-dark:focus {\n  color: #fff;\n  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);\n}\na.badge-dark:focus, a.badge-dark.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.badge-focus {\n  color: #fff;\n  background-color: #444054;\n}\na.badge-focus:hover, a.badge-focus:focus {\n  color: #fff;\n  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);\n}\na.badge-focus:focus, a.badge-focus.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(68, 64, 84, 0.5);\n}\n\n.badge-alternate {\n  color: #fff;\n  background-color: #83588a;\n}\na.badge-alternate:hover, a.badge-alternate:focus {\n  color: #fff;\n  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);\n}\na.badge-alternate:focus, a.badge-alternate.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(131, 88, 138, 0.5);\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 0.3rem;\n}\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 4rem;\n}\n.alert-dismissible .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0.75rem 1.25rem;\n  color: inherit;\n}\n\n.alert-primary {\n  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);\n  background-color: rgb(86.5882352941%, 87.2156862745%, 96.9411764706%);\n  border-color: rgb(81.2235294118%, 82.1019607843%, 95.7176470588%);\n}\n.alert-primary hr {\n  border-top-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);\n}\n.alert-primary .alert-link {\n  color: rgb(11.5294117647%, 12.6274509804%, 29.6470588235%);\n}\n\n.alert-secondary {\n  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);\n  background-color: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);\n  border-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);\n}\n.alert-secondary hr {\n  border-top-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);\n}\n.alert-secondary .alert-link {\n  color: rgb(12.7531431457%, 13.8159050745%, 14.7605823445%);\n}\n\n.alert-success {\n  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);\n  background-color: rgb(84.5490196078%, 95.3725490196%, 89.8039215686%);\n  border-color: rgb(78.368627451%, 93.5215686275%, 85.7254901961%);\n}\n.alert-success hr {\n  border-top-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);\n}\n.alert-success .alert-link {\n  color: rgb(7.2605218465%, 24.5355565848%, 15.6476763934%);\n}\n\n.alert-info {\n  color: rgb(9.7882352941%, 36.0941176471%, 52%);\n  background-color: rgb(83.7647058824%, 93.8823529412%, 100%);\n  border-color: rgb(77.2705882353%, 91.4352941176%, 100%);\n}\n.alert-info hr {\n  border-top-color: rgb(67.2705882353%, 87.6671781756%, 100%);\n}\n.alert-info .alert-link {\n  color: rgb(6.6199184624%, 24.4109493302%, 35.1683168317%);\n}\n\n.alert-warning {\n  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);\n  background-color: rgb(99.3725490196%, 94.5098039216%, 82.8235294118%);\n  border-color: rgb(99.1215686275%, 92.3137254902%, 75.9529411765%);\n}\n.alert-warning hr {\n  border-top-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);\n}\n.alert-warning .alert-link {\n  color: rgb(32.9127970623%, 24.6512852491%, 4.7970068593%);\n}\n\n.alert-danger {\n  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);\n  background-color: rgb(97.0196078431%, 82.9019607843%, 86.2745098039%);\n  border-color: rgb(95.8274509804%, 76.062745098%, 80.7843137255%);\n}\n.alert-danger hr {\n  border-top-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);\n}\n.alert-danger .alert-link {\n  color: rgb(27.1643662189%, 4.6317122124%, 10.0145128918%);\n}\n\n.alert-light {\n  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);\n  background-color: rgb(98.6666666667%, 98.6666666667%, 98.6666666667%);\n  border-color: rgb(98.1333333333%, 98.1333333333%, 98.1333333333%);\n}\n.alert-light hr {\n  border-top-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);\n}\n.alert-light .alert-link {\n  color: rgb(38.5333333333%, 38.5333333333%, 38.5333333333%);\n}\n\n.alert-dark {\n  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);\n  background-color: rgb(84.0784313725%, 84.5490196078%, 85.0196078431%);\n  border-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);\n}\n.alert-dark hr {\n  border-top-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);\n}\n.alert-dark .alert-link {\n  color: rgb(1.6384043272%, 1.8274509804%, 2.0164976335%);\n}\n\n.alert-focus {\n  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);\n  background-color: rgb(85.3333333333%, 85.0196078431%, 86.5882352941%);\n  border-color: rgb(79.4666666667%, 79.0274509804%, 81.2235294118%);\n}\n.alert-focus hr {\n  border-top-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);\n}\n.alert-focus .alert-link {\n  color: rgb(4.6774774775%, 4.4023317435%, 5.7780604134%);\n}\n\n.alert-alternate {\n  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);\n  background-color: rgb(90.2745098039%, 86.9019607843%, 90.8235294118%);\n  border-color: rgb(86.3843137255%, 81.662745098%, 87.1529411765%);\n}\n.alert-alternate hr {\n  border-top-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);\n}\n.alert-alternate .alert-link {\n  color: rgb(15.1208051362%, 10.1574874197%, 15.9287870901%);\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  font-size: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #545cd8;\n  transition: width 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: #495057;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n.list-group-item-action:active {\n  color: #212529;\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n.list-group-item:first-child {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n}\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #007bff;\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal .list-group-item {\n  margin-right: -1px;\n  margin-bottom: 0;\n}\n.list-group-horizontal .list-group-item:first-child {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n}\n.list-group-horizontal .list-group-item:last-child {\n  margin-right: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n  .list-group-horizontal-sm .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n  .list-group-horizontal-md .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n  .list-group-horizontal-lg .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n  .list-group-horizontal-xl .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n}\n.list-group-flush .list-group-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.list-group-flush .list-group-item:last-child {\n  margin-bottom: -1px;\n}\n.list-group-flush:first-child .list-group-item:first-child {\n  border-top: 0;\n}\n.list-group-flush:last-child .list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom: 0;\n}\n\n.list-group-item-primary {\n  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);\n  background-color: rgb(81.2235294118%, 82.1019607843%, 95.7176470588%);\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);\n  background-color: rgb(73.0806722689%, 74.3400560224%, 93.8605042017%);\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);\n  border-color: rgb(17.1294117647%, 18.7607843137%, 44.0470588235%);\n}\n\n.list-group-item-secondary {\n  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);\n  background-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);\n  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);\n  border-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);\n}\n\n.list-group-item-success {\n  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);\n  background-color: rgb(78.368627451%, 93.5215686275%, 85.7254901961%);\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);\n  background-color: rgb(70.673314951%, 91.2168811275%, 80.6473651961%);\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);\n  border-color: rgb(11.8274509804%, 39.968627451%, 25.4901960784%);\n}\n\n.list-group-item-info {\n  color: rgb(9.7882352941%, 36.0941176471%, 52%);\n  background-color: rgb(77.2705882353%, 91.4352941176%, 100%);\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: rgb(9.7882352941%, 36.0941176471%, 52%);\n  background-color: rgb(67.2705882353%, 87.6671781756%, 100%);\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(9.7882352941%, 36.0941176471%, 52%);\n  border-color: rgb(9.7882352941%, 36.0941176471%, 52%);\n}\n\n.list-group-item-warning {\n  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);\n  background-color: rgb(99.1215686275%, 92.3137254902%, 75.9529411765%);\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);\n  background-color: rgb(98.76914572%, 89.2300250497%, 66.305364084%);\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);\n  border-color: rgb(50.368627451%, 37.7254901961%, 7.3411764706%);\n}\n\n.list-group-item-danger {\n  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);\n  background-color: rgb(95.8274509804%, 76.062745098%, 80.7843137255%);\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);\n  background-color: rgb(94.3430759804%, 67.547120098%, 73.9483762255%);\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);\n  border-color: rgb(44.2509803922%, 7.5450980392%, 16.3137254902%);\n}\n\n.list-group-item-light {\n  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);\n  background-color: rgb(98.1333333333%, 98.1333333333%, 98.1333333333%);\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);\n  background-color: rgb(93.1333333333%, 93.1333333333%, 93.1333333333%);\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);\n  border-color: rgb(48.5333333333%, 48.5333333333%, 48.5333333333%);\n}\n\n.list-group-item-dark {\n  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);\n  background-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);\n  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);\n  border-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);\n}\n\n.list-group-item-focus {\n  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);\n  background-color: rgb(79.4666666667%, 79.0274509804%, 81.2235294118%);\n}\n.list-group-item-focus.list-group-item-action:hover, .list-group-item-focus.list-group-item-action:focus {\n  color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);\n  background-color: rgb(74.3009208103%, 73.7512078865%, 76.4997725057%);\n}\n.list-group-item-focus.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);\n  border-color: rgb(13.8666666667%, 13.0509803922%, 17.1294117647%);\n}\n\n.list-group-item-alternate {\n  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);\n  background-color: rgb(86.3843137255%, 81.662745098%, 87.1529411765%);\n}\n.list-group-item-alternate.list-group-item-action:hover, .list-group-item-alternate.list-group-item-action:focus {\n  color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);\n  background-color: rgb(82.0181165424%, 75.7824634079%, 83.0332228666%);\n}\n.list-group-item-alternate.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);\n  border-color: rgb(26.7137254902%, 17.9450980392%, 28.1411764706%);\n}\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: 0.5;\n}\n.close:hover {\n  color: #000;\n  text-decoration: none;\n}\n.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {\n  opacity: 0.75;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  appearance: none;\n}\n\na.close.disabled {\n  pointer-events: none;\n}\n\n.toast {\n  max-width: 350px;\n  overflow: hidden;\n  font-size: 0.875rem;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  opacity: 0;\n  border-radius: 0.25rem;\n}\n.toast:not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n.toast.showing {\n  opacity: 1;\n}\n.toast.show {\n  display: block;\n  opacity: 1;\n}\n.toast.hide {\n  display: none;\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.toast-body {\n  padding: 0.75rem;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.fade .modal-dialog {\n  transform: translate(0, -50px);\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n\n.modal-dialog-scrollable {\n  display: flex;\n  max-height: calc(100% - 1rem);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: calc(100vh - 1rem);\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-header,\n.modal-dialog-scrollable .modal-footer {\n  flex-shrink: 0;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n.modal-dialog-centered::before {\n  display: block;\n  height: calc(100vh - 1rem);\n  content: \"\";\n}\n.modal-dialog-centered.modal-dialog-scrollable {\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n}\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n  max-height: none;\n}\n.modal-dialog-centered.modal-dialog-scrollable::before {\n  content: none;\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n.modal-header .close {\n  padding: 1rem 1rem;\n  margin: -1rem -1rem -1rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1rem;\n  border-top: 1px solid #dee2e6;\n  border-bottom-right-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n.modal-footer > :not(:first-child) {\n  margin-left: 0.25rem;\n}\n.modal-footer > :not(:last-child) {\n  margin-right: 0.25rem;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 3.5rem);\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered::before {\n    height: calc(100vh - 3.5rem);\n  }\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: 0.9;\n}\n.tooltip .arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n.tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 320px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125);\n  border-radius: 0.3rem;\n}\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 0.3rem;\n}\n.popover .arrow::before, .popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top, .bs-popover-auto[x-placement^=top] {\n  margin-bottom: 0.5rem;\n}\n.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {\n  bottom: calc((0.5rem + 1px) * -1);\n}\n.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-right, .bs-popover-auto[x-placement^=right] {\n  margin-left: 0.5rem;\n}\n.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {\n  left: calc((0.5rem + 1px) * -1);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {\n  margin-top: 0.5rem;\n}\n.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {\n  top: calc((0.5rem + 1px) * -1);\n}\n.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #fff;\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid #fff;\n}\n\n.bs-popover-left, .bs-popover-auto[x-placement^=left] {\n  margin-right: 0.5rem;\n}\n.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {\n  right: calc((0.5rem + 1px) * -1);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.88rem;\n  background-color: #fff;\n  border-bottom: 1px solid rgb(95%, 95%, 95%);\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #212529;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: 0s 0.6s opacity;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-left,\n  .carousel-fade .active.carousel-item-right {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: no-repeat 50%/100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators li {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators li {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spinner-border 0.75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: spinner-grow 0.75s linear infinite;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.bg-primary {\n  background-color: #545cd8 !important;\n}\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%) !important;\n}\n\n.bg-secondary {\n  background-color: #6c757d !important;\n}\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%) !important;\n}\n\n.bg-success {\n  background-color: #3ac47d !important;\n}\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%) !important;\n}\n\n.bg-info {\n  background-color: #30b1ff !important;\n}\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: rgb(0%, 61.5856777494%, 98.8235294118%) !important;\n}\n\n.bg-warning {\n  background-color: #f7b924 !important;\n}\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%) !important;\n}\n\n.bg-danger {\n  background-color: #d92550 !important;\n}\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%) !important;\n}\n\n.bg-light {\n  background-color: #eeeeee !important;\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%) !important;\n}\n\n.bg-dark {\n  background-color: #343a40 !important;\n}\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%) !important;\n}\n\n.bg-focus {\n  background-color: #444054 !important;\n}\n\na.bg-focus:hover, a.bg-focus:focus,\nbutton.bg-focus:hover,\nbutton.bg-focus:focus {\n  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%) !important;\n}\n\n.bg-alternate {\n  background-color: #83588a !important;\n}\n\na.bg-alternate:hover, a.bg-alternate:focus,\nbutton.bg-alternate:hover,\nbutton.bg-alternate:focus {\n  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%) !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.border {\n  border: 1px solid #dee2e6 !important;\n}\n\n.border-top {\n  border-top: 1px solid #dee2e6 !important;\n}\n\n.border-right {\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n\n.border-left {\n  border-left: 1px solid #dee2e6 !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-right-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-left-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #545cd8 !important;\n}\n\n.border-secondary {\n  border-color: #6c757d !important;\n}\n\n.border-success {\n  border-color: #3ac47d !important;\n}\n\n.border-info {\n  border-color: #30b1ff !important;\n}\n\n.border-warning {\n  border-color: #f7b924 !important;\n}\n\n.border-danger {\n  border-color: #d92550 !important;\n}\n\n.border-light {\n  border-color: #eeeeee !important;\n}\n\n.border-dark {\n  border-color: #343a40 !important;\n}\n\n.border-focus {\n  border-color: #444054 !important;\n}\n\n.border-alternate {\n  border-color: #83588a !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.rounded-sm {\n  border-radius: 0.2rem !important;\n}\n\n.rounded {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important;\n}\n\n.rounded-right {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-left {\n  border-top-left-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-lg {\n  border-radius: 0.3rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.8571428571%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n}\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n  .float-sm-right {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n  .float-md-right {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n  .float-lg-right {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n  .float-xl-right {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n}\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -1rem !important;\n}\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important;\n}\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important;\n}\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important;\n}\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important;\n}\n\n.m-n4 {\n  margin: -1.5rem !important;\n}\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important;\n}\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important;\n}\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important;\n}\n\n.m-n5 {\n  margin: -3rem !important;\n}\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important;\n}\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important;\n}\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important;\n}\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1rem !important;\n  }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-sm-n5 {\n    margin: -3rem !important;\n  }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important;\n  }\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-md-n3 {\n    margin: -1rem !important;\n  }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-md-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-md-n5 {\n    margin: -3rem !important;\n  }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1rem !important;\n  }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-lg-n5 {\n    margin: -3rem !important;\n  }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1rem !important;\n  }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-xl-n5 {\n    margin: -3rem !important;\n  }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\n}\n\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-lighter {\n  font-weight: lighter !important;\n}\n\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n\n.font-weight-bolder {\n  font-weight: bolder !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-primary {\n  color: #545cd8 !important;\n}\n\na.text-primary:hover, a.text-primary:focus {\n  color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%) !important;\n}\n\n.text-secondary {\n  color: #6c757d !important;\n}\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: rgb(28.4473617773%, 30.8179752588%, 32.9251872423%) !important;\n}\n\n.text-success {\n  color: #3ac47d !important;\n}\n\na.text-success:hover, a.text-success:focus {\n  color: rgb(15.8947043384%, 53.7131387988%, 34.2558283156%) !important;\n}\n\n.text-info {\n  color: #30b1ff !important;\n}\n\na.text-info:hover, a.text-info:focus {\n  color: rgb(0%, 55.3537936914%, 88.8235294118%) !important;\n}\n\n.text-warning {\n  color: #f7b924 !important;\n}\n\na.text-warning:hover, a.text-warning:focus {\n  color: rgb(78.1264576315%, 56.00846506%, 2.8539345254%) !important;\n}\n\n.text-danger {\n  color: #d92550 !important;\n}\n\na.text-danger:hover, a.text-danger:focus {\n  color: rgb(59.4681179558%, 10.1397251814%, 21.923730122%) !important;\n}\n\n.text-light {\n  color: #eeeeee !important;\n}\n\na.text-light:hover, a.text-light:focus {\n  color: rgb(78.3333333333%, 78.3333333333%, 78.3333333333%) !important;\n}\n\n.text-dark {\n  color: #343a40 !important;\n}\n\na.text-dark:hover, a.text-dark:focus {\n  color: rgb(6.9438810007%, 7.7450980392%, 8.5463150778%) !important;\n}\n\n.text-focus {\n  color: #444054 !important;\n}\n\na.text-focus:hover, a.text-focus:focus {\n  color: rgb(12.8828828829%, 12.1250662427%, 15.9141494436%) !important;\n}\n\n.text-alternate {\n  color: #83588a !important;\n}\n\na.text-alternate:hover, a.text-alternate:focus {\n  color: rgb(33.9831684886%, 22.8283879924%, 35.799062988%) !important;\n}\n\n.text-body {\n  color: #495057 !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-break {\n  word-break: break-word !important;\n  overflow-wrap: break-word !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\na,\nbutton,\n.btn {\n  outline: none !important;\n}\n\n.app-container {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  margin: 0;\n}\n\n.SidebarAnimation-appear {\n  transform: translateX(-30px);\n  opacity: 0;\n}\n.SidebarAnimation-appear.SidebarAnimation-appear-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: all 0.4s linear;\n}\n\n.HeaderAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n}\n.HeaderAnimation-appear.HeaderAnimation-appear-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 0.4s linear;\n}\n\n.MainAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n}\n.MainAnimation-appear.MainAnimation-appear-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 0.4s linear;\n}\n\n.app-header {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  position: relative;\n  z-index: 10;\n  transition: all 0.2s;\n}\n.app-header.header-shadow {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n.app-header .app-header__content {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  flex: 1;\n  padding: 0 1.5rem;\n  height: 60px;\n}\n.app-header .app-header__content .app-header-left {\n  display: flex;\n  align-items: center;\n}\n.app-header .app-header__content .app-header-right {\n  align-items: center;\n  display: flex;\n  margin-left: auto;\n}\n.app-header .header-user-info > .widget-heading, .app-header .header-user-info > .widget-subheading {\n  white-space: nowrap;\n}\n.app-header .header-user-info > .widget-subheading {\n  font-size: 0.8rem;\n}\n\n.app-header__logo {\n  padding: 0 1.5rem;\n  height: 60px;\n  width: 280px;\n  display: flex;\n  align-items: center;\n  transition: width 0.2s;\n}\n.app-header__logo .logo-src {\n  height: 23px;\n  width: 97px;\n  background: url(\"~assets/utils/images/logo-inverse.png\");\n}\n\n.app-header__menu,\n.app-header__mobile-menu {\n  display: none;\n  padding: 0 1.5rem;\n  height: 60px;\n  align-items: center;\n}\n\n.fixed-header .app-header {\n  position: fixed;\n  width: 100%;\n  top: 0;\n}\n.fixed-header .app-header .app-header__logo {\n  visibility: visible;\n}\n.fixed-header .app-main {\n  padding-top: 60px;\n}\n.fixed-header:not(.fixed-sidebar):not(.closed-sidebar) .app-sidebar .app-header__logo {\n  visibility: hidden;\n}\n\n.header-dots {\n  margin-left: auto;\n  display: flex;\n}\n.header-dots > .dropdown {\n  display: flex;\n  align-content: center;\n}\n.header-dots .icon-wrapper-alt {\n  margin: 0;\n  height: 44px;\n  width: 44px;\n  text-align: center;\n  overflow: visible;\n}\n.header-dots .icon-wrapper-alt .language-icon {\n  border-radius: 30px;\n  position: relative;\n  z-index: 4;\n  width: 28px;\n  height: 28px;\n  overflow: hidden;\n  margin: 0 auto;\n}\n.header-dots .icon-wrapper-alt .language-icon img {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  margin: -22px 0 0 -20px;\n}\n.header-dots .icon-wrapper-alt .icon-wrapper-bg {\n  opacity: 0.1;\n  transition: opacity 0.2s;\n  border-radius: 40px;\n}\n.header-dots .icon-wrapper-alt svg {\n  margin: 0 auto;\n}\n@-moz-document url-prefix() {\n  .header-dots .icon-wrapper-alt svg {\n    width: 50%;\n  }\n}\n.header-dots .icon-wrapper-alt i {\n  font-size: 1.3rem;\n}\n.header-dots .icon-wrapper-alt:hover {\n  cursor: pointer;\n}\n.header-dots .icon-wrapper-alt:hover .icon-wrapper-bg {\n  opacity: 0.2;\n}\n.header-dots .icon-wrapper-alt .badge-dot {\n  top: 1px;\n  right: 1px;\n  border: 0;\n}\n\n.header-megamenu.nav > li > .nav-link {\n  color: #6c757d;\n  padding-left: 0.6666666667rem;\n  padding-right: 0.6666666667rem;\n}\n.header-megamenu.nav > li > .nav-link .badge-pill {\n  padding: 5px 7px;\n}\n.header-megamenu.nav > li > .nav-link:hover {\n  color: #343a40;\n}\n.header-megamenu.nav > li > .nav-link svg {\n  margin-top: 1px;\n}\n\n.header-btn-lg {\n  padding: 0 0 0 1.5rem;\n  margin-left: 1.5rem;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.header-btn-lg::before {\n  position: absolute;\n  left: -1px;\n  top: 50%;\n  background: #dee2e6;\n  width: 1px;\n  height: 30px;\n  margin-top: -15px;\n  content: \"\";\n}\n.header-btn-lg .hamburger-inner,\n.header-btn-lg .hamburger-inner::before,\n.header-btn-lg .hamburger-inner::after {\n  background: #6c757d;\n}\n\n.app-header.header-text-light .app-header-left > .nav > li > .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n.app-header.header-text-light .app-header-left > .nav > li > .nav-link .nav-link-icon {\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .app-header-left > .nav > li > .nav-link:hover {\n  color: rgb(255, 255, 255);\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt svg {\n  fill: rgba(255, 255, 255, 0.7);\n  transition: all 0.2s;\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt .icon-wrapper-bg {\n  background: rgba(255, 255, 255, 0.1) !important;\n  transition: all 0.2s;\n  opacity: 1;\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover svg {\n  fill: rgba(255, 255, 255, 0.95);\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {\n  background: rgba(255, 255, 255, 0.15) !important;\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt .badge-dot {\n  border-color: transparent;\n}\n.app-header.header-text-light .app-header-right > .header-btn-lg .widget-content-left .btn-group > .btn-link,\n.app-header.header-text-light .app-header-right > .header-btn-lg .widget-heading,\n.app-header.header-text-light .app-header-right > .header-btn-lg .widget-subheading {\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .app-header-right > .header-btn-lg .header-user-info > .btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);\n}\n.app-header.header-text-light .search-wrapper .input-holder .search-icon {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-light .search-wrapper .input-holder .search-input::placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-webkit-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-ms-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-moz-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n.app-header.header-text-light .search-wrapper.active .input-holder {\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-header.header-text-light .search-wrapper.active .input-holder .search-input {\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .search-wrapper.active .input-holder .search-icon {\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-header.header-text-light .header-btn-lg::before {\n  background: rgba(255, 255, 255, 0.2);\n}\n.app-header.header-text-light .header-btn-lg .hamburger-inner,\n.app-header.header-text-light .header-btn-lg .hamburger.is-active .hamburger-inner,\n.app-header.header-text-light .header-btn-lg .hamburger-inner::before,\n.app-header.header-text-light .header-btn-lg .hamburger-inner::after,\n.app-header.header-text-light .header__pane .hamburger-inner,\n.app-header.header-text-light .header__pane .hamburger.is-active .hamburger-inner,\n.app-header.header-text-light .header__pane .hamburger-inner::before,\n.app-header.header-text-light .header__pane .hamburger-inner::after {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n}\n.app-header.header-text-light .search-wrapper .input-holder .search-icon span::after {\n  border-color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .search-wrapper .close::before,\n.app-header.header-text-light .search-wrapper .close::after,\n.app-header.header-text-light .search-wrapper .input-holder .search-icon span::before {\n  background: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .app-header__logo .logo-src {\n  background: url(\"~assets/utils/images/logo.png\");\n}\n.app-header.header-text-light .app-header__mobile-menu .hamburger-inner,\n.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::before,\n.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::after {\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.app-header.header-text-dark .app-header-left > .nav > li > .nav-link {\n  color: rgba(0, 0, 0, 0.7);\n}\n.app-header.header-text-dark .app-header-left > .nav > li > .nav-link .nav-link-icon {\n  color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .app-header-left > .nav > li > .nav-link:hover {\n  color: rgb(0, 0, 0);\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt svg {\n  fill: rgba(0, 0, 0, 0.7);\n  transition: all 0.2s;\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt .icon-wrapper-bg {\n  background: rgba(0, 0, 0, 0.1) !important;\n  transition: all 0.2s;\n  opacity: 1;\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover svg {\n  fill: rgba(0, 0, 0, 0.95);\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {\n  background: rgba(0, 0, 0, 0.15) !important;\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt .badge-dot {\n  border-color: transparent;\n}\n.app-header.header-text-dark .app-header-right .widget-content-left > .btn-group > .btn-link,\n.app-header.header-text-dark .app-header-right .widget-content-left .widget-heading,\n.app-header.header-text-dark .app-header-right .widget-content-left .widget-subheading {\n  color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .search-wrapper .input-holder .search-icon {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-dark .search-wrapper.active .input-holder {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-dark .search-wrapper.active .input-holder .search-input {\n  color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .search-wrapper.active .input-holder .search-icon {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-dark .header-btn-lg::before {\n  background: rgba(0, 0, 0, 0.2);\n}\n.app-header.header-text-dark .header-btn-lg .hamburger-inner,\n.app-header.header-text-dark .header-btn-lg .hamburger.is-active .hamburger-inner,\n.app-header.header-text-dark .header-btn-lg .hamburger-inner::before,\n.app-header.header-text-dark .header-btn-lg .hamburger-inner::after,\n.app-header.header-text-dark .header__pane .hamburger-inner,\n.app-header.header-text-dark .header__pane .hamburger.is-active .hamburger-inner,\n.app-header.header-text-dark .header__pane .hamburger-inner::before,\n.app-header.header-text-dark .header__pane .hamburger-inner::after {\n  background-color: rgba(0, 0, 0, 0.8) !important;\n}\n.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::after {\n  border-color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .search-wrapper .close::before,\n.app-header.header-text-dark .search-wrapper .close::after,\n.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::before {\n  background: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .app-header__logo .logo-src {\n  background: url(\"~assets/utils/images/logo-inverse.png\");\n}\n\n.app-sidebar {\n  width: 280px;\n  display: flex;\n  z-index: 11;\n  overflow: hidden;\n  min-width: 280px;\n  position: relative;\n  flex: 0 0 280px;\n  margin-top: -60px;\n  padding-top: 60px;\n  transition: all 0.2s;\n}\n.app-sidebar .app-sidebar__inner {\n  padding: 2px 1.5rem 1.5rem;\n}\n.app-sidebar .scrollbar-container {\n  z-index: 15;\n  width: 100%;\n}\n.app-sidebar .app-sidebar-bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0.05;\n  background-size: cover;\n  z-index: 10;\n}\n.app-sidebar .app-header__logo {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: none;\n  z-index: 11;\n}\n.app-sidebar.sidebar-shadow {\n  box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);\n}\n\n.app-sidebar__heading {\n  text-transform: uppercase;\n  font-size: 0.8rem;\n  margin: 0.75rem 0;\n  font-weight: bold;\n  color: #545cd8;\n  white-space: nowrap;\n  position: relative;\n}\n\n.sidebar-mobile-overlay {\n  display: none;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: #333;\n  opacity: 0.6;\n  left: 0;\n  top: 0;\n  z-index: 12;\n}\n\n.vertical-nav-menu {\n  position: relative;\n}\n.vertical-nav-menu::after {\n  content: \" \";\n  pointer-events: none;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n}\n.vertical-nav-menu .metismenu-container,\n.vertical-nav-menu .metismenu-item {\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.vertical-nav-menu .metismenu-container {\n  list-style: none;\n}\n.vertical-nav-menu .metismenu-container:before {\n  opacity: 0;\n  transition: opacity 300ms;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link {\n  transition: transform 0.2s, height 300ms, color 300ms, background-color 300ms;\n  display: block;\n  line-height: 2.5rem;\n  height: 2.5rem;\n  padding: 0 1.5rem 0 45px;\n  position: relative;\n  border-radius: 0.25rem;\n  color: #343a40;\n  white-space: nowrap;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link:hover {\n  background: #e0f3ff;\n  text-decoration: none;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-icon {\n  opacity: 0.6;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-state-icon {\n  opacity: 1;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link.active {\n  color: #545cd8;\n  background: #e0f3ff;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link.has-active-child, .vertical-nav-menu .metismenu-container .metismenu-link.active {\n  font-weight: bold;\n}\n.vertical-nav-menu .metismenu-container i.metismenu-state-icon,\n.vertical-nav-menu .metismenu-container i.metismenu-icon {\n  text-align: center;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  position: absolute;\n  left: 5px;\n  top: 50%;\n  margin-top: -17px;\n  font-size: 1.5rem;\n  opacity: 0.3;\n  transition: color 300ms;\n}\n.vertical-nav-menu .metismenu-container i.metismenu-state-icon {\n  transition: transform 300ms;\n  left: auto;\n  right: 0;\n}\n.vertical-nav-menu .metismenu-container i.metismenu-state-icon.rotate-minus-90 {\n  transform: rotate(-180deg);\n}\n.vertical-nav-menu .metismenu-container .metismenu-container {\n  transition: padding 300ms;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible {\n  padding: 0.5em 0 0 2rem;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible:before {\n  content: \"\";\n  height: 100%;\n  opacity: 1;\n  width: 3px;\n  background: #e0f3ff;\n  position: absolute;\n  left: 20px;\n  top: 0;\n  border-radius: 15px;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link {\n  height: 2.3em;\n  line-height: 2.3em;\n  color: #6c757d;\n  margin: 0 0 3px;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link:hover {\n  color: #545cd8;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link .metismenu-icon {\n  display: none;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link.active {\n  color: #545cd8;\n  background: #e0f3ff;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-item > .metismenu-link {\n  height: 0;\n  overflow: hidden;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-link {\n  padding-left: 1em;\n}\n\n.app-sidebar.sidebar-text-light {\n  border-right: 0 !important;\n}\n.app-sidebar.sidebar-text-light .app-sidebar__heading {\n  color: rgba(255, 255, 255, 0.6);\n}\n.app-sidebar.sidebar-text-light .app-sidebar__heading::before {\n  background: rgba(255, 255, 255, 0.2) !important;\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link:hover {\n  color: rgb(255, 255, 255);\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link.active {\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {\n  color: rgba(255, 255, 255, 0.6);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link:hover {\n  color: rgb(255, 255, 255);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible::before {\n  background: rgba(255, 255, 255, 0.3);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-state-icon,\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-icon {\n  opacity: 0.5;\n}\n.app-sidebar.sidebar-text-light .ps__thumb-y {\n  background: rgba(255, 255, 255, 0.3);\n}\n.app-sidebar.sidebar-text-light .ps__rail-y:hover .ps__thumb-y {\n  background: rgba(255, 255, 255, 0.2);\n}\n.app-sidebar.sidebar-text-light .app-header__logo .logo-src {\n  background: url(\"~assets/utils/images/logo.png\");\n}\n.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner,\n.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::before,\n.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::after {\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.app-sidebar.sidebar-text-dark {\n  border-right: 0 !important;\n}\n.app-sidebar.sidebar-text-dark .app-sidebar__heading {\n  color: rgba(0, 0, 0, 0.6);\n}\n.app-sidebar.sidebar-text-dark .app-sidebar__heading::before {\n  background: rgba(0, 0, 0, 0.5) !important;\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link {\n  color: rgba(0, 0, 0, 0.7);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link:hover {\n  color: rgb(0, 0, 0);\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link.active {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {\n  color: rgba(0, 0, 0, 0.6);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible::before {\n  background: rgba(0, 0, 0, 0.3);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-state-icon,\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-icon {\n  opacity: 0.5;\n}\n.app-sidebar.sidebar-text-dark .ps__thumb-y {\n  background: rgba(0, 0, 0, 0.3);\n}\n.app-sidebar.sidebar-text-dark .ps__rail-y:hover .ps__thumb-y {\n  background: rgba(0, 0, 0, 0.2);\n}\n.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner,\n.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::before,\n.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::after {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.fixed-sidebar .app-sidebar {\n  position: fixed;\n  height: 100vh;\n}\n.fixed-sidebar .app-main .app-main__outer {\n  z-index: 9;\n  padding-left: 280px;\n}\n.fixed-sidebar.fixed-header .app-sidebar .app-header__logo {\n  display: none;\n}\n.fixed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {\n  display: flex;\n}\n.fixed-sidebar:not(.fixed-header) .app-header {\n  margin-left: 280px;\n}\n.fixed-sidebar:not(.fixed-header) .app-header .app-header__logo {\n  display: none;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-header {\n  margin-left: 80px;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {\n  width: 80px;\n  padding: 0;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .logo-src {\n  display: none;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .header__pane {\n  margin-right: auto;\n}\n\n.closed-sidebar .app-sidebar {\n  transition: all 0.3s ease;\n  width: 80px;\n  min-width: 80px;\n  flex: 0 0 80px;\n  z-index: 13;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading {\n  text-indent: -999em;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: #e0f3ff;\n  text-indent: 1px;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-link {\n  text-indent: -99rem;\n  padding: 0;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {\n  text-indent: 0;\n  left: 50%;\n  margin-left: -17px;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-state-icon {\n  visibility: hidden;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible {\n  padding: 0;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {\n  height: 0;\n}\n.closed-sidebar .app-sidebar:hover {\n  flex: 0 0 280px !important;\n  width: 280px !important;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading {\n  text-indent: initial;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading::before {\n  display: none;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-link {\n  text-indent: initial;\n  padding: 0 1.5rem 0 45px;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-icon {\n  text-indent: initial;\n  left: 5px;\n  margin-left: 0;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-state-icon {\n  visibility: visible;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible {\n  padding: 0.5em 0 0 2rem;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {\n  height: 2.3em;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {\n  padding-left: 1em;\n}\n.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar .scrollbar-container {\n  position: static;\n  height: auto;\n  overflow: initial !important;\n}\n.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar:hover .scrollbar-container {\n  position: absolute;\n  height: 100%;\n  overflow: hidden !important;\n}\n.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo {\n  width: 80px;\n}\n.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .logo-src {\n  display: none;\n}\n.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .header__pane {\n  margin-right: auto;\n}\n.closed-sidebar.fixed-sidebar .app-main__outer {\n  padding-left: 80px;\n}\n.closed-sidebar.fixed-header:not(.fixed-sidebar) .app-sidebar .app-header__logo {\n  visibility: hidden;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo,\n.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo {\n  width: auto;\n  display: flex;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane,\n.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo .header__pane {\n  display: none;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo {\n  display: flex;\n  width: 80px;\n  padding: 0 1.5rem !important;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .logo-src {\n  display: block !important;\n  margin: 0 auto;\n  width: 21px;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane {\n  display: none;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo {\n  width: 280px;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo .logo-src {\n  width: 97px;\n  margin: 0;\n}\n.closed-sidebar.closed-sidebar-mobile .app-header {\n  margin-left: 0 !important;\n}\n.closed-sidebar.fixed-footer .app-footer__inner {\n  margin-left: 0 !important;\n}\n\n.app-main {\n  z-index: 8;\n  position: relative;\n  display: flex;\n}\n.app-main .app-main__outer {\n  flex: 1;\n  flex-direction: column;\n  display: flex;\n  z-index: 12;\n  width: 1px;\n}\n.app-main .app-main__inner {\n  padding: 30px 30px 0;\n  flex: 1;\n}\n.app-main .app-main__inner > .RRT__container > .RRT__panel {\n  margin-top: 30px;\n}\n.app-main .app-main__inner > .RRT__container > .body-tabs-layout .RRT__tab {\n  margin-top: -0.5rem;\n}\n\n.body-tabs-shadow-btn .app-main__inner > .RRT__container > .RRT__panel {\n  margin-top: 20px;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout {\n  border: 0;\n  background: transparent;\n  position: relative;\n  z-index: 7;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__showmore {\n  margin-top: -13px;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab {\n  margin-top: 0.5rem;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab--selected {\n  color: #fff;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper {\n  position: absolute;\n  top: 1.1rem;\n  z-index: 5;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper .RRT__inkbar {\n  height: 35px;\n  margin-top: 0;\n  border-radius: 0.25rem;\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.app-theme-white.app-container {\n  background: #f1f4f6;\n}\n.app-theme-white .app-sidebar {\n  background: #ffffff;\n}\n.app-theme-white .app-page-title {\n  background: rgba(255, 255, 255, 0.55);\n}\n.app-theme-white .app-footer .app-footer__inner,\n.app-theme-white .app-header {\n  background: #fafbfc;\n}\n.app-theme-white.fixed-header .app-header__logo {\n  background: rgba(250, 251, 252, 0.1);\n}\n\n.app-theme-gray.app-container {\n  background: #ffffff;\n}\n.app-theme-gray .app-sidebar {\n  background: #ffffff;\n  border-right: #dee2e6 solid 1px;\n}\n.app-theme-gray .app-page-title {\n  background: rgba(0, 0, 0, 0.03);\n}\n.app-theme-gray .app-footer,\n.app-theme-gray .app-header {\n  background: #f8f9fa;\n}\n.app-theme-gray .app-footer {\n  border-top: #dee2e6 solid 1px;\n}\n.app-theme-gray .app-header .app-header__logo {\n  border-right: rgba(0, 0, 0, 0.1) solid 1px;\n}\n.app-theme-gray.fixed-header .app-header__logo {\n  background: rgba(0, 0, 0, 0.03);\n}\n.app-theme-gray .card {\n  border-width: 1px;\n}\n.app-theme-gray .main-card {\n  box-shadow: 0 0 0 0 transparent !important;\n}\n.app-theme-gray .main-card > .card-body > .card-title {\n  text-transform: none;\n  font-size: 1.1rem;\n  font-weight: normal;\n  border-bottom: #dee2e6 solid 1px;\n  position: relative;\n  padding: 0 0 1.125rem;\n  margin: 0 0 1.125rem;\n}\n.app-theme-gray .main-card > .card-body > .card-title::before {\n  position: absolute;\n  width: 40px;\n  background: #545cd8;\n  border-radius: 30px;\n  height: 5px;\n  left: 0;\n  bottom: -2px;\n  content: \"\";\n}\n.app-theme-gray .app-inner-layout__sidebar {\n  border-left: 0 !important;\n}\n\n.app-footer {\n  height: 60px;\n}\n.app-footer .app-footer__inner {\n  padding: 0 1.5rem 0 0.75rem;\n  height: 60px;\n  transition: all 0.2s;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.app-footer .app-footer__inner .app-footer-left {\n  display: flex;\n  align-items: center;\n}\n.app-footer .app-footer__inner .app-footer-right {\n  margin-left: auto;\n  display: flex;\n}\n\n.footer-dots {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.footer-dots .dots-separator {\n  height: 40px;\n  margin: 0 0.6rem;\n  width: 1px;\n  background: #e9ecef;\n}\n\n.dot-btn-wrapper {\n  padding: 0.5rem;\n  position: relative;\n  display: flex;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n.dot-btn-wrapper .badge-abs {\n  right: 50%;\n}\n.dot-btn-wrapper .badge-abs.badge-dot-sm {\n  top: -2px;\n  margin-right: -3px;\n}\n.dot-btn-wrapper .dot-btn-icon {\n  font-size: 1.8rem;\n}\n.dot-btn-wrapper:hover {\n  text-decoration: none;\n  opacity: 1;\n}\n\n.fixed-footer .app-footer {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  z-index: 7;\n}\n.fixed-footer .app-footer .app-footer__inner {\n  margin-left: 280px;\n  box-shadow: 0.3rem -0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.02), 0.3rem -0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.02), 0.3rem -0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.04), 0.3rem -0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.02);\n}\n.fixed-footer .app-main .app-main__outer {\n  padding-bottom: 60px;\n}\n.fixed-footer.closed-sidebar .app-footer .app-footer__inner {\n  margin-left: 80px !important;\n}\n\n.app-page-title {\n  padding: 30px;\n  margin: -30px -30px 30px;\n  position: relative;\n}\n.app-page-title .page-title-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.app-page-title .page-title-heading,\n.app-page-title .page-title-subheading {\n  margin: 0;\n  padding: 0;\n}\n.app-page-title .page-title-heading {\n  font-size: 1.25rem;\n  font-weight: 400;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.app-page-title .page-title-subheading {\n  padding: 3px 0 0;\n  font-size: 0.88rem;\n  opacity: 0.6;\n}\n.app-page-title .page-title-subheading .breadcrumb {\n  padding: 0;\n  margin: 3px 0 0;\n  background: transparent;\n}\n.app-page-title .page-title-actions {\n  margin-left: auto;\n}\n.app-page-title .page-title-actions .breadcrumb {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n}\n.app-page-title .page-title-icon {\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  padding: 0.8333333333rem;\n  margin: 0 30px 0 0;\n  background: #fff;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n  border-radius: 0.25rem;\n  width: 60px;\n  height: 60px;\n}\n.app-page-title .page-title-icon i {\n  margin: auto;\n}\n.app-page-title .page-title-icon.rounded-circle {\n  margin: 0 20px 0 0;\n}\n.app-page-title + .RRT__container {\n  margin-top: -23.0769230769px;\n}\n.app-page-title + .rc-tabs {\n  max-width: calc(100vw - 322px);\n  margin: -30px -15px 39px;\n}\n@media only screen and (max-width: 812px) and (min-width: 360px) {\n  .app-page-title + .rc-tabs {\n    max-width: calc(100vw - 0px);\n    margin: -30px -15px 39px;\n  }\n}\n.app-page-title.app-page-title-simple {\n  margin: 0;\n  background: none !important;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n}\n\n.page-title-icon-rounded .page-title-icon {\n  border-radius: 50px;\n}\n\n.body-tabs.body-tabs-layout {\n  margin-left: -30px;\n  margin-right: -30px;\n  padding: 0 30px;\n  border-top: 0;\n  border-bottom: #dee2e6 solid 1px;\n}\n\n.search-wrapper {\n  position: relative;\n  margin-right: 0.6666666667rem;\n}\n.search-wrapper .input-holder {\n  height: 42px;\n  width: 42px;\n  overflow: hidden;\n  position: relative;\n  transition: all 0.3s ease-in-out;\n}\n.search-wrapper .input-holder .search-input {\n  width: 100%;\n  padding: 0 70px 0 20px;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: transparent;\n  box-sizing: border-box;\n  border: none;\n  outline: none;\n  transform: translate(0, 60px);\n  transition: all 0.3s cubic-bezier(0, 0.105, 0.035, 1.57);\n  transition-delay: 0.3s;\n  font-size: 0.88rem;\n}\n.search-wrapper .input-holder .search-icon {\n  width: 42px;\n  height: 42px;\n  border: none;\n  padding: 0;\n  outline: none;\n  position: relative;\n  z-index: 2;\n  float: right;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 30px;\n}\n.search-wrapper .input-holder .search-icon span {\n  width: 22px;\n  height: 22px;\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  transform: rotate(45deg);\n  transition: all 0.4s cubic-bezier(0.65, -0.6, 0.24, 1.65);\n}\n.search-wrapper .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {\n  position: absolute;\n  content: \"\";\n}\n.search-wrapper .input-holder .search-icon span::before {\n  width: 4px;\n  height: 11px;\n  left: 9px;\n  top: 13px;\n  border-radius: 2px;\n  background: #545cd8;\n}\n.search-wrapper .input-holder .search-icon span::after {\n  width: 14px;\n  height: 14px;\n  left: 4px;\n  top: 0;\n  border-radius: 16px;\n  border: 2px solid #545cd8;\n}\n.search-wrapper .close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  margin-top: -10px;\n  cursor: pointer;\n  opacity: 0 !important;\n  transform: rotate(-180deg);\n  transition: all 0.2s cubic-bezier(0.285, -0.45, 0.935, 0.11);\n  transition-delay: 0.1s;\n}\n.search-wrapper .close::before, .search-wrapper .close::after {\n  position: absolute;\n  content: \"\";\n  background: #545cd8;\n  border-radius: 2px;\n}\n.search-wrapper .close::before {\n  width: 2px;\n  height: 20px;\n  left: 9px;\n  top: 0;\n}\n.search-wrapper .close::after {\n  width: 20px;\n  height: 2px;\n  left: 0;\n  top: 9px;\n}\n.search-wrapper.active {\n  width: 330px;\n}\n.search-wrapper.active .input-holder {\n  width: 290px;\n  border-radius: 50px;\n  background: rgba(0, 0, 0, 0.05);\n  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);\n}\n.search-wrapper.active .input-holder .search-input {\n  opacity: 1;\n  transform: translate(0, 11px);\n}\n.search-wrapper.active .input-holder .search-icon {\n  width: 42px;\n  height: 42px;\n  margin: 0;\n  border-radius: 30px;\n}\n.search-wrapper.active .input-holder .search-icon span {\n  transform: rotate(-45deg);\n}\n.search-wrapper.active .close {\n  left: 300px;\n  opacity: 0.6 !important;\n  transform: rotate(45deg);\n  transition: all 0.6s cubic-bezier(0, 0.105, 0.035, 1.57);\n  transition-delay: 0.5s;\n}\n.search-wrapper.active .close:hover {\n  opacity: 1 !important;\n}\n.search-wrapper.active + .header-megamenu {\n  opacity: 0;\n}\n\n.opacity-01 {\n  opacity: 0.01 !important;\n}\n\n.opacity-02 {\n  opacity: 0.02 !important;\n}\n\n.opacity-03 {\n  opacity: 0.03 !important;\n}\n\n.opacity-04 {\n  opacity: 0.04 !important;\n}\n\n.opacity-05 {\n  opacity: 0.05 !important;\n}\n\n.opacity-06 {\n  opacity: 0.06 !important;\n}\n\n.opacity-07 {\n  opacity: 0.07 !important;\n}\n\n.opacity-08 {\n  opacity: 0.08 !important;\n}\n\n.opacity-09 {\n  opacity: 0.09 !important;\n}\n\n.opacity-1 {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-2 {\n  opacity: 0.2 !important;\n}\n\n.opacity-3 {\n  opacity: 0.3 !important;\n}\n\n.opacity-4 {\n  opacity: 0.4 !important;\n}\n\n.opacity-5 {\n  opacity: 0.5 !important;\n}\n\n.opacity-6 {\n  opacity: 0.6 !important;\n}\n\n.opacity-7 {\n  opacity: 0.7 !important;\n}\n\n.opacity-8 {\n  opacity: 0.8 !important;\n}\n\n.opacity-9 {\n  opacity: 0.9 !important;\n}\n\n.opacity-10 {\n  opacity: 1 !important;\n}\n\n.filter-grayscale-5 {\n  filter: grayscale(5%) !important;\n}\n\n.filter-grayscale-10 {\n  filter: grayscale(10%) !important;\n}\n\n.filter-grayscale-20 {\n  filter: grayscale(20%) !important;\n}\n\n.filter-grayscale-30 {\n  filter: grayscale(30%) !important;\n}\n\n.filter-grayscale-40 {\n  filter: grayscale(40%) !important;\n}\n\n.filter-grayscale-50 {\n  filter: grayscale(50%) !important;\n}\n\n.filter-grayscale-80 {\n  filter: grayscale(80%) !important;\n}\n\n.filter-grayscale-100 {\n  filter: grayscale(100%) !important;\n}\n\n.br-tl {\n  border-top-left-radius: 0.25rem !important;\n}\n\n.br-tr {\n  border-top-right-radius: 0.25rem !important;\n}\n\n.br-bl {\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.br-br {\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.b-radius-0 {\n  border-radius: 0 !important;\n}\n\n.rm-border {\n  border-width: 0 !important;\n}\n\n.br-a {\n  border-radius: 0.25rem;\n}\n\n.margin-h-center {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.center-svg {\n  margin: 0 auto;\n}\n.center-svg svg {\n  margin: 0 auto;\n}\n\n.apexcharts-canvas {\n  margin: 0 auto;\n}\n\n.apexcharts-donut {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.alert-dismissible .close {\n  top: 0;\n  right: 5px;\n  padding: 5px;\n}\n\n.icon-gradient {\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-fill-color: transparent;\n}\n\n.font-size-xlg {\n  font-size: 1.3rem !important;\n}\n\n.font-size-md {\n  font-size: 0.9rem !important;\n}\n\n.font-size-lg {\n  font-size: 1.1rem !important;\n}\n\n.no-shadow {\n  box-shadow: 0 0 0 transparent !important;\n}\n\n.h-100 {\n  height: 100vh !important;\n}\n\n.he-auto {\n  height: auto !important;\n}\n\n.he-100 {\n  height: 100%;\n}\n\n.h-sm {\n  height: 150px;\n}\n\n.text-nowrap {\n  white-space: nowrap;\n}\n\n.fsize-1 {\n  font-size: 0.95rem !important;\n}\n\n.fsize-2 {\n  font-size: 1.3rem !important;\n}\n\n.fsize-3 {\n  font-size: 1.6rem !important;\n}\n\n.fsize-4 {\n  font-size: 2rem !important;\n}\n\n.z-index-6 {\n  z-index: 6;\n}\n\n.line-height-1 {\n  line-height: 1;\n}\n\n.center-elem {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.flex2 {\n  flex: 2;\n}\n\n.divider {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  height: 1px;\n  overflow: hidden;\n  background: #e9ecef;\n}\n\n.list-group-item:hover {\n  z-index: initial;\n}\n\n.no-results {\n  padding: 1.5rem;\n  text-align: center;\n}\n.no-results .results-title {\n  color: #495057;\n  font-size: 1.25rem;\n}\n.no-results .results-subtitle {\n  color: #adb5bd;\n  font-size: 1.1rem;\n}\n\n.bg-animation {\n  animation: bg-pan-left 8s both;\n}\n\n@-webkit-keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n@keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n.w-100 {\n  width: 100%;\n}\n\n.mb--2 {\n  margin-bottom: -1.5rem;\n}\n\n.mbg-3 {\n  margin-bottom: 30px;\n}\n\n.loader-container {\n  align-items: center;\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  width: 100vw;\n  text-align: center;\n  line-height: 1.6rem;\n}\n.loader-container .loader-container-inner {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 0 1.5rem;\n}\n.loader-container small {\n  margin: 10px 0 0;\n  display: block;\n  color: #6c757d;\n  font-weight: normal;\n}\n.loader-container h3 {\n  text-align: center;\n  display: block;\n}\n\n.bg-warm-flame {\n  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;\n}\n\n.bg-night-fade {\n  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;\n}\n\n.bg-sunny-morning {\n  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;\n}\n\n.bg-tempting-azure {\n  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;\n}\n\n.bg-amy-crisp {\n  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;\n}\n\n.bg-heavy-rain {\n  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;\n}\n\n.bg-mean-fruit {\n  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;\n}\n\n.bg-malibu-beach {\n  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;\n}\n\n.bg-deep-blue {\n  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;\n}\n\n.bg-ripe-malin {\n  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;\n}\n\n.bg-arielle-smile {\n  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;\n}\n\n.bg-plum-plate {\n  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n}\n\n.bg-happy-fisher {\n  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;\n}\n\n.bg-happy-itmeo {\n  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;\n}\n\n.bg-mixed-hopes {\n  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;\n}\n\n.bg-strong-bliss {\n  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;\n}\n\n.bg-grow-early {\n  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;\n}\n\n.bg-love-kiss {\n  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;\n}\n\n.bg-premium-dark {\n  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;\n}\n\n.bg-happy-green {\n  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;\n}\n\n.bg-vicious-stance {\n  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;\n}\n\n.bg-midnight-bloom {\n  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;\n}\n\n.bg-night-sky {\n  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;\n}\n\n.bg-slick-carbon {\n  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.25) 200%) !important;\n  background-blend-mode: multiply;\n}\n\n.bg-royal {\n  background-image: linear-gradient(to right, #141e30, #243b55) !important;\n}\n\n.bg-asteroid {\n  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;\n}\n\n.bg-transparent {\n  background: transparent !important;\n}\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\nCopyright (c) 2015 Daniel Eden\n*/\nbody {\n  -webkit-backface-visibility: hidden;\n}\n\n.animated, .TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s);\n  animation-duration: calc(1s);\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n.animated.infinite, .infinite.TabsAnimation-appear {\n  animation-iteration-count: infinite;\n}\n.animated.hinge, .hinge.TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s * 2);\n  animation-duration: calc(1s * 2);\n}\n.animated.bounceIn, .bounceIn.TabsAnimation-appear, .animated.bounceOut, .bounceOut.TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s * 0.75);\n  animation-duration: calc(1s * 0.75);\n}\n.animated.flipOutX, .flipOutX.TabsAnimation-appear, .animated.flipOutY, .flipOutY.TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s * 0.75);\n  animation-duration: calc(1s * 0.75);\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.fadeInUp, .TabsAnimation-appear {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp;\n}\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes lightSpeedIn {\n  0% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n  60% {\n    -webkit-transform: translateX(-20%) skewX(30deg);\n    opacity: 1;\n  }\n  80% {\n    -webkit-transform: translateX(0%) skewX(-15deg);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n}\n@keyframes lightSpeedIn {\n  0% {\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n  60% {\n    transform: translateX(-20%) skewX(30deg);\n    opacity: 1;\n  }\n  80% {\n    transform: translateX(0%) skewX(-15deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n}\n.lightSpeedIn {\n  -webkit-animation-name: lightSpeedIn;\n  animation-name: lightSpeedIn;\n  -webkit-animation-timing-function: ease-out;\n  animation-timing-function: ease-out;\n}\n\n@-webkit-keyframes lightSpeedOut {\n  0% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n}\n@keyframes lightSpeedOut {\n  0% {\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n}\n.lightSpeedOut {\n  -webkit-animation-name: lightSpeedOut;\n  animation-name: lightSpeedOut;\n  -webkit-animation-timing-function: ease-in;\n  animation-timing-function: ease-in;\n}\n\n.dropdown-menu.show {\n  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n\n.popover.show {\n  display: block;\n  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n\n.dropdown-menu[data-placement^=top].show {\n  animation: fade-in3 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n  bottom: auto !important;\n  top: auto !important;\n}\n\n@keyframes fade-in2 {\n  0% {\n    margin-top: -50px;\n    visibility: hidden;\n    opacity: 0;\n  }\n  100% {\n    margin-top: 0px;\n    visibility: visible;\n    opacity: 1;\n  }\n}\n.form-control {\n  transition: all 0.2s;\n}\n\n.btn-outline-2x {\n  border-width: 2px;\n}\n\n.btn-group .btn {\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n.btn-group .btn-outline-2x + .btn-outline-2x {\n  margin-left: -2px;\n}\n.btn-group .btn-square {\n  border-radius: 0;\n}\n\n.btn {\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n.btn.btn-pill.btn-wide, .btn.btn-pill {\n  border-top-left-radius: 50px;\n  border-bottom-left-radius: 50px;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n\n.btn-dashed {\n  border-style: dashed;\n}\n\n.btn-icon {\n  vertical-align: bottom;\n}\n.btn-icon.btn-icon-right .btn-icon-wrapper {\n  margin-left: 0.5rem;\n  margin-right: 0;\n}\n.btn-icon .btn-icon-wrapper {\n  margin-right: 0.5rem;\n  margin-left: 0;\n  margin-top: 0;\n  font-size: 17px;\n  vertical-align: middle;\n  transition: color 0.1s;\n  display: inline-block;\n}\n.btn-icon.btn-link {\n  text-decoration: none;\n}\n.btn-icon.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 25px;\n}\n.btn-icon.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 16px;\n}\n\n.btn-icon-only .btn-icon-wrapper {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.btn-hover-shine {\n  position: relative;\n}\n.btn-hover-shine:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.4);\n  -webkit-transition: none;\n  -moz-transition: none;\n  transition: none;\n}\n.btn-hover-shine:hover:after {\n  width: 120%;\n  background-color: rgba(255, 255, 255, 0);\n  transition: all 0.4s ease-in-out;\n}\n.btn-hover-shine.btn-pill::after {\n  border-top-left-radius: 50px;\n  border-bottom-left-radius: 50px;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n\n.btn-icon-vertical {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.btn-icon-vertical .btn-icon-wrapper {\n  display: block;\n  font-size: 200%;\n  margin: 5px 0;\n  opacity: 0.6;\n}\n.btn-icon-vertical.btn-link {\n  text-decoration: none;\n}\n.btn-icon-vertical.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 25px;\n}\n.btn-icon-vertical.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 16px;\n}\n.btn-icon-vertical:active .btn-icon-wrapper, .btn-icon-vertical.active .btn-icon-wrapper, .btn-icon-vertical:hover .btn-icon-wrapper {\n  opacity: 1;\n}\n.btn-icon-vertical.btn-icon-bottom .btn-icon-wrapper {\n  margin: 0.2rem 0 5px;\n}\n.btn-icon-vertical.btn-transition-text .btn-icon-wrapper {\n  transition: all 0.2s !important;\n}\n.btn-icon-vertical.btn-transition-text:hover .btn-icon-wrapper {\n  transform: scale(1.3);\n}\n.btn-icon-vertical.btn-transition-text.btn-transition-alt:hover .btn-icon-wrapper {\n  color: #fff !important;\n}\n\n.btn-icon-lg {\n  font-size: 2.5rem !important;\n}\n\n.btn-transition {\n  color: #6c757d;\n  border-color: #e9ecef;\n  background-color: none;\n}\n.btn-transition.btn-outline-link {\n  border-color: transparent;\n  background-color: transparent;\n}\n.btn-transition.btn-outline-link:hover {\n  color: #545cd8;\n  background: #f8f9fa;\n}\n.btn-transition.disabled, .btn-transition:disabled {\n  color: #6c757d;\n  border-color: #e9ecef;\n}\n.btn-transition:hover .btn-icon-wrapper {\n  transition: none;\n}\n\n.btn-transition-alt:hover .icon-gradient {\n  -webkit-background-clip: initial;\n  -webkit-text-fill-color: initial;\n  background-clip: initial;\n  text-fill-color: initial;\n  background: none !important;\n  color: #fff;\n}\n\n.btn-square {\n  border-radius: 0 !important;\n}\n\n.btn.btn-wide {\n  padding: 0.375rem 1.5rem;\n  font-size: 0.8rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n}\n\n.btn-lg.btn-wide, .btn-group-lg > .btn-wide.btn {\n  padding: 0.5rem 2rem;\n  font-size: 1.1rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\n.btn-sm.btn-wide, .btn-group-sm > .btn-wide.btn {\n  padding: 0.25rem 1rem;\n  font-size: 0.8rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.dropdown-toggle::after {\n  position: relative;\n  top: 2px;\n  opacity: 0.8;\n}\n\n.dropright .dropdown-toggle::after {\n  top: 0;\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, 0.1) solid 1px;\n}\n\n.btn-gradient-primary {\n  background-image: linear-gradient(140deg, rgb(16.2773109244%, 19.6162464986%, 71.3697478992%) -30%, #545cd8 90%);\n  background-color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);\n  border-color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);\n  color: #fff;\n}\n.btn-gradient-primary.active, .btn-gradient-primary:active, .btn-gradient-primary:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(15.1630252101%, 18.2733893557%, 66.4840336134%) 0%, rgb(28.0554621849%, 31.4212885154%, 83.5915966387%) 100%);\n  color: #fff;\n  border-color: rgb(12.5630252101%, 15.1400560224%, 55.0840336134%);\n}\n.btn-gradient-primary:focus, .btn-gradient-primary.focus, .btn-gradient-primary:active, .btn-gradient-primary.active {\n  color: #fff !important;\n  border-color: rgb(14.4201680672%, 17.3781512605%, 63.2268907563%) !important;\n}\n.btn-gradient-primary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n.btn-gradient-primary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);\n}\n\n.btn-gradient-secondary {\n  background-image: linear-gradient(140deg, rgb(28.4473617773%, 30.8179752588%, 32.9251872423%) -30%, #6c757d 90%);\n  background-color: rgb(28.4473617773%, 30.8179752588%, 32.9251872423%);\n  border-color: rgb(28.4473617773%, 30.8179752588%, 32.9251872423%);\n  color: #fff;\n}\n.btn-gradient-secondary.active, .btn-gradient-secondary:active, .btn-gradient-secondary:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(25.6662458975%, 27.8050997223%, 29.7063031221%) 0%, rgb(39.5718252966%, 42.8694774047%, 45.800723723%) 100%);\n  color: #fff;\n  border-color: rgb(19.1769755112%, 20.7750568038%, 22.1955735084%);\n}\n.btn-gradient-secondary:focus, .btn-gradient-secondary.focus, .btn-gradient-secondary:active, .btn-gradient-secondary.active {\n  color: #fff !important;\n  border-color: rgb(23.8121686443%, 25.7965160313%, 27.5603803753%) !important;\n}\n.btn-gradient-secondary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n.btn-gradient-secondary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);\n}\n\n.btn-gradient-success {\n  background-image: linear-gradient(140deg, rgb(15.8947043384%, 53.7131387988%, 34.2558283156%) -30%, #3ac47d 90%);\n  background-color: rgb(15.8947043384%, 53.7131387988%, 34.2558283156%);\n  border-color: rgb(15.8947043384%, 53.7131387988%, 34.2558283156%);\n  color: #fff;\n}\n.btn-gradient-success.active, .btn-gradient-success:active, .btn-gradient-success:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(14.5246255983%, 49.083217539%, 31.3030724101%) 0%, rgb(21.3750192991%, 72.2328238382%, 46.0668519376%) 100%);\n  color: #fff;\n  border-color: rgb(11.3277752046%, 38.2800679327%, 24.4133086305%);\n}\n.btn-gradient-success:focus, .btn-gradient-success.focus, .btn-gradient-success:active, .btn-gradient-success.active {\n  color: #fff !important;\n  border-color: rgb(13.6112397715%, 45.9966033658%, 29.3345684731%) !important;\n}\n.btn-gradient-success.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n.btn-gradient-success.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);\n}\n\n.btn-gradient-info {\n  background-image: linear-gradient(140deg, rgb(0%, 55.3537936914%, 88.8235294118%) -30%, #30b1ff 90%);\n  background-color: rgb(0%, 55.3537936914%, 88.8235294118%);\n  border-color: rgb(0%, 55.3537936914%, 88.8235294118%);\n  color: #fff;\n}\n.btn-gradient-info.active, .btn-gradient-info:active, .btn-gradient-info:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(0%, 51.6146632566%, 82.8235294118%) 0%, rgb(12.8235294118%, 67.1508951407%, 100%) 100%);\n  color: #fff;\n  border-color: rgb(0%, 42.8900255754%, 68.8235294118%);\n}\n.btn-gradient-info:focus, .btn-gradient-info.focus, .btn-gradient-info:active, .btn-gradient-info.active {\n  color: #fff !important;\n  border-color: rgb(0%, 49.1219096334%, 78.8235294118%) !important;\n}\n.btn-gradient-info.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n.btn-gradient-info.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);\n}\n\n.btn-gradient-warning {\n  background-image: linear-gradient(140deg, rgb(78.1264576315%, 56.00846506%, 2.8539345254%) -30%, #f7b924 90%);\n  background-color: rgb(78.1264576315%, 56.00846506%, 2.8539345254%);\n  border-color: rgb(78.1264576315%, 56.00846506%, 2.8539345254%);\n  color: #fff;\n}\n.btn-gradient-warning.active, .btn-gradient-warning:active, .btn-gradient-warning:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(72.337911376%, 51.8586853243%, 2.6424807809%) 0%, rgb(96.6512913535%, 70.6987993435%, 8.3291008033%) 100%);\n  color: #fff;\n  border-color: rgb(58.8313034465%, 42.1758659411%, 2.1490887104%);\n}\n.btn-gradient-warning:focus, .btn-gradient-warning.focus, .btn-gradient-warning:active, .btn-gradient-warning.active {\n  color: #fff !important;\n  border-color: rgb(68.478880539%, 49.0921655006%, 2.5015116179%) !important;\n}\n.btn-gradient-warning.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n.btn-gradient-warning.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);\n}\n\n.btn-gradient-danger {\n  background-image: linear-gradient(140deg, rgb(59.4681179558%, 10.1397251814%, 21.923730122%) -30%, #d92550 90%);\n  background-color: rgb(59.4681179558%, 10.1397251814%, 21.923730122%);\n  border-color: rgb(59.4681179558%, 10.1397251814%, 21.923730122%);\n  color: #fff;\n}\n.btn-gradient-danger.active, .btn-gradient-danger:active, .btn-gradient-danger:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(54.3421337039%, 9.2657094334%, 20.0339663424%) 0%, rgb(79.9720549637%, 13.6357881735%, 29.4827852401%) 100%);\n  color: #fff;\n  border-color: rgb(42.3815037826%, 7.2263393546%, 15.6245175235%);\n}\n.btn-gradient-danger:focus, .btn-gradient-danger.focus, .btn-gradient-danger:active, .btn-gradient-danger.active {\n  color: #fff !important;\n  border-color: rgb(50.9248108692%, 8.683032268%, 18.7741238228%) !important;\n}\n.btn-gradient-danger.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n.btn-gradient-danger.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);\n}\n\n.btn-gradient-focus {\n  background-image: linear-gradient(140deg, rgb(12.8828828829%, 12.1250662427%, 15.9141494436%) -30%, #444054 90%);\n  background-color: rgb(12.8828828829%, 12.1250662427%, 15.9141494436%);\n  border-color: rgb(12.8828828829%, 12.1250662427%, 15.9141494436%);\n  color: #fff;\n}\n.btn-gradient-focus.active, .btn-gradient-focus:active, .btn-gradient-focus:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(10.1261261261%, 9.5304716481%, 12.5087440382%) 0%, rgb(23.9099099099%, 22.5034446211%, 29.5357710652%) 100%);\n  color: #fff;\n  border-color: rgb(3.6936936937%, 3.4764175941%, 4.5627980922%);\n}\n.btn-gradient-focus:focus, .btn-gradient-focus.focus, .btn-gradient-focus:active, .btn-gradient-focus.active {\n  color: #fff !important;\n  border-color: rgb(8.2882882883%, 7.8007419184%, 10.2384737679%) !important;\n}\n.btn-gradient-focus.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n.btn-gradient-focus.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);\n}\n\n.btn-gradient-alternate {\n  background-image: linear-gradient(140deg, rgb(33.9831684886%, 22.8283879924%, 35.799062988%) -30%, #83588a 90%);\n  background-color: rgb(33.9831684886%, 22.8283879924%, 35.799062988%);\n  border-color: rgb(33.9831684886%, 22.8283879924%, 35.799062988%);\n  color: #fff;\n}\n.btn-gradient-alternate.active, .btn-gradient-alternate:active, .btn-gradient-alternate:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(30.5052923824%, 20.4921048065%, 32.1353461739%) 0%, rgb(47.8946729134%, 32.1735207357%, 50.4539302447%) 100%);\n  color: #fff;\n  border-color: rgb(22.3902481347%, 15.0407773729%, 23.5866736075%);\n}\n.btn-gradient-alternate:focus, .btn-gradient-alternate.focus, .btn-gradient-alternate:active, .btn-gradient-alternate.active {\n  color: #fff !important;\n  border-color: rgb(28.1867083116%, 18.9345826826%, 29.6928682978%) !important;\n}\n.btn-gradient-alternate.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n.btn-gradient-alternate.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);\n}\n\n.btn-gradient-light {\n  background-image: linear-gradient(140deg, rgb(78.3333333333%, 78.3333333333%, 78.3333333333%) -30%, #eeeeee 90%);\n  background-color: rgb(78.3333333333%, 78.3333333333%, 78.3333333333%);\n  border-color: rgb(78.3333333333%, 78.3333333333%, 78.3333333333%);\n  color: #212529;\n}\n.btn-gradient-light.active, .btn-gradient-light:active, .btn-gradient-light:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(75.3333333333%, 75.3333333333%, 75.3333333333%) 0%, rgb(90.3333333333%, 90.3333333333%, 90.3333333333%) 100%);\n  color: #212529;\n  border-color: rgb(68.3333333333%, 68.3333333333%, 68.3333333333%);\n}\n.btn-gradient-light:focus, .btn-gradient-light.focus, .btn-gradient-light:active, .btn-gradient-light.active {\n  color: #212529 !important;\n  border-color: #bbbbbb !important;\n}\n.btn-gradient-light.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n.btn-gradient-light.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);\n}\n\n.btn-gradient-dark {\n  background-image: linear-gradient(140deg, rgb(6.9438810007%, 7.7450980392%, 8.5463150778%) -30%, #343a40 90%);\n  background-color: rgb(6.9438810007%, 7.7450980392%, 8.5463150778%);\n  border-color: rgb(6.9438810007%, 7.7450980392%, 8.5463150778%);\n  color: #fff;\n}\n.btn-gradient-dark.active, .btn-gradient-dark:active, .btn-gradient-dark:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(4.2542258283%, 4.7450980392%, 5.2359702502%) 0%, rgb(17.7025016903%, 19.7450980392%, 21.7876943881%) 100%);\n  color: #fff;\n  border-color: black;\n}\n.btn-gradient-dark:focus, .btn-gradient-dark.focus, .btn-gradient-dark:active, .btn-gradient-dark.active {\n  color: #fff !important;\n  border-color: rgb(2.46112238%, 2.7450980392%, 3.0290736984%) !important;\n}\n.btn-gradient-dark.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n.btn-gradient-dark.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);\n}\n\n.btn-shadow.active {\n  box-shadow: 0 0 0 0 transparent !important;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: rgb(20.7268907563%, 24.4355742297%, 81.9201680672%);\n  border-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n}\n.btn-primary:focus, .btn-primary.focus {\n  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n  border-color: rgb(17.2058823529%, 20.7352941176%, 75.4411764706%);\n}\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);\n}\n.btn-primary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n.btn-primary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary:hover {\n  color: #fff;\n  background-color: rgb(35.4001514769%, 38.3501641%, 40.9723975427%);\n  border-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.btn-secondary:focus, .btn-secondary.focus {\n  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n  border-color: rgb(30.7649583439%, 33.3287048725%, 35.6075906758%);\n}\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);\n}\n.btn-secondary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n.btn-secondary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: rgb(19.3199011888%, 65.2879419484%, 41.6377180794%);\n  border-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);\n}\n.btn-success:focus, .btn-success.focus {\n  box-shadow: 0 0 0 0 rgba(34.3333333333%, 80.3333333333%, 56.6666666667%, 0.5);\n}\n.btn-success.disabled, .btn-success:disabled {\n  color: #fff;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);\n  border-color: rgb(17.0364366219%, 57.5714065154%, 36.7164582368%);\n}\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(34.3333333333%, 80.3333333333%, 56.6666666667%, 0.5);\n}\n.btn-success.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n.btn-success.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info:hover {\n  color: #fff;\n  background-color: rgb(3.8235294118%, 63.7595907928%, 100%);\n  border-color: rgb(0%, 61.5856777494%, 98.8235294118%);\n}\n.btn-info:focus, .btn-info.focus {\n  box-shadow: 0 0 0 0 rgba(31%, 74%, 100%, 0.5);\n}\n.btn-info.disabled, .btn-info:disabled {\n  color: #fff;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(0%, 61.5856777494%, 98.8235294118%);\n  border-color: rgb(0%, 58.4697357204%, 93.8235294118%);\n}\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(31%, 74%, 100%, 0.5);\n}\n.btn-info.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n.btn-info.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);\n}\n\n.btn-warning {\n  color: #212529;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning:hover {\n  color: #212529;\n  background-color: rgb(92.5978232703%, 66.3829143992%, 3.3825688866%);\n  border-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);\n}\n.btn-warning:focus, .btn-warning.focus {\n  box-shadow: 0 0 0 0 rgba(84.2745098039%, 63.8431372549%, 14.4117647059%, 0.5);\n}\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #212529;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {\n  color: #212529;\n  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);\n  border-color: rgb(82.9502461778%, 59.4666148398%, 3.0301459791%);\n}\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(84.2745098039%, 63.8431372549%, 14.4117647059%, 0.5);\n}\n.btn-warning.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n.btn-warning.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: rgb(72.2830785858%, 12.3247645515%, 26.6481395708%);\n  border-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);\n}\n.btn-danger:focus, .btn-danger.focus {\n  box-shadow: 0 0 0 0 rgba(87.3333333333%, 27.3333333333%, 41.6666666667%, 0.5);\n}\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);\n  border-color: rgb(63.7397714992%, 10.8680716381%, 23.4985332716%);\n}\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(87.3333333333%, 27.3333333333%, 41.6666666667%, 0.5);\n}\n.btn-danger.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n.btn-danger.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);\n}\n\n.btn-light {\n  color: #212529;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light:hover {\n  color: #212529;\n  background-color: rgb(85.8333333333%, 85.8333333333%, 85.8333333333%);\n  border-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);\n}\n.btn-light:focus, .btn-light.focus {\n  box-shadow: 0 0 0 0 rgba(81.2745098039%, 81.5098039216%, 81.7450980392%, 0.5);\n}\n.btn-light.disabled, .btn-light:disabled {\n  color: #212529;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {\n  color: #212529;\n  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);\n  border-color: rgb(80.8333333333%, 80.8333333333%, 80.8333333333%);\n}\n.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(81.2745098039%, 81.5098039216%, 81.7450980392%, 0.5);\n}\n.btn-light.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n.btn-light.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: rgb(13.6680189317%, 15.2450980392%, 16.8221771467%);\n  border-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);\n}\n.btn-dark:focus, .btn-dark.focus {\n  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);\n}\n.btn-dark.disabled, .btn-dark:disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);\n  border-color: rgb(9.185260311%, 10.2450980392%, 11.3049357674%);\n}\n.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);\n}\n.btn-dark.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n.btn-dark.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);\n}\n\n.btn-focus {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus:hover {\n  color: #fff;\n  background-color: rgb(19.7747747748%, 18.6115527292%, 24.4276629571%);\n  border-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);\n}\n.btn-focus:focus, .btn-focus.focus {\n  box-shadow: 0 0 0 0 rgba(37.6666666667%, 36.3333333333%, 43%, 0.5);\n}\n.btn-focus.disabled, .btn-focus:disabled {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus:not(:disabled):not(.disabled):active, .btn-focus:not(:disabled):not(.disabled).active, .show > .btn-focus.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);\n  border-color: rgb(15.1801801802%, 14.2872284049%, 18.7519872814%);\n}\n.btn-focus:not(:disabled):not(.disabled):active:focus, .btn-focus:not(:disabled):not(.disabled).active:focus, .show > .btn-focus.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(37.6666666667%, 36.3333333333%, 43%, 0.5);\n}\n.btn-focus.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n.btn-focus.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);\n}\n\n.btn-alternate {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate:hover {\n  color: #fff;\n  background-color: rgb(42.6778587541%, 28.669095957%, 44.9583550234%);\n  border-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);\n}\n.btn-alternate:focus, .btn-alternate.focus {\n  box-shadow: 0 0 0 0 rgba(58.6666666667%, 44.3333333333%, 61%, 0.5);\n}\n.btn-alternate.disabled, .btn-alternate:disabled {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate:not(:disabled):not(.disabled):active, .btn-alternate:not(:disabled):not(.disabled).active, .show > .btn-alternate.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);\n  border-color: rgb(36.8813985771%, 24.7752906472%, 38.8521603332%);\n}\n.btn-alternate:not(:disabled):not(.disabled):active:focus, .btn-alternate:not(:disabled):not(.disabled).active:focus, .show > .btn-alternate.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(58.6666666667%, 44.3333333333%, 61%, 0.5);\n}\n.btn-alternate.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n.btn-alternate.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);\n}\n\n.btn-shadow-primary:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n\n.btn-shadow-secondary:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n\n.btn-shadow-success:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n\n.btn-shadow-info:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n\n.btn-shadow-warning:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n\n.btn-shadow-danger:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n\n.btn-shadow-light:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n\n.btn-shadow-dark:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-shadow-focus:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n\n.btn-shadow-alternate:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n\n.btn-outline-primary {\n  color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n  color: #545cd8;\n  background-color: transparent;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary.btn-shadow.active:hover, .btn-outline-primary.btn-shadow.disabled:hover, .btn-outline-primary.btn-shadow:active:hover, .btn-outline-primary.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);\n}\n.btn-outline-primary.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(84, 92, 216, 0.19);\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary.btn-shadow.active:hover, .btn-outline-secondary.btn-shadow.disabled:hover, .btn-outline-secondary.btn-shadow:active:hover, .btn-outline-secondary.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);\n}\n.btn-outline-secondary.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(108, 117, 125, 0.19);\n}\n\n.btn-outline-success {\n  color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:focus, .btn-outline-success.focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n  color: #3ac47d;\n  background-color: transparent;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success.btn-shadow.active:hover, .btn-outline-success.btn-shadow.disabled:hover, .btn-outline-success.btn-shadow:active:hover, .btn-outline-success.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);\n}\n.btn-outline-success.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(58, 196, 125, 0.19);\n}\n\n.btn-outline-info {\n  color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:focus, .btn-outline-info.focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n  color: #30b1ff;\n  background-color: transparent;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info.btn-shadow.active:hover, .btn-outline-info.btn-shadow.disabled:hover, .btn-outline-info.btn-shadow:active:hover, .btn-outline-info.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);\n}\n.btn-outline-info.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(48, 177, 255, 0.19);\n}\n\n.btn-outline-warning {\n  color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:hover {\n  color: #212529;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n  color: #f7b924;\n  background-color: transparent;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning.btn-shadow.active:hover, .btn-outline-warning.btn-shadow.disabled:hover, .btn-outline-warning.btn-shadow:active:hover, .btn-outline-warning.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);\n}\n.btn-outline-warning.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(247, 185, 36, 0.19);\n}\n\n.btn-outline-danger {\n  color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n  color: #d92550;\n  background-color: transparent;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger.btn-shadow.active:hover, .btn-outline-danger.btn-shadow.disabled:hover, .btn-outline-danger.btn-shadow:active:hover, .btn-outline-danger.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);\n}\n.btn-outline-danger.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(217, 37, 80, 0.19);\n}\n\n.btn-outline-light {\n  color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:hover {\n  color: #212529;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:focus, .btn-outline-light.focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n  color: #eeeeee;\n  background-color: transparent;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {\n  color: #212529;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light.btn-shadow.active:hover, .btn-outline-light.btn-shadow.disabled:hover, .btn-outline-light.btn-shadow:active:hover, .btn-outline-light.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);\n}\n.btn-outline-light.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(238, 238, 238, 0.19);\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark.btn-shadow.active:hover, .btn-outline-dark.btn-shadow.disabled:hover, .btn-outline-dark.btn-shadow:active:hover, .btn-outline-dark.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);\n}\n.btn-outline-dark.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(52, 58, 64, 0.19);\n}\n\n.btn-outline-focus {\n  color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:hover {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:focus, .btn-outline-focus.focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus.disabled, .btn-outline-focus:disabled {\n  color: #444054;\n  background-color: transparent;\n}\n.btn-outline-focus:not(:disabled):not(.disabled):active, .btn-outline-focus:not(:disabled):not(.disabled).active, .show > .btn-outline-focus.dropdown-toggle {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:not(:disabled):not(.disabled):active:focus, .btn-outline-focus:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-focus.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus.btn-shadow.active:hover, .btn-outline-focus.btn-shadow.disabled:hover, .btn-outline-focus.btn-shadow:active:hover, .btn-outline-focus.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);\n}\n.btn-outline-focus.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(68, 64, 84, 0.19);\n}\n\n.btn-outline-alternate {\n  color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:hover {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:focus, .btn-outline-alternate.focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate.disabled, .btn-outline-alternate:disabled {\n  color: #83588a;\n  background-color: transparent;\n}\n.btn-outline-alternate:not(:disabled):not(.disabled):active, .btn-outline-alternate:not(:disabled):not(.disabled).active, .show > .btn-outline-alternate.dropdown-toggle {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:not(:disabled):not(.disabled):active:focus, .btn-outline-alternate:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-alternate.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate.btn-shadow.active:hover, .btn-outline-alternate.btn-shadow.disabled:hover, .btn-outline-alternate.btn-shadow:active:hover, .btn-outline-alternate.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);\n}\n.btn-outline-alternate.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(131, 88, 138, 0.19);\n}\n\n.btn {\n  position: relative;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n\n.btn-light {\n  border-color: rgb(86.0784313725%, 86.0784313725%, 86.0784313725%);\n}\n\n.btn-outline-light {\n  color: #8f8f8f;\n}\n\n.dropdown-menu {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n  font-size: 0.88rem;\n  margin: 0.125rem;\n}\n.dropdown-menu.dropdown-menu-right {\n  right: 0 !important;\n}\n.dropdown-menu .dropdown-header {\n  text-transform: uppercase;\n  font-size: 0.7333333333rem;\n  color: #545cd8;\n  font-weight: bold;\n}\n.dropdown-menu .dropdown-item {\n  font-size: 0.88rem;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n  z-index: 6;\n  position: relative;\n}\n.dropdown-menu .dropdown-item .dropdown-icon {\n  font-size: 1rem;\n  margin-right: 0.325rem;\n  width: 30px;\n  text-align: center;\n  opacity: 0.3;\n  margin-left: -10px;\n}\n.dropdown-menu .dropdown-item:hover .dropdown-icon {\n  opacity: 0.7;\n}\n.dropdown-menu.dropdown-menu-shadow {\n  box-shadow: 0 0.66875rem 2.3875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 1.1375rem 1.60625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.45rem 0.73125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.325rem 0.3875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n\n.dropdown-menu-rounded {\n  border-radius: 10px;\n  padding: 0.65rem;\n}\n.dropdown-menu-rounded .dropdown-item {\n  border-radius: 30px;\n}\n.dropdown-menu-rounded .dropdown-divider {\n  margin-left: -0.65rem;\n  margin-right: -0.65rem;\n}\n.dropdown-menu-rounded .dropdown-menu-header {\n  margin-left: -0.65rem;\n  margin-right: -0.65rem;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n.dropdown-menu-rounded .menu-header-image,\n.dropdown-menu-rounded .dropdown-menu-header-inner {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.dropdown-menu-hover-link .dropdown-item:hover {\n  background: none;\n  color: #545cd8;\n}\n\n.dropdown-menu-hover-primary .dropdown-item:hover {\n  background: #545cd8;\n  color: #fff;\n}\n\n.dropdown-menu.dropdown-menu-lg {\n  min-width: 22rem;\n}\n.dropdown-menu.dropdown-menu-xl {\n  min-width: 25rem;\n}\n\n.dropdown-menu .dropdown-menu-header,\n.dropdown-menu .menu-header-image,\n.dropdown-menu .dropdown-menu-header-inner {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.dropdown-menu-header {\n  color: #fff;\n  margin-top: -0.65rem;\n  margin-bottom: 0.65rem;\n  position: relative;\n  z-index: 6;\n}\n.dropdown-menu-header .dropdown-menu-header-inner {\n  margin: -1px -1px 0;\n  padding: 1.5rem 0.5rem;\n  position: relative;\n}\n.dropdown-menu-header .menu-header-image {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 8;\n  opacity: 0.25;\n  filter: grayscale(80%);\n  background-size: cover;\n}\n.dropdown-menu-header .menu-header-content {\n  text-align: center;\n  position: relative;\n  z-index: 10;\n}\n.dropdown-menu-header .menu-header-content.text-left {\n  padding-left: 0.5rem;\n}\n.dropdown-menu-header .menu-header-content.btn-pane-right {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  text-align: left;\n}\n.dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {\n  margin: 0 0 0 auto;\n}\n.dropdown-menu-header .menu-header-content .menu-header-btn-pane {\n  margin-top: 10px;\n  margin-bottom: 3px;\n}\n.dropdown-menu-header + .grid-menu {\n  margin-top: -0.65rem;\n}\n\n.menu-header-title {\n  font-weight: 500;\n  font-size: 1.25rem;\n  margin: 0;\n}\n\n.menu-header-subtitle {\n  font-size: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  margin: 5px 0 0;\n  opacity: 0.8;\n}\n\n.dropdown-menu .grid-menu {\n  margin-bottom: -0.65rem;\n  padding: 1px;\n}\n.dropdown-menu .grid-menu [class*=col-] {\n  padding: 0.65rem;\n}\n.dropdown-menu .grid-menu-xl {\n  margin-bottom: -0.4814814815rem;\n}\n.dropdown-menu .grid-menu-xl [class*=col-] {\n  padding: 0;\n}\n\n.dropdown-toggle::after {\n  position: relative;\n  top: 2px;\n  opacity: 0.8;\n  margin-left: 5px;\n}\n\n.dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-toggle::after {\n  top: 0;\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, 0.1) solid 2px;\n}\n\n.dropdown-menu::before, .dropdown-menu::after {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  left: 5px;\n  top: -5px;\n  transform: rotate(45deg);\n  border-radius: 4px;\n  content: \"\";\n  display: block;\n  z-index: 5;\n}\n.dropdown-menu::before {\n  background: #fff;\n  z-index: 5;\n}\n.dropdown-menu::after {\n  top: -6px;\n  background: rgba(0, 0, 0, 0.15);\n  z-index: 4;\n}\n.dropdown-menu[data-placement=top-start]::before, .dropdown-menu[data-placement=top-start]::after {\n  top: auto;\n  bottom: -5px;\n}\n.dropdown-menu[data-placement=top-start]::after {\n  bottom: -6px;\n}\n.dropdown-menu[data-placement=left-start]::before, .dropdown-menu[data-placement=left-start]::after {\n  left: auto;\n  right: -5px;\n  top: 5px;\n}\n.dropdown-menu[data-placement=left-start]::after {\n  top: 5px;\n  right: -6px;\n}\n.dropdown-menu[data-placement=right-start]::before, .dropdown-menu[data-placement=right-start]::after {\n  right: auto;\n  left: -5px;\n  top: 5px;\n}\n.dropdown-menu[data-placement=right-start]::after {\n  top: 5px;\n  left: -6px;\n}\n.dropdown-menu.dropdown-menu-right::before, .dropdown-menu.dropdown-menu-right::after {\n  left: auto;\n  right: 6px;\n}\n.dropdown-menu.dropdown-menu-right::after {\n  right: 6px;\n}\n.dropdown-menu.rm-pointers::before, .dropdown-menu.rm-pointers::after {\n  display: none;\n}\n\n.dropdown-mega-menu {\n  width: 56rem;\n  padding: 1rem;\n}\n.dropdown-mega-menu .nav-item.nav-item-header {\n  text-transform: none;\n  font-size: 1rem;\n  padding-top: 0;\n  font-weight: normal;\n}\n.dropdown-mega-menu .grid-menu {\n  margin-bottom: 0;\n}\n\n.dropdown-mega-menu-sm {\n  width: 40rem;\n}\n\nbody .dropdown-menu.dropdown-menu-inline {\n  border: 0;\n  position: static !important;\n  box-shadow: 0 0 0 transparent;\n  background: transparent;\n  border-radius: 0;\n  display: inline-block;\n  float: none;\n  left: 0 !important;\n  top: 0 !important;\n  width: 100% !important;\n  transform: translateY(0) !important;\n}\nbody .dropdown-menu.dropdown-menu-inline::before, body .dropdown-menu.dropdown-menu-inline::after {\n  display: none;\n}\n\n.nav-item .nav-link {\n  font-weight: normal;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n}\n.nav-link .nav-link-icon {\n  color: #545cd8;\n  font-size: 1rem;\n  width: 30px;\n  text-align: center;\n  opacity: 0.45;\n  margin-left: -10px;\n}\n.nav-link:hover {\n  color: #495057;\n}\n.nav-link:hover .nav-link-icon {\n  opacity: 0.9;\n  color: #545cd8;\n}\n.nav-link:disabled .nav-link-icon, .nav-link.disabled .nav-link-icon {\n  opacity: 0.3;\n}\n\n.nav-item.nav-item-header {\n  text-transform: uppercase;\n  font-size: 0.7333333333rem;\n  color: #6c757d;\n  font-weight: bold;\n  padding: 0.5rem 1rem;\n}\n.nav-item.nav-item-btn {\n  padding: 0.5rem 1rem;\n}\n.nav-item.nav-item-divider {\n  margin: 0.5rem 0;\n  height: 1px;\n  overflow: hidden;\n  background: #dee2e6;\n}\n\n.nav .badge {\n  margin-left: 8px;\n}\n\n.nav-pills .nav-link.active, .nav-pills .nav-link.active:hover {\n  color: #fff;\n}\n.nav-pills .nav-link.active .nav-link-icon, .nav-pills .nav-link.active:hover .nav-link-icon {\n  color: #fff;\n  opacity: 0.8;\n}\n.nav-pills .nav-link:hover {\n  color: #495057 !important;\n}\n\n.grid-menu [class*=col-] {\n  border-right: #dee2e6 solid 0;\n  border-bottom: #dee2e6 solid 1px;\n}\n.grid-menu [class*=col-]:hover {\n  z-index: 5;\n}\n@media (min-width: 576px) {\n  .grid-menu [class*=col-]:nth-last-child(-n+2) {\n    border-bottom-width: 0;\n  }\n  .grid-menu [class*=col-]:nth-child(1n) {\n    border-right-width: 1px;\n  }\n  .grid-menu [class*=col-]:nth-child(2n) {\n    border-right-width: 0;\n  }\n}\n.grid-menu [class*=col-]:nth-last-child(-n+1) {\n  border-bottom-width: 0;\n}\n@media (min-width: 1200px) {\n  .grid-menu.grid-menu-3col [class*=col-]:nth-last-child(-n+3) {\n    border-bottom-width: 0;\n  }\n  .grid-menu.grid-menu-3col [class*=col-]:nth-child(2n) {\n    border-right-width: 1px;\n  }\n  .grid-menu.grid-menu-3col [class*=col-]:nth-child(3n) {\n    border-right-width: 0;\n  }\n}\n.grid-menu .btn {\n  display: block;\n  border: 0;\n  min-width: 100%;\n}\n\n.badge-primary {\n  color: #fff;\n  background-color: #545cd8;\n}\na.badge-primary:hover, a.badge-primary:focus {\n  color: #fff;\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n}\na.badge-primary:focus, a.badge-primary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(84, 92, 216, 0.5);\n}\n\n.badge-secondary {\n  color: #fff;\n  background-color: #6c757d;\n}\na.badge-secondary:hover, a.badge-secondary:focus {\n  color: #fff;\n  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\na.badge-secondary:focus, a.badge-secondary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.badge-success {\n  color: #fff;\n  background-color: #3ac47d;\n}\na.badge-success:hover, a.badge-success:focus {\n  color: #fff;\n  background-color: rgb(18.1781689054%, 61.4296742319%, 39.1770881581%);\n}\na.badge-success:focus, a.badge-success.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(58, 196, 125, 0.5);\n}\n\n.badge-info {\n  color: #fff;\n  background-color: #30b1ff;\n}\na.badge-info:hover, a.badge-info:focus {\n  color: #fff;\n  background-color: rgb(0%, 61.5856777494%, 98.8235294118%);\n}\na.badge-info:focus, a.badge-info.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(48, 177, 255, 0.5);\n}\n\n.badge-warning {\n  color: #212529;\n  background-color: #f7b924;\n}\na.badge-warning:hover, a.badge-warning:focus {\n  color: #212529;\n  background-color: rgb(87.774034724%, 62.9247646195%, 3.2063574328%);\n}\na.badge-warning:focus, a.badge-warning.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(247, 185, 36, 0.5);\n}\n\n.badge-danger {\n  color: #fff;\n  background-color: #d92550;\n}\na.badge-danger:hover, a.badge-danger:focus {\n  color: #fff;\n  background-color: rgb(68.0114250425%, 11.5964180948%, 25.0733364212%);\n}\na.badge-danger:focus, a.badge-danger.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(217, 37, 80, 0.5);\n}\n\n.badge-light {\n  color: #212529;\n  background-color: #eeeeee;\n}\na.badge-light:hover, a.badge-light:focus {\n  color: #212529;\n  background-color: rgb(83.3333333333%, 83.3333333333%, 83.3333333333%);\n}\na.badge-light:focus, a.badge-light.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(238, 238, 238, 0.5);\n}\n\n.badge-dark {\n  color: #fff;\n  background-color: #343a40;\n}\na.badge-dark:hover, a.badge-dark:focus {\n  color: #fff;\n  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);\n}\na.badge-dark:focus, a.badge-dark.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.badge-focus {\n  color: #fff;\n  background-color: #444054;\n}\na.badge-focus:hover, a.badge-focus:focus {\n  color: #fff;\n  background-color: rgb(17.4774774775%, 16.449390567%, 21.5898251192%);\n}\na.badge-focus:focus, a.badge-focus.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(68, 64, 84, 0.5);\n}\n\n.badge-alternate {\n  color: #fff;\n  background-color: #83588a;\n}\na.badge-alternate:hover, a.badge-alternate:focus {\n  color: #fff;\n  background-color: rgb(39.7796286656%, 26.7221933021%, 41.9052576783%);\n}\na.badge-alternate:focus, a.badge-alternate.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(131, 88, 138, 0.5);\n}\n\n.badge {\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 5px 10px;\n  min-width: 19px;\n}\n\n.badge-light {\n  background: #fff;\n}\n\n.badge-dot {\n  text-indent: -999em;\n  padding: 0;\n  width: 8px;\n  height: 8px;\n  border: transparent solid 1px;\n  border-radius: 30px;\n  min-width: 2px;\n}\n\n.badge-dot-lg {\n  width: 10px;\n  height: 10px;\n}\n\n.badge-dot-xl {\n  width: 18px;\n  height: 18px;\n  position: relative;\n}\n.badge-dot-xl::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 0.25rem;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: -5px 0 0 -5px;\n  background: #fff;\n}\n\n.badge-dot-sm {\n  width: 6px;\n  height: 6px;\n}\n\n.btn .badge {\n  margin-left: 8px;\n}\n.btn .badge-dot {\n  position: absolute;\n  border: #fff solid 2px;\n  top: -5px;\n  right: -5px;\n  width: 11px;\n  height: 11px;\n}\n.btn .badge-dot.badge-dot-lg {\n  width: 14px;\n  height: 14px;\n}\n.btn .badge-dot.badge-dot-sm {\n  width: 8px;\n  height: 8px;\n  border-width: 1px;\n}\n.btn .badge-dot-inside {\n  top: 10px;\n  right: 10px;\n}\n\n.btn-sm .badge-dot-sm, .btn-group-sm > .btn .badge-dot-sm {\n  top: 1px;\n  right: 4px;\n}\n.btn-sm .badge-dot, .btn-group-sm > .btn .badge-dot {\n  top: 0px;\n  right: 2px;\n}\n.btn-sm .badge-dot-lg, .btn-group-sm > .btn .badge-dot-lg {\n  top: -3px;\n  right: -2px;\n}\n.btn-sm .badge-pill, .btn-group-sm > .btn .badge-pill {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n}\n\n.badge-abs {\n  position: absolute;\n  right: -3px;\n  top: -3px;\n}\n\n.avatar-icon-wrapper {\n  display: inline-block;\n  margin-right: 0.1rem;\n  position: relative;\n}\n.avatar-icon-wrapper .badge {\n  position: absolute;\n  right: -2px;\n  top: -2px;\n}\n.avatar-icon-wrapper .badge:empty {\n  display: block;\n}\n.avatar-icon-wrapper .badge.badge-bottom {\n  top: auto;\n  right: -2px;\n  bottom: -2px;\n}\n.avatar-icon-wrapper .badge-dot {\n  width: 10px;\n  height: 10px;\n  border: #fff solid 2px;\n}\n.avatar-icon-wrapper .badge-dot.badge-dot-lg {\n  width: 14px;\n  height: 14px;\n  border: #fff solid 2px;\n  top: 0;\n  right: 0;\n}\n.avatar-icon-wrapper .badge-dot.badge-dot-lg.badge-bottom {\n  top: auto;\n  right: 0;\n  bottom: 0;\n}\n\n.avatar-icon-add .avatar-icon {\n  background: #e0f3ff;\n  border: rgb(57.3697478992%, 59.3641456583%, 90.2773109244%) dashed 1px;\n  color: #545cd8;\n  text-align: center;\n  opacity: 0.6;\n}\n.avatar-icon-add .avatar-icon i {\n  font-style: normal;\n  vertical-align: middle;\n  font-size: 1.5rem;\n  display: block;\n  height: 100%;\n}\n.avatar-icon-add:hover {\n  cursor: pointer;\n}\n.avatar-icon-add:hover .avatar-icon {\n  opacity: 1;\n}\n\na.avatar-icon-wrapper:hover .avatar-icon {\n  opacity: 0.8;\n}\n\n.avatar-icon {\n  display: block;\n  width: 44px;\n  height: 44px;\n  transition: all 0.2s;\n  opacity: 1;\n  border-radius: 50px;\n}\n.avatar-icon.rounded {\n  border-radius: 0.39rem !important;\n}\n\n.avatar-icon-xl .avatar-icon {\n  width: 64px;\n  height: 64px;\n}\n.avatar-icon-xl.avatar-icon-add i {\n  font-size: 2rem;\n}\n\n.avatar-icon-lg .avatar-icon {\n  width: 54px;\n  height: 54px;\n}\n.avatar-icon-lg.avatar-icon-add i {\n  font-size: 1.75rem;\n}\n\n.avatar-icon-sm .avatar-icon {\n  width: 34px;\n  height: 34px;\n}\n.avatar-icon-sm.avatar-icon-add i {\n  font-size: 1.1rem;\n}\n\n.avatar-icon-xs .avatar-icon {\n  width: 26px;\n  height: 26px;\n  transition: transform 0.2s;\n}\n.avatar-icon-xs.avatar-icon-add i {\n  line-height: 26px;\n  font-size: 0.88rem;\n}\n.avatar-icon-xs:hover .avatar-icon {\n  transform: scale(2);\n}\n\n.avatar-icon {\n  border: #fff solid 3px;\n  overflow: hidden;\n}\n.avatar-icon img {\n  width: 100%;\n  height: 100%;\n}\n\n.avatar-wrapper-overlap .avatar-icon-wrapper {\n  z-index: 5;\n  margin-left: -18px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper:hover {\n  z-index: 7;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xl {\n  margin-left: -30px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-lg {\n  margin-left: -24px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-sm {\n  margin-left: -14px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xs {\n  margin-left: -10px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-add, .avatar-wrapper-overlap .avatar-icon-wrapper:first-child {\n  margin-left: 0 !important;\n}\n\n@-webkit-keyframes sploosh {\n  0% {\n    box-shadow: 0 0 0 0px rgba(51, 51, 51, 0.2);\n  }\n  100% {\n    box-shadow: 0 0 0 8px rgba(51, 51, 51, 0);\n  }\n}\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n  }\n  16.5% {\n    -webkit-transform: scale(1.2);\n  }\n  33% {\n    -webkit-transform: scale(1.1);\n  }\n  100% {\n    -webkit-transform: scale(1);\n  }\n}\n.badge-pulse {\n  -webkit-animation: pulse 2s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  position: relative;\n}\n.badge-pulse::before, .badge-pulse::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  border: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);\n  -webkit-animation-iteration-count: infinite;\n}\n.badge-pulse::after {\n  -webkit-animation-delay: 0.33s;\n  -webkit-animation-duration: 2.2s;\n}\n\n.card {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n  border-width: 0;\n  transition: all 0.2s;\n}\n.card > .dropdown-menu-header {\n  margin: 0;\n}\n.card > .dropdown-menu-header .dropdown-menu-header-inner {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.card.text-dark.text-white .card-footer,\n.card.text-dark.text-white .card-header, .card.text-white .card-footer,\n.card.text-white .card-header {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n}\n.card.text-dark.text-white .card-footer,\n.card.text-dark.text-white .card-header {\n  color: rgba(0, 0, 0, 0.9);\n}\n.card .card-footer {\n  display: flex;\n  align-items: center;\n}\n\n.btn-actions-pane-right {\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.btn-actions-pane-left {\n  margin-right: auto;\n}\n\n.actions-icon-btn .btn-icon-only {\n  padding-left: 0;\n  padding-right: 0;\n}\n.actions-icon-btn .btn-icon-only .btn-icon-wrapper {\n  font-size: 1.3rem;\n  width: 30px;\n  text-align: center;\n}\n.actions-icon-btn .btn-icon-only {\n  color: #495057;\n}\n.actions-icon-btn .btn-icon-only:hover {\n  color: #545cd8;\n}\n\n.card-header,\n.card-title {\n  text-transform: uppercase;\n  color: rgba(6.9915966387%, 8.4257703081%, 30.6554621849%, 0.7);\n  font-weight: bold;\n  font-size: 0.88rem;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  border-bottom-width: 1px;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-right: 0.625rem;\n  height: 3.5rem;\n}\n.card-header.no-border {\n  border: 0;\n  padding: 0;\n  height: auto;\n}\n.card-header .menu-header-subtitle {\n  display: block;\n}\n.card-header.card-header-tab .nav {\n  width: auto;\n  margin-left: auto;\n}\n.card-header.card-header-tab .card-header-title {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n.card-header .header-icon {\n  font-size: 1.65rem;\n  margin-right: 0.625rem;\n}\n.card-header > .nav {\n  margin-left: -0.625rem;\n  height: 100%;\n  width: 100%;\n}\n.card-header > .nav .nav-item {\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.card-header > .nav .nav-link {\n  text-transform: none;\n  width: 100%;\n  display: block;\n  color: #495057;\n}\n.card-header > .nav .nav-link::before {\n  content: \"\";\n  border-radius: 15px;\n  background: #545cd8;\n  transition: all 0.2s;\n  height: 4px;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  opacity: 0;\n}\n.card-header > .nav .nav-link:hover {\n  color: #545cd8;\n}\n.card-header > .nav .nav-link.active {\n  color: #545cd8;\n}\n.card-header > .nav .nav-link.active::before {\n  opacity: 1;\n}\n.card-header.card-header-tab-animation .nav .nav-link::before {\n  transform: scale(0);\n  opacity: 1;\n  width: 90%;\n  left: 5%;\n}\n.card-header.card-header-tab-animation .nav .nav-link.active::before, .card-header.card-header-tab-animation .nav .nav-link:hover::before {\n  transform: scale(1);\n}\n\n.card-border {\n  box-shadow: 0 0 0 transparent;\n  border-width: 1px;\n}\n\n.card-hover-shadow:hover {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n\n.card-hover-shadow-2x:hover {\n  box-shadow: 0 0.66875rem 2.3875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 1.1375rem 1.60625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.45rem 0.73125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.325rem 0.3875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n\n.card-subtitle {\n  margin-bottom: 0.75rem;\n  font-size: 0.968rem;\n  color: rgba(6.9915966387%, 8.4257703081%, 30.6554621849%, 0.55);\n}\n\n.card-shadow-primary {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.03), 0 0.9375rem 1.40625rem rgba(84, 92, 216, 0.03), 0 0.25rem 0.53125rem rgba(84, 92, 216, 0.05), 0 0.125rem 0.1875rem rgba(84, 92, 216, 0.03);\n}\n\n.card-shadow-secondary {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.03), 0 0.9375rem 1.40625rem rgba(108, 117, 125, 0.03), 0 0.25rem 0.53125rem rgba(108, 117, 125, 0.05), 0 0.125rem 0.1875rem rgba(108, 117, 125, 0.03);\n}\n\n.card-shadow-success {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.03), 0 0.9375rem 1.40625rem rgba(58, 196, 125, 0.03), 0 0.25rem 0.53125rem rgba(58, 196, 125, 0.05), 0 0.125rem 0.1875rem rgba(58, 196, 125, 0.03);\n}\n\n.card-shadow-info {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.03), 0 0.9375rem 1.40625rem rgba(48, 177, 255, 0.03), 0 0.25rem 0.53125rem rgba(48, 177, 255, 0.05), 0 0.125rem 0.1875rem rgba(48, 177, 255, 0.03);\n}\n\n.card-shadow-warning {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.03), 0 0.9375rem 1.40625rem rgba(247, 185, 36, 0.03), 0 0.25rem 0.53125rem rgba(247, 185, 36, 0.05), 0 0.125rem 0.1875rem rgba(247, 185, 36, 0.03);\n}\n\n.card-shadow-danger {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.03), 0 0.9375rem 1.40625rem rgba(217, 37, 80, 0.03), 0 0.25rem 0.53125rem rgba(217, 37, 80, 0.05), 0 0.125rem 0.1875rem rgba(217, 37, 80, 0.03);\n}\n\n.card-shadow-light {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.03), 0 0.9375rem 1.40625rem rgba(238, 238, 238, 0.03), 0 0.25rem 0.53125rem rgba(238, 238, 238, 0.05), 0 0.125rem 0.1875rem rgba(238, 238, 238, 0.03);\n}\n\n.card-shadow-dark {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.03), 0 0.9375rem 1.40625rem rgba(52, 58, 64, 0.03), 0 0.25rem 0.53125rem rgba(52, 58, 64, 0.05), 0 0.125rem 0.1875rem rgba(52, 58, 64, 0.03);\n}\n\n.card-shadow-focus {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.03), 0 0.9375rem 1.40625rem rgba(68, 64, 84, 0.03), 0 0.25rem 0.53125rem rgba(68, 64, 84, 0.05), 0 0.125rem 0.1875rem rgba(68, 64, 84, 0.03);\n}\n\n.card-shadow-alternate {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.03), 0 0.9375rem 1.40625rem rgba(131, 88, 138, 0.03), 0 0.25rem 0.53125rem rgba(131, 88, 138, 0.05), 0 0.125rem 0.1875rem rgba(131, 88, 138, 0.03);\n}\n\n.card-header-lg {\n  padding: 1.5rem 2.5rem;\n  height: auto;\n}\n\n.sticky-active-class .sticky-inner-wrapper > div {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n\n.nav-pills,\n.nav-tabs {\n  margin-bottom: 1rem;\n}\n\n.nav-link {\n  font-weight: bold;\n}\n.nav-link:hover {\n  cursor: pointer;\n}\n\n.nav-tabs .nav-link:hover {\n  color: #545cd8 !important;\n}\n.nav-tabs .nav-link.active {\n  color: #545cd8;\n}\n\n.nav-pills .nav-link:hover {\n  color: #545cd8 !important;\n}\n.nav-pills .nav-link.active {\n  background: #545cd8;\n}\n.nav-pills .nav-link.active:hover {\n  color: #fff !important;\n}\n\n.RRT__container {\n  position: relative;\n}\n\n.RRT__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.RRT__accordion {\n  flex-direction: column;\n}\n\n.RRT__tab {\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  padding: 0.5rem 1rem;\n  transition: all 0.2s;\n}\n.RRT__tab:hover {\n  color: #545cd8;\n}\n.RRT__tab:focus {\n  outline: 0;\n}\n\n.RRT__tab--selected {\n  color: #545cd8;\n}\n\n.RRT__tab--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.RRT__tab:focus {\n  z-index: 2;\n}\n\n.RRT__tab--selected .RRT__removable {\n  position: relative;\n}\n\n.RRT__tab--selected .RRT__removable-text {\n  margin-right: 10px;\n}\n\n.RRT__tab--selected .RRT__removable-icon {\n  position: absolute;\n  font-size: 18px;\n  right: 0.5em;\n  top: 0.2em;\n}\n\n.body-tabs.body-tabs-layout.body-tabs-big {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  margin: 0 auto;\n  padding: 10px;\n  border-radius: 50px;\n  border: #e9ecef solid 1px;\n  z-index: 7;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 300;\n  padding: 0;\n  height: 50px;\n  line-height: 50px;\n  flex: 1;\n  text-align: center;\n  position: relative;\n  color: #545cd8;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab:hover {\n  color: #212529;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected {\n  color: #fff;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected:hover {\n  color: #fff;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper {\n  height: 70px !important;\n  top: -70px !important;\n  margin: 0 auto -3.4rem;\n  position: relative;\n  padding: 0 10px;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper::before {\n  position: absolute;\n  content: \"\";\n  background: #fff;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: -11px;\n  border-radius: 50px;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper .RRT__inkbar {\n  height: 50px !important;\n  margin-top: 10px;\n  border-radius: 50px;\n  box-shadow: 0 0 0 transparent;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper + .RRT__panel {\n  margin-top: -1rem;\n}\n\n.RRT__panel {\n  margin-top: 1rem;\n}\n\n.RRT__showmore {\n  border-radius: 0.25rem;\n  background: #545cd8;\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  font-weight: bold;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  display: block;\n  margin-left: 15px;\n  position: absolute;\n  right: 30px;\n  top: 50%;\n  margin-top: -18px;\n  font-size: 1.4rem;\n}\n.RRT__showmore:focus {\n  outline: none;\n}\n\n.RRT__showmore-label {\n  position: relative;\n  z-index: 1;\n  color: #fff;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  line-height: 24px;\n}\n\n.RRT__showmore--selected {\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.RRT__showmore-list {\n  position: absolute;\n  right: -1px;\n  top: 100%;\n  display: none;\n  min-width: 15rem;\n  padding: 0.65rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 0.88rem;\n  color: #495057;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n.RRT__showmore-list .RRT__tab {\n  display: block;\n  width: 100%;\n  padding: 0.4rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n}\n.RRT__showmore-list .RRT__tab:hover, .RRT__showmore-list .RRT__tab.RRT__tab--selected {\n  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%) !important;\n  text-decoration: none;\n  background: #e0f3ff;\n}\n\n.RRT__showmore-list--opened {\n  display: block;\n}\n.RRT__showmore-list--opened .RRT__tab--selected {\n  color: #545cd8;\n}\n\n.RRT__inkbar-wrapper {\n  width: 100%;\n}\n\n.RRT__inkbar {\n  position: relative;\n  bottom: 0;\n  height: 3px;\n  margin-top: -3px;\n  background-color: #545cd8;\n  border-radius: 15px;\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n  z-index: 2;\n}\n\n.card-tabs .card-header {\n  padding: 0 1.25rem;\n}\n.card-tabs .card-header.RRT__tabs {\n  cursor: pointer;\n  font-weight: normal;\n}\n.card-tabs .card-header.RRT__tabs .RRT__tab {\n  text-transform: none;\n  line-height: 1.3;\n}\n.card-tabs .RRT__inkbar-wrapper {\n  width: calc(100% - 1.5rem) !important;\n  margin-left: 1.25rem;\n}\n.card-tabs .RRT__panel {\n  padding: 1rem;\n  margin: 0;\n}\n.card-tabs.text-white .RRT__tab {\n  color: rgba(255, 255, 255, 0.6);\n}\n.card-tabs.text-white .RRT__tab:hover {\n  color: #fff;\n}\n.card-tabs.text-white .RRT__tab--selected {\n  color: #fff;\n}\n.card-tabs.text-white .RRT__inkbar {\n  background: rgb(98.0840336134%, 98.1736694678%, 99.5630252101%);\n}\n\n.card-tabs-animated .RRT__container > .RRT__tabs {\n  background: transparent;\n  position: relative;\n  z-index: 7;\n}\n.card-tabs-animated .RRT__container > .RRT__tabs.card-header {\n  border-bottom: 0;\n  height: auto;\n  padding: 1.5rem 1.5rem 0.5rem;\n}\n.card-tabs-animated .RRT__inkbar-wrapper {\n  position: absolute;\n  top: 1.5rem;\n  z-index: 5;\n}\n.card-tabs-animated .RRT__tab {\n  padding: 0.5rem 1.2rem;\n}\n.card-tabs-animated .RRT__tab--selected {\n  color: #fff;\n}\n.card-tabs-animated .RRT__inkbar {\n  height: 35px;\n  margin-top: 0;\n  border-radius: 0.25rem;\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.card-tabs-animated-inner .RRT__tabs {\n  padding: 0 5%;\n}\n.card-tabs-animated-inner .RRT__inkbar-wrapper {\n  left: 5%;\n  width: 90%;\n  height: 36px;\n  top: 14px;\n}\n.card-tabs-animated-inner .RRT__inkbar {\n  height: 36px;\n}\n\n.body-tabs {\n  border-bottom: #dee2e6 solid 2px;\n}\n.body-tabs > .RRT__tab {\n  padding: 1rem 1.25rem;\n  font-weight: normal;\n  font-size: 0.88rem;\n}\n.body-tabs.body-tabs-alt > .RRT__tab {\n  padding: 1.3636363636rem 0.5rem;\n  font-weight: normal;\n  font-size: 0.86rem;\n  width: 33%;\n  text-align: center;\n}\n.body-tabs.body-tabs-alt .RRT__inkbar {\n  height: 2px;\n  margin-top: -2px;\n}\n\n.popover .RRT__panel,\n.dropdown-menu .RRT__panel {\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.popover .RRT__panel::after, .popover .RRT__panel::before,\n.dropdown-menu .RRT__panel::after,\n.dropdown-menu .RRT__panel::before {\n  width: 100%;\n  bottom: auto;\n  top: 0;\n  left: 0;\n  height: 20px;\n  position: absolute;\n  z-index: 10;\n  content: \"\";\n  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\n}\n.popover .RRT__panel::after,\n.dropdown-menu .RRT__panel::after {\n  bottom: 0;\n  top: auto;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\n}\n\n.tabs-lg-alternate.card-header {\n  padding: 0;\n  height: auto;\n}\n.tabs-lg-alternate.card-header .widget-number {\n  font-size: 2rem;\n  font-weight: 300;\n}\n.tabs-lg-alternate.card-header .tab-subheading {\n  padding: 5px 0 0;\n  opacity: 0.6;\n  transition: all 0.2s;\n}\n.tabs-lg-alternate.card-header > .nav {\n  margin: 0;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link {\n  padding: 1.5rem 0;\n  border-right: #e9ecef solid 1px;\n  background: #f8f9fa;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link:hover {\n  background: #fff;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link:hover .tab-subheading {\n  color: #000;\n  opacity: 0.9;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link::before {\n  background: #fff;\n  border-radius: 0;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link.active {\n  background: #fff;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link.active .tab-subheading {\n  color: #000;\n  opacity: 0.9;\n}\n.tabs-lg-alternate.card-header > .nav .nav-item:last-child .nav-link {\n  border-right: 0;\n}\n\n.accordion-wrapper {\n  border-radius: 0.25rem;\n  border: #e9ecef solid 1px;\n}\n.accordion-wrapper > .card {\n  box-shadow: 0 0 0 0 transparent;\n}\n.accordion-wrapper > .card > .card-header {\n  padding: 1rem;\n  height: auto;\n}\n.accordion-wrapper > .card > .card-header .btn:active,\n.accordion-wrapper > .card > .card-header .btn:focus,\n.accordion-wrapper > .card > .card-header .btn:hover {\n  text-decoration: none;\n}\n.accordion-wrapper > .card > .card-header .form-heading p {\n  margin: 0;\n}\n.accordion-wrapper > .card .collapse {\n  border-bottom: transparent solid 1px;\n}\n.accordion-wrapper > .card .collapse.show {\n  border-bottom-color: #e9ecef;\n}\n\n.modal-header,\n.modal-footer {\n  background: #f8f9fa;\n}\n\n.modal-footer {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.modal-dialog {\n  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);\n  border-radius: 0.25rem;\n}\n\n/**\n * Dots\n */\n@keyframes scale {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  45% {\n    transform: scale(0.1);\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.ball-pulse > div:nth-child(0) {\n  animation: scale 0.75s -0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div:nth-child(1) {\n  animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div:nth-child(2) {\n  animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div:nth-child(3) {\n  animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n}\n\n@keyframes ball-pulse-sync {\n  33% {\n    transform: translateY(10px);\n  }\n  66% {\n    transform: translateY(-10px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n.ball-pulse-sync > div:nth-child(0) {\n  animation: ball-pulse-sync 0.6s -0.21s infinite ease-in-out;\n}\n.ball-pulse-sync > div:nth-child(1) {\n  animation: ball-pulse-sync 0.6s -0.14s infinite ease-in-out;\n}\n.ball-pulse-sync > div:nth-child(2) {\n  animation: ball-pulse-sync 0.6s -0.07s infinite ease-in-out;\n}\n.ball-pulse-sync > div:nth-child(3) {\n  animation: ball-pulse-sync 0.6s 0s infinite ease-in-out;\n}\n.ball-pulse-sync > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n}\n\n@keyframes ball-scale {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.ball-scale > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  height: 60px;\n  width: 60px;\n  animation: ball-scale 1s 0s ease-in-out infinite;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.ball-rotate {\n  position: relative;\n}\n.ball-rotate > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: relative;\n}\n.ball-rotate > div:first-child {\n  animation: rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86) infinite;\n}\n.ball-rotate > div:before, .ball-rotate > div:after {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  content: \"\";\n  position: absolute;\n  opacity: 0.8;\n}\n.ball-rotate > div:before {\n  top: 0px;\n  left: -28px;\n}\n.ball-rotate > div:after {\n  top: 0px;\n  left: 25px;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n.ball-clip-rotate > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  border: 2px solid #545cd8;\n  border-bottom-color: transparent;\n  height: 25px;\n  width: 25px;\n  background: transparent !important;\n  display: inline-block;\n  animation: rotate 0.75s 0s linear infinite;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n@keyframes scale {\n  30% {\n    transform: scale(0.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.ball-clip-rotate-pulse {\n  position: relative;\n  transform: translateY(-15px);\n}\n.ball-clip-rotate-pulse > div {\n  animation-fill-mode: both;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  border-radius: 100%;\n}\n.ball-clip-rotate-pulse > div:first-child {\n  background: #545cd8;\n  height: 16px;\n  width: 16px;\n  top: 7px;\n  left: -7px;\n  animation: scale 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n}\n.ball-clip-rotate-pulse > div:last-child {\n  position: absolute;\n  border: 2px solid #545cd8;\n  width: 30px;\n  height: 30px;\n  left: -16px;\n  top: -2px;\n  background: transparent;\n  border: 2px solid;\n  border-color: #545cd8 transparent #545cd8 transparent;\n  animation: rotate 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n  animation-duration: 1s;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n.ball-clip-rotate-multiple {\n  position: relative;\n}\n.ball-clip-rotate-multiple > div {\n  animation-fill-mode: both;\n  position: absolute;\n  left: -20px;\n  top: -20px;\n  border: 2px solid #545cd8;\n  border-bottom-color: transparent;\n  border-top-color: transparent;\n  border-radius: 100%;\n  height: 35px;\n  width: 35px;\n  animation: rotate 1s 0s ease-in-out infinite;\n}\n.ball-clip-rotate-multiple > div:last-child {\n  display: inline-block;\n  top: -10px;\n  left: -10px;\n  width: 15px;\n  height: 15px;\n  animation-duration: 0.5s;\n  border-color: #545cd8 transparent #545cd8 transparent;\n  animation-direction: reverse;\n}\n\n@keyframes ball-scale-ripple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.ball-scale-ripple > div {\n  animation-fill-mode: both;\n  height: 50px;\n  width: 50px;\n  border-radius: 100%;\n  border: 2px solid #545cd8;\n  animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n}\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.ball-scale-ripple-multiple > div:nth-child(0) {\n  animation-delay: -0.8s;\n}\n.ball-scale-ripple-multiple > div:nth-child(1) {\n  animation-delay: -0.6s;\n}\n.ball-scale-ripple-multiple > div:nth-child(2) {\n  animation-delay: -0.4s;\n}\n.ball-scale-ripple-multiple > div:nth-child(3) {\n  animation-delay: -0.2s;\n}\n.ball-scale-ripple-multiple {\n  position: relative;\n  transform: translateY(-25px);\n}\n.ball-scale-ripple-multiple > div {\n  animation-fill-mode: both;\n  position: absolute;\n  top: -2px;\n  left: -26px;\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 2px solid #545cd8;\n  animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n}\n\n@keyframes ball-beat {\n  50% {\n    opacity: 0.2;\n    transform: scale(0.75);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.ball-beat > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation: ball-beat 0.7s 0s infinite linear;\n}\n.ball-beat > div:nth-child(2n-1) {\n  animation-delay: -0.35s !important;\n}\n\n@keyframes ball-scale-multiple {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  5% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.ball-scale-multiple > div:nth-child(2) {\n  animation-delay: -0.4s;\n}\n.ball-scale-multiple > div:nth-child(3) {\n  animation-delay: -0.2s;\n}\n.ball-scale-multiple {\n  position: relative;\n  transform: translateY(-30px);\n}\n.ball-scale-multiple > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  left: -30px;\n  top: 0px;\n  opacity: 0;\n  margin: 0;\n  width: 60px;\n  height: 60px;\n  animation: ball-scale-multiple 1s 0s linear infinite;\n}\n\n@keyframes ball-triangle-path-1 {\n  33% {\n    transform: translate(25px, -50px);\n  }\n  66% {\n    transform: translate(50px, 0px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n@keyframes ball-triangle-path-2 {\n  33% {\n    transform: translate(25px, 50px);\n  }\n  66% {\n    transform: translate(-25px, 50px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n@keyframes ball-triangle-path-3 {\n  33% {\n    transform: translate(-50px, 0px);\n  }\n  66% {\n    transform: translate(-25px, -50px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n.ball-triangle-path {\n  position: relative;\n}\n.ball-triangle-path > div:nth-child(1) {\n  animation-name: ball-triangle-path-1;\n  animation-delay: 0;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n.ball-triangle-path > div:nth-child(2) {\n  animation-name: ball-triangle-path-2;\n  animation-delay: 0;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n.ball-triangle-path > div:nth-child(3) {\n  animation-name: ball-triangle-path-3;\n  animation-delay: 0;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n.ball-triangle-path {\n  transform: translate(-29.9940011998px, -37.5093773443px);\n}\n.ball-triangle-path > div {\n  animation-fill-mode: both;\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-radius: 100%;\n  border: 1px solid #545cd8;\n}\n.ball-triangle-path > div:nth-of-type(1) {\n  top: 50px;\n}\n.ball-triangle-path > div:nth-of-type(2) {\n  left: 25px;\n}\n.ball-triangle-path > div:nth-of-type(3) {\n  top: 50px;\n  left: 50px;\n}\n\n@keyframes ball-pulse-rise-even {\n  0% {\n    transform: scale(1.1);\n  }\n  25% {\n    transform: translateY(-30px);\n  }\n  50% {\n    transform: scale(0.4);\n  }\n  75% {\n    transform: translateY(30px);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(1);\n  }\n}\n@keyframes ball-pulse-rise-odd {\n  0% {\n    transform: scale(0.4);\n  }\n  25% {\n    transform: translateY(30px);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  75% {\n    transform: translateY(-30px);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(0.75);\n  }\n}\n.ball-pulse-rise > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation-duration: 1s;\n  animation-timing-function: cubic-bezier(0.15, 0.46, 0.9, 0.6);\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n.ball-pulse-rise > div:nth-child(2n) {\n  animation-name: ball-pulse-rise-even;\n}\n.ball-pulse-rise > div:nth-child(2n-1) {\n  animation-name: ball-pulse-rise-odd;\n}\n\n@keyframes ball-grid-beat {\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ball-grid-beat > div:nth-child(1) {\n  animation-delay: 0.33s;\n  animation-duration: 0.96s;\n}\n.ball-grid-beat > div:nth-child(2) {\n  animation-delay: 0.47s;\n  animation-duration: 1.26s;\n}\n.ball-grid-beat > div:nth-child(3) {\n  animation-delay: 0.8s;\n  animation-duration: 1.02s;\n}\n.ball-grid-beat > div:nth-child(4) {\n  animation-delay: 0.35s;\n  animation-duration: 1.46s;\n}\n.ball-grid-beat > div:nth-child(5) {\n  animation-delay: -0.01s;\n  animation-duration: 1.02s;\n}\n.ball-grid-beat > div:nth-child(6) {\n  animation-delay: 0.23s;\n  animation-duration: 1.19s;\n}\n.ball-grid-beat > div:nth-child(7) {\n  animation-delay: 0.75s;\n  animation-duration: 1.52s;\n}\n.ball-grid-beat > div:nth-child(8) {\n  animation-delay: 0.72s;\n  animation-duration: 1.45s;\n}\n.ball-grid-beat > div:nth-child(9) {\n  animation-delay: 0.49s;\n  animation-duration: 1.45s;\n}\n.ball-grid-beat {\n  width: 57px;\n}\n.ball-grid-beat > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  float: left;\n  animation-name: ball-grid-beat;\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n\n@keyframes ball-grid-pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.ball-grid-pulse > div:nth-child(1) {\n  animation-delay: -0.16s;\n  animation-duration: 0.63s;\n}\n.ball-grid-pulse > div:nth-child(2) {\n  animation-delay: 0.54s;\n  animation-duration: 1.3s;\n}\n.ball-grid-pulse > div:nth-child(3) {\n  animation-delay: 0.28s;\n  animation-duration: 1.05s;\n}\n.ball-grid-pulse > div:nth-child(4) {\n  animation-delay: -0.05s;\n  animation-duration: 1.19s;\n}\n.ball-grid-pulse > div:nth-child(5) {\n  animation-delay: 0.41s;\n  animation-duration: 0.9s;\n}\n.ball-grid-pulse > div:nth-child(6) {\n  animation-delay: 0.46s;\n  animation-duration: 1.04s;\n}\n.ball-grid-pulse > div:nth-child(7) {\n  animation-delay: 0.13s;\n  animation-duration: 0.88s;\n}\n.ball-grid-pulse > div:nth-child(8) {\n  animation-delay: -0.12s;\n  animation-duration: 1.21s;\n}\n.ball-grid-pulse > div:nth-child(9) {\n  animation-delay: 0.17s;\n  animation-duration: 1.21s;\n}\n.ball-grid-pulse {\n  width: 57px;\n}\n.ball-grid-pulse > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  float: left;\n  animation-name: ball-grid-pulse;\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n\n@keyframes ball-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n    transform: scale(0.4);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.ball-spin-fade-loader > div:nth-child(1) {\n  top: 25px;\n  left: 0;\n  animation: ball-spin-fade-loader 1s -0.96s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(2) {\n  top: 17.0454545455px;\n  left: 17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.84s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(3) {\n  top: 0;\n  left: 25px;\n  animation: ball-spin-fade-loader 1s -0.72s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(4) {\n  top: -17.0454545455px;\n  left: 17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.6s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(5) {\n  top: -25px;\n  left: 0;\n  animation: ball-spin-fade-loader 1s -0.48s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(6) {\n  top: -17.0454545455px;\n  left: -17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.36s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(7) {\n  top: 0;\n  left: -25px;\n  animation: ball-spin-fade-loader 1s -0.24s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(8) {\n  top: 17.0454545455px;\n  left: -17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.12s infinite linear;\n}\n.ball-spin-fade-loader {\n  position: relative;\n  top: -10px;\n  left: -10px;\n}\n.ball-spin-fade-loader > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n}\n\n@keyframes ball-spin-loader {\n  75% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ball-spin-loader > span:nth-child(1) {\n  top: 45px;\n  left: 0;\n  animation: ball-spin-loader 2s 0.9s infinite linear;\n}\n.ball-spin-loader > span:nth-child(2) {\n  top: 30.6818181818px;\n  left: 30.6818181818px;\n  animation: ball-spin-loader 2s 1.8s infinite linear;\n}\n.ball-spin-loader > span:nth-child(3) {\n  top: 0;\n  left: 45px;\n  animation: ball-spin-loader 2s 2.7s infinite linear;\n}\n.ball-spin-loader > span:nth-child(4) {\n  top: -30.6818181818px;\n  left: 30.6818181818px;\n  animation: ball-spin-loader 2s 3.6s infinite linear;\n}\n.ball-spin-loader > span:nth-child(5) {\n  top: -45px;\n  left: 0;\n  animation: ball-spin-loader 2s 4.5s infinite linear;\n}\n.ball-spin-loader > span:nth-child(6) {\n  top: -30.6818181818px;\n  left: -30.6818181818px;\n  animation: ball-spin-loader 2s 5.4s infinite linear;\n}\n.ball-spin-loader > span:nth-child(7) {\n  top: 0;\n  left: -45px;\n  animation: ball-spin-loader 2s 6.3s infinite linear;\n}\n.ball-spin-loader > span:nth-child(8) {\n  top: 30.6818181818px;\n  left: -30.6818181818px;\n  animation: ball-spin-loader 2s 7.2s infinite linear;\n}\n.ball-spin-loader {\n  position: relative;\n}\n.ball-spin-loader > div {\n  animation-fill-mode: both;\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  background: green;\n}\n\n@keyframes ball-zig {\n  33% {\n    transform: translate(-15px, -30px);\n  }\n  66% {\n    transform: translate(15px, -30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n@keyframes ball-zag {\n  33% {\n    transform: translate(15px, 30px);\n  }\n  66% {\n    transform: translate(-15px, 30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n.ball-zig-zag {\n  position: relative;\n  transform: translate(-15px, -15px);\n}\n.ball-zig-zag > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  margin-left: 15px;\n  top: 4px;\n  left: -7px;\n}\n.ball-zig-zag > div:first-child {\n  animation: ball-zig 0.7s 0s infinite linear;\n}\n.ball-zig-zag > div:last-child {\n  animation: ball-zag 0.7s 0s infinite linear;\n}\n\n@keyframes ball-zig-deflect {\n  17% {\n    transform: translate(-15px, -30px);\n  }\n  34% {\n    transform: translate(15px, -30px);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(15px, -30px);\n  }\n  84% {\n    transform: translate(-15px, -30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n@keyframes ball-zag-deflect {\n  17% {\n    transform: translate(15px, 30px);\n  }\n  34% {\n    transform: translate(-15px, 30px);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(-15px, 30px);\n  }\n  84% {\n    transform: translate(15px, 30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n.ball-zig-zag-deflect {\n  position: relative;\n  transform: translate(-15px, -15px);\n}\n.ball-zig-zag-deflect > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  margin-left: 15px;\n  top: 4px;\n  left: -7px;\n}\n.ball-zig-zag-deflect > div:first-child {\n  animation: ball-zig-deflect 1.5s 0s infinite linear;\n}\n.ball-zig-zag-deflect > div:last-child {\n  animation: ball-zag-deflect 1.5s 0s infinite linear;\n}\n\n/**\n * Lines\n */\n@keyframes line-scale {\n  0% {\n    transform: scaley(1);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1);\n  }\n}\n.line-scale > div:nth-child(1) {\n  animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(2) {\n  animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(3) {\n  animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(4) {\n  animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(5) {\n  animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n}\n\n@keyframes line-scale-party {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.line-scale-party > div:nth-child(1) {\n  animation-delay: 0.1s;\n  animation-duration: 0.34s;\n}\n.line-scale-party > div:nth-child(2) {\n  animation-delay: 0.19s;\n  animation-duration: 1.25s;\n}\n.line-scale-party > div:nth-child(3) {\n  animation-delay: -0.08s;\n  animation-duration: 1s;\n}\n.line-scale-party > div:nth-child(4) {\n  animation-delay: 0.04s;\n  animation-duration: 0.41s;\n}\n.line-scale-party > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation-name: line-scale-party;\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n\n@keyframes line-scale-pulse-out {\n  0% {\n    transform: scaley(1);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1);\n  }\n}\n.line-scale-pulse-out > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation: line-scale-pulse-out 0.9s -0.6s infinite cubic-bezier(0.85, 0.25, 0.37, 0.85);\n}\n.line-scale-pulse-out > div:nth-child(2), .line-scale-pulse-out > div:nth-child(4) {\n  animation-delay: -0.4s !important;\n}\n.line-scale-pulse-out > div:nth-child(1), .line-scale-pulse-out > div:nth-child(5) {\n  animation-delay: -0.2s !important;\n}\n\n@keyframes line-scale-pulse-out-rapid {\n  0% {\n    transform: scaley(1);\n  }\n  80% {\n    transform: scaley(0.3);\n  }\n  90% {\n    transform: scaley(1);\n  }\n}\n.line-scale-pulse-out-rapid > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  vertical-align: middle;\n  animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78);\n}\n.line-scale-pulse-out-rapid > div:nth-child(2), .line-scale-pulse-out-rapid > div:nth-child(4) {\n  animation-delay: -0.25s !important;\n}\n.line-scale-pulse-out-rapid > div:nth-child(1), .line-scale-pulse-out-rapid > div:nth-child(5) {\n  animation-delay: 0s !important;\n}\n\n@keyframes line-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.line-spin-fade-loader > div:nth-child(1) {\n  top: 20px;\n  left: 0;\n  animation: line-spin-fade-loader 1.2s -0.84s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(2) {\n  top: 13.6363636364px;\n  left: 13.6363636364px;\n  transform: rotate(-45deg);\n  animation: line-spin-fade-loader 1.2s -0.72s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(3) {\n  top: 0;\n  left: 20px;\n  transform: rotate(90deg);\n  animation: line-spin-fade-loader 1.2s -0.6s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(4) {\n  top: -13.6363636364px;\n  left: 13.6363636364px;\n  transform: rotate(45deg);\n  animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(5) {\n  top: -20px;\n  left: 0;\n  animation: line-spin-fade-loader 1.2s -0.36s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(6) {\n  top: -13.6363636364px;\n  left: -13.6363636364px;\n  transform: rotate(-45deg);\n  animation: line-spin-fade-loader 1.2s -0.24s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(7) {\n  top: 0;\n  left: -20px;\n  transform: rotate(90deg);\n  animation: line-spin-fade-loader 1.2s -0.12s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(8) {\n  top: 13.6363636364px;\n  left: -13.6363636364px;\n  transform: rotate(45deg);\n  animation: line-spin-fade-loader 1.2s 0s infinite ease-in-out;\n}\n.line-spin-fade-loader {\n  position: relative;\n  top: -10px;\n  left: -4px;\n}\n.line-spin-fade-loader > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  width: 5px;\n  height: 15px;\n}\n\n/**\n * Misc\n */\n@keyframes triangle-skew-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n.triangle-skew-spin > div {\n  animation-fill-mode: both;\n  width: 0;\n  height: 0;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n  border-bottom: 20px solid #545cd8;\n  animation: triangle-skew-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n}\n\n@keyframes square-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n.square-spin > div {\n  animation-fill-mode: both;\n  width: 50px;\n  height: 50px;\n  background: #545cd8;\n  animation: square-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n}\n\n@keyframes rotate_pacman_half_up {\n  0% {\n    transform: rotate(270deg);\n  }\n  50% {\n    transform: rotate(360deg);\n  }\n  100% {\n    transform: rotate(270deg);\n  }\n}\n@keyframes rotate_pacman_half_down {\n  0% {\n    transform: rotate(90deg);\n  }\n  50% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(90deg);\n  }\n}\n@keyframes pacman-balls {\n  75% {\n    opacity: 0.7;\n  }\n  100% {\n    transform: translate(-100px, -6.25px);\n  }\n}\n.pacman > div:nth-child(2) {\n  animation: pacman-balls 1s -0.99s infinite linear;\n}\n.pacman > div:nth-child(3) {\n  animation: pacman-balls 1s -0.66s infinite linear;\n}\n.pacman > div:nth-child(4) {\n  animation: pacman-balls 1s -0.33s infinite linear;\n}\n.pacman > div:nth-child(5) {\n  animation: pacman-balls 1s 0s infinite linear;\n}\n.pacman {\n  position: relative;\n}\n.pacman > div:first-of-type {\n  width: 0px;\n  height: 0px;\n  border-right: 25px solid transparent;\n  border-top: 25px solid #545cd8;\n  border-left: 25px solid #545cd8;\n  border-bottom: 25px solid #545cd8;\n  border-radius: 25px;\n  animation: rotate_pacman_half_up 0.5s 0s infinite;\n  position: relative;\n  left: -30px;\n}\n.pacman > div:nth-child(2) {\n  width: 0px;\n  height: 0px;\n  border-right: 25px solid transparent;\n  border-top: 25px solid #545cd8;\n  border-left: 25px solid #545cd8;\n  border-bottom: 25px solid #545cd8;\n  border-radius: 25px;\n  animation: rotate_pacman_half_down 0.5s 0s infinite;\n  margin-top: -50px;\n  position: relative;\n  left: -30px;\n}\n.pacman > div:nth-child(3),\n.pacman > div:nth-child(4),\n.pacman > div:nth-child(5),\n.pacman > div:nth-child(6) {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  transform: translate(0, -6.25px);\n  top: 25px;\n  left: 70px;\n}\n\n@keyframes cube-transition {\n  25% {\n    transform: translateX(50px) scale(0.5) rotate(-90deg);\n  }\n  50% {\n    transform: translate(50px, 50px) rotate(-180deg);\n  }\n  75% {\n    transform: translateY(50px) scale(0.5) rotate(-270deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n.cube-transition {\n  position: relative;\n  transform: translate(-25px, -25px);\n}\n.cube-transition > div {\n  animation-fill-mode: both;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  top: -5px;\n  left: -5px;\n  background-color: #545cd8;\n  animation: cube-transition 1.6s 0s infinite ease-in-out;\n}\n.cube-transition > div:last-child {\n  animation-delay: -0.8s;\n}\n\n@keyframes spin-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.semi-circle-spin {\n  position: relative;\n  width: 35px;\n  height: 35px;\n  overflow: hidden;\n}\n.semi-circle-spin > div {\n  position: absolute;\n  border-width: 0px;\n  border-radius: 100%;\n  animation: spin-rotate 0.6s 0s infinite linear;\n  background-image: linear-gradient(transparent 0%, transparent 70%, #545cd8 30%, #545cd8 100%);\n  width: 100%;\n  height: 100%;\n}\n\n.progress .progress-bar:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.progress.progress-bar-sm {\n  height: 0.5rem;\n}\n.progress.progress-bar-xs {\n  height: 0.3rem;\n}\n.progress.progress-bar-rounded {\n  border-radius: 30px;\n}\n\n.progress-bar-animated-alt.progress-bar,\n.progress-bar-animated-alt .progress-bar {\n  position: relative;\n}\n.progress-bar-animated-alt.progress-bar::after,\n.progress-bar-animated-alt .progress-bar::after {\n  content: \"\";\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  animation: progress-active 2s ease infinite;\n}\n\n@keyframes progress-active {\n  0% {\n    opacity: 0.4;\n    width: 0;\n  }\n  100% {\n    opacity: 0;\n    width: 100%;\n  }\n}\n.vertical-timeline {\n  width: 100%;\n  position: relative;\n  padding: 1.5rem 0 1rem;\n}\n.vertical-timeline::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.vertical-timeline::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 67px;\n  height: 100%;\n  width: 4px;\n  background: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.vertical-timeline-element {\n  position: relative;\n  margin: 0 0 1rem;\n}\n.vertical-timeline-element:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.vertical-timeline-element:last-child {\n  margin-bottom: 0;\n}\n\n.vertical-timeline-element-content {\n  position: relative;\n  margin-left: 90px;\n  font-size: 0.8rem;\n}\n.vertical-timeline-element-content:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.vertical-timeline-element-content .timeline-title {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  margin: 0 0 0.5rem;\n  padding: 2px 0 0;\n  font-weight: bold;\n}\n.vertical-timeline-element-content p {\n  color: #6c757d;\n  margin: 0 0 0.5rem;\n}\n.vertical-timeline-element-content .vertical-timeline-element-date {\n  display: block;\n  position: absolute;\n  left: -90px;\n  top: 0;\n  padding-right: 10px;\n  text-align: right;\n  color: #adb5bd;\n  font-size: 0.7619047619rem;\n  white-space: nowrap;\n}\n\n.vertical-timeline-element-icon {\n  position: absolute;\n  top: 0;\n  left: 60px;\n}\n.vertical-timeline-element-icon .badge-dot-xl {\n  box-shadow: 0 0 0 5px #fff;\n}\n\n.vertical-timeline-element--no-children .vertical-timeline-element-content {\n  background: 0 0;\n  box-shadow: none;\n}\n.vertical-timeline-element--no-children .vertical-timeline-element-content::before {\n  display: none;\n}\n\n.vertical-without-time::before {\n  left: 11px;\n}\n.vertical-without-time .vertical-timeline-element-content {\n  margin-left: 36px;\n}\n.vertical-without-time .vertical-timeline-element-icon {\n  left: 4px;\n}\n\n.vertical-time-icons {\n  padding: 2rem 0 0;\n}\n.vertical-time-icons::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 14px;\n  height: 100%;\n  width: 6px;\n  background: #e9ecef;\n  border-radius: 0.25rem;\n}\n.vertical-time-icons .vertical-timeline-element {\n  margin-bottom: 1rem;\n}\n.vertical-time-icons .vertical-timeline-element-content {\n  margin-left: 50px;\n}\n.vertical-time-icons .vertical-timeline-element-icon {\n  width: 34px;\n  height: 34px;\n  left: 0;\n  top: -7px;\n}\n.vertical-time-icons .vertical-timeline-element-icon .timeline-icon {\n  width: 34px;\n  height: 34px;\n  background: #fff;\n  border-radius: 50px;\n  border-width: 2px;\n  border-style: solid;\n  box-shadow: 0 0 0 5px #fff;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.vertical-time-icons .vertical-timeline-element-icon .timeline-icon i {\n  display: block;\n  font-size: 1.1rem;\n  margin: 0 auto;\n}\n.vertical-time-icons .vertical-timeline-element-icon .timeline-icon svg {\n  margin: 0 auto;\n}\n\n.vertical-time-simple {\n  padding: 0.5rem 0;\n}\n.vertical-time-simple .vertical-timeline-element {\n  margin: 0 0 0.5rem;\n}\n.vertical-time-simple .timeline-title {\n  font-weight: normal;\n  font-size: 0.9166666667rem;\n  padding: 0;\n}\n.vertical-time-simple .vertical-timeline-element-icon {\n  height: 14px;\n  width: 14px;\n  background: #e9ecef;\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  display: block;\n  border-radius: 20px;\n}\n.vertical-time-simple .vertical-timeline-element-icon::after {\n  content: \"\";\n  position: absolute;\n  background: #fff;\n  left: 50%;\n  top: 50%;\n  margin: -4px 0 0 -4px;\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 20px;\n}\n.vertical-time-simple .timeline-title {\n  text-transform: none;\n}\n\n.dot-primary .vertical-timeline-element-icon {\n  background: #545cd8;\n}\n\n.dot-secondary .vertical-timeline-element-icon {\n  background: #6c757d;\n}\n\n.dot-success .vertical-timeline-element-icon {\n  background: #3ac47d;\n}\n\n.dot-info .vertical-timeline-element-icon {\n  background: #30b1ff;\n}\n\n.dot-warning .vertical-timeline-element-icon {\n  background: #f7b924;\n}\n\n.dot-danger .vertical-timeline-element-icon {\n  background: #d92550;\n}\n\n.dot-light .vertical-timeline-element-icon {\n  background: #eeeeee;\n}\n\n.dot-dark .vertical-timeline-element-icon {\n  background: #343a40;\n}\n\n.dot-focus .vertical-timeline-element-icon {\n  background: #444054;\n}\n\n.dot-alternate .vertical-timeline-element-icon {\n  background: #83588a;\n}\n\n.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {\n  visibility: hidden;\n}\n\n.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {\n  visibility: visible;\n  animation: cd-bounce-1 0.8s;\n}\n\n@-webkit-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2);\n  }\n  100% {\n    -webkit-transform: scale(1);\n  }\n}\n@-moz-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -moz-transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    -moz-transform: scale(1.2);\n  }\n  100% {\n    -moz-transform: scale(1);\n  }\n}\n@keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n    -moz-transform: scale(0.5);\n    -ms-transform: scale(0.5);\n    -o-transform: scale(0.5);\n    transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2);\n    -moz-transform: scale(1.2);\n    -ms-transform: scale(1.2);\n    -o-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {\n  visibility: hidden;\n}\n\n.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n  visibility: visible;\n  -webkit-animation: cd-bounce-2 0.6s;\n  -moz-animation: cd-bounce-2 0.6s;\n  animation: cd-bounce-2 0.6s;\n}\n\n@media only screen and (min-width: 1170px) {\n  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {\n    -webkit-animation: cd-bounce-2-inverse 0.6s;\n    -moz-animation: cd-bounce-2-inverse 0.6s;\n    animation: cd-bounce-2-inverse 0.6s;\n  }\n}\n@media only screen and (max-width: 1169px) {\n  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n    visibility: visible;\n    -webkit-animation: cd-bounce-2-inverse 0.6s;\n    -moz-animation: cd-bounce-2-inverse 0.6s;\n    animation: cd-bounce-2-inverse 0.6s;\n  }\n}\n@-webkit-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n  }\n}\n@-moz-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(20px);\n  }\n  100% {\n    -moz-transform: translateX(0);\n  }\n}\n@keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n    -moz-transform: translateX(-100px);\n    -ms-transform: translateX(-100px);\n    -o-transform: translateX(-100px);\n    transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n    -moz-transform: translateX(20px);\n    -ms-transform: translateX(20px);\n    -o-transform: translateX(20px);\n    transform: translateX(20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n@-webkit-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n  }\n}\n@-moz-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(-20px);\n  }\n  100% {\n    -moz-transform: translateX(0);\n  }\n}\n@keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n    -moz-transform: translateX(100px);\n    -ms-transform: translateX(100px);\n    -o-transform: translateX(100px);\n    transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n    -moz-transform: translateX(-20px);\n    -ms-transform: translateX(-20px);\n    -o-transform: translateX(-20px);\n    transform: translateX(-20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n.todo-list-wrapper .todo-indicator {\n  position: absolute;\n  width: 4px;\n  height: 60%;\n  border-radius: 0.3rem;\n  left: 0.625rem;\n  top: 20%;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n.todo-list-wrapper .list-group-item:hover .todo-indicator {\n  opacity: 0.9;\n}\n.todo-list-wrapper .custom-control,\n.todo-list-wrapper input[checkbox] {\n  margin-left: 0.625rem;\n}\n\n.list-group-flush + .card-footer {\n  border-top: 0;\n}\n\n.rm-list-borders .list-group-item {\n  border: 0;\n  padding: 0.5rem 0;\n}\n\n.rm-list-borders-scroll .list-group-item {\n  border: 0;\n  padding-right: 1.125rem;\n}\n\n.input-group .input-group-prepend div:not([class]) .react-datepicker__input-container .form-control, .input-group .input-group-prepend + div .react-datepicker__input-container .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n.input-group > div:not([class]) {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n}\n.input-group > div:not([class]) .react-datepicker__input-container .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group .input-group-prepend + div {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n}\n.input-group > .react-datepicker-wrapper {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n}\n.input-group > .react-datepicker-wrapper > .react-datepicker__input-container > .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\nlegend {\n  font-size: 0.88rem;\n  font-weight: bold;\n}\n\n.form-heading {\n  font-size: 1.1rem;\n  margin: 0;\n  color: #545cd8;\n}\n.form-heading p {\n  color: #6c757d;\n  padding: 0.3rem 0 0;\n  font-size: 0.88rem;\n}\n\n.custom-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.pagination li a {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #007bff;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n.pagination li a:hover {\n  z-index: 2;\n  color: rgb(0%, 33.7647058824%, 70%);\n  text-decoration: none;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n.pagination li a:focus {\n  z-index: 2;\n  outline: 0;\n  box-shadow: none;\n}\n.pagination li a:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n.pagination li:first-child a {\n  margin-left: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.pagination li:last-child a {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.pagination li.active a {\n  z-index: 1;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #007bff;\n}\n.pagination li.active a:hover {\n  color: #fff;\n}\n.pagination li.disabled a {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-rounded li a {\n  border-radius: 50px !important;\n  margin: 0 0.3rem;\n}\n\n.chat-box-wrapper {\n  display: flex;\n  clear: both;\n  padding: 0.75rem;\n}\n.chat-box-wrapper + .chat-box-wrapper {\n  padding-top: 0;\n}\n.chat-box-wrapper .chat-box {\n  box-shadow: 0 0 0 transparent;\n  position: relative;\n  opacity: 1;\n  background: #e0f3ff;\n  border: 0;\n  padding: 0.75rem 1.5rem;\n  border-radius: 30px;\n  border-top-left-radius: 0.25rem;\n  flex: 1;\n  display: flex;\n  max-width: 50%;\n  min-width: 100%;\n  text-align: left;\n}\n.chat-box-wrapper .chat-box + small {\n  text-align: left;\n  padding: 0.5rem 0 0;\n  margin-left: 1.5rem;\n  display: block;\n}\n.chat-box-wrapper.chat-box-wrapper-right {\n  text-align: right;\n}\n.chat-box-wrapper.chat-box-wrapper-right .chat-box {\n  border-radius: 30px;\n  border-top-left-radius: 30px;\n  border-top-right-radius: 0.25rem;\n  margin-left: auto;\n}\n.chat-box-wrapper.chat-box-wrapper-right .chat-box + small {\n  text-align: right;\n  margin-right: 1.5rem;\n  margin-left: 0;\n}\n\n.forms-wizard {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  width: 100%;\n  display: table;\n  table-layout: fixed;\n  border-radius: 0.25rem;\n}\n.forms-wizard li {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  font-size: 1rem;\n  padding: 1rem 0;\n  color: #adb5bd;\n  position: relative;\n}\n.forms-wizard li::after, .forms-wizard li::before {\n  position: absolute;\n  height: 4px;\n  top: 50%;\n  margin-top: -1rem;\n  width: 50%;\n  content: \"\";\n  background: #dee2e6;\n  z-index: 5;\n  transition: all 0.2s;\n}\n.forms-wizard li::after {\n  left: 50%;\n}\n.forms-wizard li::before {\n  left: 0;\n}\n.forms-wizard li:first-child::before {\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n.forms-wizard li:last-child::after {\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n.forms-wizard li em {\n  font-style: normal;\n  font-size: 1.5rem;\n  background: #ced4da;\n  color: #fff;\n  text-align: center;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  border-radius: 50px;\n  display: block;\n  margin: 0 auto 0.5rem;\n  position: relative;\n  z-index: 7;\n  transition: all 0.2s;\n}\n.forms-wizard li.form-wizard-step-doing {\n  color: #495057;\n}\n.forms-wizard li.form-wizard-step-doing em {\n  background: #545cd8;\n}\n.forms-wizard li.form-wizard-step-doing::before {\n  background: #545cd8;\n}\n.forms-wizard li.form-wizard-step-done em {\n  font-family: \"Linearicons-Free\";\n  background: #3ac47d;\n  overflow: hidden;\n}\n.forms-wizard li.form-wizard-step-done em::before {\n  width: 42px;\n  height: 42px;\n  font-size: 1.2rem;\n  line-height: 40px;\n  text-align: center;\n  display: block;\n}\n.forms-wizard li.form-wizard-step-done::after, .forms-wizard li.form-wizard-step-done::before {\n  background: #3ac47d;\n}\n.forms-wizard li:hover {\n  color: #6c757d;\n}\n\n.forms-wizard-alt .forms-wizard li {\n  font-size: 0.88rem;\n}\n.forms-wizard-alt .forms-wizard li em {\n  width: 14px;\n  height: 14px;\n  line-height: 14px;\n  text-indent: -999rem;\n  border: #fff solid 2px;\n  margin: -7px auto 0;\n}\n\n.forms-wizard-vertical .forms-wizard {\n  display: block;\n  width: 30%;\n  float: left;\n  padding: 0 1.5rem 1.5rem 0;\n}\n.forms-wizard-vertical .forms-wizard li {\n  text-align: left;\n  display: flex;\n  align-items: center;\n  align-content: flex-start;\n  padding: 0.75rem;\n  margin-bottom: 0.5rem;\n  border-radius: 0.3rem;\n  transition: all 0.2s;\n}\n.forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {\n  display: none;\n}\n.forms-wizard-vertical .forms-wizard li em {\n  margin: 0 0.75rem 0 0;\n}\n.forms-wizard-vertical .forms-wizard li:hover {\n  background: #e9ecef;\n}\n.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {\n  background: #545cd8;\n  color: #fff;\n}\n.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {\n  background: rgba(255, 255, 255, 0.2);\n}\n.forms-wizard-vertical .form-wizard-content {\n  width: 70%;\n  overflow: auto;\n}\n\n@media screen and (min-width: 360px) and (max-width: 812px) {\n  .forms-wizard-vertical .forms-wizard {\n    display: block;\n    width: 50%;\n    float: left;\n    padding: 0 1.5rem 1.5rem 0;\n  }\n  .forms-wizard-vertical .forms-wizard li {\n    text-align: left;\n    display: flex;\n    align-items: center;\n    align-content: flex-start;\n    padding: 0.75rem;\n    margin-bottom: 0.5rem;\n    border-radius: 0.3rem;\n    transition: all 0.2s;\n  }\n  .forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {\n    display: none;\n  }\n  .forms-wizard-vertical .forms-wizard li em {\n    margin: 0 0.75rem 0 0;\n  }\n  .forms-wizard-vertical .forms-wizard li:hover {\n    background: #e9ecef;\n  }\n  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {\n    background: #545cd8;\n    color: #fff;\n  }\n  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {\n    background: rgba(255, 255, 255, 0.2);\n  }\n  .forms-wizard-vertical .form-wizard-content {\n    width: 50%;\n    overflow: auto;\n  }\n}\n.icon-wrapper {\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n\n.widget-chart {\n  text-align: center;\n  padding: 1rem;\n  position: relative;\n}\n.widget-chart .progress-sub-label {\n  opacity: 0.8;\n  padding: 5px 0 0;\n}\n.widget-chart .progress-circle-wrapper {\n  min-width: 68px;\n  margin-right: 1rem;\n}\n.widget-chart .progress-circle-wrapper .react-sweet-progress-symbol {\n  font-size: 0.8rem;\n}\n.widget-chart .widget-chart-content {\n  position: relative;\n  z-index: 5;\n}\n.widget-chart .widget-chart-content-lg {\n  padding: 2rem 0 1rem 2rem;\n}\n.widget-chart .widget-chart-content-lg .widget-numbers {\n  margin-bottom: 0;\n}\n.widget-chart .widget-chart-wrapper {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  opacity: 0.25;\n  z-index: 6;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  overflow: hidden;\n}\n.widget-chart .widget-numbers {\n  font-weight: bold;\n  font-size: 2.5rem;\n  display: block;\n  line-height: 1;\n  margin: 1rem auto;\n}\n.widget-chart .widget-numbers + .widget-chart-flex, .widget-chart .widget-numbers + .widget-description, .widget-chart .widget-numbers + .widget-subheading {\n  margin-top: -0.5rem;\n}\n.widget-chart .widget-subheading {\n  margin: -0.5rem 0 0;\n  display: block;\n  opacity: 0.6;\n}\n.widget-chart .widget-subheading:first-child {\n  margin-top: 0;\n}\n.widget-chart .widget-subheading + .widget-numbers {\n  margin-top: 0.5rem;\n}\n.widget-chart .widget-description {\n  margin: 1rem 0 0;\n}\n.widget-chart.widget-chart-hover {\n  transition: all 0.2s;\n}\n.widget-chart.widget-chart-hover:hover {\n  z-index: 15;\n  transform: scale(1.15);\n  box-shadow: 0 0.46875rem 4.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.9375rem 2.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.25rem 1.3125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.06), 0 0.125rem 1.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.06);\n  cursor: pointer;\n  background: #fff;\n}\n.widget-chart .widget-chart-actions {\n  position: absolute;\n  right: 0.5rem;\n  top: 0.5rem;\n  z-index: 12;\n}\n.widget-chart .widget-chart-actions .btn-link {\n  font-size: 1.1rem;\n  padding-top: 0;\n  padding-bottom: 0;\n  opacity: 0.6;\n}\n.widget-chart .widget-progress-wrapper {\n  margin-top: 1rem;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {\n  margin: 0 -1px -1px;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress .progress-bar {\n  border-bottom-left-radius: 0.25rem;\n}\n.widget-chart .widget-chart-flex {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  margin-bottom: 1rem;\n}\n.widget-chart .widget-chart-flex:last-child {\n  margin-bottom: 0;\n}\n.widget-chart .widget-chart-flex .widget-subheading {\n  margin: 0;\n}\n.widget-chart .widget-chart-flex .widget-description {\n  margin-top: 0;\n}\n.widget-chart.text-left {\n  flex-direction: row;\n  align-items: center;\n}\n.widget-chart.text-left .icon-wrapper {\n  min-width: 54px;\n  margin: 0 1rem 0 0;\n}\n.widget-chart.text-left .widget-numbers {\n  margin-left: 0;\n}\n.widget-chart.text-left .widget-chart-content {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  flex: 1;\n  position: relative;\n}\n.widget-chart.text-left .widget-chart-content > .widget-numbers:first-child {\n  margin-top: 0;\n}\n.widget-chart.text-left .widget-chart-content .widget-description {\n  align-self: flex-start;\n}\n.widget-chart.text-left .widget-chart-wrapper {\n  height: 35%;\n}\n.widget-chart.widget-chart-left {\n  padding-bottom: 15%;\n}\n.widget-chart .chart-wrapper-relative {\n  position: relative;\n  opacity: 1;\n  margin-top: 1rem;\n}\n\n.widget-chart-actions {\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  z-index: 12;\n}\n.widget-chart-actions .btn-link {\n  font-size: 1.1rem;\n  padding-top: 0;\n  padding-bottom: 0;\n  opacity: 0.6;\n}\n\n.widget-chart:hover .widget-chart-actions .btn-link,\n.widget-content:hover .widget-chart-actions .btn-link {\n  opacity: 1;\n}\n\n.grid-menu .widget-chart.widget-chart-hover:hover {\n  background: #fff;\n  border-radius: 0.25rem;\n}\n\n.icon-wrapper {\n  width: 54px;\n  height: 54px;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n}\n.icon-wrapper[class*=border-] {\n  border-width: 1px;\n  border-style: solid;\n}\n.icon-wrapper .icon-wrapper-bg {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 3;\n  opacity: 0.2;\n}\n.icon-wrapper .icon-wrapper-bg.bg-light {\n  opacity: 0.08;\n}\n.icon-wrapper i {\n  margin: 0 auto;\n  font-size: 1.7rem;\n  position: relative;\n  z-index: 5;\n}\n.icon-wrapper i:before {\n  margin-top: -3px;\n}\n.icon-wrapper .progress-circle-wrapper {\n  width: 100%;\n  margin-right: 0;\n}\n\n.widget-chart2 .widget-chart-flex {\n  display: flex;\n  align-items: baseline;\n  align-content: center;\n  margin-bottom: 0;\n}\n.widget-chart2 .widget-chart-flex .widget-subtitle {\n  margin-left: auto;\n}\n.widget-chart2 .widget-chart-flex .widget-numbers {\n  font-weight: normal;\n}\n.widget-chart2 .widget-chart-flex + .widget-chart-flex .widget-numbers {\n  margin-bottom: 0;\n}\n.widget-chart2 .widget-chat-wrapper-outer {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  max-width: 100%;\n}\n.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper {\n  height: 70px;\n  opacity: 0.8;\n  position: relative;\n  margin: 1rem auto -0.5rem;\n}\n.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper-lg {\n  height: 130px;\n}\n\n.card-btm-border {\n  border-bottom: transparent solid 4px;\n}\n\n.progress-box {\n  text-align: center;\n}\n.progress-box h4 {\n  font-size: 0.88rem;\n  font-weight: bold;\n  opacity: 0.6;\n  text-transform: uppercase;\n  padding-bottom: 0.3333333333rem;\n}\n.progress-box svg {\n  margin: 0 auto;\n}\n\n.svg-bg {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0.1;\n}\n.svg-bg svg {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.widget-numbers-sm {\n  font-size: 1.5rem;\n}\n\n.widget-content {\n  padding: 1rem;\n  flex-direction: row;\n  align-items: center;\n}\n.widget-content .widget-content-wrapper {\n  display: flex;\n  flex: 1;\n  position: relative;\n  align-items: center;\n}\n.widget-content .widget-content-left .widget-heading {\n  opacity: 0.8;\n  font-weight: bold;\n}\n.widget-content .widget-content-left .widget-subheading {\n  opacity: 0.5;\n}\n.widget-content .widget-content-right {\n  margin-left: auto;\n}\n.widget-content .widget-numbers {\n  font-weight: bold;\n  font-size: 1.8rem;\n  display: block;\n}\n.widget-content .widget-content-outer {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.widget-content .widget-progress-wrapper {\n  margin-top: 1rem;\n}\n.widget-content .widget-progress-wrapper .progress-sub-label {\n  margin-top: 0.3333333333rem;\n  opacity: 0.5;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.widget-content .widget-progress-wrapper .progress-sub-label .sub-label-right {\n  margin-left: auto;\n}\n.widget-content .widget-content-right.widget-content-actions {\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n.widget-content:hover .widget-content-right.widget-content-actions {\n  visibility: visible;\n  opacity: 1;\n}\n\n.profile-block {\n  position: relative;\n  overflow: hidden;\n}\n.profile-block .profile-blur {\n  width: 100%;\n  height: 100%;\n  filter: blur(5px);\n  transform: scale(1.8);\n  position: absolute;\n  left: -25%;\n  top: -25%;\n}\n.profile-block .profile-inner {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  left: 0;\n  top: 0;\n}\n.profile-block .dropdown-menu-header .menu-header-content {\n  padding: 3rem;\n}\n.profile-block .dropdown-menu-header .menu-header-content .menu-header-title {\n  margin: 0.75rem 0 0;\n}\n.profile-block .dropdown-menu-header .menu-header-content .menu-header-subtitle {\n  margin: 0.5rem 0 0;\n}\n.profile-block .dropdown-menu-header .menu-header-btn-pane {\n  margin: 0.5rem 0 0;\n}\n.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon {\n  color: #fff;\n  padding: 0;\n  width: 44px;\n  height: 44px;\n  line-height: 37px;\n  font-size: 1.1rem;\n}\n.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.app-logo {\n  height: 23px;\n  width: 97px;\n  background: url(\"~assets/utils/images/logo-inverse.png\");\n}\n\n.app-logo-inverse {\n  height: 23px;\n  width: 97px;\n  background: url(\"~assets/utils/images/logo.png\");\n}\n\n.app-login-box .app-logo {\n  margin-bottom: 3rem;\n}\n.app-login-box h4 {\n  margin-bottom: 1.5rem;\n  font-weight: normal;\n}\n.app-login-box h4 div {\n  opacity: 0.6;\n}\n.app-login-box h4 span {\n  font-size: 1.1rem;\n}\n\n.app-inner-layout.rm-sidebar .app-inner-layout__wrapper .app-inner-layout__content {\n  width: auto;\n  float: none;\n}\n.app-inner-layout .app-inner-layout__header {\n  width: 100%;\n  padding: 1.5rem;\n  text-align: left;\n}\n.app-inner-layout .app-inner-layout__header .app-page-title {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n}\n.app-inner-layout .app-inner-layout__header {\n  border-bottom: #e9ecef solid 1px;\n}\n.app-inner-layout .app-inner-layout__header-boxed {\n  padding: 1.5rem;\n}\n.app-inner-layout .app-inner-layout__header-boxed .app-inner-layout__header {\n  border-radius: 0.3rem;\n}\n.app-inner-layout .app-inner-layout__wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  min-height: 100vh;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content {\n  flex: 1;\n  display: flex;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content.card {\n  box-shadow: 0 0 0 0 transparent;\n  border-radius: 0;\n  border: 0;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__top-pane {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  text-align: left;\n  padding: 0.75rem 1.5rem;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-left {\n  display: flex;\n  align-items: center;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-right {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__bottom-pane {\n  padding: 1.5rem;\n  border-top: #e9ecef solid 1px;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar {\n  width: 270px;\n  list-style: none;\n  text-align: left;\n  order: -1;\n  flex: 0 0 270px;\n  display: flex;\n  margin: 0;\n  position: relative;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .dropdown-item {\n  white-space: normal;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar.card {\n  box-shadow: 0 0 0 0 transparent;\n  border-radius: 0;\n  background: #f8f9fa;\n  border: 0;\n  border-right: #e9ecef solid 1px;\n  border-left: #e9ecef solid 1px;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-footer,\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-header {\n  background: #f8f9fa;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__aside {\n  width: 60px;\n}\n.app-inner-layout .app-inner-layout__footer {\n  width: 100%;\n  height: 50px;\n}\n\n.app-wrapper-footer .app-footer {\n  border-top: #e9ecef solid 1px;\n}\n.app-wrapper-footer .app-footer .app-footer__inner {\n  border-left: #e9ecef solid 1px;\n}\n\n.chat-layout.app-inner-layout .app-inner-layout__sidebar {\n  width: 360px;\n  flex: 0 0 360px;\n}\n.chat-layout .app-inner-layout__top-pane h4 {\n  font-size: 1.25rem;\n}\n.chat-layout .app-inner-layout__top-pane h4 div {\n  font-size: 0.88rem;\n}\n.chat-layout .chat-box-wrapper {\n  padding: 1.5rem;\n}\n\n@media (max-width: 1199.98px) {\n  .chat-layout.app-inner-layout .app-inner-layout__sidebar .widget-content .widget-content-left .widget-subheading {\n    white-space: normal;\n  }\n}\n.mobile-app-menu-btn {\n  display: none;\n  margin: 3px 1.5rem 0 0;\n}\n\n.table_header {\n  text-align: center;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 5px;\n  margin-top: 10px;\n  font-weight: bold;\n}\n\n@media (max-width: 991.98px) {\n  .app-inner-layout__sidebar {\n    display: none !important;\n  }\n  .mobile-app-menu-btn {\n    display: block;\n  }\n  .open-mobile-menu .app-inner-layout__sidebar {\n    display: block !important;\n  }\n}\n/*\n * Container style\n */\n.ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none !important;\n  opacity: 0;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  z-index: 7;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  border-radius: 50px;\n  z-index: 7;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus {\n  background-color: rgba(0, 0, 0, 0.1);\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  transition: background-color 0.2s linear, height 0.2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  transition: background-color 0.2s linear, width 0.2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x {\n  background-color: rgba(0, 0, 0, 0.12);\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y {\n  background-color: rgba(0, 0, 0, 0.12);\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n.scrollbar-container {\n  position: relative;\n  height: 100%;\n}\n\n.scroll-area {\n  overflow-x: hidden;\n  height: 400px;\n}\n\n.scroll-area-xs {\n  height: 150px;\n  overflow-x: hidden;\n}\n\n.scroll-area-sm {\n  height: 200px;\n  overflow-x: hidden;\n}\n\n.scroll-area-md {\n  height: 300px;\n  overflow-x: hidden;\n}\n\n.scroll-area-lg {\n  height: 400px;\n  overflow-x: hidden;\n}\n\n.scroll-area-x {\n  overflow-x: auto;\n  width: 100%;\n  max-width: 100%;\n}\n\n.shadow-overflow {\n  position: relative;\n}\n.shadow-overflow::after, .shadow-overflow::before {\n  width: 100%;\n  bottom: auto;\n  top: 0;\n  left: 0;\n  height: 1.5rem;\n  position: absolute;\n  z-index: 10;\n  content: \"\";\n  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\n}\n.shadow-overflow::after {\n  bottom: 0;\n  top: auto;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\n}\n\n.rc-tabs {\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n\n.rc-tabs-bar,\n.rc-tabs-nav-container {\n  font-size: 14px;\n  line-height: 1.5;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n  outline: none;\n  zoom: 1;\n  transition: padding 0.45s;\n}\n\n.rc-tabs-ink-bar {\n  margin-top: 0;\n  border-radius: 0.25rem;\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.rc-tabs-ink-bar-animated {\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n}\n\n.rc-tabs-tab-prev,\n.rc-tabs-tab-next {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  z-index: 1;\n  line-height: 36px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  position: absolute;\n}\n\n.rc-tabs-tab-prev-icon,\n.rc-tabs-tab-next-icon {\n  position: relative;\n  display: inline-block;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  line-height: inherit;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  font-smoothing: antialiased;\n  text-stroke-width: 0;\n  font-family: sans-serif;\n}\n\n.rc-tabs-tab-prev-icon:before,\n.rc-tabs-tab-next-icon:before {\n  display: block;\n}\n\n.rc-tabs-tab-btn-disabled {\n  cursor: default;\n  color: #495057;\n}\n\n.rc-tabs-nav-wrap {\n  overflow: hidden;\n}\n\n.rc-tabs-nav {\n  box-sizing: border-box;\n  padding-left: 0;\n  position: relative;\n  margin: 0;\n  float: left;\n  list-style: none;\n  display: inline-block;\n  transform-origin: 0 0;\n}\n.rc-tabs-nav > div:first-child {\n  z-index: 5;\n  position: relative;\n}\n\n.rc-tabs-nav-animated {\n  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n}\n\n.rc-tabs-nav:before,\n.rc-tabs-nav:after {\n  display: table;\n  content: \" \";\n}\n\n.rc-tabs-nav:after {\n  clear: both;\n}\n\n.rc-tabs-tab {\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  padding: 8px 20px;\n  cursor: pointer;\n}\n\n.rc-tabs-tab:hover {\n  color: #545cd8;\n}\n\n.rc-tabs-tab-active,\n.rc-tabs-tab-active:hover {\n  color: #fff;\n  cursor: default;\n  transform: translateZ(0);\n}\n\n.rc-tabs-tab-disabled {\n  cursor: default;\n  color: #495057;\n}\n\n.rc-tabs-tab-disabled:hover {\n  color: #495057;\n}\n\n.rc-tabs-content {\n  zoom: 1;\n}\n\n.rc-tabs-content .rc-tabs-tabpane {\n  overflow: hidden;\n}\n\n.rc-tabs-content-animated {\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  display: -ms-flexbox;\n  display: flex;\n  will-change: transform;\n}\n\n.rc-tabs-content-animated .rc-tabs-tabpane {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n\n.no-flexbox .rc-tabs-content {\n  transform: none !important;\n  overflow: hidden;\n}\n\n.no-csstransitions .rc-tabs-tabpane-inactive,\n.no-flexbox .rc-tabs-tabpane-inactive,\n.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {\n  display: none;\n}\n\n.rc-tabs-bottom .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n.rc-tabs-top .rc-tabs-content {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-container-scrolling {\n  padding-left: 35px;\n  padding-right: 35px;\n}\n\n.rc-tabs-top .rc-tabs-nav-scroll {\n  width: 99999px;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe {\n  position: relative;\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  margin-right: 0;\n  padding: 8px 0;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.rc-tabs-top .rc-tabs-nav-wrap {\n  width: 100%;\n  padding: 1.5rem 15px;\n}\n\n.rc-tabs-top .rc-tabs-content-animated {\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-tab-next {\n  right: 2px;\n}\n\n.rc-tabs-top .rc-tabs-tab-next-icon:before {\n  content: \">\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev {\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-tab-prev-icon:before {\n  content: \"<\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev,\n.rc-tabs-top .rc-tabs-tab-next {\n  margin-right: -2px;\n  width: 0;\n  height: 0;\n  top: 0;\n  text-align: center;\n  opacity: 0;\n  transition: width 0.3s, height 0.3s, opacity 0.3s;\n}\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 35px;\n  height: 100%;\n}\n\n.rc-tabs-top .rc-tabs-ink-bar {\n  height: 35px;\n  bottom: 0;\n  left: 0;\n  background: #545cd8;\n}\n\n.rc-tabs-top .rc-tabs-tab {\n  float: left;\n  height: 100%;\n  line-height: 1.3;\n  margin-right: 0.75rem;\n}\n\n.rc-tabs-top .rc-tabs-tabpane-inactive {\n  height: 0;\n  overflow: visible;\n}\n\n/*!\n * Ladda\n * http://lab.hakim.se/ladda\n * MIT licensed\n *\n * Copyright (C) 2018 Hakim El Hattab, http://hakim.se\n */\n/*************************************\n * CONFIG\n */\n/*************************************\n * MIXINS\n */\n/*************************************\n * Opacity animation for spin.js\n */\n@keyframes ladda-spinner-line-fade {\n  0%, 100% {\n    opacity: 0.22; /* minimum opacity */\n  }\n  1% {\n    opacity: 1;\n  }\n}\n/*************************************\n * BUTTON BASE\n */\n.ladda-button {\n  position: relative;\n}\n\n/* Spinner animation */\n.ladda-button .ladda-spinner {\n  position: absolute;\n  z-index: 2;\n  display: inline-block;\n  width: 32px;\n  top: 50%;\n  margin-top: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Button label */\n.ladda-button .ladda-label {\n  position: relative;\n  z-index: 3;\n}\n\n[class*=btn-outline-] .ladda-spinner div div div {\n  background: #000 !important;\n}\n[class*=btn-outline-].ladda-button .ladda-label {\n  transition: none !important;\n}\n\n/* Progress bar */\n.ladda-button .ladda-progress {\n  position: absolute;\n  width: 0;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background: rgba(0, 0, 0, 0.2);\n  display: none;\n  transition: 0.1s linear all !important;\n}\n\n.ladda-button[data-loading] .ladda-progress {\n  display: block;\n}\n\n/*************************************\n * EASING\n */\n.ladda-button,\n.ladda-button .ladda-spinner,\n.ladda-button .ladda-label {\n  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n}\n\n.ladda-button[data-style=zoom-in],\n.ladda-button[data-style=zoom-in] .ladda-spinner,\n.ladda-button[data-style=zoom-in] .ladda-label,\n.ladda-button[data-style=zoom-out],\n.ladda-button[data-style=zoom-out] .ladda-spinner,\n.ladda-button[data-style=zoom-out] .ladda-label {\n  transition: 0.3s ease all !important;\n}\n\n/*************************************\n * EXPAND RIGHT\n */\n.ladda-button[data-style=expand-right] .ladda-spinner {\n  right: -6px;\n}\n.ladda-button[data-style=expand-right][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-right][data-size=xs] .ladda-spinner {\n  right: -12px;\n}\n.ladda-button[data-style=expand-right][data-loading] {\n  padding-right: 56px;\n}\n.ladda-button[data-style=expand-right][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n.ladda-button[data-style=expand-right][data-loading][data-size=s], .ladda-button[data-style=expand-right][data-loading][data-size=xs] {\n  padding-right: 40px;\n}\n\n/*************************************\n * EXPAND LEFT\n */\n.ladda-button[data-style=expand-left] .ladda-spinner {\n  left: 26px;\n}\n.ladda-button[data-style=expand-left][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-left][data-size=xs] .ladda-spinner {\n  left: 4px;\n}\n.ladda-button[data-style=expand-left][data-loading] {\n  padding-left: 56px;\n}\n.ladda-button[data-style=expand-left][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n.ladda-button[data-style=expand-left][data-loading][data-size=s], .ladda-button[data-style=expand-left][data-loading][data-size=xs] {\n  padding-left: 40px;\n}\n\n/*************************************\n * EXPAND UP\n */\n.ladda-button[data-style=expand-up] {\n  overflow: hidden;\n}\n.ladda-button[data-style=expand-up] .ladda-spinner {\n  top: -32px;\n  left: 50%;\n  margin-left: 0;\n}\n.ladda-button[data-style=expand-up][data-loading] {\n  padding-top: 54px;\n}\n.ladda-button[data-style=expand-up][data-loading] .ladda-spinner {\n  opacity: 1;\n  top: 26px;\n  margin-top: 0;\n}\n.ladda-button[data-style=expand-up][data-loading][data-size=s], .ladda-button[data-style=expand-up][data-loading][data-size=xs] {\n  padding-top: 32px;\n}\n.ladda-button[data-style=expand-up][data-loading][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-up][data-loading][data-size=xs] .ladda-spinner {\n  top: 4px;\n}\n\n/*************************************\n * EXPAND DOWN\n */\n.ladda-button[data-style=expand-down] {\n  overflow: hidden;\n}\n.ladda-button[data-style=expand-down] .ladda-spinner {\n  top: 52px;\n  left: 50%;\n  margin-left: 0;\n}\n.ladda-button[data-style=expand-down][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-down][data-size=xs] .ladda-spinner {\n  top: 40px;\n}\n.ladda-button[data-style=expand-down][data-loading] {\n  padding-bottom: 54px;\n}\n.ladda-button[data-style=expand-down][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n.ladda-button[data-style=expand-down][data-loading][data-size=s], .ladda-button[data-style=expand-down][data-loading][data-size=xs] {\n  padding-bottom: 32px;\n}\n\n/*************************************\n * SLIDE LEFT\n */\n.ladda-button[data-style=slide-left] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-left] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-left] .ladda-spinner {\n  left: 100%;\n  margin-left: 0;\n}\n.ladda-button[data-style=slide-left][data-loading] .ladda-label {\n  opacity: 0;\n  left: -100%;\n}\n.ladda-button[data-style=slide-left][data-loading] .ladda-spinner {\n  opacity: 1;\n  left: 50%;\n}\n\n/*************************************\n * SLIDE RIGHT\n */\n.ladda-button[data-style=slide-right] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-right] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-right] .ladda-spinner {\n  right: 100%;\n  margin-left: 0;\n  left: 16px;\n}\n[dir=rtl] .ladda-button[data-style=slide-right] .ladda-spinner {\n  right: auto;\n}\n.ladda-button[data-style=slide-right][data-loading] .ladda-label {\n  opacity: 0;\n  left: 100%;\n}\n.ladda-button[data-style=slide-right][data-loading] .ladda-spinner {\n  opacity: 1;\n  left: 50%;\n}\n\n/*************************************\n * SLIDE UP\n */\n.ladda-button[data-style=slide-up] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-up] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-up] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n  margin-top: 1em;\n}\n.ladda-button[data-style=slide-up][data-loading] .ladda-label {\n  opacity: 0;\n  top: -1em;\n}\n.ladda-button[data-style=slide-up][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-top: 0;\n}\n\n/*************************************\n * SLIDE DOWN\n */\n.ladda-button[data-style=slide-down] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-down] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-down] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n  margin-top: -2em;\n}\n.ladda-button[data-style=slide-down][data-loading] .ladda-label {\n  opacity: 0;\n  top: 1em;\n}\n.ladda-button[data-style=slide-down][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-top: 0;\n}\n\n/*************************************\n * ZOOM-OUT\n */\n.ladda-button[data-style=zoom-out] {\n  overflow: hidden;\n}\n\n.ladda-button[data-style=zoom-out] .ladda-spinner {\n  left: 50%;\n  margin-left: 32px;\n  transform: scale(2.5);\n}\n\n.ladda-button[data-style=zoom-out] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-out][data-loading] .ladda-label {\n  opacity: 0;\n  transform: scale(0.5);\n}\n\n.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n  transform: none;\n}\n\n/*************************************\n * ZOOM-IN\n */\n.ladda-button[data-style=zoom-in] {\n  overflow: hidden;\n}\n\n.ladda-button[data-style=zoom-in] .ladda-spinner {\n  left: 50%;\n  margin-left: -16px;\n  transform: scale(0.2);\n}\n\n.ladda-button[data-style=zoom-in] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-in][data-loading] .ladda-label {\n  opacity: 0;\n  transform: scale(2.2);\n}\n\n.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n  transform: none;\n}\n\n/*************************************\n * CONTRACT\n */\n.ladda-button[data-style=contract] {\n  overflow: hidden;\n  width: 100px;\n}\n\n.ladda-button[data-style=contract] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n}\n\n.ladda-button[data-style=contract][data-loading] .ladda-label {\n  opacity: 0;\n}\n\n.ladda-button[data-style=contract][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n/*************************************\n * OVERLAY\n */\n.ladda-button[data-style=contract-overlay] {\n  overflow: hidden;\n  width: 100px;\n  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);\n}\n\n.ladda-button[data-style=contract-overlay] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/\n  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {\n  opacity: 0;\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n[dir=rtl] .ladda-spinner > div {\n  left: 25% !important;\n}\n\n/*!\n * Hamburgers\n * @description Tasty CSS-animated hamburgers\n * @author Jonathan Suh @jonsuh\n * @site https://jonsuh.com/hamburgers\n * @link https://github.com/jonsuh/hamburgers\n */\n.hamburger {\n  padding: 0px 0px;\n  display: inline-block;\n  cursor: pointer;\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n}\n.hamburger:hover {\n  opacity: 0.7;\n}\n.hamburger.is-active:hover {\n  opacity: 0.7;\n}\n.hamburger.is-active .hamburger-inner,\n.hamburger.is-active .hamburger-inner::before,\n.hamburger.is-active .hamburger-inner::after {\n  background-color: #545cd8;\n}\n\n.hamburger-box {\n  width: 24px;\n  height: 14px;\n  display: inline-block;\n  position: relative;\n}\n\n.hamburger-inner {\n  display: block;\n  top: 50%;\n  margin-top: -1px;\n}\n.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {\n  width: 24px;\n  height: 2px;\n  background-color: #545cd8;\n  border-radius: 10px;\n  position: absolute;\n  transition-property: transform;\n  transition-duration: 0.15s;\n  transition-timing-function: ease;\n}\n.hamburger-inner::before, .hamburger-inner::after {\n  content: \"\";\n  display: block;\n}\n.hamburger-inner::before {\n  top: -6px;\n}\n.hamburger-inner::after {\n  bottom: -6px;\n}\n\n/*\n * Elastic\n */\n.hamburger--elastic .hamburger-inner {\n  top: 1px;\n  transition-duration: 0.275s;\n  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic .hamburger-inner::before {\n  top: 6px;\n  transition: opacity 0.125s 0.275s ease;\n}\n.hamburger--elastic .hamburger-inner::after {\n  top: 12px;\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic.is-active .hamburger-inner {\n  transform: translate3d(0, 6px, 0) rotate(135deg);\n  transition-delay: 0.075s;\n}\n.hamburger--elastic.is-active .hamburger-inner::before {\n  transition-delay: 0s;\n  opacity: 0;\n}\n.hamburger--elastic.is-active .hamburger-inner::after {\n  transform: translate3d(0, -12px, 0) rotate(-270deg);\n  transition-delay: 0.075s;\n}\n\n.drawer-content-wrapper {\n  background: #fff;\n  position: relative;\n  padding: 1.5rem;\n}\n.drawer-content-wrapper .drawer-heading {\n  font-size: 0.968rem;\n  color: #495057;\n  margin: 0;\n  background: #f8f9fa;\n  padding: 0.75rem 1.5rem;\n  border-bottom: #dee2e6 solid 1px;\n  border-top: #dee2e6 solid 1px;\n}\n.drawer-content-wrapper .drawer-heading:first-child {\n  border-top: 0;\n}\n.drawer-content-wrapper .drawer-section {\n  padding: 1.5rem;\n}\n.drawer-content-wrapper > .app-sidebar__heading:first-child {\n  margin-top: 0;\n}\n\n.drawer-nav-btn {\n  border-radius: 30px;\n  background: #fff;\n  position: fixed;\n  right: 0.75rem;\n  top: 0.75rem;\n  padding: 0.5rem;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  z-index: 20;\n}\n.drawer-nav-btn .hamburger {\n  margin-top: 4px;\n}\n\nbody.stop-scrolling {\n  height: 100%;\n  overflow: hidden;\n}\n\n.sweet-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n  opacity: 0.5 !important;\n}\n\n.sweet-alert {\n  background-color: #fff;\n  width: 30%;\n  padding: 1rem;\n  border-radius: 0.25rem;\n  text-align: center;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin-left: -15%;\n  margin-top: -15%;\n  overflow: hidden;\n  display: none;\n  z-index: 99999;\n  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);\n}\n.sweet-alert h2 {\n  color: #495057;\n  text-align: center;\n  text-transform: none;\n  position: relative;\n  margin: 0.75rem 0;\n  padding: 0;\n  display: block;\n}\n.sweet-alert p {\n  color: #adb5bd;\n  text-align: center;\n  position: relative;\n  float: none;\n  margin: 0;\n  padding: 0;\n}\n.sweet-alert fieldset {\n  border: none;\n  position: relative;\n}\n.sweet-alert .sa-error-container {\n  background-color: #f8f9fa;\n  margin-left: -17px;\n  margin-right: -17px;\n  overflow: hidden;\n  padding: 0 10px;\n  max-height: 0;\n  transition: padding 0.15s, max-height 0.15s;\n}\n.sweet-alert .sa-error-container.show {\n  padding: 10px 0;\n  max-height: 100px;\n  transition: padding 0.25s, max-height 0.25s;\n}\n.sweet-alert .sa-error-container .icon {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #d92550;\n  color: #fff;\n  line-height: 24px;\n  text-align: center;\n  margin-right: 3px;\n}\n.sweet-alert .sa-error-container p {\n  display: inline-block;\n}\n.sweet-alert .sa-input-error {\n  position: absolute;\n  top: 29px;\n  right: 26px;\n  width: 20px;\n  height: 20px;\n  opacity: 0;\n  -webkit-transform: scale(0.5);\n  transform: scale(0.5);\n  -webkit-transform-origin: 50% 50%;\n  transform-origin: 50% 50%;\n  -webkit-transition: all 0.1s;\n  transition: all 0.1s;\n}\n.sweet-alert .sa-input-error::before, .sweet-alert .sa-input-error::after {\n  content: \"\";\n  width: 20px;\n  height: 6px;\n  background-color: #d92550;\n  border-radius: 3px;\n  position: absolute;\n  top: 50%;\n  margin-top: -4px;\n  left: 50%;\n  margin-left: -9px;\n}\n.sweet-alert .sa-input-error::before {\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.sweet-alert .sa-input-error::after {\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.sweet-alert .sa-input-error.show {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n.sweet-alert input {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 3px;\n  border: 1px solid #d7d7d7;\n  height: 43px;\n  margin-top: 10px;\n  margin-bottom: 17px;\n  font-size: 18px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n  padding: 0 12px;\n  display: none;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.sweet-alert input:focus {\n  outline: none;\n  box-shadow: 0 0 3px #c4e6f5;\n  border: 1px solid #b4dbed;\n}\n.sweet-alert .sweet-alert.show-input input {\n  display: block;\n}\n.sweet-alert .sa-confirm-button-container {\n  display: inline-block;\n  position: relative;\n}\n.sweet-alert .la-ball-fall {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -27px;\n  margin-top: 4px;\n  opacity: 0;\n  visibility: hidden;\n}\n.sweet-alert button {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  font-size: 0.88rem;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s !important;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.sweet-alert button:hover {\n  color: #fff;\n  background-color: rgb(20.7268907563%, 24.4355742297%, 81.9201680672%);\n  border-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n}\n.sweet-alert button:focus, .sweet-alert button.focus {\n  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);\n}\n.sweet-alert button.disabled, .sweet-alert button:disabled {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.sweet-alert button:not(:disabled):not(.disabled):active, .sweet-alert button:not(:disabled):not(.disabled).active, .show > .sweet-alert button.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n  border-color: rgb(17.2058823529%, 20.7352941176%, 75.4411764706%);\n}\n.sweet-alert button:not(:disabled):not(.disabled):active:focus, .sweet-alert button:not(:disabled):not(.disabled).active:focus, .show > .sweet-alert button.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(43%, 45.6666666667%, 87%, 0.5);\n}\n.sweet-alert button:hover, .sweet-alert button:focus {\n  text-decoration: none;\n}\n.sweet-alert button:focus, .sweet-alert button.focus {\n  outline: 0;\n  box-shadow: none;\n}\n.sweet-alert button.disabled, .sweet-alert button:disabled {\n  opacity: 0.65;\n}\n.sweet-alert button.cancel {\n  font-weight: 400;\n  color: #545cd8;\n  background-color: transparent;\n  border-color: transparent;\n  margin-right: 0.5rem;\n}\n.sweet-alert button.cancel:hover {\n  color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);\n  text-decoration: underline;\n  background-color: transparent;\n  border-color: transparent;\n}\n.sweet-alert button.cancel:active, .sweet-alert button.cancel.active, .sweet-alert button.cancel:focus, .sweet-alert button.cancel.focus {\n  text-decoration: none;\n  border-color: transparent;\n  box-shadow: none;\n  background-color: transparent;\n}\n.sweet-alert button.cancel:disabled, .sweet-alert button.cancel.disabled {\n  color: #6c757d;\n  pointer-events: none;\n}\n.sweet-alert button.confirm[disabled] ~ .la-ball-fall {\n  opacity: 1;\n  visibility: visible;\n  transition-delay: 0s;\n}\n.sweet-alert[data-has-cancel-button=false] button {\n  box-shadow: none !important;\n}\n.sweet-alert[data-has-confirm-button=false][data-has-cancel-button=false] {\n  padding-bottom: 40px;\n}\n.sweet-alert .sa-button-container {\n  padding: 1rem 0 0;\n}\n\n.sa-icon {\n  width: 80px;\n  height: 80px;\n  border: 4px solid #dee2e6;\n  -webkit-border-radius: 40px;\n  border-radius: 50%;\n  margin: 20px auto;\n  padding: 0;\n  position: relative;\n  box-sizing: content-box;\n}\n.sa-icon.sa-error {\n  border-color: #d92550;\n}\n.sa-icon.sa-error .sa-x-mark {\n  position: relative;\n  display: block;\n}\n.sa-icon.sa-error .sa-line {\n  position: absolute;\n  height: 5px;\n  width: 47px;\n  background-color: #d92550;\n  display: block;\n  top: 37px;\n  border-radius: 2px;\n}\n.sa-icon.sa-error .sa-line.sa-left {\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  left: 17px;\n}\n.sa-icon.sa-error .sa-line.sa-right {\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  right: 16px;\n}\n.sa-icon.sa-warning {\n  border-color: #f7b924;\n}\n.sa-icon.sa-warning .sa-body {\n  position: absolute;\n  width: 5px;\n  height: 47px;\n  left: 50%;\n  top: 10px;\n  -webkit-border-radius: 2px;\n  border-radius: 2px;\n  margin-left: -2px;\n  background-color: #f7b924;\n}\n.sa-icon.sa-warning .sa-dot {\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  margin-left: -3px;\n  left: 50%;\n  bottom: 10px;\n  background-color: #f7b924;\n}\n.sa-icon.sa-info {\n  border-color: #30b1ff;\n}\n.sa-icon.sa-info::before {\n  content: \"\";\n  position: absolute;\n  width: 5px;\n  height: 29px;\n  left: 50%;\n  bottom: 17px;\n  border-radius: 2px;\n  margin-left: -2px;\n  background-color: #30b1ff;\n}\n.sa-icon.sa-info::after {\n  content: \"\";\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  margin-left: -3px;\n  top: 19px;\n  background-color: #30b1ff;\n}\n.sa-icon.sa-success {\n  border-color: #3ac47d;\n}\n.sa-icon.sa-success::before, .sa-icon.sa-success::after {\n  content: \"\";\n  -webkit-border-radius: 40px;\n  border-radius: 50%;\n  position: absolute;\n  width: 60px;\n  height: 120px;\n  background: #fff;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.sa-icon.sa-success::before {\n  -webkit-border-radius: 120px 0 0 120px;\n  border-radius: 120px 0 0 120px;\n  top: -7px;\n  left: -33px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: 60px 60px;\n  transform-origin: 60px 60px;\n}\n.sa-icon.sa-success::after {\n  -webkit-border-radius: 0 120px 120px 0;\n  border-radius: 0 120px 120px 0;\n  top: -11px;\n  left: 30px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: 0 60px;\n  transform-origin: 0 60px;\n}\n.sa-icon.sa-success .sa-placeholder {\n  width: 80px;\n  height: 80px;\n  border: 4px solid rgba(165, 220, 134, 0.2);\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n  border-radius: 50%;\n  box-sizing: content-box;\n  position: absolute;\n  left: -4px;\n  top: -4px;\n  z-index: 2;\n}\n.sa-icon.sa-success .sa-fix {\n  width: 5px;\n  height: 90px;\n  background-color: #fff;\n  position: absolute;\n  left: 28px;\n  top: 8px;\n  z-index: 1;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.sa-icon.sa-success .sa-line {\n  height: 5px;\n  background-color: #3ac47d;\n  display: block;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 2;\n}\n.sa-icon.sa-success .sa-line.sa-tip {\n  width: 25px;\n  left: 14px;\n  top: 46px;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.sa-icon.sa-success .sa-line.sa-long {\n  width: 47px;\n  right: 8px;\n  top: 38px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.sa-icon.sa-custom {\n  background-size: contain;\n  border-radius: 0;\n  border: none;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n@media all and (max-width: 540px) {\n  .sweet-alert {\n    width: auto;\n    margin-left: 0;\n    margin-right: 0;\n    left: 15px;\n    right: 15px;\n  }\n}\n/*\n * Animations\n */\n@-webkit-keyframes showSweetAlert {\n  0% {\n    transform: scale(0.7);\n    -webkit-transform: scale(0.7);\n  }\n  45% {\n    transform: scale(1.05);\n    -webkit-transform: scale(1.05);\n  }\n  80% {\n    transform: scale(0.95);\n    -webkit-transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n}\n@keyframes showSweetAlert {\n  0% {\n    transform: scale(0.7);\n    -webkit-transform: scale(0.7);\n  }\n  45% {\n    transform: scale(1.05);\n    -webkit-transform: scale(1.05);\n  }\n  80% {\n    transform: scale(0.95);\n    -webkit-transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n}\n@-webkit-keyframes hideSweetAlert {\n  0% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n  100% {\n    transform: scale(0.5);\n    -webkit-transform: scale(0.5);\n  }\n}\n@keyframes hideSweetAlert {\n  0% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n  100% {\n    transform: scale(0.5);\n    -webkit-transform: scale(0.5);\n  }\n}\n@-webkit-keyframes slideFromTop {\n  0% {\n    top: 0%;\n  }\n  100% {\n    top: 50%;\n  }\n}\n@keyframes slideFromTop {\n  0% {\n    top: 0%;\n  }\n  100% {\n    top: 50%;\n  }\n}\n@-webkit-keyframes slideToTop {\n  0% {\n    top: 50%;\n  }\n  100% {\n    top: 0%;\n  }\n}\n@keyframes slideToTop {\n  0% {\n    top: 50%;\n  }\n  100% {\n    top: 0%;\n  }\n}\n@-webkit-keyframes slideFromBottom {\n  0% {\n    top: 70%;\n  }\n  100% {\n    top: 50%;\n  }\n}\n@keyframes slideFromBottom {\n  0% {\n    top: 70%;\n  }\n  100% {\n    top: 50%;\n  }\n}\n@-webkit-keyframes slideToBottom {\n  0% {\n    top: 50%;\n  }\n  100% {\n    top: 70%;\n  }\n}\n@keyframes slideToBottom {\n  0% {\n    top: 50%;\n  }\n  100% {\n    top: 70%;\n  }\n}\n.showSweetAlert[data-animation=pop] {\n  -webkit-animation: showSweetAlert 0.3s;\n  animation: showSweetAlert 0.3s;\n}\n\n.showSweetAlert[data-animation=none] {\n  -webkit-animation: none;\n  animation: none;\n}\n\n.showSweetAlert[data-animation=slide-from-top] {\n  -webkit-animation: slideFromTop 0.3s;\n  animation: slideFromTop 0.3s;\n}\n\n.showSweetAlert[data-animation=slide-from-bottom] {\n  -webkit-animation: slideFromBottom 0.3s;\n  animation: slideFromBottom 0.3s;\n}\n\n.hideSweetAlert[data-animation=pop] {\n  -webkit-animation: hideSweetAlert 0.2s;\n  animation: hideSweetAlert 0.2s;\n}\n\n.hideSweetAlert[data-animation=none] {\n  -webkit-animation: none;\n  animation: none;\n}\n\n.hideSweetAlert[data-animation=slide-from-top] {\n  -webkit-animation: slideToTop 0.4s;\n  animation: slideToTop 0.4s;\n}\n\n.hideSweetAlert[data-animation=slide-from-bottom] {\n  -webkit-animation: slideToBottom 0.3s;\n  animation: slideToBottom 0.3s;\n}\n\n@-webkit-keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n@keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n@-webkit-keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n@keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n@-webkit-keyframes rotatePlaceholder {\n  0% {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n  5% {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n  12% {\n    transform: rotate(-405deg);\n    -webkit-transform: rotate(-405deg);\n  }\n  100% {\n    transform: rotate(-405deg);\n    -webkit-transform: rotate(-405deg);\n  }\n}\n@keyframes rotatePlaceholder {\n  0% {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n  5% {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n  12% {\n    transform: rotate(-405deg);\n    -webkit-transform: rotate(-405deg);\n  }\n  100% {\n    transform: rotate(-405deg);\n    -webkit-transform: rotate(-405deg);\n  }\n}\n.animateSuccessTip {\n  -webkit-animation: animateSuccessTip 0.75s;\n  animation: animateSuccessTip 0.75s;\n}\n\n.animateSuccessLong {\n  -webkit-animation: animateSuccessLong 0.75s;\n  animation: animateSuccessLong 0.75s;\n}\n\n.sa-icon.sa-success.animate::after {\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\n  animation: rotatePlaceholder 4.25s ease-in;\n}\n\n@-webkit-keyframes animateErrorIcon {\n  0% {\n    transform: rotateX(100deg);\n    -webkit-transform: rotateX(100deg);\n    opacity: 0;\n  }\n  100% {\n    transform: rotateX(0deg);\n    -webkit-transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n@keyframes animateErrorIcon {\n  0% {\n    transform: rotateX(100deg);\n    -webkit-transform: rotateX(100deg);\n    opacity: 0;\n  }\n  100% {\n    transform: rotateX(0deg);\n    -webkit-transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n.animateErrorIcon {\n  -webkit-animation: animateErrorIcon 0.5s;\n  animation: animateErrorIcon 0.5s;\n}\n\n@-webkit-keyframes animateXMark {\n  0% {\n    transform: scale(0.4);\n    -webkit-transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  50% {\n    transform: scale(0.4);\n    -webkit-transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  80% {\n    transform: scale(1.15);\n    -webkit-transform: scale(1.15);\n    margin-top: -6px;\n  }\n  100% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n@keyframes animateXMark {\n  0% {\n    transform: scale(0.4);\n    -webkit-transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  50% {\n    transform: scale(0.4);\n    -webkit-transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  80% {\n    transform: scale(1.15);\n    -webkit-transform: scale(1.15);\n    margin-top: -6px;\n  }\n  100% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n.animateXMark {\n  -webkit-animation: animateXMark 0.5s;\n  animation: animateXMark 0.5s;\n}\n\n@-webkit-keyframes pulseWarning {\n  0% {\n    border-color: #F8D486;\n  }\n  100% {\n    border-color: #f7b924;\n  }\n}\n@keyframes pulseWarning {\n  0% {\n    border-color: #F8D486;\n  }\n  100% {\n    border-color: #f7b924;\n  }\n}\n.pulseWarning {\n  -webkit-animation: pulseWarning 0.75s infinite alternate;\n  animation: pulseWarning 0.75s infinite alternate;\n}\n\n@-webkit-keyframes pulseWarningIns {\n  0% {\n    background-color: #F8D486;\n  }\n  100% {\n    background-color: #f7b924;\n  }\n}\n@keyframes pulseWarningIns {\n  0% {\n    background-color: #F8D486;\n  }\n  100% {\n    background-color: #f7b924;\n  }\n}\n.pulseWarningIns {\n  -webkit-animation: pulseWarningIns 0.75s infinite alternate;\n  animation: pulseWarningIns 0.75s infinite alternate;\n}\n\n@-webkit-keyframes rotate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes rotate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* Internet Explorer 9 has some special quirks that are fixed here */\n/* The icons are not animated. */\n/* This file is automatically merged into sweet-alert.min.js through Gulp */\n/* Error icon */\n.sweet-alert .sa-icon.sa-error .sa-line.sa-left {\n  -ms-transform: rotate(45deg) \\9 ;\n}\n\n.sweet-alert .sa-icon.sa-error .sa-line.sa-right {\n  -ms-transform: rotate(-45deg) \\9 ;\n}\n\n/* Success icon */\n.sweet-alert .sa-icon.sa-success {\n  border-color: transparent \\9 ;\n}\n\n.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {\n  -ms-transform: rotate(45deg) \\9 ;\n}\n\n.sweet-alert .sa-icon.sa-success .sa-line.sa-long {\n  -ms-transform: rotate(-45deg) \\9 ;\n}\n\n/*!\n * Load Awesome v1.1.0 (http://github.danielcardoso.net/load-awesome/)\n * Copyright 2015 Daniel Cardoso <@DanielCardoso>\n * Licensed under MIT\n */\n.la-ball-fall,\n.la-ball-fall > div {\n  position: relative;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.la-ball-fall {\n  display: block;\n  font-size: 0;\n  color: #fff;\n}\n\n.la-ball-fall.la-dark {\n  color: #333;\n}\n\n.la-ball-fall > div {\n  display: inline-block;\n  float: none;\n  background-color: currentColor;\n  border: 0 solid currentColor;\n}\n\n.la-ball-fall {\n  width: 54px;\n  height: 18px;\n}\n\n.la-ball-fall > div {\n  width: 10px;\n  height: 10px;\n  margin: 4px;\n  border-radius: 100%;\n  opacity: 0;\n  -webkit-animation: ball-fall 1s ease-in-out infinite;\n  -moz-animation: ball-fall 1s ease-in-out infinite;\n  -o-animation: ball-fall 1s ease-in-out infinite;\n  animation: ball-fall 1s ease-in-out infinite;\n}\n\n.la-ball-fall > div:nth-child(1) {\n  -webkit-animation-delay: -200ms;\n  -moz-animation-delay: -200ms;\n  -o-animation-delay: -200ms;\n  animation-delay: -200ms;\n}\n\n.la-ball-fall > div:nth-child(2) {\n  -webkit-animation-delay: -100ms;\n  -moz-animation-delay: -100ms;\n  -o-animation-delay: -100ms;\n  animation-delay: -100ms;\n}\n\n.la-ball-fall > div:nth-child(3) {\n  -webkit-animation-delay: 0ms;\n  -moz-animation-delay: 0ms;\n  -o-animation-delay: 0ms;\n  animation-delay: 0ms;\n}\n\n.la-ball-fall.la-sm {\n  width: 26px;\n  height: 8px;\n}\n\n.la-ball-fall.la-sm > div {\n  width: 4px;\n  height: 4px;\n  margin: 2px;\n}\n\n.la-ball-fall.la-2x {\n  width: 108px;\n  height: 36px;\n}\n\n.la-ball-fall.la-2x > div {\n  width: 20px;\n  height: 20px;\n  margin: 8px;\n}\n\n.la-ball-fall.la-3x {\n  width: 162px;\n  height: 54px;\n}\n\n.la-ball-fall.la-3x > div {\n  width: 30px;\n  height: 30px;\n  margin: 12px;\n}\n\n/*\n * Animation\n */\n@-webkit-keyframes ball-fall {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-145%);\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: 0.5;\n  }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  90% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(145%);\n    transform: translateY(145%);\n  }\n}\n@-moz-keyframes ball-fall {\n  0% {\n    opacity: 0;\n    -moz-transform: translateY(-145%);\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: 0.5;\n  }\n  20% {\n    opacity: 1;\n    -moz-transform: translateY(0);\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    -moz-transform: translateY(0);\n    transform: translateY(0);\n  }\n  90% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 0;\n    -moz-transform: translateY(145%);\n    transform: translateY(145%);\n  }\n}\n@-o-keyframes ball-fall {\n  0% {\n    opacity: 0;\n    -o-transform: translateY(-145%);\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: 0.5;\n  }\n  20% {\n    opacity: 1;\n    -o-transform: translateY(0);\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    -o-transform: translateY(0);\n    transform: translateY(0);\n  }\n  90% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 0;\n    -o-transform: translateY(145%);\n    transform: translateY(145%);\n  }\n}\n@keyframes ball-fall {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-145%);\n    -moz-transform: translateY(-145%);\n    -o-transform: translateY(-145%);\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: 0.5;\n  }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n  }\n  90% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(145%);\n    -moz-transform: translateY(145%);\n    -o-transform: translateY(145%);\n    transform: translateY(145%);\n  }\n}\n.Toastify__toast-container {\n  z-index: 9999;\n  position: fixed;\n  padding: 0;\n  width: 320px;\n  box-sizing: border-box;\n  color: #fff;\n}\n.Toastify__toast-container--top-left {\n  top: 1rem;\n  left: 1rem;\n}\n.Toastify__toast-container--top-center {\n  top: 1rem;\n  left: 50%;\n  margin-left: -160px;\n}\n.Toastify__toast-container--top-right {\n  top: 1rem;\n  right: 1rem;\n}\n.Toastify__toast-container--bottom-left {\n  bottom: 1rem;\n  left: 1rem;\n}\n.Toastify__toast-container--bottom-center {\n  bottom: 1rem;\n  left: 50%;\n  margin-left: -160px;\n}\n.Toastify__toast-container--bottom-right {\n  bottom: 1rem;\n  right: 1rem;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast-container {\n    width: 100vw;\n    padding: 0;\n    left: 0;\n    margin: 0;\n  }\n  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {\n    top: 0;\n  }\n  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {\n    bottom: 0;\n  }\n  .Toastify__toast-container--rtl {\n    right: 0;\n    left: initial;\n  }\n}\n.Toastify__toast {\n  position: relative;\n  min-height: 54px;\n  box-sizing: border-box;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n  display: flex;\n  justify-content: space-between;\n  max-height: 800px;\n  overflow: hidden;\n  font-family: sans-serif;\n  cursor: pointer;\n  direction: ltr;\n}\n.Toastify__toast--rtl {\n  direction: rtl;\n}\n.Toastify__toast--default {\n  background: #fff;\n  color: #495057;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(84, 92, 216, 0.03), 0 1.1375rem 1.60625rem rgba(84, 92, 216, 0.03), 0 0.45rem 0.73125rem rgba(84, 92, 216, 0.05), 0 0.325rem 0.3875rem rgba(84, 92, 216, 0.03);\n}\n.Toastify__toast--info {\n  background: #30b1ff;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(48, 177, 255, 0.03), 0 1.1375rem 1.60625rem rgba(48, 177, 255, 0.03), 0 0.45rem 0.73125rem rgba(48, 177, 255, 0.05), 0 0.325rem 0.3875rem rgba(48, 177, 255, 0.03);\n}\n.Toastify__toast--success {\n  background: #3ac47d;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(58, 196, 125, 0.03), 0 1.1375rem 1.60625rem rgba(58, 196, 125, 0.03), 0 0.45rem 0.73125rem rgba(58, 196, 125, 0.05), 0 0.325rem 0.3875rem rgba(58, 196, 125, 0.03);\n}\n.Toastify__toast--warning {\n  background: #f7b924;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(247, 185, 36, 0.03), 0 1.1375rem 1.60625rem rgba(247, 185, 36, 0.03), 0 0.45rem 0.73125rem rgba(247, 185, 36, 0.05), 0 0.325rem 0.3875rem rgba(247, 185, 36, 0.03);\n}\n.Toastify__toast--error {\n  background: #d92550;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(217, 37, 80, 0.03), 0 1.1375rem 1.60625rem rgba(217, 37, 80, 0.03), 0 0.45rem 0.73125rem rgba(217, 37, 80, 0.05), 0 0.325rem 0.3875rem rgba(217, 37, 80, 0.03);\n}\n.Toastify__toast-body {\n  margin: auto 0;\n  padding: 0 0 0.4rem;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast {\n    margin-bottom: 0;\n  }\n}\n.Toastify__close-button {\n  color: #fff;\n  font-size: 14px;\n  background: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  position: absolute;\n  top: 5px;\n  right: 9px;\n}\n.Toastify__close-button--default {\n  color: #000;\n  opacity: 0.3;\n}\n.Toastify__close-button:hover, .Toastify__close-button:focus {\n  opacity: 1;\n}\n\n@keyframes Toastify__trackProgress {\n  0% {\n    width: 96%;\n  }\n  100% {\n    width: 0;\n  }\n}\n.Toastify__progress-bar {\n  position: absolute;\n  bottom: 9%;\n  left: 2%;\n  width: 0;\n  height: 5px;\n  z-index: 9999;\n  animation: Toastify__trackProgress linear 1;\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 0.25rem;\n}\n.Toastify__progress-bar--rtl {\n  right: 0;\n  left: initial;\n}\n.Toastify__progress-bar--default {\n  background: #545cd8;\n}\n@keyframes Toastify__bounceInRight {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInLeft {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInUp {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__bounceOutUp {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n@keyframes Toastify__bounceInDown {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutDown {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {\n  animation-name: Toastify__bounceInLeft;\n}\n.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {\n  animation-name: Toastify__bounceInRight;\n}\n.Toastify__bounce-enter--top-center {\n  animation-name: Toastify__bounceInDown;\n}\n.Toastify__bounce-enter--bottom-center {\n  animation-name: Toastify__bounceInUp;\n}\n\n.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {\n  animation-name: Toastify__bounceOutLeft;\n}\n.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {\n  animation-name: Toastify__bounceOutRight;\n}\n.Toastify__bounce-exit--top-center {\n  animation-name: Toastify__bounceOutUp;\n}\n.Toastify__bounce-exit--bottom-center {\n  animation-name: Toastify__bounceOutDown;\n}\n\n@keyframes Toastify__zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n@keyframes Toastify__zoomOut {\n  from {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n.Toastify__zoom-enter {\n  animation-name: Toastify__zoomIn;\n}\n\n.Toastify__zoom-exit {\n  animation-name: Toastify__zoomOut;\n}\n\n@keyframes Toastify__flipIn {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n@keyframes Toastify__flipOut {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n}\n.Toastify__flip-enter {\n  animation-name: Toastify__flipIn;\n}\n\n.Toastify__flip-exit {\n  animation-name: Toastify__flipOut;\n}\n\n@keyframes Toastify__slideInRight {\n  from {\n    transform: translate3d(110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInLeft {\n  from {\n    transform: translate3d(-110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInUp {\n  from {\n    transform: translate3d(0, 110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInDown {\n  from {\n    transform: translate3d(0, -110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutRight {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutLeft {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(-110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutDown {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 500px, 0);\n  }\n}\n@keyframes Toastify__slideOutUp {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -500px, 0);\n  }\n}\n.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {\n  animation-name: Toastify__slideInLeft;\n}\n.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {\n  animation-name: Toastify__slideInRight;\n}\n.Toastify__slide-enter--top-center {\n  animation-name: Toastify__slideInDown;\n}\n.Toastify__slide-enter--bottom-center {\n  animation-name: Toastify__slideInUp;\n}\n\n.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {\n  animation-name: Toastify__slideOutLeft;\n}\n.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {\n  animation-name: Toastify__slideOutRight;\n}\n.Toastify__slide-exit--top-center {\n  animation-name: Toastify__slideOutUp;\n}\n.Toastify__slide-exit--bottom-center {\n  animation-name: Toastify__slideOutDown;\n}\n\n/* -- container -- */\n.rodal,\n.rodal-mask {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.rodal {\n  position: fixed;\n}\n\n/* -- mask -- */\n.rodal-mask {\n  position: absolute;\n  background-color: #000;\n  opacity: 0.5;\n}\n\n/* -- dialog -- */\n.rodal-dialog {\n  position: absolute;\n  top: 10%;\n  left: 0;\n  right: 0;\n  margin: auto;\n  z-index: 101;\n  background: #fff;\n  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);\n  border-radius: 0.25rem;\n  height: auto !important;\n}\n\n.rodal-dialog:focus {\n  outline: none;\n}\n\n/* -- close button -- */\n.rodal-close {\n  position: absolute;\n  cursor: pointer;\n  top: 16px;\n  right: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.rodal-close:before,\n.rodal-close:after {\n  position: absolute;\n  content: \"\";\n  height: 2px;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  margin-top: -1px;\n  background: #adb5bd;\n  border-radius: 100%;\n  transition: background 0.2s;\n}\n\n.rodal-close:before {\n  transform: rotate(45deg);\n}\n\n.rodal-close:after {\n  transform: rotate(-45deg);\n}\n\n.rodal-close:hover:before,\n.rodal-close:hover:after {\n  background: #343a40;\n}\n\n/* -- fade -- */\n@keyframes rodal-fade-enter {\n  from {\n    opacity: 0;\n  }\n}\n.rodal-fade-enter {\n  animation: rodal-fade-enter both ease-in;\n}\n\n@keyframes rodal-fade-leave {\n  to {\n    opacity: 0;\n  }\n}\n.rodal-fade-leave {\n  animation: rodal-fade-leave both ease-out;\n}\n\n@keyframes rodal-zoom-enter {\n  from {\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-zoom-enter {\n  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-zoom-leave {\n  to {\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-zoom-leave {\n  animation: rodal-zoom-leave both;\n}\n\n@keyframes rodal-slideDown-enter {\n  from {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n.rodal-slideDown-enter {\n  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideDown-leave {\n  to {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n.rodal-slideDown-leave {\n  animation: rodal-slideDown-leave both;\n}\n\n/* -- slideLeft -- */\n@keyframes rodal-slideLeft-enter {\n  from {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n.rodal-slideLeft-enter {\n  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideLeft-leave {\n  to {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n.rodal-slideLeft-leave {\n  animation: rodal-slideLeft-leave both;\n}\n\n/* -- slideRight -- */\n@keyframes rodal-slideRight-enter {\n  from {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n.rodal-slideRight-enter {\n  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideRight-leave {\n  to {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n.rodal-slideRight-leave {\n  animation: rodal-slideRight-leave both;\n}\n\n/* -- slideUp -- */\n@keyframes rodal-slideUp-enter {\n  from {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n.rodal-slideUp-enter {\n  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideUp-leave {\n  to {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n.rodal-slideUp-leave {\n  animation: rodal-slideUp-leave both;\n}\n\n/* -- flip -- */\n@keyframes rodal-flip-enter {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);\n  }\n  70% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n.rodal-flip-enter {\n  animation: rodal-flip-enter both ease-in;\n  backface-visibility: visible !important;\n}\n\n@keyframes rodal-flip-leave {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);\n  }\n}\n.rodal-flip-leave {\n  animation: rodal-flip-leave both;\n  backface-visibility: visible !important;\n}\n\n/* -- rotate -- */\n@keyframes rodal-rotate-enter {\n  from {\n    transform: rotate3d(0, 0, 1, -180deg) scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-rotate-enter {\n  animation: rodal-rotate-enter both;\n  transform-origin: center;\n}\n\n@keyframes rodal-rotate-leave {\n  to {\n    transform: rotate3d(0, 0, 1, 180deg) scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-rotate-leave {\n  animation: rodal-rotate-leave both;\n  transform-origin: center;\n}\n\n/* -- door -- */\n@keyframes rodal-door-enter {\n  from {\n    transform: scale3d(0, 1, 1);\n  }\n}\n.rodal-door-enter {\n  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-door-leave {\n  60% {\n    transform: scale3d(0.01, 1, 1);\n  }\n  to {\n    transform: scale3d(0, 1, 0.1);\n  }\n}\n.rodal-door-leave {\n  animation: rodal-door-leave both;\n}\n\n.react-sweet-progress {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.react-sweet-progress-symbol {\n  display: flex;\n  align-items: center;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  width: 35px;\n  height: 20px;\n  padding-left: 10px;\n  color: rgba(0, 0, 0, 0.7);\n  font-weight: 200;\n}\n\n.react-sweet-progress-symbol-absolute {\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  transform: translate3d(-50%, -50%, 0);\n}\n\n.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {\n  padding: 0;\n  width: 100%;\n}\n\n.react-sweet-progress-circle-outer {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line {\n  width: 100%;\n  border-radius: 100px;\n  background-color: #efefef;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line-inner {\n  position: relative;\n  min-height: 10px;\n  border-radius: 100px;\n  transition: width 0.3s ease;\n}\n\n.react-sweet-progress-line-inner-status-active:before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border-radius: 10px;\n  background: #fff;\n  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;\n  content: \"\";\n  opacity: 0;\n}\n\n@keyframes active-anim {\n  0% {\n    width: 0;\n    opacity: 0.1;\n  }\n  20% {\n    width: 0;\n    opacity: 0.5;\n  }\n  to {\n    width: 100%;\n    opacity: 0;\n  }\n}\n.react-sweet-progress-circle path {\n  stroke-linecap: round;\n}\n\n/* Slider */\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.slick-slider-sm .slick-slider {\n  max-width: 450px;\n}\n.slick-slider-sm .slick-slider .slick-prev {\n  left: -20px;\n}\n.slick-slider-sm .slick-slider .slick-next {\n  right: -20px;\n}\n\n.slick-slider-md .slick-slider {\n  max-width: 650px;\n  margin: 0 auto;\n}\n\n.slick-slider-hover .slick-arrow {\n  opacity: 0;\n  background: #545cd8;\n  color: #fff !important;\n}\n.slick-slider-hover .slick-prev {\n  left: -30px;\n}\n.slick-slider-hover .slick-next {\n  right: -30px;\n}\n.slick-slider-hover:hover .slick-arrow {\n  opacity: 1;\n}\n\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.slick-list:focus {\n  outline: none;\n}\n.slick-list.dragging {\n  cursor: pointer;\n  cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.slick-track:before, .slick-track:after {\n  content: \"\";\n  display: table;\n}\n.slick-track:after {\n  clear: both;\n}\n.slick-loading .slick-track {\n  visibility: hidden;\n}\n\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n}\n[dir=rtl] .slick-slide {\n  float: right;\n}\n.slick-slide img {\n  display: block;\n}\n.slick-slide.slick-loading img {\n  display: none;\n}\n.slick-slide {\n  display: none;\n}\n.slick-slide.dragging img {\n  pointer-events: none;\n}\n.slick-initialized .slick-slide {\n  display: block;\n}\n.slick-loading .slick-slide {\n  visibility: hidden;\n}\n.slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n\n.slick-arrow.slick-hidden {\n  display: none;\n}\n\n/* Arrows */\n.slick-prev,\n.slick-next {\n  position: absolute;\n  display: block;\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n  color: #6c757d;\n  top: 50%;\n  transform: translate(0, -80%);\n  padding: 0;\n  border: none;\n  outline: none;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n  transition: all 0.2s;\n  font-family: \"Pe-icon-7-stroke\";\n  border-radius: 50px;\n  background: #fff;\n  z-index: 6;\n  overflow: hidden;\n}\n.slick-prev::before,\n.slick-next::before {\n  font-size: 35px;\n  height: 40px;\n  line-height: 40px;\n  width: 40px;\n}\n.slick-prev:hover, .slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus {\n  outline: none;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  color: #545cd8;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before {\n  opacity: 0.25;\n}\n\n.slick-prev {\n  left: 0;\n}\n.slick-prev:before {\n  content: \"\\e686\";\n}\n\n.slick-next {\n  right: 0;\n}\n.slick-next:before {\n  content: \"\\e684\";\n}\n\n/* Dots */\n.slick-dots {\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  margin: 0.75rem 0 0;\n  width: 100%;\n}\n.slick-dots li {\n  position: relative;\n  display: inline-block;\n  padding: 0;\n  margin: 0 5px;\n  cursor: pointer;\n  transform: scale(0.8);\n  transition: all 0.2s;\n}\n.slick-dots li button {\n  border: 0;\n  background: transparent;\n  display: block;\n  height: 14px;\n  width: 14px;\n  background: #545cd8;\n  cursor: pointer;\n  position: relative;\n  border-radius: 20px;\n  color: transparent;\n}\n.slick-dots li button::before {\n  content: \"\";\n  position: absolute;\n  background: #fff;\n  left: 50%;\n  top: 50%;\n  margin: -4px 0 0 -4px;\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 20px;\n}\n.slick-dots li.slick-active {\n  transform: scale(1.2);\n}\n\n.slick-center {\n  transform: scale(1.1);\n}\n\n.slick-slider .slide-img-bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  opacity: 0.4;\n  z-index: 10;\n}\n.slick-slider .slider-content {\n  position: relative;\n  z-index: 15;\n  text-align: center;\n  margin: 0 6rem;\n}\n.slick-slider .slider-content h3 {\n  font-size: 1.75rem;\n  font-weight: normal;\n  margin-bottom: 1.5rem;\n}\n.slick-slider .slider-content p {\n  font-size: 1rem;\n  opacity: 0.7;\n}\n\n.slider-light .slick-dots {\n  position: absolute;\n  bottom: 10px;\n}\n.slider-light .slick-dots li button {\n  background: rgba(255, 255, 255, 0.25);\n}\n.slider-light .slick-prev,\n.slider-light .slick-next {\n  background: transparent;\n  color: #fff;\n  box-shadow: 0 0 0 0 transparent;\n}\n.slider-light .slick-prev:hover,\n.slider-light .slick-next:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n.slider-light .slick-next {\n  right: 15px;\n}\n.slider-light .slick-prev {\n  left: 15px;\n}\n.slider-light .slider-content {\n  color: #fff;\n}\n\n.loading-indicator {\n  text-align: center;\n}\n\n.loading-bullet {\n  display: inline-block;\n  opacity: 0;\n  font-size: 2em;\n  color: #02a17c;\n}\n\n.block-ui {\n  position: relative;\n  min-height: 8em;\n}\n\n.block-ui-container {\n  position: absolute;\n  z-index: 1010;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  min-height: 2em;\n  cursor: wait;\n  overflow: hidden;\n}\n\n.block-ui-container:focus {\n  outline: none;\n}\n\n.block-ui-overlay {\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  background-color: white;\n}\n\n.block-ui-message-container {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  right: 0;\n  text-align: center;\n  transform: translateY(-50%);\n  z-index: 10001;\n}\n\n.block-ui-message {\n  color: #333;\n  background: none;\n  z-index: 1011;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.block-overlay-dark .block-ui-overlay {\n  background: rgb(0, 0, 0);\n}\n\n.popover {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n.popover .grid-menu {\n  margin-bottom: -0.5rem;\n  padding: 1px;\n}\n.popover .grid-menu [class*=col-] {\n  padding: 0.5rem;\n}\n.popover .grid-menu + .nav .nav-item-btn {\n  margin-bottom: 0.5rem;\n}\n.popover .grid-menu-xl {\n  margin-bottom: -0.3703703704rem;\n}\n.popover .grid-menu-xl [class*=col-] {\n  padding: 0;\n}\n.popover .popover-inner .dropdown-menu-header {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n  margin-top: -1px;\n  margin-left: -1px;\n  margin-right: -1px;\n}\n\n.rm-max-width > .popover {\n  max-width: initial;\n}\n\n.rm-pointers > .popover .arrow {\n  display: none !important;\n}\n\n.popover-primary {\n  background-color: #545cd8 !important;\n}\n\n.popover-secondary {\n  background-color: #6c757d !important;\n}\n\n.popover-success {\n  background-color: #3ac47d !important;\n}\n\n.popover-info {\n  background-color: #30b1ff !important;\n}\n\n.popover-warning {\n  background-color: #f7b924 !important;\n}\n\n.popover-danger {\n  background-color: #d92550 !important;\n}\n\n.popover-light {\n  background-color: #eeeeee !important;\n}\n\n.popover-dark {\n  background-color: #343a40 !important;\n}\n\n.popover-focus {\n  background-color: #444054 !important;\n}\n\n.popover-alternate {\n  background-color: #83588a !important;\n}\n\n.popover-custom .popover-body {\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n.popover-custom .popover-body .dropdown-menu-header {\n  margin-top: 0;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n}\n.popover-custom .popover-body .dropdown-menu-header .menu-header-content {\n  padding: 0 1.5rem;\n}\n.popover-custom .popover-body .dropdown-menu-header .dropdown-menu-header-inner.bg-light {\n  color: rgba(0, 0, 0, 0.8);\n}\n.popover-custom.popover-custom-lg {\n  min-width: 22rem;\n}\n.popover-custom.popover-custom-xl {\n  min-width: 25rem;\n}\n.popover-custom.popover-custom-sm {\n  min-width: 15rem;\n}\n\n.popover-bg {\n  border: 0;\n}\n.popover-bg .arrow {\n  display: none;\n}\n.popover-bg .popover-header {\n  background: rgba(255, 255, 255, 0.1);\n  border-bottom: 0;\n  color: rgb(255, 255, 255);\n}\n.popover-bg .popover-header::before {\n  display: none;\n}\n.popover-bg .popover-body {\n  color: rgba(255, 255, 255, 0.7);\n}\n.popover-bg.text-dark .popover-header {\n  color: rgba(0, 0, 0, 0.8);\n}\n.popover-bg.text-dark .popover-body {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.tooltip-light > .tooltip .tooltip-inner {\n  background: #fff;\n  color: #343a40;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n  border: rgba(12.5630252101%, 15.1400560224%, 55.0840336134%, 0.125) solid 1px;\n}\n.tooltip-light > .tooltip .arrow {\n  display: none;\n}\n\n.scrollable-block {\n  margin-bottom: 50px;\n  overflow: hidden;\n  position: relative;\n}\n.scrollable-block .sticky {\n  z-index: 2;\n}\n\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 1 1;\n  min-height: 580px;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n\n.rbc-abs-full, .rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rbc-rtl {\n  direction: rtl;\n}\n\n.rbc-off-range {\n  color: rgb(70%, 70%, 70%);\n}\n\n.rbc-header {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  flex: 1 0;\n  flex-basis: auto !important;\n}\n.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-content {\n  position: relative;\n  user-select: none;\n  z-index: 4;\n}\n\n.rbc-today {\n  background-color: #e0f3ff;\n}\n\n.rbc-toolbar {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  width: 100%;\n  padding: 0 10px;\n  text-align: center;\n}\n.rbc-toolbar button {\n  color: #fff;\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  vertical-align: middle;\n  background: #545cd8;\n  border: 1px solid #545cd8;\n  padding: 0.375rem 1rem;\n  border-radius: 0.25rem;\n  line-height: normal;\n  white-space: nowrap;\n  font-weight: bold;\n  text-transform: capitalize;\n  font-size: 0.88rem;\n}\n.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {\n  background-image: none;\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n  border-color: rgb(17.3915966387%, 20.9591036415%, 76.2554621849%);\n}\n.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {\n  color: #fff;\n  background-color: rgb(15.5344537815%, 18.7210084034%, 68.112605042%);\n  border-color: rgb(12.5630252101%, 15.1400560224%, 55.0840336134%);\n}\n.rbc-toolbar button:focus {\n  color: #fff;\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n  border-color: rgb(17.3915966387%, 20.9591036415%, 76.2554621849%);\n}\n.rbc-toolbar button:hover {\n  color: #fff;\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n  border-color: rgb(17.3915966387%, 20.9591036415%, 76.2554621849%);\n}\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n.rbc-btn-group > button:first-child:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 4px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n.rbc-event {\n  cursor: pointer;\n  padding: 0.125rem;\n  background-color: #545cd8;\n  border-radius: 0.25rem;\n  color: #fff;\n}\n.rbc-event.rbc-selected {\n  background-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n}\n\n.rbc-event-label {\n  font-size: 80%;\n}\n\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #e9ecef;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  width: 100%;\n  user-select: none;\n  height: 100%;\n}\n.rbc-month-view .rbc-header {\n  border-bottom: 1px solid #e9ecef;\n}\n.rbc-month-view .rbc-header + .rbc-header {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-month-view .rbc-header + .rbc-header {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n\n.rbc-month-header {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #e9ecef;\n}\n\n.rbc-date-cell {\n  padding-right: 5px;\n  text-align: right;\n  flex: 1 1;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-bg {\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n\n.rbc-day-bg {\n  flex: 1 0;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n\n.rbc-off-range-bg {\n  background: #f8f9fa;\n}\n\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n\n.rbc-agenda-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table {\n  width: 100%;\n  border: 1px solid #e9ecef;\n}\n.rbc-agenda-view table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table tbody > tr > td + td {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-agenda-view table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n.rbc-agenda-view table tbody > tr + tr {\n  border-top: 1px solid #e9ecef;\n}\n.rbc-agenda-view table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-agenda-view table thead > tr > th {\n  text-align: right;\n}\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: \" »\";\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: \"« \";\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n\n.rbc-time-column {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  flex: 1;\n}\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid #e9ecef;\n  min-height: 40px;\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  flex: none;\n}\n\n.rbc-label {\n  padding: 0 5px;\n}\n\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-event {\n  border: 1px solid rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n  display: flex;\n  max-height: 100%;\n  flex-flow: column wrap;\n  align-items: flex-start;\n  overflow: hidden;\n}\n.rbc-day-slot .rbc-event-label {\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid white;\n}\n\n.rbc-time-slot {\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n\n.rbc-day-header {\n  text-align: center;\n}\n\n.rbc-day-slot .rbc-event {\n  position: absolute;\n  z-index: 2;\n}\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  cursor: default;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #white;\n  font-size: 75%;\n  padding: 3px;\n}\n\n.rbc-time-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #e9ecef;\n  min-height: 0;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n.rbc-time-view .rbc-allday-cell {\n  width: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  min-height: 20px;\n}\n\n.rbc-time-header {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #e9ecef;\n}\n.rbc-time-header > .rbc-row > * + * {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-time-header > .rbc-row > * + * {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #e9ecef;\n}\n.rbc-time-header .rbc-gutter-cell {\n  flex: none;\n}\n.rbc-time-header > .rbc-gutter-cell + * {\n  width: 100%;\n}\n\n.rbc-time-content {\n  display: flex;\n  flex: 1 0 0%;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #e9ecef;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  user-select: none;\n}\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  height: 1px;\n  background-color: #3ac47d;\n  pointer-events: none;\n}\n.rbc-current-time-indicator::before {\n  display: block;\n  position: absolute;\n  left: -3px;\n  top: -3px;\n  content: \" \";\n  background-color: #3ac47d;\n  border-radius: 50%;\n  width: 8px;\n  height: 8px;\n}\n.rbc-rtl .rbc-current-time-indicator::before {\n  left: 0;\n  right: -3px;\n}\n\n.handle-bar {\n  background: transparent !important;\n  border-radius: 30px;\n}\n.handle-bar:active, .handle-bar:hover, .handle-bar.handle-bar_clone {\n  background-color: #e9ecef !important;\n}\n.handle-bar.resize-not-allowed:hover {\n  background-color: #e9ecef;\n}\n.handle-bar .handle-bar_drag {\n  border-color: #545cd8 !important;\n}\n\n/**\n * Extra class applied to VirtualScroll through className prop\n */\n.rst__virtualScrollOverride {\n  overflow: auto !important;\n}\n\n.ReactVirtualized__Grid__innerScrollContainer {\n  overflow: visible !important;\n}\n\n.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {\n  direction: rtl;\n}\n\n.ReactVirtualized__Grid {\n  outline: none;\n}\n\n.rst__node {\n  min-width: 100%;\n  white-space: nowrap;\n  position: relative;\n  text-align: left;\n}\n\n.rst__node.rst__rtl {\n  text-align: right;\n}\n\n.rst__nodeContent {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n/* ==========================================================================\n   Scaffold\n\n    Line-overlaid blocks used for showing the tree structure\n   ========================================================================== */\n.rst__lineBlock,\n.rst__absoluteLineBlock {\n  height: 100%;\n  position: relative;\n  display: inline-block;\n}\n\n.rst__absoluteLineBlock {\n  position: absolute;\n  top: 0;\n}\n\n.rst__lineHalfHorizontalRight::before,\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  position: absolute;\n  content: \"\";\n  background-color: black;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |     |\n * +-----+\n */\n.rst__lineHalfHorizontalRight::before {\n  height: 1px;\n  top: 50%;\n  right: 0;\n  width: 50%;\n}\n\n.rst__rtl.rst__lineHalfHorizontalRight::before {\n  left: 0;\n  right: initial;\n}\n\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  width: 1px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__lineFullVertical::after,\n.rst__rtl.rst__lineHalfVerticalTop::after,\n.rst__rtl.rst__lineHalfVerticalBottom::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__lineHalfVerticalTop::after {\n  height: 50%;\n}\n\n.rst__lineHalfVerticalBottom::after {\n  top: auto;\n  bottom: 0;\n  height: 50%;\n}\n\n/* Highlight line for pointing to dragged row destination\n   ========================================================================== */\n.rst__highlightLineVertical {\n  z-index: 3;\n}\n\n.rst__highlightLineVertical::before {\n  position: absolute;\n  content: \"\";\n  background-color: #545cd8;\n  width: 8px;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__highlightLineVertical::before {\n  margin-left: initial;\n  margin-right: -4px;\n  left: initial;\n  right: 50%;\n}\n\n@keyframes arrow-pulse {\n  0% {\n    transform: translate(0, 0);\n    opacity: 0;\n  }\n  30% {\n    transform: translate(0, 300%);\n    opacity: 1;\n  }\n  70% {\n    transform: translate(0, 700%);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(0, 1000%);\n    opacity: 0;\n  }\n}\n.rst__highlightLineVertical::after {\n  content: \"\";\n  position: absolute;\n  height: 0;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid white;\n  animation: arrow-pulse 1s infinite linear both;\n}\n\n.rst__rtl.rst__highlightLineVertical::after {\n  margin-left: initial;\n  margin-right: -4px;\n  right: 50%;\n  left: initial;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |  |  |\n * +--+--+\n */\n.rst__highlightTopLeftCorner::before {\n  z-index: 3;\n  content: \"\";\n  position: absolute;\n  border-top: solid 8px #545cd8;\n  border-left: solid 8px #545cd8;\n  box-sizing: border-box;\n  height: calc(50% + 4px);\n  top: 50%;\n  margin-top: -4px;\n  right: 0;\n  width: calc(50% + 4px);\n}\n\n.rst__rtl.rst__highlightTopLeftCorner::before {\n  border-right: solid 8px #545cd8;\n  border-left: none;\n  left: 0;\n  right: initial;\n}\n\n/**\n * +--+--+\n * |  |  |\n * |  |  |\n * |  +->|\n * +-----+\n */\n.rst__highlightBottomLeftCorner {\n  z-index: 3;\n}\n\n.rst__highlightBottomLeftCorner::before {\n  content: \"\";\n  position: absolute;\n  border-bottom: solid 8px #545cd8;\n  border-left: solid 8px #545cd8;\n  box-sizing: border-box;\n  height: calc(100% + 4px);\n  top: 0;\n  right: 12px;\n  width: calc(50% - 8px);\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::before {\n  border-right: solid 8px #545cd8;\n  border-left: none;\n  left: 12px;\n  right: initial;\n}\n\n.rst__highlightBottomLeftCorner::after {\n  content: \"\";\n  position: absolute;\n  height: 0;\n  right: 0;\n  top: 100%;\n  margin-top: -12px;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid #545cd8;\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::after {\n  left: 0;\n  right: initial;\n  border-right: 12px solid #545cd8;\n  border-left: none;\n}\n\n.rst__rowWrapper {\n  padding: 10px 10px 10px 0;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.rst__rtl.rst__rowWrapper {\n  padding: 10px 0 10px 10px;\n}\n\n.rst__row {\n  height: 100%;\n  white-space: nowrap;\n  display: flex;\n}\n\n.rst__row > * {\n  box-sizing: border-box;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__rowLandingPad,\n.rst__rowCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.rst__rowLandingPad > *,\n.rst__rowCancelPad > * {\n  opacity: 0 !important;\n}\n\n.rst__rowLandingPad::before,\n.rst__rowCancelPad::before {\n  background-color: lightblue;\n  border: 1px dashed #fff;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__rowCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/**\n * Nodes matching the search conditions are highlighted\n */\n.rst__rowSearchMatch {\n  outline: solid 3px #0080ff;\n}\n\n/**\n * The node that matches the search conditions and is currently focused\n */\n.rst__rowSearchFocus {\n  outline: solid 3px #fc6421;\n}\n\n.rst__rowContents,\n.rst__rowLabel,\n.rst__rowToolbar,\n.rst__moveHandle,\n.rst__toolbarButton {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.rst__rowContents {\n  position: relative;\n  height: 100%;\n  border: solid #dee2e6 1px;\n  border-left: none;\n  padding: 0 5px 0 10px;\n  border-radius: 2px;\n  min-width: 230px;\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: white;\n}\n\n.rst__rtl.rst__rowContents {\n  border-right: none;\n  border-left: solid #dee2e6 1px;\n  padding: 0 10px 0 5px;\n}\n\n.rst__rowContentsDragDisabled {\n  border-left: solid #dee2e6 1px;\n}\n\n.rst__rtl.rst__rowContentsDragDisabled {\n  border-right: solid #dee2e6 1px;\n  border-left: solid #dee2e6 1px;\n}\n\n.rst__rowLabel {\n  flex: 0 1 auto;\n  padding-right: 20px;\n}\n\n.rst__rtl.rst__rowLabel {\n  padding-left: 20px;\n  padding-right: inherit;\n}\n\n.rst__rowToolbar {\n  flex: 0 1 auto;\n  display: flex;\n}\n\n.rst__moveHandle,\n.rst__loadingHandle {\n  height: 100%;\n  width: 44px;\n  background: #e9ecef url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+\") no-repeat center;\n  border: solid #aaa 1px;\n  cursor: move;\n  border-radius: 1px;\n  z-index: 1;\n}\n\n.rst__loadingHandle {\n  cursor: default;\n  background: #e9ecef;\n}\n\n@keyframes pointFade {\n  0%, 19.999%, 100% {\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n}\n.rst__loadingCircle {\n  width: 80%;\n  height: 80%;\n  margin: 10%;\n  position: relative;\n}\n\n.rst__loadingCirclePoint {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.rst__rtl.rst__loadingCirclePoint {\n  right: 0;\n  left: initial;\n}\n\n.rst__loadingCirclePoint::before {\n  content: \"\";\n  display: block;\n  margin: 0 auto;\n  width: 11%;\n  height: 30%;\n  background-color: #fff;\n  border-radius: 30%;\n  animation: pointFade 800ms infinite ease-in-out both;\n}\n\n.rst__loadingCirclePoint:nth-of-type(1) {\n  transform: rotate(0deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(1)::before,\n.rst__loadingCirclePoint:nth-of-type(7)::before {\n  animation-delay: -800ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(2) {\n  transform: rotate(30deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(8) {\n  transform: rotate(210deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(2)::before,\n.rst__loadingCirclePoint:nth-of-type(8)::before {\n  animation-delay: -666ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(3) {\n  transform: rotate(60deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(9) {\n  transform: rotate(240deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(3)::before,\n.rst__loadingCirclePoint:nth-of-type(9)::before {\n  animation-delay: -533ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(4) {\n  transform: rotate(90deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(10) {\n  transform: rotate(270deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(4)::before,\n.rst__loadingCirclePoint:nth-of-type(10)::before {\n  animation-delay: -400ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(5) {\n  transform: rotate(120deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(11) {\n  transform: rotate(300deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(5)::before,\n.rst__loadingCirclePoint:nth-of-type(11)::before {\n  animation-delay: -266ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(6) {\n  transform: rotate(150deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(12) {\n  transform: rotate(330deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(6)::before,\n.rst__loadingCirclePoint:nth-of-type(12)::before {\n  animation-delay: -133ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(13) {\n  transform: rotate(360deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(7)::before,\n.rst__loadingCirclePoint:nth-of-type(13)::before {\n  animation-delay: 0ms;\n}\n\n.rst__rowTitle {\n  font-weight: bold;\n}\n\n.rst__rowTitleWithSubtitle {\n  font-size: 85%;\n  display: block;\n  height: 0.8rem;\n}\n\n.rst__rowSubtitle {\n  font-size: 70%;\n  line-height: 1;\n}\n\n.rst__collapseButton,\n.rst__expandButton {\n  appearance: none;\n  border: none;\n  position: absolute;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px #000;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n\n.rst__rtl.rst__collapseButton,\n.rst__rtl.rst__expandButton {\n  transform: translate(50%, -50%);\n}\n\n.rst__collapseButton:focus,\n.rst__expandButton:focus {\n  outline: none;\n  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;\n}\n\n.rst__collapseButton:hover:not(:active),\n.rst__expandButton:hover:not(:active) {\n  background-size: 24px;\n  height: 20px;\n  width: 20px;\n}\n\n.rst__collapseButton {\n  background: #fff url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==\") no-repeat center;\n}\n\n.rst__expandButton {\n  background: #fff url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+\") no-repeat center;\n}\n\n/**\n * Line for under a node with children\n */\n.rst__lineChildren {\n  height: 100%;\n  display: inline-block;\n  position: absolute;\n}\n\n.rst__lineChildren::after {\n  content: \"\";\n  position: absolute;\n  background-color: black;\n  width: 1px;\n  left: 50%;\n  bottom: 0;\n  height: 10px;\n}\n\n.rst__rtl.rst__lineChildren::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__placeholder {\n  position: relative;\n  height: 68px;\n  max-width: 300px;\n  padding: 10px;\n}\n\n.rst__placeholder,\n.rst__placeholder > * {\n  box-sizing: border-box;\n}\n\n.rst__placeholder::before {\n  border: 3px dashed #e9ecef;\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  z-index: -1;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__placeholderLandingPad,\n.rst__placeholderCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.rst__placeholderLandingPad *,\n.rst__placeholderCancelPad * {\n  opacity: 0 !important;\n}\n\n.rst__placeholderLandingPad::before,\n.rst__placeholderCancelPad::before {\n  background-color: lightblue;\n  border-color: white;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__placeholderCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/* Collection default theme */\n/* Grid default theme */\n/* Table default theme */\n.ReactVirtualized__Table__headerRow {\n  font-weight: 700;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__headerTruncatedText {\n  display: inline-block;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ReactVirtualized__Table__headerColumn,\n.ReactVirtualized__Table__rowColumn {\n  margin-right: 10px;\n  min-width: 0px;\n}\n\n.ReactVirtualized__Table__rowColumn {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ReactVirtualized__Table__headerColumn:first-of-type,\n.ReactVirtualized__Table__rowColumn:first-of-type {\n  margin-left: 10px;\n}\n\n.ReactVirtualized__Table__sortableHeaderColumn {\n  cursor: pointer;\n}\n\n.ReactVirtualized__Table__sortableHeaderIconContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__sortableHeaderIcon {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 24px;\n  flex: 0 0 24px;\n  height: 1em;\n  width: 1em;\n  fill: currentColor;\n}\n\n/* List default theme */\n.ReactTable {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.ReactTable .rt-table {\n  flex: auto 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  border-collapse: collapse;\n  overflow: auto;\n}\n.ReactTable .-pagination input,\n.ReactTable .-pagination select,\n.ReactTable .rt-thead.-filters input,\n.ReactTable .rt-thead.-filters select {\n  display: block;\n  width: 100%;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n}\n.ReactTable .-pagination input::-ms-expand,\n.ReactTable .-pagination select::-ms-expand,\n.ReactTable .rt-thead.-filters input::-ms-expand,\n.ReactTable .rt-thead.-filters select::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.ReactTable .-pagination input:focus,\n.ReactTable .-pagination select:focus,\n.ReactTable .rt-thead.-filters input:focus,\n.ReactTable .rt-thead.-filters select:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: rgb(73.6554621849%, 74.8879551821%, 93.9915966387%);\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.ReactTable .-pagination input::placeholder,\n.ReactTable .-pagination select::placeholder,\n.ReactTable .rt-thead.-filters input::placeholder,\n.ReactTable .rt-thead.-filters select::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.ReactTable .-pagination input:disabled, .ReactTable .-pagination input[readonly],\n.ReactTable .-pagination select:disabled,\n.ReactTable .-pagination select[readonly],\n.ReactTable .rt-thead.-filters input:disabled,\n.ReactTable .rt-thead.-filters input[readonly],\n.ReactTable .rt-thead.-filters select:disabled,\n.ReactTable .rt-thead.-filters select[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.ReactTable .rt-thead {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n}\n.ReactTable .rt-thead.-headerGroups {\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid #e9ecef;\n}\n.ReactTable .rt-thead.-headerGroups .rt-th,\n.ReactTable .rt-thead.-headerGroups .rt-td {\n  padding: 0.3rem;\n  color: #6c757d;\n}\n.ReactTable .rt-thead.-headerGroups .rt-th:hover,\n.ReactTable .rt-thead.-headerGroups .rt-td:hover {\n  color: #6c757d;\n}\n.ReactTable .rt-thead.-headerGroups .rt-th:empty,\n.ReactTable .rt-thead.-headerGroups .rt-td:empty {\n  padding: 0;\n}\n.ReactTable .rt-thead.-filters {\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n.ReactTable .rt-thead.-filters .rt-th {\n  border-right: 1px solid #e9ecef;\n}\n.ReactTable .rt-thead.-filters.-header {\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);\n}\n.ReactTable .rt-thead .rt-tr {\n  text-align: center;\n}\n.ReactTable .rt-thead .rt-th,\n.ReactTable .rt-thead .rt-td {\n  padding: 0.55rem;\n  line-height: normal;\n  position: relative;\n  font-weight: bold;\n  border-right: 1px solid #e9ecef;\n  border-bottom: 1px solid #e9ecef;\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-shadow: inset 0 0 0 0 transparent;\n  color: #545cd8;\n}\n.ReactTable .rt-thead .rt-th:hover,\n.ReactTable .rt-thead .rt-td:hover {\n  color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);\n}\n.ReactTable .rt-thead .rt-th.-sort-asc,\n.ReactTable .rt-thead .rt-td.-sort-asc {\n  box-shadow: inset 0 3px 0 0 #545cd8;\n}\n.ReactTable .rt-thead .rt-th.-sort-desc,\n.ReactTable .rt-thead .rt-td.-sort-desc {\n  box-shadow: inset 0 -3px 0 0 #545cd8;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\n  cursor: pointer;\n}\n.ReactTable .rt-thead .rt-th:last-child,\n.ReactTable .rt-thead .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-thead .rt-resizable-header {\n  overflow: visible;\n}\n.ReactTable .rt-thead .rt-resizable-header:last-child {\n  overflow: hidden;\n}\n.ReactTable .rt-thead .rt-resizable-header-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ReactTable .rt-thead .rt-header-pivot {\n  border-right-color: #f7f7f7;\n}\n.ReactTable .rt-thead .rt-header-pivot:after,\n.ReactTable .rt-thead .rt-header-pivot:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.ReactTable .rt-thead .rt-header-pivot:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-left-color: #fff;\n  border-width: 8px;\n  margin-top: -8px;\n}\n.ReactTable .rt-thead .rt-header-pivot:before {\n  border-color: rgba(102, 102, 102, 0);\n  border-left-color: #f7f7f7;\n  border-width: 10px;\n  margin-top: -10px;\n}\n.ReactTable .rt-tbody {\n  flex: 99999 1 auto;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n.ReactTable .rt-tbody .rt-tr-group {\n  border-bottom: solid 1px #e9ecef;\n}\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n  border-bottom: 0;\n}\n.ReactTable .rt-tbody .rt-td {\n  border-right: 1px solid #e9ecef;\n  align-items: center;\n  align-content: center;\n  display: flex;\n}\n.ReactTable .rt-tbody .rt-td [contenteditable=true] {\n  width: 100%;\n  border: 1px solid transparent;\n  background: #fff !important;\n  border-radius: 0.2rem;\n}\n.ReactTable .rt-tbody .rt-td [contenteditable=true]:focus {\n  padding: 3px 5px;\n  border-color: rgb(73.6554621849%, 74.8879551821%, 93.9915966387%);\n  outline: none;\n}\n.ReactTable .rt-tbody .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-tbody .rt-expandable {\n  cursor: pointer;\n  text-overflow: clip;\n}\n.ReactTable .rt-tr-group {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.ReactTable .rt-tr {\n  flex: 1 0 auto;\n  display: inline-flex;\n}\n.ReactTable .rt-th,\n.ReactTable .rt-td {\n  flex: 1 0 0;\n  text-overflow: ellipsis;\n  padding: 0.55rem;\n  transition: 0.3s ease;\n  transition-property: width, min-width, padding, opacity;\n}\n.ReactTable .rt-th.-hidden,\n.ReactTable .rt-td.-hidden {\n  width: 0 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  opacity: 0 !important;\n}\n.ReactTable .rt-expander {\n  display: inline-block;\n  position: relative;\n  color: transparent;\n  margin: 0 10px 0 0;\n}\n.ReactTable .rt-expander:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) rotate(-90deg);\n  border-left: 5.04px solid transparent;\n  border-right: 5.04px solid transparent;\n  border-top: 7px solid rgba(0, 0, 0, 0.8);\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n}\n.ReactTable .rt-expander.-open:after {\n  transform: translate(-50%, -50%) rotate(0);\n}\n.ReactTable .rt-resizer {\n  display: inline-block;\n  position: absolute;\n  width: 36px;\n  top: 0;\n  bottom: 0;\n  right: -18px;\n  cursor: col-resize;\n  z-index: 10;\n}\n.ReactTable .rt-tfoot {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n.ReactTable .rt-tfoot .rt-td {\n  border-right: 1px solid #e9ecef;\n}\n.ReactTable .rt-tfoot .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable.-striped .rt-tr.-odd {\n  background: rgba(0, 0, 0, 0.03);\n}\n.ReactTable.-fixed .-header {\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);\n}\n.ReactTable.-fixed .pagination-bottom {\n  box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);\n}\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n  background: #e0f3ff;\n}\n.ReactTable .-pagination {\n  z-index: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  flex-wrap: wrap;\n  padding: 3px;\n  border-top: 2px solid rgba(0, 0, 0, 0.1);\n}\n.ReactTable .-pagination .-btn {\n  appearance: none;\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 0.25rem;\n  padding: 6px;\n  font-size: 1em;\n  color: #545cd8;\n  background: #f8f9fa;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  outline: none;\n  font-weight: bold;\n}\n.ReactTable .-pagination .-btn[disabled] {\n  opacity: 0.5;\n  cursor: default;\n}\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n  background: #545cd8;\n  color: #fff;\n}\n.ReactTable .-pagination .-previous,\n.ReactTable .-pagination .-next {\n  flex: 1;\n  text-align: center;\n}\n.ReactTable .-pagination .-center {\n  text-align: center;\n  margin-bottom: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-around;\n}\n.ReactTable .-pagination .-totalPages {\n  padding-left: 5px;\n  font-weight: bold;\n}\n.ReactTable .-pagination .-pageInfo {\n  display: inherit;\n  margin: 3px 0 3px 10px;\n  white-space: nowrap;\n  height: 30px;\n  line-height: 30px;\n}\n.ReactTable .-pagination .-pageJump {\n  display: inline-block;\n  margin: 0 5px;\n}\n.ReactTable .-pagination .-pageJump input {\n  width: 70px;\n  text-align: center;\n}\n.ReactTable .-pagination .-pageSizeOptions {\n  margin: 3px 10px;\n}\n.ReactTable .rt-noData {\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: 1;\n  pointer-events: none;\n  padding: 20px;\n  color: rgba(0, 0, 0, 0.5);\n}\n.ReactTable .-loading {\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none;\n}\n.ReactTable .-loading > div {\n  position: absolute;\n  display: block;\n  text-align: center;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  font-size: 15px;\n  color: #545cd8;\n  transform: translateY(-52%);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n.ReactTable .-loading.-active {\n  opacity: 1;\n  z-index: 2;\n  pointer-events: all;\n}\n.ReactTable .-loading.-active > div {\n  transform: translateY(50%);\n}\n.ReactTable .rt-resizing .rt-th,\n.ReactTable .rt-resizing .rt-td {\n  transition: none !important;\n  cursor: col-resize;\n  user-select: none;\n}\n\n.table thead th,\n.table td {\n  vertical-align: middle;\n}\n\n.table th .filter {\n  margin-top: 0.375rem;\n  height: auto;\n  padding: 0.3rem 0.5rem;\n}\n\n.caret-4-asc,\n.caret-4-desc {\n  font-family: \"Linearicons-Free\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  margin-left: 0.375rem;\n}\n\n.table .sortable:hover .caret-4-asc,\n.table .sortable:hover .caret-4-desc {\n  color: #545cd8;\n}\n\n.table-lg th,\n.table-lg td {\n  padding: 1.1rem 0.825rem;\n}\n\n@font-face {\n  font-family: \"Linearicons-Free\";\n  src: url(\"components/icons/linearicons/Linearicons-Free.eot?w118d\");\n  src: url(\"components/icons/linearicons/Linearicons-Free.eot?#iefixw118d\") format(\"embedded-opentype\"), url(\"components/icons/linearicons/Linearicons-Free.woff2?w118d\") format(\"woff2\"), url(\"components/icons/linearicons/Linearicons-Free.woff?w118d\") format(\"woff\"), url(\"components/icons/linearicons/Linearicons-Free.ttf?w118d\") format(\"truetype\"), url(\"components/icons/linearicons/Linearicons-Free.svg?w118d#Linearicons-Free\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=lnr-],\n[class*=\" lnr-\"] {\n  font-family: \"Linearicons-Free\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.lnr-home:before {\n  content: \"\\e800\";\n}\n\n.lnr-apartment:before {\n  content: \"\\e801\";\n}\n\n.lnr-pencil:before {\n  content: \"\\e802\";\n}\n\n.lnr-magic-wand:before {\n  content: \"\\e803\";\n}\n\n.lnr-drop:before {\n  content: \"\\e804\";\n}\n\n.lnr-lighter:before {\n  content: \"\\e805\";\n}\n\n.lnr-poop:before {\n  content: \"\\e806\";\n}\n\n.lnr-sun:before {\n  content: \"\\e807\";\n}\n\n.lnr-moon:before {\n  content: \"\\e808\";\n}\n\n.lnr-cloud:before {\n  content: \"\\e809\";\n}\n\n.lnr-cloud-upload:before {\n  content: \"\\e80a\";\n}\n\n.lnr-cloud-download:before {\n  content: \"\\e80b\";\n}\n\n.lnr-cloud-sync:before {\n  content: \"\\e80c\";\n}\n\n.lnr-cloud-check:before {\n  content: \"\\e80d\";\n}\n\n.lnr-database:before {\n  content: \"\\e80e\";\n}\n\n.lnr-lock:before {\n  content: \"\\e80f\";\n}\n\n.lnr-cog:before {\n  content: \"\\e810\";\n}\n\n.lnr-trash:before {\n  content: \"\\e811\";\n}\n\n.lnr-dice:before {\n  content: \"\\e812\";\n}\n\n.lnr-heart:before {\n  content: \"\\e813\";\n}\n\n.lnr-star:before {\n  content: \"\\e814\";\n}\n\n.lnr-star-half:before {\n  content: \"\\e815\";\n}\n\n.lnr-star-empty:before {\n  content: \"\\e816\";\n}\n\n.lnr-flag:before {\n  content: \"\\e817\";\n}\n\n.lnr-envelope:before {\n  content: \"\\e818\";\n}\n\n.lnr-paperclip:before {\n  content: \"\\e819\";\n}\n\n.lnr-inbox:before {\n  content: \"\\e81a\";\n}\n\n.lnr-eye:before {\n  content: \"\\e81b\";\n}\n\n.lnr-printer:before {\n  content: \"\\e81c\";\n}\n\n.lnr-file-empty:before {\n  content: \"\\e81d\";\n}\n\n.lnr-file-add:before {\n  content: \"\\e81e\";\n}\n\n.lnr-enter:before {\n  content: \"\\e81f\";\n}\n\n.lnr-exit:before {\n  content: \"\\e820\";\n}\n\n.lnr-graduation-hat:before {\n  content: \"\\e821\";\n}\n\n.lnr-license:before {\n  content: \"\\e822\";\n}\n\n.lnr-music-note:before {\n  content: \"\\e823\";\n}\n\n.lnr-film-play:before {\n  content: \"\\e824\";\n}\n\n.lnr-camera-video:before {\n  content: \"\\e825\";\n}\n\n.lnr-camera:before {\n  content: \"\\e826\";\n}\n\n.lnr-picture:before {\n  content: \"\\e827\";\n}\n\n.lnr-book:before {\n  content: \"\\e828\";\n}\n\n.lnr-bookmark:before {\n  content: \"\\e829\";\n}\n\n.lnr-user:before {\n  content: \"\\e82a\";\n}\n\n.lnr-users:before {\n  content: \"\\e82b\";\n}\n\n.lnr-shirt:before {\n  content: \"\\e82c\";\n}\n\n.lnr-store:before {\n  content: \"\\e82d\";\n}\n\n.lnr-cart:before {\n  content: \"\\e82e\";\n}\n\n.lnr-tag:before {\n  content: \"\\e82f\";\n}\n\n.lnr-phone-handset:before {\n  content: \"\\e830\";\n}\n\n.lnr-phone:before {\n  content: \"\\e831\";\n}\n\n.lnr-pushpin:before {\n  content: \"\\e832\";\n}\n\n.lnr-map-marker:before {\n  content: \"\\e833\";\n}\n\n.lnr-map:before {\n  content: \"\\e834\";\n}\n\n.lnr-location:before {\n  content: \"\\e835\";\n}\n\n.lnr-calendar-full:before {\n  content: \"\\e836\";\n}\n\n.lnr-keyboard:before {\n  content: \"\\e837\";\n}\n\n.lnr-spell-check:before {\n  content: \"\\e838\";\n}\n\n.lnr-screen:before {\n  content: \"\\e839\";\n}\n\n.lnr-smartphone:before {\n  content: \"\\e83a\";\n}\n\n.lnr-tablet:before {\n  content: \"\\e83b\";\n}\n\n.lnr-laptop:before {\n  content: \"\\e83c\";\n}\n\n.lnr-laptop-phone:before {\n  content: \"\\e83d\";\n}\n\n.lnr-power-switch:before {\n  content: \"\\e83e\";\n}\n\n.lnr-bubble:before {\n  content: \"\\e83f\";\n}\n\n.lnr-heart-pulse:before {\n  content: \"\\e840\";\n}\n\n.lnr-construction:before {\n  content: \"\\e841\";\n}\n\n.lnr-pie-chart:before {\n  content: \"\\e842\";\n}\n\n.lnr-chart-bars:before {\n  content: \"\\e843\";\n}\n\n.lnr-gift:before {\n  content: \"\\e844\";\n}\n\n.lnr-diamond:before {\n  content: \"\\e845\";\n}\n\n.lnr-linearicons:before {\n  content: \"\\e846\";\n}\n\n.lnr-dinner:before {\n  content: \"\\e847\";\n}\n\n.lnr-coffee-cup:before {\n  content: \"\\e848\";\n}\n\n.lnr-leaf:before {\n  content: \"\\e849\";\n}\n\n.lnr-paw:before {\n  content: \"\\e84a\";\n}\n\n.lnr-rocket:before {\n  content: \"\\e84b\";\n}\n\n.lnr-briefcase:before {\n  content: \"\\e84c\";\n}\n\n.lnr-bus:before {\n  content: \"\\e84d\";\n}\n\n.lnr-car:before {\n  content: \"\\e84e\";\n}\n\n.lnr-train:before {\n  content: \"\\e84f\";\n}\n\n.lnr-bicycle:before {\n  content: \"\\e850\";\n}\n\n.lnr-wheelchair:before {\n  content: \"\\e851\";\n}\n\n.lnr-select:before {\n  content: \"\\e852\";\n}\n\n.lnr-earth:before {\n  content: \"\\e853\";\n}\n\n.lnr-smile:before {\n  content: \"\\e854\";\n}\n\n.lnr-sad:before {\n  content: \"\\e855\";\n}\n\n.lnr-neutral:before {\n  content: \"\\e856\";\n}\n\n.lnr-mustache:before {\n  content: \"\\e857\";\n}\n\n.lnr-alarm:before {\n  content: \"\\e858\";\n}\n\n.lnr-bullhorn:before {\n  content: \"\\e859\";\n}\n\n.lnr-volume-high:before {\n  content: \"\\e85a\";\n}\n\n.lnr-volume-medium:before {\n  content: \"\\e85b\";\n}\n\n.lnr-volume-low:before {\n  content: \"\\e85c\";\n}\n\n.lnr-volume:before {\n  content: \"\\e85d\";\n}\n\n.lnr-mic:before {\n  content: \"\\e85e\";\n}\n\n.lnr-hourglass:before {\n  content: \"\\e85f\";\n}\n\n.lnr-undo:before {\n  content: \"\\e860\";\n}\n\n.lnr-redo:before {\n  content: \"\\e861\";\n}\n\n.lnr-sync:before {\n  content: \"\\e862\";\n}\n\n.lnr-history:before {\n  content: \"\\e863\";\n}\n\n.lnr-clock:before {\n  content: \"\\e864\";\n}\n\n.lnr-download:before {\n  content: \"\\e865\";\n}\n\n.lnr-upload:before {\n  content: \"\\e866\";\n}\n\n.lnr-enter-down:before {\n  content: \"\\e867\";\n}\n\n.lnr-exit-up:before {\n  content: \"\\e868\";\n}\n\n.lnr-bug:before {\n  content: \"\\e869\";\n}\n\n.lnr-code:before {\n  content: \"\\e86a\";\n}\n\n.lnr-link:before {\n  content: \"\\e86b\";\n}\n\n.lnr-unlink:before {\n  content: \"\\e86c\";\n}\n\n.lnr-thumbs-up:before {\n  content: \"\\e86d\";\n}\n\n.lnr-thumbs-down:before {\n  content: \"\\e86e\";\n}\n\n.lnr-magnifier:before {\n  content: \"\\e86f\";\n}\n\n.lnr-cross:before {\n  content: \"\\e870\";\n}\n\n.lnr-menu:before {\n  content: \"\\e871\";\n}\n\n.lnr-list:before {\n  content: \"\\e872\";\n}\n\n.lnr-chevron-up:before, .caret-4-asc:before {\n  content: \"\\e873\";\n}\n\n.lnr-chevron-down:before, .caret-4-desc:before {\n  content: \"\\e874\";\n}\n\n.lnr-chevron-left:before {\n  content: \"\\e875\";\n}\n\n.lnr-chevron-right:before {\n  content: \"\\e876\";\n}\n\n.lnr-arrow-up:before {\n  content: \"\\e877\";\n}\n\n.lnr-arrow-down:before {\n  content: \"\\e878\";\n}\n\n.lnr-arrow-left:before {\n  content: \"\\e879\";\n}\n\n.lnr-arrow-right:before {\n  content: \"\\e87a\";\n}\n\n.lnr-move:before {\n  content: \"\\e87b\";\n}\n\n.lnr-warning:before {\n  content: \"\\e87c\";\n}\n\n.lnr-question-circle:before {\n  content: \"\\e87d\";\n}\n\n.lnr-menu-circle:before {\n  content: \"\\e87e\";\n}\n\n.lnr-checkmark-circle:before, .forms-wizard li.form-wizard-step-done em:before {\n  content: \"\\e87f\";\n}\n\n.lnr-cross-circle:before {\n  content: \"\\e880\";\n}\n\n.lnr-plus-circle:before {\n  content: \"\\e881\";\n}\n\n.lnr-circle-minus:before {\n  content: \"\\e882\";\n}\n\n.lnr-arrow-up-circle:before {\n  content: \"\\e883\";\n}\n\n.lnr-arrow-down-circle:before {\n  content: \"\\e884\";\n}\n\n.lnr-arrow-left-circle:before {\n  content: \"\\e885\";\n}\n\n.lnr-arrow-right-circle:before {\n  content: \"\\e886\";\n}\n\n.lnr-chevron-up-circle:before {\n  content: \"\\e887\";\n}\n\n.lnr-chevron-down-circle:before {\n  content: \"\\e888\";\n}\n\n.lnr-chevron-left-circle:before {\n  content: \"\\e889\";\n}\n\n.lnr-chevron-right-circle:before {\n  content: \"\\e88a\";\n}\n\n.lnr-crop:before {\n  content: \"\\e88b\";\n}\n\n.lnr-frame-expand:before {\n  content: \"\\e88c\";\n}\n\n.lnr-frame-contract:before {\n  content: \"\\e88d\";\n}\n\n.lnr-layers:before {\n  content: \"\\e88e\";\n}\n\n.lnr-funnel:before {\n  content: \"\\e88f\";\n}\n\n.lnr-text-format:before {\n  content: \"\\e890\";\n}\n\n.lnr-text-format-remove:before {\n  content: \"\\e891\";\n}\n\n.lnr-text-size:before {\n  content: \"\\e892\";\n}\n\n.lnr-bold:before {\n  content: \"\\e893\";\n}\n\n.lnr-italic:before {\n  content: \"\\e894\";\n}\n\n.lnr-underline:before {\n  content: \"\\e895\";\n}\n\n.lnr-strikethrough:before {\n  content: \"\\e896\";\n}\n\n.lnr-highlight:before {\n  content: \"\\e897\";\n}\n\n.lnr-text-align-left:before {\n  content: \"\\e898\";\n}\n\n.lnr-text-align-center:before {\n  content: \"\\e899\";\n}\n\n.lnr-text-align-right:before {\n  content: \"\\e89a\";\n}\n\n.lnr-text-align-justify:before {\n  content: \"\\e89b\";\n}\n\n.lnr-line-spacing:before {\n  content: \"\\e89c\";\n}\n\n.lnr-indent-increase:before {\n  content: \"\\e89d\";\n}\n\n.lnr-indent-decrease:before {\n  content: \"\\e89e\";\n}\n\n.lnr-pilcrow:before {\n  content: \"\\e89f\";\n}\n\n.lnr-direction-ltr:before {\n  content: \"\\e8a0\";\n}\n\n.lnr-direction-rtl:before {\n  content: \"\\e8a1\";\n}\n\n.lnr-page-break:before {\n  content: \"\\e8a2\";\n}\n\n.lnr-sort-alpha-asc:before {\n  content: \"\\e8a3\";\n}\n\n.lnr-sort-amount-asc:before {\n  content: \"\\e8a4\";\n}\n\n.lnr-hand:before {\n  content: \"\\e8a5\";\n}\n\n.lnr-pointer-up:before {\n  content: \"\\e8a6\";\n}\n\n.lnr-pointer-right:before {\n  content: \"\\e8a7\";\n}\n\n.lnr-pointer-down:before {\n  content: \"\\e8a8\";\n}\n\n.lnr-pointer-left:before {\n  content: \"\\e8a9\";\n}\n\n/*\n*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set\n*/\n@font-face {\n  font-family: \"Pe-icon-7-stroke\";\n  src: url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?d7yf1v\");\n  src: url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?#iefixd7yf1v\") format(\"embedded-opentype\"), url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.woff?d7yf1v\") format(\"woff\"), url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.ttf?d7yf1v\") format(\"truetype\"), url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.svg?d7yf1v#Pe-icon-7-stroke\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=pe-7s-], [class*=\" pe-7s-\"] {\n  display: inline-block;\n  font-family: \"Pe-icon-7-stroke\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* HELPER CLASS\n * -------------------------- */\n/* FA based classes */\n/*! Modified from font-awesome helper CSS classes - PIXEDEN\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (CSS: MIT License)\n */\n/* makes the font 33% larger relative to the icon container */\n.pe-lg {\n  font-size: 1.1704rem;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.pe-2x {\n  font-size: 1.76rem;\n}\n\n.pe-3x {\n  font-size: 2.64rem;\n}\n\n.pe-4x {\n  font-size: 3.52rem;\n}\n\n.pe-5x {\n  font-size: 4.4rem;\n}\n\n.pe-fw {\n  width: 1.2857142857em;\n  text-align: center;\n}\n\n.pe-ul {\n  padding-left: 0;\n  margin-left: 2.1428571429em;\n  list-style-type: none;\n}\n.pe-ul > li {\n  position: relative;\n}\n\n.pe-li {\n  position: absolute;\n  left: -2.1428571429em;\n  width: 2.1428571429em;\n  top: 0.1428571429em;\n  text-align: center;\n}\n.pe-li.pe-lg {\n  left: -1.8571428571em;\n}\n\n.pe-border {\n  padding: 0.2em 0.25em 0.15em;\n  border: solid 0.08em #eeeeee;\n  border-radius: 0.1em;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pe.pull-left {\n  float: left;\n  margin-right: 0.3em;\n  margin-left: 0.3em;\n}\n\n.pe-spin {\n  animation: spin 2s infinite linear;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n.pe-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  transform: rotate(90deg);\n}\n\n.pe-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  transform: rotate(180deg);\n}\n\n.pe-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  transform: rotate(270deg);\n}\n\n.pe-flip-horizontal {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);\n  transform: scale(-1, 1);\n}\n\n.pe-flip-vertical {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);\n  transform: scale(1, -1);\n}\n\n.pe-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.pe-stack-1x,\n.pe-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.pe-stack-1x {\n  line-height: inherit;\n}\n\n.pe-stack-2x {\n  font-size: 2em;\n}\n\n.pe-inverse {\n  color: #ffffff;\n}\n\n/* Custom classes / mods - PIXEDEN */\n.pe-va {\n  vertical-align: middle;\n}\n\n.pe-border {\n  border: solid 0.08em #eaeaea;\n}\n\n.pe-7s-album:before {\n  content: \"\\e6aa\";\n}\n\n.pe-7s-arc:before {\n  content: \"\\e6ab\";\n}\n\n.pe-7s-back-2:before {\n  content: \"\\e6ac\";\n}\n\n.pe-7s-bandaid:before {\n  content: \"\\e6ad\";\n}\n\n.pe-7s-car:before {\n  content: \"\\e6ae\";\n}\n\n.pe-7s-diamond:before {\n  content: \"\\e6af\";\n}\n\n.pe-7s-door-lock:before {\n  content: \"\\e6b0\";\n}\n\n.pe-7s-eyedropper:before {\n  content: \"\\e6b1\";\n}\n\n.pe-7s-female:before {\n  content: \"\\e6b2\";\n}\n\n.pe-7s-gym:before {\n  content: \"\\e6b3\";\n}\n\n.pe-7s-hammer:before {\n  content: \"\\e6b4\";\n}\n\n.pe-7s-headphones:before {\n  content: \"\\e6b5\";\n}\n\n.pe-7s-helm:before {\n  content: \"\\e6b6\";\n}\n\n.pe-7s-hourglass:before {\n  content: \"\\e6b7\";\n}\n\n.pe-7s-leaf:before {\n  content: \"\\e6b8\";\n}\n\n.pe-7s-magic-wand:before {\n  content: \"\\e6b9\";\n}\n\n.pe-7s-male:before {\n  content: \"\\e6ba\";\n}\n\n.pe-7s-map-2:before {\n  content: \"\\e6bb\";\n}\n\n.pe-7s-next-2:before {\n  content: \"\\e6bc\";\n}\n\n.pe-7s-paint-bucket:before {\n  content: \"\\e6bd\";\n}\n\n.pe-7s-pendrive:before {\n  content: \"\\e6be\";\n}\n\n.pe-7s-photo:before {\n  content: \"\\e6bf\";\n}\n\n.pe-7s-piggy:before {\n  content: \"\\e6c0\";\n}\n\n.pe-7s-plugin:before {\n  content: \"\\e6c1\";\n}\n\n.pe-7s-refresh-2:before {\n  content: \"\\e6c2\";\n}\n\n.pe-7s-rocket:before {\n  content: \"\\e6c3\";\n}\n\n.pe-7s-settings:before {\n  content: \"\\e6c4\";\n}\n\n.pe-7s-shield:before {\n  content: \"\\e6c5\";\n}\n\n.pe-7s-smile:before {\n  content: \"\\e6c6\";\n}\n\n.pe-7s-usb:before {\n  content: \"\\e6c7\";\n}\n\n.pe-7s-vector:before {\n  content: \"\\e6c8\";\n}\n\n.pe-7s-wine:before {\n  content: \"\\e6c9\";\n}\n\n.pe-7s-cloud-upload:before {\n  content: \"\\e68a\";\n}\n\n.pe-7s-cash:before {\n  content: \"\\e68c\";\n}\n\n.pe-7s-close:before {\n  content: \"\\e680\";\n}\n\n.pe-7s-bluetooth:before {\n  content: \"\\e68d\";\n}\n\n.pe-7s-cloud-download:before {\n  content: \"\\e68b\";\n}\n\n.pe-7s-way:before {\n  content: \"\\e68e\";\n}\n\n.pe-7s-close-circle:before {\n  content: \"\\e681\";\n}\n\n.pe-7s-id:before {\n  content: \"\\e68f\";\n}\n\n.pe-7s-angle-up:before {\n  content: \"\\e682\";\n}\n\n.pe-7s-wristwatch:before {\n  content: \"\\e690\";\n}\n\n.pe-7s-angle-up-circle:before {\n  content: \"\\e683\";\n}\n\n.pe-7s-world:before {\n  content: \"\\e691\";\n}\n\n.pe-7s-angle-right:before {\n  content: \"\\e684\";\n}\n\n.pe-7s-volume:before {\n  content: \"\\e692\";\n}\n\n.pe-7s-angle-right-circle:before {\n  content: \"\\e685\";\n}\n\n.pe-7s-users:before {\n  content: \"\\e693\";\n}\n\n.pe-7s-angle-left:before {\n  content: \"\\e686\";\n}\n\n.pe-7s-user-female:before {\n  content: \"\\e694\";\n}\n\n.pe-7s-angle-left-circle:before {\n  content: \"\\e687\";\n}\n\n.pe-7s-up-arrow:before {\n  content: \"\\e695\";\n}\n\n.pe-7s-angle-down:before {\n  content: \"\\e688\";\n}\n\n.pe-7s-switch:before {\n  content: \"\\e696\";\n}\n\n.pe-7s-angle-down-circle:before {\n  content: \"\\e689\";\n}\n\n.pe-7s-scissors:before {\n  content: \"\\e697\";\n}\n\n.pe-7s-wallet:before {\n  content: \"\\e600\";\n}\n\n.pe-7s-safe:before {\n  content: \"\\e698\";\n}\n\n.pe-7s-volume2:before {\n  content: \"\\e601\";\n}\n\n.pe-7s-volume1:before {\n  content: \"\\e602\";\n}\n\n.pe-7s-voicemail:before {\n  content: \"\\e603\";\n}\n\n.pe-7s-video:before {\n  content: \"\\e604\";\n}\n\n.pe-7s-user:before {\n  content: \"\\e605\";\n}\n\n.pe-7s-upload:before {\n  content: \"\\e606\";\n}\n\n.pe-7s-unlock:before {\n  content: \"\\e607\";\n}\n\n.pe-7s-umbrella:before {\n  content: \"\\e608\";\n}\n\n.pe-7s-trash:before {\n  content: \"\\e609\";\n}\n\n.pe-7s-tools:before {\n  content: \"\\e60a\";\n}\n\n.pe-7s-timer:before {\n  content: \"\\e60b\";\n}\n\n.pe-7s-ticket:before {\n  content: \"\\e60c\";\n}\n\n.pe-7s-target:before {\n  content: \"\\e60d\";\n}\n\n.pe-7s-sun:before {\n  content: \"\\e60e\";\n}\n\n.pe-7s-study:before {\n  content: \"\\e60f\";\n}\n\n.pe-7s-stopwatch:before {\n  content: \"\\e610\";\n}\n\n.pe-7s-star:before {\n  content: \"\\e611\";\n}\n\n.pe-7s-speaker:before {\n  content: \"\\e612\";\n}\n\n.pe-7s-signal:before {\n  content: \"\\e613\";\n}\n\n.pe-7s-shuffle:before {\n  content: \"\\e614\";\n}\n\n.pe-7s-shopbag:before {\n  content: \"\\e615\";\n}\n\n.pe-7s-share:before {\n  content: \"\\e616\";\n}\n\n.pe-7s-server:before {\n  content: \"\\e617\";\n}\n\n.pe-7s-search:before {\n  content: \"\\e618\";\n}\n\n.pe-7s-film:before {\n  content: \"\\e6a5\";\n}\n\n.pe-7s-science:before {\n  content: \"\\e619\";\n}\n\n.pe-7s-disk:before {\n  content: \"\\e6a6\";\n}\n\n.pe-7s-ribbon:before {\n  content: \"\\e61a\";\n}\n\n.pe-7s-repeat:before {\n  content: \"\\e61b\";\n}\n\n.pe-7s-refresh:before {\n  content: \"\\e61c\";\n}\n\n.pe-7s-add-user:before {\n  content: \"\\e6a9\";\n}\n\n.pe-7s-refresh-cloud:before {\n  content: \"\\e61d\";\n}\n\n.pe-7s-paperclip:before {\n  content: \"\\e69c\";\n}\n\n.pe-7s-radio:before {\n  content: \"\\e61e\";\n}\n\n.pe-7s-note2:before {\n  content: \"\\e69d\";\n}\n\n.pe-7s-print:before {\n  content: \"\\e61f\";\n}\n\n.pe-7s-network:before {\n  content: \"\\e69e\";\n}\n\n.pe-7s-prev:before {\n  content: \"\\e620\";\n}\n\n.pe-7s-mute:before {\n  content: \"\\e69f\";\n}\n\n.pe-7s-power:before {\n  content: \"\\e621\";\n}\n\n.pe-7s-medal:before {\n  content: \"\\e6a0\";\n}\n\n.pe-7s-portfolio:before {\n  content: \"\\e622\";\n}\n\n.pe-7s-like2:before {\n  content: \"\\e6a1\";\n}\n\n.pe-7s-plus:before {\n  content: \"\\e623\";\n}\n\n.pe-7s-left-arrow:before {\n  content: \"\\e6a2\";\n}\n\n.pe-7s-play:before {\n  content: \"\\e624\";\n}\n\n.pe-7s-key:before {\n  content: \"\\e6a3\";\n}\n\n.pe-7s-plane:before {\n  content: \"\\e625\";\n}\n\n.pe-7s-joy:before {\n  content: \"\\e6a4\";\n}\n\n.pe-7s-photo-gallery:before {\n  content: \"\\e626\";\n}\n\n.pe-7s-pin:before {\n  content: \"\\e69b\";\n}\n\n.pe-7s-phone:before {\n  content: \"\\e627\";\n}\n\n.pe-7s-plug:before {\n  content: \"\\e69a\";\n}\n\n.pe-7s-pen:before {\n  content: \"\\e628\";\n}\n\n.pe-7s-right-arrow:before {\n  content: \"\\e699\";\n}\n\n.pe-7s-paper-plane:before {\n  content: \"\\e629\";\n}\n\n.pe-7s-delete-user:before {\n  content: \"\\e6a7\";\n}\n\n.pe-7s-paint:before {\n  content: \"\\e62a\";\n}\n\n.pe-7s-bottom-arrow:before {\n  content: \"\\e6a8\";\n}\n\n.pe-7s-notebook:before {\n  content: \"\\e62b\";\n}\n\n.pe-7s-note:before {\n  content: \"\\e62c\";\n}\n\n.pe-7s-next:before {\n  content: \"\\e62d\";\n}\n\n.pe-7s-news-paper:before {\n  content: \"\\e62e\";\n}\n\n.pe-7s-musiclist:before {\n  content: \"\\e62f\";\n}\n\n.pe-7s-music:before {\n  content: \"\\e630\";\n}\n\n.pe-7s-mouse:before {\n  content: \"\\e631\";\n}\n\n.pe-7s-more:before {\n  content: \"\\e632\";\n}\n\n.pe-7s-moon:before {\n  content: \"\\e633\";\n}\n\n.pe-7s-monitor:before {\n  content: \"\\e634\";\n}\n\n.pe-7s-micro:before {\n  content: \"\\e635\";\n}\n\n.pe-7s-menu:before {\n  content: \"\\e636\";\n}\n\n.pe-7s-map:before {\n  content: \"\\e637\";\n}\n\n.pe-7s-map-marker:before {\n  content: \"\\e638\";\n}\n\n.pe-7s-mail:before {\n  content: \"\\e639\";\n}\n\n.pe-7s-mail-open:before {\n  content: \"\\e63a\";\n}\n\n.pe-7s-mail-open-file:before {\n  content: \"\\e63b\";\n}\n\n.pe-7s-magnet:before {\n  content: \"\\e63c\";\n}\n\n.pe-7s-loop:before {\n  content: \"\\e63d\";\n}\n\n.pe-7s-look:before {\n  content: \"\\e63e\";\n}\n\n.pe-7s-lock:before {\n  content: \"\\e63f\";\n}\n\n.pe-7s-lintern:before {\n  content: \"\\e640\";\n}\n\n.pe-7s-link:before {\n  content: \"\\e641\";\n}\n\n.pe-7s-like:before {\n  content: \"\\e642\";\n}\n\n.pe-7s-light:before {\n  content: \"\\e643\";\n}\n\n.pe-7s-less:before {\n  content: \"\\e644\";\n}\n\n.pe-7s-keypad:before {\n  content: \"\\e645\";\n}\n\n.pe-7s-junk:before {\n  content: \"\\e646\";\n}\n\n.pe-7s-info:before {\n  content: \"\\e647\";\n}\n\n.pe-7s-home:before {\n  content: \"\\e648\";\n}\n\n.pe-7s-help2:before {\n  content: \"\\e649\";\n}\n\n.pe-7s-help1:before {\n  content: \"\\e64a\";\n}\n\n.pe-7s-graph3:before {\n  content: \"\\e64b\";\n}\n\n.pe-7s-graph2:before {\n  content: \"\\e64c\";\n}\n\n.pe-7s-graph1:before {\n  content: \"\\e64d\";\n}\n\n.pe-7s-graph:before {\n  content: \"\\e64e\";\n}\n\n.pe-7s-global:before {\n  content: \"\\e64f\";\n}\n\n.pe-7s-gleam:before {\n  content: \"\\e650\";\n}\n\n.pe-7s-glasses:before {\n  content: \"\\e651\";\n}\n\n.pe-7s-gift:before {\n  content: \"\\e652\";\n}\n\n.pe-7s-folder:before {\n  content: \"\\e653\";\n}\n\n.pe-7s-flag:before {\n  content: \"\\e654\";\n}\n\n.pe-7s-filter:before {\n  content: \"\\e655\";\n}\n\n.pe-7s-file:before {\n  content: \"\\e656\";\n}\n\n.pe-7s-expand1:before {\n  content: \"\\e657\";\n}\n\n.pe-7s-exapnd2:before {\n  content: \"\\e658\";\n}\n\n.pe-7s-edit:before {\n  content: \"\\e659\";\n}\n\n.pe-7s-drop:before {\n  content: \"\\e65a\";\n}\n\n.pe-7s-drawer:before {\n  content: \"\\e65b\";\n}\n\n.pe-7s-download:before {\n  content: \"\\e65c\";\n}\n\n.pe-7s-display2:before {\n  content: \"\\e65d\";\n}\n\n.pe-7s-display1:before {\n  content: \"\\e65e\";\n}\n\n.pe-7s-diskette:before {\n  content: \"\\e65f\";\n}\n\n.pe-7s-date:before {\n  content: \"\\e660\";\n}\n\n.pe-7s-cup:before {\n  content: \"\\e661\";\n}\n\n.pe-7s-culture:before {\n  content: \"\\e662\";\n}\n\n.pe-7s-crop:before {\n  content: \"\\e663\";\n}\n\n.pe-7s-credit:before {\n  content: \"\\e664\";\n}\n\n.pe-7s-copy-file:before {\n  content: \"\\e665\";\n}\n\n.pe-7s-config:before {\n  content: \"\\e666\";\n}\n\n.pe-7s-compass:before {\n  content: \"\\e667\";\n}\n\n.pe-7s-comment:before {\n  content: \"\\e668\";\n}\n\n.pe-7s-coffee:before {\n  content: \"\\e669\";\n}\n\n.pe-7s-cloud:before {\n  content: \"\\e66a\";\n}\n\n.pe-7s-clock:before {\n  content: \"\\e66b\";\n}\n\n.pe-7s-check:before {\n  content: \"\\e66c\";\n}\n\n.pe-7s-chat:before {\n  content: \"\\e66d\";\n}\n\n.pe-7s-cart:before {\n  content: \"\\e66e\";\n}\n\n.pe-7s-camera:before {\n  content: \"\\e66f\";\n}\n\n.pe-7s-call:before {\n  content: \"\\e670\";\n}\n\n.pe-7s-calculator:before {\n  content: \"\\e671\";\n}\n\n.pe-7s-browser:before {\n  content: \"\\e672\";\n}\n\n.pe-7s-box2:before {\n  content: \"\\e673\";\n}\n\n.pe-7s-box1:before {\n  content: \"\\e674\";\n}\n\n.pe-7s-bookmarks:before {\n  content: \"\\e675\";\n}\n\n.pe-7s-bicycle:before {\n  content: \"\\e676\";\n}\n\n.pe-7s-bell:before {\n  content: \"\\e677\";\n}\n\n.pe-7s-battery:before {\n  content: \"\\e678\";\n}\n\n.pe-7s-ball:before {\n  content: \"\\e679\";\n}\n\n.pe-7s-back:before {\n  content: \"\\e67a\";\n}\n\n.pe-7s-attention:before {\n  content: \"\\e67b\";\n}\n\n.pe-7s-anchor:before {\n  content: \"\\e67c\";\n}\n\n.pe-7s-albums:before {\n  content: \"\\e67d\";\n}\n\n.pe-7s-alarm:before {\n  content: \"\\e67e\";\n}\n\n.pe-7s-airplay:before {\n  content: \"\\e67f\";\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  margin-left: -6px;\n  position: absolute;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  box-sizing: content-box;\n  position: absolute;\n  border: 6px solid transparent;\n  height: 0;\n  width: 1px;\n}\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  content: \"\";\n  z-index: -1;\n  border-width: 6px;\n  left: -6px;\n  border-bottom-color: #dee2e6;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -6px;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  border-top: none;\n  border-bottom-color: #fff;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #dee2e6;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  bottom: 0;\n  margin-bottom: -6px;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  bottom: -1px;\n  border-top-color: #dee2e6;\n}\n\n.react-datepicker-wrapper {\n  display: block;\n  z-index: 100;\n}\n\n.react-datepicker {\n  background-color: #fff;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  display: inline-block;\n  position: relative;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time {\n  border-radius: 0.3rem;\n}\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 102;\n}\n.react-datepicker-popper[data-placement^=bottom] {\n  margin-top: 8px;\n}\n.react-datepicker-popper[data-placement^=top] {\n  margin-bottom: 8px;\n}\n.react-datepicker-popper[data-placement^=right] {\n  margin-left: 6px;\n}\n.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n.react-datepicker-popper[data-placement^=left] {\n  margin-right: 6px;\n}\n.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #fff;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n  padding-top: 10px;\n  position: relative;\n}\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header {\n  margin-top: 0;\n  color: #343a40;\n  font-weight: bold;\n  font-size: 0.968rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: 2rem;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 15px;\n  padding: 0;\n  border: 0.35rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n.react-datepicker__navigation--previous {\n  left: 10px;\n  border-right-color: #ced4da;\n}\n.react-datepicker__navigation--previous:hover {\n  border-right-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n}\n.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: rgb(75.0866393069%, 78.137254902%, 81.187870497%);\n  cursor: default;\n}\n.react-datepicker__navigation--next {\n  right: 10px;\n  border-left-color: #ced4da;\n}\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 80px;\n}\n.react-datepicker__navigation--next:hover {\n  border-left-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n}\n.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: rgb(75.0866393069%, 78.137254902%, 81.187870497%);\n  cursor: default;\n}\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #ced4da;\n}\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n}\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #ced4da;\n}\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__month {\n  margin: 0.5rem;\n  text-align: center;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #dee2e6;\n  width: 120px;\n}\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -122px;\n  top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 120px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  height: calc(195px + 2rem / 2);\n  overflow-y: scroll;\n  width: 100%;\n  box-sizing: content-box;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  padding: 5px 10px;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #e0f3ff;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #545cd8;\n  color: #fff;\n  font-weight: bold;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #545cd8;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ced4da;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ced4da;\n  display: inline-block;\n  width: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.25rem;\n  background-color: #fff;\n}\n\n.react-datepicker__day-names {\n  background: #f8f9fa;\n  border-top: #dee2e6 solid 1px;\n  margin-top: 10px;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #495057;\n  display: inline-block;\n  width: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__day {\n  cursor: pointer;\n  border-radius: 0.25rem;\n}\n.react-datepicker__day:hover {\n  background-color: #545cd8;\n  color: #fff;\n}\n.react-datepicker__day--today {\n  font-weight: bold;\n}\n.react-datepicker__day--highlighted {\n  border-radius: 0.25rem;\n  background-color: #545cd8;\n  color: #fff;\n}\n.react-datepicker__day--highlighted:hover {\n  background-color: rgb(24.7983193277%, 28.3165266106%, 82.8487394958%);\n}\n.react-datepicker__day--highlighted-custom-1 {\n  color: #f7b924;\n}\n.react-datepicker__day--highlighted-custom-2 {\n  color: #444054;\n}\n.react-datepicker__day--selected {\n  background-color: #3ac47d;\n  color: #fff;\n}\n.react-datepicker__day--selected:hover {\n  background-color: #3ac47d;\n  color: #fff;\n}\n.react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range {\n  background-color: #e0f3ff;\n  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);\n}\n.react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover {\n  background-color: #e0f3ff;\n  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);\n}\n.react-datepicker__day--keyboard-selected {\n  border-radius: 0.25rem;\n  background-color: rgb(37.9651073028%, 81.6427358345%, 59.1709124595%);\n  color: #fff;\n}\n.react-datepicker__day--keyboard-selected:hover {\n  background-color: rgb(20.4616334723%, 69.146209665%, 44.0983480006%);\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {\n  background-color: #e0f3ff;\n}\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {\n  background-color: #3ac47d;\n  color: #fff;\n}\n.react-datepicker__day--disabled {\n  cursor: default;\n  color: #ced4da;\n}\n.react-datepicker__day--disabled:hover {\n  background-color: transparent;\n  color: #ced4da;\n}\n\n.react-datepicker__day--selecting-range-start,\n.react-datepicker__day--selecting-range-end {\n  background-color: #3ac47d !important;\n  color: #fff !important;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: #ced4da;\n  float: right;\n  margin-left: 20px;\n  top: 8px;\n  position: relative;\n  border-width: 0.35rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #fff;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.25rem;\n  border: 1px solid #dee2e6;\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ced4da;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 25%;\n  right: 7px;\n}\n.react-datepicker__close-icon::after {\n  background-color: #545cd8;\n  border-radius: 50%;\n  bottom: 0;\n  box-sizing: border-box;\n  color: #fff;\n  content: \"×\";\n  cursor: pointer;\n  font-size: 12px;\n  height: 16px;\n  width: 16px;\n  line-height: 1;\n  margin: -8px auto 0;\n  padding: 2px;\n  position: absolute;\n  right: 0px;\n  text-align: center;\n}\n\n.react-datepicker__today-button {\n  background: #fff;\n  border-top: 1px solid #dee2e6;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1040;\n  background-color: rgba(0, 0, 0, 0.5);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.584rem;\n}\n.react-datepicker__portal .react-datepicker__navigation {\n  border: 0.63rem solid transparent;\n  margin-top: 3px;\n}\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: #545cd8;\n}\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n}\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: rgb(75.0866393069%, 78.137254902%, 81.187870497%);\n  cursor: default;\n}\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: #545cd8;\n}\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: rgb(18.1344537815%, 21.8543417367%, 79.512605042%);\n}\n.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: rgb(75.0866393069%, 78.137254902%, 81.187870497%);\n  cursor: default;\n}\n\n.rangeButtonSelectedStyle {\n  background: #545cd8 !important;\n}\n\n.rangebuttonstyle {\n  outline: none !important;\n  color: #545cd8 !important;\n}\n\n.rc-slider-tooltip {\n  z-index: 555;\n}\n\n.rc-tooltip.rc-tooltip-zoom-enter,\n.rc-tooltip.rc-tooltip-zoom-leave {\n  display: block;\n}\n\n.rc-tooltip-zoom-enter,\n.rc-tooltip-zoom-appear {\n  opacity: 0;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,\n.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {\n  animation-name: rcToolTipZoomIn;\n  animation-play-state: running;\n}\n\n.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {\n  animation-name: rcToolTipZoomOut;\n  animation-play-state: running;\n}\n\n@keyframes rcToolTipZoomIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n}\n@keyframes rcToolTipZoomOut {\n  0% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n}\n.rc-tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  visibility: visible;\n  font-size: 12px;\n  line-height: 1.5;\n  opacity: 0.9;\n}\n\n.rc-tooltip-hidden {\n  display: none;\n}\n\n.rc-tooltip-placement-top,\n.rc-tooltip-placement-topLeft,\n.rc-tooltip-placement-topRight {\n  padding: 5px 0 9px 0;\n}\n\n.rc-tooltip-placement-right,\n.rc-tooltip-placement-rightTop,\n.rc-tooltip-placement-rightBottom {\n  padding: 0 5px 0 9px;\n}\n\n.rc-tooltip-placement-bottom,\n.rc-tooltip-placement-bottomLeft,\n.rc-tooltip-placement-bottomRight {\n  padding: 9px 0 5px 0;\n}\n\n.rc-tooltip-placement-left,\n.rc-tooltip-placement-leftTop,\n.rc-tooltip-placement-leftBottom {\n  padding: 0 9px 0 5px;\n}\n\n.rc-tooltip-inner {\n  padding: 12px 14px;\n  color: #fff;\n  text-align: left;\n  text-decoration: none;\n  background-color: #343a40;\n  border-radius: 6px;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);\n  min-height: 34px;\n  font-weight: bold;\n}\n\n.rc-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow,\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  bottom: 4px;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #343a40;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  right: 15%;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow,\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow,\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  left: 4px;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #343a40;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow,\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow,\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  right: 4px;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #343a40;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  top: 4px;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #343a40;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  right: 15%;\n}\n\n.rc-slider {\n  position: relative;\n  height: 20px;\n  padding: 8px 0 0;\n  width: 100%;\n  border-radius: 0.25rem;\n  -ms-touch-action: none;\n  touch-action: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  background-color: #e9ecef;\n  height: 4px;\n  border-radius: 0.25rem;\n}\n\n.rc-slider-track {\n  position: absolute;\n  left: 0;\n  height: 4px;\n  border-radius: 0.25rem;\n  background-color: #545cd8;\n}\n\n.rc-slider-handle {\n  position: absolute;\n  margin-left: -8px;\n  margin-top: -6px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  cursor: grab;\n  border-radius: 50%;\n  border: solid 2px #545cd8;\n  background-color: #fff;\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n  transition: box-shadow 200ms;\n}\n.rc-slider-handle:focus {\n  outline: none;\n}\n.rc-slider-handle:focus, .rc-slider-handle:active, .rc-slider-handle:hover {\n  border-color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);\n}\n.rc-slider-handle:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n\n.rc-slider-mark {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  width: 100%;\n  font-size: 12px;\n}\n\n.rc-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  color: #6c757d;\n}\n\n.rc-slider-mark-text-active {\n  color: #343a40;\n}\n\n.rc-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n\n.rc-slider-dot {\n  position: absolute;\n  bottom: -2px;\n  margin-left: -4px;\n  width: 8px;\n  height: 8px;\n  border: 2px solid #dee2e6;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 50%;\n  vertical-align: middle;\n}\n\n.rc-slider-dot-active {\n  border-color: #545cd8;\n}\n\n.rc-slider-disabled {\n  background-color: #e9ecef;\n}\n\n.rc-slider-disabled .rc-slider-track {\n  background-color: #ced4da;\n}\n\n.rc-slider-disabled .rc-slider-handle,\n.rc-slider-disabled .rc-slider-dot {\n  border-color: #ced4da;\n  box-shadow: none;\n  background-color: #fff;\n  cursor: not-allowed;\n}\n\n.rc-slider-disabled .rc-slider-mark-text,\n.rc-slider-disabled .rc-slider-dot {\n  cursor: not-allowed !important;\n}\n\n.rc-slider-vertical {\n  width: 14px;\n  height: 100%;\n  padding: 0 5px;\n}\n\n.rc-slider-vertical .rc-slider-rail {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-track {\n  left: 5px;\n  bottom: 0;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-handle {\n  margin-left: -6px;\n  margin-bottom: -7px;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n\n.rc-slider-vertical .rc-slider-mark {\n  top: 0;\n  left: 18px;\n  height: 100%;\n}\n\n.rc-slider-vertical .rc-slider-step {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-dot {\n  left: 2px;\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:first-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:last-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n  animation-name: rcSliderTooltipZoomDownIn;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n  animation-name: rcSliderTooltipZoomDownOut;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  transform: scale(0, 0);\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n\n@keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n  100% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n}\n@keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n}\n.rc-slider-tooltip {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  visibility: visible;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-tooltip-hidden {\n  display: none;\n}\n\n.rc-slider-tooltip-placement-top {\n  padding: 4px 0 8px 0;\n}\n\n.rc-slider-tooltip-inner {\n  padding: 0 8px;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  color: #fff;\n  text-align: center;\n  text-decoration: none;\n  background-color: #212529;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n  font-weight: bold;\n}\n\n.rc-slider-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  bottom: 4px;\n  left: 50%;\n  margin-left: -4px;\n  border-width: 4px 4px 0;\n  border-top-color: #212529;\n}\n\n.rc-slider-primary .rc-slider-track {\n  background-color: #545cd8;\n}\n.rc-slider-primary .rc-slider-handle {\n  border-color: #545cd8;\n  background-color: #fff;\n}\n.rc-slider-primary .rc-slider-handle:focus, .rc-slider-primary .rc-slider-handle:active, .rc-slider-primary .rc-slider-handle:hover {\n  border-color: rgb(16.2773109244%, 19.6162464986%, 71.3697478992%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);\n}\n.rc-slider-primary .rc-slider-dot-active {\n  border-color: #545cd8;\n}\n\n.rc-slider-secondary .rc-slider-track {\n  background-color: #6c757d;\n}\n.rc-slider-secondary .rc-slider-handle {\n  border-color: #6c757d;\n  background-color: #fff;\n}\n.rc-slider-secondary .rc-slider-handle:focus, .rc-slider-secondary .rc-slider-handle:active, .rc-slider-secondary .rc-slider-handle:hover {\n  border-color: rgb(28.4473617773%, 30.8179752588%, 32.9251872423%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.8), 0 0.125rem 0.5875rem rgba(108, 117, 125, 0.9);\n}\n.rc-slider-secondary .rc-slider-dot-active {\n  border-color: #6c757d;\n}\n\n.rc-slider-success .rc-slider-track {\n  background-color: #3ac47d;\n}\n.rc-slider-success .rc-slider-handle {\n  border-color: #3ac47d;\n  background-color: #fff;\n}\n.rc-slider-success .rc-slider-handle:focus, .rc-slider-success .rc-slider-handle:active, .rc-slider-success .rc-slider-handle:hover {\n  border-color: rgb(15.8947043384%, 53.7131387988%, 34.2558283156%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.8), 0 0.125rem 0.5875rem rgba(58, 196, 125, 0.9);\n}\n.rc-slider-success .rc-slider-dot-active {\n  border-color: #3ac47d;\n}\n\n.rc-slider-info .rc-slider-track {\n  background-color: #30b1ff;\n}\n.rc-slider-info .rc-slider-handle {\n  border-color: #30b1ff;\n  background-color: #fff;\n}\n.rc-slider-info .rc-slider-handle:focus, .rc-slider-info .rc-slider-handle:active, .rc-slider-info .rc-slider-handle:hover {\n  border-color: rgb(0%, 55.3537936914%, 88.8235294118%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.8), 0 0.125rem 0.5875rem rgba(48, 177, 255, 0.9);\n}\n.rc-slider-info .rc-slider-dot-active {\n  border-color: #30b1ff;\n}\n\n.rc-slider-warning .rc-slider-track {\n  background-color: #f7b924;\n}\n.rc-slider-warning .rc-slider-handle {\n  border-color: #f7b924;\n  background-color: #fff;\n}\n.rc-slider-warning .rc-slider-handle:focus, .rc-slider-warning .rc-slider-handle:active, .rc-slider-warning .rc-slider-handle:hover {\n  border-color: rgb(78.1264576315%, 56.00846506%, 2.8539345254%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.8), 0 0.125rem 0.5875rem rgba(247, 185, 36, 0.9);\n}\n.rc-slider-warning .rc-slider-dot-active {\n  border-color: #f7b924;\n}\n\n.rc-slider-danger .rc-slider-track {\n  background-color: #d92550;\n}\n.rc-slider-danger .rc-slider-handle {\n  border-color: #d92550;\n  background-color: #fff;\n}\n.rc-slider-danger .rc-slider-handle:focus, .rc-slider-danger .rc-slider-handle:active, .rc-slider-danger .rc-slider-handle:hover {\n  border-color: rgb(59.4681179558%, 10.1397251814%, 21.923730122%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.8), 0 0.125rem 0.5875rem rgba(217, 37, 80, 0.9);\n}\n.rc-slider-danger .rc-slider-dot-active {\n  border-color: #d92550;\n}\n\n.rc-slider-light .rc-slider-track {\n  background-color: #eeeeee;\n}\n.rc-slider-light .rc-slider-handle {\n  border-color: #eeeeee;\n  background-color: #fff;\n}\n.rc-slider-light .rc-slider-handle:focus, .rc-slider-light .rc-slider-handle:active, .rc-slider-light .rc-slider-handle:hover {\n  border-color: rgb(78.3333333333%, 78.3333333333%, 78.3333333333%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.8), 0 0.125rem 0.5875rem rgba(238, 238, 238, 0.9);\n}\n.rc-slider-light .rc-slider-dot-active {\n  border-color: #eeeeee;\n}\n\n.rc-slider-dark .rc-slider-track {\n  background-color: #343a40;\n}\n.rc-slider-dark .rc-slider-handle {\n  border-color: #343a40;\n  background-color: #fff;\n}\n.rc-slider-dark .rc-slider-handle:focus, .rc-slider-dark .rc-slider-handle:active, .rc-slider-dark .rc-slider-handle:hover {\n  border-color: rgb(6.9438810007%, 7.7450980392%, 8.5463150778%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.8), 0 0.125rem 0.5875rem rgba(52, 58, 64, 0.9);\n}\n.rc-slider-dark .rc-slider-dot-active {\n  border-color: #343a40;\n}\n\n.rc-slider-focus .rc-slider-track {\n  background-color: #444054;\n}\n.rc-slider-focus .rc-slider-handle {\n  border-color: #444054;\n  background-color: #fff;\n}\n.rc-slider-focus .rc-slider-handle:focus, .rc-slider-focus .rc-slider-handle:active, .rc-slider-focus .rc-slider-handle:hover {\n  border-color: rgb(12.8828828829%, 12.1250662427%, 15.9141494436%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.8), 0 0.125rem 0.5875rem rgba(68, 64, 84, 0.9);\n}\n.rc-slider-focus .rc-slider-dot-active {\n  border-color: #444054;\n}\n\n.rc-slider-alternate .rc-slider-track {\n  background-color: #83588a;\n}\n.rc-slider-alternate .rc-slider-handle {\n  border-color: #83588a;\n  background-color: #fff;\n}\n.rc-slider-alternate .rc-slider-handle:focus, .rc-slider-alternate .rc-slider-handle:active, .rc-slider-alternate .rc-slider-handle:hover {\n  border-color: rgb(33.9831684886%, 22.8283879924%, 35.799062988%);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.8), 0 0.125rem 0.5875rem rgba(131, 88, 138, 0.9);\n}\n.rc-slider-alternate .rc-slider-dot-active {\n  border-color: #83588a;\n}\n\n.rc-slider-line .rc-slider-handle {\n  border-radius: 0;\n  border-width: 0 3px 0 0;\n  margin-left: -8px;\n  width: 10px;\n  background-color: transparent;\n  box-shadow: 0 0 0 transparent !important;\n}\n\n.rc-slider-square .rc-slider-handle {\n  border-radius: 3px;\n  border-widtH: 1px;\n}\n.rc-slider-square .rc-slider-handle:before {\n  position: absolute;\n  height: 8px;\n  width: 4px;\n  border: #adb5bd solid 1px;\n  border-width: 0 1px;\n  display: block;\n  content: \"\";\n  top: 50%;\n  left: 50%;\n  margin: -4px -2px;\n}\n\n.rc-slider-lg.rc-slider {\n  height: 20px;\n  padding: 8px 0 0;\n}\n.rc-slider-lg .rc-slider-rail {\n  height: 4px;\n}\n.rc-slider-lg .rc-slider-track {\n  height: 4px;\n}\n.rc-slider-lg .rc-slider-handle {\n  margin-left: -10px;\n  margin-top: -8px;\n  width: 20px;\n  height: 20px;\n}\n.rc-slider-lg.rc-slider-line .rc-slider-handle {\n  margin-left: -8px;\n  width: 10px;\n}\n.rc-slider-lg.rc-slider-square .rc-slider-handle:before {\n  height: 10px;\n  width: 6px;\n  margin: -5px -3px;\n}\n\n.rc-slider-sm.rc-slider {\n  height: 20px;\n  padding: 8px 0 0;\n}\n.rc-slider-sm .rc-slider-rail {\n  height: 4px;\n}\n.rc-slider-sm .rc-slider-track {\n  height: 4px;\n}\n.rc-slider-sm .rc-slider-handle {\n  margin-left: -6px;\n  margin-top: -4px;\n  width: 12px;\n  height: 12px;\n}\n.rc-slider-sm.rc-slider-line .rc-slider-handle {\n  margin-left: -8px;\n  width: 10px;\n}\n.rc-slider-sm.rc-slider-square .rc-slider-handle:before {\n  height: 6px;\n  margin: -3px 0 0 -1px;\n  border: 0;\n  width: 2px;\n  background: #adb5bd;\n}\n\n.rdw-option-wrapper {\n  border: 1px solid #F1F1F1;\n  padding: 5px;\n  min-width: 25px;\n  height: 20px;\n  border-radius: 2px;\n  margin: 0 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-option-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-option-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-option-active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-option-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.rdw-dropdown-wrapper {\n  height: 30px;\n  background: white;\n  cursor: pointer;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  margin: 0 3px;\n  text-transform: capitalize;\n  background: white;\n}\n\n.rdw-dropdown-wrapper:focus {\n  outline: none;\n}\n\n.rdw-dropdown-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n\n.rdw-dropdown-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-dropdown-carettoopen {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-top: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.rdw-dropdown-carettoclose {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-bottom: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.rdw-dropdown-selectedtext {\n  display: flex;\n  position: relative;\n  height: 100%;\n  align-items: center;\n  padding: 0 5px;\n}\n\n.rdw-dropdown-optionwrapper {\n  z-index: 100;\n  position: relative;\n  border: 1px solid #F1F1F1;\n  width: 98%;\n  background: white;\n  border-radius: 2px;\n  margin: 0;\n  padding: 0;\n  max-height: 250px;\n  overflow-y: scroll;\n}\n\n.rdw-dropdown-optionwrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n\n.rdw-dropdownoption-default {\n  min-height: 25px;\n  display: flex;\n  align-items: center;\n  padding: 0 5px;\n}\n\n.rdw-dropdownoption-highlighted {\n  background: #F1F1F1;\n}\n\n.rdw-dropdownoption-active {\n  background: #f5f5f5;\n}\n\n.rdw-dropdownoption-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.rdw-inline-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-inline-dropdown {\n  width: 50px;\n}\n\n.rdw-inline-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-block-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-block-dropdown {\n  width: 110px;\n}\n\n.rdw-fontsize-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-fontsize-dropdown {\n  min-width: 40px;\n}\n\n.rdw-fontsize-option {\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-fontfamily-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-fontfamily-dropdown {\n  width: 115px;\n}\n\n.rdw-fontfamily-placeholder {\n  white-space: nowrap;\n  max-width: 90px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rdw-fontfamily-optionwrapper {\n  width: 140px;\n}\n\n.rdw-list-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-list-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n\n.rdw-list-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-text-align-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-text-align-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n\n.rdw-text-align-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-right-aligned-block {\n  text-align: right;\n}\n\n.rdw-left-aligned-block {\n  text-align: left !important;\n}\n\n.rdw-center-aligned-block {\n  text-align: center !important;\n}\n\n.rdw-justify-aligned-block {\n  text-align: justify !important;\n}\n\n.rdw-right-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-left-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-center-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-justify-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-colorpicker-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-colorpicker-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 175px;\n  height: 175px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-colorpicker-modal-header {\n  display: flex;\n  padding-bottom: 5px;\n}\n\n.rdw-colorpicker-modal-style-label {\n  font-size: 15px;\n  width: 50%;\n  text-align: center;\n  cursor: pointer;\n  padding: 0 10px 5px;\n}\n\n.rdw-colorpicker-modal-style-label-active {\n  border-bottom: 2px solid #0a66b7;\n}\n\n.rdw-colorpicker-modal-options {\n  margin: 5px auto;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  overflow: scroll;\n}\n\n.rdw-colorpicker-cube {\n  width: 22px;\n  height: 22px;\n  border: 1px solid #F1F1F1;\n}\n\n.rdw-colorpicker-option {\n  margin: 3px;\n  padding: 0;\n  min-height: 20px;\n  border: none;\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  box-shadow: 1px 2px 1px #BFBDBD inset;\n}\n\n.rdw-colorpicker-option:hover {\n  box-shadow: 1px 2px 1px #BFBDBD;\n}\n\n.rdw-colorpicker-option:active {\n  box-shadow: -1px -2px 1px #BFBDBD;\n}\n\n.rdw-colorpicker-option-active {\n  box-shadow: 0px 0px 2px 2px #BFBDBD;\n}\n\n.rdw-link-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-link-dropdown {\n  width: 50px;\n}\n\n.rdw-link-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-link-dropdownPlaceholder {\n  margin-left: 8px;\n}\n\n.rdw-link-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 205px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-link-modal-label {\n  font-size: 15px;\n}\n\n.rdw-link-modal-input {\n  margin-top: 5px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  height: 25px;\n  margin-bottom: 15px;\n  padding: 0 5px;\n}\n\n.rdw-link-modal-input:focus {\n  outline: none;\n}\n\n.rdw-link-modal-buttonsection {\n  margin: 0 auto;\n}\n\n.rdw-link-modal-target-option {\n  margin-bottom: 20px;\n}\n\n.rdw-link-modal-target-option > span {\n  margin-left: 5px;\n}\n\n.rdw-link-modal-btn {\n  margin-left: 10px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-link-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-link-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-link-modal-btn:focus {\n  outline: none !important;\n}\n\n.rdw-link-modal-btn:disabled {\n  background: #ece9e9;\n}\n\n.rdw-link-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-history-dropdown {\n  width: 50px;\n}\n\n.rdw-embedded-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-embedded-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  justify-content: space-between;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-embedded-modal-header {\n  font-size: 15px;\n  display: flex;\n}\n\n.rdw-embedded-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.rdw-embedded-modal-header-label {\n  width: 95px;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n\n.rdw-embedded-modal-link-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.rdw-embedded-modal-link-input {\n  width: 88%;\n  height: 35px;\n  margin: 10px 0;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n\n.rdw-embedded-modal-link-input-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.rdw-embedded-modal-link-input:focus {\n  outline: none;\n}\n\n.rdw-embedded-modal-btn-section {\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-embedded-modal-btn {\n  margin: 0 3px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-embedded-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-embedded-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-embedded-modal-btn:focus {\n  outline: none !important;\n}\n\n.rdw-embedded-modal-btn:disabled {\n  background: #ece9e9;\n}\n\n.rdw-embedded-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n\n.rdw-embedded-modal-size-input {\n  width: 80%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n\n.rdw-embedded-modal-size-input:focus {\n  outline: none;\n}\n\n.rdw-emoji-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-emoji-modal {\n  overflow: auto;\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-emoji-icon {\n  margin: 2.5px;\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n  font-size: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rdw-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.rdw-spinner > div {\n  width: 12px;\n  height: 12px;\n  background-color: #333;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.rdw-spinner .rdw-bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.rdw-spinner .rdw-bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n  }\n}\n@keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.rdw-image-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-image-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-image-modal-header {\n  font-size: 15px;\n  margin: 10px 0;\n  display: flex;\n}\n\n.rdw-image-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.rdw-image-modal-header-label {\n  width: 80px;\n  background: #f1f1f1;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n}\n\n.rdw-image-modal-header-label-highlighted {\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n\n.rdw-image-modal-upload-option {\n  width: 100%;\n  color: gray;\n  cursor: pointer;\n  display: flex;\n  border: none;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n  background-color: #f1f1f1;\n  outline: 2px dashed gray;\n  outline-offset: -10px;\n  margin: 10px 0;\n  padding: 9px 0;\n}\n\n.rdw-image-modal-upload-option-highlighted {\n  outline: 2px dashed #0a66b7;\n}\n\n.rdw-image-modal-upload-option-label {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n}\n\n.rdw-image-modal-upload-option-label span {\n  padding: 0 20px;\n}\n\n.rdw-image-modal-upload-option-image-preview {\n  max-width: 100%;\n  max-height: 200px;\n}\n\n.rdw-image-modal-upload-option-input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n\n.rdw-image-modal-url-section {\n  display: flex;\n  align-items: center;\n}\n\n.rdw-image-modal-url-input {\n  width: 90%;\n  height: 35px;\n  margin: 15px 0 12px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n\n.rdw-image-modal-btn-section {\n  margin: 10px auto 0;\n}\n\n.rdw-image-modal-url-input:focus {\n  outline: none;\n}\n\n.rdw-image-modal-btn {\n  margin: 0 5px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-image-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-image-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-image-modal-btn:focus {\n  outline: none !important;\n}\n\n.rdw-image-modal-btn:disabled {\n  background: #ece9e9;\n}\n\n.rdw-image-modal-spinner {\n  position: absolute;\n  top: -3px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n}\n\n.rdw-image-modal-alt-input {\n  width: 70%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n  margin-left: 5px;\n}\n\n.rdw-image-modal-alt-input:focus {\n  outline: none;\n}\n\n.rdw-image-modal-alt-lbl {\n  font-size: 12px;\n}\n\n.rdw-image-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n\n.rdw-image-modal-size-input {\n  width: 40%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n\n.rdw-image-modal-size-input:focus {\n  outline: none;\n}\n\n.rdw-image-mandatory-sign {\n  color: red;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n\n.rdw-remove-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-history-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-history-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-history-dropdown {\n  width: 50px;\n}\n\n.rdw-link-decorator-wrapper {\n  position: relative;\n}\n\n.rdw-link-decorator-icon {\n  position: absolute;\n  left: 40%;\n  top: 0;\n  cursor: pointer;\n  background-color: white;\n}\n\n.rdw-mention-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.rdw-suggestion-wrapper {\n  position: relative;\n}\n\n.rdw-suggestion-dropdown {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #F1F1F1;\n  min-width: 100px;\n  max-height: 150px;\n  overflow: auto;\n  background: white;\n  z-index: 100;\n}\n\n.rdw-suggestion-option {\n  padding: 7px 5px;\n  border-bottom: 1px solid #f1f1f1;\n}\n\n.rdw-suggestion-option-active {\n  background-color: #F1F1F1;\n}\n\n.rdw-hashtag-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.rdw-image-alignment-options-popup {\n  position: absolute;\n  background: white;\n  display: flex;\n  padding: 5px 2px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  width: 105px;\n  cursor: pointer;\n  z-index: 100;\n}\n\n.rdw-alignment-option-left {\n  justify-content: flex-start;\n}\n\n.rdw-image-alignment-option {\n  height: 15px;\n  width: 15px;\n  min-width: 15px;\n}\n\n.rdw-image-alignment {\n  position: relative;\n}\n\n.rdw-image-imagewrapper {\n  position: relative;\n}\n\n.rdw-image-center {\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-image-left {\n  display: flex;\n}\n\n.rdw-image-right {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.rdw-image-alignment-options-popup-right {\n  right: 0;\n}\n\n.rdw-editor-main {\n  height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n}\n\n.rdw-editor-toolbar {\n  padding: 6px 5px 0;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  display: flex;\n  justify-content: flex-start;\n  background: white;\n  flex-wrap: wrap;\n  font-size: 15px;\n  margin-bottom: 5px;\n  user-select: none;\n}\n\n.public-DraftStyleDefault-block {\n  margin: 1em 0;\n}\n\n.rdw-editor-wrapper:focus {\n  outline: none;\n}\n\n.rdw-editor-wrapper {\n  box-sizing: content-box;\n}\n\n.rdw-editor-main blockquote {\n  border-left: 5px solid #f1f1f1;\n  padding-left: 5px;\n}\n\n.rdw-editor-main pre {\n  background: #f1f1f1;\n  border-radius: 3px;\n  padding: 1px 10px;\n} /**\n* Draft v0.9.1\n*\n* Copyright (c) 2013-present, Facebook, Inc.\n* All rights reserved.\n*\n* This source code is licensed under the BSD-style license found in the\n* LICENSE file in the root directory of this source tree. An additional grant\n* of patent rights can be found in the PATENTS file in the same directory.\n*/\n.DraftEditor-editorContainer, .DraftEditor-root, .public-DraftEditor-content {\n  height: inherit;\n  text-align: initial;\n}\n\n.public-DraftEditor-content[contenteditable=true] {\n  -webkit-user-modify: read-write-plaintext-only;\n}\n\n.DraftEditor-root {\n  position: relative;\n}\n\n.DraftEditor-editorContainer {\n  background-color: rgba(255, 255, 255, 0);\n  border-left: 0.1px solid transparent;\n  position: relative;\n  z-index: 1;\n}\n\n.public-DraftEditor-block {\n  position: relative;\n}\n\n.DraftEditor-alignLeft .public-DraftStyleDefault-block {\n  text-align: left;\n}\n\n.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {\n  left: 0;\n  text-align: left;\n}\n\n.DraftEditor-alignCenter .public-DraftStyleDefault-block {\n  text-align: center;\n}\n\n.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {\n  margin: 0 auto;\n  text-align: center;\n  width: 100%;\n}\n\n.DraftEditor-alignRight .public-DraftStyleDefault-block {\n  text-align: right;\n}\n\n.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {\n  right: 0;\n  text-align: right;\n}\n\n.public-DraftEditorPlaceholder-root {\n  color: #9197a3;\n  position: absolute;\n  z-index: 0;\n}\n\n.public-DraftEditorPlaceholder-hasFocus {\n  color: #bdc1c9;\n}\n\n.DraftEditorPlaceholder-hidden {\n  display: none;\n}\n\n.public-DraftStyleDefault-block {\n  position: relative;\n  white-space: pre-wrap;\n}\n\n.public-DraftStyleDefault-ltr {\n  direction: ltr;\n  text-align: left;\n}\n\n.public-DraftStyleDefault-rtl {\n  direction: rtl;\n  text-align: right;\n}\n\n.public-DraftStyleDefault-listLTR {\n  direction: ltr;\n}\n\n.public-DraftStyleDefault-listRTL {\n  direction: rtl;\n}\n\n.public-DraftStyleDefault-ol, .public-DraftStyleDefault-ul {\n  margin: 16px 0;\n  padding: 0;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {\n  margin-left: 1.5em;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {\n  margin-right: 1.5em;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {\n  margin-left: 3em;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {\n  margin-right: 3em;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {\n  margin-left: 4.5em;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {\n  margin-right: 4.5em;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {\n  margin-left: 6em;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {\n  margin-right: 6em;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {\n  margin-left: 7.5em;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {\n  margin-right: 7.5em;\n}\n\n.public-DraftStyleDefault-unorderedListItem {\n  list-style-type: square;\n  position: relative;\n}\n\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {\n  list-style-type: disc;\n}\n\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {\n  list-style-type: circle;\n}\n\n.public-DraftStyleDefault-orderedListItem {\n  list-style-type: none;\n  position: relative;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {\n  left: -36px;\n  position: absolute;\n  text-align: right;\n  width: 30px;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {\n  position: absolute;\n  right: -36px;\n  text-align: left;\n  width: 30px;\n}\n\n.public-DraftStyleDefault-orderedListItem:before {\n  content: counter(ol0) \". \";\n  counter-increment: ol0;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {\n  content: counter(ol1) \". \";\n  counter-increment: ol1;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {\n  content: counter(ol2) \". \";\n  counter-increment: ol2;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {\n  content: counter(ol3) \". \";\n  counter-increment: ol3;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {\n  content: counter(ol4) \". \";\n  counter-increment: ol4;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {\n  counter-reset: ol0;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {\n  counter-reset: ol1;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {\n  counter-reset: ol2;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {\n  counter-reset: ol3;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {\n  counter-reset: ol4;\n}\n\n.demo-editor {\n  height: 275px !important;\n  border: 1px solid #F1F1F1 !important;\n  padding: 5px !important;\n  border-radius: 2px !important;\n}\n\n.has-switch {\n  border-radius: 30px;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1.72222;\n  overflow: hidden;\n  position: relative;\n  text-align: left;\n  width: 60px;\n  user-select: none;\n}\n\n.has-switch.deactivate {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n\n.has-switch.deactivate label,\n.has-switch.deactivate span {\n  cursor: default !important;\n}\n\n.has-switch > div {\n  position: relative;\n  top: 0;\n  width: 100px;\n}\n\n.has-switch > div.switch-animate {\n  transition: left 0.25s ease-out;\n}\n\n.has-switch > div.switch-off {\n  left: -35px;\n}\n\n.has-switch > div.switch-on {\n  left: 0;\n}\n\n.has-switch > div label {\n  background-color: #FFFFFF;\n  background: rgb(255, 255, 255);\n  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%);\n  background-size: 150% 150%;\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n\n.has-switch input[type=checkbox] {\n  display: none;\n}\n\n.has-switch span {\n  cursor: pointer;\n  float: left;\n  font-size: 11px;\n  font-weight: 400;\n  height: 24px;\n  line-height: 15px;\n  margin: 0;\n  padding-bottom: 6px;\n  padding-top: 5px;\n  position: relative;\n  text-align: center;\n  text-indent: -10px;\n  width: 50%;\n  z-index: 1;\n  transition: 0.25s ease-out;\n}\n\n.has-switch span.switch-left {\n  background-color: #545cd8;\n  border-left: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 30px 0 0 30px;\n  color: #FFFFFF;\n}\n\n.has-switch .switch-off span.switch-left {\n  background-color: #ced4da !important;\n}\n\n.has-switch span.switch-right {\n  border-radius: 0 30px 30px 0;\n  background-color: #545cd8;\n  color: #ffffff;\n  text-indent: 1px;\n}\n\n.has-switch .switch-off span.switch-right {\n  background-color: #ced4da !important;\n}\n\n.has-switch label {\n  border-radius: 12px;\n  float: left;\n  height: 22px;\n  margin: 1px -13px;\n  padding: 0;\n  position: relative;\n  vertical-align: middle;\n  width: 22px;\n  z-index: 100;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out;\n}\n\n.has-switch .switch-on .fa-check:before {\n  margin-left: 10px;\n}\n\n.has-switch:hover .switch-on label {\n  margin: 1px -17px;\n  width: 26px;\n}\n\n.has-switch:hover .switch-off label {\n  margin: 1px -13px;\n  width: 26px;\n}\n\n.has-switch-sm.has-switch span {\n  height: 18px;\n  line-height: 18px;\n  padding: 0;\n}\n.has-switch-sm.has-switch label {\n  height: 16px;\n  width: 16px;\n  margin: 1px -8px;\n}\n.has-switch-sm.has-switch .switch-off label {\n  margin: 1px -13px;\n}\n.has-switch-sm.has-switch:hover .switch-on label {\n  margin: 1px -11px;\n  width: 20px;\n}\n.has-switch-sm.has-switch:hover .switch-off label {\n  margin: 1px -13px;\n  width: 20px;\n}\n\n.dropzone-wrapper {\n  width: 100%;\n  border: #ced4da dashed 2px;\n  border-radius: 0.3rem;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  height: 230px;\n  transition: all 0.2s;\n}\n.dropzone-wrapper:hover {\n  border-color: #545cd8;\n}\n.dropzone-wrapper > div {\n  width: 100%;\n  height: 100%;\n  outline: none !important;\n  display: flex;\n  align-items: center;\n}\n.dropzone-wrapper.dropzone-wrapper-lg {\n  height: 300px;\n}\n.dropzone-wrapper.dropzone-wrapper-sm {\n  height: 150px;\n}\n.dropzone-wrapper input {\n  width: 100%;\n  height: 100%;\n}\n.dropzone-wrapper .dropzone-content {\n  margin: 0 auto;\n  color: #6c757d;\n}\n.dropzone-wrapper[aria-disabled=true] {\n  border-color: #dee2e6;\n}\n.dropzone-wrapper[aria-disabled=true] .dropzone-content {\n  color: #ced4da;\n}\n\n.rbt {\n  outline: none;\n}\n.rbt-menu {\n  margin-bottom: 2px;\n}\n.rbt-menu > li a {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rbt-menu > li a:focus {\n  outline: none;\n}\n.rbt-menu-pagination-option {\n  text-align: center;\n}\n.rbt .rbt-input-main::-ms-clear {\n  display: none;\n}\n.rbt-input-multi {\n  cursor: text;\n  overflow: hidden;\n  position: relative;\n}\n.rbt-input-multi.form-control[disabled] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.rbt-input-multi input::-moz-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.rbt-input-multi input:-ms-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi input::-webkit-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi .rbt-input-wrapper {\n  margin-top: 2px;\n  overflow: hidden;\n}\n.rbt-input-multi .rbt-input-main {\n  height: auto;\n}\n.rbt-input-multi .rbt-input-hint-container {\n  display: inline-block;\n}\n.rbt-input-multi.input-lg .rbt-input-main, .rbt-input-multi.form-control-lg .rbt-input-main {\n  height: auto;\n}\n.rbt-input-multi.input-sm .rbt-input-main, .rbt-input-multi.form-control-sm .rbt-input-main {\n  height: auto;\n}\n.rbt-close {\n  z-index: 1;\n}\n.rbt-close-lg {\n  font-size: 24px;\n}\n.rbt-token {\n  background-color: #e0f3ff;\n  border: 0;\n  border-radius: 0.25rem;\n  color: #545cd8;\n  display: inline-block;\n  line-height: 1em;\n  margin: 0 3px 3px 0;\n  padding: 4px 7px;\n  position: relative;\n}\n.rbt-token-disabled {\n  background-color: #f8f9fa;\n  color: #adb5bd;\n  pointer-events: none;\n}\n.rbt-token-removeable {\n  cursor: pointer;\n  padding-right: 21px;\n}\n.rbt-token-active {\n  background-color: #545cd8;\n  color: #fff;\n  outline: none;\n  text-decoration: none;\n}\n.rbt-token .rbt-token-remove-button {\n  bottom: 0;\n  color: #495057;\n  font-size: inherit;\n  font-weight: normal;\n  opacity: 1;\n  outline: none;\n  padding: 3px 7px;\n  position: absolute;\n  right: 0;\n  text-shadow: none;\n  top: -1px;\n}\n.rbt-loader {\n  -webkit-animation: loader-animation 600ms infinite linear;\n  -o-animation: loader-animation 600ms infinite linear;\n  animation: loader-animation 600ms infinite linear;\n  border: 1px solid #e0f3ff;\n  border-radius: 50%;\n  border-top-color: rgb(67.8431372549%, 87.5521821632%, 100%);\n  display: block;\n  height: 16px;\n  width: 16px;\n}\n.rbt-loader-lg {\n  height: 20px;\n  width: 20px;\n}\n.rbt-aux {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  bottom: 0;\n  justify-content: center;\n  pointer-events: none; /* Don't block clicks on the input */\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 34px;\n}\n.rbt-aux-lg {\n  width: 46px;\n}\n.rbt-aux .rbt-close {\n  margin-top: -1px;\n  pointer-events: auto; /* Override pointer-events: none; above */\n}\n.has-aux .rbt-input {\n  padding-right: 34px;\n}\n.rbt-highlight-text {\n  background-color: inherit;\n  color: inherit;\n  font-weight: bold;\n  padding: 0;\n}\n\n/* Input Groups */\n.input-group > .rbt {\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.input-group > .rbt .rbt-input-hint-container {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n.input-group > .rbt .rbt-input-hint {\n  z-index: 5;\n}\n.input-group > .rbt .rbt-aux {\n  z-index: 5;\n}\n.input-group > .rbt:not(:first-child) .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .rbt:not(:last-child) .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n@keyframes loader-animation {\n  to {\n    transform: rotate(1turn);\n  }\n}\n@-webkit-keyframes loader-animation {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n.input-group > .rbt .rbt-input-hint-container {\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  height: 100%;\n}\n\n.rw-btn,\n.rw-input-reset,\n.rw-input,\n.rw-filter-input,\n.rw-dropdown-list-autofill {\n  color: inherit;\n  padding: 0;\n  margin: 0;\n  border: none;\n  box-shadow: none;\n  background: none;\n  background-image: none;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n}\n\n.rw-btn::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\n\nselect.rw-input, select.rw-filter-input, select.rw-dropdown-list-autofill {\n  text-transform: none;\n}\n\nhtml input[type=button].rw-input, html input[type=button].rw-filter-input, html input[type=button].rw-dropdown-list-autofill {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\ntextarea.rw-input, textarea.rw-filter-input, textarea.rw-dropdown-list-autofill {\n  overflow: auto;\n  resize: vertical;\n}\n\nbutton[disabled].rw-input, button[disabled].rw-filter-input, button[disabled].rw-dropdown-list-autofill,\nfieldset[disabled] .rw-input,\nfieldset[disabled] .rw-filter-input,\nfieldset[disabled] .rw-dropdown-list-autofill,\nhtml input[disabled].rw-input,\nhtml input[disabled].rw-filter-input,\nhtml input[disabled].rw-dropdown-list-autofill {\n  cursor: not-allowed;\n}\n\nbutton.rw-input::-moz-focus-inner, button.rw-filter-input::-moz-focus-inner, button.rw-dropdown-list-autofill::-moz-focus-inner,\ninput.rw-input::-moz-focus-inner,\ninput.rw-filter-input::-moz-focus-inner,\ninput.rw-dropdown-list-autofill::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\ninput[type=checkbox],\ninput[type=radio] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\n/* -------------- */\n@font-face {\n  font-family: \"RwWidgets\";\n  font-weight: normal;\n  font-style: normal;\n  src: url(\"components/react-widgets/fonts/rw-widgets.eot?v=4.1.0\");\n  src: url(\"components/react-widgets/fonts/rw-widgets.eot?#iefix&v=4.1.0\") format(\"embedded-opentype\"), url(\"components/react-widgets/fonts/rw-widgets.woff?v=4.1.0\") format(\"woff\"), url(\"components/react-widgets/fonts/rw-widgets.ttf?v=4.1.0\") format(\"truetype\"), url(\"components/react-widgets/fonts/rw-widgets.svg?v=4.1.0#fontawesomeregular\") format(\"svg\");\n}\n.rw-i {\n  display: inline-block;\n  color: #495057;\n  font-family: RwWidgets;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\n.rw-i-caret-down:before {\n  content: \"\\e803\";\n}\n\n.rw-i-caret-up:before {\n  content: \"\\e800\";\n}\n\n.rw-i-chevron-left:before {\n  content: \"\\f104\";\n}\n\n.rw-i-chevron-right:before {\n  content: \"\\f105\";\n}\n\n.rw-i-clock-o:before {\n  content: \"\\e805\";\n}\n\n.rw-i-calendar:before {\n  content: \"\\e804\";\n}\n\n.rw-i-search:before {\n  content: \"\\e801\";\n}\n\n/* for debugging */\n@keyframes react-widgets-autofill-start {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n@keyframes react-widgets-autofill-cancel {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n.rw-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.rw-widget {\n  background-clip: border-box;\n  border: none;\n  color: #333333;\n  font-size: 1em;\n  font-family: inherit;\n  outline: none;\n  position: relative;\n}\n.rw-widget > .rw-widget-container {\n  width: 100%;\n  margin: 0;\n}\n\n.rw-widget-container {\n  background-color: #fff;\n  border: #ced4da 1px solid;\n  border-radius: 0.25rem;\n}\n.rw-widget-container.rw-state-focus, .rw-widget-container.rw-state-focus:hover, .rw-state-focus > .rw-widget-container, .rw-state-focus > .rw-widget-container:hover {\n  background-color: #fff;\n  border-color: #545cd8;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.rw-widget-container.rw-state-readonly, .rw-state-readonly > .rw-widget-container {\n  cursor: not-allowed;\n}\n.rw-widget-container.rw-state-disabled, .rw-widget-container.rw-state-disabled:hover, .rw-widget-container.rw-state-disabled:active, .rw-state-disabled > .rw-widget-container, .rw-state-disabled > .rw-widget-container:hover, .rw-state-disabled > .rw-widget-container:active, fieldset[disabled] .rw-widget-container, fieldset[disabled] .rw-widget-container:hover, fieldset[disabled] .rw-widget-container:active {\n  box-shadow: none;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.rw-widget-picker {\n  position: relative;\n  overflow: hidden;\n  border-collapse: separate;\n  display: inline-table;\n  height: calc(1.5em + 0.75rem + 2px);\n}\n.rw-widget-picker > * {\n  position: relative;\n  border: none;\n  outline: none;\n  width: 100%;\n  height: 100%;\n  display: table-cell;\n}\n.rw-widget-picker > .rw-select {\n  width: 1%;\n  white-space: nowrap;\n}\n.rw-open > .rw-widget-picker {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rw-open-up > .rw-widget-picker {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\nfieldset[disabled] .rw-widget-picker, .rw-state-disabled > .rw-widget-picker {\n  background-color: rgb(93.5%, 93.5%, 93.5%);\n}\n\n.rw-select {\n  cursor: pointer;\n}\n.rw-select > * {\n  width: 1.9em;\n}\n.rw-state-readonly .rw-select, .rw-state-disabled .rw-select {\n  cursor: not-allowed;\n}\n\n.rw-select-bordered {\n  cursor: pointer;\n}\n.rw-select-bordered:hover, .rw-select-bordered:active {\n  background-color: #e0f3ff;\n}\n.rw-select-bordered:hover .rw-i, .rw-select-bordered:active .rw-i {\n  color: #545cd8;\n}\n.rw-select-bordered:active {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.rw-state-disabled .rw-select-bordered, .rw-state-disabled .rw-select-bordered:hover, .rw-state-disabled .rw-select-bordered:active, .rw-state-readonly .rw-select-bordered, .rw-state-readonly .rw-select-bordered:hover, .rw-state-readonly .rw-select-bordered:active, fieldset[disabled] .rw-select-bordered, fieldset[disabled] .rw-select-bordered:hover, fieldset[disabled] .rw-select-bordered:active {\n  cursor: not-allowed;\n  background-color: inherit;\n  background-image: none;\n  box-shadow: none;\n}\n.rw-state-disabled .rw-select-bordered .rw-i, .rw-state-disabled .rw-select-bordered:hover .rw-i, .rw-state-disabled .rw-select-bordered:active .rw-i, .rw-state-readonly .rw-select-bordered .rw-i, .rw-state-readonly .rw-select-bordered:hover .rw-i, .rw-state-readonly .rw-select-bordered:active .rw-i, fieldset[disabled] .rw-select-bordered .rw-i, fieldset[disabled] .rw-select-bordered:hover .rw-i, fieldset[disabled] .rw-select-bordered:active .rw-i {\n  color: inherit;\n}\n.rw-select-bordered {\n  border: none;\n  border-left: #ced4da 1px solid;\n}\n.rw-rtl .rw-select-bordered {\n  border-right: #ced4da 1px solid;\n  border-left: none;\n}\n\n.rw-rtl {\n  direction: rtl;\n}\n\n.rw-input-reset::-moz-placeholder, .rw-input::-moz-placeholder, .rw-filter-input::-moz-placeholder, .rw-dropdown-list-autofill::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.rw-input-reset:-ms-input-placeholder, .rw-input:-ms-input-placeholder, .rw-filter-input:-ms-input-placeholder, .rw-dropdown-list-autofill:-ms-input-placeholder {\n  color: #999;\n}\n.rw-input-reset::-webkit-input-placeholder, .rw-input::-webkit-input-placeholder, .rw-filter-input::-webkit-input-placeholder, .rw-dropdown-list-autofill::-webkit-input-placeholder {\n  color: #999;\n}\n.rw-input-reset, .rw-input, .rw-filter-input, .rw-dropdown-list-autofill {\n  outline: 0;\n}\n\n.rw-input, .rw-filter-input, .rw-dropdown-list-autofill {\n  color: #495057;\n  padding: 0 0.857em;\n  background-color: #fff;\n}\n.rw-input[type=text]::-ms-clear, [type=text].rw-filter-input::-ms-clear, [type=text].rw-dropdown-list-autofill::-ms-clear {\n  display: none;\n}\n.rw-input[disabled], [disabled].rw-filter-input, [disabled].rw-dropdown-list-autofill, fieldset[disabled] .rw-input, fieldset[disabled] .rw-filter-input, fieldset[disabled] .rw-dropdown-list-autofill {\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n  background-color: rgb(93.5%, 93.5%, 93.5%);\n  border-color: #ced4da;\n}\n.rw-input[readonly], [readonly].rw-filter-input, [readonly].rw-dropdown-list-autofill {\n  cursor: not-allowed;\n}\n\n.rw-i.rw-loading {\n  display: block;\n  background: url(\"components/react-widgets/img/loading.gif\") no-repeat center;\n  min-width: 16px;\n  width: 1.9em;\n  height: 16px;\n}\n.rw-i.rw-loading:before {\n  content: \"\";\n}\n\n.rw-placeholder {\n  color: #999;\n}\n\n.rw-detect-autofill:-webkit-autofill {\n  animation-name: react-widgets-autofill-start;\n  transition: background-color 50000s ease-in-out 0s;\n}\n.rw-detect-autofill:not(:-webkit-autofill) {\n  animation-name: react-widgets-autofill-cancel;\n}\n\n.rw-webkit-autofill .rw-widget-container,\n.rw-input:-webkit-autofill,\n.rw-filter-input:-webkit-autofill,\n.rw-dropdown-list-autofill:-webkit-autofill {\n  background-color: rgb(250, 255, 189) !important;\n  background-image: none !important;\n  color: rgb(0, 0, 0) !important;\n}\n\n.rw-widget-input, .rw-filter-input {\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n\n.rw-widget-input.rw-state-focus, .rw-state-focus.rw-filter-input {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25), inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n\n.rw-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: 1em;\n  outline: 0;\n  overflow: auto;\n  max-height: 200px;\n}\n\n.rw-list-option {\n  user-select: none;\n  color: #333333;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n.rw-list-option.rw-state-focus, .rw-list-option.rw-state-focus:hover {\n  background-color: #545cd8;\n  border-color: #545cd8;\n  color: #e0f3ff;\n}\n.rw-list-option.rw-state-focus:hover, .rw-list-option.rw-state-focus:hover:hover {\n  background-color: #545cd8;\n  border-color: #545cd8;\n  color: #e0f3ff;\n}\n.rw-list-option:hover, .rw-list-option:hover.rw-state-focus {\n  background-color: #e0f3ff;\n  border-color: #e0f3ff;\n  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);\n}\n.rw-list-option.rw-state-selected, .rw-list-option.rw-state-selected:hover {\n  background-color: #545cd8;\n  border-color: #545cd8;\n  color: #fff;\n}\nfieldset[disabled] .rw-list-option, .rw-list-option.rw-state-disabled, .rw-list-option.rw-state-readonly {\n  box-shadow: none;\n  cursor: not-allowed;\n  color: #999999;\n  filter: alpha(opacity=7);\n  opacity: 0.7;\n}\nfieldset[disabled] .rw-list-option:hover, .rw-list-option.rw-state-disabled:hover, .rw-list-option.rw-state-readonly:hover {\n  background: none;\n  border-color: transparent;\n}\n\n.rw-list-empty,\n.rw-list-option,\n.rw-list-optgroup {\n  padding: 0.4rem 1.5rem;\n  outline: 0;\n}\n\n.rw-list-optgroup {\n  font-weight: bold;\n  padding-top: 7px;\n}\n\n.rw-list-option-create {\n  border-top: 1px #ced4da solid;\n}\n\n.rw-dropdown-list-autofill {\n  padding: 0;\n}\n\n.rw-dropdown-list .rw-select,\n.rw-dropdown-list .rw-select .rw-btn {\n  height: 100%;\n}\n\n.rw-dropdown-list-input {\n  background-color: transparent;\n  vertical-align: middle;\n  padding-right: 0;\n  /* ellipsis */\n}\n.rw-dropdown-list-input {\n  max-width: 1px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.rw-rtl .rw-dropdown-list-input {\n  padding-right: 0.857em;\n  padding-left: 0;\n}\n\n.rw-filter-input {\n  position: relative;\n  margin: 4px;\n  padding-right: 0;\n}\n.rw-filter-input .rw-rtl {\n  padding-right: 0.857em;\n  padding-left: 0;\n}\n.rw-filter-input .rw-select,\n.rw-filter-input .rw-btn {\n  opacity: 0.75;\n  filter: alpha(opacity=75);\n  cursor: text;\n}\n.rw-filter-input > .rw-select, .rw-filter-input > .rw-select:active, .rw-filter-input > .rw-select:hover {\n  background: none;\n  cursor: initial;\n  box-shadow: none;\n}\n\n.rw-number-picker .rw-btn {\n  cursor: pointer;\n}\n.rw-number-picker .rw-btn:hover, .rw-number-picker .rw-btn:active {\n  background-color: #e0f3ff;\n}\n.rw-number-picker .rw-btn:hover .rw-i, .rw-number-picker .rw-btn:active .rw-i {\n  color: #545cd8;\n}\n.rw-number-picker .rw-btn:active {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.rw-state-disabled .rw-number-picker .rw-btn, .rw-state-disabled .rw-number-picker .rw-btn:hover, .rw-state-disabled .rw-number-picker .rw-btn:active, .rw-state-readonly .rw-number-picker .rw-btn, .rw-state-readonly .rw-number-picker .rw-btn:hover, .rw-state-readonly .rw-number-picker .rw-btn:active, fieldset[disabled] .rw-number-picker .rw-btn, fieldset[disabled] .rw-number-picker .rw-btn:hover, fieldset[disabled] .rw-number-picker .rw-btn:active {\n  cursor: not-allowed;\n  background-color: inherit;\n  background-image: none;\n  box-shadow: none;\n}\n.rw-state-disabled .rw-number-picker .rw-btn .rw-i, .rw-state-disabled .rw-number-picker .rw-btn:hover .rw-i, .rw-state-disabled .rw-number-picker .rw-btn:active .rw-i, .rw-state-readonly .rw-number-picker .rw-btn .rw-i, .rw-state-readonly .rw-number-picker .rw-btn:hover .rw-i, .rw-state-readonly .rw-number-picker .rw-btn:active .rw-i, fieldset[disabled] .rw-number-picker .rw-btn .rw-i, fieldset[disabled] .rw-number-picker .rw-btn:hover .rw-i, fieldset[disabled] .rw-number-picker .rw-btn:active .rw-i {\n  color: inherit;\n}\n.rw-number-picker .rw-btn {\n  height: calc(calc(1.5em + 0.75rem + 2px)/2 - 1px);\n  /** ie8 fallback **/\n  margin-top: -1px\\9 ;\n  height: calc(1.5em + 0.75rem + 2px)/2\\9 ;\n  /** --- **/\n  line-height: calc(1.5em + 0.75rem + 2px)/2;\n  line-height: calc(calc(1.5em + 0.75rem + 2px)/2 - 1px);\n  display: block;\n  border: none;\n}\n.rw-number-picker .rw-select {\n  vertical-align: middle;\n}\n.rw-number-picker .rw-select:hover, .rw-number-picker .rw-select:active {\n  box-shadow: none;\n}\n\n.rw-select-list {\n  overflow: auto;\n  position: relative;\n}\n.rw-select-list .rw-list {\n  max-height: none;\n  font-size: 1em;\n}\n\n.rw-select-list-label {\n  display: block;\n  position: relative;\n  font-weight: normal;\n  cursor: inherit;\n  padding-left: 20px;\n  margin: 0;\n}\n.rw-rtl .rw-select-list-label {\n  padding-left: 0;\n  padding-right: 20px;\n}\n\ninput.rw-select-list-input {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  top: 0.1em/9;\n  margin: 0;\n  line-height: normal;\n  cursor: inherit;\n}\n.rw-rtl input.rw-select-list-input {\n  left: auto;\n  right: 0;\n}\n\n.rw-loading-mask {\n  content: \"\";\n  background: url(\"components/react-widgets/img/loader-big.gif\") no-repeat center;\n  position: absolute;\n  background-color: #fff;\n  border-radius: 0.25rem;\n  opacity: 0.7;\n  filter: alpha(opacity=70);\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.rw-multiselect {\n  cursor: text;\n}\n.rw-multiselect .rw-input-reset, .rw-multiselect .rw-input, .rw-multiselect .rw-dropdown-list-autofill, .rw-multiselect .rw-filter-input {\n  height: calc(calc(1.5em + 0.75rem + 2px) - 2px);\n  /** ie8 fallback **/\n  margin-top: -2px\\9 ;\n  height: calc(1.5em + 0.75rem + 2px)\\9 ;\n  /** --- **/\n  border-width: 0;\n  width: auto;\n  max-width: 100%;\n  padding: 0 0.857em;\n}\n.rw-multiselect .rw-select, .rw-multiselect .rw-select:hover, .rw-multiselect .rw-select:active {\n  box-shadow: none;\n  background: none;\n}\n\n.rw-multiselect-taglist {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: inline;\n  outline: none;\n}\n\n.rw-multiselect-tag {\n  display: inline-table;\n  color: #212529;\n  padding: 0 0.35em 0 0.35em;\n  margin-left: calc(calc(1.5em + 0.75rem + 2px)/5 - 1px);\n  margin-top: calc(calc(1.5em + 0.75rem + 2px)/5 - 1px);\n  height: calc(1.5em + 0.75rem + 2px)/1.5;\n  border-radius: 0.2rem;\n  background-color: #e0f3ff;\n  border: 1px solid rgb(57.8431372549%, 83.6812144213%, 100%);\n  cursor: default;\n  vertical-align: top;\n  text-align: center;\n  overflow: hidden;\n  max-width: 100%;\n}\n.rw-multiselect-tag > * {\n  display: table-cell;\n  vertical-align: middle;\n  height: 100%;\n}\n.rw-rtl .rw-multiselect-tag {\n  margin-left: 0;\n  margin-right: calc(calc(1.5em + 0.75rem + 2px)/5 - 1px);\n  padding: 0 0.35em 0 0.35em;\n}\n.rw-multiselect-tag.rw-state-focus, .rw-multiselect-tag.rw-state-focus:hover {\n  background-color: #545cd8;\n  border-color: #545cd8;\n  color: #e0f3ff;\n}\n.rw-multiselect-tag.rw-state-readonly, .rw-multiselect-tag.rw-state-disabled, .rw-state-readonly .rw-multiselect-tag, .rw-state-disabled .rw-multiselect-tag, fieldset[disabled] .rw-multiselect-tag {\n  cursor: not-allowed;\n}\n.rw-multiselect-tag.rw-state-disabled, .rw-state-disabled .rw-multiselect-tag, fieldset[disabled] .rw-multiselect-tag {\n  opacity: 0.65;\n  filter: alpha(opacity=65);\n}\nfieldset[disabled] .rw-multiselect-tag {\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.rw-multiselect-tag-btn {\n  color: #212529;\n  margin-left: 0.25em;\n}\n.rw-rtl .rw-multiselect-tag-btn {\n  margin-left: 0;\n  margin-right: 0.25em;\n}\n\n.rw-popup-container {\n  position: absolute;\n  z-index: 1005;\n  top: 100%;\n  left: -6px;\n  right: -6px;\n}\n.rw-popup-container.rw-dropup {\n  top: auto;\n  bottom: 100%;\n}\n.rw-state-focus .rw-popup-container {\n  z-index: 1006;\n}\n\n.rw-popup-transition {\n  width: 100%;\n  margin-bottom: 6px;\n  padding: 0 6px;\n}\n.rw-dropup > .rw-popup-transition {\n  margin-bottom: 0;\n  margin-top: 6px;\n}\n\n.rw-popup {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n  border: #ced4da 1px solid;\n  background: #fff;\n}\n.rw-dropup .rw-popup {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.2rem;\n  border-top-left-radius: 0.2rem;\n  box-shadow: 0 -0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 -0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 -0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 -0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n\n.rw-popup-transition {\n  transition: transform 200ms;\n}\n\n.rw-popup-transition-entering {\n  overflow: hidden;\n}\n.rw-popup-transition-entering .rw-popup-transition {\n  transform: translateY(0);\n  transition-timing-function: ease-out;\n}\n\n.rw-popup-transition-exiting .rw-popup-transition {\n  transition-timing-function: ease-in;\n}\n\n.rw-popup-transition-exiting,\n.rw-popup-transition-exited {\n  overflow: hidden;\n}\n.rw-popup-transition-exiting .rw-popup-transition,\n.rw-popup-transition-exited .rw-popup-transition {\n  transform: translateY(-100%);\n}\n.rw-popup-transition-exiting.rw-dropup .rw-popup-transition,\n.rw-popup-transition-exited.rw-dropup .rw-popup-transition {\n  transform: translateY(100%);\n}\n\n.rw-popup-transition-exited {\n  display: none;\n}\n\n.rw-state-disabled {\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.ui-theme-settings {\n  position: fixed;\n  z-index: 155;\n  right: -30px;\n  top: 0;\n  height: 100vh;\n  transform: translate(500px);\n  transition: all 0.2s;\n  box-shadow: -0.46875rem 0 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), -0.9375rem 0 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), -0.25rem 0 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), -0.125rem 0 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n}\n.ui-theme-settings .btn-open-options {\n  border-radius: 50px;\n  position: absolute;\n  left: -114px;\n  bottom: 80px;\n  padding: 0;\n  height: 54px;\n  line-height: 54px;\n  width: 54px;\n  text-align: center;\n  display: block;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n  margin-top: -27px;\n}\n.ui-theme-settings .btn-open-options svg {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  margin: -0.5em 0 0 -0.5em;\n}\n.ui-theme-settings .theme-settings__inner {\n  background: #fff;\n  width: 500px;\n  height: 100vh;\n  padding: 0;\n}\n.ui-theme-settings.settings-open {\n  transform: translate(0);\n  right: 0;\n}\n.ui-theme-settings .theme-settings-swatches {\n  text-align: center;\n}\n.ui-theme-settings .theme-settings-swatches .swatch-holder-img {\n  width: 72px;\n  height: auto;\n  border-radius: 3px;\n}\n.ui-theme-settings .theme-settings-swatches .swatch-holder-img img {\n  width: 100%;\n}\n.ui-theme-settings .themeoptions-heading {\n  font-size: 1.1rem;\n  color: #495057;\n  margin: 0;\n  background: #f8f9fa;\n  padding: 0.75rem 1.5rem;\n  border-bottom: #dee2e6 solid 1px;\n  border-top: #dee2e6 solid 1px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.ui-theme-settings .themeoptions-heading:first-child {\n  border-top: 0;\n}\n.ui-theme-settings .list-group-item h5 {\n  color: #545cd8;\n  font-size: 0.968rem;\n  text-transform: uppercase;\n  margin: 0;\n  text-align: center;\n}\n\n.swatch-holder {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  margin: 5px 5px 0;\n  transition: all 0.2s;\n  opacity: 0.7;\n  display: inline-block;\n  border-radius: 30px;\n}\n.swatch-holder.active {\n  border: #fff solid 2px;\n  box-shadow: 0 0 0 5px #545cd8;\n  opacity: 1;\n}\n.swatch-holder:hover {\n  opacity: 1;\n}\n\n.swatch-holder-lg {\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n}\n\n.font-icon-wrapper {\n  text-align: center;\n  border: #e9ecef solid 1px;\n  border-radius: 0.25rem;\n  margin: 0 0 10px;\n  padding: 5px;\n}\n.font-icon-wrapper.font-icon-lg {\n  float: left;\n  padding: 10px;\n  text-align: center;\n  margin-right: 15px;\n  min-width: 64px;\n}\n.font-icon-wrapper.font-icon-lg i {\n  font-size: 2.5rem;\n}\n.font-icon-wrapper:hover {\n  background: #f8f9fa;\n  color: #545cd8;\n}\n.font-icon-wrapper:hover p {\n  color: #6c757d;\n}\n.font-icon-wrapper i {\n  font-size: 1.65rem;\n}\n.font-icon-wrapper p {\n  color: #adb5bd;\n  font-size: 0.8066666667rem;\n  margin: 5px 0 0;\n}\n\n.btn-icon-vertical {\n  min-width: 100px;\n}\n\n.card.mb-3 {\n  margin-bottom: 30px !important;\n}\n\n.demo-image-bg {\n  height: 350px;\n  margin-bottom: 30px;\n}\n\n.loader-wrapper {\n  width: 150px;\n  height: 100px;\n  float: left;\n}\n\n.slider-item {\n  background: #dee2e6;\n  border-radius: 0.25rem;\n  color: #6c757d;\n  font-size: 36px;\n  padding: 0;\n  position: relative;\n  height: 150px;\n  line-height: 150px;\n  text-align: center;\n  margin: 0 1.5rem;\n  transition: all 0.2s;\n}\n\n.slick-center .slider-item {\n  background: #adb5bd;\n  color: #495057;\n}\n\n.after-img {\n  max-width: 100%;\n}\n\n@media only screen and (max-width: 1320px) {\n  .header-user-info {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-main {\n    display: block;\n  }\n  .dropdown-menu::before, .dropdown-menu::after {\n    display: none;\n  }\n  .app-sidebar {\n    flex: 0 0 280px !important;\n    width: 280px !important;\n    transform: translateX(-280px);\n  }\n  .app-sidebar .app-header__logo {\n    display: none;\n  }\n  .sidebar-mobile-open .app-sidebar {\n    transform: translateX(0);\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading {\n    text-indent: initial;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {\n    display: none;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-link {\n    text-indent: initial;\n    padding: 0 1.5rem 0 45px;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-icon {\n    text-indent: initial;\n    left: 5px;\n    margin-left: 0;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-state-icon {\n    visibility: visible;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible {\n    padding: 0.5em 0 0 2rem;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {\n    height: 2.3em;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {\n    padding-left: 1em;\n  }\n  .sidebar-mobile-open .app-sidebar .app-header__logo {\n    width: auto !important;\n  }\n  .sidebar-mobile-open .app-sidebar .app-header__logo .logo-src {\n    width: 97px !important;\n    margin-left: auto;\n    margin-right: 0;\n  }\n  .sidebar-mobile-open .fixed-sidebar .app-sidebar {\n    height: 100%;\n  }\n  .sidebar-mobile-open .sidebar-mobile-overlay {\n    display: block;\n  }\n  .app-main .app-main__outer {\n    padding-left: 0 !important;\n    width: auto;\n  }\n  .app-header {\n    justify-content: space-between;\n  }\n  .app-header .app-header__logo {\n    display: none;\n    order: 2;\n    background: transparent !important;\n    border: 0 !important;\n  }\n  .app-header .app-header__content {\n    visibility: hidden;\n    opacity: 0;\n    box-shadow: 0 0.46875rem 2.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.9375rem 1.40625rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03), 0 0.25rem 0.53125rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.05), 0 0.125rem 0.1875rem rgba(3.2773109244%, 3.9495798319%, 14.3697478992%, 0.03);\n    position: absolute;\n    left: 5%;\n    width: 90%;\n    top: 0;\n    transition: all 0.2s;\n    background: #fff;\n    border-radius: 50px;\n    padding: 0 10px;\n    overflow: hidden;\n  }\n  .app-header .app-header__content .header-btn-lg {\n    margin-left: 0.5rem;\n    padding: 0 0.5rem;\n  }\n  .app-header .app-header__content .header-btn-lg .hamburger-box {\n    margin-top: 5px;\n  }\n  .app-header .app-header__content .header-btn-lg + .header-btn-lg {\n    display: none;\n  }\n  .app-header .app-header__content .app-header-left .nav {\n    display: none;\n  }\n  .app-header .app-header__content.header-mobile-open {\n    visibility: visible;\n    opacity: 1;\n    top: 80px;\n  }\n  .app-header .app-header__mobile-menu {\n    display: flex;\n    order: 1;\n  }\n  .app-header .app-header__menu {\n    display: flex;\n    order: 3;\n  }\n  .app-header.header-text-light .app-header__menu > span .btn, .app-header.header-text-light .app-header__menu > .btn {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n  .app-header.header-text-light .header-mobile-open {\n    background: #343a40;\n  }\n  .popover,\n  .dropdown-menu {\n    position: fixed !important;\n    z-index: 50;\n    left: 5% !important;\n    top: 50% !important;\n    width: 90% !important;\n    transform: translateY(-50%) !important;\n    min-width: 10px !important;\n  }\n  .popover .btn-icon-vertical .btn-icon-wrapper,\n  .dropdown-menu .btn-icon-vertical .btn-icon-wrapper {\n    display: none;\n  }\n  .popover {\n    max-width: initial;\n  }\n  .popover .arrow {\n    display: none !important;\n  }\n  .app-page-title {\n    text-align: center;\n  }\n  .app-page-title .page-title-heading,\n  .app-page-title .page-title-wrapper {\n    margin: 0 auto;\n    display: block;\n  }\n  .app-page-title .page-title-actions {\n    margin: 15px auto 0;\n  }\n  .app-page-title .page-title-actions .breadcrumb-item,\n  .app-page-title .page-title-actions .breadcrumb,\n  .app-page-title .page-title-subheading .breadcrumb-item,\n  .app-page-title .page-title-subheading .breadcrumb {\n    display: inline-block;\n  }\n  .app-footer .app-footer__inner .app-footer-right {\n    display: none;\n  }\n  .app-footer .app-footer__inner .app-footer-left {\n    width: 100%;\n  }\n  .app-footer .app-footer__inner .app-footer-left .footer-dots {\n    margin: 0 auto;\n  }\n  .fixed-footer.closed-sidebar .app-footer .app-footer__inner {\n    margin-left: 0 !important;\n  }\n  .widget-content .widget-numbers {\n    font-size: 1.6rem;\n    line-height: 1;\n  }\n  .slick-slider-sm .slick-slider {\n    max-width: 650px !important;\n  }\n  .body-tabs.body-tabs-layout.body-tabs-big {\n    display: block !important;\n  }\n  .body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {\n    display: inline-block !important;\n    padding: 0 1.5rem !important;\n  }\n  .body-tabs.body-tabs-layout.body-tabs-big .RRT__showmore {\n    margin-top: -20px;\n  }\n  .ReactTable .-pagination .-center {\n    display: none;\n  }\n  .ReactTable .-pagination .-previous {\n    padding-right: 3px;\n  }\n  .bg-transparent.list-group-item {\n    border-color: transparent;\n  }\n  .tabs-lg-alternate.card-header > .nav .nav-item .widget-number {\n    font-size: 1.5rem;\n  }\n  .page-title-head {\n    display: block;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-page-title .page-title-icon,\n  .ui-theme-settings {\n    display: none;\n  }\n  .card-header.responsive-center {\n    display: block;\n    text-align: center;\n    height: auto;\n    padding: 1.5rem;\n  }\n  .card-header.responsive-center .nav,\n  .card-header.responsive-center .btn-actions-pane-right {\n    margin: 0.75rem 0 0;\n  }\n  .card-header.responsive-center .nav .d-inline-block.ml-2,\n  .card-header.responsive-center .btn-actions-pane-right .d-inline-block.ml-2 {\n    width: 100% !important;\n    text-align: left;\n    margin: 0 !important;\n  }\n  .slick-slider-sm .slick-slider {\n    max-width: 650px !important;\n  }\n}\n@media (min-width: 992px) {\n  .slick-slider-sm .slick-slider {\n    max-width: 850px !important;\n  }\n}\n@media (max-width: 1199.98px) {\n  .-hide-paging .-pagination .-center {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-main .app-main__inner {\n    padding: 15px 15px 0;\n  }\n  .mbg-3,\n  body .card.mb-3 {\n    margin-bottom: 15px !important;\n  }\n  .app-page-title {\n    padding: 15px;\n    margin: -15px -15px 30px;\n  }\n  .body-tabs.body-tabs-layout {\n    margin-left: -15px;\n    margin-right: -15px;\n    padding: 0 15px;\n  }\n  .app-main .app-main__inner > .RRT__container > .RRT__panel {\n    margin-top: 15px;\n  }\n  .popover,\n  .dropdown-menu {\n    width: 80%;\n    left: 10%;\n  }\n  body .card-header {\n    height: auto;\n    display: block;\n    padding: 0.75rem 1.5rem;\n    text-align: center;\n  }\n  body .card-header .btn-actions-pane-right {\n    padding: 0.75rem 0 0;\n  }\n  body .card-header .actions-icon-btn {\n    padding: 0;\n  }\n  .card-header.card-header-tab .card-header-title {\n    display: inline-flex !important;\n    line-height: 1;\n  }\n  .card-header.card-header-tab > .nav {\n    margin: 0.75rem 0 -0.75rem;\n    display: table !important;\n    width: 100%;\n  }\n  .card-header.card-header-tab > .nav .nav-item {\n    display: table-cell;\n  }\n  .header-icon {\n    display: none;\n  }\n  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right,\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {\n    display: block;\n    text-align: center;\n  }\n  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper,\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {\n    margin-right: 0 !important;\n  }\n  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane,\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {\n    margin-top: 1rem;\n  }\n  .slick-slider-sm .slick-slider .slick-prev {\n    left: 15px;\n  }\n  .slick-slider-sm .slick-slider .slick-next {\n    right: 15px;\n  }\n}\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {\n    display: block;\n    text-align: center;\n  }\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {\n    margin-right: 0 !important;\n  }\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {\n    margin-top: 1rem;\n  }\n}\n.off-overflow .rt-table {\n  overflow: unset !important;\n}\n\n#taskCKEditor .ck-editor__editable_inline {\n  min-height: 200px;\n}\n\n.custom-datetimepicker-task {\n  width: 400px;\n}\n\n#reportCKEditor .ck-editor__editable_inline {\n  min-height: 200px;\n}","// GENERIC\n\n$enable-caret: true;\n$enable-rounded: true;\n$enable-shadows: false;\n$enable-gradients: false;\n$enable-transitions: true;\n$enable-grid-classes: true;\n$enable-print-styles: false;\n\n$body-bg: #fff;\n\n// Colors\n\n$white: #fff;\n$gray-100: #f8f9fa;\n$gray-200: #e9ecef;\n$gray-300: #dee2e6;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #6c757d;\n$gray-700: #495057;\n$gray-800: #343a40;\n$gray-900: #212529;\n$black: #000;\n\n$grays: ();\n\n$grays: map-merge(\n                (\n                        \"100\": $gray-100,\n                        \"200\": $gray-200,\n                        \"300\": $gray-300,\n                        \"400\": $gray-400,\n                        \"500\": $gray-500,\n                        \"600\": $gray-600,\n                        \"700\": $gray-700,\n                        \"800\": $gray-800,\n                        \"900\": $gray-900\n                ),\n                $grays\n);\n\n//--#{$color}\n$brand: #545cd8;\n$blue: #86c6fb;\n$indigo: #444054;\n$purple: #83588a;\n$pink: #f65ca2;\n$red: #d92550;\n$orange: #fd7e14;\n$yellow: #f7b924;\n$green: #3ac47d;\n$teal: #16E0BD;\n$cyan: #30b1ff;\n$blue-light: #eeeeee;\n\n$primary: $brand;\n$secondary: $gray-600;\n$success: $green;\n$info: $cyan;\n$warning: $yellow;\n$danger: $red;\n$light: $blue-light;\n$dark: $gray-800;\n$focus: $indigo;\n$alt: $purple;\n\n$theme-colors: ();\n\n$theme-colors: map-merge(\n                (\n                        \"primary\": $primary,\n                        \"secondary\": $secondary,\n                        \"success\": $success,\n                        \"info\": $info,\n                        \"warning\": $warning,\n                        \"danger\": $danger,\n                        \"light\": $light,\n                        \"dark\": $dark,\n                        \"focus\": $focus,\n                        \"alternate\": $alt\n                ),\n                $theme-colors\n);\n\n// BOOTSTRAP OVERWRITES\n\n$headings-font-weight: 400;\n\n$font-size-base: 0.88rem;\n$font-size-lg: ($font-size-base * 1.25);\n$font-size-sm: ($font-size-base * 1.1);\n$font-size-xs: ($font-size-base / 1.1);\n\n$btn-transition: color .15s, background-color .15s, border-color .15s, box-shadow .15s;\n$btn-focus-width: 0;\n$btn-focus-box-shadow: none;\n\n$pagination-focus-box-shadow: none;\n\n$body-color: $gray-700;\n\n$card-cap-bg: $white;\n$card-border-color: rgba(darken($primary, 25%), .125);\n\n$dropdown-min-width: 15rem;\n$dropdown-link-hover-bg: #e0f3ff;\n$dropdown-item-padding-y: .4rem;\n$dropdown-padding-y: .65rem;\n\n$box-shadow-default: 0 0.46875rem 2.1875rem rgba(darken($primary, 50%), .03), 0 0.9375rem 1.40625rem rgba(darken($primary, 50%), .03), 0 0.25rem 0.53125rem rgba(darken($primary, 50%), .05), 0 0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\n\n$box-shadow-default-right: 0.46875rem 0 2.1875rem rgba(darken($primary, 50%), .03),\n0.9375rem 0 1.40625rem rgba(darken($primary, 50%), .03),\n0.25rem 0 0.53125rem rgba(darken($primary, 50%), .05),\n0.125rem 0 0.1875rem rgba(darken($primary, 50%), .03);\n\n$box-shadow-default-inverse: 0 -0.46875rem 2.1875rem rgba(darken($primary, 50%), .03), 0 -0.9375rem 1.40625rem rgba(darken($primary, 50%), .03), 0 -0.25rem 0.53125rem rgba(darken($primary, 50%), .05), 0 -0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\n\n$box-shadow-lg-default: 0 0.76875rem 2.4875rem rgba($gray-800, .3), 0 1.3375rem 1.70625rem rgba($gray-800, .3), 0 0.55rem 0.53125rem rgba(darken($gray-800, 50%), .05), 0 0.225rem 0.4375rem rgba($gray-800, .3);\n\n$form-check-input-margin-y: 0.3rem;\n\n$input-group-addon-bg: lighten($dropdown-link-hover-bg, 3%);\n\n// Tables\n\n$table-accent-bg: rgba($black, .03);\n$table-hover-bg: $dropdown-link-hover-bg;\n$table-active-bg: $table-hover-bg;\n$table-border-color: $gray-200;\n$table-head-bg: $gray-100;\n$table-head-color: $gray-600;\n$table-cell-padding: .55rem;\n$table-cell-padding-sm: .3rem;\n\n// Popovers\n\n$popover-max-width: 320px;\n$popover-box-shadow: $box-shadow-default;\n$popover-border-color: $card-border-color;\n$popover-header-bg: $white;\n\n// Color Modifiers\n\n$link-color: theme-color(\"primary\");\n$component-active-bg: theme-color(\"primary\");\n$custom-control-indicator-checked-disabled-bg: rgba(theme-color(\"primary\"), .5);\n$form-feedback-valid-color: theme-color(\"success\");\n$form-feedback-invalid-color: theme-color(\"danger\");\n$progress-bar-bg: theme-color(\"primary\");\n$input-btn-focus-color: rgba($component-active-bg, .25);\n$input-focus-border-color: lighten($component-active-bg, 25%);\n$custom-control-indicator-checked-bg: $component-active-bg;\n$custom-control-indicator-active-bg: lighten($component-active-bg, 35%);\n$custom-checkbox-indicator-indeterminate-bg: $component-active-bg;\n$custom-range-thumb-bg: $component-active-bg;\n$custom-range-thumb-active-bg: lighten($component-active-bg, 35%);\n$dropdown-link-active-bg: $component-active-bg;\n$nav-pills-link-active-bg: $component-active-bg;\n$pagination-active-bg: $component-active-bg;\n$list-group-active-bg: $component-active-bg;\n\n$list-group-border-color: rgba($primary, .08) !default;\n\n// Mixins\n\n@mixin box-shadow-architect($shadow) {\n  box-shadow: 0 0.66875rem 2.3875rem rgba($shadow, .03), 0 1.1375rem 1.60625rem rgba($shadow, .03), 0 0.45rem 0.73125rem rgba($shadow, .05), 0 0.325rem 0.3875rem rgba($shadow, .03);\n}\n\n// Border\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value;\n  }\n}\n\n// List Group\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n\n// Background\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n  }\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover {\n  &:hover { @content; }\n}\n\n@mixin hover-focus {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n}\n\n@mixin bg-gradient-variant($parent, $color) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n}\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable at-rule-no-vendor-prefix, declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Suppress the focus outline on elements that cannot be accessed via keyboard.\n// This prevents an unwanted focus outline from appearing around elements that\n// might still respond to pointer events.\n//\n// Credit: https://github.com/suitcss/base\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href)\n// which have not been made explicitly keyboard-focusable (without tabindex).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover-focus {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  // Matches default `<td>` alignment by inheriting from the `<body>`, or the\n  // closest parent with a set `text-align`.\n  text-align: inherit;\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 0;\n}\n\n// Work around a Firefox/IE bug where the transparent `button` background\n// results in a loss of the default `button` focus styles.\n//\n// Credit: https://github.com/suitcss/base/\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  // Remove the default appearance of temporal inputs to avoid a Mobile Safari\n  // bug where setting a custom line-height prevents text from being vertically\n  // centered within the input.\n  // See https://bugs.webkit.org/show_bug.cgi?id=139848\n  // and https://github.com/twbs/bootstrap/issues/11266\n  -webkit-appearance: listbox;\n}\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer / 2 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             80% !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n$table-dark-color:            $white !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    calc(#{$input-line-height * 1em} + #{$input-padding-y * 2}) !default;\n$input-height-inner-half:               calc(#{$input-line-height * .5em} + #{$input-padding-y}) !default;\n$input-height-inner-quarter:            calc(#{$input-line-height * .25em} + #{$input-padding-y / 2}) !default;\n\n$input-height:                          calc(#{$input-line-height * 1em} + #{$input-padding-y * 2} + #{$input-height-border}) !default;\n$input-height-sm:                       calc(#{$input-line-height-sm * 1em} + #{$input-btn-padding-y-sm * 2} + #{$input-height-border}) !default;\n$input-height-lg:                       calc(#{$input-line-height-lg * 1em} + #{$input-btn-padding-y-lg * 2} + #{$input-height-border}) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   none !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    none !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\"), \"#\", \"%23\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/%3e%3c/svg%3e\"), \"#\", \"%23\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   none !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='#{$custom-control-indicator-checked-color}'/%3e%3c/svg%3e\"), \"#\", \"%23\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size / 2 !default;\n$custom-switch-indicator-size:                  calc(#{$custom-control-indicator-size} - #{$custom-control-indicator-border-width * 4}) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\"), \"#\", \"%23\") !default;\n$custom-select-background:          $custom-select-indicator no-repeat right $custom-select-padding-x center / $custom-select-bg-size !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: calc((1em + #{2 * $custom-select-padding-y}) * 3 / 4 + #{$custom-select-padding-x + $custom-select-indicator-padding}) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// CreateNew validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\"), \"#\", \"%23\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='#{$form-feedback-icon-invalid-color}' viewBox='-2 -2 7 7'%3e%3cpath stroke='#{$form-feedback-icon-invalid-color}' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\"), \"#\", \"%23\") !default;\n\n$form-validation-states: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer / 2 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer / 2 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) / 2 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       str-replace(url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='#{$navbar-dark-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"), \"#\", \"%23\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      str-replace(url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"), \"#\", \"%23\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-100 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-600 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          calc(#{$card-border-radius} - #{$card-border-width}) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width / 2 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// CreateNew tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\"), \"#\", \"%23\") !default;\n$carousel-control-next-icon-bg:      str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e\"), \"#\", \"%23\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:         2rem !default;\n$spinner-height:        $spinner-width !default;\n$spinner-border-width:  .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated font-resizing\n//\n// See https://github.com/twbs/rfs\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n// Resize font-size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: $rfs-base-font-size / ($rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: $rfs-base-font-size / ($rfs-base-font-size * 0 + 1 / $rfs-rem-value);\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: $rfs-breakpoint / ($rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: $rfs-breakpoint / ($rfs-breakpoint * 0 + 1 / $rfs-rem-value);\n}\n\n// Responsive font-size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Variables for storing static and fluid rescaling\n    $rfs-static: null;\n    $rfs-fluid: null;\n\n    // Remove px-unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: $fs / ($fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: $fs / ($fs * 0 + 1 / $rfs-rem-value);\n    }\n\n    // Set default font-size\n    @if $rfs-font-size-unit == rem {\n      $rfs-static: #{$fs / $rfs-rem-value}rem#{$rfs-suffix};\n    }\n    @else if $rfs-font-size-unit == px {\n      $rfs-static: #{$fs}px#{$rfs-suffix};\n    }\n    @else {\n      @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n    }\n\n    // Only add media query if font-size is bigger as the minimum font-size\n    // If $rfs-factor == 1, no rescaling will take place\n    @if $fs > $rfs-base-font-size and $enable-responsive-font-sizes {\n      $min-width: null;\n      $variable-unit: null;\n\n      // Calculate minimum font-size for given font-size\n      $fs-min: $rfs-base-font-size + ($fs - $rfs-base-font-size) / $rfs-factor;\n\n      // Calculate difference between given font-size and minimum font-size for given font-size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      // No need to check if the unit is valid, because we did that before\n      $min-width: if($rfs-font-size-unit == rem, #{$fs-min / $rfs-rem-value}rem, #{$fs-min}px);\n\n      // If two-dimensional, use smallest of screen width and height\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{$fs-diff * 100 / $rfs-breakpoint}#{$variable-unit};\n\n      // Set the calculated font-size.\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n    }\n\n    // Rendering\n    @if $rfs-fluid == null {\n      // Only render static font-size if no fluid font-size is available\n      font-size: $rfs-static;\n    }\n    @else {\n      $mq-value: null;\n\n      // RFS breakpoint formatting\n      @if $rfs-breakpoint-unit == em or $rfs-breakpoint-unit == rem {\n        $mq-value: #{$rfs-breakpoint / $rfs-rem-value}#{$rfs-breakpoint-unit};\n      }\n      @else if $rfs-breakpoint-unit == px {\n        $mq-value: #{$rfs-breakpoint}px;\n      }\n      @else {\n        @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n      }\n\n      @if $rfs-class == \"disable\" {\n        // Adding an extra class increases specificity,\n        // which prevents the media query to override the font size\n        &,\n        .disable-responsive-font-size &,\n        &.disable-responsive-font-size {\n          font-size: $rfs-static;\n        }\n      }\n      @else {\n        font-size: $rfs-static;\n      }\n\n      @if $rfs-two-dimensional {\n        @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n          @if $rfs-class == \"enable\" {\n            .enable-responsive-font-size &,\n            &.enable-responsive-font-size {\n              font-size: $rfs-fluid;\n            }\n          }\n          @else {\n            font-size: $rfs-fluid;\n          }\n\n          @if $rfs-safari-iframe-resize-bug-fix {\n            // stylelint-disable-next-line length-zero-no-unit\n            min-width: 0vw;\n          }\n        }\n      }\n      @else {\n        @media (max-width: #{$mq-value}) {\n          @if $rfs-class == \"enable\" {\n            .enable-responsive-font-size &,\n            &.enable-responsive-font-size {\n              font-size: $rfs-fluid;\n            }\n          }\n          @else {\n            font-size: $rfs-fluid;\n          }\n\n          @if $rfs-safari-iframe-resize-bug-fix {\n            // stylelint-disable-next-line length-zero-no-unit\n            min-width: 0vw;\n          }\n        }\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixin uses RFS to rescale font sizes\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// stylelint-disable declaration-no-important, selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled;\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled;\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid;\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid;\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer / 2;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/#feat=css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-blacklist\n// Single side border-radius\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: $radius;\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n    border-top-right-radius: $radius;\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: $radius;\n    border-bottom-right-radius: $radius;\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: $radius;\n    border-bottom-left-radius: $radius;\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n    border-bottom-left-radius: $radius;\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: $radius;\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: $radius;\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: $radius;\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-break: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  .container {\n    @include make-container();\n    @include make-container-max-widths();\n  }\n}\n\n// Fluid container\n//\n// Utilizes the mixin meant for fixed width containers, but with 100% width for\n// fluid, full width layouts.\n\n@if $enable-grid-classes {\n  .container-fluid {\n    @include make-container();\n  }\n}\n\n// Row\n//\n// Rows contain and clear the floats of your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter / 2;\n  padding-left: $gutter / 2;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter / 2;\n  margin-left: -$gutter / 2;\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter / 2;\n  padding-left: $gutter / 2;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage($size / $columns);\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage($size / $columns);\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: $size / $columns;\n  margin-left: if($num == 0, 0, percentage($num));\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter / 2;\n    padding-left: $gutter / 2;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    // Allow columns to stretch full width below their breakpoints\n    @for $i from 1 through $columns {\n      .col#{$infix}-#{$i} {\n        @extend %grid-column;\n      }\n    }\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n      .col#{$infix}-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%; // Reset earlier grid tiers\n      }\n\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @include make-col($i, $columns);\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      // `$columns - 1` because offsetting by the width of an entire row isn't possible\n      @for $i from 0 through ($columns - 1) {\n        @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n          .offset#{$infix}-#{$i} {\n            @include make-col-offset($i, $columns);\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(odd) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus();\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\nselect.form-control {\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: calc(#{$input-padding-y} + #{$input-border-width});\n  padding-bottom: calc(#{$input-padding-y} + #{$input-border-width});\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: calc(#{$input-padding-y-lg} + #{$input-border-width});\n  padding-bottom: calc(#{$input-padding-y-lg} + #{$input-border-width});\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: calc(#{$input-padding-y-sm} + #{$input-border-width});\n  padding-bottom: calc(#{$input-padding-y-sm} + #{$input-border-width});\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding-top: $input-padding-y;\n  padding-bottom: $input-padding-y;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// CreateNew control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// CreateNew groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// CreateNew grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width / 2;\n  margin-left: -$form-grid-gutter-width / 2;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width / 2;\n    padding-left: $form-grid-gutter-width / 2;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// CreateNew validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-blacklist\n@mixin transition($transition...) {\n  @if $enable-transitions {\n    @if length($transition) == 0 {\n      transition: $transition-base;\n    } @else {\n      transition: $transition;\n    }\n  }\n\n  @if $enable-prefers-reduced-motion-media-query {\n    @media (prefers-reduced-motion: reduce) {\n      transition: none;\n    }\n  }\n}\n","// CreateNew control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus() {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\n    } @else {\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n}\n\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  .form-control {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: $icon;\n        background-repeat: no-repeat;\n        background-position: center right $input-height-inner-quarter;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right;\n        background: $custom-select-background, $icon $custom-select-bg no-repeat $custom-select-feedback-icon-position / $custom-select-feedback-icon-size;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n\n  .form-control-file {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .form-check-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active {\n    @include box-shadow($btn-active-box-shadow);\n\n    &:focus {\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n    box-shadow: none;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    } @else {\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret;\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y 0;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When enabled Popper.js, reset basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-padding-y $dropdown-item-padding-x;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down;\n      } @else if $direction == up {\n        @include caret-up;\n      } @else if $direction == right {\n        @include caret-right;\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left;\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    // Add width 1% and flex-basis auto to ensure that button will not wrap out\n    // the column. Applies to IE Edge+ and Firefox. Chrome does not require this.\n    width: 1%;\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:last-child) { @include border-right-radius(0); }\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) / 2;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-color solid $custom-control-indicator-border-width;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) / 2;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: no-repeat 50% / #{$custom-control-indicator-bg-size};\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: $custom-checkbox-indicator-icon-checked;\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: $custom-checkbox-indicator-icon-indeterminate;\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      background-color: $custom-control-indicator-checked-disabled-bg;\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      background-color: $custom-control-indicator-checked-disabled-bg;\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-blacklist\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: $custom-radio-indicator-icon-checked;\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      background-color: $custom-control-indicator-checked-disabled-bg;\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-blacklist\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: calc(#{(($font-size-base * $line-height-base - $custom-control-indicator-size) / 2)} + #{$custom-control-indicator-border-width * 2});\n      left: calc(#{-($custom-switch-width + $custom-control-gutter)} + #{$custom-control-indicator-border-width * 2});\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-blacklist\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      background-color: $custom-control-indicator-checked-disabled-bg;\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-background;\n  background-color: $custom-select-bg;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      box-shadow: $custom-select-box-shadow, $custom-select-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: calc(#{$custom-range-thumb-height} + #{$custom-range-thumb-focus-box-shadow-width * 2});\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: none;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) / 2; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height / 2;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s or `<ul>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n\n  @include hover-focus {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-item {\n    margin-bottom: -$nav-tabs-border-width;\n  }\n\n  .nav-link {\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus {\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  > .container,\n  > .container-fluid {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        > .container,\n        > .container-fluid {\n          padding-right: 0;\n          padding-left: 0;\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        > .container,\n        > .container-fluid {\n          flex-wrap: nowrap;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: $navbar-light-toggler-icon-bg;\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: $navbar-dark-toggler-icon-bg;\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group:first-child {\n    .list-group-item:first-child {\n      @include border-top-radius($card-border-radius);\n    }\n  }\n\n  > .list-group:last-child {\n    .list-group-item:last-child {\n      @include border-bottom-radius($card-border-radius);\n    }\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y / 2;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n\n  + .list-group {\n    .list-group-item:first-child {\n      border-top: 0;\n    }\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x / 2;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x / 2;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x / 2;\n  margin-left: -$card-spacer-x / 2;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n}\n\n.card-img {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n  @include border-radius($card-inner-border-radius);\n}\n\n// Card image caps\n.card-img-top {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  display: flex;\n  flex-direction: column;\n\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      display: flex;\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      flex-direction: column;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  display: flex;\n  flex-direction: column;\n\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-blacklist\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-blacklist\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-blacklist\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-blacklist\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  > .card {\n    overflow: hidden;\n\n    &:not(:first-of-type) {\n      .card-header:first-child {\n        @include border-radius(0);\n      }\n\n      &:not(:last-of-type) {\n        border-bottom: 0;\n        @include border-radius(0);\n      }\n    }\n\n    &:first-of-type {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:last-of-type {\n      @include border-top-radius(0);\n    }\n\n    .card-header {\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      display: inline-block; // Suppress underlining of the separator in modern browsers\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: $breadcrumb-divider;\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 2;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 1;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding / 2);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: progress-bar-stripes $progress-bar-animation-timing;\n\n    @media (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  // Place the border on the list items and negative margin up for better styling\n  margin-bottom: -$list-group-border-width;\n  color: $list-group-color;\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius($list-group-border-radius);\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n    @include border-bottom-radius($list-group-border-radius);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      .list-group-item {\n        margin-right: -$list-group-border-width;\n        margin-bottom: 0;\n\n        &:first-child {\n          @include border-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          margin-right: 0;\n          @include border-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  .list-group-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:last-child {\n      margin-bottom: -$list-group-border-width;\n    }\n  }\n\n  &:first-child {\n    .list-group-item:first-child {\n      border-top: 0;\n    }\n  }\n\n  &:last-child {\n    .list-group-item:last-child {\n      margin-bottom: 0;\n      border-bottom: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  appearance: none;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  max-width: $toast-max-width;\n  overflow: hidden; // cheap rounded corners on nested items\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  backdrop-filter: blur(10px);\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: calc(100% - #{$modal-dialog-margin * 2});\n\n  .modal-content {\n    max-height: calc(100vh - #{$modal-dialog-margin * 2}); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - #{$modal-dialog-margin * 2});\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: calc(100vh - #{$modal-dialog-margin * 2});\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when should there be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-border-radius);\n\n  // Easily place margin between footer elements\n  > :not(:first-child) { margin-left: .25rem; }\n  > :not(:last-child) { margin-right: .25rem; }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: calc(100% - #{$modal-dialog-margin-y-sm-up * 2});\n\n    .modal-content {\n      max-height: calc(100vh - #{$modal-dialog-margin-y-sm-up * 2});\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: calc(100% - #{$modal-dialog-margin-y-sm-up * 2});\n\n    &::before {\n      height: calc(100vh - #{$modal-dialog-margin-y-sm-up * 2});\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width / 2) $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width / 2) 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $border-radius-lg;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width / 2;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  $offset-border-width: calc(#{$border-radius-lg} - #{$popover-border-width});\n  @include border-top-radius($offset-border-width);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(0s $carousel-transition-duration opacity);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  color: $carousel-control-color;\n  text-align: center;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: no-repeat 50% / 100% 100%;\n}\n.carousel-control-prev-icon {\n  background-image: $carousel-control-prev-icon-bg;\n}\n.carousel-control-next-icon {\n  background-image: $carousel-control-next-icon-bg;\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) / 2;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) / 2;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 50%;\n  animation: spinner-border .75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 50%;\n  opacity: 0;\n  animation: spinner-grow .75s linear infinite;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-blacklist, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage($embed-responsive-aspect-ratio-y / $embed-responsive-aspect-ratio-x);\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://a11yproject.com/posts/how-to-hide-content/\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if $size != 0 {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate; }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // IE & < Edge 18\n  overflow-wrap: break-word !important;\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// General\n\na,\nbutton,\n.btn {\n  outline: none !important;\n}\n\n.app-container {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  margin: 0;\n}","// Sidebar Animation\n\n.SidebarAnimation-appear {\n  transform: translateX(-30px);\n  opacity: 0;\n\n  &.SidebarAnimation-appear-active {\n    opacity: 1;\n    transform: translateX(0);\n    transition: all .4s linear;\n  }\n}\n\n// Tabs Animation\n\n.TabsAnimation-appear {\n  @extend .animated;\n  @extend .fadeInUp;\n}\n\n// Header Animation\n\n.HeaderAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n\n  &.HeaderAnimation-appear-active {\n    opacity: 1;\n    transform: translateY(0);\n    transition: all .4s linear;\n  }\n}\n\n// Main Animation\n\n.MainAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n\n  &.MainAnimation-appear-active {\n    opacity: 1;\n    transform: translateY(0);\n    transition: all .4s linear;\n  }\n}","// Header Base\n\n.app-header {\n  height: $app-header-height;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  position: relative;\n  z-index: 10;\n  transition: all .2s;\n\n  &.header-shadow {\n    box-shadow: $box-shadow-default;\n  }\n\n  .app-header__content {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    flex: 1;\n    padding: 0 $layout-spacer-x;\n    height: $app-header-height;\n\n    .app-header-left {\n      display: flex;\n      align-items: center;\n    }\n\n    .app-header-right {\n      align-items: center;\n      display: flex;\n      margin-left: auto;\n    }\n  }\n\n  .header-user-info {\n    & > .widget-heading,\n    & > .widget-subheading {\n      white-space: nowrap;\n    }\n\n    & > .widget-subheading {\n      font-size: $font-size-xs;\n    }\n  }\n}\n\n.app-header__logo {\n  padding: 0 $layout-spacer-x;\n  height: $app-header-height;\n  width: $app-sidebar-width;\n  display: flex;\n  align-items: center;\n  transition: width .2s;\n\n  .logo-src {\n    height: $logo-height;\n    width: $logo-width;\n    background: url('~assets/utils/images/logo-inverse.png');\n  }\n}\n\n.app-header__menu,\n.app-header__mobile-menu {\n  display: none;\n  padding: 0 $layout-spacer-x;\n  height: $app-header-height;\n  align-items: center;\n}\n\n// Header Modifiers\n\n@import \"modifiers/fixed-header\";\n@import \"modifiers/header-dots\";\n@import \"modifiers/header-megamenu\";\n@import \"modifiers/header-buttons\";\n//@import \"modifiers/header-horizontal\";\n\n// Header Themes\n\n@import \"themes/header-light\";\n@import \"themes/header-dark\";\n//@import \"themes/header-inverted\";","// Variables\n\n$spacer-lg                      : 3rem;\n$spacer-sm                      : 1.5rem;\n\n$layout-spacer-lg               : 3rem;\n$layout-spacer-x                : 1.5rem;\n\n$app-sidebar-width              : 280px;\n$app-sidebar-width-collapsed    : 80px;\n\n$logo-height                    : 23px;\n$logo-width                     : 97px;\n\n$app-header-height              : 60px;","// Fixed Header\n\n.fixed-header {\n  .app-header {\n    position: fixed;\n    width: 100%;\n    top: 0;\n\n    .app-header__logo {\n      visibility: visible;\n    }\n  }\n\n  .app-main {\n    padding-top: $app-header-height;\n  }\n\n  &:not(.fixed-sidebar):not(.closed-sidebar) {\n    .app-sidebar {\n      .app-header__logo {\n        visibility: hidden;\n      }\n    }\n  }\n}","// Header Dots\n\n.header-dots {\n  margin-left: auto;\n  display: flex;\n\n  & > .dropdown {\n    display: flex;\n    align-content: center;\n  }\n\n  .icon-wrapper-alt {\n    margin: 0;\n    height: 44px;\n    width: 44px;\n    text-align: center;\n    overflow: visible;\n\n    .language-icon {\n      @include border-radius(30px);\n      position: relative;\n      z-index: 4;\n      width: 28px;\n      height: 28px;\n      overflow: hidden;\n      margin: 0 auto;\n\n      img {\n        position: relative;\n        top: 50%;\n        left: 50%;\n        margin: -22px 0 0 -20px;\n      }\n\n    }\n\n    .icon-wrapper-bg {\n      opacity: .1;\n      transition: opacity .2s;\n      @include border-radius(40px);\n    }\n\n    svg {\n      margin: 0 auto;\n    }\n\n    @-moz-document url-prefix() {\n      svg {\n        width: 50%;\n      }\n    }\n\n    i {\n      font-size: 1.3rem;\n    }\n\n    &:hover {\n      cursor: pointer;\n\n      .icon-wrapper-bg {\n        opacity: .2;\n      }\n    }\n\n    .badge-dot {\n      top: 1px;\n      right: 1px;\n      border: 0;\n    }\n  }\n}","// Header Mega Menu\n\n.header-megamenu {\n  &.nav {\n    & > li > .nav-link {\n      color: $gray-600;\n      padding-left: ($nav-link-padding-x / 1.5);\n      padding-right: ($nav-link-padding-x / 1.5);\n\n      .badge-pill {\n        padding: 5px 7px;\n      }\n\n      &:hover {\n        color: $gray-800;\n      }\n\n      svg {\n        margin-top: 1px;\n      }\n    }\n  }\n}","\n// Header Buttons\n\n.header-btn-lg {\n  padding: 0 0 0 ($layout-spacer-x);\n  margin-left: ($layout-spacer-x);\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  &::before {\n    position: absolute;\n    left: -1px;\n    top: 50%;\n    background: $border-color;\n    width: 1px;\n    height: 30px;\n    margin-top: -15px;\n    content: '';\n  }\n\n  .hamburger-inner,\n  .hamburger-inner::before,\n  .hamburger-inner::after {\n    background: $gray-600;\n  }\n\n}","// Header Light\n\n.app-header {\n  &.header-text-light {\n    .app-header-left > .nav > li > .nav-link {\n      color: rgba(255, 255, 255, .7);\n\n      .nav-link-icon {\n        color: rgba(255, 255, 255, .8);\n      }\n\n      &:hover {\n        color: rgba(255, 255, 255, 1);\n      }\n    }\n\n    .app-header-right {\n      .icon-wrapper-alt {\n\n        svg {\n          fill: rgba(255, 255, 255, .7);\n          transition: all .2s;\n        }\n\n        .icon-wrapper-bg {\n          background: rgba(255, 255, 255, .1) !important;\n          transition: all .2s;\n          opacity: 1;\n        }\n\n        &:hover {\n          svg {\n            fill: rgba(255, 255, 255, .95);\n          }\n\n          .icon-wrapper-bg {\n            background: rgba(255, 255, 255, .15) !important;\n          }\n        }\n\n        .badge-dot {\n          border-color: transparent;\n        }\n      }\n\n      & > .header-btn-lg {\n\n        & .widget-content-left .btn-group > .btn-link,\n        .widget-heading,\n        .widget-subheading {\n          color: rgba(255, 255, 255, .8);\n        }\n\n        .header-user-info {\n          & > .btn-shadow {\n            box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, .1), 0 0.0625rem 0.125rem rgba(0, 0, 0, .2);\n          }\n        }\n      }\n    }\n\n    .search-wrapper {\n      .input-holder {\n        .search-icon {\n          background: rgba(0, 0, 0, .1);\n        }\n\n        .search-input {\n          &::placeholder,\n          &::-webkit-input-placeholder,\n          &:-ms-input-placeholder,\n          &:-moz-placeholder,\n          &::-moz-placeholder {\n            color: rgba(255, 255, 255, .5) !important;\n          }\n        }\n      }\n\n      &.active {\n        .input-holder {\n          background: rgba(255, 255, 255, .1);\n\n          .search-input {\n            color: rgba(255, 255, 255, .8);\n          }\n\n          .search-icon {\n            background: rgba(255, 255, 255, .1);\n          }\n        }\n      }\n    }\n\n    .header-btn-lg {\n      &::before {\n        background: rgba(255, 255, 255, .2);\n      }\n    }\n\n    .header-btn-lg,\n    .header__pane {\n      .hamburger-inner,\n      .hamburger.is-active .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background-color: rgba(255, 255, 255, .8) !important;\n      }\n    }\n\n    .search-wrapper .input-holder .search-icon span::after {\n      border-color: rgba(255, 255, 255, .8);\n    }\n\n    .search-wrapper .close::before,\n    .search-wrapper .close::after,\n    .search-wrapper .input-holder .search-icon span::before {\n      background: rgba(255, 255, 255, .8);\n    }\n\n    .app-header__logo {\n      .logo-src {\n        background: url('~assets/utils/images/logo.png');\n      }\n    }\n\n    .app-header__mobile-menu {\n      .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background: rgba(255, 255, 255, .9);\n      }\n    }\n\n  }\n\n}","// Header Dark\n\n.app-header {\n  &.header-text-dark {\n    .app-header-left > .nav > li > .nav-link {\n      color: rgba(0,0,0,.7);\n\n      .nav-link-icon {\n        color: rgba(0, 0, 0, .8);\n      }\n\n      &:hover {\n        color: rgba(0,0,0,1);\n      }\n    }\n\n    .app-header-right {\n      .icon-wrapper-alt {\n\n        svg {\n          fill: rgba(0,0,0,.7);\n          transition: all .2s;\n        }\n\n        .icon-wrapper-bg {\n          background: rgba(0,0,0,.1) !important;\n          transition: all .2s;\n          opacity: 1;\n        }\n\n        &:hover {\n          svg {\n            fill: rgba(0,0,0,.95);\n          }\n\n          .icon-wrapper-bg {\n            background: rgba(0,0,0,.15) !important;\n          }\n        }\n\n        .badge-dot {\n          border-color: transparent;\n        }\n      }\n\n      .widget-content-left {\n\n        & > .btn-group > .btn-link,\n        .widget-heading,\n        .widget-subheading {\n          color: rgba(0,0,0,.8);\n        }\n      }\n    }\n\n    .search-wrapper {\n      .input-holder {\n        .search-icon {\n          background: rgba(0,0,0,.1);\n        }\n      }\n\n      &.active {\n        .input-holder {\n          background: rgba(0,0,0,.1);\n\n          .search-input {\n            color: rgba(0,0,0,.8);\n          }\n\n          .search-icon {\n            background: rgba(0,0,0,.1);\n          }\n        }\n      }\n    }\n\n    .header-btn-lg {\n      &::before {\n        background: rgba(0,0,0,.2);\n      }\n    }\n\n    .header-btn-lg,\n    .header__pane {\n      .hamburger-inner,\n      .hamburger.is-active .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background-color: rgba(0, 0, 0, .8) !important;\n      }\n    }\n\n    .search-wrapper .input-holder .search-icon span::after {\n      border-color: rgba(0, 0, 0, .8);\n    }\n\n    .search-wrapper .close::before,\n    .search-wrapper .close::after,\n    .search-wrapper .input-holder .search-icon span::before {\n      background: rgba(0, 0, 0, .8);\n    }\n\n    .app-header__logo {\n      .logo-src {\n        background: url('~assets/utils/images/logo-inverse.png');\n      }\n    }\n\n  }\n\n\n}","// Sidebar Base\n\n.app-sidebar {\n  width: $app-sidebar-width;\n  display: flex;\n  z-index: 11;\n  overflow: hidden;\n  min-width: $app-sidebar-width;\n  position: relative;\n  flex: 0 0 $app-sidebar-width;\n  margin-top: -$app-header-height;\n  padding-top: $app-header-height;\n  transition: all .2s;\n\n  .app-sidebar__inner {\n    padding: 2px ($layout-spacer-x) $layout-spacer-x;\n  }\n\n  .scrollbar-container {\n    z-index: 15;\n    width: 100%;\n  }\n\n  .app-sidebar-bg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    opacity: 0.05;\n    background-size: cover;\n    z-index: 10;\n  }\n\n  .app-header__logo {\n    position: absolute;\n    left: 0;\n    top: 0;\n    display: none;\n    z-index: 11;\n  }\n\n  &.sidebar-shadow {\n    box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);\n  }\n}\n\n.app-sidebar__heading {\n  text-transform: uppercase;\n  font-size: $font-size-xs;\n  margin: ($layout-spacer-x / 2) 0;\n  font-weight: bold;\n  color: $primary;\n  white-space: nowrap;\n  position: relative;\n}\n\n.sidebar-mobile-overlay {\n  display: none;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: #333;\n  opacity: .6;\n  left: 0;\n  top: 0;\n  z-index: 12;\n}\n\n// Sidebar Components\n\n@import \"modifiers/navmenu-vertical\";\n\n// Sidebar Modifiers\n\n@import \"themes/sidebar-light\";\n@import \"themes/sidebar-dark\";\n//@import \"themes/sidebar-inverted\";\n\n\n@import \"modifiers/fixed-sidebar\";\n@import \"modifiers/closed-sidebar\";\n","// Navigation Menu Vertical\n\n.vertical-nav-menu {\n  position: relative;\n\n  &::after {\n    content: \" \";\n    pointer-events: none;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n\n  .metismenu-container,\n  .metismenu-item {\n    margin: 0;\n    padding: 0;\n    position: relative;\n  }\n  .metismenu-container {\n    list-style: none;\n\n    &:before {\n      opacity: 0;\n      transition: opacity 300ms;\n    }\n\n    .metismenu-link {\n      transition: transform .2s, height 300ms, color 300ms, background-color 300ms;\n      display: block;\n      line-height: 2.5rem;\n      height: 2.5rem;\n      padding: 0 $layout-spacer-x 0 45px;\n      position: relative;\n      @include border-radius($border-radius);\n      color: $gray-800;\n      white-space: nowrap;\n\n      &:hover {\n        background: $dropdown-link-hover-bg;\n        text-decoration: none;\n        //transform: scale(1.02);\n\n        i.metismenu-icon {\n          opacity: .6;\n        }\n\n        i.metismenu-state-icon {\n          opacity: 1;\n        }\n      }\n\n      &.active {\n        color: $primary;\n        background: $dropdown-link-hover-bg;\n      }\n\n      &.has-active-child,\n      &.active {\n        font-weight: bold;\n      }\n    }\n\n    i.metismenu-state-icon,\n    i.metismenu-icon {\n      text-align: center;\n      width: 34px;\n      height: 34px;\n      line-height: 34px;\n      position: absolute;\n      left: 5px;\n      top: 50%;\n      margin-top: -17px;\n      font-size: 1.5rem;\n      opacity: .3;\n      transition: color 300ms;\n    }\n\n    i.metismenu-state-icon {\n      transition: transform 300ms;\n      left: auto;\n      right: 0;\n\n      &.rotate-minus-90 {\n        transform: rotate(-180deg);\n      }\n    }\n\n    .metismenu-container {\n      transition: padding 300ms;\n\n      &.visible {\n        padding: .5em 0 0 2rem;\n\n        &:before {\n          content: '';\n          height: 100%;\n          opacity: 1;\n          width: 3px;\n          background: $dropdown-link-hover-bg;\n          position: absolute;\n          left: 20px;\n          top: 0;\n          @include border-radius(15px);\n        }\n\n        & > .metismenu-item > .metismenu-link {\n          height: 2.3em;\n          line-height: 2.3em;\n          color: $gray-600;\n          margin: 0 0 3px;\n\n          &:hover {\n            color: $primary;\n          }\n\n          .metismenu-icon {\n            display: none;\n          }\n\n          &.active {\n            color: $primary;\n            background: $dropdown-link-hover-bg;\n          }\n        }\n      }\n\n      .metismenu-item > .metismenu-link {\n        height: 0;\n        overflow: hidden;\n      }\n\n      .metismenu-link {\n        padding-left: 1em;\n      }\n    }\n  }\n}\n","// Sidebar Light\n\n.app-sidebar {\n  &.sidebar-text-light {\n    border-right: 0 !important;\n\n    .app-sidebar__heading {\n      color: rgba(255, 255, 255, .6);\n\n      &::before {\n        background: rgba(255, 255, 255, 0.2) !important;\n      }\n    }\n\n    .metismenu {\n      .metismenu-container {\n        .metismenu-link {\n          color: rgba(255, 255, 255, .7);\n\n          &:hover {\n            color: rgba(255, 255, 255, 1);\n            background: rgba(255, 255, 255, .1);\n          }\n\n          &.active {\n            background: rgba(255, 255, 255, .1);\n          }\n        }\n\n        &.metismenu-container {\n          &.visible {\n            .metismenu-item > .metismenu-link {\n              color: rgba(255, 255, 255, .6);\n\n              &.active {\n                background: rgba(255, 255, 255, .1);\n                color: rgba(255, 255, 255, .8);\n              }\n\n              &:hover {\n                color: rgba(255, 255, 255, 1);\n              }\n\n            }\n\n            &::before {\n              background: rgba(255, 255, 255, .3);\n            }\n          }\n        }\n\n        i.metismenu-state-icon,\n        i.metismenu-icon {\n          opacity: .5;\n        }\n      }\n    }\n\n    .ps__thumb-y {\n      background: rgba(255, 255, 255, .3);\n    }\n\n    .ps__rail-y:hover {\n      .ps__thumb-y {\n        background: rgba(255, 255, 255, .2);\n      }\n    }\n\n    .app-header__logo {\n      .logo-src {\n        background: url('~assets/utils/images/logo.png');\n      }\n\n      .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background-color: rgba(255, 255, 255, .8);\n      }\n    }\n  }\n}","// Sidebar Light\n\n.app-sidebar {\n  &.sidebar-text-dark {\n    border-right: 0 !important;\n\n    .app-sidebar__heading {\n      color: rgba(0, 0, 0, .6);\n\n      &::before {\n        background: rgba(0, 0, 0, 0.5) !important;\n      }\n    }\n\n    .metismenu {\n      .metismenu-container {\n        .metismenu-link {\n          color: rgba(0, 0, 0, .7);\n\n          &:hover {\n            color: rgba(0, 0, 0, 1);\n            background: rgba(0, 0, 0, .1);\n          }\n\n          &.active {\n            background: rgba(0, 0, 0, .1);\n          }\n        }\n\n        &.metismenu-container {\n          &.visible {\n            .metismenu-item > .metismenu-link {\n              color: rgba(0, 0, 0, .6);\n\n              &.active {\n                background: rgba(0, 0, 0, .1);\n              }\n            }\n\n            &::before {\n              background: rgba(0, 0, 0, .3);\n            }\n          }\n\n          i.metismenu-state-icon,\n          i.metismenu-icon {\n            opacity: .5;\n          }\n        }\n      }\n    }\n\n    .ps__thumb-y {\n      background: rgba(0, 0, 0, .3);\n    }\n\n    .ps__rail-y:hover {\n      .ps__thumb-y {\n        background: rgba(0, 0, 0, .2);\n      }\n    }\n\n    .app-header__logo {\n\n      .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background-color: rgba(0, 0, 0, .8);\n      }\n    }\n  }\n}","// Fixed Sidebar\n\n.fixed-sidebar {\n  .app-sidebar {\n    position: fixed;\n    height: 100vh;\n  }\n\n  .app-main {\n\n    .app-main__outer {\n      z-index: 9;\n      padding-left: $app-sidebar-width;\n    }\n\n  }\n\n  &.fixed-header {\n    .app-sidebar {\n      .app-header__logo {\n        display: none;\n      }\n    }\n  }\n\n  &:not(.fixed-header) {\n    .app-sidebar {\n      .app-header__logo {\n        display: flex;\n      }\n    }\n\n    .app-header {\n\n      margin-left: $app-sidebar-width;\n\n      .app-header__logo {\n        display: none;\n      }\n    }\n\n    .app-main {\n      //z-index: 12;\n    }\n  }\n\n  &.closed-sidebar {\n    &:not(.fixed-header) {\n\n      .app-header {\n        margin-left: $app-sidebar-width-collapsed;\n      }\n\n      .app-sidebar {\n\n        .app-header__logo {\n          width: $app-sidebar-width-collapsed;\n          padding: 0;\n\n          .logo-src {\n            display: none;\n          }\n\n          .header__pane {\n            margin-right: auto;\n          }\n        }\n      }\n    }\n  }\n}","// Closed Sidebar\n\n// Sidebar Menu Hover\n\n.closed-sidebar {\n  .app-sidebar {\n    transition: all .3s ease;\n    width: $app-sidebar-width-collapsed;\n    min-width: $app-sidebar-width-collapsed;\n    flex: 0 0 $app-sidebar-width-collapsed;\n    z-index: 13;\n\n    .app-sidebar__inner {\n\n      .app-sidebar__heading {\n        text-indent: -999em;\n\n        &::before {\n          content: '';\n          position: absolute;\n          top: 50%;\n          left: 0;\n          width: 100%;\n          height: 1px;\n          background: $dropdown-link-hover-bg;\n          text-indent: 1px;\n        }\n      }\n\n      .metismenu-link {\n        text-indent: -99rem;\n        padding: 0;\n      }\n\n      .metismenu-icon {\n        text-indent: 0;\n        left: 50%;\n        margin-left: -17px;\n      }\n\n      .metismenu-state-icon {\n        visibility: hidden;\n      }\n\n      .metismenu-container {\n        &.visible {\n          padding: 0;\n\n          & > .metismenu-item > .metismenu-link {\n            height: 0;\n          }\n        }\n      }\n    }\n\n    &:hover {\n      flex: 0 0 $app-sidebar-width !important;\n      width: $app-sidebar-width !important;\n\n      .app-sidebar__inner {\n\n        .app-sidebar__heading {\n          text-indent: initial;\n          &::before {\n            display: none;\n          }\n        }\n\n        .metismenu-link {\n          text-indent: initial;\n          padding: 0 $layout-spacer-x 0 45px;\n        }\n\n        .metismenu-icon {\n          text-indent: initial;\n          left: 5px;\n          margin-left: 0;\n        }\n\n        .metismenu-state-icon {\n          visibility: visible;\n        }\n\n        .metismenu-container {\n          &.visible {\n            padding: .5em 0 0 2rem;\n\n            & > .metismenu-item > .metismenu-link {\n              height: 2.3em;\n            }\n          }\n\n          .metismenu-container {\n            .metismenu-link {\n              padding-left: 1em;\n            }\n          }\n\n        }\n      }\n    }\n  }\n\n  &:not(.sidebar-mobile-open) {\n\n    .app-sidebar {\n      .scrollbar-container {\n        position: static;\n        height: auto;\n        overflow: initial !important;\n      }\n\n      &:hover {\n        .scrollbar-container {\n          position: absolute;\n          height: 100%;\n          overflow: hidden !important;\n        }\n      }\n    }\n  }\n\n  &:not(.closed-sidebar-mobile) {\n    .app-header {\n      .app-header__logo {\n        width: $app-sidebar-width-collapsed;\n\n        .logo-src {\n          display: none;\n        }\n\n        .header__pane {\n          margin-right: auto;\n        }\n      }\n    }\n\n  }\n\n  &.fixed-sidebar {\n    .app-main__outer {\n      padding-left: $app-sidebar-width-collapsed;\n    }\n  }\n\n  &.fixed-header:not(.fixed-sidebar) {\n    .app-sidebar {\n      .app-header__logo {\n        visibility: hidden;\n      }\n    }\n  }\n\n  &.closed-sidebar-mobile {\n    .app-sidebar,\n    .app-header {\n      .app-header__logo {\n        width: auto;\n        display: flex;\n\n        .header__pane {\n          display: none;\n        }\n      }\n    }\n\n    .app-sidebar {\n      .app-header__logo {\n        display: flex;\n        width: $app-sidebar-width-collapsed;\n        padding: 0 $layout-spacer-x !important;\n\n        .logo-src {\n          display: block !important;\n          margin: 0 auto;\n          width: $logo-width - 76;\n        }\n\n        .header__pane {\n          display: none;\n        }\n      }\n\n      &:hover {\n        .app-header__logo {\n          width: $app-sidebar-width;\n\n          .logo-src {\n            width: $logo-width;\n            margin: 0;\n\n          }\n        }\n      }\n    }\n\n    .app-header {\n      margin-left: 0 !important;\n    }\n  }\n\n  &.fixed-footer {\n    .app-footer__inner {\n      margin-left: 0 !important;\n    }\n  }\n}","// Main Base\n\n.app-main {\n  z-index: 8;\n  position: relative;\n  display: flex;\n\n  .app-main__outer {\n    flex: 1;\n    flex-direction: column;\n    display: flex;\n    z-index: 12;\n    width: 1px;\n  }\n\n  .app-main__inner {\n    padding: $grid-gutter-width $grid-gutter-width 0;\n    flex: 1;\n\n    & > .RRT__container {\n      & > .RRT__panel {\n        margin-top: $grid-gutter-width;\n      }\n\n      & > .body-tabs-layout {\n        .RRT__tab {\n          margin-top: (-($layout-spacer-x / 3));\n        }\n      }\n    }\n  }\n}\n\n// Alternate Section Tabs\n\n.body-tabs-shadow-btn {\n\n  .app-main__inner {\n    & > .RRT__container {\n      & > .RRT__panel {\n        margin-top: ($grid-gutter-width / 1.5);\n      }\n\n      .body-tabs-layout {\n        border: 0;\n        background: transparent;\n        position: relative;\n        z-index: 7;\n\n        .RRT__showmore {\n          margin-top: -13px;\n        }\n\n        .RRT__tab {\n          margin-top: $nav-link-padding-y;\n        }\n\n        .RRT__tab--selected {\n          color: $white;\n        }\n\n        & + .RRT__inkbar-wrapper {\n          position: absolute;\n          top: ($nav-link-padding-y * 2.2);\n          z-index: 5;\n\n          .RRT__inkbar {\n            height: 35px;\n            margin-top: 0;\n            @include border-radius($border-radius);\n            box-shadow:\n                    0 16px 26px -10px rgba($primary, 0.56),\n                    0 4px 25px 0px rgba(0, 0, 0, 0.12),\n                    0 8px 10px -5px rgba($primary, 0.2);\n          }\n        }\n      }\n    }\n  }\n\n\n}\n\n// Themes\n\n@import \"themes/main-white\";\n@import \"themes/main-gray\";\n//@import \"themes/main-inverted-blue\";\n//@import \"themes/main-inverted-black\";\n","// Theme White\n\n// Variables\n\n$app-container-bg: #f1f4f6;\n$app-sidebar-bg: #ffffff;\n$app-header-bg: #fafbfc;\n$app-header-logo-bg: rgba(255, 255, 255, .9);\n\n// Content\n\n.app-theme-white {\n\n  &.app-container {\n    background: $app-container-bg;\n  }\n\n  .app-sidebar {\n    background: $app-sidebar-bg;\n  }\n\n  .app-page-title {\n    background: rgba(255, 255, 255, .55);\n  }\n\n  .app-footer .app-footer__inner,\n  .app-header {\n    background: $app-header-bg;\n  }\n\n  &.fixed-header {\n    .app-header__logo {\n      background: rgba($app-header-bg, .1);\n    }\n  }\n\n}","// Theme Gray\n\n// Variables\n\n$app-container-bg: #ffffff;\n$app-sidebar-bg: #ffffff;\n$app-header-bg: #f8f9fa;\n$app-header-logo-bg: rgba(0, 0, 0, .03);\n\n// Content\n\n.app-theme-gray {\n\n  &.app-container {\n    background: $app-container-bg;\n  }\n\n  .app-sidebar {\n    background: $app-sidebar-bg;\n    border-right: $gray-300 solid 1px;\n  }\n\n  .app-page-title {\n    background: rgba(0, 0, 0, .03);\n  }\n\n  .app-footer,\n  .app-header {\n    background: $app-header-bg;\n  }\n\n  .app-footer {\n    border-top: $gray-300 solid 1px;\n  }\n\n  .app-header {\n    .app-header__logo {\n      border-right: rgba(0, 0, 0, .1) solid 1px;\n    }\n  }\n\n  &.fixed-header {\n    .app-header__logo {\n      background: $app-header-logo-bg;\n    }\n  }\n\n  .card {\n    border-width: 1px;\n  }\n\n  .main-card {\n    box-shadow: 0 0 0 0 transparent !important;\n\n    & > .card-body {\n\n      & > .card-title {\n        text-transform: none;\n        font-size: $font-size-lg;\n        font-weight: normal;\n        border-bottom: $gray-300 solid 1px;\n        position: relative;\n        padding: 0 0 ($card-spacer-y * 1.5);\n        margin: 0 0 ($card-spacer-y * 1.5);\n\n        &::before {\n          position: absolute;\n          width: 40px;\n          background: $primary;\n          @include border-radius(30px);\n          height: 5px;\n          left: 0;\n          bottom: -2px;\n          content: \"\";\n        }\n      }\n    }\n  }\n\n  .app-inner-layout__sidebar {\n    border-left: 0 !important;\n  }\n\n}\n","// Footer base\n\n.app-footer {\n  height: $app-header-height;\n\n  .app-footer__inner {\n    padding: 0 $layout-spacer-x 0 ($layout-spacer-x / 2);\n    height: $app-header-height;\n    transition: all .2s;\n\n    display: flex;\n    align-content: center;\n    align-items: center;\n\n    .app-footer-left {\n      display: flex;\n      align-items: center;\n    }\n\n    .app-footer-right {\n      margin-left: auto;\n      display: flex;\n    }\n  }\n}\n\n// Footer Dots Section\n\n.footer-dots {\n  display: flex;\n  align-items: center;\n  align-content: center;\n\n  .dots-separator {\n    height: 40px;\n    margin: 0 ($layout-spacer-x / 2.5);\n    width: 1px;\n    background: $gray-200;\n  }\n}\n\n.dot-btn-wrapper {\n  padding: .5rem;\n  position: relative;\n  display: flex;\n  opacity: .7;\n  transition: opacity .2s;\n\n  .badge-abs {\n    right: 50%;\n\n    &.badge-dot-sm {\n      top: -2px;\n      margin-right: -3px;\n    }\n  }\n\n  .dot-btn-icon {\n    font-size: 1.8rem;\n  }\n\n  &:hover {\n    text-decoration: none;\n    opacity: 1;\n  }\n}\n\n// Footer Modifiers\n\n@import \"fixed-footer\";\n","// Fixed Header\n\n.fixed-footer {\n  .app-footer {\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    z-index: 7;\n\n    .app-footer__inner {\n      margin-left: $app-sidebar-width;\n      box-shadow: 0.3rem -0.46875rem 2.1875rem rgba(darken($primary, 50%), .02),\n      0.3rem -0.9375rem 1.40625rem rgba(darken($primary, 50%), .02),\n      0.3rem -0.25rem 0.53125rem rgba(darken($primary, 50%), .04),\n      0.3rem -0.125rem 0.1875rem rgba(darken($primary, 50%), .02);\n\n    }\n  }\n\n  .app-main .app-main__outer {\n    padding-bottom: $app-header-height;\n  }\n\n  &.closed-sidebar {\n    .app-footer {\n      .app-footer__inner {\n        margin-left: $app-sidebar-width-collapsed !important;\n      }\n    }\n  }\n\n}\n","// Page title\n\n.app-page-title {\n  padding: $grid-gutter-width;\n  margin: (-$grid-gutter-width) (-$grid-gutter-width) ($grid-gutter-width);\n  position: relative;\n\n  .page-title-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n\n  .page-title-heading,\n  .page-title-subheading {\n    margin: 0;\n    padding: 0;\n  }\n\n  .page-title-heading {\n    font-size: $h5-font-size;\n    font-weight: 400;\n    display: flex;\n    align-content: center;\n    align-items: center;\n  }\n\n  .page-title-subheading {\n    padding: 3px 0 0;\n    font-size: $font-size-base;\n    opacity: .6;\n\n    .breadcrumb {\n      padding: 0;\n      margin: 3px 0 0;\n      background: transparent;\n    }\n  }\n\n  .page-title-actions {\n    margin-left: auto;\n\n    .breadcrumb {\n      margin: 0;\n      padding: 0;\n      background: transparent;\n    }\n  }\n\n  .page-title-icon {\n    font-size: 2rem;\n    display: flex;\n    align-items: center;\n    align-content: center;\n    text-align: center;\n    padding: ($layout-spacer-x / 1.8);\n    margin: 0 ($grid-gutter-width) 0 0;\n    background: $white;\n    box-shadow: $box-shadow-default;\n    @include border-radius($border-radius);\n    width: 60px;\n    height: 60px;\n\n    i {\n      margin: auto;\n    }\n\n    &.rounded-circle {\n      margin: 0 ($grid-gutter-width / 1.5) 0 0;\n    }\n  }\n\n  & + .RRT__container {\n    margin-top: -($grid-gutter-width / 1.3);\n  }\n\n  & + .rc-tabs {\n    // to fix width issue in firefox\n    max-width: calc(100vw - 322px);\n    margin: (-($grid-gutter-width)) (-($grid-gutter-width / 2)) (($grid-gutter-width * 1.3));\n  }\n  @media only screen and (max-width: 812px) and (min-width: 360px)  {\n    & + .rc-tabs {\n      // to fix width issue in firefox\n      max-width: calc(100vw - 0px);\n      margin: (-($grid-gutter-width)) (-($grid-gutter-width / 2)) (($grid-gutter-width * 1.3));\n    }\n  }\n\n  &.app-page-title-simple {\n    margin: 0;\n    background: none !important;\n    padding-left: 0;\n    padding-right: 0;\n    padding-top: 0;\n  }\n}\n\n.page-title-icon-rounded {\n  .page-title-icon {\n    @include border-radius(50px);\n  }\n}\n\n// Body Tabs\n\n.body-tabs {\n  &.body-tabs-layout {\n    margin-left: -($grid-gutter-width);\n    margin-right: -($grid-gutter-width);\n    padding: 0 $grid-gutter-width;\n    border-top: 0;\n    border-bottom: $gray-300 solid 1px;\n  }\n}\n","// Search Box\n\n$search-box-size:     42px;\n\n.search-wrapper {\n  position: relative;\n  margin-right: ($nav-link-padding-x / 1.5);\n\n  .input-holder {\n    height: $search-box-size;\n    width: $search-box-size;\n    overflow: hidden;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n\n    .search-input {\n      width: 100%;\n      padding: 0 70px 0 20px;\n      opacity: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      background: transparent;\n      box-sizing: border-box;\n      border: none;\n      outline: none;\n      transform: translate(0, 60px);\n      transition: all .3s cubic-bezier(0.000, 0.105, 0.035, 1.570);\n      transition-delay: 0.3s;\n      font-size: $font-size-base;\n    }\n\n    .search-icon {\n      width: $search-box-size;\n      height: $search-box-size;\n      border: none;\n      padding: 0;\n      outline: none;\n      position: relative;\n      z-index: 2;\n      float: right;\n      cursor: pointer;\n      transition: all 0.3s ease-in-out;\n      background: rgba(0,0,0,.06);\n      @include border-radius(30px);\n\n      span {\n        width: 22px;\n        height: 22px;\n        display: inline-block;\n        vertical-align: middle;\n        position: relative;\n        transform: rotate(45deg);\n        transition: all .4s cubic-bezier(0.650, -0.600, 0.240, 1.650);\n\n        &::before,\n        &::after {\n          position: absolute;\n          content: '';\n        }\n\n        &::before {\n          width: 4px;\n          height: 11px;\n          left: 9px;\n          top: 13px;\n          border-radius: 2px;\n          background: $primary;\n        }\n\n        &::after {\n          width: 14px;\n          height: 14px;\n          left: 4px;\n          top: 0;\n          border-radius: 16px;\n          border: 2px solid $primary;\n        }\n      }\n    }\n  }\n\n  .close {\n    position: absolute;\n    z-index: 1;\n    top: 50%;\n    left: 0;\n    width: 20px;\n    height: 20px;\n    margin-top: -10px;\n    cursor: pointer;\n    opacity: 0 !important;\n    transform: rotate(-180deg);\n    transition: all .2s cubic-bezier(0.285, -0.450, 0.935, 0.110);\n    transition-delay: 0.1s;\n\n    &::before,\n    &::after {\n      position: absolute;\n      content: '';\n      background: $primary;\n      border-radius: 2px;\n    }\n\n    &::before {\n      width: 2px;\n      height: 20px;\n      left: 9px;\n      top: 0;\n    }\n\n    &::after {\n      width: 20px;\n      height: 2px;\n      left: 0;\n      top: 9px;\n    }\n  }\n\n  &.active {\n    width: 330px;\n\n    .input-holder {\n      width: 290px;\n      border-radius: 50px;\n      background: rgba(0, 0, 0, 0.05);\n      transition: all .5s cubic-bezier(0.000, 0.105, 0.035, 1.570);\n\n      .search-input {\n        opacity: 1;\n        transform: translate(0, 11px);\n      }\n\n      .search-icon {\n        width: $search-box-size;\n        height: $search-box-size;\n        margin: 0;\n        border-radius: 30px;\n\n        span {\n          transform: rotate(-45deg);\n        }\n      }\n    }\n\n    .close {\n      left: 300px;\n      opacity: .6 !important;\n      transform: rotate(45deg);\n      transition: all .6s cubic-bezier(0.000, 0.105, 0.035, 1.570);\n      transition-delay: 0.5s;\n\n      &:hover {\n        opacity: 1 !important;\n      }\n    }\n\n    & + .header-megamenu {\n      opacity: 0;\n    }\n\n  }\n}","\n// Opacity\n\n.opacity-01 {\n  opacity: .01 !important;\n}\n\n.opacity-02 {\n  opacity: .02 !important;\n}\n\n.opacity-03 {\n  opacity: .03 !important;\n}\n\n.opacity-04 {\n  opacity: .04 !important;\n}\n\n.opacity-05 {\n  opacity: .05 !important;\n}\n\n.opacity-06 {\n  opacity: .06 !important;\n}\n\n.opacity-07 {\n  opacity: .07 !important;\n}\n\n.opacity-08 {\n  opacity: .08 !important;\n}\n\n.opacity-09 {\n  opacity: .09 !important;\n}\n\n.opacity-1 {\n  opacity: .1 !important;\n}\n\n.opacity-15 {\n  opacity: .15 !important;\n}\n\n.opacity-2 {\n  opacity: .2 !important;\n}\n\n.opacity-3 {\n  opacity: .3 !important;\n}\n\n.opacity-4 {\n  opacity: .4 !important;\n}\n\n.opacity-5 {\n  opacity: .5 !important;\n}\n\n.opacity-6 {\n  opacity: .6 !important;\n}\n\n.opacity-7 {\n  opacity: .7 !important;\n}\n\n.opacity-8 {\n  opacity: .8 !important;\n}\n\n.opacity-9 {\n  opacity: .9 !important;\n}\n\n.opacity-10 {\n  opacity: 1 !important;\n}","// Grayscale Filter\n\n.filter-grayscale-5 {\n  filter: grayscale(5%) !important;\n}\n\n.filter-grayscale-10 {\n  filter: grayscale(10%) !important;\n}\n\n.filter-grayscale-20 {\n  filter: grayscale(20%) !important;\n}\n\n.filter-grayscale-30 {\n  filter: grayscale(30%) !important;\n}\n\n.filter-grayscale-40 {\n  filter: grayscale(40%) !important;\n}\n\n.filter-grayscale-50 {\n  filter: grayscale(50%) !important;\n}\n\n.filter-grayscale-80 {\n  filter: grayscale(80%) !important;\n}\n\n.filter-grayscale-100 {\n  filter: grayscale(100%) !important;\n}","// Helpers imports\n@import \"helpers/opacity\";\n@import \"helpers/grayscale\";\n\n// Resets\n\n.br-tl {\n  border-top-left-radius: $border-radius !important;\n}\n\n.br-tr {\n  border-top-right-radius: $border-radius !important;\n}\n\n.br-bl {\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.br-br {\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.b-radius-0 {\n  border-radius: 0 !important;\n}\n\n.rm-border {\n  border-width: 0 !important;\n}\n\n.br-a {\n  @include border-radius($border-radius);\n}\n\n// Center Elements\n\n.margin-h-center {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.center-svg {\n  margin: 0 auto;\n\n  svg {\n    margin: 0 auto;\n  }\n}\n\n.apexcharts-canvas {\n  margin: 0 auto;\n}\n\n.apexcharts-donut {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.alert-dismissible {\n  .close {\n    top: 0;\n    right: 5px;\n    padding: 5px;\n  }\n}\n\n// Gradient Icons\n\n.icon-gradient {\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-fill-color: transparent;\n}\n\n// Font sizes\n\n.font-size-xlg {\n  font-size: 1.3rem !important;\n}\n\n.font-size-md {\n  font-size: .9rem !important;\n}\n\n.font-size-lg {\n  font-size: 1.1rem !important;\n}\n\n// No Shadow\n\n.no-shadow {\n  box-shadow: 0 0 0 transparent !important;\n}\n\n// Layout\n\n.h-100 {\n  height: 100vh !important;\n}\n\n.he-auto {\n  height: auto !important;\n}\n\n.he-100 {\n  height: 100%;\n}\n\n.h-sm {\n  height: 150px;\n}\n\n.text-nowrap {\n  white-space: nowrap;\n}\n\n// Font size\n\n.fsize-1 {\n  font-size: .95rem !important;\n}\n\n.fsize-2 {\n  font-size: 1.3rem !important;\n}\n\n.fsize-3 {\n  font-size: 1.6rem !important;\n}\n\n.fsize-4 {\n  font-size: 2rem !important;\n}\n\n.z-index-6 {\n  z-index: 6;\n}\n\n.line-height-1 {\n  line-height: 1;\n}\n\n// Center element\n\n.center-elem {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.flex2 {\n  flex: 2;\n}\n\n// Divider\n\n.divider {\n  margin-top: $spacer;\n  margin-bottom: $spacer;\n  height: 1px;\n  overflow: hidden;\n  background: $gray-200;\n}\n\n.list-group-item:hover {\n  z-index: initial;\n}\n\n// No Results\n\n.no-results {\n  padding: ($spacer * 1.5);\n  text-align: center;\n\n  .results-title {\n    color: $gray-700;\n    font-size: $h5-font-size;\n  }\n\n  .results-subtitle {\n    color: $gray-500;\n    font-size: $font-size-lg;\n  }\n}\n\n// Background Color Animation\n\n.bg-animation {\n  animation: bg-pan-left 8s both;\n}\n\n@-webkit-keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n// Width 100%\n\n.w-100 {\n  width: 100%;\n}\n\n.mb--2 {\n  margin-bottom: -1.5rem;\n}\n\n// Margins\n\n.mbg-3 {\n  margin-bottom: $grid-gutter-width;\n}\n\n// Loader\n\n.loader-container {\n  align-items: center;\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  width: 100vw;\n  text-align: center;\n  line-height: 1.6rem;\n\n  .loader-container-inner {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding: 0 $layout-spacer-x;\n  }\n\n  small {\n    margin: 10px 0 0;\n    display: block;\n    color: $gray-600;\n    font-weight: normal;\n  }\n\n  h3 {\n    text-align: center;\n    display: block;\n  }\n}","// Gradients\n\n.bg-warm-flame {\n  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;\n}\n\n.bg-night-fade {\n  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;\n}\n\n.bg-sunny-morning {\n  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;\n}\n\n.bg-tempting-azure {\n  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;\n}\n\n.bg-amy-crisp {\n  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;\n}\n\n.bg-heavy-rain {\n  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;\n}\n\n.bg-mean-fruit {\n  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;\n}\n\n.bg-malibu-beach {\n  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;\n}\n\n.bg-deep-blue {\n  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;\n}\n\n.bg-ripe-malin {\n  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;\n}\n\n.bg-arielle-smile {\n  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;\n}\n\n.bg-plum-plate {\n  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n}\n\n.bg-happy-fisher {\n  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;\n}\n\n.bg-happy-itmeo {\n  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;\n}\n\n.bg-mixed-hopes {\n  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;\n}\n\n.bg-strong-bliss {\n  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;\n}\n\n.bg-grow-early {\n  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;\n}\n\n.bg-love-kiss {\n  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;\n}\n\n.bg-premium-dark {\n  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;\n}\n\n.bg-happy-green {\n  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;\n}\n\n.bg-vicious-stance {\n  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;\n}\n\n.bg-midnight-bloom {\n  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;\n}\n\n.bg-night-sky {\n  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;\n}\n\n.bg-slick-carbon {\n  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255,255,255,0.40) 0%, rgba(0,0,0,0.25) 200%) !important;\n  background-blend-mode: multiply;\n}\n\n.bg-royal {\n  background-image: linear-gradient(to right, #141e30, #243b55) !important;\n}\n\n.bg-asteroid {\n  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;\n}\n\n.bg-transparent {\n  background: transparent !important;\n}","@charset \"UTF-8\";\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\nCopyright (c) 2015 Daniel Eden\n*/\n\nbody {\n\t-webkit-backface-visibility: hidden; // Addresses a small issue in webkit: https://css-tricks.com/almanac/properties/b/backface-visibility/\n}\n\n.animated {\n  \t@include animate-prefixer(animation-duration, calc( #{$base-duration} ) );\n  \t@include animate-prefixer(animation-fill-mode, $base-fill-mode);\n\n\t&.infinite {\n\t  animation-iteration-count: $base-iteration-count;\n\t}\n\n\t&.hinge {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 2 ) );\n\t}\n\n\t&.bounceIn,\n\t&.bounceOut {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 0.75 ) );\n\t}\n\n\t&.flipOutX,\n\t&.flipOutY {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 0.75 ) );\n\t}\n}","///////////////////////////////////////////////////////////////////\n// Sass Mixins which will be used by the modules                 //\n///////////////////////////////////////////////////////////////////\n\n//===============================================================//\n//          Automatically add vendor prefixes in one hit         //\n//===============================================================//\n//      .fadeIn {                                                //\n//          @include animate-prefixer(animation, 'fadeIn');        //\n//      }                                                        //\n//===============================================================//\n//                                                               //\n//===============================================================//\n@mixin animate-prefixer($property, $value...) {\n    -webkit-#{$property}: unquote('#{$value}');\n    #{$property}: unquote('#{$value}');\n}\n//===============================================================//\n// Generate keyframes animations with vendor prefixes in one hit //\n//===============================================================//\n//      .fadeIn {                                                //\n//          @include animate-prefixer(animation, fadeIn);        //\n//      }                                                        //\n//      @include animate-keyframe(fadeIn) {                      //\n//          0% {opacity: 0;}                                     //\n//          100% {opacity: 1;}                                   //\n//      }                                                        //\n//===============================================================//\n// Courtesy of @integralist: (twitter.com)                       //\n//===============================================================//\n\n@mixin animate-keyframe($animation-name) {\n    @-webkit-keyframes #{$animation-name} {\n        @content;\n    }\n\n    @keyframes #{$animation-name} {\n        @content;\n    }\n}\n","/////////////////////////////////////////////////////////\n// Animation Default Settings                          //\n/////////////////////////////////////////////////////////\n\n\n// Base module settings\n$base-duration\t\t\t\t\t: 1s !default;           // used in 1-base module\n$base-origin \t\t\t\t\t: top center !default;\n$base-degrees \t\t\t\t\t: 30deg !default;        // used in lightspeed & special modules\n$base-fill-mode\t\t\t\t\t: both !default;\n$base-iteration-count\t\t\t: infinite !default;\n\n$base-timing-function-in\t\t: ease-in !default;\n$base-timing-function-out\t\t: ease-out !default;\n$base-timing-function-in-out\t: ease-in-out !default;\n\n$base-distance\t\t\t\t\t: 10px !default; \t\t// used in fade, shake and bounce modules\n$base-distance-big\t\t\t\t: 1000px !default;       // used in fadeBig and bounce modules\n\n\n// Rotate module settings\n$rotate-degrees \t\t\t\t: 90deg !default;\n$rotate-degrees-max \t\t\t: 200deg !default;\n$rotate-origin \t\t\t\t\t: center center !default;\n\n// Flipper module settings\n$flipper-perspective\t\t\t: 400px !default;\n$flipper-translate \t\t\t\t: 150px !default;\n$flipper-degrees \t\t\t\t: 10deg !default;\n$flipper-degrees-max \t\t\t: 90deg !default;\n\n\n// Hinge module settings\n$hinge-origin \t\t\t\t\t: top left !default;\n$hinge-degrees-max \t\t\t\t: 80deg !default;\n$hinge-translate \t\t\t\t: 700px !default;\n\n\n//==================================================================================================//\n// Module loading                                                                                   //\n//==================================================================================================//\n// To include an animation module in the compiled css file, simply set it's attribute below to true //\n// (all modules set to false will not be included)                                                  //\n// The idea here is to only load the animations you want to use on a per project basis              //\n// This helps keep the compiled css file at its leanest                                             //\n//==================================================================================================//\n// Hugely influenced and inspired by @csswizardry's inuit.css _vars.scss file                       //\n//==================================================================================================//\n\n$use-all                    :   false !default; // all animations status\n$use-fade               :   $use-all !default; // all fades\n$use-bounce             :   $use-all !default; // all bounces\n$use-rotate             :   $use-all !default; // all rotates\n$use-slide              :   $use-all !default; // all slide animations\n$use-flipers            :   $use-all !default; // all flip animations\n$use-light-speed        :   $use-all !default; // all light speed animations\n$use-attention-seekers  :   $use-all !default; // all attention seeker animations\n$use-special            :   $use-all !default; // all special animations\n$use-zoom               :   $use-all !default; // all zoom animations\n// Fade Enter\n$use-fade-in            :   $use-fade !default;\n$use-fadeIn \t\t\t:\t$use-fade-in !default;\n$use-fadeInUp \t\t\t:\t$use-fade-in !default;\n$use-fadeInUpBig \t\t:\t$use-fade-in !default;\n$use-fadeInDown \t\t:\t$use-fade-in !default;\n$use-fadeInDownBig \t\t:\t$use-fade-in !default;\n$use-fadeInLeft \t\t:\t$use-fade-in !default;\n$use-fadeInLeftBig \t\t:\t$use-fade-in !default;\n$use-fadeInRight \t\t:\t$use-fade-in !default;\n$use-fadeInRightBig \t:\t$use-fade-in !default;\n\n\n// Fade Exit\n$use-fade-out           :   $use-fade !default;\n$use-fadeOut\t\t\t:   $use-fade-out !default;\n$use-fadeOutUp\t\t\t:\t$use-fade-out !default;\n$use-fadeOutUpBig   \t:\t$use-fade-out !default;\n$use-fadeOutDown\t\t:\t$use-fade-out !default;\n$use-fadeOutDownBig \t:\t$use-fade-out !default;\n$use-fadeOutLeft\t\t:\t$use-fade-out !default;\n$use-fadeOutLeftBig \t:\t$use-fade-out !default;\n$use-fadeOutRight\t\t:\t$use-fade-out !default;\n$use-fadeOutRightBig\t:\t$use-fade-out !default;\n\n\n// Bounce Enter\n$use-bounce-in          :   $use-bounce !default;\n$use-bounceIn\t\t\t:\t$use-bounce-in !default;\n$use-bounceInUp\t\t\t: \t$use-bounce-in !default;\n$use-bounceInDown \t\t: \t$use-bounce-in !default;\n$use-bounceInLeft \t\t: \t$use-bounce-in !default;\n$use-bounceInRight \t\t: \t$use-bounce-in !default;\n\n\n// Bounce Exit\n$use-bounce-out         :   $use-bounce !default;\n$use-bounceOut\t\t\t:\t$use-bounce-out !default;\n$use-bounceOutUp\t\t: \t$use-bounce-out !default;\n$use-bounceOutDown \t\t: \t$use-bounce-out !default;\n$use-bounceOutLeft \t\t: \t$use-bounce-out !default;\n$use-bounceOutRight \t: \t$use-bounce-out !default;\n\n\n\n// Rotate Enter\n$use-rotate-in          :   $use-rotate !default;\n$use-rotateIn \t\t\t:\t$use-rotate-in !default;\n$use-rotateInUpLeft \t: \t$use-rotate-in !default;\n$use-rotateInUpRight \t: \t$use-rotate-in !default;\n$use-rotateInDownLeft \t: \t$use-rotate-in !default;\n$use-rotateInDownRight \t: \t$use-rotate-in !default;\n\n\n// Rotate Exit\n$use-rotate-out         :   $use-rotate !default;\n$use-rotateOut \t\t\t:\t$use-rotate-out !default;\n$use-rotateOutUpLeft \t: \t$use-rotate-out !default;\n$use-rotateOutUpRight \t: \t$use-rotate-out !default;\n$use-rotateOutDownLeft \t: \t$use-rotate-out !default;\n$use-rotateOutDownRight : \t$use-rotate-out !default;\n\n\n// Slide Enter\n$use-slide-in           :   $use-slide !default;\n$use-slideIn\t\t\t:   $use-slide-in !default;\n$use-slideInUp\t\t\t:   $use-slide-in !default;\n$use-slideInDown\t\t:   $use-slide-in !default;\n$use-slideInLeft\t\t:   $use-slide-in !default;\n$use-slideInRight\t\t:   $use-slide-in !default;\n\n// Slide Exit\n$use-slide-out          :   $use-slide !default;\n$use-slideOut\t\t\t:   $use-slide-out !default;\n$use-slideOutUp\t\t\t:   $use-slide-out !default;\n$use-slideOutDown\t\t:   $use-slide-out !default;\n$use-slideOutLeft\t\t:   $use-slide-out !default;\n$use-slideOutRight\t\t:   $use-slide-out !default;\n\n// Flippers\n$use-flip\t\t\t\t:\t$use-flipers !default;\n$use-flipInX\t\t\t:\t$use-flipers !default;\n$use-flipInY\t\t\t:\t$use-flipers !default;\n$use-flipOutX\t\t\t:\t$use-flipers !default;\n$use-flipOutY\t\t\t:\t$use-flipers !default;\n\n\n// Lightspeed\n$use-lightSpeedIn \t\t:\t$use-light-speed !default;\n$use-lightSpeedOut \t\t:\t$use-light-speed !default;\n\n\n// Attention Seekers\n$use-bounce\t\t\t\t:\t$use-attention-seekers !default;\n$use-flash\t\t\t\t:\t$use-attention-seekers !default;\n$use-pulse\t\t\t\t:\t$use-attention-seekers !default;\n$use-wiggle\t\t\t\t:\t$use-attention-seekers !default;\n$use-swing\t\t\t\t:\t$use-attention-seekers !default;\n$use-shake\t\t\t\t:\t$use-attention-seekers !default;\n$use-tada\t\t\t\t:\t$use-attention-seekers !default;\n$use-wobble\t\t\t\t:\t$use-attention-seekers !default;\n\n\n// Special\n$use-hinge\t\t\t\t:\t$use-special !default;\n$use-rollIn\t\t\t\t: \t$use-special !default;\n$use-rollOut \t\t\t:\t$use-special !default;\n\n\n// Zoom In\n$use-zoom-in            :   $use-zoom !default;\n$use-zoomIn \t\t\t:\t$use-zoom-in !default;\n$use-zoomInDown \t\t:\t$use-zoom-in !default;\n$use-zoomInLeft \t\t:\t$use-zoom-in !default;\n$use-zoomInRight \t\t:\t$use-zoom-in !default;\n$use-zoomInUp \t\t\t:\t$use-zoom-in !default;\n\n\n// Zoom Out\n$use-zoom-out           :   $use-zoom !default;\n$use-zoomOut\t\t\t:\t$use-zoom-out !default;\n$use-zoomOutDown\t\t:\t$use-zoom-out !default;\n$use-zoomOutLeft\t\t:\t$use-zoom-out !default;\n$use-zoomOutRight\t\t:\t$use-zoom-out !default;\n$use-zoomOutUp\t\t\t:\t$use-zoom-out !default;\n","@if $use-fadeIn == true {\n\n\t@include animate-keyframe(fadeIn) {\n\t\t0% {opacity: 0;}\n\t\t100% {opacity: 1;}\n\t}\n\n\t.fadeIn {\n\t\t@include animate-prefixer(animation-name, fadeIn);\n\t}\n\n}\n","@if $use-fadeInDown == true {\n\n\t@-webkit-keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY(-$base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0);\n\t\t}\n\t}\n\n\t@keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY(-$base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\n\t.fadeInDown {\n\t\t@include animate-prefixer(animation-name, fadeInDown);\n\t}\n\n}\n","@if $use-fadeInUp == true {\n\n\t@-webkit-keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY($base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0);\n\t\t}\n\t}\n\n\t@keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY($base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\n\t.fadeInUp {\n\t\t@include animate-prefixer(animation-name, fadeInUp);\n\t}\n\n}\n","@if $use-fadeOut == true {\n\n\t@include animate-keyframe(fadeOut) {\n\t\t0% {opacity: 1;}\n\t\t100% {opacity: 0;}\n\t}\n\n\t.fadeOut {\n\t\t@include animate-prefixer(animation-name, fadeOut);\n\t}\n\n}\n","@if $use-lightSpeedIn == true {\n\n\t@-webkit-keyframes lightSpeedIn {\n\t\t0% { -webkit-transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t\t60% { -webkit-transform: translateX(-20%) skewX($base-degrees); opacity: 1; }\n\t\t80% { -webkit-transform: translateX(0%) skewX(-$base-degrees / 2); opacity: 1; }\n\t\t100% { -webkit-transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t}\n\n\t@keyframes lightSpeedIn {\n\t\t0% { transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t\t60% { transform: translateX(-20%) skewX($base-degrees); opacity: 1; }\n\t\t80% { transform: translateX(0%) skewX(-$base-degrees / 2); opacity: 1; }\n\t\t100% { transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t}\n\n\t.lightSpeedIn {\n\t\t@include animate-prefixer(animation-name, lightSpeedIn);\n\t\t@include animate-prefixer(animation-timing-function, $base-timing-function-out);\n\t}\n\n}\n","@if $use-lightSpeedOut == true {\n\n\t@-webkit-keyframes lightSpeedOut {\n\t\t0% { -webkit-transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t\t100% { -webkit-transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t}\n\n\t@keyframes lightSpeedOut {\n\t\t0% { transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t\t100% { transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t}\n\n\t.lightSpeedOut {\n\t\t@include animate-prefixer(animation-name, lightSpeedOut);\n\t\t@include animate-prefixer(animation-timing-function, $base-timing-function-in);\n\t}\n}\n","// Common Comps Animations\n\n\n$base-duration\t\t\t\t\t: .2s;\n$base-distance                  : 10px;\n$base-fill-mode\t\t\t\t\t: both;\n\n// Dropdown Animation\n\n.dropdown-menu {\n  &.show {\n    animation: fade-in2 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n  }\n}\n\n.popover {\n  &.show {\n    display: block;\n    animation: fade-in2 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n  }\n}\n\n.dropdown-menu {\n  &[data-placement^=\"top\"].show {\n    animation: fade-in3 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n    bottom: auto !important;\n    top: auto !important;\n  }\n}\n\n@keyframes fade-in2 {\n  0% {\n    margin-top: -50px;\n    visibility: hidden;\n    opacity: 0;\n  }\n  100% {\n    margin-top: 0px;\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n.form-control {\n  transition: all .2s;\n}\n","// Buttons\n\n// 2x Outline Border\n\n.btn-outline-2x {\n  border-width: 2px;\n}\n\n.btn-group {\n  .btn {\n    font-size: 0.8rem;\n    font-weight: 500;\n  }\n\n  .btn-outline-2x + .btn-outline-2x {\n    margin-left: -2px;\n  }\n\n  .btn-square {\n    @include border-radius(0);\n  }\n}\n\n.btn {\n  font-size: 0.8rem;\n  font-weight: 500;\n\n  // Pills Buttons\n\n  &.btn-pill.btn-wide,\n  &.btn-pill {\n    @include border-left-radius(50px);\n    @include border-right-radius(50px);\n  }\n\n}\n\n// Dashed Border\n\n.btn-dashed {\n  border-style: dashed;\n}\n\n// Icon Buttons\n\n.btn-icon {\n  vertical-align: bottom;\n\n  &.btn-icon-right {\n    .btn-icon-wrapper {\n      margin-left: ($spacer / 2);\n      margin-right: 0;\n    }\n  }\n\n  .btn-icon-wrapper {\n    margin-right: ($spacer / 2);\n    margin-left: 0;\n    margin-top: 0;\n    font-size: 17px;\n    vertical-align: middle;\n    transition: color .1s;\n    display: inline-block;\n  }\n\n  &.btn-link {\n    text-decoration: none;\n  }\n\n  &.btn-lg:not(.btn-block) {\n    .btn-icon-wrapper {\n      font-size: 25px;\n    }\n  }\n\n  &.btn-sm:not(.btn-block) {\n    .btn-icon-wrapper {\n      font-size: 16px;\n    }\n  }\n}\n\n.btn-icon-only {\n  .btn-icon-wrapper {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n// Hover Shine {\n\n.btn-hover-shine {\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.4);\n    -webkit-transition: none;\n    -moz-transition: none;\n    transition: none;\n  }\n\n  &:hover:after {\n    width: 120%;\n    background-color: rgba(255, 255, 255, 0);\n    transition: all 0.4s ease-in-out;\n  }\n\n  &.btn-pill {\n    &::after {\n      @include border-left-radius(50px);\n      @include border-right-radius(50px);\n    }\n  }\n}\n\n// Vertical Icons {\n\n.btn-icon-vertical {\n  padding-top: ($btn-block-spacing-y * 2);\n  padding-bottom: ($btn-block-spacing-y * 2);\n\n  .btn-icon-wrapper {\n    display: block;\n    font-size: 200%;\n    margin: 5px 0;\n    opacity: .6;\n  }\n\n  &.btn-link {\n    text-decoration: none;\n  }\n\n  &.btn-lg:not(.btn-block) {\n    .btn-icon-wrapper {\n      font-size: 25px;\n    }\n  }\n\n  &.btn-sm:not(.btn-block) {\n    .btn-icon-wrapper {\n      font-size: 16px;\n    }\n  }\n\n  &:active,\n  &.active,\n  &:hover {\n    .btn-icon-wrapper {\n      opacity: 1;\n    }\n  }\n\n  &.btn-icon-bottom {\n    .btn-icon-wrapper {\n      margin: ($spacer / 5) 0 5px;\n    }\n  }\n\n  &.btn-transition-text {\n    .btn-icon-wrapper {\n      transition: all .2s !important;\n    }\n\n    &:hover {\n      .btn-icon-wrapper {\n        transform: scale(1.3);\n      }\n    }\n\n    &.btn-transition-alt {\n\n      &:hover {\n        .btn-icon-wrapper {\n          color: $white !important;\n        }\n      }\n    }\n  }\n}\n\n.btn-icon-lg {\n  font-size: $h1-font-size !important;\n}\n\n// Buttons Transitions\n\n.btn-transition {\n  color: $gray-600;\n  border-color: $gray-200;\n  background-color: none;\n\n  &.btn-outline-link {\n    border-color: transparent;\n    background-color: transparent;\n\n    &:hover {\n      color: $primary;\n      background: $gray-100;\n    }\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $gray-600;\n    border-color: $gray-200;\n  }\n\n  &:hover {\n    .btn-icon-wrapper {\n      transition: none;\n    }\n  }\n}\n\n.btn-transition-alt {\n  &:hover {\n    .icon-gradient {\n      -webkit-background-clip: initial;\n      -webkit-text-fill-color: initial;\n      background-clip: initial;\n      text-fill-color: initial;\n      background: none !important;\n      color: $white;\n    }\n  }\n}\n\n// Square Buttons\n\n.btn-square {\n  @include border-radius(0 !important);\n}\n\n// Wide buttons\n\n.btn {\n  &.btn-wide {\n    @include button-size($btn-padding-y, ($btn-padding-x * 2), $font-size-xs, $btn-line-height, $btn-border-radius);\n  }\n}\n\n.btn-lg {\n  &.btn-wide {\n    @include button-size($btn-padding-y-lg, ($btn-padding-x-lg * 2), $font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n  }\n}\n\n.btn-sm {\n  &.btn-wide {\n    @include button-size($btn-padding-y-sm, ($btn-padding-x-sm * 2), $font-size-xs, $btn-line-height-sm, $btn-border-radius-sm);\n  }\n}\n\n// Dropdown toggle\n\n.dropdown-toggle {\n  &::after {\n    position: relative;\n    top: 2px;\n    opacity: .8;\n  }\n}\n\n.dropright {\n  .dropdown-toggle {\n    &::after {\n      top: 0;\n    }\n  }\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, .1) solid 1px;\n}\n\n// Buttons Gradients\n\n$btn-gradients: ();\n\n$gradient-primary: $brand;\n$gradient-secondary: $gray-600;\n$gradient-success: $green;\n$gradient-info: $cyan;\n$gradient-warning: $yellow;\n$gradient-danger: $red;\n$gradient-light: $blue-light;\n$gradient-dark: $gray-800;\n$gradient-focus: $indigo;\n$gradient-alt: $purple;\n\n$gradinet-percent: 15%;\n\n$btn-gradients: map_merge(\n                (\n                        \"primary\": (\n                                darken($gradient-primary, $gradinet-percent), // color-start\n                                $gradient-primary, // color-end\n                                0%, // gr-start\n                        ),\n                        \"secondary\": (\n                                darken($gradient-secondary, $gradinet-percent), // color-start\n                                $gradient-secondary, // color-end\n                                0%, // gr-start\n                        ),\n                        \"success\": (\n                                darken($gradient-success, $gradinet-percent), // color-start\n                                $gradient-success, // color-end\n                                0%, // gr-start\n                        ),\n                        \"info\": (\n                                darken($gradient-info, $gradinet-percent), // color-start\n                                $gradient-info, // color-end\n                                0%, // gr-start\n                        ),\n                        \"warning\": (\n                                darken($gradient-warning, $gradinet-percent), // color-start\n                                $gradient-warning, // color-end\n                                0%, // gr-start\n                        ),\n                        \"danger\": (\n                                darken($gradient-danger, $gradinet-percent), // color-start\n                                $gradient-danger, // color-end\n                                0%, // gr-start\n                        ),\n                        \"focus\": (\n                                darken($gradient-focus, $gradinet-percent), // color-start\n                                $gradient-focus, // color-end\n                                0%, // gr-start\n                        ),\n                        \"alternate\": (\n                                darken($gradient-alt, $gradinet-percent), // color-start\n                                $gradient-alt, // color-end\n                                0%, // gr-start\n                        ),\n                        \"light\": (\n                                darken($gradient-light, $gradinet-percent), // color-start\n                                $gradient-light, // color-end\n                                0%, // gr-start\n                        ),\n                        \"dark\": (\n                                darken($gradient-dark, $gradinet-percent), // color-start\n                                $gradient-dark, // color-end\n                                0%, // gr-start\n                        ),\n                ),\n                $btn-gradients\n);\n\n@mixin btn-grad-variant($color-start, $color-end, $gr-start) {\n  background-image: linear-gradient(140deg, $color-start -30%, $color-end 90%);\n  background-color: $color-start;\n  border-color: $color-start;\n  color: color-yiq(darken($color-start, 10%));\n\n  &.active,\n  &:active,\n  &:not(:disabled):not(.disabled):hover {\n    background-image: linear-gradient(120deg, darken($color-start, 3%) 0%, darken($color-end, 3%) 100%);\n    color: color-yiq(darken($color-start, 10%));\n    border-color: darken($color-start, 10%);\n  }\n\n  &:focus,\n  &.focus,\n  &:active,\n  &.active {\n    color: color-yiq(darken($color-start, 10%)) !important;\n    border-color: darken($color-end, 20%) !important;\n  }\n\n}\n\n@each $grad, $colors in $btn-gradients {\n  $color: nth($colors, 1);\n  $color1: nth($colors, 2);\n  $color2: nth($colors, 3);\n\n  .btn-gradient-#{$grad} {\n    @include btn-grad-variant($color, $color1, $color2);\n\n    &.btn-shadow {\n      box-shadow: 0 0.125rem 0.625rem rgba($color1, .4), 0 0.0625rem 0.125rem rgba($color1, .5);\n\n      &:hover {\n        box-shadow: 0 0.125rem 0.625rem rgba($color1, .5), 0 0.0625rem 0.125rem rgba($color1, .6);\n      }\n    }\n  }\n}\n\n.btn-shadow {\n  &.active {\n    box-shadow: 0 0 0 0 transparent !important;\n  }\n}\n\n// Links\n\n$link-color: theme-color(\"primary\");\n$link-hover-color: darken($link-color, 15%);\n\n// Generate Buttons\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n\n    &.btn-shadow {\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\n\n      &:hover {\n        box-shadow: 0 0.125rem 0.625rem rgba($value, .5), 0 0.0625rem 0.125rem rgba($value, .6);\n      }\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-shadow-#{$color} {\n    &:hover {\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n\n    &.btn-shadow {\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\n\n      &.active:hover,\n      &.disabled:hover,\n      &:active:hover,\n      &:disabled:hover {\n        box-shadow: 0 0.125rem 0.625rem rgba($value, .5), 0 0.0625rem 0.125rem rgba($value, .6);\n      }\n\n      &:hover {\n        box-shadow: (0px 5px 15px 2px rgba($value, 0.19));\n      }\n    }\n  }\n}\n\n.btn {\n  position: relative;\n  @include transition($btn-transition);\n}\n\n.btn-light {\n  border-color: darken(#f5f5f5, 10%);\n}\n\n.btn-outline-light {\n  color: darken(#f5f5f5, 40%);\n}","// Dropdown\n\n.dropdown-menu {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(darken($primary, 50%), .03),\n  0 0.9375rem 1.40625rem rgba(darken($primary, 50%), .03),\n  0 0.25rem 0.53125rem rgba(darken($primary, 50%), .05),\n  0 0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\n  font-size: $font-size-base;\n\n  margin: $dropdown-spacer;\n\n  &.dropdown-menu-right {\n    right: 0 !important;\n  }\n\n  .dropdown-header {\n    text-transform: uppercase;\n    font-size: $font-size-base / 1.2;\n    color: $primary;\n    font-weight: bold;\n  }\n\n  .dropdown-item {\n    font-size: $font-size-base;\n    display: flex;\n    align-items: center;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    cursor: pointer;\n    z-index: 6;\n    position: relative;\n\n    .dropdown-icon {\n      font-size: 1rem;\n      margin-right: ($dropdown-padding-y / 2);\n      width: 30px;\n      text-align: center;\n      opacity: .3;\n      margin-left: -10px;\n    }\n\n    &:hover {\n      .dropdown-icon {\n        opacity: .7;\n      }\n    }\n  }\n\n  &.dropdown-menu-shadow {\n    box-shadow: 0 0.66875rem 2.3875rem rgba(darken($primary, 50%), .03),\n    0 1.1375rem 1.60625rem rgba(darken($primary, 50%), .03),\n    0 0.45rem 0.73125rem rgba(darken($primary, 50%), .05),\n    0 0.325rem 0.3875rem rgba(darken($primary, 50%), .03);\n  }\n}\n\n.dropdown-menu-rounded {\n  @include border-radius(10px);\n  padding: $dropdown-padding-y;\n\n  .dropdown-item {\n    @include border-radius(30px);\n  }\n\n  .dropdown-divider {\n    margin-left: -$dropdown-padding-y;\n    margin-right: -$dropdown-padding-y;\n  }\n\n  .dropdown-menu-header {\n    margin-left: -$dropdown-padding-y;\n    margin-right: -$dropdown-padding-y;\n    @include border-top-radius(10px);\n  }\n\n  .menu-header-image,\n  .dropdown-menu-header-inner {\n    @include border-top-radius(10px);\n  }\n}\n\n.dropdown-menu-hover-link {\n  .dropdown-item {\n    &:hover {\n      background: none;\n      color: $primary;\n    }\n  }\n}\n\n.dropdown-menu-hover-primary {\n  .dropdown-item {\n    &:hover {\n      background: $primary;\n      color: $white;\n    }\n  }\n}\n\n.dropdown-menu {\n  &.dropdown-menu-lg {\n    min-width: 22rem;\n  }\n\n  &.dropdown-menu-xl {\n    min-width: 25rem;\n  }\n}\n\n// Dropdown header\n\n.dropdown-menu {\n  .dropdown-menu-header,\n  .menu-header-image,\n  .dropdown-menu-header-inner {\n    @include border-top-radius($dropdown-border-radius);\n  }\n}\n\n.dropdown-menu-header {\n  color: $white;\n  margin-top: -$dropdown-padding-y;\n  margin-bottom: $dropdown-padding-y;\n  position: relative;\n  z-index: 6;\n\n  .dropdown-menu-header-inner {\n    margin: -1px -1px 0;\n    padding: ($spacer * 1.5) ($spacer / 2);\n    position: relative;\n  }\n\n  .menu-header-image {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 8;\n    opacity: .25;\n    filter: grayscale(80%);\n    background-size: cover;\n  }\n\n  .menu-header-content {\n    text-align: center;\n    position: relative;\n    z-index: 10;\n\n    &.text-left {\n      padding-left: ($spacer / 2);\n    }\n\n    &.btn-pane-right {\n      padding-left: ($spacer / 2);\n      padding-right: ($spacer / 2);\n      display: flex;\n      align-content: center;\n      align-items: center;\n      text-align: left;\n\n      .menu-header-btn-pane {\n        margin: 0 0 0 auto;\n      }\n    }\n\n    .menu-header-btn-pane {\n      margin-top: 10px;\n      margin-bottom: 3px;\n    }\n  }\n\n  & + .grid-menu {\n    margin-top: -$dropdown-padding-y;\n  }\n}\n\n.menu-header-title {\n  font-weight: 500;\n  font-size: $h5-font-size;\n  margin: 0;\n}\n\n.menu-header-subtitle {\n  font-size: $font-family-base;\n  margin: 5px 0 0;\n  opacity: .8;\n}\n\n.dropdown-menu {\n  .grid-menu {\n    margin-bottom: -$dropdown-padding-y;\n    padding: 1px;\n\n    [class*=\"col-\"] {\n      padding: $dropdown-padding-y;\n    }\n  }\n\n  .grid-menu-xl {\n    margin-bottom: -($dropdown-padding-y / 1.35);\n\n    [class*=\"col-\"] {\n      padding: 0;\n    }\n  }\n}\n\n// Dropdown toggle\n\n.dropdown-toggle {\n  &::after {\n    position: relative;\n    top: 2px;\n    opacity: .8;\n    margin-left: 5px;\n  }\n}\n\n.dropdown-toggle-split {\n  &::after {\n    margin-left: 0;\n  }\n}\n\n.dropright {\n  .dropdown-toggle {\n    &::after {\n      top: 0;\n    }\n  }\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, .1) solid 2px;\n}\n\n// Dropdown Indicators\n\n.dropdown-menu {\n\n  &::before,\n  &::after {\n    position: absolute;\n    width: 14px;\n    height: 14px;\n    left: 5px;\n    top: -5px;\n    transform: rotate(45deg);\n    border-radius: 4px;\n    content: '';\n    display: block;\n    z-index: 5;\n  }\n\n  &::before {\n    background: $dropdown-bg;\n    z-index: 5;\n  }\n\n  &::after {\n    top: -6px;\n    background: $dropdown-border-color;\n    z-index: 4;\n  }\n\n  &[data-placement=\"top-start\"] {\n    &::before,\n    &::after {\n      top: auto;\n      bottom: -5px;\n    }\n\n    &::after {\n      bottom: -6px;\n    }\n  }\n\n  &[data-placement=\"left-start\"] {\n    &::before,\n    &::after {\n      left: auto;\n      right: -5px;\n      top: 5px;\n    }\n\n    &::after {\n      top: 5px;\n      right: -6px;\n    }\n  }\n\n  &[data-placement=\"right-start\"] {\n    &::before,\n    &::after {\n      right: auto;\n      left: -5px;\n      top: 5px;\n    }\n\n    &::after {\n      top: 5px;\n      left: -6px;\n    }\n  }\n\n  &.dropdown-menu-right {\n    &::before,\n    &::after {\n      left: auto;\n      right: 6px;\n    }\n\n    &::after {\n      right: 6px;\n    }\n  }\n\n  &.rm-pointers {\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n}\n\n// Dropdown Mega Menu\n\n.dropdown-mega-menu {\n  width: 56rem;\n  padding: $spacer;\n\n  .nav-item.nav-item-header {\n    text-transform: none;\n    font-size: $h6-font-size;\n    padding-top: 0;\n    font-weight: normal;\n  }\n\n  .grid-menu {\n    margin-bottom: 0;\n  }\n}\n\n.dropdown-mega-menu-sm {\n  width: 40rem;\n}\n\n// Dropdown Inline\n\nbody .dropdown-menu.dropdown-menu-inline {\n  border: 0;\n  position: static !important;\n  box-shadow: 0 0 0 transparent;\n  background: transparent;\n  @include border-radius(0);\n  display: inline-block;\n  float: none;\n  left: 0 !important;\n  top: 0 !important;\n  width: 100% !important;\n  transform: translateY(0) !important;\n\n  &::before,\n  &::after {\n    display: none;\n  }\n}\n","// NAVS\n\n.nav-item {\n  .nav-link {\n    font-weight: normal;\n  }\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n\n  .nav-link-icon {\n    color: $primary;\n    font-size: 1rem;\n    width: 30px;\n    text-align: center;\n    opacity: .45;\n    margin-left: -10px;\n  }\n\n  &:hover {\n    color: $gray-700;\n\n    .nav-link-icon {\n      opacity: .9;\n      color: $primary;\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    .nav-link-icon {\n      opacity: .3;\n    }\n  }\n}\n\n.nav-item {\n  &.nav-item-header {\n    text-transform: uppercase;\n    font-size: $font-size-base / 1.2;\n    color: $gray-600;\n    font-weight: bold;\n    padding: $nav-link-padding-y $nav-link-padding-x;\n  }\n\n  &.nav-item-btn {\n    padding: $nav-link-padding-y $nav-link-padding-x;\n  }\n\n  &.nav-item-divider {\n    margin: $nav-link-padding-y 0;\n    height: 1px;\n    overflow: hidden;\n    background: $gray-300;\n  }\n}\n\n.nav {\n  .badge {\n    margin-left: 8px;\n  }\n}\n\n.nav-pills {\n  .nav-link {\n\n    &.active,\n    &.active:hover {\n      color: $white;\n\n      .nav-link-icon {\n        color: $white;\n        opacity: .8;\n      }\n    }\n\n    &:hover {\n      color: $gray-700 !important;\n    }\n  }\n}\n\n// Grid Menus\n\n.grid-menu {\n\n  [class*=\"col-\"] {\n    border-right: $border-color solid 0;\n    border-bottom: $border-color solid 1px;\n\n    &:hover {\n      z-index: 5;\n    }\n  }\n\n  @include media-breakpoint-between(sm, xl) {\n\n    [class*=\"col-\"]:nth-last-child(-n+2) {\n      border-bottom-width: 0;\n    }\n\n    [class*=\"col-\"]:nth-child(1n) {\n      border-right-width: 1px;\n    }\n\n    [class*=\"col-\"]:nth-child(2n) {\n      border-right-width: 0;\n    }\n  }\n\n  [class*=\"col-\"]:nth-last-child(-n+1) {\n    border-bottom-width: 0;\n  }\n\n  &.grid-menu-3col {\n\n    @include media-breakpoint-up(xl) {\n\n      [class*=\"col-\"]:nth-last-child(-n+3) {\n        border-bottom-width: 0;\n      }\n\n      [class*=\"col-\"]:nth-child(2n) {\n        border-right-width: 1px;\n      }\n\n      [class*=\"col-\"]:nth-child(3n) {\n        border-right-width: 0;\n      }\n    }\n  }\n\n  .btn {\n    display: block;\n    border: 0;\n    min-width: 100%;\n  }\n}\n\n","// Badges\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n\n.badge {\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 5px 10px;\n  min-width: 19px;\n}\n\n.badge-light {\n  background: $white;\n}\n\n.badge-dot {\n  text-indent: -999em;\n  padding: 0;\n  width: 8px;\n  height: 8px;\n  border: transparent solid 1px;\n  @include border-radius(30px);\n  min-width: 2px;\n}\n\n.badge-dot-lg {\n  width: 10px;\n  height: 10px;\n}\n\n.badge-dot-xl {\n  width: 18px;\n  height: 18px;\n  position: relative;\n\n  &::before {\n    content: '';\n    width: 10px;\n    height: 10px;\n    @include border-radius($border-radius);\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -5px 0 0 -5px;\n    background: $white;\n  }\n}\n\n.badge-dot-sm {\n  width: 6px;\n  height: 6px;\n}\n\n.btn {\n  .badge {\n    margin-left: 8px;\n  }\n\n  .badge-dot {\n    position: absolute;\n    border: $white solid 2px;\n    top: -5px;\n    right: -5px;\n    width: 11px;\n    height: 11px;\n\n    &.badge-dot-lg {\n      width: 14px;\n      height: 14px;\n    }\n\n    &.badge-dot-sm {\n      width: 8px;\n      height: 8px;\n      border-width: 1px;\n    }\n  }\n\n  .badge-dot-inside {\n    top: 10px;\n    right: 10px;\n  }\n}\n\n.btn-sm {\n  .badge-dot-sm {\n    top: 1px;\n    right: 4px;\n  }\n\n  .badge-dot {\n    top: 0px;\n    right: 2px;\n  }\n\n  .badge-dot-lg {\n    top: -3px;\n    right: -2px;\n  }\n\n  .badge-pill {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n  }\n}\n\n.badge-abs {\n  position: absolute;\n  right: -3px;\n  top: -3px;\n}\n\n// Avatars\n\n.avatar-icon-wrapper {\n  display: inline-block;\n  margin-right: .1rem;\n  position: relative;\n\n  .badge {\n    position: absolute;\n    right: -2px;\n    top: -2px;\n\n    &:empty {\n      display: block;\n    }\n\n    &.badge-bottom {\n      top: auto;\n      right: -2px;\n      bottom: -2px;\n    }\n  }\n\n  .badge-dot {\n    width: 10px;\n    height: 10px;\n    border: $white solid 2px;\n\n    &.badge-dot-lg {\n      width: 14px;\n      height: 14px;\n      border: $white solid 2px;\n      top: 0;\n      right: 0;\n\n      &.badge-bottom {\n        top: auto;\n        right: 0;\n        bottom: 0;\n      }\n    }\n  }\n}\n\n.avatar-icon-add {\n\n  .avatar-icon {\n    background: $dropdown-link-hover-bg;\n    border: lighten($primary, 15%) dashed 1px;\n    color: $primary;\n    text-align: center;\n    opacity: .6;\n\n    i {\n      font-style: normal;\n      vertical-align: middle;\n      font-size: $h4-font-size;\n      display: block;\n      height: 100%;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n\n    .avatar-icon {\n      opacity: 1;\n    }\n  }\n}\n\na.avatar-icon-wrapper {\n  &:hover {\n\n    .avatar-icon {\n      opacity: .8;\n    }\n  }\n}\n\n.avatar-icon {\n  display: block;\n  width: 44px;\n  height: 44px;\n  transition: all .2s;\n  opacity: 1;\n  @include border-radius(50px);\n\n  &.rounded {\n    @include border-radius(($border-radius-lg * 1.3) !important);\n  }\n}\n\n.avatar-icon-xl {\n  .avatar-icon {\n    width: 64px;\n    height: 64px;\n  }\n\n  &.avatar-icon-add {\n    i {\n      font-size: $h2-font-size;\n    }\n  }\n}\n\n.avatar-icon-lg {\n  .avatar-icon {\n    width: 54px;\n    height: 54px;\n  }\n\n  &.avatar-icon-add {\n    i {\n      font-size: $h3-font-size;\n    }\n  }\n}\n\n.avatar-icon-sm {\n  .avatar-icon {\n    width: 34px;\n    height: 34px;\n  }\n\n  &.avatar-icon-add {\n    i {\n      font-size: $font-size-lg;\n    }\n  }\n}\n\n.avatar-icon-xs {\n  .avatar-icon {\n    width: 26px;\n    height: 26px;\n    transition: transform .2s;\n  }\n\n  &.avatar-icon-add {\n    i {\n      line-height: 26px;\n      font-size: $font-size-base;\n    }\n  }\n\n  &:hover {\n    .avatar-icon {\n      transform: scale(2);\n    }\n  }\n}\n\n.avatar-icon {\n  border: $white solid 3px;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.avatar-wrapper-overlap {\n  .avatar-icon-wrapper {\n    z-index: 5;\n    margin-left: -18px;\n\n    &:hover {\n      z-index: 7;\n    }\n\n    &.avatar-icon-xl {\n      margin-left: -30px;\n    }\n    &.avatar-icon-lg {\n      margin-left: -24px;\n    }\n    &.avatar-icon-sm {\n      margin-left: -14px;\n    }\n    &.avatar-icon-xs {\n      margin-left: -10px;\n    }\n\n    &.avatar-icon-add,\n    &:first-child {\n      margin-left: 0 !important;\n    }\n  }\n}\n\n// Badge Pulse\n\n@-webkit-keyframes sploosh {\n  0% {\n    box-shadow: 0 0 0 0px rgba(#333, .2);\n  }\n  100% {\n    box-shadow: 0 0 0 8px rgba(#333, 0);\n  }\n}\n\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n  }\n  16.5% {\n    -webkit-transform: scale(1.2);\n  }\n  33% {\n    -webkit-transform: scale(1.1);\n  }\n  100% {\n    -webkit-transform: scale(1);\n  }\n}\n\n.badge-pulse {\n  -webkit-animation: pulse 2s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  position: relative;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: 0;\n\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n\n    -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);\n    -webkit-animation-iteration-count: infinite;\n  }\n\n  &::after {\n    -webkit-animation-delay: .33s;\n    -webkit-animation-duration: 2.2s;\n  }\n}","// CARDS\n\n.card {\n  box-shadow: $box-shadow-default;\n  border-width: 0;\n  transition: all .2s;\n\n  & > .dropdown-menu-header {\n    margin: 0;\n\n    .dropdown-menu-header-inner {\n      @include border-top-radius($card-border-radius);\n    }\n  }\n\n  &.text-dark.text-white,\n  &.text-white {\n    .card-footer,\n    .card-header {\n      background: rgba(255, 255, 255, .1);\n      color: rgba(255, 255, 255, .9);\n    }\n  }\n\n  &.text-dark.text-white {\n    .card-footer,\n    .card-header {\n      color: rgba(0, 0, 0, .9);\n    }\n  }\n\n  .card-footer {\n    display: flex;\n    align-items: center;\n  }\n}\n\n.btn-actions-pane-right {\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.btn-actions-pane-left {\n  margin-right: auto;\n}\n\n.actions-icon-btn {\n  .btn-icon-only {\n    padding-left: 0;\n    padding-right: 0;\n\n    .btn-icon-wrapper {\n      font-size: 1.3rem;\n      width: 30px;\n      text-align: center;\n    }\n\n    color: $gray-700;\n\n    &:hover {\n      color: $primary;\n    }\n  }\n}\n\n.card-header,\n.card-title {\n  text-transform: uppercase;\n  color: rgba(darken($primary, 40%), .7);\n  font-weight: bold;\n  font-size: $font-size-base;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  border-bottom-width: 1px;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-right: ($card-spacer-x / 2);\n  height: 3.5rem;\n\n  &.no-border {\n    border: 0;\n    padding: 0;\n    height: auto;\n  }\n\n  .menu-header-subtitle {\n    display: block;\n  }\n\n  &.card-header-tab {\n    .nav {\n      width: auto;\n      margin-left: auto;\n    }\n\n    .card-header-title {\n      display: flex;\n      align-items: center;\n      white-space: nowrap;\n    }\n  }\n\n  .header-icon {\n    font-size: ($font-size-lg * 1.5);\n    margin-right: ($card-spacer-x / 2);\n  }\n\n  & > .nav {\n    margin-left: -($card-spacer-x / 2);\n    height: 100%;\n    width: 100%;\n\n    .nav-item {\n      position: relative;\n      height: 100%;\n      display: flex;\n      align-items: center;\n    }\n\n    .nav-link {\n      text-transform: none;\n      width: 100%;\n      display: block;\n      color: $gray-700;\n\n      &::before {\n        content: '';\n        @include border-radius(15px);\n        background: $primary;\n        transition: all .2s;\n        height: 4px;\n        width: 100%;\n        position: absolute;\n        left: 0;\n        bottom: -2px;\n        opacity: 0;\n      }\n\n      &:hover {\n        color: $primary;\n      }\n\n      &.active {\n        color: $primary;\n\n        &::before {\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  &.card-header-tab-animation {\n    .nav .nav-link {\n      &::before {\n        transform: scale(0);\n        opacity: 1;\n        width: 90%;\n        left: 5%;\n      }\n\n      &.active,\n      &:hover {\n        &::before {\n          transform: scale(1);\n        }\n      }\n    }\n  }\n}\n\n.card-border {\n  box-shadow: 0 0 0 transparent;\n  border-width: 1px;\n}\n\n.card-hover-shadow {\n  &:hover {\n    box-shadow: 0 0.46875rem 2.1875rem rgba(darken($primary, 50%), .03),\n    0 0.9375rem 1.40625rem rgba(darken($primary, 50%), .03),\n    0 0.25rem 0.53125rem rgba(darken($primary, 50%), .05),\n    0 0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\n  }\n}\n\n.card-hover-shadow-2x {\n  &:hover {\n    box-shadow: 0 0.66875rem 2.3875rem rgba(darken($primary, 50%), .03),\n    0 1.1375rem 1.60625rem rgba(darken($primary, 50%), .03),\n    0 0.45rem 0.73125rem rgba(darken($primary, 50%), .05),\n    0 0.325rem 0.3875rem rgba(darken($primary, 50%), .03);\n  }\n}\n\n.card-subtitle {\n  margin-bottom: $card-spacer-y;\n  font-size: $font-size-sm;\n  color: rgba(darken($primary, 40%), .55);\n}\n\n@each $color, $value in $theme-colors {\n  .card-shadow-#{$color} {\n    box-shadow: 0 0.46875rem 2.1875rem rgba($value, .03),\n    0 0.9375rem 1.40625rem rgba($value, .03),\n    0 0.25rem 0.53125rem rgba($value, .05),\n    0 0.125rem 0.1875rem rgba($value, .03);\n  }\n}\n\n// Large Card Header\n\n.card-header-lg {\n  padding: ($card-spacer-y * 2) ($card-spacer-x * 2);\n  height: auto;\n}\n\n.sticky-active-class {\n  .sticky-inner-wrapper {\n    & > div {\n      box-shadow: $box-shadow-default;\n    }\n  }\n}","// TABS\n\n.nav-pills,\n.nav-tabs {\n  margin-bottom: $spacer;\n}\n\n.nav-link {\n  font-weight: bold;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.nav-tabs {\n  .nav-link {\n\n    &:hover {\n      color: $primary !important;\n    }\n\n    &.active {\n      color: $primary;\n    }\n  }\n}\n\n.nav-pills {\n  .nav-link {\n\n    &:hover {\n      color: $primary !important;\n    }\n\n    &.active {\n      background: $primary;\n\n      &:hover {\n        color: $white !important;\n      }\n    }\n  }\n}\n\n// Fancy Tabs\n\n.RRT__container {\n  position: relative;\n}\n\n.RRT__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.RRT__accordion {\n  flex-direction: column;\n}\n\n.RRT__tab {\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  transition: all .2s;\n\n  &:hover {\n    color: $primary;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.RRT__tab--selected {\n  color: $primary;\n}\n\n.RRT__tab--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.RRT__tab:focus {\n  z-index: 2;\n}\n\n.RRT__tab--selected .RRT__removable {\n  position: relative;\n}\n\n.RRT__tab--selected .RRT__removable-text {\n  margin-right: 10px;\n}\n\n.RRT__tab--selected .RRT__removable-icon {\n  position: absolute;\n  font-size: 18px;\n  right: 0.5em;\n  top: 0.2em;\n}\n\n// Alternate Style\n\n.body-tabs.body-tabs-layout {\n  &.body-tabs-big {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    @extend .container;\n    margin: 0 auto;\n    padding: 10px;\n    @include border-radius(50px);\n    border: $gray-200 solid 1px;\n    z-index: 7;\n\n    .RRT__tab {\n      margin: 0;\n      font-size: 1rem;\n      font-weight: 300;\n      padding: 0;\n      height: 50px;\n      line-height: 50px;\n      flex: 1;\n      text-align: center;\n      position: relative;\n      color: $primary;\n\n      &:hover {\n        color: $gray-900;\n      }\n\n      &.RRT__tab--selected {\n        color: $white;\n\n        &:hover {\n          color: $white;\n        }\n      }\n    }\n\n    & + .RRT__inkbar-wrapper {\n      height: 70px !important;\n      top: -70px !important;\n      @extend .container;\n      margin: 0 auto -3.4rem;\n      position: relative;\n      padding: 0 10px;\n\n      &::before {\n        position: absolute;\n        content: '';\n        background: $white;\n        width: 100%;\n        height: 100%;\n        left: 0;\n        top: -11px;\n        @include border-radius(50px);\n      }\n\n      .RRT__inkbar {\n        height: 50px !important;\n        margin-top: 10px;\n        @include border-radius(50px);\n        box-shadow: 0 0 0 transparent;\n      }\n\n      & + .RRT__panel {\n        margin-top: -1rem;\n      }\n    }\n  }\n}\n\n// Panels\n\n.RRT__panel {\n  margin-top: $spacer;\n}\n\n.RRT__accordion .RRT__panel {\n}\n\n// Show More\n\n.RRT__showmore {\n  @include border-radius($border-radius);\n  background: $primary;\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  font-weight: bold;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  display: block;\n  margin-left: 15px;\n  position: absolute;\n  right: $grid-gutter-width;\n  top: 50%;\n  margin-top: -18px;\n  font-size: 1.4rem;\n\n  &:focus {\n    outline: none;\n\n  }\n}\n\n.RRT__showmore-label {\n  position: relative;\n  z-index: 1;\n  color: $white;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  line-height: 24px;\n}\n\n.RRT__showmore--selected {\n  box-shadow: 0 16px 26px -10px rgba($primary, 0.56),\n  0 4px 25px 0px rgba(0, 0, 0, 0.12),\n  0 8px 10px -5px rgba($primary, 0.2);\n}\n\n.RRT__showmore-list {\n  position: absolute;\n  right: -1px;\n  top: 100%;\n  display: none;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y 0;\n  margin: $dropdown-spacer 0 0; // override default ul\n  font-size: $font-size-base; // Redeclare because nesting can cause inheritance issues\n  color: $body-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  box-shadow: $box-shadow-default;\n\n  .RRT__tab {\n    display: block;\n    width: 100%; // For `<button>`s\n    padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n    clear: both;\n    font-weight: $font-weight-normal;\n    color: $dropdown-link-color;\n    text-align: inherit; // For `<button>`s\n    white-space: nowrap; // prevent links from randomly breaking onto new lines\n    background-color: transparent; // For `<button>`s\n    border: 0; // For `<button>`s\n    margin: 0;\n\n    &:hover,\n    &.RRT__tab--selected {\n      color: $dropdown-link-hover-color !important;\n      text-decoration: none;\n      background: $dropdown-link-hover-bg;\n    }\n  }\n}\n\n.RRT__showmore-list--opened {\n  display: block;\n\n  .RRT__tab--selected {\n    color: $primary;\n  }\n}\n\n// Inkbar\n\n.RRT__inkbar-wrapper {\n  width: 100%;\n}\n\n.RRT__inkbar {\n  position: relative;\n  bottom: 0;\n  height: 3px;\n  margin-top: -3px;\n  background-color: $primary;\n  @include border-radius(15px);\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n  z-index: 2;\n}\n\n.card-tabs {\n  .card-header {\n    padding: 0 1.25rem;\n\n    &.RRT__tabs {\n      cursor: pointer;\n      font-weight: normal;\n\n      .RRT__tab {\n        text-transform: none;\n        line-height: 1.3;\n      }\n    }\n  }\n\n  .RRT__inkbar-wrapper {\n    width: calc(100% - 1.5rem) !important;\n    margin-left: 1.25rem;\n  }\n\n  .RRT__panel {\n    padding: $spacer;\n    margin: 0;\n  }\n\n  &.text-white {\n\n    .RRT__tab {\n      color: rgba(255, 255, 255, .6);\n\n      &:hover {\n        color: $white;\n      }\n    }\n\n    .RRT__tab--selected {\n      color: $white;\n    }\n\n    .RRT__inkbar {\n      background: lighten($primary, 40%);\n    }\n  }\n}\n\n.card-tabs-animated {\n  .RRT__container > .RRT__tabs {\n    background: transparent;\n    position: relative;\n    z-index: 7;\n\n    &.card-header {\n      border-bottom: 0;\n      height: auto;\n      padding: $layout-spacer-x $layout-spacer-x ($layout-spacer-x / 3);\n    }\n  }\n\n  .RRT__inkbar-wrapper {\n    position: absolute;\n    top: $layout-spacer-x;\n    z-index: 5;\n  }\n\n  .RRT__tab {\n    padding: $nav-link-padding-y ($nav-link-padding-x * 1.2);\n  }\n\n  .RRT__tab--selected {\n    color: $white;\n  }\n\n  .RRT__inkbar {\n    height: 35px;\n    margin-top: 0;\n    @include border-radius($border-radius);\n    box-shadow: 0 16px 26px -10px rgba($primary, 0.56),\n    0 4px 25px 0px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba($primary, 0.2);\n  }\n}\n\n.card-tabs-animated-inner {\n  .RRT__tabs {\n    padding: 0 5%;\n  }\n\n  .RRT__inkbar-wrapper {\n    left: 5%;\n    width: 90%;\n    height: 36px;\n    top: 14px;\n  }\n\n  .RRT__inkbar {\n    height: 36px;\n  }\n}\n\n.body-tabs {\n  border-bottom: $gray-300 solid 2px;\n\n  & > .RRT__tab {\n    padding: ($layout-spacer-x / 1.5) ($layout-spacer-x / 1.2);\n    font-weight: normal;\n    font-size: $font-size-base;\n  }\n\n  &.body-tabs-alt {\n    & > .RRT__tab {\n      padding: ($layout-spacer-x / 1.1) ($layout-spacer-x / 3);\n      font-weight: normal;\n      font-size: 0.86rem;\n      width: 33%;\n      text-align: center;\n    }\n\n    .RRT__inkbar {\n      height: 2px;\n      margin-top: -2px;\n    }\n  }\n}\n\n.popover,\n.dropdown-menu {\n  .RRT__panel {\n    margin: 0;\n    padding: 0;\n    position: relative;\n\n    &::after,\n    &::before {\n      width: 100%;\n      bottom: auto;\n      top: 0;\n      left: 0;\n      height: 20px;\n      position: absolute;\n      z-index: 10;\n      content: '';\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\n    }\n\n    &::after {\n      bottom: 0;\n      top: auto;\n\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 80%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\n    }\n  }\n}\n\n// Tabs alternate\n\n.tabs-lg-alternate {\n  &.card-header {\n    padding: 0;\n    height: auto;\n\n    .widget-number {\n      font-size: $h2-font-size;\n      font-weight: 300;\n    }\n\n    .tab-subheading {\n      padding: 5px 0 0;\n      opacity: .6;\n      transition: all .2s;\n    }\n\n    & > .nav {\n      margin: 0;\n\n      .nav-link {\n        padding: $layout-spacer-x 0;\n        border-right: $gray-200 solid 1px;\n        background: $gray-100;\n\n        &:hover {\n          background: $white;\n          .tab-subheading {\n            color: $black;\n            opacity: .9;\n          }\n        }\n\n        &::before {\n          background: $white;\n          border-radius: 0;\n        }\n\n        &.active {\n          background: $white;\n\n          .tab-subheading {\n            color: $black;\n            opacity: .9;\n          }\n        }\n      }\n\n      .nav-item:last-child {\n        .nav-link {\n          border-right: 0;\n        }\n      }\n    }\n  }\n}\n","// Accordions\n\n.accordion-wrapper {\n  @include border-radius($border-radius);\n  border: $gray-200 solid 1px;\n\n  & > .card {\n    box-shadow: 0 0 0 0 transparent;\n\n    & > .card-header {\n      padding: 1rem;\n      height: auto;\n\n      .btn:active,\n      .btn:focus,\n      .btn:hover {\n        text-decoration: none;\n      }\n\n      .form-heading {\n        p {\n          margin: 0;\n        }\n      }\n    }\n\n    .collapse {\n      border-bottom: transparent solid 1px;\n\n      &.show {\n        border-bottom-color: $gray-200;\n      }\n    }\n  }\n}","// Modals\n\n.modal-header,\n.modal-footer {\n  background: $gray-100;\n}\n\n.modal-footer {\n  @include border-bottom-radius($border-radius);\n}\n\n.modal-dialog {\n  box-shadow: $box-shadow-lg-default;\n  @include border-radius($border-radius);\n}","$primary-color: $primary !default;\n$ball-size: 15px !default;\n$margin: 2px !default;\n$line-height: 35px !default;\n$line-width: 4px !default;\n\n\n@mixin global-bg() {\n  background-color: $primary-color;\n}\n\n@mixin global-animation() {\n  animation-fill-mode: both;\n}\n\n@mixin balls() {\n  @include global-bg();\n\n  width: $ball-size;\n  height: $ball-size;\n  border-radius: 100%;\n  margin: $margin;\n}\n\n@mixin lines() {\n  @include global-bg();\n\n  width: $line-width;\n  height: $line-height;\n  border-radius: 2px;\n  margin: $margin;\n}\n\n\n/**\n * Dots\n */\n@import '../../../node_modules/loaders.css/src/animations/ball-pulse';\n@import '../../../node_modules/loaders.css/src/animations/ball-pulse-sync';\n@import '../../../node_modules/loaders.css/src/animations/ball-scale';\n@import '../../../node_modules/loaders.css/src/animations/ball-rotate';\n@import '../../../node_modules/loaders.css/src/animations/ball-clip-rotate';\n@import '../../../node_modules/loaders.css/src/animations/ball-clip-rotate-pulse';\n@import '../../../node_modules/loaders.css/src/animations/ball-clip-rotate-multiple';\n@import '../../../node_modules/loaders.css/src/animations/ball-scale-ripple';\n@import '../../../node_modules/loaders.css/src/animations/ball-scale-ripple-multiple';\n@import '../../../node_modules/loaders.css/src/animations/ball-beat';\n@import '../../../node_modules/loaders.css/src/animations/ball-scale-multiple';\n@import '../../../node_modules/loaders.css/src/animations/ball-triangle-trace';\n@import '../../../node_modules/loaders.css/src/animations/ball-pulse-rise';\n@import '../../../node_modules/loaders.css/src/animations/ball-grid-beat';\n@import '../../../node_modules/loaders.css/src/animations/ball-grid-pulse';\n@import '../../../node_modules/loaders.css/src/animations/ball-spin-fade-loader';\n@import '../../../node_modules/loaders.css/src/animations/ball-spin-loader';\n@import '../../../node_modules/loaders.css/src/animations/ball-zig-zag';\n@import '../../../node_modules/loaders.css/src/animations/ball-zig-zag-deflect';\n\n/**\n * Lines\n */\n@import '../../../node_modules/loaders.css/src/animations/line-scale';\n@import '../../../node_modules/loaders.css/src/animations/line-scale-random';\n@import '../../../node_modules/loaders.css/src/animations/line-scale-pulse-out';\n@import '../../../node_modules/loaders.css/src/animations/line-scale-pulse-out-rapid';\n@import '../../../node_modules/loaders.css/src/animations/line-spin-fade-loader';\n\n/**\n * Misc\n */\n@import '../../../node_modules/loaders.css/src/animations/triangle-skew-spin';\n@import '../../../node_modules/loaders.css/src/animations/square-spin';\n@import '../../../node_modules/loaders.css/src/animations/pacman';\n@import '../../../node_modules/loaders.css/src/animations/cube-transition';\n@import '../../../node_modules/loaders.css/src/animations/semi-circle-spin';\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes scale {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  45% {\n    transform: scale(0.1);\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n// mixins should be separated out\n@mixin ball-pulse($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation: scale 0.75s delay(0.12s, $n, $i) infinite cubic-bezier(.2,.68,.18,1.08);\n    }\n  }\n}\n\n.ball-pulse {\n  @include ball-pulse();\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@mixin global-bg() {\n  background-color: $primary-color;\n}\n\n@mixin global-animation() {\n  animation-fill-mode: both;\n}\n\n@mixin balls() {\n  @include global-bg();\n\n  width: $ball-size;\n  height: $ball-size;\n  border-radius: 100%;\n  margin: $margin;\n}\n\n@mixin lines() {\n  @include global-bg();\n\n  width: $line-width;\n  height: $line-height;\n  border-radius: 2px;\n  margin: $margin;\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$amount: 10px;\n\n@keyframes ball-pulse-sync {\n  33% {\n    transform: translateY($amount);\n  }\n  66% {\n    transform: translateY(-$amount);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@mixin ball-pulse-sync($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation: ball-pulse-sync 0.6s delay(0.07s, $n, $i) infinite ease-in-out;\n    }\n  }\n}\n\n.ball-pulse-sync {\n  @include ball-pulse-sync();\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-scale {\n  0% {\n    transform: scale(0.0);\n  }\n  100% {\n    transform: scale(1.0);\n    opacity: 0;\n  }\n}\n\n.ball-scale {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    height: 60px;\n    width: 60px;\n    animation: ball-scale 1s 0s ease-in-out infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n }\n}\n\n.ball-rotate {\n  position: relative;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: relative;\n\n    &:first-child {\n      animation: rotate 1s 0s cubic-bezier(.7,-.13,.22,.86) infinite;\n    }\n\n    &:before, &:after {\n      @include balls();\n\n      content: \"\";\n      position: absolute;\n      opacity: 0.8;\n    }\n\n    &:before {\n      top: 0px;\n      left: -28px;\n    }\n\n    &:after {\n      top: 0px;\n      left: 25px;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n.ball-clip-rotate {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    border: 2px solid $primary-color;\n    border-bottom-color: transparent;\n    height: 25px;\n    width: 25px;\n    background: transparent !important;\n    display: inline-block;\n    animation: rotate 0.75s 0s linear infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n@keyframes scale {\n  30% {\n    transform: scale(0.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.ball-clip-rotate-pulse {\n  position: relative;\n  transform: translateY(-15px);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-radius: 100%;\n\n    &:first-child {\n      background: $primary-color;\n      height: 16px;\n      width: 16px;\n      top: 7px;\n      left: -7px;\n      animation: scale 1s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n    }\n\n    &:last-child {\n      position: absolute;\n      border: 2px solid $primary-color;\n      width: 30px;\n      height: 30px;  \n      left: -16px;\n      top: -2px;\n      background: transparent;\n      border: 2px solid;\n      border-color: $primary-color transparent $primary-color transparent;\n      animation: rotate 1s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n      animation-duration: 1s;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n.ball-clip-rotate-multiple {\n  position: relative;\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    left: -20px;\n    top: -20px;\n    border: 2px solid $primary-color;\n    border-bottom-color: transparent;\n    border-top-color: transparent;\n    border-radius: 100%;\n    height: 35px;\n    width: 35px;\n    animation: rotate 1s 0s ease-in-out infinite;\n\n    &:last-child {\n      display: inline-block;\n      top: -10px;\n      left: -10px;\n      width: 15px;\n      height: 15px;\n      animation-duration: 0.5s;\n      border-color: $primary-color transparent $primary-color transparent;\n      animation-direction: reverse;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-scale-ripple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n.ball-scale-ripple {\n\n  > div {\n    @include global-animation();\n\n    height: 50px;\n    width: 50px;\n    border-radius: 100%;\n    border: 2px solid $primary-color;;\n    animation: ball-scale-ripple 1s 0s infinite cubic-bezier(.21,.53,.56,.8);\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 50px;\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n@mixin ball-scale-ripple-multiple ($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: delay(0.2s, $n, $i - 1);\n    }\n  }\n}\n\n.ball-scale-ripple-multiple {\n  @include ball-scale-ripple-multiple();\n\n  position: relative;\n  transform: translateY(-$size / 2);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    top: -2px;\n    left: -26px;\n    width: $size;\n    height: $size;\n    border-radius: 100%;\n    border: 2px solid $primary-color;\n    animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(.21,.53,.56,.8);\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-beat {\n  50% {\n    opacity: 0.2;\n    transform: scale(0.75);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.ball-beat {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    animation: ball-beat 0.7s 0s infinite linear;\n\n    &:nth-child(2n-1) {\n      animation-delay: -0.35s !important;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 60px;\n\n@keyframes ball-scale-multiple {\n  0% {\n    transform: scale(0.0);\n    opacity: 0;\n  }\n  5% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.0);\n    opacity: 0;\n  }\n}\n\n@mixin ball-scale-multiple ($n:3, $start:0) {\n  @for $i from 2 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: delay(0.2s, $n, $i - 1);\n    }\n  }\n}\n\n.ball-scale-multiple {\n  @include ball-scale-multiple();\n\n  position: relative;\n  transform: translateY(-$size / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    left: -30px;\n    top: 0px;\n    opacity: 0;\n    margin: 0;\n    width: $size;\n    height: $size;\n    animation: ball-scale-multiple 1s 0s linear infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 50px;\n\n@keyframes ball-triangle-path-1 {\n  33% {\n    transform: translate($amount / 2, -$amount);\n  }\n  66% {\n    transform: translate($amount, 0px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes ball-triangle-path-2 {\n  33% {\n    transform: translate($amount / 2, $amount);\n  }\n  66% {\n    transform: translate(- $amount / 2, $amount);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes ball-triangle-path-3 {\n  33% {\n    transform: translate(-$amount, 0px);\n  }\n  66% {\n    transform: translate(- $amount / 2, -$amount);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@mixin ball-triangle-path($n:3) {\n  $animations: ball-triangle-path-1 ball-triangle-path-2 ball-triangle-path-3;\n\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-name: nth($animations, $i);\n      animation-delay: 0;\n      animation-duration: 2s;\n      animation-timing-function: ease-in-out;\n      animation-iteration-count: infinite;\n    }\n  }\n}\n\n.ball-triangle-path {\n  position: relative;\n  @include ball-triangle-path();\n  transform: translate(-$amount / 1.667, -$amount / 1.333);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    border: 1px solid $primary-color;\n\n    &:nth-of-type(1) {\n      top: $amount;\n    }\n\n    &:nth-of-type(2) {\n      left: $amount / 2;\n    }\n\n    &:nth-of-type(3) {\n      top: $amount;\n      left: $amount;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$rise-amount: 30px;\n\n@keyframes ball-pulse-rise-even {\n  0% {\n    transform: scale(1.1);\n  }\n  25% {\n    transform: translateY(-$rise-amount);\n  }\n  50% {\n    transform: scale(0.4);\n  }\n  75% {\n    transform: translateY($rise-amount);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(1.0);\n  }\n}\n\n@keyframes ball-pulse-rise-odd {\n  0% {\n    transform: scale(0.4);\n  }\n  25% {\n    transform: translateY($rise-amount);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  75% {\n    transform: translateY(-$rise-amount);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(0.75);\n  }\n}\n\n.ball-pulse-rise {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    animation-duration: 1s;\n    animation-timing-function: cubic-bezier(.15,.46,.9,.6);\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n\n    &:nth-child(2n) {\n      animation-name: ball-pulse-rise-even;\n    }\n\n    &:nth-child(2n-1) {\n      animation-name: ball-pulse-rise-odd;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-grid-beat {\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin ball-grid-beat($n:9) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.6) + s;\n    }\n  }\n\n}\n\n.ball-grid-beat {\n  @include ball-grid-beat();\n  width: ($ball-size * 3) + $margin * 6;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    float: left;\n    animation-name: ball-grid-beat;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-grid-pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@mixin ball-grid-pulse($n:9) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.6) + s;\n    }\n  }\n\n}\n\n.ball-grid-pulse {\n  @include ball-grid-pulse();\n  width: ($ball-size * 3) + $margin * 6;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    float: left;\n    animation-name: ball-grid-pulse;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$radius: 25px;\n\n@keyframes ball-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n    transform: scale(0.4);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@mixin ball-spin-fade-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n      }\n\n      animation: ball-spin-fade-loader 1s delay(0.12s, $n, $i - 1) infinite linear;\n    }\n  }\n}\n\n.ball-spin-fade-loader {\n  @include ball-spin-fade-loader();\n\n  position: relative;\n  top: -10px;\n  left: -10px;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$radius: 45px;\n\n@keyframes ball-spin-loader {\n  75% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin ball-spin-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > span:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n      }\n\n      animation: ball-spin-loader 2s ($i * 0.9s) infinite linear;\n    }\n  }\n}\n\n.ball-spin-loader {\n  @include ball-spin-loader();\n  position: relative;\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    background: green;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 30px;\n\n@keyframes ball-zig {\n  33% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  66% {\n    transform: translate($amount/2, -$amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes ball-zag {\n  33% {\n    transform: translate($amount/2, $amount);\n  }\n  66% {\n    transform: translate(-$amount/2, $amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.ball-zig-zag {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    margin-left: $amount / 2;\n    top: 4px;\n    left: -7px;\n\n    &:first-child {\n      animation: ball-zig 0.7s 0s infinite linear;\n    }\n\n    &:last-child {\n      animation: ball-zag 0.7s 0s infinite linear;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 30px;\n\n@keyframes ball-zig-deflect {\n  17% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  34% {\n    transform: translate($amount/2, -$amount);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate($amount/2, -$amount);\n  }\n  84% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes ball-zag-deflect {\n  17% {\n    transform: translate($amount/2, $amount);\n  }\n  34% {\n    transform: translate(-$amount/2, $amount);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(-$amount/2, $amount);\n  }\n  84% {\n    transform: translate($amount/2, $amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.ball-zig-zag-deflect {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    margin-left: $amount / 2;\n    top: 4px;\n    left: -7px;\n\n    &:first-child {\n      animation: ball-zig-deflect 1.5s 0s infinite linear;\n    }\n\n    &:last-child {\n      animation: ball-zag-deflect 1.5s 0s infinite linear;\n    }\n  }\n}\n\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes line-scale {\n  0% {\n    transform: scaley(1.0);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1.0);\n  }\n}\n\n@mixin line-scale($n:5) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation: line-scale 1s delay(0.1s, $n, $i) infinite cubic-bezier(.2,.68,.18,1.08);\n    }\n  }\n}\n\n.line-scale {\n  @include line-scale();\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes line-scale-party {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    $random: 0.5;\n    transform: scale($random);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@mixin line-scale-party($n:4) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.3) + s;\n    }\n  }\n}\n\n.line-scale-party {\n  @include line-scale-party();\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    animation-name: line-scale-party;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes line-scale-pulse-out {\n  0% {\n    transform: scaley(1.0);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1.0);\n  }\n}\n\n.line-scale-pulse-out {\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    animation: line-scale-pulse-out 0.9s delay(0.2s, 3, 0) infinite cubic-bezier(.85,.25,.37,.85);\n\n    &:nth-child(2), &:nth-child(4) {\n      animation-delay: delay(0.2s, 3, 1) !important;\n    }\n\n    &:nth-child(1), &:nth-child(5) {\n      animation-delay: delay(0.2s, 3, 2) !important;\n    }\n\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes line-scale-pulse-out-rapid {\n  0% {\n    transform: scaley(1.0);\n  }\n  80% {\n    transform: scaley(0.3);\n  }\n  90% {\n    transform: scaley(1.0);\n  }\n}\n\n.line-scale-pulse-out-rapid {\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    vertical-align: middle;\n    animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(.11,.49,.38,.78);\n\n    &:nth-child(2), &:nth-child(4) {\n      animation-delay: -0.25s !important;\n    }\n\n    &:nth-child(1), &:nth-child(5) {\n      animation-delay: 0s !important;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$radius: 20px;\n\n@keyframes line-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin line-spin-fade-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n        transform: rotate(-45deg);\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n        transform: rotate(90deg);\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n        transform: rotate(45deg);\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n        transform: rotate(-45deg);\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n        transform: rotate(90deg);\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n        transform: rotate(45deg);\n      }\n\n      animation: line-spin-fade-loader 1.2s delay(0.12s, $n, $i) infinite ease-in-out;\n    }\n  }\n}\n\n.line-spin-fade-loader {\n  @include line-spin-fade-loader();\n  position: relative;\n  top: -10px;\n  left: -4px;\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    position: absolute;\n    width: 5px;\n    height: 15px;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$size: 20px;\n\n@keyframes triangle-skew-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n\n.triangle-skew-spin {\n\n  > div {\n    @include global-animation();\n\n    width: 0;\n    height: 0;\n    border-left: $size solid transparent;\n    border-right: $size solid transparent;\n    border-bottom: $size solid $primary-color;\n    animation: triangle-skew-spin 3s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes square-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n\n.square-spin {\n\n  > div {\n    @include global-animation();\n\n    width: 50px;\n    height: 50px;\n    background: $primary-color;\n    animation: square-spin 3s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 25px;\n\n@keyframes rotate_pacman_half_up  {\n    0% {\n         transform:rotate(270deg);\n    }\n    50% {\n         transform:rotate(360deg);\n    }\n    100% {\n         transform:rotate(270deg);\n    }\n}\n\n@keyframes rotate_pacman_half_down  {\n    0% {\n         transform:rotate(90deg);\n    }\n    50% {\n         transform:rotate(0deg);\n    }\n    100% {\n         transform:rotate(90deg);\n    }\n}\n\n@mixin pacman_design(){\n    width: 0px;\n    height: 0px;\n    border-right: $size solid transparent;\n    border-top: $size solid $primary-color;\n    border-left: $size solid $primary-color;\n    border-bottom: $size solid $primary-color;\n    border-radius: $size;\n}\n\n@keyframes pacman-balls {\n  75% {\n    opacity: 0.7;\n  }\n  100% {\n    transform: translate(-4 * $size, -$size / 4);\n  }\n}\n\n@mixin ball-placement($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i + 2}) {\n      animation: pacman-balls 1s delay(.33s, $n, $i) infinite linear;\n    }\n  }\n}\n\n.pacman {\n  @include ball-placement();\n\n  position: relative;\n\n  > div:first-of-type {\n    @include pacman_design();\n    animation: rotate_pacman_half_up 0.5s 0s infinite;\n    position: relative;\n    left: -30px;\n  }\n\n  > div:nth-child(2) {\n    @include pacman_design();\n    animation: rotate_pacman_half_down 0.5s 0s infinite;\n    margin-top: -2 * $size;\n    position: relative;\n    left: -30px;\n  }\n\n  > div:nth-child(3),\n  > div:nth-child(4),\n  > div:nth-child(5),\n  > div:nth-child(6) {\n    @include balls();\n\n    width: 10px;\n    height: 10px;\n\n    position: absolute;\n    transform: translate(0, -$size / 4);\n    top: 25px;\n    left: 70px;\n  }\n}","@import '../variables';\n@import '../mixins';\n\n$amount: 50px;\n$size: 10px;\n\n@keyframes cube-transition {\n  25% {\n    transform: translateX($amount) scale(0.5) rotate(-90deg);\n  }\n  50% {\n    transform: translate($amount, $amount) rotate(-180deg);\n  }\n  75% {\n    transform: translateY($amount) scale(0.5) rotate(-270deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n\n.cube-transition {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include global-animation();\n\n    width: $size;\n    height: $size;\n    position: absolute;\n    top: -5px;\n    left: -5px;\n    background-color: $primary-color;\n    animation: cube-transition 1.6s 0s infinite ease-in-out;\n\n    &:last-child {\n      animation-delay: -0.8s\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$size: 35px;\n$pos: 30%;\n\n@keyframes spin-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n }\n}\n\n.semi-circle-spin {\n  position: relative;\n  width: $size;\n  height: $size;\n  overflow: hidden;\n\n  > div {\n    position: absolute;\n    border-width: 0px;\n    border-radius: 100%;\n    animation: spin-rotate 0.6s 0s infinite linear;\n    background-image: linear-gradient(transparent 0%, transparent (100% - $pos), $primary-color $pos, $primary-color 100%);\n    width: 100%;\n    height: 100%;\n  }\n}","// Progress Bar\n\n.progress {\n\n  .progress-bar {\n    &:last-child {\n      @include border-right-radius($progress-border-radius);\n    }\n  }\n\n  &.progress-bar-sm {\n    height: .5rem;\n  }\n\n  &.progress-bar-xs {\n    height: .3rem;\n  }\n\n  &.progress-bar-rounded {\n    @include border-radius(30px);\n  }\n\n}\n\n.progress-bar-animated-alt {\n  &.progress-bar,\n  .progress-bar {\n    position: relative;\n\n    &::after {\n      content: '';\n      opacity: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: $white;\n      animation: progress-active 2s ease infinite;\n    }\n  }\n}\n\n@keyframes progress-active {\n  0% {\n    opacity: .4;\n    width: 0\n  }\n  100% {\n    opacity: 0;\n    width: 100%\n  }\n}",".vertical-timeline {\n  width: 100%;\n  position: relative;\n  padding: ($spacer * 1.5) 0 ($spacer);\n\n  &::after {\n    content: '';\n    display: table;\n    clear: both\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 67px;\n    height: 100%;\n    width: 4px;\n    background: $gray-200;\n    @include border-radius($border-radius);\n  }\n}\n\n.vertical-timeline-element {\n  position: relative;\n  margin: 0 0 ($spacer);\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both\n  }\n\n  &:last-child {\n    margin-bottom: 0\n  }\n}\n\n.vertical-timeline-element-content {\n  position: relative;\n  margin-left: 90px;\n  font-size: $font-size-xs;\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both\n  }\n\n  .timeline-title {\n    font-size: $font-size-xs;\n    text-transform: uppercase;\n    margin: 0 0 ($spacer / 2);\n    padding: 2px 0 0;\n    font-weight: bold;\n  }\n\n  p {\n    color: $gray-600;\n    margin: 0 0 ($spacer / 2);\n  }\n\n  .vertical-timeline-element-date {\n    display: block;\n    position: absolute;\n    left: -90px;\n    top: 0;\n    padding-right: 10px;\n    text-align: right;\n    color: $gray-500;\n    font-size: $font-size-xs / 1.05;\n    white-space: nowrap;\n  }\n}\n\n.vertical-timeline-element-icon {\n  position: absolute;\n  top: 0;\n  left: 60px;\n\n  .badge-dot-xl {\n    box-shadow: 0 0 0 5px $white;\n  }\n}\n\n.vertical-timeline-element--no-children .vertical-timeline-element-content {\n  background: 0 0;\n  box-shadow: none;\n\n  &::before {\n    display: none;\n  }\n}\n\n.vertical-without-time {\n  &::before {\n    left: 11px;\n  }\n\n  .vertical-timeline-element-content {\n    margin-left: 36px;\n  }\n\n  .vertical-timeline-element-icon {\n    left: 4px;\n  }\n}\n\n.vertical-time-icons {\n  padding: ($spacer * 2) 0 0;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 14px;\n    height: 100%;\n    width: 6px;\n    background: $gray-200;\n    @include border-radius($border-radius);\n  }\n\n  .vertical-timeline-element {\n    margin-bottom: $spacer;\n  }\n\n  .vertical-timeline-element-content {\n    margin-left: 50px;\n  }\n\n  .vertical-timeline-element-icon {\n    width: 34px;\n    height: 34px;\n    left: 0;\n    top: -7px;\n\n    .timeline-icon {\n      width: 34px;\n      height: 34px;\n      background: $white;\n      @include border-radius(50px);\n      border-width: 2px;\n      border-style: solid;\n      box-shadow: 0 0 0 5px $white;\n      text-align: center;\n      display: flex;\n      align-items: center;\n      align-content: center;\n\n      i {\n        display: block;\n        font-size: 1.1rem;\n        margin: 0 auto;\n      }\n\n      svg {\n        margin: 0 auto;\n      }\n    }\n  }\n}\n\n// Simple Dots Timeline\n\n.vertical-time-simple {\n  padding: ($spacer / 2) 0;\n\n  .vertical-timeline-element {\n    margin: 0 0 ($spacer / 2);\n  }\n\n  .timeline-title {\n    font-weight: normal;\n    font-size: $font-size-lg / 1.2;\n    padding: 0;\n  }\n\n  .vertical-timeline-element-icon {\n    height: 14px;\n    width: 14px;\n    background: $gray-200;\n    position: absolute;\n    left: 6px;\n    top: 2px;\n    display: block;\n    @include border-radius(20px);\n\n    &::after {\n      content: '';\n      position: absolute;\n      background: $white;\n      left: 50%;\n      top: 50%;\n      margin: -4px 0 0 -4px;\n      display: block;\n      width: 8px;\n      height: 8px;\n      @include border-radius(20px);\n    }\n  }\n\n  .timeline-title {\n    text-transform: none;\n  }\n}\n\n@mixin timeline-variant($parent, $color) {\n  #{$parent} {\n    .vertical-timeline-element-icon {\n      background: $color;\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  @include timeline-variant(\".dot-#{$color}\", $value);\n}\n\n\n// Animations\n\n.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {\n  visibility: hidden\n}\n\n.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {\n  visibility: visible;\n  animation: cd-bounce-1 .8s\n}\n\n@-webkit-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(.5)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2)\n  }\n\n  100% {\n    -webkit-transform: scale(1)\n  }\n\n}\n\n@-moz-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -moz-transform: scale(.5)\n  }\n\n  60% {\n    opacity: 1;\n    -moz-transform: scale(1.2)\n  }\n\n  100% {\n    -moz-transform: scale(1)\n  }\n\n}\n\n@keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(.5);\n    -moz-transform: scale(.5);\n    -ms-transform: scale(.5);\n    -o-transform: scale(.5);\n    transform: scale(.5)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2);\n    -moz-transform: scale(1.2);\n    -ms-transform: scale(1.2);\n    -o-transform: scale(1.2);\n    transform: scale(1.2)\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1)\n  }\n\n}\n\n.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {\n  visibility: hidden\n}\n\n.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n  visibility: visible;\n  -webkit-animation: cd-bounce-2 .6s;\n  -moz-animation: cd-bounce-2 .6s;\n  animation: cd-bounce-2 .6s\n}\n\n@media only screen and (min-width: 1170px) {\n  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {\n    -webkit-animation: cd-bounce-2-inverse .6s;\n    -moz-animation: cd-bounce-2-inverse .6s;\n    animation: cd-bounce-2-inverse .6s\n  }\n\n}\n\n@media only screen and (max-width: 1169px) {\n  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n    visibility: visible;\n    -webkit-animation: cd-bounce-2-inverse .6s;\n    -moz-animation: cd-bounce-2-inverse .6s;\n    animation: cd-bounce-2-inverse .6s\n  }\n\n}\n\n@-webkit-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px)\n  }\n\n  100% {\n    -webkit-transform: translateX(0)\n  }\n\n}\n\n@-moz-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(-100px)\n  }\n\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(20px)\n  }\n\n  100% {\n    -moz-transform: translateX(0)\n  }\n\n}\n\n@keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n    -moz-transform: translateX(-100px);\n    -ms-transform: translateX(-100px);\n    -o-transform: translateX(-100px);\n    transform: translateX(-100px)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n    -moz-transform: translateX(20px);\n    -ms-transform: translateX(20px);\n    -o-transform: translateX(20px);\n    transform: translateX(20px)\n  }\n\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0)\n  }\n\n}\n\n@-webkit-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px)\n  }\n\n  100% {\n    -webkit-transform: translateX(0)\n  }\n\n}\n\n@-moz-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(100px)\n  }\n\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(-20px)\n  }\n\n  100% {\n    -moz-transform: translateX(0)\n  }\n\n}\n\n@keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n    -moz-transform: translateX(100px);\n    -ms-transform: translateX(100px);\n    -o-transform: translateX(100px);\n    transform: translateX(100px)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n    -moz-transform: translateX(-20px);\n    -ms-transform: translateX(-20px);\n    -o-transform: translateX(-20px);\n    transform: translateX(-20px)\n  }\n\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0)\n  }\n\n}","// List Group\n\n.todo-list-wrapper {\n  .todo-indicator {\n    position: absolute;\n    width: 4px;\n    height: 60%;\n    @include border-radius($border-radius-lg);\n    left: ($card-spacer-x / 2);\n    top: 20%;\n    opacity: .6;\n    transition: opacity .2s;\n  }\n\n  .list-group-item {\n    &:hover {\n      .todo-indicator {\n        opacity: .9;\n      }\n    }\n  }\n\n  .custom-control,\n  input[checkbox] {\n    margin-left: ($card-spacer-x / 2);\n  }\n}\n\n.list-group-flush + .card-footer {\n  border-top: 0;\n}\n\n.rm-list-borders {\n  .list-group-item {\n    border: 0;\n    padding: ($card-spacer-y / 1.5) 0;\n  }\n}\n\n.rm-list-borders-scroll {\n  .list-group-item {\n    border: 0;\n    padding-right: ($card-spacer-y * 1.5);\n  }\n}","// Input groups\n\n.input-group {\n  .input-group-prepend {\n    div:not([class]) .react-datepicker__input-container,\n    & + div .react-datepicker__input-container {\n      .form-control {\n        @include border-left-radius(0);\n        @include border-right-radius($input-border-radius !important);\n      }\n    }\n  }\n\n  & > div:not([class]) {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n\n    & .react-datepicker__input-container {\n      .form-control {\n        @include border-right-radius(0);\n      }\n\n    }\n  }\n}\n\n.input-group {\n  .input-group-prepend {\n    & + div {\n      position: relative;\n      flex: 1 1 auto;\n      width: 1%;\n    }\n  }\n\n  & > .react-datepicker-wrapper {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n\n    & > .react-datepicker__input-container > .form-control {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n// Forms Legend\n\nlegend {\n  font-size: $font-size-base;\n  font-weight: bold;\n}\n\n// Headings\n\n.form-heading {\n  font-size: $font-size-lg;\n  margin: 0;\n  color: $primary;\n\n  p {\n    color: $gray-600;\n    padding: 0.3rem 0 0;\n    font-size: $font-size-base;\n  }\n}\n\n.custom-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}","// Pagination\n\n.pagination {\n  .page-number {\n    @extend .page-item;\n  }\n\n  li {\n    a {\n      position: relative;\n      display: block;\n      padding: $pagination-padding-y $pagination-padding-x;\n      margin-left: -$pagination-border-width;\n      line-height: $pagination-line-height;\n      color: $pagination-color;\n      background-color: $pagination-bg;\n      border: $pagination-border-width solid $pagination-border-color;\n\n      &:hover {\n        z-index: 2;\n        color: $pagination-hover-color;\n        text-decoration: none;\n        background-color: $pagination-hover-bg;\n        border-color: $pagination-hover-border-color;\n      }\n\n      &:focus {\n        z-index: 2;\n        outline: $pagination-focus-outline;\n        box-shadow: $pagination-focus-box-shadow;\n      }\n\n      // Opinionated: add \"hand\" cursor to non-disabled .page-link elements\n      &:not(:disabled):not(.disabled) {\n        cursor: pointer;\n      }\n    }\n\n    &:first-child {\n      a {\n        margin-left: 0;\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      a {\n        @include border-right-radius($border-radius);\n      }\n    }\n\n    &.active a {\n      z-index: 1;\n      color: $pagination-active-color;\n      background-color: $pagination-active-bg;\n      border-color: $pagination-active-border-color;\n\n      &:hover {\n        color: $pagination-active-color;\n      }\n    }\n\n    &.disabled a {\n      color: $pagination-disabled-color;\n      pointer-events: none;\n      // Opinionated: remove the \"hand\" cursor set previously for .page-link\n      cursor: auto;\n      background-color: $pagination-disabled-bg;\n      border-color: $pagination-disabled-border-color;\n    }\n  }\n}\n\n// Pagination Rounded\n\n.pagination-rounded {\n  li a {\n    @include border-radius(50px !important);\n    margin: 0 ($layout-spacer-x / 5);\n  }\n}","// Chat\n\n.chat-box-wrapper {\n  display: flex;\n  clear: both;\n  padding: ($layout-spacer-x / 2);\n\n  & + .chat-box-wrapper {\n    padding-top: 0;\n  }\n\n  .chat-box {\n    box-shadow: 0 0 0 transparent;\n    position: relative;\n    opacity: 1;\n    background: $dropdown-link-hover-bg;\n    border: 0;\n    padding: ($layout-spacer-x / 2) $layout-spacer-x;\n    @include border-radius(30px);\n    border-top-left-radius: $border-radius;\n    flex: 1;\n    display: flex;\n    max-width: 50%;\n    min-width: 100%;\n    text-align: left;\n\n    & + small {\n      text-align: left;\n      padding: ($layout-spacer-x / 3) 0 0;\n      margin-left: $layout-spacer-x;\n      display: block;\n    }\n  }\n\n  &.chat-box-wrapper-right {\n    text-align: right;\n\n    .chat-box {\n      @include border-radius(30px);\n      border-top-left-radius: 30px;\n      border-top-right-radius: $border-radius;\n      margin-left: auto;\n\n      & + small {\n        text-align: right;\n        margin-right: $layout-spacer-x;\n        margin-left: 0;\n      }\n    }\n\n  }\n}\n","// Wizard Multi Step\n\n.forms-wizard {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  width: 100%;\n  display: table;\n  table-layout: fixed;\n  @include border-radius($border-radius);\n\n  li {\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n    cursor: pointer;\n    font-size: $font-size-lg / 1.1;\n    padding: ($layout-spacer-x / 1.5) 0;\n    color: $gray-500;\n    position: relative;\n\n    &::after,\n    &::before {\n      position: absolute;\n      height: 4px;\n      top: 50%;\n      margin-top: -($layout-spacer-x / 1.5);\n      width: 50%;\n      content: '';\n      background: $gray-300;\n      z-index: 5;\n      transition: all .2s;\n    }\n\n    &::after {\n      left: 50%;\n    }\n\n    &::before {\n      left: 0;\n    }\n\n    &:first-child {\n      &::before {\n        @include border-left-radius(20px);\n      }\n    }\n\n    &:last-child {\n      &::after {\n        @include border-right-radius(20px);\n      }\n    }\n\n    em {\n      font-style: normal;\n      font-size: $h4-font-size;\n      background: $gray-400;\n      color: $white;\n      text-align: center;\n      padding: 0;\n      width: 40px;\n      height: 40px;\n      line-height: 40px;\n      @include border-radius(50px);\n      display: block;\n      margin: 0 auto 0.5rem;\n      position: relative;\n      z-index: 7;\n      transition: all .2s;\n    }\n\n    &.form-wizard-step-doing {\n      color: $gray-700;\n      em {\n        background: $primary;\n      }\n\n      &::before {\n        background: $primary;\n      }\n    }\n\n    &.form-wizard-step-done {\n      em {\n        font-family: 'Linearicons-Free';\n        @extend .lnr-checkmark-circle;\n        background: $success;\n        overflow: hidden;\n        &::before {\n          width: 42px;\n          height: 42px;\n          font-size: 1.2rem;\n          line-height: 40px;\n          text-align: center;\n          display: block;\n        }\n      }\n\n      &::after,\n      &::before {\n        background: $success;\n      }\n    }\n\n    &:hover {\n      color: $gray-600;\n    }\n  }\n}\n\n\n// CreateNew Wizard Alternate\n\n.forms-wizard-alt {\n  .forms-wizard {\n    li {\n      font-size: $font-size-base;\n\n      em {\n        width: 14px;\n        height: 14px;\n        line-height: 14px;\n        text-indent: -999rem;\n        border: $white solid 2px;\n        margin: -7px auto 0;\n\n      }\n    }\n  }\n}\n\n.forms-wizard-vertical {\n  .forms-wizard {\n    display: block;\n    width: 30%;\n    float: left;\n    padding: 0 $layout-spacer-x $layout-spacer-x 0;\n\n    li {\n      text-align: left;\n      display: flex;\n      align-items: center;\n      align-content: flex-start;\n      padding: ($layout-spacer-x / 2);\n      margin-bottom: ($layout-spacer-x / 3);\n      @include border-radius($border-radius-lg);\n      transition: all .2s;\n\n      &::before,\n      &::after {\n        display: none;\n      }\n\n      em {\n        margin: 0 ($layout-spacer-x / 2) 0 0;\n      }\n\n      &:hover {\n        background: $gray-200;\n      }\n\n      &.form-wizard-step-doing {\n        background: $primary;\n        color: $white;\n\n        em {\n          background: rgba(255,255,255,.2);\n        }\n      }\n    }\n  }\n\n  .form-wizard-content {\n    width: 70%;\n    overflow: auto;\n  }\n}\n@media screen and (min-width: 360px) and (max-width: 812px) {\n  .forms-wizard-vertical {\n    .forms-wizard {\n      display: block;\n      width: 50%;\n      float: left;\n      padding: 0 $layout-spacer-x $layout-spacer-x 0;\n  \n      li {\n        text-align: left;\n        display: flex;\n        align-items: center;\n        align-content: flex-start;\n        padding: ($layout-spacer-x / 2);\n        margin-bottom: ($layout-spacer-x / 3);\n        @include border-radius($border-radius-lg);\n        transition: all .2s;\n  \n        &::before,\n        &::after {\n          display: none;\n        }\n  \n        em {\n          margin: 0 ($layout-spacer-x / 2) 0 0;\n        }\n  \n        &:hover {\n          background: $gray-200;\n        }\n  \n        &.form-wizard-step-doing {\n          background: $primary;\n          color: $white;\n  \n          em {\n            background: rgba(255,255,255,.2);\n          }\n        }\n      }\n    }\n  \n    .form-wizard-content {\n      width: 50%;\n      overflow: auto;\n    }\n  }\n}","// Chart boxes\n\n// Variables\n\n$widget-spacer: $spacer;\n\n%center-elem {\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n\n.widget-chart {\n  text-align: center;\n  padding: $widget-spacer;\n  position: relative;\n\n  .progress-sub-label {\n    opacity: .8;\n    padding: 5px 0 0;\n  }\n\n  .progress-circle-wrapper {\n    min-width: 68px;\n    margin-right: $widget-spacer;\n\n    .react-sweet-progress-symbol {\n      font-size: $font-size-xs;\n    }\n  }\n\n  .widget-chart-content {\n    position: relative;\n    z-index: 5;\n  }\n\n  .widget-chart-content-lg {\n    padding: ($widget-spacer * 2) 0 $widget-spacer  ($widget-spacer * 2);\n\n    .widget-numbers {\n      margin-bottom: 0;\n    }\n  }\n\n  .widget-chart-wrapper {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    opacity: .25;\n    z-index: 6;\n    @include border-bottom-radius($card-border-radius);\n    overflow: hidden;\n  }\n\n  .widget-numbers {\n    font-weight: bold;\n    font-size: 2.5rem;\n    display: block;\n    line-height: 1;\n    margin: $widget-spacer auto;\n\n    & + .widget-chart-flex,\n    & + .widget-description,\n    & + .widget-subheading {\n      margin-top: -($widget-spacer / 2);\n    }\n  }\n\n  .widget-subheading {\n    margin: -0.5rem 0 0;\n    display: block;\n    opacity: .6;\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    & + .widget-numbers {\n      margin-top: ($widget-spacer / 2);\n    }\n  }\n\n  .widget-description {\n    margin: $widget-spacer 0 0;\n  }\n\n  &.widget-chart-hover {\n    transition: all .2s;\n\n    &:hover {\n      z-index: 15;\n      transform: scale(1.15);\n      box-shadow: 0 0.46875rem 4.1875rem rgba(darken($primary, 50%), .05),\n      0 0.9375rem 2.40625rem rgba(darken($primary, 50%), .05),\n      0 0.25rem 1.3125rem rgba(darken($primary, 50%), .06),\n      0 0.125rem 1.1875rem rgba(darken($primary, 50%), .06);\n      cursor: pointer;\n      background: $white;\n    }\n  }\n\n  .widget-chart-actions {\n    position: absolute;\n    right: $widget-spacer / 2;\n    top: $widget-spacer / 2;\n    z-index: 12;\n\n    .btn-link {\n      font-size: 1.1rem;\n      padding-top: 0;\n      padding-bottom: 0;\n      opacity: .6;\n    }\n  }\n\n  .widget-progress-wrapper {\n    margin-top: $widget-spacer;\n\n    &.progress-wrapper-bottom {\n      position: absolute;\n      left: 0;\n      bottom: 0;\n      width: 100%;\n\n      .progress {\n        margin: 0 -1px -1px;\n      }\n\n      .progress {\n        @include border-top-radius(0);\n        @include border-bottom-radius($card-border-radius);\n\n        .progress-bar {\n          border-bottom-left-radius: $card-border-radius;\n        }\n      }\n\n    }\n  }\n\n  .widget-chart-flex {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    margin-bottom: $widget-spacer;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .widget-subheading {\n      margin: 0;\n    }\n\n    .widget-description {\n      margin-top: 0;\n    }\n  }\n\n  &.text-left {\n    flex-direction: row;\n    align-items: center;\n\n    .icon-wrapper {\n      min-width: 54px;\n      margin: 0 ($widget-spacer) 0 0;\n    }\n\n    .widget-numbers {\n      margin-left: 0;\n    }\n\n    .widget-chart-content {\n      display: flex;\n      flex-direction: column;\n      align-content: center;\n      flex: 1;\n      position: relative;\n\n      & > .widget-numbers:first-child {\n        margin-top: 0;\n      }\n\n      .widget-description {\n        align-self: flex-start;\n      }\n    }\n\n    .widget-chart-wrapper {\n      height: 35%;\n    }\n  }\n\n  &.widget-chart-left {\n    padding-bottom: 15%;\n  }\n\n  .chart-wrapper-relative {\n    position: relative;\n    opacity: 1;\n    margin-top: ($widget-spacer);\n  }\n}\n\n.widget-chart-actions {\n  position: absolute;\n  right: $widget-spacer;\n  top: $widget-spacer;\n  z-index: 12;\n\n  .btn-link {\n    font-size: 1.1rem;\n    padding-top: 0;\n    padding-bottom: 0;\n    opacity: .6;\n  }\n}\n\n.widget-chart,\n.widget-content {\n  &:hover {\n    .widget-chart-actions {\n      .btn-link {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.grid-menu {\n  .widget-chart {\n    &.widget-chart-hover {\n      &:hover {\n        background: $card-bg;\n        @include border-radius($border-radius);\n      }\n    }\n  }\n\n}\n\n.icon-wrapper {\n  width: 54px;\n  height: 54px;\n  margin: 0 auto;\n  @extend %center-elem;\n  position: relative;\n  overflow: hidden;\n\n  &[class*=\"border-\"] {\n    border-width: 1px;\n    border-style: solid;\n  }\n\n  .icon-wrapper-bg {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    z-index: 3;\n    opacity: .2;\n\n    &.bg-light {\n      opacity: .08;\n    }\n\n  }\n\n  i {\n    margin: 0 auto;\n    font-size: 1.7rem;\n    position: relative;\n    z-index: 5;\n\n    &:before {\n      margin-top: -3px;\n    }\n  }\n\n  .progress-circle-wrapper {\n    width: 100%;\n    margin-right: 0;\n  }\n}\n\n.widget-chart2 {\n  .widget-chart-flex {\n    display: flex;\n    align-items: baseline;\n    align-content: center;\n    margin-bottom: 0;\n\n    .widget-subtitle,\n    .widget-title {\n    }\n\n    .widget-subtitle {\n      margin-left: auto;\n    }\n\n    .widget-numbers {\n      font-weight: normal;\n    }\n\n    & + .widget-chart-flex {\n      .widget-numbers {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .widget-chat-wrapper-outer {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    max-width: 100%;\n\n    .widget-chart-wrapper {\n      height: 70px;\n      opacity: .8;\n      position: relative;\n      margin: $widget-spacer auto (-($widget-spacer / 2));\n    }\n\n    .widget-chart-wrapper-lg {\n      height: 130px;\n    }\n  }\n}\n\n// Widgets with bottom border\n\n.card-btm-border {\n  border-bottom: transparent solid 4px;\n}\n\n// Progress Box\n\n.progress-box {\n  text-align: center;\n\n  h4 {\n    font-size: $font-size-base;\n    font-weight: bold;\n    opacity: .6;\n    text-transform: uppercase;\n    padding-bottom: ($widget-spacer / 3)\n  }\n\n  svg {\n    margin: 0 auto;\n  }\n}\n\n.svg-bg {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: .1;\n\n  svg {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n}\n\n.widget-numbers-sm {\n  font-size: 1.5rem;\n}","// Content Boxes\n\n// Variables\n\n$widget-spacer: $spacer;\n\n.widget-content {\n  padding: $widget-spacer;\n  flex-direction: row;\n  align-items: center;\n\n  .widget-content-wrapper {\n    display: flex;\n    flex: 1;\n    position: relative;\n    align-items: center;\n  }\n\n  .widget-content-left {\n\n    .widget-heading {\n      opacity: .8;\n      font-weight: bold;\n    }\n\n    .widget-subheading {\n      opacity: .5;\n    }\n  }\n\n  .widget-content-right {\n    margin-left: auto;\n  }\n\n  .widget-numbers {\n    font-weight: bold;\n    font-size: 1.8rem;\n    display: block;\n  }\n\n  .widget-content-outer {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n  }\n\n  .widget-progress-wrapper {\n    margin-top: $widget-spacer;\n\n    .progress-sub-label {\n      margin-top: ($widget-spacer / 3);\n      opacity: .5;\n      display: flex;\n      align-content: center;\n      align-items: center;\n\n      .sub-label-left {\n\n      }\n\n      .sub-label-right {\n        margin-left: auto;\n      }\n    }\n  }\n\n  .widget-content-right {\n    &.widget-content-actions {\n      visibility: hidden;\n      opacity: 0;\n      transition: opacity .2s;\n    }\n  }\n\n  &:hover {\n    .widget-content-right {\n      &.widget-content-actions {\n        visibility: visible;\n        opacity: 1;\n      }\n    }\n  }\n}\n","// Profile Boxes\n\n.profile-block {\n  position: relative;\n  overflow: hidden;\n\n  .profile-blur {\n    width: 100%;\n    height: 100%;\n    filter: blur(5px);\n    transform: scale(1.8);\n    position: absolute;\n    left: -25%;\n    top: -25%;\n  }\n\n  .profile-inner {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: .5;\n    left: 0;\n    top: 0;\n  }\n\n  .dropdown-menu-header {\n\n    .menu-header-content {\n      padding: $layout-spacer-lg;\n\n      .menu-header-title {\n        margin: ($layout-spacer-x / 2) 0 0;\n      }\n\n      .menu-header-subtitle {\n        margin: ($layout-spacer-x / 3) 0 0;\n      }\n    }\n\n    .menu-header-btn-pane {\n      margin: ($layout-spacer-x / 3) 0 0;\n\n      .btn-icon {\n        color: $white;\n        padding: 0;\n        width: 44px;\n        height: 44px;\n        line-height: 37px;\n        font-size: $font-size-lg;\n\n        &:hover {\n          background: rgba(255, 255, 255, .2);\n        }\n      }\n    }\n  }\n\n}","// User Pages\n\n.app-logo {\n  height: $logo-height;\n  width: $logo-width;\n  background: url('~assets/utils/images/logo-inverse.png');\n}\n\n.app-logo-inverse {\n  height: $logo-height;\n  width: $logo-width;\n  background: url('~assets/utils/images/logo.png');\n}\n\n.app-login-box {\n  .app-logo {\n    margin-bottom: $layout-spacer-lg;\n  }\n\n  h4 {\n    margin-bottom: $layout-spacer-x;\n    font-weight: normal;\n\n    div {\n      opacity: .6;\n    }\n\n    span {\n      font-size: $font-size-lg;\n    }\n  }\n}","// Applications\n\n$app-layout-sidebar-width         : 270px;\n$app-layout-aside-width           : 60px;\n$app-layout-header-height         : 50px;\n\n\n\n.app-inner-layout {\n\n  &.rm-sidebar {\n    .app-inner-layout__wrapper {\n      .app-inner-layout__content {\n        width: auto;\n        float: none;\n      }\n    }\n  }\n\n  .app-inner-layout__header {\n    width: 100%;\n    padding: $layout-spacer-x;\n    text-align: left;\n\n    .app-page-title {\n      margin: 0;\n      padding: 0;\n      background: transparent;\n    }\n\n    border-bottom: $gray-200 solid 1px;\n  }\n\n  .app-inner-layout__header-boxed {\n    padding: $layout-spacer-x;\n\n    .app-inner-layout__header {\n      @include border-radius($border-radius-lg);\n    }\n  }\n\n  .app-inner-layout__wrapper {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    min-height: 100vh;\n\n    .app-inner-layout__content {\n      flex: 1;\n      display: flex;\n\n      &.card {\n        box-shadow: 0 0 0 0 transparent;\n        border-radius: 0;\n        border: 0;\n      }\n\n      .app-inner-layout__top-pane {\n        display: flex;\n        align-content: center;\n        align-items: center;\n        text-align: left;\n        padding: ($layout-spacer-x / 2) $layout-spacer-x;\n      }\n\n      .pane-left {\n        display: flex;\n        align-items: center;\n      }\n\n      .pane-right {\n        display: flex;\n        align-items: center;\n        margin-left: auto;\n      }\n\n      .app-inner-layout__bottom-pane {\n        padding: $layout-spacer-x;\n        border-top: $gray-200 solid 1px;\n      }\n    }\n\n    .app-inner-layout__sidebar {\n      width: $app-layout-sidebar-width;\n      list-style: none;\n      text-align: left;\n      order: -1;\n      flex: 0 0 $app-layout-sidebar-width;\n      display: flex;\n      margin: 0;\n      position: relative;\n\n      .dropdown-item {\n        white-space: normal;\n      }\n\n      &.card {\n        box-shadow: 0 0 0 0 transparent;\n        border-radius: 0;\n        background: $gray-100;\n        border: 0;\n        border-right: $gray-200 solid 1px;\n        border-left: $gray-200 solid 1px;\n      }\n\n      .app-inner-layout__sidebar-footer,\n      .app-inner-layout__sidebar-header {\n        background: $gray-100;\n      }\n    }\n\n    .app-inner-layout__aside {\n      width: $app-layout-aside-width;\n    }\n  }\n\n  .app-inner-layout__footer {\n    width: 100%;\n    height: $app-layout-header-height;\n  }\n}\n\n.app-wrapper-footer {\n  .app-footer {\n    border-top: $gray-200 solid 1px;\n\n    .app-footer__inner {\n      border-left: $gray-200 solid 1px;\n    }\n  }\n}\n\n// Components\n\n@import \"chat\";\n\n// Responsive\n\n.mobile-app-menu-btn {\n  display: none;\n  margin: 3px $layout-spacer-x 0 0;\n}\n\n.table_header{\n  text-align: center;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 5px;\n  margin-top: 10px;\n  font-weight: bold\n}\n\n@import \"responsive\";","// Chat\n$app-layout-chat-sidebar-width: 360px;\n\n.chat-layout {\n  &.app-inner-layout {\n    .app-inner-layout__sidebar {\n      width: $app-layout-chat-sidebar-width;\n      flex: 0 0 $app-layout-chat-sidebar-width;\n    }\n  }\n\n  .app-inner-layout__top-pane h4 {\n    font-size: $h5-font-size;\n\n    div {\n      font-size: $font-size-base;\n    }\n  }\n\n  .chat-box-wrapper {\n    padding: $layout-spacer-x;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  .chat-layout {\n    &.app-inner-layout {\n      .app-inner-layout__sidebar {\n        .widget-content .widget-content-left .widget-subheading {\n          white-space: normal;\n        }\n      }\n    }\n  }\n}","// Responsive Applications\n\n@include media-breakpoint-down(md) {\n  .app-inner-layout__sidebar {\n    display: none !important;\n  }\n\n  .mobile-app-menu-btn {\n    display: block;\n  }\n\n  .open-mobile-menu {\n\n    .app-inner-layout__sidebar {\n      display: block !important;\n    }\n  }\n}","/*\n * Container style\n */\n.ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none !important;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  z-index: 7;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  @include border-radius(50px);\n  z-index: 7;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus {\n  background-color: rgba(0, 0, 0, .1);\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: rgba(0, 0, 0, .1);\n  border-radius: 6px;\n  transition: background-color .2s linear, height .2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: rgba(0, 0, 0, .1);\n  border-radius: 6px;\n  transition: background-color .2s linear, width .2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x {\n  background-color: rgba(0, 0, 0, .12);\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y {\n  background-color: rgba(0, 0, 0, .12);\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n.scrollbar-container {\n  position: relative;\n  height: 100%;\n}\n\n// Scroll Areas\n\n.scroll-area {\n  overflow-x: hidden;\n  height: 400px;\n}\n\n.scroll-area-xs {\n  height: 150px;\n  overflow-x: hidden;\n}\n\n.scroll-area-sm {\n  height: 200px;\n  overflow-x: hidden;\n}\n\n.scroll-area-md {\n  height: 300px;\n  overflow-x: hidden;\n}\n\n.scroll-area-lg {\n  height: 400px;\n  overflow-x: hidden;\n}\n\n.scroll-area-x {\n  overflow-x: auto;\n  width: 100%;\n  max-width: 100%;\n}\n\n.shadow-overflow {\n  position: relative;\n\n  &::after,\n  &::before {\n    width: 100%;\n    bottom: auto;\n    top: 0;\n    left: 0;\n    height: $layout-spacer-x;\n    position: absolute;\n    z-index: 10;\n    content: '';\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\n  }\n\n  &::after {\n    bottom: 0;\n    top: auto;\n\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 80%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\n  }\n\n}","\n.rc-tabs {\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n\n.rc-tabs-bar,\n.rc-tabs-nav-container {\n  font-size: 14px;\n  line-height: 1.5;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n  outline: none;\n  zoom: 1;\n  transition: padding .45s;\n}\n\n.rc-tabs-ink-bar {\n  margin-top: 0;\n  @include border-radius($border-radius);\n  box-shadow:\n          0 16px 26px -10px rgba($primary, 0.56),\n          0 4px 25px 0px rgba(0, 0, 0, 0.12),\n          0 8px 10px -5px rgba($primary, 0.2);\n}\n\n.rc-tabs-ink-bar-animated {\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n}\n\n.rc-tabs-tab-prev,\n.rc-tabs-tab-next {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  z-index: 1;\n  line-height: 36px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  position: absolute;\n}\n\n.rc-tabs-tab-prev-icon,\n.rc-tabs-tab-next-icon {\n  position: relative;\n  display: inline-block;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  line-height: inherit;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  font-smoothing: antialiased;\n  text-stroke-width: 0;\n  font-family: sans-serif;\n}\n\n.rc-tabs-tab-prev-icon:before,\n.rc-tabs-tab-next-icon:before {\n  display: block;\n}\n\n.rc-tabs-tab-btn-disabled {\n  cursor: default;\n  color: $gray-700;\n}\n\n.rc-tabs-nav-wrap {\n  overflow: hidden;\n}\n\n.rc-tabs-nav {\n  box-sizing: border-box;\n  padding-left: 0;\n  position: relative;\n  margin: 0;\n  float: left;\n  list-style: none;\n  display: inline-block;\n  transform-origin: 0 0;\n\n  & > div:first-child {\n    z-index: 5;\n    position: relative;\n  }\n}\n\n.rc-tabs-nav-animated {\n  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n}\n\n.rc-tabs-nav:before,\n.rc-tabs-nav:after {\n  display: table;\n  content: \" \";\n}\n\n.rc-tabs-nav:after {\n  clear: both;\n}\n\n.rc-tabs-tab {\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  padding: 8px 20px;\n  cursor: pointer;\n}\n\n.rc-tabs-tab:hover {\n  color: $primary;\n}\n\n.rc-tabs-tab-active,\n.rc-tabs-tab-active:hover {\n  color: $white;\n  cursor: default;\n  transform: translateZ(0);\n}\n\n.rc-tabs-tab-disabled {\n  cursor: default;\n  color: $gray-700;\n}\n\n.rc-tabs-tab-disabled:hover {\n  color: $gray-700;\n}\n\n.rc-tabs-content {\n  zoom: 1;\n}\n\n.rc-tabs-content .rc-tabs-tabpane {\n  overflow: hidden;\n}\n\n.rc-tabs-content-animated {\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  display: -ms-flexbox;\n  display: flex;\n  will-change: transform;\n}\n\n.rc-tabs-content-animated .rc-tabs-tabpane {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n\n.no-flexbox .rc-tabs-content {\n  transform: none !important;\n  overflow: hidden;\n}\n\n.no-csstransitions .rc-tabs-tabpane-inactive,\n.no-flexbox .rc-tabs-tabpane-inactive,\n.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {\n  display: none;\n}\n\n.rc-tabs-bottom .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n.rc-tabs-top .rc-tabs-content {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-container-scrolling {\n  padding-left: 35px;\n  padding-right: 35px;\n}\n\n.rc-tabs-top .rc-tabs-nav-scroll {\n  width: 99999px;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe {\n  position: relative;\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  margin-right: 0;\n  padding: 8px 0;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.rc-tabs-top .rc-tabs-nav-wrap {\n  width: 100%;\n  padding: $layout-spacer-x ($grid-gutter-width / 2);\n}\n\n.rc-tabs-top .rc-tabs-content-animated {\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-tab-next {\n  right: 2px;\n}\n\n.rc-tabs-top .rc-tabs-tab-next-icon:before {\n  content: \">\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev {\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-tab-prev-icon:before {\n  content: \"<\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev,\n.rc-tabs-top .rc-tabs-tab-next {\n  margin-right: -2px;\n  width: 0;\n  height: 0;\n  top: 0;\n  text-align: center;\n  opacity: 0;\n  transition: width .3s, height .3s, opacity .3s;\n}\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 35px;\n  height: 100%;\n}\n\n.rc-tabs-top .rc-tabs-ink-bar {\n  height: 35px;\n  bottom: 0;\n  left: 0;\n  background: $primary;\n}\n\n.rc-tabs-top .rc-tabs-tab {\n  float: left;\n  height: 100%;\n  line-height: 1.3;\n  margin-right: $layout-spacer-x / 2;\n}\n\n.rc-tabs-top .rc-tabs-tabpane-inactive {\n  height: 0;\n  overflow: visible;\n}\n","/*!\n * Ladda\n * http://lab.hakim.se/ladda\n * MIT licensed\n *\n * Copyright (C) 2018 Hakim El Hattab, http://hakim.se\n */\n\n\n/*************************************\n * CONFIG\n */\n\n$spinnerSize: 32px !default;\n\n\n/*************************************\n * MIXINS\n */\n\n@mixin transition( $value ) {\n  transition: $value !important;\n}\n\n@mixin transform( $value ) {\n  transform: $value;\n}\n\n/*************************************\n * Opacity animation for spin.js\n */\n\n@keyframes ladda-spinner-line-fade {\n  0%, 100% {\n    opacity: 0.22; /* minimum opacity */\n  }\n  1% {\n    opacity: 1;\n  }\n}\n\n\n/*************************************\n * BUTTON BASE\n */\n\n.ladda-button {\n  position: relative;\n}\n\n\n/* Spinner animation */\n.ladda-button .ladda-spinner {\n  position: absolute;\n  z-index: 2;\n  display: inline-block;\n  width: $spinnerSize;\n  top: 50%;\n  margin-top: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Button label */\n.ladda-button .ladda-label {\n  position: relative;\n  z-index: 3;\n}\n\n[class*=\"btn-outline-\"] {\n  .ladda-spinner div div div {\n    background: $black !important;\n  }\n\n  &.ladda-button .ladda-label {\n    transition: none !important;\n  }\n}\n\n/* Progress bar */\n.ladda-button .ladda-progress {\n  position: absolute;\n  width: 0;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background: rgba( 0, 0, 0, 0.2 );\n  display: none;\n\n  @include transition( 0.1s linear all );\n}\n.ladda-button[data-loading] .ladda-progress {\n  display: block;\n}\n\n\n/*************************************\n * EASING\n */\n\n.ladda-button,\n.ladda-button .ladda-spinner,\n.ladda-button .ladda-label {\n  @include transition( 0.3s cubic-bezier(0.175, 0.885, 0.320, 1.275) all );\n}\n\n.ladda-button[data-style=zoom-in],\n.ladda-button[data-style=zoom-in] .ladda-spinner,\n.ladda-button[data-style=zoom-in] .ladda-label,\n.ladda-button[data-style=zoom-out],\n.ladda-button[data-style=zoom-out] .ladda-spinner,\n.ladda-button[data-style=zoom-out] .ladda-label {\n  @include transition( 0.3s ease all );\n}\n\n\n/*************************************\n * EXPAND RIGHT\n */\n\n.ladda-button[data-style=expand-right] {\n  .ladda-spinner {\n    right: $spinnerSize/-2 + 10;\n  }\n\n  &[data-size=\"s\"] .ladda-spinner,\n  &[data-size=\"xs\"] .ladda-spinner {\n    right: $spinnerSize/-2 + 4;\n  }\n\n  &[data-loading] {\n    padding-right: 56px;\n\n    .ladda-spinner {\n      opacity: 1;\n    }\n\n    &[data-size=\"s\"],\n    &[data-size=\"xs\"] {\n      padding-right: 40px;\n    }\n  }\n}\n\n\n/*************************************\n * EXPAND LEFT\n */\n\n.ladda-button[data-style=expand-left] {\n  .ladda-spinner {\n    left: $spinnerSize/2 + 10;\n  }\n\n  &[data-size=\"s\"] .ladda-spinner,\n  &[data-size=\"xs\"] .ladda-spinner {\n    left: 4px;\n  }\n\n  &[data-loading] {\n    padding-left: 56px;\n\n    .ladda-spinner {\n      opacity: 1;\n    }\n\n    &[data-size=\"s\"],\n    &[data-size=\"xs\"] {\n      padding-left: 40px;\n    }\n  }\n}\n\n\n/*************************************\n * EXPAND UP\n */\n\n.ladda-button[data-style=expand-up] {\n  overflow: hidden;\n\n  .ladda-spinner {\n    top: -$spinnerSize;\n    left: 50%;\n    margin-left: 0;\n  }\n\n  &[data-loading] {\n    padding-top: 54px;\n\n    .ladda-spinner {\n      opacity: 1;\n      top: ($spinnerSize/ 2) + 10;\n      margin-top: 0;\n    }\n\n    &[data-size=\"s\"],\n    &[data-size=\"xs\"] {\n      padding-top: 32px;\n\n      .ladda-spinner {\n        top: 4px;\n      }\n    }\n  }\n}\n\n\n/*************************************\n * EXPAND DOWN\n */\n\n.ladda-button[data-style=expand-down] {\n  overflow: hidden;\n\n  .ladda-spinner {\n    top: 52px;\n    left: 50%;\n    margin-left: 0;\n  }\n\n  &[data-size=\"s\"] .ladda-spinner,\n  &[data-size=\"xs\"] .ladda-spinner {\n    top: 40px;\n  }\n\n  &[data-loading] {\n    padding-bottom: 54px;\n\n    .ladda-spinner {\n      opacity: 1;\n    }\n\n    &[data-size=\"s\"],\n    &[data-size=\"xs\"] {\n      padding-bottom: 32px;\n    }\n  }\n}\n\n\n/*************************************\n * SLIDE LEFT\n */\n.ladda-button[data-style=slide-left] {\n  overflow: hidden;\n\n  .ladda-label {\n    position: relative;\n  }\n  .ladda-spinner {\n    left: 100%;\n    margin-left: 0;\n  }\n\n  &[data-loading] {\n    .ladda-label {\n      opacity: 0;\n      left: -100%;\n    }\n    .ladda-spinner {\n      opacity: 1;\n      left: 50%;\n    }\n  }\n}\n\n\n/*************************************\n * SLIDE RIGHT\n */\n.ladda-button[data-style=slide-right] {\n  overflow: hidden;\n\n  .ladda-label {\n    position: relative;\n  }\n  .ladda-spinner {\n    right: 100%;\n    margin-left: 0;\n    left: $spinnerSize/2;\n\n    [dir=\"rtl\"] & {\n      right: auto;\n    }\n  }\n\n  &[data-loading] {\n    .ladda-label {\n      opacity: 0;\n      left: 100%;\n    }\n    .ladda-spinner {\n      opacity: 1;\n      left: 50%;\n    }\n  }\n}\n\n\n/*************************************\n * SLIDE UP\n */\n.ladda-button[data-style=slide-up] {\n  overflow: hidden;\n\n  .ladda-label {\n    position: relative;\n  }\n  .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: 1em;\n  }\n\n  &[data-loading] {\n    .ladda-label {\n      opacity: 0;\n      top: -1em;\n    }\n    .ladda-spinner {\n      opacity: 1;\n      margin-top: 0;\n    }\n  }\n}\n\n\n/*************************************\n * SLIDE DOWN\n */\n.ladda-button[data-style=slide-down] {\n  overflow: hidden;\n\n  .ladda-label {\n    position: relative;\n  }\n  .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: -2em;\n  }\n\n  &[data-loading] {\n    .ladda-label {\n      opacity: 0;\n      top: 1em;\n    }\n    .ladda-spinner {\n      opacity: 1;\n      margin-top: 0;\n    }\n  }\n}\n\n\n/*************************************\n * ZOOM-OUT\n */\n\n.ladda-button[data-style=zoom-out] {\n  overflow: hidden;\n}\n.ladda-button[data-style=zoom-out] .ladda-spinner {\n  left: 50%;\n  margin-left: $spinnerSize;\n\n  @include transform( scale( 2.5 ) );\n}\n.ladda-button[data-style=zoom-out] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-out][data-loading] .ladda-label {\n  opacity: 0;\n\n  @include transform( scale( 0.5 ) );\n}\n.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n\n  @include transform( none );\n}\n\n\n/*************************************\n * ZOOM-IN\n */\n\n.ladda-button[data-style=zoom-in] {\n  overflow: hidden;\n}\n.ladda-button[data-style=zoom-in] .ladda-spinner {\n  left: 50%;\n  margin-left: $spinnerSize/-2;\n\n  @include transform( scale( 0.2 ) );\n}\n.ladda-button[data-style=zoom-in] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-in][data-loading] .ladda-label {\n  opacity: 0;\n\n  @include transform( scale( 2.2 ) );\n}\n.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n\n  @include transform( none );\n}\n\n\n/*************************************\n * CONTRACT\n */\n\n.ladda-button[data-style=contract] {\n  overflow: hidden;\n  width: 100px;\n}\n.ladda-button[data-style=contract] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n}\n.ladda-button[data-style=contract][data-loading] .ladda-label {\n  opacity: 0;\n}\n.ladda-button[data-style=contract][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n\n\n/*************************************\n * OVERLAY\n */\n\n.ladda-button[data-style=contract-overlay] {\n  overflow: hidden;\n  width: 100px;\n\n  box-shadow: 0px 0px 0px 2000px rgba(0,0,0,0);\n}\n.ladda-button[data-style=contract-overlay] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n\n  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/\n  box-shadow: 0px 0px 0px 2000px rgba(0,0,0,0.8);\n}\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {\n  opacity: 0;\n}\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n\n[dir=\"rtl\"] .ladda-spinner > div {\n  left: 25% !important;\n}","@charset \"UTF-8\";\n/*!\n * Hamburgers\n * @description Tasty CSS-animated hamburgers\n * @author Jonathan Suh @jonsuh\n * @site https://jonsuh.com/hamburgers\n * @link https://github.com/jonsuh/hamburgers\n */\n\n// Settings\n// ==================================================\n$hamburger-padding-x           : 0px !default;\n$hamburger-padding-y           : 0px !default;\n$hamburger-layer-width         : 24px !default;\n$hamburger-layer-height        : 2px !default;\n$hamburger-layer-spacing       : 4px !default;\n$hamburger-layer-color         : $primary !default;\n$hamburger-layer-border-radius : 10px !default;\n$hamburger-hover-opacity       : 0.7 !default;\n$hamburger-active-layer-color  : $hamburger-layer-color !default;\n$hamburger-active-hover-opacity: $hamburger-hover-opacity !default;\n\n// To use CSS filters as the hover effect instead of opacity,\n// set $hamburger-hover-use-filter as true and\n// change the value of $hamburger-hover-filter accordingly.\n$hamburger-hover-use-filter   : false !default;\n$hamburger-hover-filter       : opacity(50%) !default;\n$hamburger-active-hover-filter: $hamburger-hover-filter !default;\n\n// Types (Remove or comment out what you don’t need)\n// ==================================================\n$hamburger-types: (\n  //3dx,\n  //3dx-r,\n  //3dy,\n  //3dy-r,\n  //3dxy,\n  //3dxy-r,\n  //arrow,\n  //arrow-r,\n  //arrowalt,\n  //arrowalt-r,\n  //arrowturn,\n  //arrowturn-r,\n  //boring,\n  //collapse,\n  //collapse-r,\n  elastic,\n  //elastic-r,\n  //emphatic,\n  //emphatic-r,\n  //minus,\n  //slider,\n  //slider-r,\n  //spin,\n  //spin-r,\n  //spring,\n  //spring-r,\n  //stand,\n  //stand-r,\n  //squeeze,\n  //vortex,\n  //vortex-r\n) !default;\n\n// Base Hamburger (We need this)\n// ==================================================\n@import \"base\";\n\n// Hamburger types\n// ==================================================\n@import \"types/3dx\";\n@import \"types/3dx-r\";\n@import \"types/3dy\";\n@import \"types/3dy-r\";\n@import \"types/3dxy\";\n@import \"types/3dxy-r\";\n@import \"types/arrow\";\n@import \"types/arrow-r\";\n@import \"types/arrowalt\";\n@import \"types/arrowalt-r\";\n@import \"types/arrowturn\";\n@import \"types/arrowturn-r\";\n@import \"types/boring\";\n@import \"types/collapse\";\n@import \"types/collapse-r\";\n@import \"types/elastic\";\n@import \"types/elastic-r\";\n@import \"types/emphatic\";\n@import \"types/emphatic-r\";\n@import \"types/minus\";\n@import \"types/slider\";\n@import \"types/slider-r\";\n@import \"types/spin\";\n@import \"types/spin-r\";\n@import \"types/spring\";\n@import \"types/spring-r\";\n@import \"types/stand\";\n@import \"types/stand-r\";\n@import \"types/squeeze\";\n@import \"types/vortex\";\n@import \"types/vortex-r\";\n\n// ==================================================\n// Cooking up additional types:\n//\n// The Sass for each hamburger type should be nested\n// inside an @if directive to check whether or not\n// it exists in $hamburger-types so only the CSS for\n// included types are generated.\n//\n// e.g. hamburgers/types/_new-type.scss\n//\n// @if index($hamburger-types, new-type) {\n//   .hamburger--new-type {\n//     ...\n//   }\n// }\n","// Hamburger\n// ==================================================\n.hamburger {\n  padding: $hamburger-padding-y $hamburger-padding-x;\n  display: inline-block;\n  cursor: pointer;\n\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n\n  // Normalize (<button>)\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n\n  &:hover {\n    @if $hamburger-hover-use-filter == true {\n      filter: $hamburger-hover-filter;\n    }\n    @else {\n      opacity: $hamburger-hover-opacity;\n    }\n  }\n\n  &.is-active {\n    &:hover {\n      @if $hamburger-hover-use-filter == true {\n        filter: $hamburger-active-hover-filter;\n      }\n      @else {\n        opacity: $hamburger-active-hover-opacity;\n      }\n    }\n\n    .hamburger-inner,\n    .hamburger-inner::before,\n    .hamburger-inner::after {\n      background-color: $hamburger-active-layer-color;\n    }\n  }\n}\n\n.hamburger-box {\n  width: $hamburger-layer-width;\n  height: $hamburger-layer-height * 3 + $hamburger-layer-spacing * 2;\n  display: inline-block;\n  position: relative;\n}\n\n.hamburger-inner {\n  display: block;\n  top: 50%;\n  margin-top: $hamburger-layer-height / -2;\n\n  &,\n  &::before,\n  &::after {\n    width: $hamburger-layer-width;\n    height: $hamburger-layer-height;\n    background-color: $hamburger-layer-color;\n    border-radius: $hamburger-layer-border-radius;\n    position: absolute;\n    transition-property: transform;\n    transition-duration: 0.15s;\n    transition-timing-function: ease;\n  }\n\n  &::before,\n  &::after {\n    content: \"\";\n    display: block;\n  }\n\n  &::before {\n    top: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\n  }\n\n  &::after {\n    bottom: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\n  }\n}\n","@if index($hamburger-types, elastic) {\n  /*\n   * Elastic\n   */\n  .hamburger--elastic {\n    .hamburger-inner {\n      top: $hamburger-layer-height / 2;\n      transition-duration: 0.275s;\n      transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n\n      &::before {\n        top: $hamburger-layer-height + $hamburger-layer-spacing;\n        transition: opacity 0.125s 0.275s ease;\n      }\n\n      &::after {\n        top: ($hamburger-layer-height * 2) + ($hamburger-layer-spacing * 2);\n        transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n      }\n    }\n\n    &.is-active {\n      .hamburger-inner {\n        $y-offset: $hamburger-layer-spacing + $hamburger-layer-height;\n\n        transform: translate3d(0, $y-offset, 0) rotate(135deg);\n        transition-delay: 0.075s;\n\n        &::before {\n          transition-delay: 0s;\n          opacity: 0;\n        }\n\n        &::after {\n          transform: translate3d(0, $y-offset * -2, 0) rotate(-270deg);\n          transition-delay: 0.075s;\n        }\n      }\n    }\n  }\n}\n","// Drawers\n\n.drawer-content-wrapper {\n  background: $white;\n  position: relative;\n  padding: $layout-spacer-x;\n\n  .drawer-heading {\n    font-size: $font-size-sm;\n    color: $body-color;\n    margin: 0;\n    background: $gray-100;\n    padding: ($layout-spacer-x / 2) $layout-spacer-x;\n    border-bottom: $gray-300 solid 1px;\n    border-top: $gray-300 solid 1px;\n\n    &:first-child {\n      border-top: 0;\n    }\n  }\n\n  .drawer-section {\n    padding: $layout-spacer-x;\n  }\n\n  & > .app-sidebar__heading:first-child {\n    margin-top: 0;\n  }\n}\n\n.drawer-nav-btn {\n  @include border-radius(30px);\n  background: $white;\n  position: fixed;\n  right: $layout-spacer-x / 2;\n  top: $layout-spacer-x / 2;\n  padding: ($layout-spacer-x / 3);\n  box-shadow: $box-shadow-sm;\n  z-index: 20;\n\n  .hamburger {\n    margin-top: 4px;\n  }\n}","body.stop-scrolling {\n  height: 100%;\n  overflow: hidden;\n}\n\n.sweet-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  background-color: $modal-backdrop-bg;\n  opacity: $modal-backdrop-opacity !important;\n}\n\n.sweet-alert {\n  background-color: $white;\n  width: 30%;\n  padding: $spacer;\n  @include border-radius($border-radius);\n  text-align: center;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin-left: -15%;\n  margin-top: -15%;\n  overflow: hidden;\n  display: none;\n  z-index: 99999;\n  box-shadow: $box-shadow-lg-default;\n\n  h2 {\n    color: $gray-700;\n    text-align: center;\n    text-transform: none;\n    position: relative;\n    margin: ($spacer-sm / 2) 0;\n    padding: 0;\n    display: block;\n  }\n\n  p {\n    color: $gray-500;\n    text-align: center;\n    position: relative;\n    float: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  fieldset {\n    border: none;\n    position: relative;\n  }\n\n  .sa-error-container {\n    background-color: $gray-100;\n    margin-left: -17px;\n    margin-right: -17px;\n    overflow: hidden;\n    padding: 0 10px;\n    max-height: 0;\n    transition: padding 0.15s, max-height 0.15s;\n\n    &.show {\n      padding: 10px 0;\n      max-height: 100px;\n      transition: padding 0.25s, max-height 0.25s;\n    }\n\n    .icon {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      border-radius: 50%;\n      background-color: $danger;\n      color: $white;\n      line-height: 24px;\n      text-align: center;\n      margin-right: 3px;\n    }\n\n    p {\n      display: inline-block;\n    }\n  }\n\n  .sa-input-error {\n    position: absolute;\n    top: 29px;\n    right: 26px;\n    width: 20px;\n    height: 20px;\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n    -webkit-transform-origin: 50% 50%;\n    transform-origin: 50% 50%;\n    -webkit-transition: all 0.1s;\n    transition: all 0.1s;\n\n    &::before, &::after {\n      content: \"\";\n      width: 20px;\n      height: 6px;\n      background-color: $danger;\n      border-radius: 3px;\n      position: absolute;\n      top: 50%;\n      margin-top: -4px;\n      left: 50%;\n      margin-left: -9px;\n    }\n\n    &::before {\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n    }\n\n    &::after {\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n    }\n\n    &.show {\n      opacity: 1;\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  input {\n    width: 100%;\n    box-sizing: border-box;\n    border-radius: 3px;\n    border: 1px solid #d7d7d7;\n    height: 43px;\n    margin-top: 10px;\n    margin-bottom: 17px;\n    font-size: 18px;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n    padding: 0 12px;\n    display: none;\n    -webkit-transition: all 0.3s;\n    transition: all 0.3s;\n  }\n\n  input:focus {\n    outline: none;\n    box-shadow: 0 0 3px #c4e6f5;\n    border: 1px solid #b4dbed;\n  }\n\n  .sweet-alert.show-input input {\n    display: block;\n  }\n\n  .sa-confirm-button-container {\n    display: inline-block;\n    position: relative;\n  }\n\n  .la-ball-fall {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin-left: -27px;\n    margin-top: 4px;\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  button {\n    display: inline-block;\n    font-weight: $btn-font-weight;\n    text-align: center;\n    white-space: nowrap;\n    font-size: $font-size-base;\n    vertical-align: middle;\n    user-select: none;\n    border: $btn-border-width solid transparent;\n    @include button-size($btn-padding-y, $btn-padding-x, $font-size-base, $btn-line-height, $btn-border-radius);\n    @include transition($btn-transition);\n    @include button-variant($primary, $primary);\n\n    // Share hover and focus styles\n    @include hover-focus {\n      text-decoration: none;\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: $btn-focus-box-shadow;\n    }\n\n    // Disabled comes first so active can properly restyle\n    &.disabled,\n    &:disabled {\n      opacity: $btn-disabled-opacity;\n      @include box-shadow(none);\n    }\n  }\n\n  button.cancel {\n    font-weight: $font-weight-normal;\n    color: $link-color;\n    background-color: transparent;\n    border-color: transparent;\n    margin-right: 0.5rem;\n\n    @include hover {\n      color: $link-hover-color;\n      text-decoration: $link-hover-decoration;\n      background-color: transparent;\n      border-color: transparent;\n    }\n\n    &:active,\n    &.active,\n    &:focus,\n    &.focus {\n      text-decoration: none;\n      border-color: transparent;\n      box-shadow: none;\n      background-color: transparent;\n    }\n\n    &:disabled,\n    &.disabled {\n      color: $btn-link-disabled-color;\n      pointer-events: none;\n    }\n  }\n\n  button.confirm[disabled] ~ .la-ball-fall {\n    opacity: 1;\n    visibility: visible;\n    transition-delay: 0s;\n  }\n\n  &[data-has-cancel-button=false] button {\n    box-shadow: none !important;\n  }\n\n  &[data-has-confirm-button=false][data-has-cancel-button=false] {\n    padding-bottom: 40px;\n  }\n\n  .sa-button-container {\n    padding: $spacer 0 0;\n  }\n\n}\n\n.sa-icon {\n  width: 80px;\n  height: 80px;\n  border: 4px solid $gray-300;\n  -webkit-border-radius: 40px;\n  border-radius: 50%;\n  margin: 20px auto;\n  padding: 0;\n  position: relative;\n  box-sizing: content-box;\n\n  &.sa-error {\n    border-color: $danger;\n\n    .sa-x-mark {\n      position: relative;\n      display: block;\n    }\n\n    .sa-line {\n      position: absolute;\n      height: 5px;\n      width: 47px;\n      background-color: $danger;\n      display: block;\n      top: 37px;\n      border-radius: 2px;\n\n      &.sa-left {\n        -webkit-transform: rotate(45deg);\n        transform: rotate(45deg);\n        left: 17px;\n      }\n\n      &.sa-right {\n        -webkit-transform: rotate(-45deg);\n        transform: rotate(-45deg);\n        right: 16px;\n      }\n    }\n  }\n\n  &.sa-warning {\n    border-color: $warning;\n\n    .sa-body {\n      position: absolute;\n      width: 5px;\n      height: 47px;\n      left: 50%;\n      top: 10px;\n      -webkit-border-radius: 2px;\n      border-radius: 2px;\n      margin-left: -2px;\n      background-color: $warning;\n    }\n\n    .sa-dot {\n      position: absolute;\n      width: 7px;\n      height: 7px;\n      -webkit-border-radius: 50%;\n      border-radius: 50%;\n      margin-left: -3px;\n      left: 50%;\n      bottom: 10px;\n      background-color: $warning;\n    }\n  }\n\n  &.sa-info {\n    border-color: $info;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      width: 5px;\n      height: 29px;\n      left: 50%;\n      bottom: 17px;\n      border-radius: 2px;\n      margin-left: -2px;\n      background-color: $info;\n    }\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      width: 7px;\n      height: 7px;\n      border-radius: 50%;\n      margin-left: -3px;\n      top: 19px;\n      background-color: $info;\n    }\n  }\n\n  &.sa-success {\n    border-color: $success;\n\n    &::before,\n    &::after {\n      content: '';\n      -webkit-border-radius: 40px;\n      border-radius: 50%;\n      position: absolute;\n      width: 60px;\n      height: 120px;\n      background: $white;\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n    }\n\n    &::before {\n      -webkit-border-radius: 120px 0 0 120px;\n      border-radius: 120px 0 0 120px;\n      top: -7px;\n      left: -33px;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n      -webkit-transform-origin: 60px 60px;\n      transform-origin: 60px 60px;\n    }\n\n    &::after {\n      -webkit-border-radius: 0 120px 120px 0;\n      border-radius: 0 120px 120px 0;\n      top: -11px;\n      left: 30px;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n      -webkit-transform-origin: 0 60px;\n      transform-origin: 0 60px;\n    }\n\n    .sa-placeholder {\n      width: 80px;\n      height: 80px;\n      border: 4px solid rgba(165, 220, 134, 0.2);\n      -webkit-border-radius: 40px;\n      border-radius: 40px;\n      border-radius: 50%;\n      box-sizing: content-box;\n      position: absolute;\n      left: -4px;\n      top: -4px;\n      z-index: 2;\n    }\n\n    .sa-fix {\n      width: 5px;\n      height: 90px;\n      background-color: $white;\n      position: absolute;\n      left: 28px;\n      top: 8px;\n      z-index: 1;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n    }\n\n    .sa-line {\n      height: 5px;\n      background-color: $success;\n      display: block;\n      border-radius: 2px;\n      position: absolute;\n      z-index: 2;\n\n      &.sa-tip {\n        width: 25px;\n        left: 14px;\n        top: 46px;\n        -webkit-transform: rotate(45deg);\n        transform: rotate(45deg);\n      }\n\n      &.sa-long {\n        width: 47px;\n        right: 8px;\n        top: 38px;\n        -webkit-transform: rotate(-45deg);\n        transform: rotate(-45deg);\n      }\n    }\n  }\n\n  &.sa-custom {\n    background-size: contain;\n    border-radius: 0;\n    border: none;\n    background-position: center center;\n    background-repeat: no-repeat;\n  }\n}\n\n@media all and (max-width: 540px) {\n  .sweet-alert {\n    width: auto;\n    margin-left: 0;\n    margin-right: 0;\n    left: 15px;\n    right: 15px;\n  }\n}\n\n/*\n * Animations\n */\n@-webkit-keyframes showSweetAlert {\n  0% {\n    transform: scale(0.7);\n    -webkit-transform: scale(0.7);\n  }\n  45% {\n    transform: scale(1.05);\n    -webkit-transform: scale(1.05);\n  }\n  80% {\n    transform: scale(0.95);\n    -webkit-transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n}\n\n@keyframes showSweetAlert {\n  0% {\n    transform: scale(0.7);\n    -webkit-transform: scale(0.7);\n  }\n  45% {\n    transform: scale(1.05);\n    -webkit-transform: scale(1.05);\n  }\n  80% {\n    transform: scale(0.95);\n    -webkit-transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n}\n\n@-webkit-keyframes hideSweetAlert {\n  0% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n  100% {\n    transform: scale(0.5);\n    -webkit-transform: scale(0.5);\n  }\n}\n\n@keyframes hideSweetAlert {\n  0% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n  100% {\n    transform: scale(0.5);\n    -webkit-transform: scale(0.5);\n  }\n}\n\n@-webkit-keyframes slideFromTop {\n  0% {\n    top: 0%;\n  }\n  100% {\n    top: 50%;\n  }\n}\n\n@keyframes slideFromTop {\n  0% {\n    top: 0%;\n  }\n  100% {\n    top: 50%;\n  }\n}\n\n@-webkit-keyframes slideToTop {\n  0% {\n    top: 50%;\n  }\n  100% {\n    top: 0%;\n  }\n}\n\n@keyframes slideToTop {\n  0% {\n    top: 50%;\n  }\n  100% {\n    top: 0%;\n  }\n}\n\n@-webkit-keyframes slideFromBottom {\n  0% {\n    top: 70%;\n  }\n  100% {\n    top: 50%;\n  }\n}\n\n@keyframes slideFromBottom {\n  0% {\n    top: 70%;\n  }\n  100% {\n    top: 50%;\n  }\n}\n\n@-webkit-keyframes slideToBottom {\n  0% {\n    top: 50%;\n  }\n  100% {\n    top: 70%;\n  }\n}\n\n@keyframes slideToBottom {\n  0% {\n    top: 50%;\n  }\n  100% {\n    top: 70%;\n  }\n}\n\n.showSweetAlert[data-animation=pop] {\n  -webkit-animation: showSweetAlert 0.3s;\n  animation: showSweetAlert 0.3s;\n}\n\n.showSweetAlert[data-animation=none] {\n  -webkit-animation: none;\n  animation: none;\n}\n\n.showSweetAlert[data-animation=slide-from-top] {\n  -webkit-animation: slideFromTop 0.3s;\n  animation: slideFromTop 0.3s;\n}\n\n.showSweetAlert[data-animation=slide-from-bottom] {\n  -webkit-animation: slideFromBottom 0.3s;\n  animation: slideFromBottom 0.3s;\n}\n\n.hideSweetAlert[data-animation=pop] {\n  -webkit-animation: hideSweetAlert 0.2s;\n  animation: hideSweetAlert 0.2s;\n}\n\n.hideSweetAlert[data-animation=none] {\n  -webkit-animation: none;\n  animation: none;\n}\n\n.hideSweetAlert[data-animation=slide-from-top] {\n  -webkit-animation: slideToTop 0.4s;\n  animation: slideToTop 0.4s;\n}\n\n.hideSweetAlert[data-animation=slide-from-bottom] {\n  -webkit-animation: slideToBottom 0.3s;\n  animation: slideToBottom 0.3s;\n}\n\n@-webkit-keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n\n@keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n\n@-webkit-keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n\n@keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n\n@-webkit-keyframes rotatePlaceholder {\n  0% {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n  5% {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n  12% {\n    transform: rotate(-405deg);\n    -webkit-transform: rotate(-405deg);\n  }\n  100% {\n    transform: rotate(-405deg);\n    -webkit-transform: rotate(-405deg);\n  }\n}\n\n@keyframes rotatePlaceholder {\n  0% {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n  5% {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n  12% {\n    transform: rotate(-405deg);\n    -webkit-transform: rotate(-405deg);\n  }\n  100% {\n    transform: rotate(-405deg);\n    -webkit-transform: rotate(-405deg);\n  }\n}\n\n.animateSuccessTip {\n  -webkit-animation: animateSuccessTip 0.75s;\n  animation: animateSuccessTip 0.75s;\n}\n\n.animateSuccessLong {\n  -webkit-animation: animateSuccessLong 0.75s;\n  animation: animateSuccessLong 0.75s;\n}\n\n.sa-icon.sa-success.animate::after {\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\n  animation: rotatePlaceholder 4.25s ease-in;\n}\n\n@-webkit-keyframes animateErrorIcon {\n  0% {\n    transform: rotateX(100deg);\n    -webkit-transform: rotateX(100deg);\n    opacity: 0;\n  }\n  100% {\n    transform: rotateX(0deg);\n    -webkit-transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n@keyframes animateErrorIcon {\n  0% {\n    transform: rotateX(100deg);\n    -webkit-transform: rotateX(100deg);\n    opacity: 0;\n  }\n  100% {\n    transform: rotateX(0deg);\n    -webkit-transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n.animateErrorIcon {\n  -webkit-animation: animateErrorIcon 0.5s;\n  animation: animateErrorIcon 0.5s;\n}\n\n@-webkit-keyframes animateXMark {\n  0% {\n    transform: scale(0.4);\n    -webkit-transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  50% {\n    transform: scale(0.4);\n    -webkit-transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  80% {\n    transform: scale(1.15);\n    -webkit-transform: scale(1.15);\n    margin-top: -6px;\n  }\n  100% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animateXMark {\n  0% {\n    transform: scale(0.4);\n    -webkit-transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  50% {\n    transform: scale(0.4);\n    -webkit-transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0;\n  }\n  80% {\n    transform: scale(1.15);\n    -webkit-transform: scale(1.15);\n    margin-top: -6px;\n  }\n  100% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n\n.animateXMark {\n  -webkit-animation: animateXMark 0.5s;\n  animation: animateXMark 0.5s;\n}\n\n@-webkit-keyframes pulseWarning {\n  0% {\n    border-color: #F8D486;\n  }\n  100% {\n    border-color: $warning;\n  }\n}\n\n@keyframes pulseWarning {\n  0% {\n    border-color: #F8D486;\n  }\n  100% {\n    border-color: $warning;\n  }\n}\n\n.pulseWarning {\n  -webkit-animation: pulseWarning 0.75s infinite alternate;\n  animation: pulseWarning 0.75s infinite alternate;\n}\n\n@-webkit-keyframes pulseWarningIns {\n  0% {\n    background-color: #F8D486;\n  }\n  100% {\n    background-color: $warning;\n  }\n}\n\n@keyframes pulseWarningIns {\n  0% {\n    background-color: #F8D486;\n  }\n  100% {\n    background-color: $warning;\n  }\n}\n\n.pulseWarningIns {\n  -webkit-animation: pulseWarningIns 0.75s infinite alternate;\n  animation: pulseWarningIns 0.75s infinite alternate;\n}\n\n@-webkit-keyframes rotate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Internet Explorer 9 has some special quirks that are fixed here */\n/* The icons are not animated. */\n/* This file is automatically merged into sweet-alert.min.js through Gulp */\n/* Error icon */\n.sweet-alert .sa-icon.sa-error .sa-line.sa-left {\n  -ms-transform: rotate(45deg) \\9\n;\n}\n\n.sweet-alert .sa-icon.sa-error .sa-line.sa-right {\n  -ms-transform: rotate(-45deg) \\9\n;\n}\n\n/* Success icon */\n.sweet-alert .sa-icon.sa-success {\n  border-color: transparent \\9\n;\n}\n\n.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {\n  -ms-transform: rotate(45deg) \\9\n;\n}\n\n.sweet-alert .sa-icon.sa-success .sa-line.sa-long {\n  -ms-transform: rotate(-45deg) \\9\n;\n}\n\n/*!\n * Load Awesome v1.1.0 (http://github.danielcardoso.net/load-awesome/)\n * Copyright 2015 Daniel Cardoso <@DanielCardoso>\n * Licensed under MIT\n */\n.la-ball-fall,\n.la-ball-fall > div {\n  position: relative;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.la-ball-fall {\n  display: block;\n  font-size: 0;\n  color: #fff;\n}\n\n.la-ball-fall.la-dark {\n  color: #333;\n}\n\n.la-ball-fall > div {\n  display: inline-block;\n  float: none;\n  background-color: currentColor;\n  border: 0 solid currentColor;\n}\n\n.la-ball-fall {\n  width: 54px;\n  height: 18px;\n}\n\n.la-ball-fall > div {\n  width: 10px;\n  height: 10px;\n  margin: 4px;\n  border-radius: 100%;\n  opacity: 0;\n  -webkit-animation: ball-fall 1s ease-in-out infinite;\n  -moz-animation: ball-fall 1s ease-in-out infinite;\n  -o-animation: ball-fall 1s ease-in-out infinite;\n  animation: ball-fall 1s ease-in-out infinite;\n}\n\n.la-ball-fall > div:nth-child(1) {\n  -webkit-animation-delay: -200ms;\n  -moz-animation-delay: -200ms;\n  -o-animation-delay: -200ms;\n  animation-delay: -200ms;\n}\n\n.la-ball-fall > div:nth-child(2) {\n  -webkit-animation-delay: -100ms;\n  -moz-animation-delay: -100ms;\n  -o-animation-delay: -100ms;\n  animation-delay: -100ms;\n}\n\n.la-ball-fall > div:nth-child(3) {\n  -webkit-animation-delay: 0ms;\n  -moz-animation-delay: 0ms;\n  -o-animation-delay: 0ms;\n  animation-delay: 0ms;\n}\n\n.la-ball-fall.la-sm {\n  width: 26px;\n  height: 8px;\n}\n\n.la-ball-fall.la-sm > div {\n  width: 4px;\n  height: 4px;\n  margin: 2px;\n}\n\n.la-ball-fall.la-2x {\n  width: 108px;\n  height: 36px;\n}\n\n.la-ball-fall.la-2x > div {\n  width: 20px;\n  height: 20px;\n  margin: 8px;\n}\n\n.la-ball-fall.la-3x {\n  width: 162px;\n  height: 54px;\n}\n\n.la-ball-fall.la-3x > div {\n  width: 30px;\n  height: 30px;\n  margin: 12px;\n}\n\n/*\n * Animation\n */\n@-webkit-keyframes ball-fall {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-145%);\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: .5;\n  }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  90% {\n    opacity: .5;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(145%);\n    transform: translateY(145%);\n  }\n}\n\n@-moz-keyframes ball-fall {\n  0% {\n    opacity: 0;\n    -moz-transform: translateY(-145%);\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: .5;\n  }\n  20% {\n    opacity: 1;\n    -moz-transform: translateY(0);\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    -moz-transform: translateY(0);\n    transform: translateY(0);\n  }\n  90% {\n    opacity: .5;\n  }\n  100% {\n    opacity: 0;\n    -moz-transform: translateY(145%);\n    transform: translateY(145%);\n  }\n}\n\n@-o-keyframes ball-fall {\n  0% {\n    opacity: 0;\n    -o-transform: translateY(-145%);\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: .5;\n  }\n  20% {\n    opacity: 1;\n    -o-transform: translateY(0);\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    -o-transform: translateY(0);\n    transform: translateY(0);\n  }\n  90% {\n    opacity: .5;\n  }\n  100% {\n    opacity: 0;\n    -o-transform: translateY(145%);\n    transform: translateY(145%);\n  }\n}\n\n@keyframes ball-fall {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-145%);\n    -moz-transform: translateY(-145%);\n    -o-transform: translateY(-145%);\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: .5;\n  }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n  }\n  90% {\n    opacity: .5;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(145%);\n    -moz-transform: translateY(145%);\n    -o-transform: translateY(145%);\n    transform: translateY(145%);\n  }\n}\n",".#{$rt-namespace}__toast-container {\n    z-index: $rt-z-index;\n    position: fixed;\n    padding: 0;\n    width: $rt-toast-width;\n    box-sizing: border-box;\n    color: $white;\n    &--top-left {\n        top: $spacer;\n        left: $spacer;\n    }\n    &--top-center {\n        top: $spacer;\n        left: 50%;\n        margin-left: -($rt-toast-width / 2);\n    }\n    &--top-right {\n        top: $spacer;\n        right: $spacer;\n    }\n    &--bottom-left {\n        bottom: $spacer;\n        left: $spacer;\n    }\n    &--bottom-center {\n        bottom: $spacer;\n        left: 50%;\n        margin-left: -($rt-toast-width / 2);\n    }\n    &--bottom-right {\n        bottom: $spacer;\n        right: $spacer;\n    }\n}\n\n@media #{$rt-mobile} {\n    .#{$rt-namespace}__toast-container {\n        width: 100vw;\n        padding: 0;\n        left: 0;\n        margin: 0;\n        &--top-left,\n        &--top-center,\n        &--top-right {\n            top: 0;\n        }\n        &--bottom-left,\n        &--bottom-center,\n        &--bottom-right {\n            bottom: 0;\n        }\n        &--rtl{\n          right: 0;\n          left: initial;\n        }\n    }\n}\n","$rt-namespace: 'Toastify';\n$rt-toast-width: 320px !default;\n$rt-toast-background: #ffffff !default;\n$rt-toast-min-height: 54px !default;\n$rt-toast-max-height: 800px !default;\n\n\n$rt-color-default: #fff !default;\n$rt-color-info: $info !default;\n$rt-color-success: $success !default;\n$rt-color-warning: $warning !default;\n$rt-color-error: $danger !default;\n\n$rt-color-progress-default: $primary !default;\n\n$rt-mobile: \"only screen and (max-width : 480px)\" !default;\n$rt-font-family: sans-serif !default;\n$rt-z-index: 9999 !default;\n\n",".#{$rt-namespace}__toast {\n    position: relative;\n    min-height: $rt-toast-min-height;\n    box-sizing: border-box;\n    margin-bottom: 1rem;\n    padding: $spacer;\n    @include border-radius($border-radius);\n    box-shadow: $box-shadow-default;\n    display: flex;\n    justify-content: space-between;\n    max-height: $rt-toast-max-height;\n    overflow: hidden;\n    font-family: $rt-font-family;\n    cursor: pointer;\n    direction: ltr;\n    &--rtl {\n        direction: rtl;\n    }\n    &--default {\n        background: $rt-color-default;\n        color: $gray-700;\n        @include box-shadow-architect($primary);\n    }\n    &--info {\n        background: $rt-color-info;\n        @include box-shadow-architect($info);\n    }\n    &--success {\n        background: $rt-color-success;\n        @include box-shadow-architect($success);\n    }\n    &--warning {\n        background: $rt-color-warning;\n        @include box-shadow-architect($warning);\n    }\n    &--error {\n        background: $rt-color-error;\n        @include box-shadow-architect($danger);\n    }\n    &-body {\n        margin: auto 0;\n        padding: 0 0 ($spacer / 2.5);\n    }\n}\n\n@media #{$rt-mobile} {\n  .#{$rt-namespace}__toast{\n    margin-bottom: 0;  \n  }\n}",".#{$rt-namespace}__close-button {\n  color: $white;\n  font-size: 14px;\n  background: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  position: absolute;\n  top: 5px;\n  right: 9px;\n  &--default {\n    color: #000;\n    opacity: 0.3;\n  }\n\n  &:hover,\n  &:focus {\n    opacity: 1;\n  }\n}\n","@keyframes #{$rt-namespace}__trackProgress {\n  0%{\n    width: 96%;\n  }\n  100%{\n    width: 0;\n  }\n}\n\n.#{$rt-namespace}__progress-bar {\n  position: absolute;\n  bottom: 9%;\n  left: 2%;\n  width: 0;\n  height: 5px;\n  z-index: $rt-z-index;\n  animation: #{$rt-namespace}__trackProgress linear 1;\n  background-color: rgba(255,255,255,.3);\n  @include border-radius($border-radius);\n\n  &--rtl {\n    right: 0;\n    left: initial;\n  }\n  &--default{\n    background: $rt-color-progress-default;\n  }\n\n  &--info{}\n  &--success{}\n  &--warning{}\n  &--error{}\n}\n","@mixin timing-function {\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n}\n\n@keyframes #{$rt-namespace}__bounceInRight {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n        @include timing-function;\n    }\n    from {\n        opacity: 0;\n        transform: translate3d(3000px, 0, 0);\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(-25px, 0, 0);\n    }\n    75% {\n        transform: translate3d(10px, 0, 0);\n    }\n    90% {\n        transform: translate3d(-5px, 0, 0);\n    }\n    to {\n        transform: none;\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceOutRight {\n    20% {\n        opacity: 1;\n        transform: translate3d(-20px, 0, 0);\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(2000px, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceInLeft {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n        @include timing-function;\n    }\n    0% {\n        opacity: 0;\n        transform: translate3d(-3000px, 0, 0);\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(25px, 0, 0);\n    }\n    75% {\n        transform: translate3d(-10px, 0, 0);\n    }\n    90% {\n        transform: translate3d(5px, 0, 0);\n    }\n    to {\n        transform: none;\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceOutLeft {\n    20% {\n        opacity: 1;\n        transform: translate3d(20px, 0, 0);\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(-2000px, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceInUp {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n        @include timing-function;\n    }\n    from {\n        opacity: 0;\n        transform: translate3d(0, 3000px, 0);\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(0, -20px, 0);\n    }\n    75% {\n        transform: translate3d(0, 10px, 0);\n    }\n    90% {\n        transform: translate3d(0, -5px, 0);\n    }\n    to {\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceOutUp {\n    20% {\n        transform: translate3d(0, -10px, 0);\n    }\n    40%,\n    45% {\n        opacity: 1;\n        transform: translate3d(0, 20px, 0);\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(0, -2000px, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceInDown {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n        @include timing-function;\n    }\n    0% {\n        opacity: 0;\n        transform: translate3d(0, -3000px, 0);\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(0, 25px, 0);\n    }\n    75% {\n        transform: translate3d(0, -10px, 0);\n    }\n    90% {\n        transform: translate3d(0, 5px, 0);\n    }\n    to {\n        transform: none;\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceOutDown {\n    20% {\n        transform: translate3d(0, 10px, 0);\n    }\n    40%,\n    45% {\n        opacity: 1;\n        transform: translate3d(0, -20px, 0);\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(0, 2000px, 0);\n    }\n}\n\n.#{$rt-namespace}__bounce-enter {\n    &--top-left,\n    &--bottom-left {\n        animation-name: #{$rt-namespace}__bounceInLeft;\n    }\n    &--top-right,\n    &--bottom-right {\n        animation-name: #{$rt-namespace}__bounceInRight;\n    }\n    &--top-center {\n        animation-name: #{$rt-namespace}__bounceInDown;\n    }\n    &--bottom-center {\n        animation-name: #{$rt-namespace}__bounceInUp;\n    }\n}\n\n.#{$rt-namespace}__bounce-exit {\n    &--top-left,\n    &--bottom-left {\n        animation-name: #{$rt-namespace}__bounceOutLeft;\n    }\n    &--top-right,\n    &--bottom-right {\n        animation-name: #{$rt-namespace}__bounceOutRight;\n    }\n    &--top-center {\n        animation-name: #{$rt-namespace}__bounceOutUp;\n    }\n    &--bottom-center {\n        animation-name: #{$rt-namespace}__bounceOutDown;\n    }\n}","@keyframes #{$rt-namespace}__zoomIn {\n    from {\n        opacity: 0;\n        transform: scale3d(0.3, 0.3, 0.3);\n    }\n    50% {\n        opacity: 1;\n    }\n}\n\n@keyframes #{$rt-namespace}__zoomOut {\n    from {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0;\n        transform: scale3d(0.3, 0.3, 0.3);\n    }\n    to {\n        opacity: 0\n    }\n}\n\n.#{$rt-namespace}__zoom-enter {\n    animation-name: #{$rt-namespace}__zoomIn;\n}\n\n.#{$rt-namespace}__zoom-exit {\n    animation-name: #{$rt-namespace}__zoomOut;\n}\n","@keyframes #{$rt-namespace}__flipIn {\n    from {\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        animation-timing-function: ease-in;\n        opacity: 0;\n    }\n    40% {\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        animation-timing-function: ease-in;\n    }\n    60% {\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n    }\n    to {\n        transform: perspective(400px);\n    }\n}\n\n@keyframes #{$rt-namespace}__flipOut {\n    from {\n        transform: perspective(400px);\n    }\n    30% {\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        opacity: 1\n    }\n    to {\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        opacity: 0\n    }\n}\n\n.#{$rt-namespace}__flip-enter {\n    animation-name: #{$rt-namespace}__flipIn;\n}\n\n.#{$rt-namespace}__flip-exit {\n    animation-name: #{$rt-namespace}__flipOut;\n}\n","@mixin transform {\n    transform: translate3d(0, 0, 0);\n}\n\n@keyframes #{$rt-namespace}__slideInRight {\n    from {\n        transform: translate3d(110%, 0, 0);\n        visibility: visible;\n    }\n    to {\n        @include transform;\n    }\n}\n\n@keyframes #{$rt-namespace}__slideInLeft {\n    from {\n        transform: translate3d(-110%, 0, 0);\n        visibility: visible;\n    }\n    to {\n        @include transform;\n    }\n}\n\n@keyframes #{$rt-namespace}__slideInUp {\n    from {\n        transform: translate3d(0, 110%, 0);\n        visibility: visible;\n    }\n    to {\n        @include transform;\n    }\n}\n\n@keyframes #{$rt-namespace}__slideInDown {\n    from {\n        transform: translate3d(0, -110%, 0);\n        visibility: visible;\n    }\n    to {\n        @include transform;\n    }\n}\n\n@keyframes #{$rt-namespace}__slideOutRight {\n    from {\n        @include transform;\n    }\n    to {\n        visibility: hidden;\n        transform: translate3d(110%, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__slideOutLeft {\n    from {\n        @include transform;\n    }\n    to {\n        visibility: hidden;\n        transform: translate3d(-110%, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__slideOutDown {\n    from {\n        @include transform;\n    }\n    to {\n        visibility: hidden;\n        transform: translate3d(0, 500px, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__slideOutUp {\n    from {\n        @include transform;\n    }\n    to {\n        visibility: hidden;\n        transform: translate3d(0, -500px, 0);\n    }\n}\n\n.#{$rt-namespace}__slide-enter {\n    &--top-left,\n    &--bottom-left {\n        animation-name: #{$rt-namespace}__slideInLeft;\n    }\n    &--top-right,\n    &--bottom-right {\n        animation-name: #{$rt-namespace}__slideInRight;\n    }\n    &--top-center {\n        animation-name: #{$rt-namespace}__slideInDown;\n    }\n    &--bottom-center {\n        animation-name: #{$rt-namespace}__slideInUp;\n    }\n}\n\n.#{$rt-namespace}__slide-exit {\n    &--top-left,\n    &--bottom-left {\n        animation-name: #{$rt-namespace}__slideOutLeft;\n    }\n    &--top-right,\n    &--bottom-right {\n        animation-name: #{$rt-namespace}__slideOutRight;\n    }\n    &--top-center {\n        animation-name: #{$rt-namespace}__slideOutUp;\n    }\n    &--bottom-center {\n        animation-name: #{$rt-namespace}__slideOutDown;\n    }\n}","/* -- container -- */\n.rodal,\n.rodal-mask {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.rodal {\n  position: fixed;\n}\n\n/* -- mask -- */\n.rodal-mask {\n  position: absolute;\n  background-color: $modal-backdrop-bg;\n  opacity: $modal-backdrop-opacity;\n}\n\n/* -- dialog -- */\n.rodal-dialog {\n  position: absolute;\n  top: 10%;\n  left: 0;\n  right: 0;\n  margin: auto;\n  z-index: 101;\n  background: $white;\n  box-shadow: $box-shadow-lg-default;\n  @include border-radius($border-radius);\n  height: auto !important;\n}\n\n.rodal-dialog:focus {\n  outline: none;\n}\n\n/* -- close button -- */\n.rodal-close {\n  position: absolute;\n  cursor: pointer;\n  top: 16px;\n  right: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.rodal-close:before,\n.rodal-close:after {\n  position: absolute;\n  content: '';\n  height: 2px;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  margin-top: -1px;\n  background: $gray-500;\n  border-radius: 100%;\n  transition: background .2s;\n}\n\n.rodal-close:before {\n  transform: rotate(45deg);\n}\n\n.rodal-close:after {\n  transform: rotate(-45deg);\n}\n\n.rodal-close:hover:before,\n.rodal-close:hover:after {\n  background: $gray-800;\n}\n\n/* -- fade -- */\n\n@keyframes rodal-fade-enter {\n  from {\n    opacity: 0;\n  }\n}\n\n.rodal-fade-enter {\n  animation: rodal-fade-enter both ease-in;\n}\n\n@keyframes rodal-fade-leave {\n  to {\n    opacity: 0\n  }\n}\n\n.rodal-fade-leave {\n  animation: rodal-fade-leave both ease-out;\n}\n\n@keyframes rodal-zoom-enter {\n  from {\n    transform: scale3d(.3, .3, .3);\n  }\n}\n\n.rodal-zoom-enter {\n  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-zoom-leave {\n  to {\n    transform: scale3d(.3, .3, .3);\n  }\n}\n\n.rodal-zoom-leave {\n  animation: rodal-zoom-leave both;\n}\n\n@keyframes rodal-slideDown-enter {\n  from {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n\n.rodal-slideDown-enter {\n  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideDown-leave {\n  to {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n\n.rodal-slideDown-leave {\n  animation: rodal-slideDown-leave both;\n}\n\n/* -- slideLeft -- */\n\n@keyframes rodal-slideLeft-enter {\n  from {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n\n.rodal-slideLeft-enter {\n  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideLeft-leave {\n  to {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n\n.rodal-slideLeft-leave {\n  animation: rodal-slideLeft-leave both;\n}\n\n/* -- slideRight -- */\n\n@keyframes rodal-slideRight-enter {\n  from {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n\n.rodal-slideRight-enter {\n  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideRight-leave {\n  to {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n\n.rodal-slideRight-leave {\n  animation: rodal-slideRight-leave both;\n}\n\n/* -- slideUp -- */\n\n@keyframes rodal-slideUp-enter {\n  from {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n\n.rodal-slideUp-enter {\n  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideUp-leave {\n  to {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n\n.rodal-slideUp-leave {\n  animation: rodal-slideUp-leave both;\n}\n\n/* -- flip -- */\n\n@keyframes rodal-flip-enter {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);\n  }\n  70% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n\n.rodal-flip-enter {\n  animation: rodal-flip-enter both ease-in;\n  backface-visibility: visible !important;\n}\n\n@keyframes rodal-flip-leave {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);\n  }\n}\n\n.rodal-flip-leave {\n  animation: rodal-flip-leave both;\n  backface-visibility: visible !important;\n}\n\n/* -- rotate -- */\n\n@keyframes rodal-rotate-enter {\n  from {\n    transform: rotate3d(0, 0, 1, -180deg) scale3d(.3, .3, .3);\n  }\n}\n\n.rodal-rotate-enter {\n  animation: rodal-rotate-enter both;\n  transform-origin: center;\n}\n\n@keyframes rodal-rotate-leave {\n  to {\n    transform: rotate3d(0, 0, 1, 180deg) scale3d(.3, .3, .3);\n  }\n}\n\n.rodal-rotate-leave {\n  animation: rodal-rotate-leave both;\n  transform-origin: center;\n}\n\n/* -- door -- */\n\n@keyframes rodal-door-enter {\n  from {\n    transform: scale3d(0, 1, 1);\n  }\n}\n\n.rodal-door-enter {\n  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-door-leave {\n  60% {\n    transform: scale3d(.01, 1, 1);\n  }\n  to {\n    transform: scale3d(0, 1, .1);\n  }\n}\n\n.rodal-door-leave {\n  animation: rodal-door-leave both;\n}",".react-sweet-progress {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.react-sweet-progress-symbol {\n  display: flex;\n  align-items: center;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  width: 35px;\n  height: 20px;\n  padding-left: 10px;\n  color: rgba(0, 0, 0, 0.7);\n  font-weight: 200;\n}\n\n.react-sweet-progress-symbol-absolute {\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  transform: translate3d(-50%, -50%, 0);\n}\n\n.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {\n  padding: 0;\n  width: 100%;\n}\n\n.react-sweet-progress-circle-outer {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line {\n  width: 100%;\n  border-radius: 100px;\n  background-color: #efefef;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line-inner {\n  position: relative;\n  min-height: 10px;\n  border-radius: 100px;\n  transition: width 0.3s ease;\n}\n\n.react-sweet-progress-line-inner-status-active:before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border-radius: 10px;\n  background: #fff;\n  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;\n  content: \"\";\n  opacity: 0;\n}\n\n@keyframes active-anim {\n  0% {\n    width: 0;\n    opacity: .1;\n  }\n  20% {\n    width: 0;\n    opacity: .5;\n  }\n  to {\n    width: 100%;\n    opacity: 0;\n  }\n}\n\n.react-sweet-progress-circle path {\n  stroke-linecap: round;\n}\n","/* Slider */\n\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.slick-slider-sm {\n  .slick-slider {\n    max-width: 450px;\n\n    .slick-prev {\n      left: -20px;\n    }\n\n    .slick-next {\n      right: -20px;\n    }\n  }\n}\n\n.slick-slider-md {\n  .slick-slider {\n    max-width: 650px;\n    margin: 0 auto;\n  }\n}\n\n.slick-slider-hover {\n  .slick-arrow {\n    opacity: 0;\n    background: $primary-color;\n    color: $white !important;\n  }\n\n  .slick-prev {\n    left: -30px;\n\n  }\n\n  .slick-next {\n    right: -30px;\n  }\n\n\n  &:hover {\n    .slick-arrow {\n      opacity: 1;\n    }\n  }\n}\n\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n  }\n\n  &.dragging {\n    cursor: pointer;\n    cursor: hand;\n  }\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n\n  .slick-loading & {\n    visibility: hidden;\n  }\n}\n\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n  [dir=\"rtl\"] & {\n    float: right;\n  }\n  img {\n    display: block;\n  }\n  &.slick-loading img {\n    display: none;\n  }\n\n  display: none;\n\n  &.dragging img {\n    pointer-events: none;\n  }\n\n  .slick-initialized & {\n    display: block;\n  }\n\n  .slick-loading & {\n    visibility: hidden;\n  }\n\n  .slick-vertical & {\n    display: block;\n    height: auto;\n    border: 1px solid transparent;\n  }\n}\n\n.slick-arrow.slick-hidden {\n  display: none;\n}\n\n@import \"slick-theme\";","// Default Variables\n\n$slick-font-path: \"./fonts/\" !default;\n$slick-font-family: \"slick\" !default;\n$slick-loader-path: \"./\" !default;\n$slick-arrow-color: $primary !default;\n$slick-next-character: \"\\E684\" !default;\n$slick-prev-character: \"\\E686\" !default;\n$slick-dot-size: 6px !default;\n$slick-opacity-default: 0.75 !default;\n$slick-opacity-on-hover: 1 !default;\n$slick-opacity-not-active: 0.25 !default;\n\n/* Arrows */\n\n.slick-prev,\n.slick-next {\n  position: absolute;\n  display: block;\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n  color: $gray-600;\n  top: 50%;\n  transform: translate(0, -80%);\n  padding: 0;\n  border: none;\n  outline: none;\n  box-shadow: $box-shadow-default;\n  transition: all .2s;\n  font-family: 'Pe-icon-7-stroke';\n  @include border-radius(50px);\n  background: $white;\n  z-index: 6;\n  overflow: hidden;\n\n  &::before {\n    font-size: 35px;\n    height: 40px;\n    line-height: 40px;\n    width: 40px;\n  }\n\n  &:hover, &:focus {\n    outline: none;\n    box-shadow: $box-shadow-lg;\n    color: $primary;\n  }\n\n  &.slick-disabled:before {\n    opacity: $slick-opacity-not-active;\n  }\n}\n\n.slick-prev {\n  left: 0;\n  &:before {\n    content: $slick-prev-character;\n\n  }\n}\n\n.slick-next {\n  right: 0;\n  &:before {\n    content: $slick-next-character;\n  }\n}\n\n/* Dots */\n\n.slick-dots {\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  margin: ($layout-spacer-x / 2) 0 0;\n  width: 100%;\n  li {\n    position: relative;\n    display: inline-block;\n    padding: 0;\n    margin: 0 5px;\n    cursor: pointer;\n    transform: scale(.8);\n    transition: all .2s;\n\n    button {\n      border: 0;\n      background: transparent;\n      display: block;\n      height: 14px;\n      width: 14px;\n      background: $primary;\n      cursor: pointer;\n      position: relative;\n      @include border-radius(20px);\n      color: transparent;\n\n      &::before {\n        content: '';\n        position: absolute;\n        background: $white;\n        left: 50%;\n        top: 50%;\n        margin: -4px 0 0 -4px;\n        display: block;\n        width: 8px;\n        height: 8px;\n        @include border-radius(20px);\n      }\n\n    }\n    &.slick-active {\n      transform: scale(1.2);\n    }\n  }\n}\n\n.slick-center {\n  transform: scale(1.1);\n}\n\n.slick-slider {\n  .slide-img-bg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    opacity: .4;\n    z-index: 10;\n  }\n\n  .slider-content {\n    position: relative;\n    z-index: 15;\n    text-align: center;\n    margin: 0 ($spacer-lg * 2);\n\n    h3 {\n      font-size: $h3-font-size;\n      font-weight: normal;\n      margin-bottom: $spacer-sm;\n    }\n\n    p {\n      font-size: $h6-font-size;\n      opacity: .7;\n    }\n  }\n}\n\n// slider-light\n\n.slider-light {\n  .slick-dots {\n    position: absolute;\n    bottom: 10px;\n\n    li button {\n      background: rgba(255, 255, 255, 0.25);\n    }\n  }\n\n  .slick-prev,\n  .slick-next {\n    background: transparent;\n    color: $white;\n    box-shadow: 0 0 0 0 transparent;\n\n    &:hover {\n      background: rgba(255,255,255,.15);\n    }\n  }\n\n  .slick-next {\n    right: 15px;\n  }\n\n  .slick-prev {\n    left: 15px;\n  }\n\n  .slider-content {\n    color: $white;\n  }\n}\n",".loading-indicator {\n  text-align: center;\n}\n\n.loading-bullet {\n  display: inline-block;\n  opacity: 0;\n  font-size: 2em;\n  color: #02a17c;\n}\n\n.block-ui {\n  position: relative;\n  min-height: 8em;\n}\n\n.block-ui-container {\n  position: absolute;\n  z-index: 1010;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  min-height: 2em;\n  cursor: wait;\n  overflow: hidden;\n}\n\n.block-ui-container:focus {\n  outline: none;\n}\n\n.block-ui-overlay {\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  background-color: white;\n}\n\n.block-ui-message-container {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  right: 0;\n  text-align: center;\n  transform: translateY(-50%);\n  z-index: 10001;\n}\n\n.block-ui-message {\n  color: #333;\n  background: none;\n  z-index: 1011;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.block-overlay-dark {\n  .block-ui-overlay {\n    background: rgba(0,0,0,1);\n  }\n}","// Tooltips & Popovers\n\n// Popover\n\n.popover {\n  box-shadow: $box-shadow-default;\n\n  .grid-menu {\n    margin-bottom: -$popover-body-padding-y;\n    padding: 1px;\n\n    [class*=\"col-\"] {\n      padding: $popover-body-padding-y;\n    }\n\n    & + .nav {\n      .nav-item-btn {\n        margin-bottom: $popover-body-padding-y;\n      }\n    }\n  }\n\n  .grid-menu-xl {\n    margin-bottom: -($popover-body-padding-y / 1.35);\n\n    [class*=\"col-\"] {\n      padding: 0;\n    }\n  }\n\n  .popover-inner {\n    .dropdown-menu-header {\n      @include border-top-radius($popover-border-radius);\n      overflow: hidden;\n      margin-top: -1px;\n      margin-left: -1px;\n      margin-right: -1px;\n    }\n  }\n}\n\n.rm-max-width {\n  & > .popover {\n    max-width: initial;\n  }\n}\n\n.rm-pointers {\n  & > .popover {\n    .arrow {\n      display: none !important;\n    }\n  }\n}\n\n@mixin bg-popover($parent, $color) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n}\n\n@each $color, $value in $theme-colors {\n  @include bg-popover(\".popover-#{$color}\", $value);\n}\n\n.popover-custom {\n  .popover-body {\n    padding-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n\n    .dropdown-menu-header {\n      margin-top: 0;\n      @include border-top-radius($popover-border-radius);\n      overflow: hidden;\n\n      .menu-header-content {\n        padding: 0 $layout-spacer-x;\n      }\n\n      .dropdown-menu-header-inner.bg-light {\n        color: rgba(0, 0, 0, .8);\n      }\n    }\n  }\n\n  &.popover-custom-lg {\n    min-width: 22rem;\n  }\n\n  &.popover-custom-xl {\n    min-width: 25rem;\n  }\n\n  &.popover-custom-sm {\n    min-width: 15rem;\n  }\n}\n\n.popover-bg {\n  border: 0;\n\n  .arrow {\n    display: none;\n  }\n\n  .popover-header {\n    background: rgba(255, 255, 255, .1);\n    border-bottom: 0;\n    color: rgba(255, 255, 255, 1);\n\n    &::before {\n      display: none;\n    }\n  }\n\n  .popover-body {\n    color: rgba(255, 255, 255, .7);\n  }\n\n  &.text-dark {\n    .popover-header {\n      color: rgba(0, 0, 0, .8);\n    }\n\n    .popover-body {\n      color: rgba(0, 0, 0, .7);\n    }\n  }\n}\n\n// Tooltip\n\n.tooltip-light {\n  & > .tooltip {\n    .tooltip-inner {\n      background: $white;\n      color: $gray-800;\n      box-shadow: $box-shadow-default;\n      border: $popover-border-color solid 1px;\n    }\n\n    .arrow {\n      display: none;\n    }\n  }\n}\n","// Sticky Elements\n\n.scrollable-block {\n  margin-bottom: 50px;\n  overflow: hidden;\n  position: relative;\n  .sticky {\n    z-index: 2;\n  }\n}",".rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n","@import 'scss/variables';\n@import 'scss/reset';\n\n\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n    flex: 1 1;\n    min-height: 580px;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n\n.rbc-abs-full {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.rbc-ellipsis {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rbc-rtl {\n  direction: rtl;\n}\n\n.rbc-off-range {\n  color: $out-of-range-color;\n}\n\n.rbc-header {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  flex: 1 0;\n  flex-basis: auto !important;\n\n  > a {\n    &, &:active, &:visited {\n      color: inherit;\n      text-decoration: none;\n    }\n  }\n}\n\n.rbc-row-content {\n  position: relative;\n  user-select: none;\n  z-index: 4;\n}\n\n.rbc-today {\n  background-color: $today-highlight-bg;\n}\n\n\n@import 'scss/toolbar';\n@import 'scss/event';\n@import 'scss/month';\n@import 'scss/agenda';\n@import 'scss/time-grid';\n","\n$out-of-range-color: lighten(#333, 50%);\n\n$calendar-border: $gray-200;\n$cell-border: $gray-200;\n\n$border-color: $gray-300;\n\n$segment-width: percentage(1 / 7);\n\n$time-selection-color: #white;\n$time-selection-bg-color: rgba(0,0,0, .50);\n$date-selection-bg-color: rgba(0,0,0, .10);\n\n\n$event-bg: $primary;\n$event-border: darken($event-bg, 10%);\n$event-color: $white;\n$event-border-radius: $border-radius;\n$event-padding: $dropdown-spacer;\n$event-zindex: 4;\n\n$btn-color: $white;\n$btn-bg: $primary;\n$btn-border: $primary;\n\n$current-time-color: $success;\n\n$rbc-css-prefix: rbc-i;\n\n$today-highlight-bg: $dropdown-link-hover-bg;\n","@import 'variables';\n\n$active-background: darken($btn-bg, 10%);\n$active-border: darken($btn-border, 12%);\n\n.rbc-toolbar {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n\n  .rbc-toolbar-label {\n    width: 100%;\n    padding: 0 10px;\n    text-align: center;\n  }\n\n  & button {\n    color: $btn-color;\n    display: inline-block;\n    margin: 0;\n    text-align: center;\n    vertical-align: middle;\n    background: $primary;\n    border: 1px solid $btn-border;\n    padding: .375rem 1rem;\n    border-radius: $border-radius;\n    line-height: normal;\n    white-space: nowrap;\n    font-weight: bold;\n    text-transform: capitalize;\n    font-size: $font-size-sm / 1.1;\n\n    &:active,\n    &.rbc-active {\n      background-image: none;\n      box-shadow: inset 0 3px 5px rgba(0,0,0,.125);\n      background-color: $active-background;\n      border-color: $active-border;\n\n      &:hover,\n      &:focus {\n        color: $btn-color;\n        background-color: darken($btn-bg, 17%);\n        border-color: darken($btn-border, 25%);\n      }\n    }\n\n    &:focus {\n      color: $btn-color;\n      background-color: $active-background;\n      border-color: $active-border;\n    }\n\n    &:hover {\n      color: $btn-color;\n      background-color: $active-background;\n      border-color: $active-border;\n    }\n  }\n}\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n\n  > button:first-child:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  > button:last-child:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rbc-rtl & > button:first-child:not(:last-child) {\n    border-radius: 4px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rbc-rtl & > button:last-child:not(:first-child) {\n    border-radius: 4px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  > button:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n\n  button + button {\n    margin-left: -1px;\n  }\n\n  .rbc-rtl & button + button {\n    margin-left: 0;\n    margin-right: -1px;\n  }\n\n  & + &,\n  & + button {\n    margin-left: 10px;\n  }\n}\n","@import 'variables';\n\n.rbc-event {\n  cursor: pointer;\n  padding: $event-padding;\n  background-color: $event-bg;\n  border-radius: $event-border-radius;\n  color: $event-color;\n\n  &.rbc-selected {\n    background-color: darken($event-bg, 10%);\n  }\n}\n\n.rbc-event-label {\n  @extend .rbc-ellipsis;\n  font-size: 80%;\n}\n\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51,51,51,.5);\n}\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n","@import 'variables';\n\n\n.rbc-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n\n  .rbc-event-content {\n    @extend .rbc-ellipsis;\n  }\n}\n\n.rbc-selected-cell {\n  background-color: $date-selection-bg-color;\n}\n\n\n.rbc-show-more {\n  @extend .rbc-ellipsis;\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: $event-zindex;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid $calendar-border;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  width: 100%;\n  user-select: none;\n\n  height: 100%; // ie-fix\n\n  .rbc-header {\n    border-bottom: 1px solid $cell-border;\n  }\n\n  .rbc-header + .rbc-header {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & .rbc-header + .rbc-header {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n}\n\n.rbc-month-header {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: hidden;\n\n  height: 100%; // ie-fix\n\n  & + & {\n    border-top: 1px solid $cell-border;\n  }\n}\n\n.rbc-date-cell {\n  padding-right: 5px;\n  text-align: right;\n  flex: 1 1;\n\n  &.rbc-now {\n    font-weight: bold;\n  }\n\n  > a {\n    &, &:active, &:visited {\n      color: inherit;\n      text-decoration: none;\n    }\n  }\n}\n\n.rbc-row-bg {\n  @extend .rbc-abs-full;\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n\n.rbc-day-bg {\nflex: 1 0;\n  & + & {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & + & {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n}\n\n.rbc-off-range-bg {\n    background: $gray-100;\n}\n\n.rbc-overlay {\n  position: absolute;\n  z-index: $event-zindex + 1;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0,0,0,.25);\n  padding: 10px;\n\n  > * + * {\n    margin-top: 1px;\n  }\n}\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px ;\n  padding: 2px 10px;\n}\n","\n.rbc-agenda-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: auto;\n\n  table {\n    width: 100%;\n    border: 1px solid $cell-border;\n\n    tbody > tr > td {\n      padding: 5px 10px;\n      vertical-align: top;\n\n    }\n\n    .rbc-agenda-time-cell {\n      padding-left: 15px;\n      padding-right: 15px;\n      text-transform: lowercase;\n    }\n\n    tbody > tr > td + td {\n      border-left: 1px solid $cell-border;\n    }\n\n    .rbc-rtl & {\n      tbody > tr > td + td {\n        border-left-width: 0;\n        border-right: 1px solid $cell-border;\n      }\n    }\n\n    tbody > tr + tr {\n      border-top: 1px solid $cell-border;\n    }\n\n    thead > tr > th {\n      padding: 3px 5px;\n      text-align: left;\n      border-bottom: 1px solid $cell-border;\n\n      .rbc-rtl & {\n        text-align: right;\n      }\n    }\n  }\n}\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n\n  .rbc-continues-after:after {\n    content: ' »'\n  }\n  .rbc-continues-prior:before {\n    content: '« '\n  }\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n\n\n\n.rbc-agenda-event-cell {\n  width: 100%\n}\n","@import 'variables';\n\n\n.rbc-time-column {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n\n  .rbc-timeslot-group {\n    flex: 1;\n  }\n}\n\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid $cell-border;\n  min-height: 40px;\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  flex: none;\n}\n\n.rbc-label {\n  padding: 0 5px;\n}\n\n.rbc-day-slot {\n  position: relative;\n\n  .rbc-event {\n    border: 1px solid $event-border;\n    display: flex;\n    max-height: 100%;\n    flex-flow: column wrap;\n    align-items: flex-start;\n    overflow: hidden;\n  }\n\n  .rbc-event-label {\n    flex: none;\n    padding-right: 5px;\n    width: auto;\n  }\n\n  .rbc-event-content {\n    width: 100%;\n    flex: 1 1 0;\n    word-wrap: break-word;\n    line-height: 1;\n    height: 100%;\n    min-height: 1em;\n  }\n\n  .rbc-time-slot {\n    border-top: 1px solid lighten($cell-border, 10%);\n  }\n}\n\n.rbc-time-slot {\n  flex: 1 0 0;\n\n  &.rbc-now {\n    font-weight: bold;\n  }\n}\n\n.rbc-day-header {\n  text-align: center;\n}\n\n.rbc-day-slot .rbc-event {\n  position: absolute;\n  z-index: 2;\n}\n","@import 'variables';\n@import 'time-column';\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  cursor: default;\n  background-color: $time-selection-bg-color;\n  color: $time-selection-color;\n  font-size: 75%;\n  padding: 3px;\n}\n\n.rbc-time-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  border: 1px solid $calendar-border;\n  min-height: 0;\n\n  .rbc-time-gutter {\n    white-space: nowrap;\n  }\n\n  .rbc-allday-cell {\n    width: 100%;\n    position: relative;\n  }\n\n  .rbc-allday-events {\n    position: relative;\n    z-index: 4;\n  }\n\n  .rbc-row {\n    min-height: 20px;\n  }\n}\n\n\n.rbc-time-header {\n  display: flex;\n  flex: 0 0 auto; // should not shrink below height\n  flex-direction: column;\n\n  &.rbc-overflowing {\n    border-right: 1px solid $cell-border;\n  }\n\n  .rbc-rtl &.rbc-overflowing {\n    border-right-width: 0;\n    border-left: 1px solid $cell-border;\n  }\n\n  > .rbc-row > * + * {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & > .rbc-row > * + * {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n\n  > .rbc-row:first-child {\n    border-bottom: 1px solid  $cell-border;\n  }\n\n  .rbc-gutter-cell {\n    flex: none;\n  }\n\n  > .rbc-gutter-cell + * {\n    width: 100%;\n  }\n}\n\n.rbc-time-content {\n  display: flex;\n  flex: 1 0 0%;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid $calendar-border;\n  overflow-y: auto;\n  position: relative;\n\n  > .rbc-time-gutter {\n    flex: none;\n  }\n\n  > * + * > * {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & > * + * > * {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n\n  > .rbc-day-slot {\n    width: 100%;\n    user-select: none;\n  }\n}\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  height: 1px;\n\n  background-color: $current-time-color;\n  pointer-events: none;\n\n  &::before {\n    display: block;\n\n    position: absolute;\n    left: -3px;\n    top: -3px;\n\n    content: ' ';\n    background-color: $current-time-color;\n\n    border-radius: 50%;\n    width: 8px;\n    height: 8px;\n  }\n\n  .rbc-rtl &::before {\n    left: 0;\n    right: -3px;\n  }\n}\n","// Layout Splitter\n\n.handle-bar {\n  background: transparent !important;\n  @include border-radius(30px);\n\n  &:active,\n  &:hover,\n  &.handle-bar_clone {\n    background-color: $gray-200 !important;\n  }\n\n  &.resize-not-allowed:hover {\n    background-color: $gray-200;\n  }\n\n  .handle-bar_drag {\n    border-color: $primary !important;\n  }\n}","/**\n * Extra class applied to VirtualScroll through className prop\n */\n.rst__virtualScrollOverride {\n  overflow: auto !important;\n}\n\n.ReactVirtualized__Grid__innerScrollContainer {\n  overflow: visible !important;\n}\n\n.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {\n  direction: rtl;\n}\n\n.ReactVirtualized__Grid {\n  outline: none;\n}\n\n.rst__node {\n  min-width: 100%;\n  white-space: nowrap;\n  position: relative;\n  text-align: left;\n}\n\n.rst__node.rst__rtl {\n  text-align: right;\n}\n\n.rst__nodeContent {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n/* ==========================================================================\n   Scaffold\n\n    Line-overlaid blocks used for showing the tree structure\n   ========================================================================== */\n.rst__lineBlock,\n.rst__absoluteLineBlock {\n  height: 100%;\n  position: relative;\n  display: inline-block;\n}\n\n.rst__absoluteLineBlock {\n  position: absolute;\n  top: 0;\n}\n\n.rst__lineHalfHorizontalRight::before,\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  position: absolute;\n  content: '';\n  background-color: black;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |     |\n * +-----+\n */\n.rst__lineHalfHorizontalRight::before {\n  height: 1px;\n  top: 50%;\n  right: 0;\n  width: 50%;\n}\n\n.rst__rtl.rst__lineHalfHorizontalRight::before {\n  left: 0;\n  right: initial;\n}\n\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  width: 1px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__lineFullVertical::after,\n.rst__rtl.rst__lineHalfVerticalTop::after,\n.rst__rtl.rst__lineHalfVerticalBottom::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__lineHalfVerticalTop::after {\n  height: 50%;\n}\n\n.rst__lineHalfVerticalBottom::after {\n  top: auto;\n  bottom: 0;\n  height: 50%;\n}\n\n/* Highlight line for pointing to dragged row destination\n   ========================================================================== */\n.rst__highlightLineVertical {\n  z-index: 3;\n}\n.rst__highlightLineVertical::before {\n  position: absolute;\n  content: '';\n  background-color: $primary;\n  width: 8px;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__highlightLineVertical::before {\n  margin-left: initial;\n  margin-right: -4px;\n  left: initial;\n  right: 50%;\n}\n\n@keyframes arrow-pulse {\n  0% {\n    transform: translate(0, 0);\n    opacity: 0;\n  }\n  30% {\n    transform: translate(0, 300%);\n    opacity: 1;\n  }\n  70% {\n    transform: translate(0, 700%);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(0, 1000%);\n    opacity: 0;\n  }\n}\n.rst__highlightLineVertical::after {\n  content: '';\n  position: absolute;\n  height: 0;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid white;\n  animation: arrow-pulse 1s infinite linear both;\n}\n\n.rst__rtl.rst__highlightLineVertical::after {\n  margin-left: initial;\n  margin-right: -4px;\n  right: 50%;\n  left: initial;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |  |  |\n * +--+--+\n */\n.rst__highlightTopLeftCorner::before {\n  z-index: 3;\n  content: '';\n  position: absolute;\n  border-top: solid 8px $primary;\n  border-left: solid 8px $primary;\n  box-sizing: border-box;\n  height: calc(50% + 4px);\n  top: 50%;\n  margin-top: -4px;\n  right: 0;\n  width: calc(50% + 4px);\n}\n\n.rst__rtl.rst__highlightTopLeftCorner::before {\n  border-right: solid 8px $primary;\n  border-left: none;\n  left: 0;\n  right: initial;\n}\n\n/**\n * +--+--+\n * |  |  |\n * |  |  |\n * |  +->|\n * +-----+\n */\n.rst__highlightBottomLeftCorner {\n  z-index: 3;\n}\n.rst__highlightBottomLeftCorner::before {\n  content: '';\n  position: absolute;\n  border-bottom: solid 8px $primary;\n  border-left: solid 8px $primary;\n  box-sizing: border-box;\n  height: calc(100% + 4px);\n  top: 0;\n  right: 12px;\n  width: calc(50% - 8px);\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::before {\n  border-right: solid 8px $primary;\n  border-left: none;\n  left: 12px;\n  right: initial;\n}\n\n.rst__highlightBottomLeftCorner::after {\n  content: '';\n  position: absolute;\n  height: 0;\n  right: 0;\n  top: 100%;\n  margin-top: -12px;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid $primary;\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::after {\n  left: 0;\n  right: initial;\n  border-right: 12px solid $primary;\n  border-left: none;\n}\n\n.rst__rowWrapper {\n  padding: 10px 10px 10px 0;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.rst__rtl.rst__rowWrapper {\n  padding: 10px 0 10px 10px;\n}\n\n.rst__row {\n  height: 100%;\n  white-space: nowrap;\n  display: flex;\n}\n.rst__row > * {\n  box-sizing: border-box;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__rowLandingPad,\n.rst__rowCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n.rst__rowLandingPad > *,\n.rst__rowCancelPad > * {\n  opacity: 0 !important;\n}\n.rst__rowLandingPad::before,\n.rst__rowCancelPad::before {\n  background-color: lightblue;\n  border: 1px dashed $white;\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__rowCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/**\n * Nodes matching the search conditions are highlighted\n */\n.rst__rowSearchMatch {\n  outline: solid 3px #0080ff;\n}\n\n/**\n * The node that matches the search conditions and is currently focused\n */\n.rst__rowSearchFocus {\n  outline: solid 3px #fc6421;\n}\n\n.rst__rowContents,\n.rst__rowLabel,\n.rst__rowToolbar,\n.rst__moveHandle,\n.rst__toolbarButton {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.rst__rowContents {\n  position: relative;\n  height: 100%;\n  border: solid $gray-300 1px;\n  border-left: none;\n  padding: 0 5px 0 10px;\n  border-radius: 2px;\n  min-width: 230px;\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: white;\n}\n\n.rst__rtl.rst__rowContents {\n  border-right: none;\n  border-left: solid $gray-300 1px;\n  padding: 0 10px 0 5px;\n}\n\n.rst__rowContentsDragDisabled {\n  border-left: solid $gray-300 1px;\n}\n\n.rst__rtl.rst__rowContentsDragDisabled {\n  border-right: solid $gray-300 1px;\n  border-left: solid $gray-300 1px;\n}\n\n.rst__rowLabel {\n  flex: 0 1 auto;\n  padding-right: 20px;\n}\n.rst__rtl.rst__rowLabel {\n  padding-left: 20px;\n  padding-right: inherit;\n}\n\n.rst__rowToolbar {\n  flex: 0 1 auto;\n  display: flex;\n}\n\n.rst__moveHandle,\n.rst__loadingHandle {\n  height: 100%;\n  width: 44px;\n  background: $gray-200\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+')\n  no-repeat center;\n  border: solid #aaa 1px;\n  cursor: move;\n  border-radius: 1px;\n  z-index: 1;\n}\n\n.rst__loadingHandle {\n  cursor: default;\n  background: $gray-200;\n}\n\n@keyframes pointFade {\n  0%,\n  19.999%,\n  100% {\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n}\n\n.rst__loadingCircle {\n  width: 80%;\n  height: 80%;\n  margin: 10%;\n  position: relative;\n}\n\n.rst__loadingCirclePoint {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.rst__rtl.rst__loadingCirclePoint {\n  right: 0;\n  left: initial;\n}\n\n.rst__loadingCirclePoint::before {\n  content: '';\n  display: block;\n  margin: 0 auto;\n  width: 11%;\n  height: 30%;\n  background-color: $white;\n  border-radius: 30%;\n  animation: pointFade 800ms infinite ease-in-out both;\n}\n.rst__loadingCirclePoint:nth-of-type(1) {\n  transform: rotate(0deg);\n}\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n.rst__loadingCirclePoint:nth-of-type(1)::before,\n.rst__loadingCirclePoint:nth-of-type(7)::before {\n  animation-delay: -800ms;\n}\n.rst__loadingCirclePoint:nth-of-type(2) {\n  transform: rotate(30deg);\n}\n.rst__loadingCirclePoint:nth-of-type(8) {\n  transform: rotate(210deg);\n}\n.rst__loadingCirclePoint:nth-of-type(2)::before,\n.rst__loadingCirclePoint:nth-of-type(8)::before {\n  animation-delay: -666ms;\n}\n.rst__loadingCirclePoint:nth-of-type(3) {\n  transform: rotate(60deg);\n}\n.rst__loadingCirclePoint:nth-of-type(9) {\n  transform: rotate(240deg);\n}\n.rst__loadingCirclePoint:nth-of-type(3)::before,\n.rst__loadingCirclePoint:nth-of-type(9)::before {\n  animation-delay: -533ms;\n}\n.rst__loadingCirclePoint:nth-of-type(4) {\n  transform: rotate(90deg);\n}\n.rst__loadingCirclePoint:nth-of-type(10) {\n  transform: rotate(270deg);\n}\n.rst__loadingCirclePoint:nth-of-type(4)::before,\n.rst__loadingCirclePoint:nth-of-type(10)::before {\n  animation-delay: -400ms;\n}\n.rst__loadingCirclePoint:nth-of-type(5) {\n  transform: rotate(120deg);\n}\n.rst__loadingCirclePoint:nth-of-type(11) {\n  transform: rotate(300deg);\n}\n.rst__loadingCirclePoint:nth-of-type(5)::before,\n.rst__loadingCirclePoint:nth-of-type(11)::before {\n  animation-delay: -266ms;\n}\n.rst__loadingCirclePoint:nth-of-type(6) {\n  transform: rotate(150deg);\n}\n.rst__loadingCirclePoint:nth-of-type(12) {\n  transform: rotate(330deg);\n}\n.rst__loadingCirclePoint:nth-of-type(6)::before,\n.rst__loadingCirclePoint:nth-of-type(12)::before {\n  animation-delay: -133ms;\n}\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n.rst__loadingCirclePoint:nth-of-type(13) {\n  transform: rotate(360deg);\n}\n.rst__loadingCirclePoint:nth-of-type(7)::before,\n.rst__loadingCirclePoint:nth-of-type(13)::before {\n  animation-delay: 0ms;\n}\n\n.rst__rowTitle {\n  font-weight: bold;\n}\n\n.rst__rowTitleWithSubtitle {\n  font-size: 85%;\n  display: block;\n  height: 0.8rem;\n}\n\n.rst__rowSubtitle {\n  font-size: 70%;\n  line-height: 1;\n}\n\n.rst__collapseButton,\n.rst__expandButton {\n  appearance: none;\n  border: none;\n  position: absolute;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px #000;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.rst__rtl.rst__collapseButton,\n.rst__rtl.rst__expandButton {\n  transform: translate(50%, -50%);\n}\n.rst__collapseButton:focus,\n.rst__expandButton:focus {\n  outline: none;\n  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;\n}\n.rst__collapseButton:hover:not(:active),\n.rst__expandButton:hover:not(:active) {\n  background-size: 24px;\n  height: 20px;\n  width: 20px;\n}\n\n.rst__collapseButton {\n  background: $white\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==')\n  no-repeat center;\n}\n\n.rst__expandButton {\n  background: $white\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+')\n  no-repeat center;\n}\n\n/**\n * Line for under a node with children\n */\n.rst__lineChildren {\n  height: 100%;\n  display: inline-block;\n  position: absolute;\n}\n.rst__lineChildren::after {\n  content: '';\n  position: absolute;\n  background-color: black;\n  width: 1px;\n  left: 50%;\n  bottom: 0;\n  height: 10px;\n}\n\n.rst__rtl.rst__lineChildren::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__placeholder {\n  position: relative;\n  height: 68px;\n  max-width: 300px;\n  padding: 10px;\n}\n.rst__placeholder,\n.rst__placeholder > * {\n  box-sizing: border-box;\n}\n.rst__placeholder::before {\n  border: 3px dashed $gray-200;\n  content: '';\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  z-index: -1;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__placeholderLandingPad,\n.rst__placeholderCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n.rst__placeholderLandingPad *,\n.rst__placeholderCancelPad * {\n  opacity: 0 !important;\n}\n.rst__placeholderLandingPad::before,\n.rst__placeholderCancelPad::before {\n  background-color: lightblue;\n  border-color: white;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__placeholderCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/* Collection default theme */\n\n.ReactVirtualized__Collection {\n}\n\n.ReactVirtualized__Collection__innerScrollContainer {\n}\n\n/* Grid default theme */\n\n.ReactVirtualized__Grid {\n}\n\n.ReactVirtualized__Grid__innerScrollContainer {\n}\n\n/* Table default theme */\n\n.ReactVirtualized__Table {\n}\n\n.ReactVirtualized__Table__Grid {\n}\n\n.ReactVirtualized__Table__headerRow {\n  font-weight: 700;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.ReactVirtualized__Table__row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__headerTruncatedText {\n  display: inline-block;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ReactVirtualized__Table__headerColumn,\n.ReactVirtualized__Table__rowColumn {\n  margin-right: 10px;\n  min-width: 0px;\n}\n.ReactVirtualized__Table__rowColumn {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ReactVirtualized__Table__headerColumn:first-of-type,\n.ReactVirtualized__Table__rowColumn:first-of-type {\n  margin-left: 10px;\n}\n.ReactVirtualized__Table__sortableHeaderColumn {\n  cursor: pointer;\n}\n\n.ReactVirtualized__Table__sortableHeaderIconContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.ReactVirtualized__Table__sortableHeaderIcon {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 24px;\n  flex: 0 0 24px;\n  height: 1em;\n  width: 1em;\n  fill: currentColor;\n}\n\n/* List default theme */\n\n.ReactVirtualized__List {\n}",".ReactTable {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n\n  .rt-table {\n    flex: auto 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    border-collapse: collapse;\n    overflow: auto\n  }\n\n  .-pagination input,\n  .-pagination select,\n  .rt-thead.-filters input,\n  .rt-thead.-filters select {\n    display: block;\n    width: 100%;\n    color: $input-color;\n    background-color: $input-bg;\n    background-clip: padding-box;\n    border: $input-border-width solid $input-border-color;\n\n    height: $input-height-sm;\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    line-height: $input-line-height-sm;\n    @include border-radius($input-border-radius-sm);\n\n    @if $enable-rounded {\n      border-radius: $input-border-radius;\n    } @else {\n      border-radius: 0;\n    }\n\n    @include box-shadow($input-box-shadow);\n    @include transition($input-transition);\n\n    &::-ms-expand {\n      background-color: transparent;\n      border: 0;\n    }\n\n    @include form-control-focus();\n\n    // Placeholder\n    &::placeholder {\n      color: $input-placeholder-color;\n      opacity: 1;\n    }\n\n    &:disabled,\n    &[readonly] {\n      background-color: $input-disabled-bg;\n      opacity: 1;\n    }\n  }\n\n  .rt-thead {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    user-select: none;\n\n    &.-headerGroups {\n      background: rgba(0, 0, 0, 0.03);\n      border-bottom: 1px solid $table-border-color;\n\n      .rt-th,\n      .rt-td {\n        padding: $table-cell-padding-sm;\n        color: $table-head-color;\n\n        &:hover {\n          color: $table-head-color;\n        }\n\n        &:empty {\n          padding: 0;\n        }\n      }\n\n    }\n\n    &.-filters {\n      border-bottom: 1px solid $table-border-color;\n      background: $gray-100;\n\n      .rt-th {\n        border-right: 1px solid $table-border-color\n      }\n\n      &.-header {\n        box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15)\n      }\n    }\n\n    .rt-tr {\n      text-align: center\n    }\n\n    .rt-th,\n    .rt-td {\n      padding: $table-cell-padding;\n      line-height: normal;\n      position: relative;\n      font-weight: bold;\n      border-right: 1px solid $table-border-color;\n      border-bottom: 1px solid $table-border-color;\n      transition: box-shadow .3s cubic-bezier(.175, .885, .32, 1.275);\n      box-shadow: inset 0 0 0 0 transparent;\n      color: $primary;\n\n      &:hover {\n        color: darken($primary, 15%);\n      }\n    }\n\n    .rt-th.-sort-asc,\n    .rt-td.-sort-asc {\n      box-shadow: inset 0 3px 0 0 $primary\n    }\n\n    .rt-th.-sort-desc,\n    .rt-td.-sort-desc {\n      box-shadow: inset 0 -3px 0 0 $primary\n    }\n\n    .rt-th.-cursor-pointer,\n    .rt-td.-cursor-pointer {\n      cursor: pointer\n    }\n\n    .rt-th:last-child,\n    .rt-td:last-child {\n      border-right: 0\n    }\n\n    .rt-resizable-header {\n      overflow: visible;\n    }\n\n    .rt-resizable-header:last-child {\n      overflow: hidden\n    }\n\n    .rt-resizable-header-content {\n      overflow: hidden;\n      text-overflow: ellipsis\n    }\n\n    .rt-header-pivot {\n      border-right-color: #f7f7f7\n    }\n\n    .rt-header-pivot:after,\n    .rt-header-pivot:before {\n      left: 100%;\n      top: 50%;\n      border: solid transparent;\n      content: \" \";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none\n    }\n\n    .rt-header-pivot:after {\n      border-color: rgba(255, 255, 255, 0);\n      border-left-color: $white;\n      border-width: 8px;\n      margin-top: -8px\n    }\n\n    .rt-header-pivot:before {\n      border-color: rgba(102, 102, 102, 0);\n      border-left-color: #f7f7f7;\n      border-width: 10px;\n      margin-top: -10px\n    }\n  }\n\n  .rt-tbody {\n    flex: 99999 1 auto;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n\n    .rt-tr-group {\n      border-bottom: solid 1px $table-border-color;\n    }\n\n    .rt-tr-group:last-child {\n      border-bottom: 0\n    }\n\n    .rt-td {\n      border-right: 1px solid $table-border-color;\n      align-items: center;\n      align-content: center;\n      display: flex;\n\n      [contenteditable=\"true\"] {\n        width: 100%;\n        border: 1px solid transparent;\n        background: $white !important;\n        @include border-radius($input-border-radius-sm);\n\n        &:focus {\n          padding: 3px 5px;\n          border-color: $input-focus-border-color;\n          outline: none;\n        }\n      }\n    }\n\n    .rt-td:last-child {\n      border-right: 0\n    }\n\n    .rt-expandable {\n      cursor: pointer;\n      text-overflow: clip\n    }\n  }\n\n  .rt-tr-group {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch\n  }\n\n  .rt-tr {\n    flex: 1 0 auto;\n    display: inline-flex\n  }\n\n  .rt-th,\n  .rt-td {\n    flex: 1 0 0;\n    text-overflow: ellipsis;\n    padding: $table-cell-padding;\n    //overflow: hidden;\n    transition: .3s ease;\n    transition-property: width, min-width, padding, opacity;\n\n    &.-hidden {\n      width: 0 !important;\n      min-width: 0 !important;\n      padding: 0 !important;\n      border: 0 !important;\n      opacity: 0 !important\n    }\n  }\n\n  .rt-expander {\n    display: inline-block;\n    position: relative;\n    color: transparent;\n    margin: 0 10px 0 0;\n    &:after {\n      content: '';\n      position: absolute;\n      width: 0;\n      height: 0;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%) rotate(-90deg);\n      border-left: 5.04px solid transparent;\n      border-right: 5.04px solid transparent;\n      border-top: 7px solid rgba(0, 0, 0, 0.8);\n      transition: all .3s cubic-bezier(.175, .885, .32, 1.275);\n      cursor: pointer\n    }\n    &.-open:after {\n      transform: translate(-50%, -50%) rotate(0)\n    }\n  }\n\n  .rt-resizer {\n    display: inline-block;\n    position: absolute;\n    width: 36px;\n    top: 0;\n    bottom: 0;\n    right: -18px;\n    cursor: col-resize;\n    z-index: 10\n  }\n\n  .rt-tfoot {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n\n    .rt-td {\n      border-right: 1px solid $table-border-color;\n      &:last-child {\n        border-right: 0\n      }\n    }\n  }\n\n  &.-striped .rt-tr.-odd {\n    background: rgba(0, 0, 0, 0.03)\n  }\n\n  &.-fixed {\n    .-header {\n      box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);\n    }\n\n    .pagination-bottom {\n      box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);\n    }\n  }\n\n  &.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n    background: $dropdown-link-hover-bg\n  }\n\n  .-pagination {\n    z-index: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    flex-wrap: wrap;\n    padding: 3px;\n    border-top: 2px solid rgba(0, 0, 0, 0.1);\n\n    .-btn {\n      appearance: none;\n      display: block;\n      width: 100%;\n      height: 100%;\n      border: 0;\n      border-radius: $border-radius;\n      padding: 6px;\n      font-size: 1em;\n      color: $primary;\n      background: $gray-100;\n      transition: all .2s ease;\n      cursor: pointer;\n      outline: none;\n      font-weight: bold;\n    }\n\n    .-btn[disabled] {\n      opacity: .5;\n      cursor: default\n    }\n\n    .-btn:not([disabled]):hover {\n      background: $primary;\n      color: $white\n    }\n\n    .-previous,\n    .-next {\n      flex: 1;\n      text-align: center\n    }\n\n    .-center {\n      text-align: center;\n      margin-bottom: 0;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: space-around\n    }\n\n    .-totalPages {\n      padding-left: 5px;\n      font-weight: bold;\n    }\n\n    .-pageInfo {\n      display: inherit;\n      margin: 3px 0 3px 10px;\n      white-space: nowrap;\n      height: 30px;\n      line-height: 30px;\n    }\n\n    .-pageJump {\n      display: inline-block;\n      margin: 0 5px;\n    }\n\n    .-pageJump input {\n      width: 70px;\n      text-align: center\n    }\n\n    .-pageSizeOptions {\n      margin: 3px 10px\n    }\n  }\n\n  .rt-noData {\n    display: block;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    background: rgba(255, 255, 255, 0.8);\n    transition: all .3s ease;\n    z-index: 1;\n    pointer-events: none;\n    padding: 20px;\n    color: rgba(0, 0, 0, 0.5)\n  }\n\n  .-loading {\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.8);\n    transition: all .3s ease;\n    z-index: -1;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  .-loading > div {\n    position: absolute;\n    display: block;\n    text-align: center;\n    width: 100%;\n    top: 50%;\n    left: 0;\n    font-size: 15px;\n    color: $primary;\n    transform: translateY(-52%);\n    transition: all .3s cubic-bezier(.25, .46, .45, .94)\n  }\n\n  .-loading.-active {\n    opacity: 1;\n    z-index: 2;\n    pointer-events: all;\n  }\n\n  .-loading.-active > div {\n    transform: translateY(50%)\n  }\n\n  .rt-resizing .rt-th,\n  .rt-resizing .rt-td {\n    transition: none !important;\n    cursor: col-resize;\n    user-select: none\n  }\n\n}\n\n.table thead th,\n.table td {\n  vertical-align: middle;\n}\n\n.table {\n  th .filter {\n    margin-top: ($layout-spacer-x / 4);\n    height: auto;\n    padding: 0.3rem 0.5rem;\n  }\n}\n\n.caret-4-asc,\n.caret-4-desc {\n  font-family: 'Linearicons-Free';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  margin-left: ($layout-spacer-x / 4);\n}\n\n.table .sortable:hover {\n  .caret-4-asc,\n  .caret-4-desc {\n    color: $primary;\n  }\n}\n\n.caret-4-asc {\n  @extend .lnr-chevron-up;\n}\n\n.caret-4-desc {\n  @extend .lnr-chevron-down;\n}\n\n// Table sizing\n\n.table-lg {\n  th,\n  td {\n    padding: ($table-cell-padding * 2) ($table-cell-padding * 1.5);\n  }\n}","// Linear Icons\n$linearicons-font-path: \"components/icons/linearicons\";\n\n\n@font-face {\n  font-family: 'Linearicons-Free';\n  src:url('#{$linearicons-font-path}/Linearicons-Free.eot?w118d');\n  src:url('#{$linearicons-font-path}/Linearicons-Free.eot?#iefixw118d') format('embedded-opentype'),\n  url('#{$linearicons-font-path}/Linearicons-Free.woff2?w118d') format('woff2'),\n  url('#{$linearicons-font-path}/Linearicons-Free.woff?w118d') format('woff'),\n  url('#{$linearicons-font-path}/Linearicons-Free.ttf?w118d') format('truetype'),\n  url('#{$linearicons-font-path}/Linearicons-Free.svg?w118d#Linearicons-Free') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n[class^=\"lnr-\"],\n[class*=\" lnr-\"] {\n  font-family: 'Linearicons-Free';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.lnr-home:before {\n  content: \"\\e800\";\n}\n.lnr-apartment:before {\n  content: \"\\e801\";\n}\n.lnr-pencil:before {\n  content: \"\\e802\";\n}\n.lnr-magic-wand:before {\n  content: \"\\e803\";\n}\n.lnr-drop:before {\n  content: \"\\e804\";\n}\n.lnr-lighter:before {\n  content: \"\\e805\";\n}\n.lnr-poop:before {\n  content: \"\\e806\";\n}\n.lnr-sun:before {\n  content: \"\\e807\";\n}\n.lnr-moon:before {\n  content: \"\\e808\";\n}\n.lnr-cloud:before {\n  content: \"\\e809\";\n}\n.lnr-cloud-upload:before {\n  content: \"\\e80a\";\n}\n.lnr-cloud-download:before {\n  content: \"\\e80b\";\n}\n.lnr-cloud-sync:before {\n  content: \"\\e80c\";\n}\n.lnr-cloud-check:before {\n  content: \"\\e80d\";\n}\n.lnr-database:before {\n  content: \"\\e80e\";\n}\n.lnr-lock:before {\n  content: \"\\e80f\";\n}\n.lnr-cog:before {\n  content: \"\\e810\";\n}\n.lnr-trash:before {\n  content: \"\\e811\";\n}\n.lnr-dice:before {\n  content: \"\\e812\";\n}\n.lnr-heart:before {\n  content: \"\\e813\";\n}\n.lnr-star:before {\n  content: \"\\e814\";\n}\n.lnr-star-half:before {\n  content: \"\\e815\";\n}\n.lnr-star-empty:before {\n  content: \"\\e816\";\n}\n.lnr-flag:before {\n  content: \"\\e817\";\n}\n.lnr-envelope:before {\n  content: \"\\e818\";\n}\n.lnr-paperclip:before {\n  content: \"\\e819\";\n}\n.lnr-inbox:before {\n  content: \"\\e81a\";\n}\n.lnr-eye:before {\n  content: \"\\e81b\";\n}\n.lnr-printer:before {\n  content: \"\\e81c\";\n}\n.lnr-file-empty:before {\n  content: \"\\e81d\";\n}\n.lnr-file-add:before {\n  content: \"\\e81e\";\n}\n.lnr-enter:before {\n  content: \"\\e81f\";\n}\n.lnr-exit:before {\n  content: \"\\e820\";\n}\n.lnr-graduation-hat:before {\n  content: \"\\e821\";\n}\n.lnr-license:before {\n  content: \"\\e822\";\n}\n.lnr-music-note:before {\n  content: \"\\e823\";\n}\n.lnr-film-play:before {\n  content: \"\\e824\";\n}\n.lnr-camera-video:before {\n  content: \"\\e825\";\n}\n.lnr-camera:before {\n  content: \"\\e826\";\n}\n.lnr-picture:before {\n  content: \"\\e827\";\n}\n.lnr-book:before {\n  content: \"\\e828\";\n}\n.lnr-bookmark:before {\n  content: \"\\e829\";\n}\n.lnr-user:before {\n  content: \"\\e82a\";\n}\n.lnr-users:before {\n  content: \"\\e82b\";\n}\n.lnr-shirt:before {\n  content: \"\\e82c\";\n}\n.lnr-store:before {\n  content: \"\\e82d\";\n}\n.lnr-cart:before {\n  content: \"\\e82e\";\n}\n.lnr-tag:before {\n  content: \"\\e82f\";\n}\n.lnr-phone-handset:before {\n  content: \"\\e830\";\n}\n.lnr-phone:before {\n  content: \"\\e831\";\n}\n.lnr-pushpin:before {\n  content: \"\\e832\";\n}\n.lnr-map-marker:before {\n  content: \"\\e833\";\n}\n.lnr-map:before {\n  content: \"\\e834\";\n}\n.lnr-location:before {\n  content: \"\\e835\";\n}\n.lnr-calendar-full:before {\n  content: \"\\e836\";\n}\n.lnr-keyboard:before {\n  content: \"\\e837\";\n}\n.lnr-spell-check:before {\n  content: \"\\e838\";\n}\n.lnr-screen:before {\n  content: \"\\e839\";\n}\n.lnr-smartphone:before {\n  content: \"\\e83a\";\n}\n.lnr-tablet:before {\n  content: \"\\e83b\";\n}\n.lnr-laptop:before {\n  content: \"\\e83c\";\n}\n.lnr-laptop-phone:before {\n  content: \"\\e83d\";\n}\n.lnr-power-switch:before {\n  content: \"\\e83e\";\n}\n.lnr-bubble:before {\n  content: \"\\e83f\";\n}\n.lnr-heart-pulse:before {\n  content: \"\\e840\";\n}\n.lnr-construction:before {\n  content: \"\\e841\";\n}\n.lnr-pie-chart:before {\n  content: \"\\e842\";\n}\n.lnr-chart-bars:before {\n  content: \"\\e843\";\n}\n.lnr-gift:before {\n  content: \"\\e844\";\n}\n.lnr-diamond:before {\n  content: \"\\e845\";\n}\n.lnr-linearicons:before {\n  content: \"\\e846\";\n}\n.lnr-dinner:before {\n  content: \"\\e847\";\n}\n.lnr-coffee-cup:before {\n  content: \"\\e848\";\n}\n.lnr-leaf:before {\n  content: \"\\e849\";\n}\n.lnr-paw:before {\n  content: \"\\e84a\";\n}\n.lnr-rocket:before {\n  content: \"\\e84b\";\n}\n.lnr-briefcase:before {\n  content: \"\\e84c\";\n}\n.lnr-bus:before {\n  content: \"\\e84d\";\n}\n.lnr-car:before {\n  content: \"\\e84e\";\n}\n.lnr-train:before {\n  content: \"\\e84f\";\n}\n.lnr-bicycle:before {\n  content: \"\\e850\";\n}\n.lnr-wheelchair:before {\n  content: \"\\e851\";\n}\n.lnr-select:before {\n  content: \"\\e852\";\n}\n.lnr-earth:before {\n  content: \"\\e853\";\n}\n.lnr-smile:before {\n  content: \"\\e854\";\n}\n.lnr-sad:before {\n  content: \"\\e855\";\n}\n.lnr-neutral:before {\n  content: \"\\e856\";\n}\n.lnr-mustache:before {\n  content: \"\\e857\";\n}\n.lnr-alarm:before {\n  content: \"\\e858\";\n}\n.lnr-bullhorn:before {\n  content: \"\\e859\";\n}\n.lnr-volume-high:before {\n  content: \"\\e85a\";\n}\n.lnr-volume-medium:before {\n  content: \"\\e85b\";\n}\n.lnr-volume-low:before {\n  content: \"\\e85c\";\n}\n.lnr-volume:before {\n  content: \"\\e85d\";\n}\n.lnr-mic:before {\n  content: \"\\e85e\";\n}\n.lnr-hourglass:before {\n  content: \"\\e85f\";\n}\n.lnr-undo:before {\n  content: \"\\e860\";\n}\n.lnr-redo:before {\n  content: \"\\e861\";\n}\n.lnr-sync:before {\n  content: \"\\e862\";\n}\n.lnr-history:before {\n  content: \"\\e863\";\n}\n.lnr-clock:before {\n  content: \"\\e864\";\n}\n.lnr-download:before {\n  content: \"\\e865\";\n}\n.lnr-upload:before {\n  content: \"\\e866\";\n}\n.lnr-enter-down:before {\n  content: \"\\e867\";\n}\n.lnr-exit-up:before {\n  content: \"\\e868\";\n}\n.lnr-bug:before {\n  content: \"\\e869\";\n}\n.lnr-code:before {\n  content: \"\\e86a\";\n}\n.lnr-link:before {\n  content: \"\\e86b\";\n}\n.lnr-unlink:before {\n  content: \"\\e86c\";\n}\n.lnr-thumbs-up:before {\n  content: \"\\e86d\";\n}\n.lnr-thumbs-down:before {\n  content: \"\\e86e\";\n}\n.lnr-magnifier:before {\n  content: \"\\e86f\";\n}\n.lnr-cross:before {\n  content: \"\\e870\";\n}\n.lnr-menu:before {\n  content: \"\\e871\";\n}\n.lnr-list:before {\n  content: \"\\e872\";\n}\n.lnr-chevron-up:before {\n  content: \"\\e873\";\n}\n.lnr-chevron-down:before {\n  content: \"\\e874\";\n}\n.lnr-chevron-left:before {\n  content: \"\\e875\";\n}\n.lnr-chevron-right:before {\n  content: \"\\e876\";\n}\n.lnr-arrow-up:before {\n  content: \"\\e877\";\n}\n.lnr-arrow-down:before {\n  content: \"\\e878\";\n}\n.lnr-arrow-left:before {\n  content: \"\\e879\";\n}\n.lnr-arrow-right:before {\n  content: \"\\e87a\";\n}\n.lnr-move:before {\n  content: \"\\e87b\";\n}\n.lnr-warning:before {\n  content: \"\\e87c\";\n}\n.lnr-question-circle:before {\n  content: \"\\e87d\";\n}\n.lnr-menu-circle:before {\n  content: \"\\e87e\";\n}\n.lnr-checkmark-circle:before {\n  content: \"\\e87f\";\n}\n.lnr-cross-circle:before {\n  content: \"\\e880\";\n}\n.lnr-plus-circle:before {\n  content: \"\\e881\";\n}\n.lnr-circle-minus:before {\n  content: \"\\e882\";\n}\n.lnr-arrow-up-circle:before {\n  content: \"\\e883\";\n}\n.lnr-arrow-down-circle:before {\n  content: \"\\e884\";\n}\n.lnr-arrow-left-circle:before {\n  content: \"\\e885\";\n}\n.lnr-arrow-right-circle:before {\n  content: \"\\e886\";\n}\n.lnr-chevron-up-circle:before {\n  content: \"\\e887\";\n}\n.lnr-chevron-down-circle:before {\n  content: \"\\e888\";\n}\n.lnr-chevron-left-circle:before {\n  content: \"\\e889\";\n}\n.lnr-chevron-right-circle:before {\n  content: \"\\e88a\";\n}\n.lnr-crop:before {\n  content: \"\\e88b\";\n}\n.lnr-frame-expand:before {\n  content: \"\\e88c\";\n}\n.lnr-frame-contract:before {\n  content: \"\\e88d\";\n}\n.lnr-layers:before {\n  content: \"\\e88e\";\n}\n.lnr-funnel:before {\n  content: \"\\e88f\";\n}\n.lnr-text-format:before {\n  content: \"\\e890\";\n}\n.lnr-text-format-remove:before {\n  content: \"\\e891\";\n}\n.lnr-text-size:before {\n  content: \"\\e892\";\n}\n.lnr-bold:before {\n  content: \"\\e893\";\n}\n.lnr-italic:before {\n  content: \"\\e894\";\n}\n.lnr-underline:before {\n  content: \"\\e895\";\n}\n.lnr-strikethrough:before {\n  content: \"\\e896\";\n}\n.lnr-highlight:before {\n  content: \"\\e897\";\n}\n.lnr-text-align-left:before {\n  content: \"\\e898\";\n}\n.lnr-text-align-center:before {\n  content: \"\\e899\";\n}\n.lnr-text-align-right:before {\n  content: \"\\e89a\";\n}\n.lnr-text-align-justify:before {\n  content: \"\\e89b\";\n}\n.lnr-line-spacing:before {\n  content: \"\\e89c\";\n}\n.lnr-indent-increase:before {\n  content: \"\\e89d\";\n}\n.lnr-indent-decrease:before {\n  content: \"\\e89e\";\n}\n.lnr-pilcrow:before {\n  content: \"\\e89f\";\n}\n.lnr-direction-ltr:before {\n  content: \"\\e8a0\";\n}\n.lnr-direction-rtl:before {\n  content: \"\\e8a1\";\n}\n.lnr-page-break:before {\n  content: \"\\e8a2\";\n}\n.lnr-sort-alpha-asc:before {\n  content: \"\\e8a3\";\n}\n.lnr-sort-amount-asc:before {\n  content: \"\\e8a4\";\n}\n.lnr-hand:before {\n  content: \"\\e8a5\";\n}\n.lnr-pointer-up:before {\n  content: \"\\e8a6\";\n}\n.lnr-pointer-right:before {\n  content: \"\\e8a7\";\n}\n.lnr-pointer-down:before {\n  content: \"\\e8a8\";\n}\n.lnr-pointer-left:before {\n  content: \"\\e8a9\";\n}\n","/*\n*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set\n*/\n\n@import \"variables\";\n@import \"path\";\n@import \"core\";\n@import \"helper\";\n@import \"icons\";\n","@font-face {\n\tfont-family: 'Pe-icon-7-stroke';\n\tsrc:url('#{$pe-7s-font-path}/Pe-icon-7-stroke.eot?d7yf1v');\n\tsrc:url('#{$pe-7s-font-path}/Pe-icon-7-stroke.eot?#iefixd7yf1v') format('embedded-opentype'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.woff?d7yf1v') format('woff'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.ttf?d7yf1v') format('truetype'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.svg?d7yf1v#Pe-icon-7-stroke') format('svg');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n","[class^=\"#{$font-prefix}-\"], [class*=\" #{$font-prefix}-\"] {\n\tdisplay: inline-block;\n\tfont-family: 'Pe-icon-7-stroke';\n\tspeak: none;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-variant: normal;\n\ttext-transform: none;\n\tline-height: 1;\n\n\t/* Better Font Rendering =========== */\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n","\n/* HELPER CLASS\n * -------------------------- */\n\n/* FA based classes */\n\n/*! Modified from font-awesome helper CSS classes - PIXEDEN\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (CSS: MIT License)\n */\n\n/* makes the font 33% larger relative to the icon container */\n.pe-lg {\n  font-size: $font-size-base * 1.33;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.pe-2x {\n  font-size: 2 * $font-size-base;\n}\n\n.pe-3x {\n  font-size: 3 * $font-size-base;\n}\n\n.pe-4x {\n  font-size: 4 * $font-size-base;\n}\n\n.pe-5x {\n  font-size: 5 * $font-size-base;\n}\n\n.pe-fw {\n  width: 1.2857142857142858em;\n  text-align: center;\n}\n\n.pe-ul {\n  padding-left: 0;\n  margin-left: 2.142857142857143em;\n  list-style-type: none;\n  \n  & > li {\n    position: relative;\n  }\n}\n\n.pe-li {\n  position: absolute;\n  left: -2.142857142857143em;\n  width: 2.142857142857143em;\n  top: 0.14285714285714285em;\n  text-align: center;\n\n  &.pe-lg {\n    left: -1.8571428571428572em;\n  }\n}\n\n.pe-border {\n  padding: .2em .25em .15em;\n  border: solid 0.08em #eeeeee;\n  border-radius: .1em;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pe {\n  &.pull-left {\n    float: left;\n    margin-right: .3em;\n    margin-left: .3em;\n  }\n}\n\n.pe-spin {\n  animation: spin 2s infinite linear;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n\n.pe-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  transform: rotate(90deg);\n}\n\n.pe-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  transform: rotate(180deg);\n}\n\n.pe-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  transform: rotate(270deg);\n}\n\n.pe-flip-horizontal {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);\n  transform: scale(-1, 1);\n}\n\n.pe-flip-vertical {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);\n  transform: scale(1, -1);\n}\n\n.pe-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.pe-stack-1x,\n.pe-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.pe-stack-1x {\n  line-height: inherit;\n}\n\n.pe-stack-2x {\n  font-size: 2em;\n}\n\n.pe-inverse {\n  color: #ffffff;\n}\n\n/* Custom classes / mods - PIXEDEN */\n.pe-va {\n  vertical-align: middle;\n}\n\n.pe-border {\n  border: solid 0.08em #eaeaea;\n}\n",".#{$font-prefix}-album:before {\n  content: $font-var-album;\n}\n\n.#{$font-prefix}-arc:before {\n  content: $font-var-arc;\n}\n.#{$font-prefix}-back-2:before {\n  content: $font-var-back-2;\n}\n.#{$font-prefix}-bandaid:before {\n  content: $font-var-bandaid;\n}\n.#{$font-prefix}-car:before {\n  content: $font-var-car;\n}\n.#{$font-prefix}-diamond:before {\n  content: $font-var-diamond;\n}\n.#{$font-prefix}-door-lock:before {\n  content: $font-var-door-lock;\n}\n.#{$font-prefix}-eyedropper:before {\n  content: $font-var-eyedropper;\n}\n.#{$font-prefix}-female:before {\n  content: $font-var-female;\n}\n.#{$font-prefix}-gym:before {\n  content: $font-var-gym;\n}\n.#{$font-prefix}-hammer:before {\n  content: $font-var-hammer;\n}\n.#{$font-prefix}-headphones:before {\n  content: $font-var-headphones;\n}\n.#{$font-prefix}-helm:before {\n  content: $font-var-helm;\n}\n.#{$font-prefix}-hourglass:before {\n  content: $font-var-hourglass;\n}\n.#{$font-prefix}-leaf:before {\n  content: $font-var-leaf;\n}\n.#{$font-prefix}-magic-wand:before {\n  content: $font-var-magic-wand;\n}\n.#{$font-prefix}-male:before {\n  content: $font-var-male;\n}\n.#{$font-prefix}-map-2:before {\n  content: $font-var-map-2;\n}\n.#{$font-prefix}-next-2:before {\n  content: $font-var-next-2;\n}\n.#{$font-prefix}-paint-bucket:before {\n  content: $font-var-paint-bucket;\n}\n.#{$font-prefix}-pendrive:before {\n  content: $font-var-pendrive;\n}\n.#{$font-prefix}-photo:before {\n  content: $font-var-photo;\n}\n.#{$font-prefix}-piggy:before {\n  content: $font-var-piggy;\n}\n.#{$font-prefix}-plugin:before {\n  content: $font-var-plugin;\n}\n.#{$font-prefix}-refresh-2:before {\n  content: $font-var-refresh-2;\n}\n.#{$font-prefix}-rocket:before {\n  content: $font-var-rocket;\n}\n.#{$font-prefix}-settings:before {\n  content: $font-var-settings;\n}\n.#{$font-prefix}-shield:before {\n  content: $font-var-shield;\n}\n.#{$font-prefix}-smile:before {\n  content: $font-var-smile;\n}\n.#{$font-prefix}-usb:before {\n  content: $font-var-usb;\n}\n.#{$font-prefix}-vector:before {\n  content: $font-var-vector;\n}\n.#{$font-prefix}-wine:before {\n  content: $font-var-wine;\n}\n.#{$font-prefix}-cloud-upload:before {\n  content: $font-var-cloud-upload;\n}\n.#{$font-prefix}-cash:before {\n  content: $font-var-cash;\n}\n.#{$font-prefix}-close:before {\n  content: $font-var-close;\n}\n.#{$font-prefix}-bluetooth:before {\n  content: $font-var-bluetooth;\n}\n.#{$font-prefix}-cloud-download:before {\n  content: $font-var-cloud-download;\n}\n.#{$font-prefix}-way:before {\n  content: $font-var-way;\n}\n.#{$font-prefix}-close-circle:before {\n  content: $font-var-close-circle;\n}\n.#{$font-prefix}-id:before {\n  content: $font-var-id;\n}\n.#{$font-prefix}-angle-up:before {\n  content: $font-var-angle-up;\n}\n.#{$font-prefix}-wristwatch:before {\n  content: $font-var-wristwatch;\n}\n.#{$font-prefix}-angle-up-circle:before {\n  content: $font-var-angle-up-circle;\n}\n.#{$font-prefix}-world:before {\n  content: $font-var-world;\n}\n.#{$font-prefix}-angle-right:before {\n  content: $font-var-angle-right;\n}\n.#{$font-prefix}-volume:before {\n  content: $font-var-volume;\n}\n.#{$font-prefix}-angle-right-circle:before {\n  content: $font-var-angle-right-circle;\n}\n.#{$font-prefix}-users:before {\n  content: $font-var-users;\n}\n.#{$font-prefix}-angle-left:before {\n  content: $font-var-angle-left;\n}\n.#{$font-prefix}-user-female:before {\n  content: $font-var-user-female;\n}\n.#{$font-prefix}-angle-left-circle:before {\n  content: $font-var-angle-left-circle;\n}\n.#{$font-prefix}-up-arrow:before {\n  content: $font-var-up-arrow;\n}\n.#{$font-prefix}-angle-down:before {\n  content: $font-var-angle-down;\n}\n.#{$font-prefix}-switch:before {\n  content: $font-var-switch;\n}\n.#{$font-prefix}-angle-down-circle:before {\n  content: $font-var-angle-down-circle;\n}\n.#{$font-prefix}-scissors:before {\n  content: $font-var-scissors;\n}\n.#{$font-prefix}-wallet:before {\n  content: $font-var-wallet;\n}\n.#{$font-prefix}-safe:before {\n  content: $font-var-safe;\n}\n.#{$font-prefix}-volume2:before {\n  content: $font-var-volume2;\n}\n.#{$font-prefix}-volume1:before {\n  content: $font-var-volume1;\n}\n.#{$font-prefix}-voicemail:before {\n  content: $font-var-voicemail;\n}\n.#{$font-prefix}-video:before {\n  content: $font-var-video;\n}\n.#{$font-prefix}-user:before {\n  content: $font-var-user;\n}\n.#{$font-prefix}-upload:before {\n  content: $font-var-upload;\n}\n.#{$font-prefix}-unlock:before {\n  content: $font-var-unlock;\n}\n.#{$font-prefix}-umbrella:before {\n  content: $font-var-umbrella;\n}\n.#{$font-prefix}-trash:before {\n  content: $font-var-trash;\n}\n.#{$font-prefix}-tools:before {\n  content: $font-var-tools;\n}\n.#{$font-prefix}-timer:before {\n  content: $font-var-timer;\n}\n.#{$font-prefix}-ticket:before {\n  content: $font-var-ticket;\n}\n.#{$font-prefix}-target:before {\n  content: $font-var-target;\n}\n.#{$font-prefix}-sun:before {\n  content: $font-var-sun;\n}\n.#{$font-prefix}-study:before {\n  content: $font-var-study;\n}\n.#{$font-prefix}-stopwatch:before {\n  content: $font-var-stopwatch;\n}\n.#{$font-prefix}-star:before {\n  content: $font-var-star;\n}\n.#{$font-prefix}-speaker:before {\n  content: $font-var-speaker;\n}\n.#{$font-prefix}-signal:before {\n  content: $font-var-signal;\n}\n.#{$font-prefix}-shuffle:before {\n  content: $font-var-shuffle;\n}\n.#{$font-prefix}-shopbag:before {\n  content: $font-var-shopbag;\n}\n.#{$font-prefix}-share:before {\n  content: $font-var-share;\n}\n.#{$font-prefix}-server:before {\n  content: $font-var-server;\n}\n.#{$font-prefix}-search:before {\n  content: $font-var-search;\n}\n.#{$font-prefix}-film:before {\n  content: $font-var-film;\n}\n.#{$font-prefix}-science:before {\n  content: $font-var-science;\n}\n.#{$font-prefix}-disk:before {\n  content: $font-var-disk;\n}\n.#{$font-prefix}-ribbon:before {\n  content: $font-var-ribbon;\n}\n.#{$font-prefix}-repeat:before {\n  content: $font-var-repeat;\n}\n.#{$font-prefix}-refresh:before {\n  content: $font-var-refresh;\n}\n.#{$font-prefix}-add-user:before {\n  content: $font-var-add-user;\n}\n.#{$font-prefix}-refresh-cloud:before {\n  content: $font-var-refresh-cloud;\n}\n.#{$font-prefix}-paperclip:before {\n  content: $font-var-paperclip;\n}\n.#{$font-prefix}-radio:before {\n  content: $font-var-radio;\n}\n.#{$font-prefix}-note2:before {\n  content: $font-var-note2;\n}\n.#{$font-prefix}-print:before {\n  content: $font-var-print;\n}\n.#{$font-prefix}-network:before {\n  content: $font-var-network;\n}\n.#{$font-prefix}-prev:before {\n  content: $font-var-prev;\n}\n.#{$font-prefix}-mute:before {\n  content: $font-var-mute;\n}\n.#{$font-prefix}-power:before {\n  content: $font-var-power;\n}\n.#{$font-prefix}-medal:before {\n  content: $font-var-medal;\n}\n.#{$font-prefix}-portfolio:before {\n  content: $font-var-portfolio;\n}\n.#{$font-prefix}-like2:before {\n  content: $font-var-like2;\n}\n.#{$font-prefix}-plus:before {\n  content: $font-var-plus;\n}\n.#{$font-prefix}-left-arrow:before {\n  content: $font-var-left-arrow;\n}\n.#{$font-prefix}-play:before {\n  content: $font-var-play;\n}\n.#{$font-prefix}-key:before {\n  content: $font-var-key;\n}\n.#{$font-prefix}-plane:before {\n  content: $font-var-plane;\n}\n.#{$font-prefix}-joy:before {\n  content: $font-var-joy;\n}\n.#{$font-prefix}-photo-gallery:before {\n  content: $font-var-photo-gallery;\n}\n.#{$font-prefix}-pin:before {\n  content: $font-var-pin;\n}\n.#{$font-prefix}-phone:before {\n  content: $font-var-phone;\n}\n.#{$font-prefix}-plug:before {\n  content: $font-var-plug;\n}\n.#{$font-prefix}-pen:before {\n  content: $font-var-pen;\n}\n.#{$font-prefix}-right-arrow:before {\n  content: $font-var-right-arrow;\n}\n.#{$font-prefix}-paper-plane:before {\n  content: $font-var-paper-plane;\n}\n.#{$font-prefix}-delete-user:before {\n  content: $font-var-delete-user;\n}\n.#{$font-prefix}-paint:before {\n  content: $font-var-paint;\n}\n.#{$font-prefix}-bottom-arrow:before {\n  content: $font-var-bottom-arrow;\n}\n.#{$font-prefix}-notebook:before {\n  content: $font-var-notebook;\n}\n.#{$font-prefix}-note:before {\n  content: $font-var-note;\n}\n.#{$font-prefix}-next:before {\n  content: $font-var-next;\n}\n.#{$font-prefix}-news-paper:before {\n  content: $font-var-news-paper;\n}\n.#{$font-prefix}-musiclist:before {\n  content: $font-var-musiclist;\n}\n.#{$font-prefix}-music:before {\n  content: $font-var-music;\n}\n.#{$font-prefix}-mouse:before {\n  content: $font-var-mouse;\n}\n.#{$font-prefix}-more:before {\n  content: $font-var-more;\n}\n.#{$font-prefix}-moon:before {\n  content: $font-var-moon;\n}\n.#{$font-prefix}-monitor:before {\n  content: $font-var-monitor;\n}\n.#{$font-prefix}-micro:before {\n  content: $font-var-micro;\n}\n.#{$font-prefix}-menu:before {\n  content: $font-var-menu;\n}\n.#{$font-prefix}-map:before {\n  content: $font-var-map;\n}\n.#{$font-prefix}-map-marker:before {\n  content: $font-var-map-marker;\n}\n.#{$font-prefix}-mail:before {\n  content: $font-var-mail;\n}\n.#{$font-prefix}-mail-open:before {\n  content: $font-var-mail-open;\n}\n.#{$font-prefix}-mail-open-file:before {\n  content: $font-var-mail-open-file;\n}\n.#{$font-prefix}-magnet:before {\n  content: $font-var-magnet;\n}\n.#{$font-prefix}-loop:before {\n  content: $font-var-loop;\n}\n.#{$font-prefix}-look:before {\n  content: $font-var-look;\n}\n.#{$font-prefix}-lock:before {\n  content: $font-var-lock;\n}\n.#{$font-prefix}-lintern:before {\n  content: $font-var-lintern;\n}\n.#{$font-prefix}-link:before {\n  content: $font-var-link;\n}\n.#{$font-prefix}-like:before {\n  content: $font-var-like;\n}\n.#{$font-prefix}-light:before {\n  content: $font-var-light;\n}\n.#{$font-prefix}-less:before {\n  content: $font-var-less;\n}\n.#{$font-prefix}-keypad:before {\n  content: $font-var-keypad;\n}\n.#{$font-prefix}-junk:before {\n  content: $font-var-junk;\n}\n.#{$font-prefix}-info:before {\n  content: $font-var-info;\n}\n.#{$font-prefix}-home:before {\n  content: $font-var-home;\n}\n.#{$font-prefix}-help2:before {\n  content: $font-var-help2;\n}\n.#{$font-prefix}-help1:before {\n  content: $font-var-help1;\n}\n.#{$font-prefix}-graph3:before {\n  content: $font-var-graph3;\n}\n.#{$font-prefix}-graph2:before {\n  content: $font-var-graph2;\n}\n.#{$font-prefix}-graph1:before {\n  content: $font-var-graph1;\n}\n.#{$font-prefix}-graph:before {\n  content: $font-var-graph;\n}\n.#{$font-prefix}-global:before {\n  content: $font-var-global;\n}\n.#{$font-prefix}-gleam:before {\n  content: $font-var-gleam;\n}\n.#{$font-prefix}-glasses:before {\n  content: $font-var-glasses;\n}\n.#{$font-prefix}-gift:before {\n  content: $font-var-gift;\n}\n.#{$font-prefix}-folder:before {\n  content: $font-var-folder;\n}\n.#{$font-prefix}-flag:before {\n  content: $font-var-flag;\n}\n.#{$font-prefix}-filter:before {\n  content: $font-var-filter;\n}\n.#{$font-prefix}-file:before {\n  content: $font-var-file;\n}\n.#{$font-prefix}-expand1:before {\n  content: $font-var-expand1;\n}\n.#{$font-prefix}-exapnd2:before {\n  content: $font-var-exapnd2;\n}\n.#{$font-prefix}-edit:before {\n  content: $font-var-edit;\n}\n.#{$font-prefix}-drop:before {\n  content: $font-var-drop;\n}\n.#{$font-prefix}-drawer:before {\n  content: $font-var-drawer;\n}\n.#{$font-prefix}-download:before {\n  content: $font-var-download;\n}\n.#{$font-prefix}-display2:before {\n  content: $font-var-display2;\n}\n.#{$font-prefix}-display1:before {\n  content: $font-var-display1;\n}\n.#{$font-prefix}-diskette:before {\n  content: $font-var-diskette;\n}\n.#{$font-prefix}-date:before {\n  content: $font-var-date;\n}\n.#{$font-prefix}-cup:before {\n  content: $font-var-cup;\n}\n.#{$font-prefix}-culture:before {\n  content: $font-var-culture;\n}\n.#{$font-prefix}-crop:before {\n  content: $font-var-crop;\n}\n.#{$font-prefix}-credit:before {\n  content: $font-var-credit;\n}\n.#{$font-prefix}-copy-file:before {\n  content: $font-var-copy-file;\n}\n.#{$font-prefix}-config:before {\n  content: $font-var-config;\n}\n.#{$font-prefix}-compass:before {\n  content: $font-var-compass;\n}\n.#{$font-prefix}-comment:before {\n  content: $font-var-comment;\n}\n.#{$font-prefix}-coffee:before {\n  content: $font-var-coffee;\n}\n.#{$font-prefix}-cloud:before {\n  content: $font-var-cloud;\n}\n.#{$font-prefix}-clock:before {\n  content: $font-var-clock;\n}\n.#{$font-prefix}-check:before {\n  content: $font-var-check;\n}\n.#{$font-prefix}-chat:before {\n  content: $font-var-chat;\n}\n.#{$font-prefix}-cart:before {\n  content: $font-var-cart;\n}\n.#{$font-prefix}-camera:before {\n  content: $font-var-camera;\n}\n.#{$font-prefix}-call:before {\n  content: $font-var-call;\n}\n.#{$font-prefix}-calculator:before {\n  content: $font-var-calculator;\n}\n.#{$font-prefix}-browser:before {\n  content: $font-var-browser;\n}\n.#{$font-prefix}-box2:before {\n  content: $font-var-box2;\n}\n.#{$font-prefix}-box1:before {\n  content: $font-var-box1;\n}\n.#{$font-prefix}-bookmarks:before {\n  content: $font-var-bookmarks;\n}\n.#{$font-prefix}-bicycle:before {\n  content: $font-var-bicycle;\n}\n.#{$font-prefix}-bell:before {\n  content: $font-var-bell;\n}\n.#{$font-prefix}-battery:before {\n  content: $font-var-battery;\n}\n.#{$font-prefix}-ball:before {\n  content: $font-var-ball;\n}\n.#{$font-prefix}-back:before {\n  content: $font-var-back;\n}\n.#{$font-prefix}-attention:before {\n  content: $font-var-attention;\n}\n.#{$font-prefix}-anchor:before {\n  content: $font-var-anchor;\n}\n.#{$font-prefix}-albums:before {\n  content: $font-var-albums;\n}\n.#{$font-prefix}-alarm:before {\n  content: $font-var-alarm;\n}\n.#{$font-prefix}-airplay:before {\n  content: $font-var-airplay;\n}\n","$pe-7s-font-path: \"../fonts\" !default;\n$font-size-base: 1em !default;\n$font-prefix: \"pe-7s\" !default;\n\n$font-var-album: \"\\e6aa\";\n$font-var-arc: \"\\e6ab\";\n$font-var-back-2: \"\\e6ac\";\n$font-var-bandaid: \"\\e6ad\";\n$font-var-car: \"\\e6ae\";\n$font-var-diamond: \"\\e6af\";\n$font-var-door-lock: \"\\e6b0\";\n$font-var-eyedropper: \"\\e6b1\";\n$font-var-female: \"\\e6b2\";\n$font-var-gym: \"\\e6b3\";\n$font-var-hammer: \"\\e6b4\";\n$font-var-headphones: \"\\e6b5\";\n$font-var-helm: \"\\e6b6\";\n$font-var-hourglass: \"\\e6b7\";\n$font-var-leaf: \"\\e6b8\";\n$font-var-magic-wand: \"\\e6b9\";\n$font-var-male: \"\\e6ba\";\n$font-var-map-2: \"\\e6bb\";\n$font-var-next-2: \"\\e6bc\";\n$font-var-paint-bucket: \"\\e6bd\";\n$font-var-pendrive: \"\\e6be\";\n$font-var-photo: \"\\e6bf\";\n$font-var-piggy: \"\\e6c0\";\n$font-var-plugin: \"\\e6c1\";\n$font-var-refresh-2: \"\\e6c2\";\n$font-var-rocket: \"\\e6c3\";\n$font-var-settings: \"\\e6c4\";\n$font-var-shield: \"\\e6c5\";\n$font-var-smile: \"\\e6c6\";\n$font-var-usb: \"\\e6c7\";\n$font-var-vector: \"\\e6c8\";\n$font-var-wine: \"\\e6c9\";\n$font-var-cloud-upload: \"\\e68a\";\n$font-var-cash: \"\\e68c\";\n$font-var-close: \"\\e680\";\n$font-var-bluetooth: \"\\e68d\";\n$font-var-cloud-download: \"\\e68b\";\n$font-var-way: \"\\e68e\";\n$font-var-close-circle: \"\\e681\";\n$font-var-id: \"\\e68f\";\n$font-var-angle-up: \"\\e682\";\n$font-var-wristwatch: \"\\e690\";\n$font-var-angle-up-circle: \"\\e683\";\n$font-var-world: \"\\e691\";\n$font-var-angle-right: \"\\e684\";\n$font-var-volume: \"\\e692\";\n$font-var-angle-right-circle: \"\\e685\";\n$font-var-users: \"\\e693\";\n$font-var-angle-left: \"\\e686\";\n$font-var-user-female: \"\\e694\";\n$font-var-angle-left-circle: \"\\e687\";\n$font-var-up-arrow: \"\\e695\";\n$font-var-angle-down: \"\\e688\";\n$font-var-switch: \"\\e696\";\n$font-var-angle-down-circle: \"\\e689\";\n$font-var-scissors: \"\\e697\";\n$font-var-wallet: \"\\e600\";\n$font-var-safe: \"\\e698\";\n$font-var-volume2: \"\\e601\";\n$font-var-volume1: \"\\e602\";\n$font-var-voicemail: \"\\e603\";\n$font-var-video: \"\\e604\";\n$font-var-user: \"\\e605\";\n$font-var-upload: \"\\e606\";\n$font-var-unlock: \"\\e607\";\n$font-var-umbrella: \"\\e608\";\n$font-var-trash: \"\\e609\";\n$font-var-tools: \"\\e60a\";\n$font-var-timer: \"\\e60b\";\n$font-var-ticket: \"\\e60c\";\n$font-var-target: \"\\e60d\";\n$font-var-sun: \"\\e60e\";\n$font-var-study: \"\\e60f\";\n$font-var-stopwatch: \"\\e610\";\n$font-var-star: \"\\e611\";\n$font-var-speaker: \"\\e612\";\n$font-var-signal: \"\\e613\";\n$font-var-shuffle: \"\\e614\";\n$font-var-shopbag: \"\\e615\";\n$font-var-share: \"\\e616\";\n$font-var-server: \"\\e617\";\n$font-var-search: \"\\e618\";\n$font-var-film: \"\\e6a5\";\n$font-var-science: \"\\e619\";\n$font-var-disk: \"\\e6a6\";\n$font-var-ribbon: \"\\e61a\";\n$font-var-repeat: \"\\e61b\";\n$font-var-refresh: \"\\e61c\";\n$font-var-add-user: \"\\e6a9\";\n$font-var-refresh-cloud: \"\\e61d\";\n$font-var-paperclip: \"\\e69c\";\n$font-var-radio: \"\\e61e\";\n$font-var-note2: \"\\e69d\";\n$font-var-print: \"\\e61f\";\n$font-var-network: \"\\e69e\";\n$font-var-prev: \"\\e620\";\n$font-var-mute: \"\\e69f\";\n$font-var-power: \"\\e621\";\n$font-var-medal: \"\\e6a0\";\n$font-var-portfolio: \"\\e622\";\n$font-var-like2: \"\\e6a1\";\n$font-var-plus: \"\\e623\";\n$font-var-left-arrow: \"\\e6a2\";\n$font-var-play: \"\\e624\";\n$font-var-key: \"\\e6a3\";\n$font-var-plane: \"\\e625\";\n$font-var-joy: \"\\e6a4\";\n$font-var-photo-gallery: \"\\e626\";\n$font-var-pin: \"\\e69b\";\n$font-var-phone: \"\\e627\";\n$font-var-plug: \"\\e69a\";\n$font-var-pen: \"\\e628\";\n$font-var-right-arrow: \"\\e699\";\n$font-var-paper-plane: \"\\e629\";\n$font-var-delete-user: \"\\e6a7\";\n$font-var-paint: \"\\e62a\";\n$font-var-bottom-arrow: \"\\e6a8\";\n$font-var-notebook: \"\\e62b\";\n$font-var-note: \"\\e62c\";\n$font-var-next: \"\\e62d\";\n$font-var-news-paper: \"\\e62e\";\n$font-var-musiclist: \"\\e62f\";\n$font-var-music: \"\\e630\";\n$font-var-mouse: \"\\e631\";\n$font-var-more: \"\\e632\";\n$font-var-moon: \"\\e633\";\n$font-var-monitor: \"\\e634\";\n$font-var-micro: \"\\e635\";\n$font-var-menu: \"\\e636\";\n$font-var-map: \"\\e637\";\n$font-var-map-marker: \"\\e638\";\n$font-var-mail: \"\\e639\";\n$font-var-mail-open: \"\\e63a\";\n$font-var-mail-open-file: \"\\e63b\";\n$font-var-magnet: \"\\e63c\";\n$font-var-loop: \"\\e63d\";\n$font-var-look: \"\\e63e\";\n$font-var-lock: \"\\e63f\";\n$font-var-lintern: \"\\e640\";\n$font-var-link: \"\\e641\";\n$font-var-like: \"\\e642\";\n$font-var-light: \"\\e643\";\n$font-var-less: \"\\e644\";\n$font-var-keypad: \"\\e645\";\n$font-var-junk: \"\\e646\";\n$font-var-info: \"\\e647\";\n$font-var-home: \"\\e648\";\n$font-var-help2: \"\\e649\";\n$font-var-help1: \"\\e64a\";\n$font-var-graph3: \"\\e64b\";\n$font-var-graph2: \"\\e64c\";\n$font-var-graph1: \"\\e64d\";\n$font-var-graph: \"\\e64e\";\n$font-var-global: \"\\e64f\";\n$font-var-gleam: \"\\e650\";\n$font-var-glasses: \"\\e651\";\n$font-var-gift: \"\\e652\";\n$font-var-folder: \"\\e653\";\n$font-var-flag: \"\\e654\";\n$font-var-filter: \"\\e655\";\n$font-var-file: \"\\e656\";\n$font-var-expand1: \"\\e657\";\n$font-var-exapnd2: \"\\e658\";\n$font-var-edit: \"\\e659\";\n$font-var-drop: \"\\e65a\";\n$font-var-drawer: \"\\e65b\";\n$font-var-download: \"\\e65c\";\n$font-var-display2: \"\\e65d\";\n$font-var-display1: \"\\e65e\";\n$font-var-diskette: \"\\e65f\";\n$font-var-date: \"\\e660\";\n$font-var-cup: \"\\e661\";\n$font-var-culture: \"\\e662\";\n$font-var-crop: \"\\e663\";\n$font-var-credit: \"\\e664\";\n$font-var-copy-file: \"\\e665\";\n$font-var-config: \"\\e666\";\n$font-var-compass: \"\\e667\";\n$font-var-comment: \"\\e668\";\n$font-var-coffee: \"\\e669\";\n$font-var-cloud: \"\\e66a\";\n$font-var-clock: \"\\e66b\";\n$font-var-check: \"\\e66c\";\n$font-var-chat: \"\\e66d\";\n$font-var-cart: \"\\e66e\";\n$font-var-camera: \"\\e66f\";\n$font-var-call: \"\\e670\";\n$font-var-calculator: \"\\e671\";\n$font-var-browser: \"\\e672\";\n$font-var-box2: \"\\e673\";\n$font-var-box1: \"\\e674\";\n$font-var-bookmarks: \"\\e675\";\n$font-var-bicycle: \"\\e676\";\n$font-var-bell: \"\\e677\";\n$font-var-battery: \"\\e678\";\n$font-var-ball: \"\\e679\";\n$font-var-back: \"\\e67a\";\n$font-var-attention: \"\\e67b\";\n$font-var-anchor: \"\\e67c\";\n$font-var-albums: \"\\e67d\";\n$font-var-alarm: \"\\e67e\";\n$font-var-airplay: \"\\e67f\";\n","%triangle-arrow {\n  margin-left: -$datepicker__triangle-size;\n  position: absolute;\n\n  &,\n  &::before {\n    box-sizing: content-box;\n    position: absolute;\n    border: $datepicker__triangle-size solid transparent;\n\n    height: 0;\n    width: 1px;\n  }\n\n  &::before {\n    content: \"\";\n    z-index: -1;\n    border-width: $datepicker__triangle-size;\n\n    left: -$datepicker__triangle-size;\n    border-bottom-color: $datepicker__border-color;\n  }\n}\n\n%triangle-arrow-up {\n  @extend %triangle-arrow;\n\n  top: 0;\n  margin-top: -$datepicker__triangle-size;\n\n  &,\n  &::before {\n    border-top: none;\n    border-bottom-color: $datepicker__background-color;\n  }\n\n  &::before {\n    top: -1px;\n    border-bottom-color: $datepicker__border-color;\n  }\n}\n\n%triangle-arrow-down {\n  @extend %triangle-arrow;\n\n  bottom: 0;\n  margin-bottom: -$datepicker__triangle-size;\n\n  &,\n  &::before {\n    border-bottom: none;\n    border-top-color: #fff;\n  }\n\n  &::before {\n    bottom: -1px;\n    border-top-color: $datepicker__border-color;\n  }\n}\n","// Datepicker\n\n$datepicker__background-color: $white;\n$datepicker__border-color: $gray-300;\n$datepicker__highlighted-color: $primary;\n$datepicker__muted-color: $gray-400;\n$datepicker__selected-color: theme-color(\"primary\");\n$datepicker__text-color: $gray-700;\n$datepicker__header-color: $gray-800;\n$datepicker__navigation-disabled-color: darken($datepicker__muted-color, 5%)\n;\n\n$datepicker__border-radius: $border-radius;\n$datepicker__day-margin: 0.166rem;\n$datepicker__font-size: $font-size-base;\n$datepicker__font-family: $font-size-base;\n$datepicker__item-size: 2rem;\n$datepicker__margin: 0.5rem;\n$datepicker__navigation-size: 0.35rem;\n$datepicker__triangle-size: 6px;","@import \"variables\";\n@import \"mixins\";\n\n.react-datepicker-wrapper {\n  display: block;\n  z-index: 100;\n}\n\n.react-datepicker {\n  background-color: $white;\n  color: $datepicker__text-color;\n  border: 1px solid $datepicker__border-color;\n  border-radius: $datepicker__border-radius;\n  display: inline-block;\n  position: relative;\n\n  box-shadow: $box-shadow-default;\n}\n\n.react-datepicker--time-only {\n  .react-datepicker__triangle {\n    left: 35px;\n  }\n\n  .react-datepicker__time-container {\n    border-left: 0;\n  }\n\n  .react-datepicker__time {\n    border-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-box {\n    border-radius: 0.3rem;\n  }\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 102;\n\n  &[data-placement^=\"bottom\"] {\n    margin-top: $datepicker__triangle-size + 2px;\n\n    .react-datepicker__triangle {\n      @extend %triangle-arrow-up;\n    }\n  }\n\n  &[data-placement^=\"top\"] {\n    margin-bottom: $datepicker__triangle-size + 2px;\n\n    .react-datepicker__triangle {\n      @extend %triangle-arrow-down;\n    }\n  }\n\n  &[data-placement^=\"right\"] {\n    margin-left: $datepicker__triangle-size;\n\n    .react-datepicker__triangle {\n      left: auto;\n      right: 42px;\n    }\n  }\n\n  &[data-placement^=\"left\"] {\n    margin-right: $datepicker__triangle-size;\n\n    .react-datepicker__triangle {\n      left: 42px;\n      right: auto;\n    }\n  }\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: $datepicker__background-color;\n  border-bottom: 1px solid $datepicker__border-color;\n  border-top-left-radius: $datepicker__border-radius;\n  border-top-right-radius: $datepicker__border-radius;\n  padding-top: 10px;\n  position: relative;\n\n  &--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header {\n  margin-top: 0;\n  color: $datepicker__header-color;\n  font-weight: bold;\n  font-size: $datepicker__font-size * 1.1;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: $datepicker__item-size;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 15px;\n  padding: 0;\n  border: $datepicker__navigation-size solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n\n  &--previous {\n    left: 10px;\n    border-right-color: $datepicker__muted-color;\n\n    &:hover {\n      border-right-color: darken($datepicker__muted-color, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-right-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n\n  &--next {\n    right: 10px;\n    border-left-color: $datepicker__muted-color;\n\n    &--with-time:not(&--with-today-button) {\n      right: 80px;\n    }\n\n    &:hover {\n      border-left-color: darken($datepicker__muted-color, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-left-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n\n  &--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &-previous {\n      top: 4px;\n      border-top-color: $datepicker__muted-color;\n\n      &:hover {\n        border-top-color: darken($datepicker__muted-color, 10%);\n      }\n    }\n\n    &-upcoming {\n      top: -4px;\n      border-bottom-color: $datepicker__muted-color;\n\n      &:hover {\n        border-bottom-color: darken($datepicker__muted-color, 10%);\n      }\n    }\n  }\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__month {\n  margin: $datepicker__margin;\n  text-align: center;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid $datepicker__border-color;\n  width: 120px;\n\n  &--with-today-button {\n    display: inline;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -122px;\n    top: 0;\n  }\n\n  .react-datepicker__time {\n    position: relative;\n    background: white;\n\n    .react-datepicker__time-box {\n      width: 120px;\n      overflow-x: hidden;\n      margin: 0 auto;\n      text-align: center;\n\n      ul.react-datepicker__time-list {\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        height: calc(195px + (#{$datepicker__item-size} / 2));\n        overflow-y: scroll;\n        width: 100%;\n        box-sizing: content-box;\n\n        li.react-datepicker__time-list-item {\n          padding: 5px 10px;\n\n          &:hover {\n            cursor: pointer;\n            background-color: $dropdown-link-hover-bg;\n          }\n\n          &--selected {\n            background-color: $datepicker__selected-color;\n            color: $white;\n            font-weight: bold;\n\n            &:hover {\n              background-color: $datepicker__selected-color;\n            }\n          }\n\n          &--disabled {\n            color: $datepicker__muted-color;\n\n            &:hover {\n              cursor: default;\n              background-color: transparent;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.react-datepicker__week-number {\n  color: $datepicker__muted-color;\n  display: inline-block;\n  width: $datepicker__item-size;\n  line-height: $datepicker__item-size;\n  text-align: center;\n  margin: $datepicker__day-margin;\n\n  &.react-datepicker__week-number--clickable {\n    cursor: pointer;\n\n    &:hover {\n      border-radius: $datepicker__border-radius;\n      background-color: $datepicker__background-color;\n    }\n  }\n}\n\n.react-datepicker__day-names {\n  background: $gray-100;\n  border-top: $gray-300 solid 1px;\n  margin-top: 10px;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: $datepicker__text-color;\n  display: inline-block;\n  width: $datepicker__item-size;\n  line-height: $datepicker__item-size;\n  text-align: center;\n  margin: $datepicker__day-margin;\n}\n\n.react-datepicker__day {\n  cursor: pointer;\n  @include border-radius($datepicker__border-radius);\n\n  &:hover {\n    background-color: $primary;\n    color: $white;\n  }\n\n  &--today {\n    font-weight: bold;\n  }\n\n  &--highlighted {\n    border-radius: $datepicker__border-radius;\n    background-color: $datepicker__highlighted-color;\n    color: $white;\n\n    &:hover {\n      background-color: darken($datepicker__highlighted-color, 5%);\n    }\n\n    &-custom-1 {\n      color: $warning;\n    }\n\n    &-custom-2 {\n      color: $focus;\n    }\n  }\n\n  &--selected {\n    background-color: $success;\n    color: $white;\n\n    &:hover {\n      background-color: $success;\n      color: $white;\n    }\n  }\n\n  &--in-selecting-range,\n  &--in-range {\n    background-color: $dropdown-link-hover-bg;\n    color: $dropdown-link-hover-color;\n\n    &:hover {\n      background-color: $dropdown-link-hover-bg;\n      color: $dropdown-link-hover-color;\n    }\n\n  }\n\n  &--keyboard-selected {\n    border-radius: $datepicker__border-radius;\n    background-color: lighten($success, 10%);\n    color: $white;\n\n    &:hover {\n      background-color: darken($success, 5%);\n    }\n  }\n\n  &--in-selecting-range:not(&--in-range) {\n    background-color: $dropdown-link-hover-bg;\n  }\n\n  &--in-range:not(&--in-selecting-range) {\n    .react-datepicker__month--selecting-range & {\n      background-color: $success;\n      color: $white;\n    }\n  }\n\n  &--disabled {\n    cursor: default;\n    color: $datepicker__muted-color;\n\n    &:hover {\n      background-color: transparent;\n      color: $datepicker__muted-color;\n    }\n  }\n}\n\n\n.react-datepicker__day--selecting-range-start,\n.react-datepicker__day--selecting-range-end {\n  background-color: $success !important;\n  color: $white !important;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: $datepicker__border-radius;\n\n  &:hover {\n    cursor: pointer;\n\n    .react-datepicker__year-read-view--down-arrow,\n    .react-datepicker__month-read-view--down-arrow {\n      border-top-color: darken($datepicker__muted-color, 10%);\n    }\n  }\n\n  &--down-arrow {\n    @extend %triangle-arrow-down;\n    border-top-color: $datepicker__muted-color;\n    float: right;\n    margin-left: 20px;\n    top: 8px;\n    position: relative;\n    border-width: $datepicker__navigation-size;\n  }\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: $datepicker__background-color;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: $datepicker__border-radius;\n  border: 1px solid $datepicker__border-color;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n  }\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n\n  &:first-of-type {\n    border-top-left-radius: $datepicker__border-radius;\n    border-top-right-radius: $datepicker__border-radius;\n  }\n\n  &:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: $datepicker__border-radius;\n    border-bottom-right-radius: $datepicker__border-radius;\n  }\n\n  &:hover {\n    background-color: $datepicker__muted-color;\n\n    .react-datepicker__navigation--years-upcoming {\n      border-bottom-color: darken($datepicker__muted-color, 10%);\n    }\n\n    .react-datepicker__navigation--years-previous {\n      border-top-color: darken($datepicker__muted-color, 10%);\n    }\n  }\n\n  &--selected {\n    position: absolute;\n    left: 15px;\n  }\n}\n\n.react-datepicker__close-icon {\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 25%;\n  right: 7px;\n\n  &::after {\n    background-color: $datepicker__selected-color;\n    border-radius: 50%;\n    bottom: 0;\n    box-sizing: border-box;\n    color: $white;\n    content: \"\\00d7\";\n    cursor: pointer;\n    font-size: 12px;\n    height: 16px;\n    width: 16px;\n    line-height: 1;\n    margin: -8px auto 0;\n    padding: 2px;\n    position: absolute;\n    right: 0px;\n    text-align: center;\n  }\n}\n\n.react-datepicker__today-button {\n  background: $datepicker__background-color;\n  border-top: 1px solid $datepicker__border-color;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  z-index: $zindex-modal-backdrop;\n  background-color: rgba($modal-backdrop-bg, $modal-backdrop-opacity);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n  }\n\n  // Resize for small screens\n  @media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__day-name,\n    .react-datepicker__day,\n    .react-datepicker__time-name {\n      width: 2rem;\n      line-height: 2rem;\n    }\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-time__header {\n    font-size: $datepicker__font-size * 1.8;\n  }\n\n  .react-datepicker__navigation {\n    border: 1.8 * $datepicker__navigation-size solid transparent;\n    margin-top: 3px;\n  }\n\n  .react-datepicker__navigation--previous {\n    border-right-color: $primary;\n\n    &:hover {\n      border-right-color: darken($primary, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-right-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n\n  .react-datepicker__navigation--next {\n    border-left-color: $primary;\n\n    &:hover {\n      border-left-color: darken($primary, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-left-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n}\n\n.rangeButtonSelectedStyle {\n  background: $primary !important;\n}\n\n.rangebuttonstyle {\n  outline: none !important;\n  color: $primary !important;\n}",".rc-slider-tooltip {\n  z-index: 555;\n}\n\n.rc-tooltip.rc-tooltip-zoom-enter,\n.rc-tooltip.rc-tooltip-zoom-leave {\n  display: block;\n}\n\n.rc-tooltip-zoom-enter,\n.rc-tooltip-zoom-appear {\n  opacity: 0;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,\n.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {\n  animation-name: rcToolTipZoomIn;\n  animation-play-state: running;\n}\n\n.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {\n  animation-name: rcToolTipZoomOut;\n  animation-play-state: running;\n}\n\n@keyframes rcToolTipZoomIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n}\n\n@keyframes rcToolTipZoomOut {\n  0% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n}\n\n.rc-tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  visibility: visible;\n  font-size: 12px;\n  line-height: 1.5;\n  opacity: 0.9;\n}\n\n.rc-tooltip-hidden {\n  display: none;\n}\n\n.rc-tooltip-placement-top,\n.rc-tooltip-placement-topLeft,\n.rc-tooltip-placement-topRight {\n  padding: 5px 0 9px 0;\n}\n\n.rc-tooltip-placement-right,\n.rc-tooltip-placement-rightTop,\n.rc-tooltip-placement-rightBottom {\n  padding: 0 5px 0 9px;\n}\n\n.rc-tooltip-placement-bottom,\n.rc-tooltip-placement-bottomLeft,\n.rc-tooltip-placement-bottomRight {\n  padding: 9px 0 5px 0;\n}\n\n.rc-tooltip-placement-left,\n.rc-tooltip-placement-leftTop,\n.rc-tooltip-placement-leftBottom {\n  padding: 0 9px 0 5px;\n}\n\n.rc-tooltip-inner {\n  padding: 12px 14px;\n  color: $white;\n  text-align: left;\n  text-decoration: none;\n  background-color: $gray-800;\n  border-radius: 6px;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);\n  min-height: 34px;\n  font-weight: bold;\n}\n\n.rc-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow,\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  bottom: 4px;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: $gray-800;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  right: 15%;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow,\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow,\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  left: 4px;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: $gray-800;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow,\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow,\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  right: 4px;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: $gray-800;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  top: 4px;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: $gray-800;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  right: 15%;\n}\n","@import 'tooltip';\n\n.rc-slider {\n  position: relative;\n  height: 20px;\n  padding: 8px 0 0;\n  width: 100%;\n  @include border-radius($border-radius);\n  -ms-touch-action: none;\n  touch-action: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  background-color: $gray-200;\n  height: 4px;\n  @include border-radius($border-radius);\n}\n\n.rc-slider-track {\n  position: absolute;\n  left: 0;\n  height: 4px;\n  @include border-radius($border-radius);\n  background-color: $primary;\n}\n\n.rc-slider-handle {\n  position: absolute;\n  margin-left: -8px;\n  margin-top: -6px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  cursor: grab;\n  border-radius: 50%;\n  border: solid 2px $primary;\n  background-color: $white;\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n  transition: box-shadow 200ms;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus,\n  &:active,\n  &:hover {\n    border-color: darken($primary, 15%);\n    box-shadow: 0 0.46875rem 2.1875rem rgba($primary, .8),\n    0 0.125rem 0.5875rem rgba($primary, .9);\n  }\n\n  &:active {\n    cursor: -webkit-grabbing;\n    cursor: grabbing;\n  }\n}\n\n.rc-slider-mark {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  width: 100%;\n  font-size: 12px;\n}\n\n.rc-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  color: $gray-600;\n}\n\n.rc-slider-mark-text-active {\n  color: $gray-800;\n}\n\n.rc-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n\n.rc-slider-dot {\n  position: absolute;\n  bottom: -2px;\n  margin-left: -4px;\n  width: 8px;\n  height: 8px;\n  border: 2px solid $gray-300;\n  background-color: $white;\n  cursor: pointer;\n  border-radius: 50%;\n  vertical-align: middle;\n}\n\n.rc-slider-dot-active {\n  border-color: $primary;\n}\n\n.rc-slider-disabled {\n  background-color: $gray-200;\n}\n\n.rc-slider-disabled .rc-slider-track {\n  background-color: $gray-400;\n}\n\n.rc-slider-disabled .rc-slider-handle,\n.rc-slider-disabled .rc-slider-dot {\n  border-color: $gray-400;\n  box-shadow: none;\n  background-color: $white;\n  cursor: not-allowed;\n}\n\n.rc-slider-disabled .rc-slider-mark-text,\n.rc-slider-disabled .rc-slider-dot {\n  cursor: not-allowed !important;\n}\n\n.rc-slider-vertical {\n  width: 14px;\n  height: 100%;\n  padding: 0 5px;\n}\n\n.rc-slider-vertical .rc-slider-rail {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-track {\n  left: 5px;\n  bottom: 0;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-handle {\n  margin-left: -6px;\n  margin-bottom: -7px;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n\n.rc-slider-vertical .rc-slider-mark {\n  top: 0;\n  left: 18px;\n  height: 100%;\n}\n\n.rc-slider-vertical .rc-slider-step {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-dot {\n  left: 2px;\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:first-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:last-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  animation-duration: .3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-duration: .3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n  animation-name: rcSliderTooltipZoomDownIn;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n  animation-name: rcSliderTooltipZoomDownOut;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  transform: scale(0, 0);\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n\n@keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n  100% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n}\n\n@keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n}\n\n.rc-slider-tooltip {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  visibility: visible;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-tooltip-hidden {\n  display: none;\n}\n\n.rc-slider-tooltip-placement-top {\n  padding: 4px 0 8px 0;\n}\n\n.rc-slider-tooltip-inner {\n  padding: 0 8px;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  color: $white;\n  text-align: center;\n  text-decoration: none;\n  background-color: $gray-900;\n  @include border-radius($border-radius);\n  box-shadow: $box-shadow-default;\n  font-weight: bold;\n}\n\n.rc-slider-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  bottom: 4px;\n  left: 50%;\n  margin-left: -4px;\n  border-width: 4px 4px 0;\n  border-top-color: $gray-900;\n}\n\n// Colors\n\n@each $color, $value in $theme-colors {\n  .rc-slider-#{$color} {\n    .rc-slider-track {\n      background-color: $value;\n    }\n\n    .rc-slider-handle {\n      border-color: $value;\n      background-color: $white;\n\n      &:focus,\n      &:active,\n      &:hover {\n        border-color: darken($value, 15%);\n        box-shadow: 0 0.46875rem 2.1875rem rgba($value, .8),\n        0 0.125rem 0.5875rem rgba($value, .9);\n      }\n    }\n\n    .rc-slider-dot-active {\n      border-color: $value;\n    }\n  }\n}\n\n// Alternate Styles\n\n.rc-slider-line {\n  .rc-slider-handle {\n    @include border-radius(0);\n    border-width: 0 3px 0 0;\n    margin-left: -8px;\n    width: 10px;\n    background-color: transparent;\n    box-shadow: 0 0 0 transparent !important;\n  }\n}\n\n.rc-slider-square {\n  .rc-slider-handle {\n    @include border-radius(3px);\n    border-widtH: 1px;\n\n    &:before {\n      position: absolute;\n      height: 8px;\n      width: 4px;\n      border: $gray-500 solid 1px;\n      border-width: 0 1px;\n      display: block;\n      content: '';\n      top: 50%;\n      left: 50%;\n      margin: -4px -2px;\n    }\n  }\n}\n\n// Sizing\n\n.rc-slider-lg {\n  &.rc-slider {\n    height: 20px;\n    padding: 8px 0 0;\n  }\n\n  .rc-slider-rail {\n    height: 4px;\n  }\n\n  .rc-slider-track {\n    height: 4px;\n  }\n\n  .rc-slider-handle {\n    margin-left: -10px;\n    margin-top: -8px;\n    width: 20px;\n    height: 20px;\n  }\n\n  &.rc-slider-line {\n    .rc-slider-handle {\n      margin-left: -8px;\n      width: 10px;\n    }\n  }\n\n  &.rc-slider-square {\n    .rc-slider-handle {\n      &:before {\n        height: 10px;\n        width: 6px;\n        margin: -5px -3px;\n      }\n    }\n  }\n\n}\n\n.rc-slider-sm {\n  &.rc-slider {\n    height: 20px;\n    padding: 8px 0 0;\n  }\n\n  .rc-slider-rail {\n    height: 4px;\n  }\n\n  .rc-slider-track {\n    height: 4px;\n  }\n\n  .rc-slider-handle {\n    margin-left: -6px;\n    margin-top: -4px;\n    width: 12px;\n    height: 12px;\n  }\n\n  &.rc-slider-line {\n    .rc-slider-handle {\n      margin-left: -8px;\n      width: 10px;\n    }\n  }\n\n  &.rc-slider-square {\n    .rc-slider-handle {\n      &:before {\n        height: 6px;\n        margin: -3px 0 0 -1px;\n        border: 0;\n        width: 2px;\n        background: $gray-500;\n      }\n    }\n  }\n}\n\n",".rdw-option-wrapper {\n  border: 1px solid #F1F1F1;\n  padding: 5px;\n  min-width: 25px;\n  height: 20px;\n  border-radius: 2px;\n  margin: 0 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.rdw-option-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.rdw-option-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-option-active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-option-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n.rdw-dropdown-wrapper {\n  height: 30px;\n  background: white;\n  cursor: pointer;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  margin: 0 3px;\n  text-transform: capitalize;\n  background: white;\n}\n.rdw-dropdown-wrapper:focus {\n  outline: none;\n}\n.rdw-dropdown-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n.rdw-dropdown-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-dropdown-carettoopen {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-top: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n.rdw-dropdown-carettoclose {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-bottom: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n.rdw-dropdown-selectedtext {\n  display: flex;\n  position: relative;\n  height: 100%;\n  align-items: center;\n  padding: 0 5px;\n}\n.rdw-dropdown-optionwrapper {\n  z-index: 100;\n  position: relative;\n  border: 1px solid #F1F1F1;\n  width: 98%;\n  background: white;\n  border-radius: 2px;\n  margin: 0;\n  padding: 0;\n  max-height: 250px;\n  overflow-y: scroll;\n}\n.rdw-dropdown-optionwrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n.rdw-dropdownoption-default {\n  min-height: 25px;\n  display: flex;\n  align-items: center;\n  padding: 0 5px;\n}\n.rdw-dropdownoption-highlighted {\n  background: #F1F1F1;\n}\n.rdw-dropdownoption-active {\n  background: #f5f5f5;\n}\n.rdw-dropdownoption-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n.rdw-inline-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-inline-dropdown {\n  width: 50px;\n}\n.rdw-inline-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-block-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-block-dropdown {\n  width: 110px;\n}\n.rdw-fontsize-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-fontsize-dropdown {\n  min-width: 40px;\n}\n.rdw-fontsize-option {\n  display: flex;\n  justify-content: center;\n}\n.rdw-fontfamily-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-fontfamily-dropdown {\n  width: 115px;\n}\n.rdw-fontfamily-placeholder {\n  white-space: nowrap;\n  max-width: 90px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rdw-fontfamily-optionwrapper {\n  width: 140px;\n}\n.rdw-list-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-list-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n.rdw-list-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-text-align-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-text-align-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n.rdw-text-align-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-right-aligned-block {\n  text-align: right;\n}\n.rdw-left-aligned-block {\n  text-align: left !important;\n}\n.rdw-center-aligned-block {\n  text-align: center !important;\n}\n.rdw-justify-aligned-block {\n  text-align: justify !important;\n}\n.rdw-right-aligned-block > div {\n  display: inline-block;\n}\n.rdw-left-aligned-block > div {\n  display: inline-block;\n}\n.rdw-center-aligned-block > div {\n  display: inline-block;\n}\n.rdw-justify-aligned-block > div {\n  display: inline-block;\n}\n.rdw-colorpicker-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-colorpicker-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 175px;\n  height: 175px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-colorpicker-modal-header {\n  display: flex;\n  padding-bottom: 5px;\n}\n.rdw-colorpicker-modal-style-label {\n  font-size: 15px;\n  width: 50%;\n  text-align: center;\n  cursor: pointer;\n  padding: 0 10px 5px;\n}\n.rdw-colorpicker-modal-style-label-active {\n  border-bottom: 2px solid #0a66b7;\n}\n.rdw-colorpicker-modal-options {\n  margin: 5px auto;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  overflow: scroll;\n}\n.rdw-colorpicker-cube {\n  width: 22px;\n  height: 22px;\n  border: 1px solid #F1F1F1;\n}\n.rdw-colorpicker-option {\n  margin: 3px;\n  padding: 0;\n  min-height: 20px;\n  border: none;\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  box-shadow: 1px 2px 1px #BFBDBD inset;\n}\n.rdw-colorpicker-option:hover {\n  box-shadow: 1px 2px 1px #BFBDBD;\n}\n.rdw-colorpicker-option:active {\n  box-shadow: -1px -2px 1px #BFBDBD;\n}\n.rdw-colorpicker-option-active {\n  box-shadow: 0px 0px 2px 2px #BFBDBD;\n}\n.rdw-link-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-link-dropdown {\n  width: 50px;\n}\n.rdw-link-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-link-dropdownPlaceholder {\n  margin-left: 8px;\n}\n.rdw-link-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 205px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-link-modal-label {\n  font-size: 15px;\n}\n.rdw-link-modal-input {\n  margin-top: 5px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  height: 25px;\n  margin-bottom: 15px;\n  padding: 0 5px;\n}\n.rdw-link-modal-input:focus {\n  outline: none;\n}\n.rdw-link-modal-buttonsection {\n  margin: 0 auto;\n}\n.rdw-link-modal-target-option {\n  margin-bottom: 20px;\n}\n.rdw-link-modal-target-option > span {\n  margin-left: 5px;\n}\n.rdw-link-modal-btn {\n  margin-left: 10px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.rdw-link-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.rdw-link-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-link-modal-btn:focus {\n  outline: none !important;\n}\n.rdw-link-modal-btn:disabled {\n  background: #ece9e9;\n}\n.rdw-link-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-history-dropdown {\n  width: 50px;\n}\n.rdw-embedded-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-embedded-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  justify-content: space-between;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-embedded-modal-header {\n  font-size: 15px;\n  display: flex;\n}\n.rdw-embedded-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.rdw-embedded-modal-header-label {\n  width: 95px;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n.rdw-embedded-modal-link-section {\n  display: flex;\n  flex-direction: column;\n}\n.rdw-embedded-modal-link-input {\n  width: 88%;\n  height: 35px;\n  margin: 10px 0;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n.rdw-embedded-modal-link-input-wrapper {\n  display: flex;\n  align-items: center;\n}\n.rdw-embedded-modal-link-input:focus {\n  outline: none;\n}\n.rdw-embedded-modal-btn-section {\n  display: flex;\n  justify-content: center;\n}\n.rdw-embedded-modal-btn {\n  margin: 0 3px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.rdw-embedded-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.rdw-embedded-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-embedded-modal-btn:focus {\n  outline: none !important;\n}\n.rdw-embedded-modal-btn:disabled {\n  background: #ece9e9;\n}\n.rdw-embedded-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n.rdw-embedded-modal-size-input {\n  width: 80%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n.rdw-embedded-modal-size-input:focus {\n  outline: none;\n}\n.rdw-emoji-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-emoji-modal {\n  overflow: auto;\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-emoji-icon {\n  margin: 2.5px;\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n  font-size: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.rdw-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n.rdw-spinner > div {\n  width: 12px;\n  height: 12px;\n  background-color: #333;\n\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n.rdw-spinner .rdw-bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n.rdw-spinner .rdw-bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n@-webkit-keyframes sk-bouncedelay {\n  0%, 80%, 100% { -webkit-transform: scale(0) }\n  40% { -webkit-transform: scale(1.0) }\n}\n@keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  } 40% {\n    -webkit-transform: scale(1.0);\n    transform: scale(1.0);\n  }\n}\n.rdw-image-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-image-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-image-modal-header {\n  font-size: 15px;\n  margin: 10px 0;\n  display: flex;\n}\n.rdw-image-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.rdw-image-modal-header-label {\n  width: 80px;\n  background: #f1f1f1;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n}\n.rdw-image-modal-header-label-highlighted {\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n.rdw-image-modal-upload-option {\n  width: 100%;\n  color: gray;\n  cursor: pointer;\n  display: flex;\n  border: none;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n  background-color: #f1f1f1;\n  outline: 2px dashed gray;\n  outline-offset: -10px;\n  margin: 10px 0;\n  padding: 9px 0;\n}\n.rdw-image-modal-upload-option-highlighted {\n  outline: 2px dashed #0a66b7;\n}\n.rdw-image-modal-upload-option-label {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n}\n.rdw-image-modal-upload-option-label span{\n  padding: 0 20px;\n}\n.rdw-image-modal-upload-option-image-preview {\n  max-width: 100%;\n  max-height: 200px;\n}\n.rdw-image-modal-upload-option-input {\n\twidth: 0.1px;\n\theight: 0.1px;\n\topacity: 0;\n\toverflow: hidden;\n\tposition: absolute;\n\tz-index: -1;\n}\n.rdw-image-modal-url-section {\n  display: flex;\n  align-items: center;\n}\n.rdw-image-modal-url-input {\n  width: 90%;\n  height: 35px;\n  margin: 15px 0 12px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n.rdw-image-modal-btn-section {\n  margin: 10px auto 0;\n}\n.rdw-image-modal-url-input:focus {\n  outline: none;\n}\n.rdw-image-modal-btn {\n  margin: 0 5px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.rdw-image-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.rdw-image-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-image-modal-btn:focus {\n  outline: none !important;\n}\n.rdw-image-modal-btn:disabled {\n  background: #ece9e9;\n}\n.rdw-image-modal-spinner {\n  position: absolute;\n  top: -3px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n}\n.rdw-image-modal-alt-input {\n  width: 70%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n  margin-left: 5px;\n}\n.rdw-image-modal-alt-input:focus {\n  outline: none;\n}\n.rdw-image-modal-alt-lbl {\n  font-size: 12px;\n}\n.rdw-image-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n.rdw-image-modal-size-input {\n  width: 40%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n.rdw-image-modal-size-input:focus {\n  outline: none;\n}\n.rdw-image-mandatory-sign {\n  color: red;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n.rdw-remove-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-history-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-history-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-history-dropdown {\n  width: 50px;\n}\n.rdw-link-decorator-wrapper {\n  position: relative;\n}\n.rdw-link-decorator-icon {\n  position: absolute;\n  left: 40%;\n  top: 0;\n  cursor: pointer;\n  background-color: white;\n}\n.rdw-mention-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n.rdw-suggestion-wrapper {\n  position: relative;\n}\n.rdw-suggestion-dropdown {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #F1F1F1;\n  min-width: 100px;\n  max-height: 150px;\n  overflow: auto;\n  background: white;\n  z-index: 100;\n}\n.rdw-suggestion-option {\n  padding: 7px 5px;\n  border-bottom: 1px solid #f1f1f1;\n}\n.rdw-suggestion-option-active {\n  background-color: #F1F1F1;\n}\n.rdw-hashtag-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n.rdw-image-alignment-options-popup {\n  position: absolute;;\n  background: white;\n  display: flex;\n  padding: 5px 2px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  width: 105px;\n  cursor: pointer;\n  z-index: 100;\n}\n.rdw-alignment-option-left {\n  justify-content: flex-start;\n}\n.rdw-image-alignment-option {\n  height: 15px;\n  width: 15px;\n  min-width: 15px;\n}\n.rdw-image-alignment {\n  position: relative;\n}\n.rdw-image-imagewrapper {\n  position: relative;\n}\n.rdw-image-center {\n  display: flex;\n  justify-content: center;\n}\n.rdw-image-left {\n  display: flex;\n}\n.rdw-image-right {\n  display: flex;\n  justify-content: flex-end;\n}\n.rdw-image-alignment-options-popup-right {\n  right: 0;\n}\n.rdw-editor-main {\n  height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n}\n.rdw-editor-toolbar {\n  padding: 6px 5px 0;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  display: flex;\n  justify-content: flex-start;\n  background: white;\n  flex-wrap: wrap;\n  font-size: 15px;\n  margin-bottom: 5px;\n  user-select: none;\n}\n.public-DraftStyleDefault-block {\n  margin: 1em 0;\n}\n.rdw-editor-wrapper:focus {\n  outline: none;\n}\n.rdw-editor-wrapper {\n  box-sizing: content-box;\n}\n.rdw-editor-main blockquote {\n  border-left: 5px solid #f1f1f1;\n  padding-left: 5px;\n}\n.rdw-editor-main pre {\n  background: #f1f1f1;\n  border-radius: 3px;\n  padding: 1px 10px;\n}/**\n * Draft v0.9.1\n *\n * Copyright (c) 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n */\n.DraftEditor-editorContainer,.DraftEditor-root,.public-DraftEditor-content{height:inherit;text-align:initial}.public-DraftEditor-content[contenteditable=true]{-webkit-user-modify:read-write-plaintext-only}.DraftEditor-root{position:relative}.DraftEditor-editorContainer{background-color:rgba(255,255,255,0);border-left:.1px solid transparent;position:relative;z-index:1}.public-DraftEditor-block{position:relative}.DraftEditor-alignLeft .public-DraftStyleDefault-block{text-align:left}.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root{left:0;text-align:left}.DraftEditor-alignCenter .public-DraftStyleDefault-block{text-align:center}.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root{margin:0 auto;text-align:center;width:100%}.DraftEditor-alignRight .public-DraftStyleDefault-block{text-align:right}.DraftEditor-alignRight .public-DraftEditorPlaceholder-root{right:0;text-align:right}.public-DraftEditorPlaceholder-root{color:#9197a3;position:absolute;z-index:0}.public-DraftEditorPlaceholder-hasFocus{color:#bdc1c9}.DraftEditorPlaceholder-hidden{display:none}.public-DraftStyleDefault-block{position:relative;white-space:pre-wrap}.public-DraftStyleDefault-ltr{direction:ltr;text-align:left}.public-DraftStyleDefault-rtl{direction:rtl;text-align:right}.public-DraftStyleDefault-listLTR{direction:ltr}.public-DraftStyleDefault-listRTL{direction:rtl}.public-DraftStyleDefault-ol,.public-DraftStyleDefault-ul{margin:16px 0;padding:0}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR{margin-left:1.5em}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL{margin-right:1.5em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR{margin-left:3em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL{margin-right:3em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR{margin-left:4.5em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL{margin-right:4.5em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR{margin-left:6em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL{margin-right:6em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR{margin-left:7.5em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL{margin-right:7.5em}.public-DraftStyleDefault-unorderedListItem{list-style-type:square;position:relative}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0{list-style-type:disc}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1{list-style-type:circle}.public-DraftStyleDefault-orderedListItem{list-style-type:none;position:relative}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before{left:-36px;position:absolute;text-align:right;width:30px}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before{position:absolute;right:-36px;text-align:left;width:30px}.public-DraftStyleDefault-orderedListItem:before{content:counter(ol0) \". \";counter-increment:ol0}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before{content:counter(ol1) \". \";counter-increment:ol1}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before{content:counter(ol2) \". \";counter-increment:ol2}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before{content:counter(ol3) \". \";counter-increment:ol3}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before{content:counter(ol4) \". \";counter-increment:ol4}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset{counter-reset:ol0}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset{counter-reset:ol1}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset{counter-reset:ol2}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset{counter-reset:ol3}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset{counter-reset:ol4}\n\n.demo-editor {\n  height: 275px !important;\n  border: 1px solid #F1F1F1 !important;\n  padding: 5px !important;\n  border-radius: 2px !important;\n}","\n/// switch\n\n.has-switch {\n  border-radius: 30px;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1.72222;\n  overflow: hidden;\n  position: relative;\n  text-align: left;\n  width: 60px;\n  user-select: none;\n\n}\n.has-switch.deactivate {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n.has-switch.deactivate label,\n.has-switch.deactivate span {\n  cursor: default !important;\n}\n.has-switch > div {\n  position: relative;\n  top: 0;\n  width: 100px;\n}\n.has-switch > div.switch-animate {\n  transition: left 0.25s ease-out;\n}\n.has-switch > div.switch-off {\n  left: -35px;\n}\n\n.has-switch > div.switch-on {\n  left: 0;\n}\n\n@mixin icon-gradient ($top-color, $bottom-color){\n  background: $top-color;\n  background: linear-gradient(to bottom,  $top-color 0%,$bottom-color 100%);\n  background-size: 150% 150%;\n}\n\n.has-switch > div label {\n  background-color: #FFFFFF;\n  @include icon-gradient (rgba(255,255,255,1), rgba(241,241,242,1));\n\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n.has-switch input[type=checkbox] {\n  display: none;\n}\n.has-switch span {\n  cursor: pointer;\n  float: left;\n  font-size: 11px;\n  font-weight: 400;\n  height: 24px;\n  line-height: 15px;\n  margin: 0;\n  padding-bottom: 6px;\n  padding-top: 5px;\n  position: relative;\n  text-align: center;\n  text-indent: -10px;\n  width: 50%;\n  z-index: 1;\n  transition: 0.25s ease-out;\n}\n.has-switch span.switch-left {\n  background-color: $primary;\n  border-left: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 30px 0 0 30px;\n  color: #FFFFFF;\n}\n.has-switch .switch-off span.switch-left{\n  background-color: $gray-400 !important;\n}\n.has-switch span.switch-right {\n  border-radius: 0 30px 30px 0;\n  background-color: $primary;\n  color: #ffffff;\n  text-indent: 1px;\n}\n.has-switch .switch-off span.switch-right{\n  background-color: $gray-400 !important;\n}\n\n.has-switch label {\n  border-radius: 12px;\n  float: left;\n  height: 22px;\n  margin: 1px -13px;\n  padding: 0;\n  position: relative;\n  vertical-align: middle;\n  width: 22px;\n  z-index: 100;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out;\n}\n.has-switch .switch-on .fa-check:before{\n  margin-left: 10px;\n}\n.has-switch:hover .switch-on label{\n  margin: 1px -17px;\n  width: 26px;\n}\n.has-switch:hover .switch-off label{\n  margin: 1px -13px;\n  width: 26px;\n}\n\n// Sizing\n\n.has-switch-sm {\n  &.has-switch {\n    span {\n      height: 18px;\n      line-height: 18px;\n      padding: 0;\n    }\n    label {\n      height: 16px;\n      width: 16px;\n      margin: 1px -8px;\n    }\n\n    .switch-off {\n      label {\n        margin: 1px -13px;\n      }\n    }\n\n    &:hover {\n      .switch-on label {\n        margin: 1px -11px;\n        width: 20px;\n      }\n\n      .switch-off label {\n        margin: 1px -13px;\n        width: 20px;\n      }\n    }\n  }\n}","// Dropzone\n\n.dropzone-wrapper {\n  width: 100%;\n  border: $gray-400 dashed 2px;\n  @include border-radius($border-radius-lg);\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  height: 230px;\n  transition: all .2s;\n\n  &:hover {\n    border-color: $primary;\n  }\n\n  & > div {\n    width: 100%;\n    height: 100%;\n    outline: none !important;\n    display: flex;\n    align-items: center;\n  }\n\n  &.dropzone-wrapper-lg {\n    height: 300px;\n  }\n\n  &.dropzone-wrapper-sm {\n    height: 150px;\n  }\n\n  input {\n    width: 100%;\n    height: 100%;\n  }\n\n  .dropzone-content {\n    margin: 0 auto;\n    color: $gray-600;\n  }\n\n  &[aria-disabled=\"true\"] {\n    border-color: $gray-300;\n\n    .dropzone-content {\n      color: $gray-400;\n    }\n  }\n}","@import '_mixins';\n\n.rbt {\n  outline: none;\n\n  &-menu {\n    margin-bottom: 2px;\n\n    & > li a {\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    &-pagination-option {\n      text-align: center;\n    }\n  }\n\n  // Hide IE's native \"clear\" button\n  & .rbt-input-main::-ms-clear {\n    display: none;\n  }\n\n  &-input-multi {\n    cursor: text;\n    overflow: hidden;\n    position: relative;\n\n    // BS4 uses the :disabled pseudo-class, which doesn't work with non-inputs.\n    &.form-control[disabled] {\n      background-color: #e9ecef;\n      opacity: 1;\n    }\n\n    input {\n      @include placeholder(#6c757d);\n    }\n\n    .rbt-input-wrapper {\n      margin-top: 2px;\n      overflow: hidden;\n    }\n\n    .rbt-input-main {\n      height: auto;\n    }\n\n    .rbt-input-hint-container {\n      display: inline-block;\n    }\n\n    &.input,\n    &.form-control {\n      &-lg {\n        .rbt-input-main {\n          height: auto;\n        }\n      }\n\n      &-sm {\n        .rbt-input-main {\n          height: auto;\n        }\n      }\n    }\n  }\n\n  &-close {\n    z-index: 1;\n\n    &-lg {\n      font-size: 24px;\n    }\n  }\n\n  &-token {\n    background-color: $dropdown-link-hover-bg;\n    border: 0;\n    @include border-radius($border-radius);\n    color: $primary;\n    display: inline-block;\n    line-height: 1em;\n    margin: 0 3px 3px 0;\n    padding: 4px 7px;\n    position: relative;\n\n    &-disabled {\n      background-color: $gray-100;\n      color: $gray-500;\n      pointer-events: none;\n    }\n\n    &-removeable {\n      cursor: pointer;\n      padding-right: 21px;\n    }\n\n    &-active {\n      background-color: $primary;\n      color: $white;\n      outline: none;\n      text-decoration: none;\n    }\n\n    & &-remove-button {\n      bottom: 0;\n      color: $gray-700;\n      font-size: inherit;\n      font-weight: normal;\n      opacity: 1;\n      outline: none;\n      padding: 3px 7px;\n      position: absolute;\n      right: 0;\n      text-shadow: none;\n      top: -1px;\n    }\n  }\n\n  &-loader {\n    @include animation(loader-animation 600ms infinite linear);\n    border: 1px solid $dropdown-link-hover-bg;\n    border-radius: 50%;\n    border-top-color: darken($dropdown-link-hover-bg, 10%);\n    display: block;\n    height: 16px;\n    width: 16px;\n\n    &-lg {\n      height: 20px;\n      width: 20px;\n    }\n  }\n\n  &-aux {\n    @include display-flex();\n    align-items: center;\n    bottom: 0;\n    justify-content: center;\n    pointer-events: none; /* Don't block clicks on the input */\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 34px;\n\n    &-lg {\n      width: 46px;\n    }\n\n    & .rbt-close {\n      margin-top: -1px;\n      pointer-events: auto; /* Override pointer-events: none; above */\n    }\n  }\n\n  .has-aux &-input {\n    padding-right: 34px;\n  }\n\n  &-highlight-text {\n    background-color: inherit;\n    color: inherit;\n    font-weight: bold;\n    padding: 0;\n  }\n}\n\n/* Input Groups */\n.input-group > .rbt {\n  @include flex(1);\n\n  & .rbt-input-hint-container {\n    @include display-flex();\n  }\n\n  & .rbt-input-hint {\n    // CreateNew-controls within input-groups have a higher z-index.\n    z-index: 5;\n  }\n\n  & .rbt-aux {\n    // CreateNew-controls within input-groups have a higher z-index.\n    z-index: 5;\n  }\n\n  &:not(:first-child) .form-control {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  &:not(:last-child) .form-control {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n}\n\n@keyframes loader-animation {\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n@-webkit-keyframes loader-animation {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n\n.input-group > .rbt {\n  & .rbt-input-hint-container {\n    @include flex(1);\n    height: 100%;\n  }\n}","\n@mixin animation($animation) {\n  -webkit-animation: $animation;\n  -o-animation: $animation;\n  animation: $animation;\n}\n\n@mixin box-shadow($shadow, $inset: false) {\n  @if $inset {\n    -webkit-box-shadow: $inset, $shadow;\n    -moz-box-shadow: $inset, $shadow;\n    box-shadow: $inset, $shadow;\n  } @else {\n    -webkit-box-shadow: $shadow;\n    -moz-box-shadow: $shadow;\n    box-shadow: $shadow;\n  }\n}\n\n@mixin display-flex()  {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n@mixin flex($value) {\n  -webkit-box-flex: $value;\n  -moz-box-flex: $value;\n  -webkit-flex: $value;\n  -ms-flex: $value;\n  flex: $value;\n}\n\n@mixin placeholder($placeholder-color) {\n  // Firefox\n  &::-moz-placeholder {\n    color: $placeholder-color;\n    opacity: 1;\n  }\n\n  // Internet Explorer 10+\n  &:-ms-input-placeholder {\n    color: $placeholder-color;\n  }\n\n  // Safari and Chrome\n  &::-webkit-input-placeholder  {\n    color: $placeholder-color;\n  }\n}","\n// Normalize.css\n.rw-btn,\n.rw-input-reset {\n  color: inherit;\n  padding: 0;\n  margin: 0;\n  border: none;\n  box-shadow: none;\n  background: none;\n  background-image: none;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n}\n\n.rw-btn::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\n\nselect.rw-input {\n  text-transform: none;\n}\n\nhtml input[type=\"button\"].rw-input {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\ntextarea.rw-input {\n  overflow: auto;\n  resize: vertical;\n}\n\n\nbutton[disabled].rw-input,\nfieldset[disabled] .rw-input,\nhtml input[disabled].rw-input {\n  cursor: not-allowed;\n}\n\nbutton.rw-input::-moz-focus-inner,\ninput.rw-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\n/* -------------- */\n","\n@font-face {\n  font-family: 'RwWidgets';\n  font-weight: normal;\n  font-style: normal;\n  src: url('#{$font-path}/rw-widgets.eot?v=#{$version}');\n  src: url('#{$font-path}/rw-widgets.eot?#iefix&v=#{$version}') format('embedded-opentype'),\n    url('#{$font-path}/rw-widgets.woff?v=#{$version}') format('woff'),\n    url('#{$font-path}/rw-widgets.ttf?v=#{$version}') format('truetype'),\n    url('#{$font-path}/rw-widgets.svg?v=#{$version}#fontawesomeregular') format('svg');\n}\n\n\n.rw-i {\n  display: inline-block;\n  color: $icon-color;\n  font-family: RwWidgets;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  -moz-osx-font-smoothing: grayscale;\n   -webkit-font-smoothing: antialiased;\n}\n\n.rw-i-caret-down:before { content: '\\e803'; }\n.rw-i-caret-up:before { content: '\\e800'; }\n.rw-i-chevron-left:before { content: '\\f104';  }\n.rw-i-chevron-right:before { content: '\\f105'; }\n\n.rw-i-clock-o:before { content:'\\e805'; }\n.rw-i-calendar:before { content: '\\e804'; }\n.rw-i-search:before { content: '\\e801'; }\n","/* for debugging */\n// *:focus {\n//   outline: 1px red solid !important;\n// }\n\n@keyframes react-widgets-autofill-start {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n\n@keyframes react-widgets-autofill-cancel {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n\n.rw-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.rw-widget {\n  @include border-box();\n\n  border: none;\n  color: $text-color;\n  font-size: $font-size;\n  font-family: $font-family;\n  outline: none;\n  position: relative;\n\n  // ensure that the \"chrome\" is the same width as the actual container\n  & > .rw-widget-container {\n    width: 100%;\n    margin: 0;\n  }\n}\n\n.rw-widget-container {\n  background-color: $input-bg;\n  border: $input-border $input-border-width solid;\n  border-radius: $input-border-radius;\n\n  &.rw-state-focus,\n  .rw-state-focus > & {\n    &,\n    &:hover {\n      background-color: $input-bg-focus;\n      border-color: $input-border-focus;\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &.rw-state-readonly,\n  .rw-state-readonly > & {\n    cursor: not-allowed;\n  }\n\n  &.rw-state-disabled,\n  .rw-state-disabled > &,\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:active {\n      box-shadow: none;\n      @include state-disabled();\n    }\n  }\n}\n\n.rw-widget-picker {\n  position: relative;\n  overflow: hidden;\n  border-collapse: separate;\n  display: inline-table;\n  height: $input-height;\n\n  & > * {\n    position: relative;\n    border: none;\n    outline: none;\n    width: 100%;\n    height: 100%;\n    display: table-cell;\n  }\n\n  & > .rw-select {\n    width: 1%;\n    white-space: nowrap;\n  }\n\n  .rw-open > & {\n    @include border-bottom-radius(0);\n  }\n\n  .rw-open-up > & {\n    @include border-top-radius(0);\n  }\n\n  fieldset[disabled] &,\n  .rw-state-disabled > & {\n    background-color: $input-bg-disabled;\n  }\n}\n\n.rw-select {\n  cursor: pointer;\n\n  & > * {\n    width: 1.9em;\n  }\n\n  .rw-state-readonly &,\n  .rw-state-disabled & {\n    cursor: not-allowed;\n  }\n}\n\n.rw-select-bordered {\n  @include make-btn-state($select-btn-bg-hover);\n\n  border: none;\n  border-left: $input-border 1px solid;\n\n  .rw-rtl & {\n    border-right: $input-border 1px solid;\n    border-left: none;\n  }\n}\n\n.rw-rtl {\n  direction: rtl;\n}\n\n.rw-input-reset {\n  @include placeholder();\n  outline: 0;\n}\n\n.rw-input {\n  @extend .rw-input-reset;\n\n  color: $input-color;\n  padding: 0 $input-padding-horizontal;\n  background-color: $input-bg;\n\n  &[type='text']::-ms-clear {\n    display: none;\n  }\n\n  &[disabled],\n  fieldset[disabled] & {\n    @include state-disabled();\n    opacity: 1;\n    background-color: $input-bg-disabled;\n    border-color: $input-border-disabled;\n  }\n\n  &[readonly] {\n    cursor: not-allowed;\n  }\n}\n\n.rw-i.rw-loading {\n  display: block;\n  background: $img-busy no-repeat center;\n  min-width: 16px;\n  width: 1.9em;\n  height: 16px;\n\n  &:before {\n    content: '';\n  }\n}\n\n.rw-placeholder {\n  color: $input-color-placeholder;\n}\n\n// https://github.com/klarna/ui/blob/master/Field/styles.scss\n.rw-detect-autofill {\n  &:-webkit-autofill {\n    animation-name: react-widgets-autofill-start;\n\n    // Make the backgound color become yellow _really slowly_\n    transition: background-color 50000s ease-in-out 0s;\n  }\n\n  &:not(:-webkit-autofill) {\n    animation-name: react-widgets-autofill-cancel;\n  }\n}\n\n.rw-webkit-autofill .rw-widget-container,\n.rw-input:-webkit-autofill {\n  background-color: $input-bg-color-autofill !important;\n  background-image: none !important;\n  color: $input-color-autofill !important;\n}\n\n//input inset\n.rw-widget-input {\n  box-shadow: $input-box-shadow;\n}\n\n.rw-widget-input.rw-state-focus {\n  box-shadow: #{$input-focus-box-shadow}, #{$input-box-shadow};\n}\n","\n@mixin border-box() {\n  background-clip: border-box;\n}\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  $opacity-ie: ($opacity * 100);\n  filter: alpha(opacity=#{$opacity-ie});\n}\n\n@mixin unstyled-list() {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n@mixin select-container($padding) {\n  padding-right: $padding;\n\n  > .rw-select {\n    width: $padding;\n  }\n\n  &.rw-rtl {\n    padding-right: 0;\n    padding-left: $padding;\n  }\n}\n\n\n@mixin border-bottom-radius($radius) {\n  border-bottom-right-radius: $radius;\n   border-bottom-left-radius: $radius;\n}\n\n@mixin border-top-radius($radius) {\n  border-top-right-radius: $radius;\n   border-top-left-radius: $radius;\n}\n\n@mixin state-hover($bg: $state-bg-hover, $border-color: $state-border-hover, $color: $state-color-hover) {\n  background-color: $bg;\n  border-color:           $border-color;\n  color:            $color;\n}\n\n@mixin state-select($bg: $state-bg-select, $border-color: $state-border-select, $color: $state-color-select) {\n  &,\n  &:hover {\n    background-color: $bg;\n    border-color:     $border-color;\n    color:            $color;\n  }\n}\n\n@mixin state-focus($bg: $state-bg-focus, $border-color: $state-border-focus, $color: $state-color-focus) {\n  &,\n  &:hover {\n    background-color: $bg;\n    border-color:     $border-color;\n    color:            $color;\n  }\n}\n\n@mixin state-disabled() {\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n\n@mixin disabled-color($color) {\n  color: lighten($color, 40%);\n  filter: alpha(opacity=7);\n  opacity: .7;\n}\n\n@mixin clearfix() {\n  &:before,\n  &:after {\n    content: \" \";\n    display: table;\n  }\n  &:after {\n    clear: both;\n  }\n}\n\n@mixin placeholder($color: $input-color-placeholder) {\n  // Firefox\n  &::-moz-placeholder {\n    color: $color;\n    opacity: 1; // See https://github.com/twbs/bootstrap/pull/11526\n  }\n  &:-ms-input-placeholder { color: $color; } // Internet Explorer 10+\n  &::-webkit-input-placeholder  { color: $color; } // Safari and Chrome\n}\n\n@mixin height-calc($total, $minus) {\n  height: calc(#{$total} - #{$minus});\n\n  /** ie8 fallback **/\n  margin-top: -#{$minus}\\9;\n  height: #{$total}\\9;\n  /** --- **/\n}\n\n@mixin make-btn-state($hover-color: $btn-bg-hover, $active-shadow: $btn-active-box-shadow) {\n  cursor: pointer;\n\n  &:hover,\n  &:active {\n    background-color: $btn-bg-hover;\n\n    .rw-i {\n      color: $primary;\n    }\n  }\n\n  &:active {\n    box-shadow: $btn-active-box-shadow;\n  }\n\n  .rw-state-disabled &,\n  .rw-state-readonly &,\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:active {\n      cursor: not-allowed;\n      background-color: inherit;\n      background-image: none;\n      box-shadow: none;\n\n\n      .rw-i {\n        color: inherit;\n      }\n    }\n  }\n}\n","\n\n$gray-base:              #000 !default;\n$gray-darker:            lighten($gray-base, 13.5%) !default; // #222\n$gray-dark:              lighten($gray-base, 20%) !default;   // #333\n$gray:                   lighten($gray-base, 33.5%) !default; // #555\n$gray-light:             lighten($gray-base, 46.7%) !default; // #777\n$gray-lighter:           lighten($gray-base, 93.5%) !default; // #eee\n\n$font-size:              1em !default;\n$font-family:            inherit !default;\n$text-color:             $gray-dark !default;\n\n$version:                   \"4.1.0\" !default;\n$font-path:                 \"components/react-widgets/fonts\" !default; // for referencing Bootstrap CDN font files directly\n$img-path:                  \"components/react-widgets/img\" !default;\n$img-busy:                  url('#{$img-path}/loading.gif') !default;\n$img-busy-lg:               url(\"#{$img-path}/loader-big.gif\") !default;\n\n$widget-bg:                 $input-bg !default;\n$widget-border:             $input-border-color !default;\n\n\n\n$icon-color:                $gray-700 !default;\n\n//\n// Widget States\n//\n$state-bg-select:           $primary !default;\n$state-border-select:       $state-bg-select !default;\n$state-color-select:        $white !default;\n\n$state-bg-hover:            $dropdown-link-hover-bg !default;\n$state-border-hover:        $dropdown-link-hover-bg !default;\n$state-color-hover:         $dropdown-link-hover-color !default;\n\n$state-bg-focus:            $dropdown-link-active-bg !default;\n$state-border-focus:        $dropdown-link-active-bg !default;\n$state-color-focus:         $dropdown-link-hover-bg !default;\n\n//\n// Buttons\n//\n$btn-bg:                    $white !default;\n$btn-color:                 $text-color !default;\n$btn-border:                $gray-400 !default;\n\n$btn-bg-hover:              $state-bg-hover !default;\n$btn-border-hover:          $state-border-hover !default;\n$btn-active-box-shadow:     inset 0 3px 5px rgba(0,0,0,.125) !default;\n\n$select-btn-bg:                    $btn-bg !default;\n$select-btn-color:                 $btn-color !default;\n$select-btn-border:                $btn-border !default;\n\n$select-btn-bg-hover:              $btn-bg-hover !default;\n$select-btn-border-hover:          $btn-border-hover !default;\n$select-btn-active-box-shadow:     $btn-active-box-shadow !default;\n\n//\n// Picker inputs\n//\n$input-color:               $gray !default;\n$input-padding-horizontal:  0.857em !default;\n$input-box-shadow:          inset 0 1px 1px rgba(0,0,0,.075) !default;\n\n$input-bg:                  $widget-bg !default;\n$input-color-placeholder:   #999 !default;\n\n$input-border:              $widget-border !default;\n$input-border-width:        1px !default;\n$input-border-radius:       $border-radius !default;\n\n$input-bg-disabled:         $gray-lighter !default;\n$input-border-disabled:     $input-border !default;\n\n$input-bg-hover:            $gray-lighter !default;\n$input-border-hover:        $input-border !default;\n\n$input-bg-focus:            $input-bg !default;\n$input-border-focus:        $state-border-focus !default;\n\n$input-focus-color:         rgba(red($input-border-focus), green($input-border-focus), blue($input-border-focus), .6) !default;\n$input-focus-box-shadow:    0 0 8px $input-focus-color !default;\n\n$input-bg-color-autofill:  rgb(250, 255, 189) !default;\n$input-color-autofill:     rgb(0, 0, 0) !default;\n//\n// List\n//\n$list-font-size:            $font-size !default;\n\n$list-bg-hover:             $state-bg-hover !default;\n$list-border-hover:         $state-border-hover !default;\n$list-color-hover:          $state-color-hover !default;\n\n$list-bg-focus:             $state-bg-focus !default;\n$list-border-focus:         $state-border-focus !default;\n$list-color-focus:          $state-color-focus !default;\n\n$list-bg-select:            $state-bg-select !default;\n$list-border-select:        $state-border-select !default;\n$list-color-select:         $state-color-select !default;\n\n$list-text-color:           $text-color !default;\n$list-padding-vertical:     $dropdown-item-padding-y !default;\n$list-padding-horizontal:   $dropdown-item-padding-x !default;\n\n//\n// Popup\n//\n$popup-bg:                  $widget-bg !default;\n$popup-border:              $widget-border !default;\n$popup-border-radius:       $border-radius-sm !default;\n$popup-box-shadow-offset:   6px !default;\n$popup-box-shadow:          $box-shadow-default !default;\n$popup-box-shadow-up:       $box-shadow-default-inverse !default;\n\n$popup-zindex:              1005 !default;\n$popup-zindex-focused:      $popup-zindex + 1 !default;\n\n\n\n//\n// Calendar\n//\n$calendar-bg:                 $widget-bg !default;\n$calendar-cell-align:         center !default;\n$calendar-cell-padding:       .25em !default;\n$calendar-cell-color:         $btn-color !default;\n$calendar-cell-border-radius: $input-border-radius !default;\n\n$calendar-cell-bg-hover:             $state-bg-hover !default;\n$calendar-cell-border-hover:         $state-border-hover !default;\n$calendar-cell-color-hover:          $state-color-hover !default;\n\n$calendar-cell-bg-focus:             $state-bg-focus !default;\n$calendar-cell-border-focus:         $state-border-focus !default;\n$calendar-cell-color-focus:          $state-color-focus !default;\n\n$calendar-cell-bg-select:            $state-bg-select !default;\n$calendar-cell-border-select:        $state-border-select !default;\n$calendar-cell-color-select:         $state-color-select !default;\n\n\n//\n// Multiselect\n//\n$multiselect-gutter-pt:           0.115 !default;\n$multiselect-tag-padding-left:    0.35em !default;\n$multiselect-tag-padding-right:   0.35em !default;\n$multiselect-tag-color:           $dropdown-link-color !default;\n$multiselect-tag-border:          darken($dropdown-link-hover-bg, 15%) !default;\n$multiselect-tag-bg:              $dropdown-link-hover-bg !default;\n$multiselect-tag-height-pt:       1 - ($multiselect-gutter-pt * 2) !default;\n$multiselect-tag-gutter:          calc(#{$input-height / 5} - #{$input-border-width}) !default;\n$multiselect-tag-height:          ($input-height / 1.5) !default;\n$multiselect-tag-border-radius:   $border-radius-sm !default;\n\n$multiselect-tag-bg-hover:             $state-bg-hover !default;\n$multiselect-tag-border-hover:         $state-border-hover !default;\n$multiselect-tag-color-hover:          $state-color-hover !default;\n\n",".rw-list {\n  @include unstyled-list();\n  font-size: $list-font-size;\n  outline: 0;\n  overflow: auto;\n  max-height: 200px;\n}\n\n.rw-list-option {\n  user-select: none;\n  color: $list-text-color;\n  cursor: pointer;\n  border: 1px solid transparent;\n\n  &.rw-state-focus {\n    @include state-focus($list-bg-focus, $list-border-focus, $list-color-focus);\n    &:hover {\n      @include state-focus($list-bg-focus, $list-border-focus, $list-color-focus);\n    }\n  }\n\n  &:hover,\n  &:hover.rw-state-focus {\n    @include state-hover($list-bg-hover, $list-border-hover, $list-color-hover);\n  }\n\n  &.rw-state-selected {\n    @include state-select($list-bg-select, $list-border-select, $list-color-select);\n  }\n\n  fieldset[disabled] &,\n  &.rw-state-disabled,\n  &.rw-state-readonly {\n    @include state-disabled();\n    @include disabled-color($list-text-color);\n\n    &:hover {\n      background: none;\n      border-color: transparent;\n    }\n  }\n}\n\n.rw-list-empty,\n.rw-list-option,\n.rw-list-optgroup {\n  padding: $list-padding-vertical $list-padding-horizontal;\n  outline: 0;\n}\n\n.rw-list-optgroup {\n  font-weight: bold;\n  padding-top: 7px;\n}\n\n.rw-list-option-create {\n  border-top: 1px $widget-border solid;\n  //padding-top: 0.357em;\n  //margin-top:  0.357em;\n}\n",".rw-dropdown-list-autofill {\n  @extend .rw-input;\n\n  padding: 0;\n}\n\n.rw-dropdown-list {\n\n  .rw-select,\n  .rw-select .rw-btn {\n    height: 100%;\n  }\n}\n\n.rw-dropdown-list-input {\n  background-color: transparent;\n  vertical-align: middle;\n  padding-right: 0;\n\n  /* ellipsis */\n  & {\n    max-width: 1px; // very hacky to force ellipsis\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  .rw-rtl & {\n    padding-right: $input-padding-horizontal;\n    padding-left: 0;\n  }\n}\n\n.rw-filter-input {\n  @extend .rw-input;\n  @extend .rw-widget-input;\n\n  position: relative;\n  margin: 4px;\n  padding-right: 0;\n\n  .rw-rtl {\n    padding-right: $input-padding-horizontal;\n    padding-left: 0;\n  }\n\n  .rw-select,\n  .rw-btn {\n    @include opacity(0.75);\n    cursor: text;\n  }\n\n  > .rw-select {\n    &,\n    &:active,\n    &:hover {\n      background: none;\n      cursor: initial;\n      box-shadow: none;\n    }\n  }\n}\n","\n.rw-number-picker {\n  $half-width: $input-height / 2;\n\n  .rw-btn {\n    @include make-btn-state();\n    @include height-calc($half-width, $input-border-width);\n\n    line-height: $half-width;\n    line-height: calc(#{$half-width} - #{$input-border-width});\n    display: block;\n    border: none;\n  }\n\n  & .rw-select {\n    vertical-align: middle;\n    \n    &:hover,\n    &:active {\n      box-shadow: none;\n    }\n  }\n}\n",".rw-select-list {\n  overflow: auto;\n  position: relative;\n\n  .rw-list {\n    max-height: none;\n    font-size: $font-size; // use widget font-size\n  }\n}\n\n.rw-select-list-label {\n  display: block;\n  position: relative;\n  font-weight: normal;\n  cursor: inherit;\n  padding-left: 20px;\n  margin: 0;\n\n  .rw-rtl & {\n    padding-left: 0;\n    padding-right: 20px;\n  }\n}\n\ninput.rw-select-list-input {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  top: 0.1em /9;\n  margin: 0;\n  line-height: normal;\n  cursor: inherit;\n\n  .rw-rtl & {\n    left: auto;\n    right: 0;\n  }\n}\n\n.rw-loading-mask {\n  content: '';\n  background: $img-busy-lg no-repeat center;\n  position: absolute;\n  background-color: #fff;\n  border-radius: $input-border-radius;\n\n  @include opacity(0.7);\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n",".rw-multiselect {\n  cursor: text;\n\n  .rw-input-reset {\n    @include height-calc($input-height, $input-border-width * 2);\n\n    border-width: 0;\n    width: auto;\n    max-width: 100%;\n    padding: 0 $input-padding-horizontal;\n  }\n\n  & .rw-select {\n    &,\n    &:hover,\n    &:active {\n      box-shadow: none;\n      background: none;\n    }\n  }\n}\n\n.rw-multiselect-taglist {\n  @include unstyled-list();\n  display: inline;\n  outline: none;\n}\n\n.rw-multiselect-tag {\n  display: inline-table;\n  color: $multiselect-tag-color;\n  padding: 0 $multiselect-tag-padding-right 0 $multiselect-tag-padding-left;\n  margin-left: $multiselect-tag-gutter;\n  margin-top: $multiselect-tag-gutter;\n  height: $multiselect-tag-height;\n  border-radius: $multiselect-tag-border-radius;\n  background-color: $multiselect-tag-bg;\n  border: 1px solid $multiselect-tag-border;\n  cursor: default;\n  vertical-align: top;\n  text-align: center;\n  overflow: hidden;\n  max-width: 100%;\n\n  & > * {\n    display: table-cell;\n    vertical-align: middle;\n    height: 100%;\n  }\n\n  .rw-rtl & {\n    margin-left: 0;\n    margin-right: $multiselect-tag-gutter;\n    padding: 0 $multiselect-tag-padding-left 0 $multiselect-tag-padding-right;\n  }\n\n  &.rw-state-focus {\n    @include state-focus();\n  }\n\n  &.rw-state-readonly,\n  &.rw-state-disabled,\n  .rw-state-readonly &,\n  .rw-state-disabled &,\n  fieldset[disabled] & {\n    cursor: not-allowed;\n  }\n\n  &.rw-state-disabled,\n  .rw-state-disabled &,\n  fieldset[disabled] & {\n    @include opacity(0.65);\n  }\n\n  fieldset[disabled] & {\n    @include state-disabled();\n  }\n}\n\n.rw-multiselect-tag-btn {\n  color: $multiselect-tag-color;\n  margin-left: 0.25em;\n\n  .rw-rtl & {\n    margin-left: 0;\n    margin-right: 0.25em;\n  }\n}\n","\n.rw-popup-container {\n  position: absolute;\n  z-index: $popup-zindex;\n  top: 100%;\n  left:  -$popup-box-shadow-offset;\n  right: -$popup-box-shadow-offset;\n\n  &.rw-dropup {\n    top:    auto;\n    bottom: 100%;\n  }\n\n  .rw-state-focus & {\n    z-index: $popup-zindex-focused;\n  }\n}\n\n.rw-popup-transition {\n  // the offsets allows for drop shadow to not be clipped by the container\n  width:            100%;\n  margin-bottom:    $popup-box-shadow-offset;\n  padding:          0 $popup-box-shadow-offset;\n\n  .rw-dropup > & {\n    margin-bottom: 0;\n    margin-top:    $popup-box-shadow-offset;\n  }\n}\n\n.rw-popup {\n  @include border-top-radius(0);\n  @include border-bottom-radius($popup-border-radius);\n\n  box-shadow:       $popup-box-shadow;\n  border:           $popup-border 1px solid;\n  background:       $popup-bg;\n\n  .rw-dropup & {\n    @include border-bottom-radius(0);\n    @include border-top-radius($popup-border-radius);\n\n    box-shadow: $popup-box-shadow-up;\n  }\n}\n\n.rw-popup-transition {\n  transition: transform 200ms;\n}\n\n.rw-popup-transition-entering {\n  overflow: hidden;\n\n  & .rw-popup-transition {\n    transform: translateY(0);\n    transition-timing-function: ease-out;\n  }\n}\n\n.rw-popup-transition-exiting {\n  & .rw-popup-transition {\n    transition-timing-function: ease-in;\n  }\n}\n\n.rw-popup-transition-exiting,\n.rw-popup-transition-exited {\n  overflow: hidden;\n\n  & .rw-popup-transition {\n    transform: translateY(-100%);\n  }\n\n  &.rw-dropup .rw-popup-transition {\n    transform: translateY(100%);\n  }\n}\n\n.rw-popup-transition-exited {\n  display: none;\n}\n","\n.rw-state-disabled {\n  @include state-disabled();\n}\n","// Theme Options\n\n// Variables\n\n$theme-options-width: 500px;\n\n.ui-theme-settings {\n  position: fixed;\n  z-index: 155;\n  right: -30px;\n  top: 0;\n  height: 100vh;\n  transform: translate($theme-options-width);\n  transition: all .2s;\n  box-shadow: -0.46875rem 0 2.1875rem rgba(darken($primary, 50%), .03),\n  -0.9375rem 0 1.40625rem rgba(darken($primary, 50%), .03),\n  -0.25rem 0 0.53125rem rgba(darken($primary, 50%), .05),\n  -0.125rem 0 0.1875rem rgba(darken($primary, 50%), .03);\n\n  .btn-open-options {\n    @include border-radius(50px);\n    position: absolute;\n    left: -114px;\n    bottom: 80px;\n    padding: 0;\n    height: 54px;\n    line-height: 54px;\n    width: 54px;\n    text-align: center;\n    display: block;\n    box-shadow: $box-shadow-default;\n    margin-top: -27px;\n\n    svg {\n      top: 50%;\n      left: 50%;\n      position: absolute;\n      margin: -0.5em 0 0 -0.5em;\n    }\n  }\n\n  .theme-settings__inner {\n    background: $white;\n    width: $theme-options-width;\n    height: 100vh;\n    padding: 0;\n  }\n\n  &.settings-open {\n    transform: translate(0);\n    right: 0;\n  }\n\n  .theme-settings-swatches {\n    text-align: center;\n\n    .swatch-holder-img {\n      width: 72px;\n      height: auto;\n      @include border-radius(3px);\n\n      img {\n        width: 100%;\n      }\n    }\n  }\n\n  .themeoptions-heading {\n    font-size: $font-size-lg;\n    color: $body-color;\n    margin: 0;\n    background: $gray-100;\n    padding: ($layout-spacer-x / 2) $layout-spacer-x;\n    border-bottom: $gray-300 solid 1px;\n    border-top: $gray-300 solid 1px;\n    display: flex;\n    align-items: center;\n    align-content: center;\n\n    &:first-child {\n      border-top: 0;\n    }\n  }\n\n  .list-group-item {\n    h5 {\n      color: $primary;\n      font-size: $font-size-sm;\n      text-transform: uppercase;\n      margin: 0;\n      text-align: center;\n    }\n  }\n}\n\n.swatch-holder {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  margin: 5px 5px 0;\n  transition: all .2s;\n  opacity: .7;\n  display: inline-block;\n  @include border-radius(30px);\n\n  &.active {\n    border: $white solid 2px;\n    box-shadow: 0 0 0 5px $primary;\n    opacity: 1;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.swatch-holder-lg {\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n}","// DEMO\n\n@import \"elements/theme-options\";\n\n// Icons demo\n\n.font-icon-wrapper {\n  text-align: center;\n  border: $gray-200 solid 1px;\n  @include border-radius($border-radius);\n  margin: 0 0 10px;\n  padding: 5px;\n\n  &.font-icon-lg {\n    float: left;\n    padding: 10px;\n    text-align: center;\n    margin-right: 15px;\n    min-width: 64px;\n\n    i {\n      font-size: $h1-font-size;\n    }\n  }\n\n  &:hover {\n    background: $gray-100;\n    color: $primary;\n\n    p {\n      color: $gray-600;\n    }\n  }\n\n  i {\n    font-size: ($font-size-lg * 1.5);\n  }\n\n  p {\n    color: $gray-500;\n    font-size: ($font-size-sm / 1.2);\n    margin: 5px 0 0;\n  }\n}\n\n.btn-icon-vertical {\n  min-width: 100px;\n}\n\n.card.mb-3 {\n  margin-bottom: $grid-gutter-width !important;\n}\n\n// Image BG\n\n.demo-image-bg {\n  height: 350px;\n  margin-bottom: $grid-gutter-width;\n}\n\n// Loaders wrapper\n\n.loader-wrapper {\n  width: 150px;\n  height: 100px;\n  float: left;\n}\n\n// Slick slider\n\n.slider-item {\n  background: $gray-300;\n  @include border-radius($border-radius);\n  color: $gray-600;\n  font-size: 36px;\n  padding: 0;\n  position: relative;\n  height: 150px;\n  line-height: 150px;\n  text-align: center;\n  margin: 0 $layout-spacer-x;\n  transition: all .2s;\n}\n\n.slick-center {\n  .slider-item {\n    background: $gray-500;\n    color: $gray-700;\n  }\n}\n\n// Image Crop\n\n.after-img {\n  max-width: 100%;\n}\n","// Responsive\n\n@media only screen and (max-width: 1320px) {\n  .header-user-info {\n    display: none;\n  }\n}\n\n@include media-breakpoint-down(md) {\n\n  .app-main {\n    display: block;\n  }\n\n  .dropdown-menu {\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n\n  .app-sidebar {\n    flex: 0 0 $app-sidebar-width !important;\n    width: $app-sidebar-width !important;\n    transform: translateX(-$app-sidebar-width);\n\n    .app-header__logo {\n      display: none;\n    }\n  }\n\n  .sidebar-mobile-open {\n\n    .app-sidebar {\n\n      transform: translateX(0);\n\n      .app-sidebar__inner {\n\n        .app-sidebar__heading {\n          text-indent: initial;\n\n          &::before {\n            display: none;\n          }\n        }\n\n        .metismenu-link {\n          text-indent: initial;\n          padding: 0 $layout-spacer-x 0 45px;\n        }\n\n        .metismenu-icon {\n          text-indent: initial;\n          left: 5px;\n          margin-left: 0;\n        }\n\n        .metismenu-state-icon {\n          visibility: visible;\n        }\n\n        .metismenu-container {\n          &.visible {\n            padding: .5em 0 0 2rem;\n\n            & > .metismenu-item > .metismenu-link {\n              height: 2.3em;\n            }\n          }\n\n          .metismenu-container {\n            .metismenu-link {\n              padding-left: 1em;\n            }\n          }\n        }\n      }\n\n      .app-header__logo {\n        width: auto !important;\n\n        .logo-src {\n          width: $logo-width !important;\n          margin-left: auto;\n          margin-right: 0;\n        }\n      }\n    }\n\n    .fixed-sidebar .app-sidebar {\n      height: 100%;\n    }\n\n    .sidebar-mobile-overlay {\n      display: block;\n    }\n  }\n\n  .app-main {\n\n    .app-main__outer {\n      padding-left: 0 !important;\n      width: auto;\n    }\n  }\n\n  .app-header {\n    justify-content: space-between;\n\n    .app-header__logo {\n      display: none;\n      order: 2;\n      background: transparent !important;\n      border: 0 !important;\n    }\n\n    .app-header__content {\n      visibility: hidden;\n      opacity: 0;\n      box-shadow: $box-shadow-default;\n      position: absolute;\n      left: 5%;\n      width: 90%;\n      top: 0;\n      transition: all .2s;\n      background: $white;\n      @include border-radius(50px);\n      padding: 0 10px;\n      overflow: hidden;\n\n      .header-btn-lg {\n        margin-left: .5rem;\n        padding: 0 .5rem;\n\n        .hamburger-box {\n          margin-top: 5px;\n        }\n\n        & + .header-btn-lg {\n          display: none;\n        }\n      }\n\n      .app-header-left {\n        .nav {\n          display: none;\n        }\n      }\n\n      &.header-mobile-open {\n        visibility: visible;\n        opacity: 1;\n        top: $app-header-height + 20;\n      }\n    }\n\n    .app-header__mobile-menu {\n      display: flex;\n      order: 1;\n    }\n\n    .app-header__menu {\n      display: flex;\n      order: 3;\n    }\n\n    &.header-text-light {\n      .app-header__menu {\n        & > span .btn,\n        & > .btn {\n          background: rgba(255, 255, 255, .1);\n          border-color: rgba(255, 255, 255, .1);\n        }\n      }\n\n      .header-mobile-open {\n        background: $gray-800;\n      }\n\n    }\n  }\n\n  .popover,\n  .dropdown-menu {\n    position: fixed !important;\n    z-index: 50;\n    left: 5% !important;\n    top: 50% !important;\n    width: 90% !important;\n    transform: translateY(-50%) !important;\n    min-width: 10px !important;\n\n    .btn-icon-vertical .btn-icon-wrapper {\n      display: none;\n    }\n\n  }\n\n  .popover {\n    max-width: initial;\n\n    .arrow {\n      display: none !important;\n    }\n  }\n\n  .app-page-title {\n    text-align: center;\n\n    .page-title-heading,\n    .page-title-wrapper {\n      margin: 0 auto;\n      display: block;\n    }\n\n    .page-title-actions {\n      margin: ($grid-gutter-width / 2) auto 0;\n    }\n\n    .page-title-actions,\n    .page-title-subheading {\n      .breadcrumb-item,\n      .breadcrumb {\n        display: inline-block;\n      }\n    }\n  }\n\n  // Footer\n\n  .app-footer .app-footer__inner {\n    .app-footer-right {\n      display: none;\n    }\n\n    .app-footer-left {\n      width: 100%;\n\n      .footer-dots {\n        margin: 0 auto;\n      }\n    }\n  }\n\n  .fixed-footer {\n    &.closed-sidebar {\n      .app-footer {\n        .app-footer__inner {\n          margin-left: 0 !important;\n        }\n      }\n    }\n  }\n\n  // Components\n\n  .widget-content {\n    .widget-numbers {\n      font-size: 1.6rem;\n      line-height: 1;\n    }\n  }\n\n  .slick-slider-sm {\n    .slick-slider {\n      max-width: 650px !important;\n    }\n  }\n\n  .body-tabs.body-tabs-layout {\n    &.body-tabs-big {\n      display: block !important;\n\n      .RRT__tab {\n        display: inline-block !important;\n        padding: 0 $layout-spacer-x !important;\n      }\n\n      .RRT__showmore {\n        margin-top: -20px;\n      }\n    }\n  }\n\n  .ReactTable .-pagination {\n    .-center {\n      display: none;\n    }\n\n    .-previous {\n      padding-right: 3px;\n    }\n  }\n\n  .bg-transparent.list-group-item {\n    border-color: transparent;\n  }\n\n  .tabs-lg-alternate.card-header {\n\n    & > .nav .nav-item {\n      .widget-number {\n        font-size: 1.5rem;\n      }\n    }\n  }\n\n  .page-title-head {\n    display: block;\n  }\n}\n\n@include media-breakpoint-between(xs, md) {\n\n  .app-page-title .page-title-icon,\n  .ui-theme-settings {\n    display: none;\n  }\n\n  .card-header {\n    &.responsive-center {\n      display: block;\n      text-align: center;\n      height: auto;\n      padding: $layout-spacer-x;\n\n      .nav,\n      .btn-actions-pane-right {\n        margin: ($layout-spacer-x / 2) 0 0;\n\n        .d-inline-block.ml-2 {\n          width: 100% !important;\n          text-align: left;\n          margin: 0 !important;\n        }\n      }\n    }\n  }\n\n  .slick-slider-sm {\n    .slick-slider {\n      max-width: 650px !important;\n    }\n  }\n}\n\n@include media-breakpoint-up(lg) {\n\n  .slick-slider-sm {\n    .slick-slider {\n      max-width: 850px !important;\n    }\n  }\n}\n\n@include media-breakpoint-down(lg) {\n\n  .-hide-paging .-pagination .-center {\n    display: none;\n  }\n}\n\n@include media-breakpoint-down(sm) {\n  .app-main .app-main__inner {\n    padding: 15px 15px 0;\n  }\n\n  .mbg-3,\n  body .card.mb-3 {\n    margin-bottom: ($grid-gutter-width / 2) !important;\n  }\n\n  .app-page-title {\n    padding: ($grid-gutter-width / 2);\n    margin: (-($grid-gutter-width / 2)) (-($grid-gutter-width / 2)) $grid-gutter-width;\n  }\n\n  .body-tabs.body-tabs-layout {\n    margin-left: (-($grid-gutter-width / 2));\n    margin-right: (-($grid-gutter-width / 2));\n    padding: 0 ($grid-gutter-width / 2);\n  }\n\n  .app-main .app-main__inner > .RRT__container > .RRT__panel {\n    margin-top: ($grid-gutter-width / 2);\n  }\n\n  .popover,\n  .dropdown-menu {\n    width: 80%;\n    left: 10%;\n  }\n\n  body .card-header {\n    height: auto;\n    display: block;\n    padding: ($layout-spacer-x / 2) $layout-spacer-x;\n    text-align: center;\n\n    .btn-actions-pane-right {\n      padding: ($layout-spacer-x / 2) 0 0;\n    }\n\n    .actions-icon-btn {\n      padding: 0;\n    }\n  }\n\n  .card-header {\n    &.card-header-tab {\n      .card-header-title {\n        display: inline-flex !important;\n        line-height: 1;\n      }\n\n      & > .nav {\n        margin: ($layout-spacer-x / 2) 0 (-($layout-spacer-x / 2));\n        display: table !important;\n        width: 100%;\n\n        .nav-item {\n          display: table-cell;\n        }\n      }\n    }\n  }\n\n  .header-icon {\n    display: none;\n  }\n\n  .profile-responsive-sm,\n  .profile-responsive {\n    .dropdown-menu-header .menu-header-content.btn-pane-right {\n      display: block;\n      text-align: center;\n\n      .avatar-icon-wrapper {\n        margin-right: 0 !important;\n      }\n\n      .menu-header-btn-pane {\n        margin-top: 1rem;\n      }\n    }\n  }\n\n  .slick-slider-sm .slick-slider .slick-prev {\n    left: ($grid-gutter-width / 2);\n  }\n\n  .slick-slider-sm .slick-slider .slick-next {\n    right: ($grid-gutter-width / 2);\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  .profile-responsive {\n    .dropdown-menu-header .menu-header-content.btn-pane-right {\n      display: block;\n      text-align: center;\n\n      .avatar-icon-wrapper {\n        margin-right: 0 !important;\n      }\n\n      .menu-header-btn-pane {\n        margin-top: 1rem;\n      }\n    }\n  }\n}\n",".off-overflow {\n  .rt-table {\n    overflow: unset !important;\n  }\n}\n\n#taskCKEditor {\n\n  .ck-editor__editable_inline {\n    min-height: 200px;\n  }\n\n}\n\n.custom-datetimepicker-task {\n  width: 400px;\n}\n\n#reportCKEditor {\n\n  .ck-editor__editable_inline {\n    min-height: 200px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
